import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: { input: any; output: any; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: string; output: string; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: string; output: string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
  /** The javascript `Date` as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: { input: string | number; output: string | number; }
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type AamMethodWeightInput = {
  method: Scalars['String']['input'];
  weight: Scalars['Float']['input'];
};

export type AamOptimizationInput = {
  benchmarks?: InputMaybe<Array<BenchmarkWeightInput>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customBenchmarkName?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  decayFactor?: InputMaybe<Scalars['Float']['input']>;
  enhancedRobustness?: InputMaybe<Scalars['Boolean']['input']>;
  excludeCash?: InputMaybe<Scalars['Boolean']['input']>;
  excludeManagerTags?: InputMaybe<Array<Scalars['String']['input']>>;
  hideNames?: InputMaybe<Scalars['Boolean']['input']>;
  maxManagerWeight?: InputMaybe<Scalars['Float']['input']>;
  maxStaleMonths?: InputMaybe<Scalars['Int']['input']>;
  maxStrategyWeight?: InputMaybe<Scalars['Float']['input']>;
  methodWeights?: InputMaybe<Array<AamMethodWeightInput>>;
  minManagerWeight?: InputMaybe<Scalars['Float']['input']>;
  minPairMonths?: InputMaybe<Scalars['Int']['input']>;
  minStrategyWeight?: InputMaybe<Scalars['Float']['input']>;
  minVolatility?: InputMaybe<Scalars['Float']['input']>;
  shrinkage?: InputMaybe<Scalars['Float']['input']>;
  strategies?: InputMaybe<Array<Scalars['String']['input']>>;
  strategyShrinkage?: InputMaybe<Scalars['Float']['input']>;
  strategyType?: InputMaybe<Scalars['String']['input']>;
  useProxies?: InputMaybe<Scalars['Boolean']['input']>;
  windowMonths?: InputMaybe<Scalars['Int']['input']>;
};

export type AamOptimizationOption = {
  __typename?: 'AamOptimizationOption';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type AamOptimizationOptions = {
  __typename?: 'AamOptimizationOptions';
  methods: Array<AamOptimizationOption>;
  strategyTypes: Array<AamOptimizationOption>;
};

export type AamOptimizationRun = {
  __typename?: 'AamOptimizationRun';
  /** The JSON as a chat file, when the run was started from a conversation. */
  jsonArtifactId?: Maybe<Scalars['Int']['output']>;
  /** Download link for the JSON document. */
  jsonUrl?: Maybe<Scalars['String']['output']>;
  /** The PDF as a chat file, when the run was started from a conversation. */
  pdfArtifactId?: Maybe<Scalars['Int']['output']>;
  /** Download link for the PDF report. */
  pdfUrl?: Maybe<Scalars['String']['output']>;
  /** The report as data: method, settings, original and target dollars and weights by strategy and manager, returns, and the risk comparison. */
  report?: Maybe<Scalars['JSON']['output']>;
  /** Set when the run was asked to save to a conversation and saving failed. The run itself succeeded: the links are temporary downloads instead of chat files, and there are no artifact ids. */
  saveError?: Maybe<Scalars['String']['output']>;
};

export type AccessLevel = {
  __typename?: 'AccessLevel';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AccountTypeEnum = {
  __typename?: 'AccountTypeEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AccountTypeEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type AccountTypeEnumList = {
  __typename?: 'AccountTypeEnumList';
  items: Array<AccountTypeEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type AccountTypeEnumSort = {
  field: AccountTypeEnumSortEnum;
  order: SortInput;
};

export enum AccountTypeEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type AccountingManager = {
  __typename?: 'AccountingManager';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AccountingManagerFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type AccountingManagerList = {
  __typename?: 'AccountingManagerList';
  items: Array<AccountingManager>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type AccountingManagerSort = {
  field: AccountingManagerSortEnum;
  order: SortInput;
};

export enum AccountingManagerSortEnum {
  Id = 'id',
  Name = 'name'
}

export type AdEntriesXApplicationFlags = {
  __typename?: 'AdEntriesXApplicationFlags';
  adEntry: User;
  applicationFlag: ApplicationFlags;
  applicationFlagId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  user: User;
  userId: Scalars['Int']['output'];
};

export type AdEntriesXApplicationFlagsFilter = {
  applicationFlagId?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type AdEntriesXApplicationFlagsInput = {
  applicationFlagId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type AdEntriesXApplicationFlagsList = {
  __typename?: 'AdEntriesXApplicationFlagsList';
  items: Array<AdEntriesXApplicationFlags>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type AdEntriesXApplicationFlagsSort = {
  field: AdEntriesXApplicationFlagsSortEnum;
  order: SortInput;
};

export enum AdEntriesXApplicationFlagsSortEnum {
  Id = 'id'
}

export type AdEntriesXApplicationsXSets = {
  __typename?: 'AdEntriesXApplicationsXSets';
  application: Application;
  applicationId: Scalars['Int']['output'];
  entry: User;
  entryId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  set: Set;
  setId: Scalars['Int']['output'];
};

export type AdEntriesXApplicationsXSetsFilter = {
  applicationId?: InputMaybe<Scalars['Int']['input']>;
  entryId?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  setId?: InputMaybe<Scalars['Int']['input']>;
};

export type AdEntriesXApplicationsXSetsInput = {
  applicationId?: InputMaybe<Scalars['Int']['input']>;
  entryId?: InputMaybe<Scalars['Int']['input']>;
  setId?: InputMaybe<Scalars['Int']['input']>;
};

export type AdEntriesXApplicationsXSetsList = {
  __typename?: 'AdEntriesXApplicationsXSetsList';
  items: Array<AdEntriesXApplicationsXSets>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type AdEntriesXApplicationsXSetsSort = {
  field: AdEntriesXApplicationsXSetsSortEnum;
  order: SortInput;
};

export enum AdEntriesXApplicationsXSetsSortEnum {
  Id = 'id'
}

export type AdEntryType = {
  __typename?: 'AdEntryType';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountryEnum>;
  countryEnumId?: Maybe<Scalars['Int']['output']>;
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email2?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  fax2?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  line3?: Maybe<Scalars['String']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  otherState?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phone2?: Maybe<Scalars['String']['output']>;
  state?: Maybe<StateEnum>;
  stateEnumId?: Maybe<Scalars['Int']['output']>;
  webPassword?: Maybe<Scalars['String']['output']>;
  webUserId?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  countryEnumId?: InputMaybe<Scalars['Int']['input']>;
  createUser?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email2?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  fax2?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  line3?: InputMaybe<Scalars['String']['input']>;
  modifyUser?: InputMaybe<Scalars['String']['input']>;
  otherState?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phone2?: InputMaybe<Scalars['String']['input']>;
  stateEnumId?: InputMaybe<Scalars['Int']['input']>;
  webPassword?: InputMaybe<Scalars['String']['input']>;
  webUserId?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type AddressSearchItem = {
  __typename?: 'AddressSearchItem';
  city?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryEnumId?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateEnumId?: Maybe<Scalars['Int']['output']>;
};

export type AdvComparison = {
  __typename?: 'AdvComparison';
  items: Array<AdvItemComparison>;
  previous: AdvFilingSummary;
  recent: AdvFilingSummary;
};

export type AdvFilingSummary = {
  __typename?: 'AdvFilingSummary';
  crd: Scalars['String']['output'];
  documentId: Scalars['Int']['output'];
  filingDate: Scalars['Date']['output'];
};

export type AdvItemComparison = {
  __typename?: 'AdvItemComparison';
  changes: Array<Scalars['String']['output']>;
  item: Scalars['String']['output'];
  summary: Scalars['String']['output'];
};

/** The review of a firm's latest Form ADV Part 1. While the review is being generated, `task` is set and `answers` is empty. */
export type AdvReview = {
  __typename?: 'AdvReview';
  answers: Array<AdvReviewAnswer>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The Form ADV Part 1 reviewed */
  documentId?: Maybe<Scalars['Int']['output']>;
  filingDate?: Maybe<Scalars['Date']['output']>;
  task?: Maybe<AsyncTaskStatus>;
};

export type AdvReviewAnswer = {
  __typename?: 'AdvReviewAnswer';
  answer: Scalars['String']['output'];
  /** The ADV item the answer was read from; null for page-1 metadata */
  item?: Maybe<Scalars['String']['output']>;
  notFound: Scalars['Boolean']['output'];
  question: Scalars['String']['output'];
};

export type AdvSummaryEmailNotification = {
  __typename?: 'AdvSummaryEmailNotification';
  documentId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  legacySkipped?: Maybe<Scalars['Boolean']['output']>;
  notifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AdvSummaryEmailNotificationBulkInput = {
  documentIds: Array<Scalars['Int']['input']>;
  legacySkipped?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdvisorTypeEnum = {
  __typename?: 'AdvisorTypeEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AdvisorTypeEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type AdvisorTypeEnumList = {
  __typename?: 'AdvisorTypeEnumList';
  items: Array<AdvisorTypeEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type AdvisorTypeEnumSort = {
  field: AdvisorTypeEnumSortEnum;
  order: SortInput;
};

export enum AdvisorTypeEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type AfsExtraction = {
  __typename?: 'AfsExtraction';
  administrator?: Maybe<Scalars['String']['output']>;
  affiliatedFunds?: Maybe<Scalars['String']['output']>;
  auditOpinionType?: Maybe<Scalars['String']['output']>;
  auditingStandards?: Maybe<Scalars['String']['output']>;
  auditorLocation?: Maybe<Scalars['String']['output']>;
  auditorName?: Maybe<Scalars['String']['output']>;
  basisOfAccountingFramework?: Maybe<Scalars['String']['output']>;
  capitalContributions?: Maybe<Scalars['Float']['output']>;
  capitalDistributions?: Maybe<Scalars['Float']['output']>;
  cash?: Maybe<Scalars['Float']['output']>;
  changeInAccruedIncentiveAllocation?: Maybe<Scalars['Float']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  custodians?: Maybe<Scalars['String']['output']>;
  dateOfAuditOpinion?: Maybe<Scalars['DateTime']['output']>;
  documentId?: Maybe<Scalars['Int']['output']>;
  domicile?: Maybe<Scalars['String']['output']>;
  emphasisOfMatter?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  extensionPeriod?: Maybe<Scalars['String']['output']>;
  fieldSources?: Maybe<Scalars['JSON']['output']>;
  fundInceptionDate?: Maybe<Scalars['DateTime']['output']>;
  fundLegalName?: Maybe<Scalars['String']['output']>;
  fundTerminationDate?: Maybe<Scalars['String']['output']>;
  holdings: Array<AfsHolding>;
  id: Scalars['Int']['output'];
  incentiveMechanics?: Maybe<Scalars['String']['output']>;
  interestExpense?: Maybe<Scalars['Float']['output']>;
  investmentAdvisor?: Maybe<Scalars['String']['output']>;
  investmentId?: Maybe<Scalars['Int']['output']>;
  investmentInMasterFund?: Maybe<Scalars['Float']['output']>;
  investmentRelatedExpensesExcludingInterest?: Maybe<Scalars['Float']['output']>;
  investmentUnfunded?: Maybe<Scalars['Float']['output']>;
  investmentsCostTotal?: Maybe<Scalars['Float']['output']>;
  investorCommitments?: Maybe<Scalars['String']['output']>;
  investorUnfunded?: Maybe<Scalars['Float']['output']>;
  irr?: Maybe<Scalars['String']['output']>;
  largestPosition?: Maybe<Scalars['String']['output']>;
  largestPositionFairValue?: Maybe<Scalars['Float']['output']>;
  largestPositionType?: Maybe<Scalars['String']['output']>;
  legalForm?: Maybe<Scalars['String']['output']>;
  level1AssetsAmount?: Maybe<Scalars['Float']['output']>;
  level1LiabilitiesAmount?: Maybe<Scalars['Float']['output']>;
  level1NavAmount?: Maybe<Scalars['Float']['output']>;
  level2AssetsAmount?: Maybe<Scalars['Float']['output']>;
  level2LiabilitiesAmount?: Maybe<Scalars['Float']['output']>;
  level2NavAmount?: Maybe<Scalars['Float']['output']>;
  level3AssetsAmount?: Maybe<Scalars['Float']['output']>;
  level3LiabilitiesAmount?: Maybe<Scalars['Float']['output']>;
  level3NavAmount?: Maybe<Scalars['Float']['output']>;
  liquidationBasisOfAccounting?: Maybe<Scalars['Boolean']['output']>;
  liquidityTerms?: Maybe<Scalars['String']['output']>;
  managementFeeBase?: Maybe<Scalars['String']['output']>;
  managementFeeRate?: Maybe<Scalars['String']['output']>;
  managementFeesExpense?: Maybe<Scalars['Float']['output']>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  netAssets?: Maybe<Scalars['Float']['output']>;
  netIncreaseInPartnersCapitalFromOperations?: Maybe<Scalars['Float']['output']>;
  oddReview?: Maybe<AfsOddReview>;
  openingNetAssetValue?: Maybe<Scalars['Float']['output']>;
  performanceFee?: Maybe<Scalars['Float']['output']>;
  performanceFeeRate?: Maybe<Scalars['String']['output']>;
  periodEndDate?: Maybe<Scalars['DateTime']['output']>;
  presentationCurrency?: Maybe<Scalars['String']['output']>;
  presentationScalingFactor?: Maybe<Scalars['Int']['output']>;
  primeBrokers?: Maybe<Scalars['String']['output']>;
  shareClasses?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  strategy?: Maybe<Scalars['String']['output']>;
  subsequentEvents?: Maybe<Scalars['String']['output']>;
  totalAssets?: Maybe<Scalars['Float']['output']>;
  totalExpenseRatio?: Maybe<Scalars['String']['output']>;
  totalExpenses?: Maybe<Scalars['Float']['output']>;
  totalInvestmentIncome?: Maybe<Scalars['Float']['output']>;
  totalInvestmentsAtFairValue?: Maybe<Scalars['Float']['output']>;
  totalLiabilities?: Maybe<Scalars['Float']['output']>;
  totalReturnRatioNet?: Maybe<Scalars['String']['output']>;
};

export type AfsHolding = {
  __typename?: 'AfsHolding';
  afsExtractionId: Scalars['Int']['output'];
  afsSecurityMappingId?: Maybe<Scalars['Int']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  deleteUser?: Maybe<Scalars['String']['output']>;
  fairValue?: Maybe<Scalars['Float']['output']>;
  holdingName: Scalars['String']['output'];
  holdingType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  netAssetsOrPartnersCapital?: Maybe<Scalars['Float']['output']>;
  percentageOfNav?: Maybe<Scalars['Float']['output']>;
  periodEndDate?: Maybe<Scalars['DateTime']['output']>;
  securityMapping?: Maybe<AfsSecurityMapping>;
  securityMasterId?: Maybe<Scalars['Int']['output']>;
  sourcePage?: Maybe<Scalars['Int']['output']>;
  sourceQuote?: Maybe<Scalars['String']['output']>;
};

export type AfsHoldingList = {
  __typename?: 'AfsHoldingList';
  items: Array<AfsHolding>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export enum AfsHoldingSortEnum {
  FairValue = 'fairValue',
  HoldingName = 'holdingName',
  HoldingType = 'holdingType',
  PercentageOfNav = 'percentageOfNav'
}

export type AfsHoldingSortInput = {
  field: AfsHoldingSortEnum;
  order: SortInput;
};

export type AfsOddReview = {
  __typename?: 'AfsOddReview';
  afsExtractionId: Scalars['Int']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  level1Amount?: Maybe<Scalars['Float']['output']>;
  level2Amount?: Maybe<Scalars['Float']['output']>;
  level3Amount?: Maybe<Scalars['Float']['output']>;
  level3SharePct?: Maybe<Scalars['Float']['output']>;
  leverageRatio?: Maybe<Scalars['Float']['output']>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  nonInvestmentExpenseRatioCommitments?: Maybe<Scalars['Float']['output']>;
  nonInvestmentExpenseRatioNav?: Maybe<Scalars['Float']['output']>;
  nonInvestmentExpenses?: Maybe<Scalars['Float']['output']>;
  oddNetAssets?: Maybe<Scalars['Float']['output']>;
  oddTotalAssets?: Maybe<Scalars['Float']['output']>;
  oddTotalExpenses?: Maybe<Scalars['Float']['output']>;
  totalExpenseRatioCommitments?: Maybe<Scalars['Float']['output']>;
  totalExpenseRatioNav?: Maybe<Scalars['Float']['output']>;
  totalInvestment?: Maybe<Scalars['Float']['output']>;
};

export type AfsSecurityMapping = {
  __typename?: 'AfsSecurityMapping';
  confidence: Scalars['Float']['output'];
  country?: Maybe<Scalars['String']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  identifierType?: Maybe<Scalars['String']['output']>;
  identifierValue?: Maybe<Scalars['String']['output']>;
  investmentId: Scalars['Int']['output'];
  llmReasoning?: Maybe<Scalars['String']['output']>;
  manuallyVerified: Scalars['Boolean']['output'];
  matchCriteriaHash?: Maybe<Scalars['String']['output']>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  needsReview: Scalars['Boolean']['output'];
  rawName: Scalars['String']['output'];
  securityMasterId?: Maybe<Scalars['Int']['output']>;
  securityMasterName?: Maybe<Scalars['String']['output']>;
  securityType?: Maybe<Scalars['String']['output']>;
  suggestedSecurityMasterId?: Maybe<Scalars['Int']['output']>;
  suggestedSecurityMasterName?: Maybe<Scalars['String']['output']>;
  verifiedBy?: Maybe<Scalars['String']['output']>;
  verifiedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type Agency = {
  __typename?: 'Agency';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
};

export type AgencyFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type AgencyList = {
  __typename?: 'AgencyList';
  items: Array<Agency>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type AgencySort = {
  field: AgencySortEnum;
  order: SortInput;
};

export enum AgencySortEnum {
  Id = 'id',
  Name = 'name',
  ShortName = 'shortName'
}

export type AggregatedHoldingResult = {
  __typename?: 'AggregatedHoldingResult';
  allMapped: Scalars['Boolean']['output'];
  fundCount: Scalars['Int']['output'];
  funds: Array<FundHoldingDetail>;
  /** Stable row key: 'sm:{id}' for mapped, 'unmapped:{holdingId}' for unmapped */
  groupKey: Scalars['String']['output'];
  hasSignificantExposure: Scalars['Boolean']['output'];
  holdingName: Scalars['String']['output'];
  holdingType?: Maybe<Scalars['String']['output']>;
  latestPeriodEndDate?: Maybe<Scalars['String']['output']>;
  /** Predominant match type: 'aiMatched', 'proxy', 'manual', 'mixed', or null */
  matchType?: Maybe<Scalars['String']['output']>;
  /** totalLookthroughValue / totalPortfolioValue * 100 */
  portfolioWeightPct?: Maybe<Scalars['Float']['output']>;
  securityMasterId?: Maybe<Scalars['Int']['output']>;
  totalFairValue: Scalars['Float']['output'];
  /** Sum of look-through values across funds */
  totalLookthroughValue: Scalars['Float']['output'];
};

export enum AlignValue {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}

export type AllocationInput = {
  analysisDate: Scalars['DateTime']['input'];
  benchmarkName?: InputMaybe<Scalars['String']['input']>;
  benchmarks: Array<BenchmarkWeightInput>;
  customBenchmarkName?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['DateTime']['input'];
  excludeCash: Scalars['Boolean']['input'];
  quarterly: Scalars['Boolean']['input'];
  strategies?: InputMaybe<Array<Scalars['String']['input']>>;
  tagType: Scalars['String']['input'];
  timePeriod: Scalars['Int']['input'];
};

export type Application = {
  __typename?: 'Application';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ApplicationFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationFlagFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationFlagList = {
  __typename?: 'ApplicationFlagList';
  items: Array<ApplicationFlags>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type ApplicationFlagSort = {
  field: ApplicationFlagSortEnum;
  order: SortInput;
};

export enum ApplicationFlagSortEnum {
  Id = 'id'
}

export type ApplicationFlags = {
  __typename?: 'ApplicationFlags';
  applicationId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ApplicationList = {
  __typename?: 'ApplicationList';
  items: Array<Application>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type ApplicationSort = {
  field: ApplicationSortEnum;
  order: SortInput;
};

export enum ApplicationSortEnum {
  Id = 'id'
}

export type AssetClass2Enum = {
  __typename?: 'AssetClass2Enum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  market: AssetClassEnum;
  marketId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AssetClass2EnumFilterInput = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type AssetClass2EnumList = {
  __typename?: 'AssetClass2EnumList';
  items: Array<AssetClass2Enum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type AssetClass2EnumSort = {
  field: AssetClass2EnumSortEnum;
  order: SortInput;
};

export enum AssetClass2EnumSortEnum {
  DisplayOrder = 'displayOrder',
  Id = 'id',
  Name = 'name'
}

export type AssetClassEnum = {
  __typename?: 'AssetClassEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AssetClassEnumFilterInput = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type AssetClassEnumList = {
  __typename?: 'AssetClassEnumList';
  items: Array<AssetClassEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type AssetClassEnumSort = {
  field: AssetClassEnumSortEnum;
  order: SortInput;
};

export enum AssetClassEnumSortEnum {
  DisplayOrder = 'displayOrder',
  Id = 'id',
  Name = 'name'
}

export type AssetClassStrategy = {
  assetClass?: InputMaybe<Array<EntityKey>>;
  strategy?: InputMaybe<Array<EntityKey>>;
  subStrategy?: InputMaybe<Array<EntityKey>>;
};

export type AssetClassStrategyFilter = {
  values: Array<AssetClassStrategy>;
};

export type AssumeUserInput = {
  assumedUserId?: InputMaybe<Scalars['Int']['input']>;
};

export type AsyncTaskStatus = {
  __typename?: 'AsyncTaskStatus';
  createUser: Scalars['String']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  jsonResult?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  timestamp: Scalars['Timestamp']['output'];
};

export type AsyncTaskStatusInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AuditContactTypeEnum = {
  __typename?: 'AuditContactTypeEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AuditContactTypeEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type AuditContactTypeEnumList = {
  __typename?: 'AuditContactTypeEnumList';
  items: Array<AuditContactTypeEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type AuditContactTypeEnumSort = {
  field: AuditContactTypeEnumSortEnum;
  order: SortInput;
};

export enum AuditContactTypeEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type AumEntry = {
  asOfDate: Scalars['DateTime']['input'];
  firmAUM?: InputMaybe<Scalars['Float']['input']>;
  investmentAUM?: InputMaybe<Scalars['Float']['input']>;
  strategyAUM?: InputMaybe<Scalars['Float']['input']>;
};

export type AumFlow = {
  __typename?: 'AumFlow';
  investment?: Maybe<Scalars['Float']['output']>;
  strategy?: Maybe<Scalars['Float']['output']>;
};

export type AumRecord = {
  __typename?: 'AumRecord';
  asOfDate: Scalars['DateTime']['output'];
  aum?: Maybe<Scalars['Float']['output']>;
};

export type AxysCode = {
  __typename?: 'AxysCode';
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type AxysCodeFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type AxysCodeList = {
  __typename?: 'AxysCodeList';
  items: Array<AxysCode>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type AxysCodeSort = {
  field: AxysCodeSortEnum;
  order: SortInput;
};

export enum AxysCodeSortEnum {
  Code = 'code',
  Id = 'id'
}

export type Balances = {
  __typename?: 'Balances';
  acctManager?: Maybe<AccountingManager>;
  additions: Scalars['Float']['output'];
  date: Scalars['DateTime']['output'];
  endBalance: Scalars['Float']['output'];
  manager?: Maybe<Investment>;
  managerId: Scalars['Int']['output'];
  performance: Scalars['Float']['output'];
  portfolio?: Maybe<Portfolio>;
  portfolioId: Scalars['Int']['output'];
  redemptions: Scalars['Float']['output'];
  redemptionsSource?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<ManagerTags>;
};

export type BalancesFilter = {
  includeAccountingEntities?: InputMaybe<Scalars['Boolean']['input']>;
  managerAttributeName?: InputMaybe<Scalars['String']['input']>;
  managerId?: InputMaybe<Scalars['Int']['input']>;
  modelStartDate?: InputMaybe<Scalars['Date']['input']>;
  modelStopDate?: InputMaybe<Scalars['Date']['input']>;
  performanceStart?: InputMaybe<Scalars['Date']['input']>;
  portfolioId?: InputMaybe<Scalars['Int']['input']>;
};

export type BalancesList = {
  __typename?: 'BalancesList';
  items: Array<Balances>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type BalancesSort = {
  field: BalancesSortEnum;
  order: SortInput;
};

export enum BalancesSortEnum {
  Date = 'date',
  ManagerId = 'managerId',
  PortfolioId = 'portfolioId'
}

export type BatchReportSectionInput = {
  extractorPrompt?: InputMaybe<Scalars['String']['input']>;
  knowledgeBaseFilter?: InputMaybe<KnowledgeBaseFilter>;
  name: Scalars['String']['input'];
  reportPrompt?: InputMaybe<Scalars['String']['input']>;
  savedKnowledgeBaseId?: InputMaybe<Scalars['Int']['input']>;
};

export type BatchReportsInput = {
  additionalRecipients?: InputMaybe<Array<Scalars['String']['input']>>;
  consolidationPrompt?: InputMaybe<Scalars['String']['input']>;
  sections: Array<BatchReportSectionInput>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type BbgContainsDistribution = {
  __typename?: 'BbgContainsDistribution';
  _id: Scalars['String']['output'];
  _type: Scalars['String']['output'];
  accessible: Scalars['Boolean']['output'];
  contentType: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
};

export type BbgDistributionsResponse = {
  __typename?: 'BbgDistributionsResponse';
  _type: Scalars['JSON']['output'];
  contains?: Maybe<Array<BbgContainsDistribution>>;
  description?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  error_description?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['JSONObject']['output']>>;
  identifier?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
};

export type BenchmarkData = {
  __typename?: 'BenchmarkData';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  records: Array<TimeSeriesRecord>;
};

export type BenchmarkTimeSeries = {
  __typename?: 'BenchmarkTimeSeries';
  benchmarks: Array<BenchmarkData>;
  root: Array<TimeSeriesRecord>;
};

export type BenchmarkWeightInput = {
  benchmarkId: Scalars['Int']['input'];
  weight: Scalars['Float']['input'];
};

export type BloombergPullLoadInput = {
  currency: Scalars['String']['input'];
  dailyId: Scalars['String']['input'];
  monthlyId: Scalars['String']['input'];
};

export type BloombergPullResponse = {
  __typename?: 'BloombergPullResponse';
  currency: Scalars['String']['output'];
  dailyId: Scalars['String']['output'];
  monthlyId: Scalars['String']['output'];
  tickers: Array<Scalars['String']['output']>;
};

export type BucketFileInput = {
  bucket: Scalars['String']['input'];
  copyAccount: Scalars['String']['input'];
  digest?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
  sourceKey: Scalars['String']['input'];
};

export type BulkPersonProfileBuilderResponse = {
  __typename?: 'BulkPersonProfileBuilderResponse';
  answer?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['Int']['output']>;
  personProfiles?: Maybe<Array<GeneratedPersonProfile>>;
};

export enum BusinessObject {
  Company = 'company',
  Firm = 'firm',
  Investment = 'investment'
}

export type BusinessObjectEnum = {
  __typename?: 'BusinessObjectEnum';
  description: Scalars['String']['output'];
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type BusinessObjectEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type BusinessObjectEnumList = {
  __typename?: 'BusinessObjectEnumList';
  items: Array<BusinessObjectEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type BusinessObjectEnumSort = {
  field: BusinessObjectEnumSortEnum;
  order: SortInput;
};

export enum BusinessObjectEnumSortEnum {
  Id = 'id'
}

export type CalendarUnitEnum = {
  __typename?: 'CalendarUnitEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CalendarUnitEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CalendarUnitEnumList = {
  __typename?: 'CalendarUnitEnumList';
  items: Array<CalendarUnitEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type CalendarUnitEnumSort = {
  field: CalendarUnitEnumSortEnum;
  order: SortInput;
};

export enum CalendarUnitEnumSortEnum {
  DisplayOrder = 'displayOrder',
  Id = 'id',
  Name = 'name'
}

export enum CaseStudyAssetType {
  Private = 'private',
  Public = 'public'
}

export type Chart = {
  __typename?: 'Chart';
  url: Scalars['String']['output'];
};

/** High chart types */
export enum ChartType {
  Chart = 'Chart',
  StockChart = 'StockChart'
}

export type ChatAgent = {
  __typename?: 'ChatAgent';
  canDelete: Scalars['Boolean']['output'];
  canEdit: Scalars['Boolean']['output'];
  color?: Maybe<Scalars['String']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  createUserFullName?: Maybe<Scalars['String']['output']>;
  defaultMode: ChatAgentRunMode;
  description: Scalars['String']['output'];
  directive: Scalars['String']['output'];
  effort?: Maybe<ChatEffort>;
  id: Scalars['Int']['output'];
  isAutoInvocable: Scalars['Boolean']['output'];
  model?: Maybe<Scalars['String']['output']>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['Int']['output']>;
  requiredFlag?: Maybe<Scalars['String']['output']>;
  scope: ChatSkillScope;
  skills: Array<ChatSkill>;
  tools?: Maybe<Array<Scalars['String']['output']>>;
  version: Scalars['Int']['output'];
};

export type ChatAgentCapabilities = {
  __typename?: 'ChatAgentCapabilities';
  allowedColors: Array<Scalars['String']['output']>;
  allowedEfforts: Array<ChatEffort>;
  allowedModels: Array<Scalars['String']['output']>;
  blockedTools: Array<ChatToolType>;
  mcpToolBundles: Array<McpToolBundleType>;
  mcpToolCategories: Array<McpToolBundleType>;
  notOfferedToAgents: Array<McpToolBundleType>;
};

export type ChatAgentFilterInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<ChatSkillScope>;
};

export type ChatAgentHistory = {
  __typename?: 'ChatAgentHistory';
  archivedAt: Scalars['DateTime']['output'];
  archivedBy: Scalars['String']['output'];
  chatAgentId: Scalars['Int']['output'];
  defaultMode: ChatAgentRunMode;
  description: Scalars['String']['output'];
  directive: Scalars['String']['output'];
  effort?: Maybe<ChatEffort>;
  id: Scalars['Int']['output'];
  isAutoInvocable?: Maybe<Scalars['Boolean']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['Int']['output']>;
  scope: ChatSkillScope;
  skills?: Maybe<Scalars['JSON']['output']>;
  tools?: Maybe<Array<Scalars['String']['output']>>;
  version: Scalars['Int']['output'];
};

export type ChatAgentInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  defaultMode?: ChatAgentRunMode;
  description: Scalars['String']['input'];
  directive: Scalars['String']['input'];
  effort?: InputMaybe<ChatEffort>;
  isAutoInvocable?: Scalars['Boolean']['input'];
  model?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  requiredFlag?: InputMaybe<Scalars['String']['input']>;
  scope?: ChatSkillScope;
  skillIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  tools?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ChatAgentList = {
  __typename?: 'ChatAgentList';
  items: Array<ChatAgent>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

/** Whether a spawned agent's conversation is discarded or kept for resumption */
export enum ChatAgentRunMode {
  Ephemeral = 'EPHEMERAL',
  Persistent = 'PERSISTENT'
}

export type ChatAgentSort = {
  field: ChatAgentSortEnum;
  order: SortInput;
};

export enum ChatAgentSortEnum {
  Createdate = 'createdate',
  Modifydate = 'modifydate',
  Name = 'name',
  Scope = 'scope'
}

export type ChatAgentUpdateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  defaultMode?: InputMaybe<ChatAgentRunMode>;
  description?: InputMaybe<Scalars['String']['input']>;
  directive?: InputMaybe<Scalars['String']['input']>;
  effort?: InputMaybe<ChatEffort>;
  isAutoInvocable?: InputMaybe<Scalars['Boolean']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requiredFlag?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<ChatSkillScope>;
  skillIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  tools?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ChatContext = {
  documentId?: InputMaybe<Scalars['Int']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  entityType?: InputMaybe<ChatEntityType>;
  files?: InputMaybe<Array<ChatContextFile>>;
  knowledgeBaseId?: InputMaybe<Scalars['Int']['input']>;
  pageContext?: InputMaybe<PageContext>;
  portfolioId?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatContextFile = {
  bucket: Scalars['String']['input'];
  documentId?: InputMaybe<Scalars['Int']['input']>;
  documentQueueId?: InputMaybe<Scalars['ID']['input']>;
  fileUrl: Scalars['String']['input'];
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export enum ChatEffort {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium',
  XHigh = 'XHigh'
}

export enum ChatEntityType {
  Company = 'company',
  Engagement = 'engagement',
  Firm = 'firm',
  Investment = 'investment'
}

export type ChatPreferences = {
  __typename?: 'ChatPreferences';
  enabled: Scalars['Boolean']['output'];
  lastUpdated?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<Scalars['String']['output']>;
};

export type ChatPreferencesInput = {
  enabled: Scalars['Boolean']['input'];
  lastUpdated?: InputMaybe<Scalars['String']['input']>;
  preferences?: InputMaybe<Scalars['String']['input']>;
};

export type ChatSkill = {
  __typename?: 'ChatSkill';
  canDelete: Scalars['Boolean']['output'];
  canEdit: Scalars['Boolean']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  createUserFullName?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  instructions: Scalars['String']['output'];
  isAutoInvocable: Scalars['Boolean']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['Int']['output']>;
  requiredFlag?: Maybe<Scalars['String']['output']>;
  scope: ChatSkillScope;
  version: Scalars['Int']['output'];
};

export type ChatSkillFilterInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<ChatSkillScope>;
};

export type ChatSkillGrantableGroup = {
  __typename?: 'ChatSkillGrantableGroup';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ChatSkillGroup = {
  __typename?: 'ChatSkillGroup';
  access: ChatSkillGroupAccess;
  chatSkillId: Scalars['Int']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  groupId: Scalars['Int']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

/** Access level a group grant confers on a chat skill */
export enum ChatSkillGroupAccess {
  Write = 'WRITE'
}

export type ChatSkillHistory = {
  __typename?: 'ChatSkillHistory';
  archivedAt: Scalars['DateTime']['output'];
  archivedBy: Scalars['String']['output'];
  archivedByFullName?: Maybe<Scalars['String']['output']>;
  chatSkillId: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  instructions: Scalars['String']['output'];
  isAutoInvocable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['Int']['output']>;
  scope: ChatSkillScope;
  version: Scalars['Int']['output'];
};

export type ChatSkillInput = {
  description: Scalars['String']['input'];
  instructions: Scalars['String']['input'];
  isAutoInvocable?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  requiredFlag?: InputMaybe<Scalars['String']['input']>;
  scope?: ChatSkillScope;
};

export type ChatSkillList = {
  __typename?: 'ChatSkillList';
  items: Array<ChatSkill>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type ChatSkillSchedule = {
  __typename?: 'ChatSkillSchedule';
  chatSkillId: Scalars['Int']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  extraInstructions?: Maybe<Scalars['String']['output']>;
  frequency: ChatSkillScheduleFrequency;
  id: Scalars['Int']['output'];
  lastConversationId?: Maybe<Scalars['Int']['output']>;
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  lastRunStatus?: Maybe<ChatSkillScheduleRunStatus>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  nextRunAt: Scalars['DateTime']['output'];
  runAtHour: Scalars['Int']['output'];
  runAtMinute: Scalars['Int']['output'];
  runOnDayOfMonth?: Maybe<Scalars['Int']['output']>;
  runOnWeekday?: Maybe<Scalars['Int']['output']>;
  timezone: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type ChatSkillScheduleFilter = {
  chatSkillId?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum ChatSkillScheduleFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekdays = 'WEEKDAYS',
  Weekly = 'WEEKLY'
}

export type ChatSkillScheduleInput = {
  chatSkillId: Scalars['Int']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  extraInstructions?: InputMaybe<Scalars['String']['input']>;
  frequency: ChatSkillScheduleFrequency;
  runAtHour: Scalars['Int']['input'];
  runAtMinute?: InputMaybe<Scalars['Int']['input']>;
  runOnDayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  runOnWeekday?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type ChatSkillScheduleList = {
  __typename?: 'ChatSkillScheduleList';
  items: Array<ChatSkillSchedule>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export enum ChatSkillScheduleRunStatus {
  Error = 'ERROR',
  Success = 'SUCCESS'
}

export type ChatSkillScheduleSort = {
  field: ChatSkillScheduleSortEnum;
  order: SortInput;
};

export enum ChatSkillScheduleSortEnum {
  Createdate = 'createdate',
  Id = 'id',
  NextRunAt = 'nextRunAt'
}

/** Scope determines who can access the skill */
export enum ChatSkillScope {
  Organization = 'ORGANIZATION',
  Personal = 'PERSONAL',
  System = 'SYSTEM'
}

export type ChatSkillSort = {
  field: ChatSkillSortEnum;
  order: SortInput;
};

export enum ChatSkillSortEnum {
  Createdate = 'createdate',
  Modifydate = 'modifydate',
  Name = 'name',
  Scope = 'scope'
}

export type ChatSkillUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  isAutoInvocable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requiredFlag?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<ChatSkillScope>;
};

export type ChatSubscriptionPayload = {
  __typename?: 'ChatSubscriptionPayload';
  error?: Maybe<Scalars['Boolean']['output']>;
  messageStream: MessageStream;
  requestId: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
};

export type ChatTaskFinishedPayload = {
  __typename?: 'ChatTaskFinishedPayload';
  /** The file saved to the conversation, when the task produced one and saving it worked. */
  conversationArtifactId?: Maybe<Scalars['Int']['output']>;
  conversationId: Scalars['Int']['output'];
  taskId: Scalars['String']['output'];
};

export enum ChatToolType {
  ActivateSkillTool = 'ActivateSkillTool',
  AlphaVantageMcp = 'AlphaVantageMcp',
  AtlasTool = 'AtlasTool',
  CalculatorTool = 'CalculatorTool',
  ChartTool = 'ChartTool',
  CitationTool = 'CitationTool',
  CsvExportTool = 'CsvExportTool',
  CurrentPageTool = 'CurrentPageTool',
  DocumentTextReaderTool = 'DocumentTextReaderTool',
  DocumentsRagTool = 'DocumentsRagTool',
  FeedbackTool = 'FeedbackTool',
  ModifyMutationPlanTool = 'ModifyMutationPlanTool',
  NotesRagTool = 'NotesRagTool',
  ScratchpadTool = 'ScratchpadTool',
  SiriusMcp = 'SiriusMcp',
  SpawnSubAgentTool = 'SpawnSubAgentTool',
  SpreadsheetReaderTool = 'SpreadsheetReaderTool',
  StageMutationsTool = 'StageMutationsTool',
  UpdatePreferencesTool = 'UpdatePreferencesTool'
}

export type Citation = {
  __typename?: 'Citation';
  id: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type CitationInput = {
  id: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export type ClearSettingInput = {
  clearSettingKey: ClearSettingKey;
  userId: Scalars['Int']['input'];
};

export enum ClearSettingKey {
  ChatPreferences = 'chatPreferences',
  DefaultInvestmentView = 'defaultInvestmentView'
}

export type Client = {
  __typename?: 'Client';
  clientName?: Maybe<Scalars['String']['output']>;
  clientType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
};

/** One month of a share class's allocation (AllocationsNew), with what was ENTERED for the month beside what was computed. Returns and fee rates are in PERCENT (1.25 = 1.25%). */
export type ClientAllocationRow = {
  __typename?: 'ClientAllocationRow';
  actGrossEndBal?: Maybe<Scalars['Float']['output']>;
  actGrossReturn?: Maybe<Scalars['Float']['output']>;
  actNetEndBal?: Maybe<Scalars['Float']['output']>;
  actNetReturn?: Maybe<Scalars['Float']['output']>;
  addition?: Maybe<Scalars['Float']['output']>;
  adjBegBal?: Maybe<Scalars['Float']['output']>;
  adminFee?: Maybe<Scalars['Float']['output']>;
  adminFeeRate?: Maybe<Scalars['Float']['output']>;
  begBal: Scalars['Float']['output'];
  clientId: Scalars['Int']['output'];
  clientName: Scalars['String']['output'];
  date: Scalars['Date']['output'];
  /** Derived inputs: not editable. */
  derived?: Maybe<Scalars['Boolean']['output']>;
  effGrossReturn?: Maybe<Scalars['Float']['output']>;
  effNetReturn?: Maybe<Scalars['Float']['output']>;
  enteredAdminFee?: Maybe<Scalars['Float']['output']>;
  enteredIncentiveFee?: Maybe<Scalars['Float']['output']>;
  /** Fees as entered for the month (null: calculated). */
  enteredMgmtFee?: Maybe<Scalars['Float']['output']>;
  estGrossEndBal?: Maybe<Scalars['Float']['output']>;
  estGrossReturn?: Maybe<Scalars['Float']['output']>;
  estNetEndBal?: Maybe<Scalars['Float']['output']>;
  estNetReturn?: Maybe<Scalars['Float']['output']>;
  finalGrossReturn?: Maybe<Scalars['Float']['output']>;
  finalNetReturn?: Maybe<Scalars['Float']['output']>;
  grossEndBal?: Maybe<Scalars['Float']['output']>;
  incentiveFee?: Maybe<Scalars['Float']['output']>;
  /** Entered, else calculated from the fee schedule. */
  mgmtFee?: Maybe<Scalars['Float']['output']>;
  mgmtFeeRate?: Maybe<Scalars['Float']['output']>;
  netEndBal?: Maybe<Scalars['Float']['output']>;
  pl?: Maybe<Scalars['Float']['output']>;
  rcgFundId: Scalars['Int']['output'];
  rcgFundName: Scalars['String']['output'];
  redemption?: Maybe<Scalars['Float']['output']>;
  shareClassId: Scalars['Int']['output'];
  shareClassName: Scalars['String']['output'];
  switchIn?: Maybe<Scalars['Float']['output']>;
  switchOut?: Maybe<Scalars['Float']['output']>;
};

/** A share class's capital changes for a month (vCashFlowsAndSwitches): redemptions and switch-outs are negative. */
export type ClientCapitalFlowRow = {
  __typename?: 'ClientCapitalFlowRow';
  addition?: Maybe<Scalars['Float']['output']>;
  date: Scalars['Date']['output'];
  redemption?: Maybe<Scalars['Float']['output']>;
  shareClassId: Scalars['Int']['output'];
  switchIn?: Maybe<Scalars['Float']['output']>;
  switchOut?: Maybe<Scalars['Float']['output']>;
};

export type ClientDocumentNotificationStatus = {
  __typename?: 'ClientDocumentNotificationStatus';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** A fee option (FeeAUMOptionEnum, FeeRateOptionEnum or FeeUnitOptionEnum). */
export type ClientFeeOption = {
  __typename?: 'ClientFeeOption';
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type ClientFeeOptions = {
  __typename?: 'ClientFeeOptions';
  /** The balance a fee is charged on. */
  aum?: Maybe<Array<ClientFeeOption>>;
  /** How an annual rate becomes monthly. */
  rate?: Maybe<Array<ClientFeeOption>>;
  /** Percentage of the balance, or dollars. */
  unit?: Maybe<Array<ClientFeeOption>>;
};

export type ClientFeeTierInput = {
  isFlat: Scalars['Boolean']['input'];
  rate: Scalars['Float']['input'];
  threshold: Scalars['Float']['input'];
};

/** One band of a fee schedule. rate is annual, as entered: percent for a percentage unit, else dollars. */
export type ClientFeeTierRow = {
  __typename?: 'ClientFeeTierRow';
  isFlat: Scalars['Boolean']['output'];
  rate: Scalars['Float']['output'];
  threshold: Scalars['Float']['output'];
};

export type ClientFilter = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type ClientInvestmentClient = {
  __typename?: 'ClientInvestmentClient';
  clientId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** An RCG fund clients can hold share classes in (the legacy vRcgFunds2). */
export type ClientInvestmentFund = {
  __typename?: 'ClientInvestmentFund';
  /** Groups funds for multi-fund pages: investment structure, else NAV classification. */
  groupId?: Maybe<Scalars['Int']['output']>;
  groupName: Scalars['String']['output'];
  /** A combined fund: its one share class is the sum of its child funds'. */
  isCombined?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  rcgFundId: Scalars['Int']['output'];
};

export type ClientList = {
  __typename?: 'ClientList';
  items: Array<Client>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

/** One share class's month-end entries: null clears a value, an omitted field is left as it is. */
export type ClientMonthEntryInput = {
  actualEndBal?: InputMaybe<Scalars['Float']['input']>;
  adminFee?: InputMaybe<Scalars['Float']['input']>;
  /** Percent (1.25 = 1.25%). */
  finalGrossReturn?: InputMaybe<Scalars['Float']['input']>;
  /** Percent (1.25 = 1.25%). */
  finalNetReturn?: InputMaybe<Scalars['Float']['input']>;
  /** Performance (incentive) fee. */
  incentiveFee?: InputMaybe<Scalars['Float']['input']>;
  mgmtFee?: InputMaybe<Scalars['Float']['input']>;
  shareClassId: Scalars['Int']['input'];
};

export type ClientShareClassInput = {
  adminTiers: Array<ClientFeeTierInput>;
  clientId: Scalars['Int']['input'];
  feeAumOptionId: Scalars['Int']['input'];
  feeRateOptionId: Scalars['Int']['input'];
  feeUnitOptionId: Scalars['Int']['input'];
  mgmtTiers: Array<ClientFeeTierInput>;
  name: Scalars['String']['input'];
  rcgFundId: Scalars['Int']['input'];
  /** Set to edit (and possibly rename) an existing share class. */
  shareClassId?: InputMaybe<Scalars['Int']['input']>;
  unfunded: Scalars['Boolean']['input'];
};

/** A client's share class in an RCG fund, with its fee terms. */
export type ClientShareClassRow = {
  __typename?: 'ClientShareClassRow';
  adminTiers: Array<ClientFeeTierRow>;
  clientId: Scalars['Int']['output'];
  /** No flows, switches, balances or allocations refer to it. */
  deletable?: Maybe<Scalars['Boolean']['output']>;
  /** Its flows, balances and fees are derived from other share classes (a combined fund's, or 1875), not entered. */
  derived?: Maybe<Scalars['Boolean']['output']>;
  feeAumOptionId: Scalars['Int']['output'];
  feeRateOptionId: Scalars['Int']['output'];
  feeUnitOptionId: Scalars['Int']['output'];
  mgmtTiers: Array<ClientFeeTierRow>;
  name: Scalars['String']['output'];
  rcgFundId: Scalars['Int']['output'];
  shareClassId: Scalars['Int']['output'];
  /** Committed capital: returns are not applied. */
  unfunded?: Maybe<Scalars['Boolean']['output']>;
};

export type ClientSort = {
  field: ClientSortEnum;
  order: SortInput;
};

export enum ClientSortEnum {
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

/** A transfer between two share classes in a month, as entered (positive). */
export type ClientSwitchRow = {
  __typename?: 'ClientSwitchRow';
  amount: Scalars['Float']['output'];
  date: Scalars['Date']['output'];
  fromShareClassId: Scalars['Int']['output'];
  toShareClassId: Scalars['Int']['output'];
};

export enum ClientVisibleTabs {
  Analytics = 'analytics',
  Documents = 'documents',
  Investment = 'investment',
  Overview = 'overview',
  OverviewGeneral = 'overviewGeneral',
  OverviewPerformance = 'overviewPerformance',
  OverviewPorfolio = 'overviewPorfolio',
  OverviewServiceProviders = 'overviewServiceProviders'
}

export type CloseDateFundSize = {
  __typename?: 'CloseDateFundSize';
  closeDate: Scalars['Date']['output'];
  fundSize: Scalars['Float']['output'];
  investment: Investment;
  investmentId: Scalars['Int']['output'];
  peCloseDateFundSizeId: Scalars['Int']['output'];
};

export type CloseDateShort = {
  closeDate?: InputMaybe<Scalars['Date']['input']>;
  fundSize?: InputMaybe<Scalars['Float']['input']>;
};

export type CogencyLink = {
  __typename?: 'CogencyLink';
  adminBookType: Scalars['Int']['output'];
  cogFinal?: Maybe<Scalars['Boolean']['output']>;
  cogFirstMonthAdjust?: Maybe<Scalars['Boolean']['output']>;
  cogStartDate?: Maybe<Scalars['Date']['output']>;
  cogencyId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  investment: Investment;
  isInactive: Scalars['Boolean']['output'];
  isLiquidating: Scalars['Boolean']['output'];
  solovisDataEnabled: Scalars['Boolean']['output'];
  solovisTranStartDate?: Maybe<Scalars['Date']['output']>;
};

export type CogencyLinkInput = {
  cogFinal?: InputMaybe<Scalars['Boolean']['input']>;
  cogFirstMonthAdjust?: InputMaybe<Scalars['Boolean']['input']>;
  cogStartDate?: InputMaybe<Scalars['Date']['input']>;
  cogencyId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  solovisDataEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  solovisTranStartDate?: InputMaybe<Scalars['Date']['input']>;
};

export type Company = {
  __typename?: 'Company';
  applicationCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  companyType?: Maybe<CompanyTypeEnum>;
  companyTypeEnumId?: Maybe<Scalars['ID']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deals: Array<Deal>;
  diligenceTabs?: Maybe<Array<TemplateAttachment>>;
  documents: Array<Maybe<Document>>;
  faceOfCompany?: Maybe<FirmEmployment>;
  fieldData: FieldData;
  fieldHistory: Array<Field>;
  fields?: Maybe<CompanyFields>;
  firmAttributes: Firm;
  firmId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isBusinessApplication: Scalars['Boolean']['output'];
  lastFundingType?: Maybe<FundingTypeEnum>;
  lastFundingTypeEnumId?: Maybe<Scalars['ID']['output']>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Has RockCreek signed an NDA precluding them from sharing fund data with 3rd Parties? */
  ndaSigned?: Maybe<Scalars['Boolean']['output']>;
  operatingStatus?: Maybe<OperatingStatusEnum>;
  operatingStatusEnumId?: Maybe<Scalars['ID']['output']>;
  primaryAssignment?: Maybe<Scalars['String']['output']>;
  primaryCompanyAdvisor?: Maybe<User>;
  primaryCompanyManager?: Maybe<FirmEmployment>;
  summary?: Maybe<Scalars['String']['output']>;
  templateOptions: Array<Scalars['String']['output']>;
  valuations: Array<CompanyValuation>;
};


export type CompanyDealsArgs = {
  filter?: InputMaybe<DealFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DealSort>>;
};


export type CompanyFieldDataArgs = {
  fieldSetType: FieldSetType;
  state?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyFieldHistoryArgs = {
  filter?: InputMaybe<FieldHistoryFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FieldHistorySort>>;
};


export type CompanyFieldsArgs = {
  state?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyTemplateOptionsArgs = {
  fieldSetType: FieldSetType;
};


export type CompanyValuationsArgs = {
  filter?: InputMaybe<CompanyValuationFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CompanyValuationSort>>;
};

export type CompanyEnum = {
  __typename?: 'CompanyEnum';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CompanyEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyEnumList = {
  __typename?: 'CompanyEnumList';
  items: Array<CompanyEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type CompanyEnumSort = {
  field: CompanyEnumSortEnum;
  order: SortInput;
};

export enum CompanyEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type CompanyFields = {
  __typename?: 'CompanyFields';
  companyId: Scalars['ID']['output'];
  companyName?: Maybe<CompanyName>;
  state?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<FieldValue>>;
};

export type CompanyFilter = {
  applicationCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  companyTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  fuzzyMatch?: InputMaybe<Scalars['String']['input']>;
  lastFundingTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  operatingStatusEnumId?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  searchFilters?: InputMaybe<CompanySearchFilters>;
};

export type CompanyInput = {
  companyTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  firmAttributes?: InputMaybe<FirmAttributes>;
  lastFundingTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ndaSigned?: InputMaybe<Scalars['Boolean']['input']>;
  operatingStatusEnumId?: InputMaybe<Scalars['Int']['input']>;
  primaryAssignment?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyList = {
  __typename?: 'CompanyList';
  items: Array<Company>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type CompanyName = {
  __typename?: 'CompanyName';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CompanySearchFilters = {
  COMPANY_ENTITY?: InputMaybe<EntitySearchFilter>;
  HEADQUARTERS?: InputMaybe<LocationFilter>;
  IMPACT?: InputMaybe<ImpactSearchFilter>;
  NAME?: InputMaybe<Scalars['String']['input']>;
  TAG_ENTITY?: InputMaybe<EntitySearchFilter>;
  YEAR_FOUNDED?: InputMaybe<IntRangeFilter>;
};

export type CompanySort = {
  field: CompanySortEnum;
  order: SortInput;
};

export enum CompanySortEnum {
  FuzzyRank = 'fuzzyRank',
  Id = 'id',
  LatestUpdate = 'latestUpdate',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type CompanyTypeEnum = {
  __typename?: 'CompanyTypeEnum';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CompanyTypeEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CompanyTypeEnumList = {
  __typename?: 'CompanyTypeEnumList';
  items: Array<CompanyTypeEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type CompanyTypeEnumSort = {
  field: CompanyTypeEnumSortEnum;
  order: SortInput;
};

export enum CompanyTypeEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type CompanyValuation = {
  __typename?: 'CompanyValuation';
  asOfDate: Scalars['Date']['output'];
  company?: Maybe<Company>;
  companyId: Scalars['Int']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  valuation?: Maybe<Scalars['Float']['output']>;
};

export type CompanyValuationFilter = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyValuationInput = {
  asOfDate: Scalars['Date']['input'];
  companyId: Scalars['Int']['input'];
  valuation?: InputMaybe<Scalars['Float']['input']>;
};

export type CompanyValuationList = {
  __typename?: 'CompanyValuationList';
  items: Array<CompanyValuation>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type CompanyValuationSort = {
  field: CompanyValuationSortEnum;
  order: SortInput;
};

export enum CompanyValuationSortEnum {
  AsOfDate = 'asOfDate',
  Id = 'id'
}

export type CompletenessSearchFilter = {
  category?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
};

export type CompoundingPeriodEnum = {
  __typename?: 'CompoundingPeriodEnum';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type CompoundingPeriodEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CompoundingPeriodEnumList = {
  __typename?: 'CompoundingPeriodEnumList';
  items: Array<CompoundingPeriodEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type CompoundingPeriodEnumSort = {
  field: CompoundingPeriodEnumSortEnum;
  order: SortInput;
};

export enum CompoundingPeriodEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type ComputeMetricsResult = {
  __typename?: 'ComputeMetricsResult';
  computed: Scalars['Int']['output'];
  errors: Scalars['Int']['output'];
};

export type ComputePortfolioBenchmarksResponse = {
  __typename?: 'ComputePortfolioBenchmarksResponse';
  csv: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  json: Scalars['JSON']['output'];
};

export type ConsultedExcerpts = {
  __typename?: 'ConsultedExcerpts';
  id: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export type ContactTypeEnum = {
  __typename?: 'ContactTypeEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ContactTypeEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ContactTypeEnumList = {
  __typename?: 'ContactTypeEnumList';
  items: Array<ContactTypeEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type ContactTypeEnumSort = {
  field: ContactTypeEnumSortEnum;
  order: SortInput;
};

export enum ContactTypeEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type Conversation = {
  __typename?: 'Conversation';
  agentId?: Maybe<Scalars['Int']['output']>;
  agentVersion?: Maybe<Scalars['Int']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  deleteUserId?: Maybe<Scalars['Int']['output']>;
  hasMutationPlans?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  lastActivityDate?: Maybe<Scalars['DateTime']['output']>;
  parentConversationId?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<ConversationSource>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type ConversationArtifact = {
  __typename?: 'ConversationArtifact';
  artifactName: Scalars['String']['output'];
  artifactType: ConversationArtifactType;
  contentType?: Maybe<Scalars['String']['output']>;
  conversationId: Scalars['Int']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  downloadUrl: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
};

export enum ConversationArtifactType {
  Document = 'document',
  Export = 'export',
  Other = 'other',
  SkillOutput = 'skillOutput',
  ToolResult = 'toolResult'
}

export type ConversationHistory = {
  __typename?: 'ConversationHistory';
  answer?: Maybe<Scalars['String']['output']>;
  chatContext?: Maybe<Scalars['String']['output']>;
  conversationId: Scalars['Int']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  question: Scalars['String']['output'];
};

export type ConversationList = {
  __typename?: 'ConversationList';
  items: Array<Conversation>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export enum ConversationSource {
  AgentChat = 'agentChat',
  BulkPersonProfileFromFilesBuilder = 'bulkPersonProfileFromFilesBuilder',
  ConversationSummary = 'conversationSummary',
  DocumentChat = 'documentChat',
  DocumentChatSpecific = 'documentChatSpecific',
  InvestmentProfileBuilder = 'investmentProfileBuilder',
  PersonProfileFromFilesBuilder = 'personProfileFromFilesBuilder',
  ScheduledSkillRun = 'scheduledSkillRun',
  ShareClassProfileBuilder = 'shareClassProfileBuilder',
  SiriusChat = 'siriusChat',
  SubAgent = 'subAgent'
}

export type CountryEnum = {
  __typename?: 'CountryEnum';
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CountryEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type CountryEnumList = {
  __typename?: 'CountryEnumList';
  items: Array<CountryEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type CountryEnumSort = {
  field: CountryEnumSortEnum;
  order: SortInput;
};

export enum CountryEnumSortEnum {
  Name = 'name'
}

export type CreateFieldDefinitionInput = {
  columns?: InputMaybe<Array<FieldColumnInput>>;
  displayName: Scalars['String']['input'];
  displayType: Scalars['String']['input'];
  fieldKey: Scalars['String']['input'];
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  ownerType: Scalars['String']['input'];
  questionText?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGuidelineInput = {
  format?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<Scalars['Int']['input']>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  limitRelationToResult?: InputMaybe<Scalars['Int']['input']>;
  limitValue?: InputMaybe<Scalars['String']['input']>;
  resultCardinality: Scalars['Int']['input'];
  resultType: Scalars['Int']['input'];
};

export type CreateGuidelineNodeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['Int']['input']>;
  siblingIndex?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateGuidelineSetInput = {
  copyGuidelines?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDate: Scalars['DateTime']['input'];
};

export type CreateTemplateAttachmentInput = {
  assetClassName?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  entityLevel: Scalars['String']['input'];
  fieldSetType: FieldSetType;
  label?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  vehicleType?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTemplateInput = {
  content: Scalars['JSON']['input'];
  fieldSetGroup: Scalars['String']['input'];
  fieldSetType: FieldSetType;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreditUsage = {
  __typename?: 'CreditUsage';
  allotment: Scalars['Int']['output'];
  periodEnd: Scalars['Date']['output'];
  periodStart: Scalars['Date']['output'];
  remaining: Scalars['Float']['output'];
  used: Scalars['Float']['output'];
};

export type CurrencyDenominationEnum = {
  __typename?: 'CurrencyDenominationEnum';
  displayOrder?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  isPerformanceCurrency?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type CurrencyDenominationEnumFilter = {
  convertibleFromCurrency?: InputMaybe<Scalars['String']['input']>;
  isPerformanceCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CurrencyDenominationEnumList = {
  __typename?: 'CurrencyDenominationEnumList';
  items: Array<CurrencyDenominationEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type CurrencyDenominationEnumSort = {
  field: CurrencyDenominationEnumSortEnum;
  order: SortInput;
};

export enum CurrencyDenominationEnumSortEnum {
  DisplayOrder = 'displayOrder',
  Id = 'id',
  Name = 'name'
}

export type CurrentUser = {
  __typename?: 'CurrentUser';
  access: EntityAccess;
  assumedUserId?: Maybe<Scalars['Int']['output']>;
  commonName: Scalars['String']['output'];
  currentUserId: Scalars['Int']['output'];
  email?: Maybe<Scalars['String']['output']>;
  entryType: AdEntryType;
  entryTypeId: Scalars['Int']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  flags: UserFlags;
  groupEntityType?: Maybe<GroupEntityType>;
  groupIds?: Maybe<Array<Scalars['Int']['output']>>;
  groups?: Maybe<Array<User>>;
  id: Scalars['Int']['output'];
  imageType?: Maybe<Scalars['String']['output']>;
  imageTypeSm?: Maybe<Scalars['String']['output']>;
  isAssumed?: Maybe<Scalars['Boolean']['output']>;
  isGroup: Scalars['Boolean']['output'];
  isPrimaryOrganizationGroup?: Maybe<Scalars['Boolean']['output']>;
  isUser: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  oktaUser?: Maybe<OktaUser>;
  organization: Organization;
  organizationId?: Maybe<Scalars['Int']['output']>;
  pushProfileChanges?: Maybe<Scalars['Boolean']['output']>;
  roleIds: Array<Scalars['Int']['output']>;
  roles: Array<ApplicationFlags>;
  sets?: Maybe<Array<Set>>;
  sub?: Maybe<Scalars['String']['output']>;
  userIds?: Maybe<Array<Scalars['Int']['output']>>;
  userName: Scalars['String']['output'];
  userSettings?: Maybe<UserSettings>;
  username?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<User>>;
};

export type CustomAnalytics = {
  __typename?: 'CustomAnalytics';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  digest?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  investment?: Maybe<Investment>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  ownerId: Scalars['Int']['output'];
  ownerType: FieldOwnerType;
  signedUrl?: Maybe<Scalars['String']['output']>;
  value: Scalars['JSON']['output'];
};

export type CustomAnalyticsFilter = {
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  ownerType?: InputMaybe<FieldOwnerType>;
};

export type CustomAnalyticsInput = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  ownerType?: InputMaybe<FieldOwnerType>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type CustomAnalyticsList = {
  __typename?: 'CustomAnalyticsList';
  items: Array<CustomAnalytics>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type CustomAnalyticsSort = {
  field: CustomAnalyticsSortEnum;
  order: SortInput;
};

export enum CustomAnalyticsSortEnum {
  AsOfDate = 'asOfDate',
  Id = 'id',
  OwnerId = 'ownerId',
  OwnerType = 'ownerType'
}

export type CustomIndexGroup = {
  __typename?: 'CustomIndexGroup';
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  geReturnDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  leReturnDate?: Maybe<Scalars['Date']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  outputInvestment: Investment;
  terms: CustomIndexTermList;
};


export type CustomIndexGroupTermsArgs = {
  filter?: InputMaybe<CustomIndexTermFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CustomIndexTermSort>>;
};

export type CustomIndexGroupFilter = {
  outputInvestmentId?: InputMaybe<Scalars['Int']['input']>;
  outputInvestmentName?: InputMaybe<Scalars['String']['input']>;
};

export type CustomIndexGroupInput = {
  geReturnDate?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  leReturnDate?: InputMaybe<Scalars['Date']['input']>;
  terms: Array<CustomIndexTermInput>;
};

export type CustomIndexGroupList = {
  __typename?: 'CustomIndexGroupList';
  items: Array<CustomIndexGroup>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type CustomIndexGroupSort = {
  field: CustomIndexGroupSortEnum;
  order: SortInput;
};

export enum CustomIndexGroupSortEnum {
  GeReturnDate = 'geReturnDate',
  Id = 'id',
  LeReturnDate = 'leReturnDate',
  NameSearchRank = 'nameSearchRank',
  OutputInvestmentId = 'outputInvestmentId'
}

export type CustomIndexInvestment = {
  __typename?: 'CustomIndexInvestment';
  groups: CustomIndexGroupList;
  id: Scalars['Int']['output'];
  outputInvestment: Investment;
};


export type CustomIndexInvestmentGroupsArgs = {
  filter?: InputMaybe<CustomIndexGroupFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CustomIndexGroupSort>>;
};

export type CustomIndexInvestmentFilter = {
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CustomIndexInvestmentInput = {
  groups: Array<CustomIndexGroupInput>;
  outputInvestmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomIndexInvestmentList = {
  __typename?: 'CustomIndexInvestmentList';
  items: Array<CustomIndexInvestment>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type CustomIndexInvestmentSort = {
  field: CustomIndexInvestmentSortEnum;
  order: SortInput;
};

export enum CustomIndexInvestmentSortEnum {
  Id = 'id',
  NameSearchRank = 'nameSearchRank'
}

export type CustomIndexTerm = {
  __typename?: 'CustomIndexTerm';
  additionFactor: Scalars['Float']['output'];
  additionFactorAfter: Scalars['Float']['output'];
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  groupId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  inputInvestment: Investment;
  inputInvestmentId: Scalars['Int']['output'];
  laggedMonths: Scalars['Int']['output'];
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  multiplierFactor: Scalars['Float']['output'];
};

export type CustomIndexTermFilter = {
  groupId?: InputMaybe<Scalars['Int']['input']>;
  inputInvestmentName?: InputMaybe<Scalars['String']['input']>;
};

export type CustomIndexTermInput = {
  additionFactor?: InputMaybe<Scalars['Float']['input']>;
  additionFactorAfter?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  inputInvestmentId: Scalars['Int']['input'];
  laggedMonths?: InputMaybe<Scalars['Int']['input']>;
  multiplierFactor?: InputMaybe<Scalars['Float']['input']>;
};

export type CustomIndexTermList = {
  __typename?: 'CustomIndexTermList';
  items: Array<CustomIndexTerm>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type CustomIndexTermSort = {
  field: CustomIndexTermSortEnum;
  order: SortInput;
};

export enum CustomIndexTermSortEnum {
  GroupId = 'groupId',
  Id = 'id',
  NameSearchRank = 'nameSearchRank'
}

export type CustomPromptsInput = {
  fieldKey: Scalars['String']['input'];
  prompt: Scalars['String']['input'];
};

export type DateRangeFilter = {
  max?: InputMaybe<Scalars['DateTime']['input']>;
  min?: InputMaybe<Scalars['DateTime']['input']>;
  relativeN?: InputMaybe<Scalars['Int']['input']>;
  relativeUnit?: InputMaybe<RelativeDateUnit>;
  roundToStart?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DatedAsset = {
  __typename?: 'DatedAsset';
  currency?: Maybe<CurrencyDenominationEnum>;
  date?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type Deal = {
  __typename?: 'Deal';
  access: EntityAccess;
  amount?: Maybe<Scalars['Float']['output']>;
  assetClass?: Maybe<AssetClass2Enum>;
  assetClassEnumId?: Maybe<Scalars['Int']['output']>;
  coInvestors?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['Int']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  dateReceived?: Maybe<Scalars['Date']['output']>;
  dealGroupId?: Maybe<Scalars['Int']['output']>;
  dealMarketing?: Maybe<DealMarketingEnum>;
  dealMarketingEnumId?: Maybe<Scalars['ID']['output']>;
  dealStructure?: Maybe<DealStructureEnum>;
  dealStructureEnumId?: Maybe<Scalars['ID']['output']>;
  dealTags: Array<DealTags>;
  documents?: Maybe<Array<Document>>;
  expectedCloseDate?: Maybe<Scalars['Date']['output']>;
  firm?: Maybe<Firm>;
  firmId: Scalars['Int']['output'];
  fundingRound?: Maybe<FundingTypeEnum>;
  fundingRoundEnumId?: Maybe<Scalars['ID']['output']>;
  headquarters?: Maybe<CountryEnum>;
  headquartersEnumId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isImpact?: Maybe<Scalars['Boolean']['output']>;
  isLeadInvestor?: Maybe<Scalars['Boolean']['output']>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  passedNote?: Maybe<Scalars['String']['output']>;
  preMoneyValuation?: Maybe<Scalars['Float']['output']>;
  rcSource?: Maybe<Scalars['String']['output']>;
  rcSourceUser?: Maybe<InvestmentAssignmentOption>;
  result?: Maybe<ResultEnum>;
  resultEnumId?: Maybe<Scalars['ID']['output']>;
  roundSize?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<StageEnum>;
  stageEnumId?: Maybe<Scalars['ID']['output']>;
  strategy?: Maybe<StrategyEnum>;
  strategyEnumId?: Maybe<Scalars['Int']['output']>;
  subStrategy?: Maybe<SubStrategyEnum>;
  subStrategyEnumId?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
};


export type DealDealTagsArgs = {
  filter?: InputMaybe<DealTagsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DealTagsSort>>;
};

export type DealFilter = {
  assetClassEnumId?: InputMaybe<Scalars['Int']['input']>;
  closeDateRangeFrom?: InputMaybe<Scalars['String']['input']>;
  closeDateRangeTo?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  dealMarketingEnumId?: InputMaybe<Scalars['ID']['input']>;
  dealStructureEnumId?: InputMaybe<Scalars['ID']['input']>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  fundingRoundEnumId?: InputMaybe<Scalars['ID']['input']>;
  headquartersEnumId?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isBusinessApplication?: InputMaybe<Scalars['Boolean']['input']>;
  isImpact?: InputMaybe<Scalars['Boolean']['input']>;
  isLeadInvestor?: InputMaybe<Scalars['Boolean']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  rcSource?: InputMaybe<Scalars['String']['input']>;
  resultEnumId?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  stageEnumId?: InputMaybe<Scalars['ID']['input']>;
};

export type DealFilterOptions = {
  __typename?: 'DealFilterOptions';
  assetClassOptionIds?: Maybe<Array<Scalars['Int']['output']>>;
  assetClassOptions?: Maybe<Array<AssetClass2Enum>>;
  dealMarketingOptionIds?: Maybe<Array<Scalars['Int']['output']>>;
  dealMarketingOptions?: Maybe<Array<DealMarketingEnum>>;
  dealStructureOptionIds?: Maybe<Array<Scalars['Int']['output']>>;
  dealStructureOptions?: Maybe<Array<DealStructureEnum>>;
  fundingTypeOptionIds?: Maybe<Array<Scalars['Int']['output']>>;
  fundingTypeOptions?: Maybe<Array<FundingTypeEnum>>;
  headQuarterOptionIds?: Maybe<Array<Scalars['Int']['output']>>;
  headQuarterOptions?: Maybe<Array<CountryEnum>>;
  rcSourceOptions?: Maybe<Array<Scalars['String']['output']>>;
  resultOptionIds?: Maybe<Array<Scalars['Int']['output']>>;
  resultOptions?: Maybe<Array<ResultEnum>>;
  stageOptionIds?: Maybe<Array<Scalars['Int']['output']>>;
  stageOptions?: Maybe<Array<StageEnum>>;
};

export type DealInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  assetClassEnumId?: InputMaybe<Scalars['Int']['input']>;
  coInvestors?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  dateReceived?: InputMaybe<Scalars['Date']['input']>;
  dealGroupId?: InputMaybe<Scalars['Int']['input']>;
  dealMarketingEnumId?: InputMaybe<Scalars['ID']['input']>;
  dealStructureEnumId?: InputMaybe<Scalars['ID']['input']>;
  dealTags?: InputMaybe<Array<DealTagsInput>>;
  expectedCloseDate?: InputMaybe<Scalars['Date']['input']>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  fundingRoundEnumId?: InputMaybe<Scalars['ID']['input']>;
  headquartersEnumId?: InputMaybe<Scalars['Int']['input']>;
  isImpact?: InputMaybe<Scalars['Boolean']['input']>;
  isLeadInvestor?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  passedNote?: InputMaybe<Scalars['String']['input']>;
  preMoneyValuation?: InputMaybe<Scalars['Float']['input']>;
  rcSource?: InputMaybe<Scalars['String']['input']>;
  resultEnumId?: InputMaybe<Scalars['ID']['input']>;
  roundSize?: InputMaybe<Scalars['Float']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  stageEnumId?: InputMaybe<Scalars['ID']['input']>;
  strategyEnumId?: InputMaybe<Scalars['Int']['input']>;
  subStrategyEnumId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type DealList = {
  __typename?: 'DealList';
  items: Array<Deal>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type DealMarketingEnum = {
  __typename?: 'DealMarketingEnum';
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type DealMarketingEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type DealMarketingEnumList = {
  __typename?: 'DealMarketingEnumList';
  items: Array<DealMarketingEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type DealMarketingEnumSort = {
  field: DealMarketingEnumSortEnum;
  order: SortInput;
};

export enum DealMarketingEnumSortEnum {
  DisplayOrder = 'displayOrder',
  Id = 'id',
  Name = 'name'
}

export type DealSort = {
  field: DealSortEnum;
  order: SortInput;
};

export enum DealSortEnum {
  Amount = 'amount',
  AssetClassEnumId = 'assetClassEnumId',
  CompanyName = 'companyName',
  CompanyNameSearchRank = 'companyNameSearchRank',
  DealMarketingEnumId = 'dealMarketingEnumId',
  DealStructureEnumId = 'dealStructureEnumId',
  ExpectedCloseDate = 'expectedCloseDate',
  FundingRoundEnumId = 'fundingRoundEnumId',
  HeadquartersEnumId = 'headquartersEnumId',
  Id = 'id',
  IsImpact = 'isImpact',
  Name = 'name',
  NameSearchRank = 'nameSearchRank',
  RcSource = 'rcSource',
  ResultEnumId = 'resultEnumId',
  Source = 'source',
  StageEnumDefault = 'stageEnumDefault',
  StageEnumId = 'stageEnumId'
}

export type DealStructureEnum = {
  __typename?: 'DealStructureEnum';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type DealStructureEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type DealStructureEnumList = {
  __typename?: 'DealStructureEnumList';
  items: Array<DealStructureEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type DealStructureEnumSort = {
  field: DealStructureEnumSortEnum;
  order: SortInput;
};

export enum DealStructureEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type DealTags = {
  __typename?: 'DealTags';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  dealId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  tag: Tag;
  tagId: Scalars['Int']['output'];
};

export type DealTagsFilter = {
  dealId?: InputMaybe<Scalars['Int']['input']>;
  tagClassId?: InputMaybe<Scalars['Int']['input']>;
  tagClassIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tagId?: InputMaybe<Scalars['Int']['input']>;
};

export type DealTagsInput = {
  dealId?: InputMaybe<Scalars['Int']['input']>;
  tagId?: InputMaybe<Scalars['Int']['input']>;
};

export type DealTagsSort = {
  field: DealTagsSortEnum;
  order: SortInput;
};

export enum DealTagsSortEnum {
  Id = 'id',
  Name = 'name'
}

export type DegreeEnum = {
  __typename?: 'DegreeEnum';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  uniqueId: Scalars['String']['output'];
};

export type DegreeEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type DegreeEnumList = {
  __typename?: 'DegreeEnumList';
  items: Array<DegreeEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type DegreeEnumSort = {
  field: DegreeEnumSortEnum;
  order: SortInput;
};

export enum DegreeEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type DeiCategory1Enum = {
  __typename?: 'DeiCategory1Enum';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAdditionalMinorityGroup: Scalars['Boolean']['output'];
};

export type DeiCategory1EnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  isAdditionalMinorityGroup?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeiCategory1EnumList = {
  __typename?: 'DeiCategory1EnumList';
  items: Array<DeiCategory1Enum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type DeiCategory1EnumSort = {
  field: DeiCategory1EnumSortEnum;
  order: SortInput;
};

export enum DeiCategory1EnumSortEnum {
  Id = 'id',
  IsAdditionalMinorityGroup = 'isAdditionalMinorityGroup',
  Name = 'name'
}

export type DeiCategory2Enum = {
  __typename?: 'DeiCategory2Enum';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type DeiCategory2EnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type DeiCategory2EnumList = {
  __typename?: 'DeiCategory2EnumList';
  items: Array<DeiCategory2Enum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type DeiCategory2EnumSort = {
  field: DeiCategory2EnumSortEnum;
  order: SortInput;
};

export enum DeiCategory2EnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type DeiFilter = {
  category1?: InputMaybe<Scalars['Int']['input']>;
  category2?: InputMaybe<Scalars['Int']['input']>;
  max?: InputMaybe<Scalars['Float']['input']>;
  measures: Array<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export enum DeleteInvestmentRiskListType {
  Custom = 'CUSTOM',
  Database = 'DATABASE'
}

export type DiligenceAnswerNotFoundInput = {
  fieldKey: Scalars['String']['input'];
  ownerId: Scalars['Int']['input'];
  ownerType: FieldOwnerType;
};

export type DiligenceDraftRunInput = {
  answerNotFound: Array<DiligenceAnswerNotFoundInput>;
  runId: Scalars['String']['input'];
};

export type DiligenceGap = {
  __typename?: 'DiligenceGap';
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  investmentId: Scalars['Int']['output'];
  ownerType: FieldOwnerType;
  questionText: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
  section?: Maybe<Scalars['String']['output']>;
  severity: DiligenceGapSeverity;
  status: DiligenceGapStatus;
  suggestedSources: Array<DiligenceGapSource>;
  whyItMatters: Scalars['String']['output'];
};

export type DiligenceGapAnalysis = {
  __typename?: 'DiligenceGapAnalysis';
  gaps: Array<DiligenceGap>;
  generatedAt: Scalars['DateTime']['output'];
  investmentId: Scalars['Int']['output'];
};

export enum DiligenceGapSeverity {
  HighRisk = 'HIGH_RISK',
  NiceToHave = 'NICE_TO_HAVE',
  Validation = 'VALIDATION'
}

export type DiligenceGapSource = {
  __typename?: 'DiligenceGapSource';
  kind: DiligenceGapSourceKind;
  label: Scalars['String']['output'];
};

export enum DiligenceGapSourceKind {
  CallTopic = 'CALL_TOPIC',
  Document = 'DOCUMENT',
  InternalDataset = 'INTERNAL_DATASET'
}

export enum DiligenceGapStatus {
  DrafterFoundNothing = 'DRAFTER_FOUND_NOTHING',
  NeverAnswered = 'NEVER_ANSWERED'
}

export type DisplayOptions = {
  __typename?: 'DisplayOptions';
  always_display_content?: Maybe<Scalars['Boolean']['output']>;
};

export type DisplaySort = {
  __typename?: 'DisplaySort';
  key: Scalars['String']['output'];
  order: Scalars['String']['output'];
};

export type DiversityStatsEnum = {
  __typename?: 'DiversityStatsEnum';
  id: Scalars['ID']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type DiversityStatsEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type DiversityStatsEnumList = {
  __typename?: 'DiversityStatsEnumList';
  items: Array<DiversityStatsEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type DiversityStatsEnumSort = {
  field: DiversityStatsEnumSortEnum;
  order: SortInput;
};

export enum DiversityStatsEnumSortEnum {
  Id = 'id'
}

export type Document = {
  __typename?: 'Document';
  access: EntityAccess;
  accessLevel: Scalars['Int']['output'];
  advSummaryEmailNotification?: Maybe<AdvSummaryEmailNotification>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  createUserFullName?: Maybe<Scalars['String']['output']>;
  date: Scalars['Date']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  digest: Scalars['String']['output'];
  documentAccessLevel: DocumentAccessLevel;
  documentGroup?: Maybe<User>;
  documentGroupId?: Maybe<Scalars['Int']['output']>;
  documentSubTypeEnumId?: Maybe<Scalars['Int']['output']>;
  documentTextTaskId?: Maybe<Scalars['String']['output']>;
  documentTypeEnum: DocumentTypeEnum;
  documentTypeEnumId: Scalars['Int']['output'];
  entityAssociations: Array<DocumentXEntity>;
  extension: Scalars['String']['output'];
  hasDocumentText: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isApproved?: Maybe<Scalars['Boolean']['output']>;
  isGallery?: Maybe<Scalars['Boolean']['output']>;
  isVectorized?: Maybe<Scalars['Boolean']['output']>;
  mercuryId?: Maybe<Scalars['String']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notifyUsers?: Maybe<Scalars['Boolean']['output']>;
  processingStatus: DocumentProcessingStatus;
  s3Bucket: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
  signedThumbnailUrl?: Maybe<Scalars['String']['output']>;
  signedUrl?: Maybe<Scalars['String']['output']>;
  tags: Array<KnowledgeBaseTags>;
  versions: Array<DocumentVersion>;
};


export type DocumentSignedUrlArgs = {
  inline?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentAccessLevel = {
  __typename?: 'DocumentAccessLevel';
  documents: Array<Document>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type DocumentAccessLevelFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentAccessLevelList = {
  __typename?: 'DocumentAccessLevelList';
  items: Array<DocumentAccessLevel>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type DocumentAccessLevelSort = {
  field: DocumentAccessLevelSortEnum;
  order: SortInput;
};

export enum DocumentAccessLevelSortEnum {
  Id = 'id',
  Name = 'name'
}

export type DocumentBatch = {
  __typename?: 'DocumentBatch';
  total: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type DocumentCountByDocumentType = {
  __typename?: 'DocumentCountByDocumentType';
  count: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  year?: Maybe<Scalars['Int']['output']>;
};

export type DocumentCountByDocumentTypeSort = {
  field: DocumentCountByDocumentTypeSortEnum;
  order: SortInput;
};

export enum DocumentCountByDocumentTypeSortEnum {
  Count = 'count',
  Name = 'name',
  Year = 'year'
}

export type DocumentFilter = {
  accessLevel?: InputMaybe<Scalars['Int']['input']>;
  companyFilters?: InputMaybe<Array<CompanySearchFilters>>;
  date?: InputMaybe<Scalars['Date']['input']>;
  digest?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use documentCategoryEnumIds instead */
  documentCategoryEnumId?: InputMaybe<Scalars['Int']['input']>;
  documentCategoryEnumIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** @deprecated Use documentTypeEnumIds instead */
  documentTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  documentTypeEnumIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  duplicates?: InputMaybe<Scalars['Upload']['input']>;
  entities?: InputMaybe<Array<EntityAssociationInput>>;
  extensions?: InputMaybe<Array<Scalars['String']['input']>>;
  firmFilter?: InputMaybe<FirmFilterInput>;
  firmFilters?: InputMaybe<Array<FirmSearchFilters>>;
  gallery?: InputMaybe<Scalars['Boolean']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  includedInAdvSummaryEmail?: InputMaybe<Scalars['Boolean']['input']>;
  investmentFilters?: InputMaybe<Array<InvestmentSearchFilters>>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  knowledgeBaseTagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxDate?: InputMaybe<Scalars['DateTime']['input']>;
  minDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifyUsers?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use `name` instead */
  q?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentInput = {
  accessLevel?: InputMaybe<Scalars['Int']['input']>;
  allowDuplicateFile?: InputMaybe<Scalars['Boolean']['input']>;
  date: Scalars['Date']['input'];
  documentGroupId?: InputMaybe<Scalars['Int']['input']>;
  documentSubTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  documentTypeEnumId: Scalars['Int']['input'];
  entities?: InputMaybe<Array<EntityAssociationInput>>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  fileFromBucket?: InputMaybe<BucketFileInput>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isGallery?: InputMaybe<Scalars['Boolean']['input']>;
  notifyUsers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The text content of the document, will be processed if not provided */
  text?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentList = {
  __typename?: 'DocumentList';
  items: Array<Document>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type DocumentProcessingItem = {
  __typename?: 'DocumentProcessingItem';
  label: Scalars['String']['output'];
  resultLabel?: Maybe<Scalars['String']['output']>;
  resultUrl?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DocumentProcessingStatus = {
  __typename?: 'DocumentProcessingStatus';
  items: Array<DocumentProcessingItem>;
};

export type DocumentPublishResult = {
  __typename?: 'DocumentPublishResult';
  documentId?: Maybe<Scalars['Int']['output']>;
  documentName?: Maybe<Scalars['String']['output']>;
  documentQueueId: Scalars['ID']['output'];
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DocumentQueue = {
  __typename?: 'DocumentQueue';
  document: Document;
  documentsId?: Maybe<Scalars['Float']['output']>;
  duplicateDocuments?: Maybe<Array<Document>>;
  emailMaps: Array<DocumentQueueEmailMap>;
  groupId?: Maybe<Scalars['Float']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  llmAsOfDate?: Maybe<Scalars['Date']['output']>;
  llmAsOfDateNotes?: Maybe<Scalars['String']['output']>;
  llmDocumentTypeEnumId?: Maybe<Scalars['Float']['output']>;
  llmDocumentTypeEnumNotes?: Maybe<Scalars['String']['output']>;
  llmEntityId?: Maybe<Scalars['Float']['output']>;
  llmEntityNotes?: Maybe<Scalars['String']['output']>;
  llmEntityTypeId?: Maybe<Scalars['Float']['output']>;
  llmEntityTypeNotes?: Maybe<Scalars['String']['output']>;
  llmProcessedAt?: Maybe<Scalars['Date']['output']>;
  llmSuggestedName?: Maybe<Scalars['String']['output']>;
  llmSuggestedNameNotes?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  queueDate: Scalars['Date']['output'];
  s3Bucket: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
  signedUrl?: Maybe<Scalars['String']['output']>;
  /** A presigned url to upload the document to S3. */
  url?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type DocumentQueueEmailMap = {
  __typename?: 'DocumentQueueEmailMap';
  documentQueueId: Scalars['String']['output'];
  emailId: Scalars['String']['output'];
  emailMetadata: EmailMetadata;
  id: Scalars['String']['output'];
};

export type DocumentQueueFilter = {
  hasLLMData?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  isArchiveAssistant?: InputMaybe<Scalars['Boolean']['input']>;
  isImage?: InputMaybe<Scalars['Boolean']['input']>;
  minQueueDate?: InputMaybe<Scalars['Date']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sharedQueueType?: InputMaybe<SharedQueueTypeEnum>;
  userId?: InputMaybe<Scalars['Float']['input']>;
};

export type DocumentQueueList = {
  __typename?: 'DocumentQueueList';
  items: Array<DocumentQueue>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type DocumentQueuePublishInput = {
  accessLevel?: InputMaybe<Scalars['Int']['input']>;
  allowDuplicateFile?: InputMaybe<Scalars['Boolean']['input']>;
  date: Scalars['Date']['input'];
  documentGroupId?: InputMaybe<Scalars['Int']['input']>;
  documentQueueId?: InputMaybe<Scalars['ID']['input']>;
  documentSubTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  documentTypeEnumId: Scalars['Int']['input'];
  entities?: InputMaybe<Array<EntityAssociationInput>>;
  isGallery?: InputMaybe<Scalars['Boolean']['input']>;
  /** Knowledge base tag IDs to associate with this document */
  knowledgeBaseTagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Override filename to use for the published Document. Falls back to DocumentQueue.name when not provided. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentQueueSort = {
  field: DocumentQueueSortEnum;
  order: SortInput;
};

export enum DocumentQueueSortEnum {
  EmailId = 'emailId',
  Name = 'name',
  NameSearchRank = 'nameSearchRank',
  QueueDate = 'queueDate'
}

export type DocumentSort = {
  field: DocumentSortEnum;
  order: SortInput;
};

export enum DocumentSortEnum {
  AccessLevelId = 'accessLevelId',
  AccessLevelName = 'accessLevelName',
  CreateDate = 'createDate',
  Date = 'date',
  DocumentCategoryEnumId = 'documentCategoryEnumId',
  DocumentTypeEnumName = 'documentTypeEnumName',
  IsApproved = 'isApproved',
  ModifyDate = 'modifyDate',
  Name = 'name',
  NameSearchRank = 'nameSearchRank',
  TextSearchRank = 'textSearchRank'
}

export type DocumentTypeEnum = {
  __typename?: 'DocumentTypeEnum';
  description?: Maybe<Scalars['String']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  documentCategoryEnumId?: Maybe<Scalars['Int']['output']>;
  documents: Array<Document>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type DocumentTypeEnumFilter = {
  documentCategoryEnumIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  isBusinessApplicantType?: InputMaybe<Scalars['Boolean']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentTypeEnumList = {
  __typename?: 'DocumentTypeEnumList';
  items: Array<DocumentTypeEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type DocumentTypeEnumSort = {
  field: DocumentTypeEnumSortEnum;
  order: SortInput;
};

export enum DocumentTypeEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type DocumentUpdateInput = {
  accessLevel?: InputMaybe<Scalars['Int']['input']>;
  /** Add entity associations incrementally (preserves existing ones) */
  addEntities?: InputMaybe<Array<EntityAssociationInput>>;
  allowDuplicateFile?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  documentSubTypeEnumId?: InputMaybe<Scalars['Float']['input']>;
  documentTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  /** Replace ALL entity associations (full replace semantics) */
  entities?: InputMaybe<Array<EntityAssociationInput>>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isGallery?: InputMaybe<Scalars['Boolean']['input']>;
  /** Knowledge base tag IDs to associate with this document */
  knowledgeBaseTagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  notifyUsers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Remove specific entity associations by type+id */
  removeEntities?: InputMaybe<Array<EntityAssociationInput>>;
};

export type DocumentVersion = {
  __typename?: 'DocumentVersion';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  createUserFullName?: Maybe<Scalars['String']['output']>;
  digest: Scalars['String']['output'];
  documentId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
  versionNumber: Scalars['Int']['output'];
};

export type DocumentXEntity = {
  __typename?: 'DocumentXEntity';
  businessObjectTypeEnumId: Scalars['Int']['output'];
  company?: Maybe<Company>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deal?: Maybe<Deal>;
  documentsId: Scalars['Int']['output'];
  entityId: Scalars['Int']['output'];
  entityName?: Maybe<Scalars['String']['output']>;
  firm?: Maybe<Firm>;
  firmEngagement?: Maybe<FirmEngagement>;
  id: Scalars['Int']['output'];
  investment?: Maybe<Investment>;
};

export type DocumentsDynamicShareRule = {
  documentTypes?: InputMaybe<Array<Scalars['Int']['input']>>;
  investmentSet?: InputMaybe<GroupShareInvestmentSetFilter>;
};

export type DocumentsDynamicShareRuleOutput = {
  __typename?: 'DocumentsDynamicShareRuleOutput';
  documentTypes?: Maybe<Array<Scalars['Int']['output']>>;
  investmentSet?: Maybe<GroupShareInvestmentSetFilterOutput>;
};

export type DryRunMutationStepResult = {
  __typename?: 'DryRunMutationStepResult';
  currentValues?: Maybe<Scalars['JSON']['output']>;
  errors: Array<ValidationError>;
  proposedValues: Scalars['JSON']['output'];
  valid: Scalars['Boolean']['output'];
};

/** Dynamic definition for group share rules. Exactly one entity rule type (investmentsDynamicShare, firmsDynamicShare, personsDynamicShare, documentsDynamicShare, or everything) must be specified. */
export type DynamicDefinitionInput = {
  description: Scalars['String']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  documentsDynamicShare?: InputMaybe<DocumentsDynamicShareRule>;
  everything?: InputMaybe<Scalars['Boolean']['input']>;
  firmsDynamicShare?: InputMaybe<FirmsDynamicShareRule>;
  investmentsDynamicShare?: InputMaybe<InvestmentsDynamicShareRule>;
  personsDynamicShare?: InputMaybe<PersonsDynamicShareRule>;
};

export type DynamicDefinitionOutput = {
  __typename?: 'DynamicDefinitionOutput';
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  documentsDynamicShare?: Maybe<DocumentsDynamicShareRuleOutput>;
  everything?: Maybe<Scalars['Boolean']['output']>;
  firmsDynamicShare?: Maybe<FirmsDynamicShareRuleOutput>;
  investmentsDynamicShare?: Maybe<InvestmentsDynamicShareRuleOutput>;
  personsDynamicShare?: Maybe<PersonsDynamicShareRuleOutput>;
};

export enum DynamicList {
  FundedList = 'fundedList',
  ImpactList = 'impactList',
  PortalMigrationList = 'portalMigrationList',
  ProspectiveList = 'prospectiveList',
  ResearchList = 'researchList'
}

export type DynamicListFilter = {
  lists: Array<DynamicList>;
  operator?: InputMaybe<Scalars['String']['input']>;
};

/** A fund's estimate overrides. null clears one; a null spread saves the NAV model's spread, as the legacy page did. */
export type EarlyEstimateInput = {
  /** The version this edit started from. If someone else has saved the fund since, the save is refused. */
  expectedVersion?: InputMaybe<Scalars['String']['input']>;
  grossEndBal?: InputMaybe<Scalars['Float']['input']>;
  grossReturn?: InputMaybe<Scalars['Float']['input']>;
  netEndBal?: InputMaybe<Scalars['Float']['input']>;
  rcgFundId: Scalars['Int']['input'];
  spread?: InputMaybe<Scalars['Float']['input']>;
};

/** One RCG fund's early estimate for a month-end: the NAV model's figures (system*) beside the entered overrides. Balances in dollars; returns and spread as fractions (0.012 = 1.2%). */
export type EarlyEstimateRow = {
  __typename?: 'EarlyEstimateRow';
  grossEndBal?: Maybe<Scalars['Float']['output']>;
  grossReturn?: Maybe<Scalars['Float']['output']>;
  /** False once the month is reconciled: estimates can no longer be entered. */
  isEstimate?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  netEndBal?: Maybe<Scalars['Float']['output']>;
  netReturn?: Maybe<Scalars['Float']['output']>;
  rcgFundId: Scalars['Int']['output'];
  spread?: Maybe<Scalars['Float']['output']>;
  systemGrossEndBal?: Maybe<Scalars['Float']['output']>;
  systemGrossReturn?: Maybe<Scalars['Float']['output']>;
  systemNetEndBal?: Maybe<Scalars['Float']['output']>;
  /** Gross return minus net return. */
  systemSpread?: Maybe<Scalars['Float']['output']>;
  /** Changes whenever anyone saves this fund's estimate; send it back as expectedVersion. Null before the first save. */
  version?: Maybe<Scalars['String']['output']>;
};

export type EffortBenchmark = {
  __typename?: 'EffortBenchmark';
  effort: Scalars['String']['output'];
  intelligenceIndex?: Maybe<Scalars['Float']['output']>;
  outputTokensPerSecond?: Maybe<Scalars['Float']['output']>;
};

export type EmRiskReportConfigInput = {
  accountName: Scalars['String']['input'];
  betaIndex: Scalars['Int']['input'];
  betaName: Scalars['String']['input'];
  customizedPerformanceBenchmarkId?: InputMaybe<Scalars['Int']['input']>;
  date: Scalars['DateTime']['input'];
  fundId: Scalars['Int']['input'];
  inceptionDate?: InputMaybe<Scalars['DateTime']['input']>;
  managerRiskPages?: InputMaybe<Scalars['Boolean']['input']>;
  timePeriod?: Scalars['Int']['input'];
  vehicleType?: InputMaybe<Scalars['String']['input']>;
};

export type EmailAttachmentInput = {
  /** Temp-upload bucket (caller's own uploads only). */
  bucket?: InputMaybe<Scalars['String']['input']>;
  /** A file generated in one of the caller's own chats, e.g. an Atlas output (ownership-checked). */
  conversationArtifactId?: InputMaybe<Scalars['Int']['input']>;
  /** Attach a platform document (entitlement-checked). */
  documentId?: InputMaybe<Scalars['Int']['input']>;
  /** Temp-upload key (caller's own uploads only). */
  key?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type EmailDomainOrganizationFilter = {
  emailDomain?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

export type EmailDomainOrganizationInput = {
  emailDomain: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export type EmailDomainOrganizationList = {
  __typename?: 'EmailDomainOrganizationList';
  items: Array<PortalEmailDomainOrganization>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type EmailDomainOrganizationSort = {
  field: EmailDomainOrganizationSortEnum;
  order: SortInput;
};

export enum EmailDomainOrganizationSortEnum {
  EmailDomain = 'emailDomain',
  OrganizationId = 'organizationId'
}

export type EmailDomainXOrganization = {
  __typename?: 'EmailDomainXOrganization';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  emailDomain: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  organizationId: Scalars['Int']['output'];
};

export type EmailDomainXOrganizationFilter = {
  emailDomain?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};

export type EmailDomainXOrganizationInput = {
  emailDomain?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};

export type EmailDomainXOrganizationList = {
  __typename?: 'EmailDomainXOrganizationList';
  items: Array<EmailDomainXOrganization>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type EmailDomainXOrganizationSort = {
  field: EmailDomainXOrganizationSortEnum;
  order: SortInput;
};

export enum EmailDomainXOrganizationSortEnum {
  EmailDomain = 'emailDomain',
  Id = 'id',
  OrganizationId = 'organizationId'
}

export type EmailMetadata = {
  __typename?: 'EmailMetadata';
  attachmentCount?: Maybe<Scalars['Float']['output']>;
  ccAddresses?: Maybe<Scalars['String']['output']>;
  emailBody?: Maybe<Scalars['String']['output']>;
  fromAddress?: Maybe<Scalars['String']['output']>;
  fromName?: Maybe<Scalars['String']['output']>;
  hasAttachments?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  importanceFlag?: Maybe<Scalars['String']['output']>;
  receivedDate?: Maybe<Scalars['Date']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  toAddress?: Maybe<Scalars['String']['output']>;
  toName?: Maybe<Scalars['String']['output']>;
};

export type EmailMetadataInput = {
  attachmentCount: Scalars['Int']['input'];
  ccAddresses?: InputMaybe<Scalars['String']['input']>;
  emailBody?: InputMaybe<Scalars['String']['input']>;
  fromAddress?: InputMaybe<Scalars['String']['input']>;
  fromName?: InputMaybe<Scalars['String']['input']>;
  hasAttachments: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  importanceFlag?: InputMaybe<Scalars['String']['input']>;
  receivedDate?: InputMaybe<Scalars['DateTime']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  toAddress?: InputMaybe<Scalars['String']['input']>;
  toName?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeRoleEnum = {
  __typename?: 'EmployeeRoleEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type EmployeeRoleEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeRoleEnumList = {
  __typename?: 'EmployeeRoleEnumList';
  items: Array<EmployeeRoleEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type EmployeeRoleEnumSort = {
  field: EmployeeRoleEnumSortEnum;
  order: SortInput;
};

export enum EmployeeRoleEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type EntityAccess = {
  __typename?: 'EntityAccess';
  delete?: Maybe<Scalars['Boolean']['output']>;
  preview?: Maybe<Scalars['Boolean']['output']>;
  read?: Maybe<Scalars['Boolean']['output']>;
  update?: Maybe<Scalars['Boolean']['output']>;
};

export type EntityAccessSearchFilter = {
  values: Array<Prud>;
};

export type EntityAssociationInput = {
  businessObjectEnumId: Scalars['Int']['input'];
  entityId: Scalars['Int']['input'];
};

export type EntityKey = {
  id: Scalars['Int']['input'];
  label: Scalars['String']['input'];
};

export type EntitySearchFilter = {
  values: Array<EntityKey>;
};

export type Exposure = {
  __typename?: 'Exposure';
  assetClass: Array<ExposureRecord>;
  assetClassDetail: Array<ExposureDetailRecord>;
  byDimension: Array<ExposureRecord>;
  duration: Array<ExposureDurationRecord>;
  marketCap: Array<ExposureRecord>;
  portfolio: Array<ExposureRecord>;
  regional: Array<ExposureRecord>;
  regionalDetail: Array<ExposureDetailRecord>;
  sector: Array<ExposureRecord>;
};


export type ExposureByDimensionArgs = {
  dimension: ExposureDimension;
};

/** A raw category tuple for one exposure dimension. Unlike ExposureRecord, categories are not coalesced into a single label, so consumers that need the exact category hierarchy (e.g. asset category level 2 + 3 pairs, or country = category4-else-category3) can apply their own fallback rules. */
export type ExposureDetailRecord = {
  __typename?: 'ExposureDetailRecord';
  category2: Scalars['String']['output'];
  category3: Scalars['String']['output'];
  category4: Scalars['String']['output'];
  month: Scalars['Int']['output'];
  weight: Scalars['Float']['output'];
  year: Scalars['Int']['output'];
};

/** exposure dimensions */
export enum ExposureDimension {
  AssetClass = 'ASSET_CLASS',
  Capitalization = 'CAPITALIZATION',
  Currency = 'CURRENCY',
  Liquidity = 'LIQUIDITY',
  Region = 'REGION',
  Sector = 'SECTOR',
  SecurityType = 'SECURITY_TYPE',
  Strategy = 'STRATEGY'
}

/** Effective duration (IR) for one month. Values are raw durations in years, NOT percentages like ExposureRecord.weight. */
export type ExposureDurationRecord = {
  __typename?: 'ExposureDurationRecord';
  month: Scalars['Int']['output'];
  value: Scalars['Float']['output'];
  year: Scalars['Int']['output'];
};

export type ExposureRecord = {
  __typename?: 'ExposureRecord';
  month: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  weight: Scalars['Float']['output'];
  year: Scalars['Int']['output'];
};

export type ExternalUserInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
};

export type ExtractResult = {
  __typename?: 'ExtractResult';
  extractBodyKey: Scalars['String']['output'];
  extractHeadKey: Scalars['String']['output'];
  skipped: Scalars['Boolean']['output'];
  writeBodyResult?: Maybe<Scalars['JSONObject']['output']>;
  writeHeadResult?: Maybe<Scalars['JSONObject']['output']>;
};

export type FdpLogin = {
  __typename?: 'FDPLogin';
  authenticatorEnum?: Maybe<FdpLoginAuthenticatorEnum>;
  authenticatorEnumId?: Maybe<Scalars['Int']['output']>;
  authenticatorImage?: Maybe<Scalars['String']['output']>;
  authenticatorImageType?: Maybe<Scalars['String']['output']>;
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  deleteDate?: Maybe<Scalars['String']['output']>;
  deleteUser?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  financialDataProvider: FinancialDataProvider;
  financialDataProviderId: Scalars['Int']['output'];
  firmFDPLogins?: Maybe<Array<FirmFdpLogins>>;
  firms?: Maybe<Array<Firm>>;
  id: Scalars['Int']['output'];
  imageLink?: Maybe<Scalars['String']['output']>;
  investmentFDPLogins?: Maybe<Array<InvestmentFdpLogins>>;
  investments?: Maybe<Array<Investment>>;
  mfaUser?: Maybe<Scalars['String']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  portfolioFDPLogins?: Maybe<Array<PortfolioFdpLogins>>;
  portfolios?: Maybe<Array<Investment>>;
  securityQuestion?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type FdpLoginAuthenticatorEnum = {
  __typename?: 'FDPLoginAuthenticatorEnum';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type FdpLoginAuthenticatorEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type FdpLoginAuthenticatorEnumSort = {
  field: FdpLoginAuthenticatorEnumSortEnum;
  order: SortInput;
};

export enum FdpLoginAuthenticatorEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type FdpLoginFilter = {
  authenticatorEnumId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  financialDataProviderId?: InputMaybe<Scalars['Int']['input']>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  includeFirmIfNoInvestment?: InputMaybe<Scalars['Boolean']['input']>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  mfaUser?: InputMaybe<Scalars['String']['input']>;
  portfolioId?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  qNotes?: InputMaybe<Scalars['String']['input']>;
  qWebsite?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type FdpLoginInput = {
  authenticatorEnumId?: InputMaybe<Scalars['Int']['input']>;
  authenticatorImage?: InputMaybe<Scalars['Upload']['input']>;
  authenticatorImageType?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  financialDataProviderId?: InputMaybe<Scalars['Int']['input']>;
  firmFDPLogins?: InputMaybe<Array<FirmFdpLoginsInput>>;
  firmIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  investmentFDPLogins?: InputMaybe<Array<InvestmentFdpLoginsInput>>;
  investmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  mfaUser?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  portfolioFDPLogins?: InputMaybe<Array<PortfolioFdpLoginsInput>>;
  portfolioIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  securityQuestion?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type FdpLoginSort = {
  field: FdpLoginSortEnum;
  order: SortInput;
};

export enum FdpLoginSortEnum {
  Email = 'email',
  FdpName = 'fdpName',
  Id = 'id',
  MfaUser = 'mfaUser',
  NameSearchRank = 'nameSearchRank',
  Username = 'username'
}

export type FdpWebsites = {
  __typename?: 'FDPWebsites';
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  deleteDate?: Maybe<Scalars['String']['output']>;
  deleteUser?: Maybe<Scalars['String']['output']>;
  financialDataProvider?: Maybe<FinancialDataProvider>;
  financialDataProviderId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  website: Scalars['String']['output'];
};

export type FdpWebsitesFilter = {
  financialDataProviderId?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type FdpWebsitesInput = {
  financialDataProviderId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type FdpWebsitesSort = {
  field: FdpWebsitesSortEnum;
  order: SortInput;
};

export enum FdpWebsitesSortEnum {
  Id = 'id',
  Website = 'website',
  WebsiteSearchRank = 'websiteSearchRank'
}

export type FxRate = {
  __typename?: 'FXRate';
  asOfDate: Scalars['DateTime']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  exchangeRate: Scalars['Float']['output'];
  fromCurrency: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  toCurrency: Scalars['String']['output'];
};

export type FactorInput = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export type Family = {
  __typename?: 'Family';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  firm: Firm;
  firmId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  investmentsFamily: Array<InvestmentsFamily>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  name: Scalars['String']['output'];
};


export type FamilyInvestmentsFamilyArgs = {
  filter?: InputMaybe<InvestmentsFamilyFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentsFamilySort>>;
};

export type FamilyFilterInput = {
  firmId?: InputMaybe<Scalars['Int']['input']>;
};

export type FamilyInput = {
  firmId?: InputMaybe<Scalars['Int']['input']>;
  investmentsFamily?: InputMaybe<Array<InvestmentInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FamilyList = {
  __typename?: 'FamilyList';
  items: Array<Family>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FamilySort = {
  field: FamilySortEnum;
  order: SortInput;
};

export enum FamilySortEnum {
  Name = 'name'
}

export type FdpLoginAuthenticatorEnumList = {
  __typename?: 'FdpLoginAuthenticatorEnumList';
  items: Array<FdpLoginAuthenticatorEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FdpLoginList = {
  __typename?: 'FdpLoginList';
  items: Array<FdpLogin>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FdpWebsitesList = {
  __typename?: 'FdpWebsitesList';
  items: Array<FdpWebsites>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FeeCalcEnum = {
  __typename?: 'FeeCalcEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type FeeCalcEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FeeCalcEnumList = {
  __typename?: 'FeeCalcEnumList';
  items: Array<FeeCalcEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FeeCalcEnumSort = {
  field: FeeCalcEnumSortEnum;
  order: SortInput;
};

export enum FeeCalcEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type FeeFreqEnum = {
  __typename?: 'FeeFreqEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type FeeFreqEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FeeFreqEnumList = {
  __typename?: 'FeeFreqEnumList';
  items: Array<FeeFreqEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FeeFreqEnumSort = {
  field: FeeFreqEnumSortEnum;
  order: SortInput;
};

export enum FeeFreqEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type Field = {
  __typename?: 'Field';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  documents: Array<FieldDocument>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  owner: FieldOwner;
  ownerId: Scalars['Float']['output'];
  ownerType: FieldOwnerType;
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<FieldState>;
  value?: Maybe<Scalars['JSON']['output']>;
};

export type FieldAccess = {
  __typename?: 'FieldAccess';
  canInput: Scalars['Boolean']['output'];
  field: Scalars['String']['output'];
  pointer?: Maybe<Scalars['String']['output']>;
};

export type FieldColumnInput = {
  displayName: Scalars['String']['input'];
  displayType: Scalars['String']['input'];
  nullable?: InputMaybe<Scalars['Boolean']['input']>;
  propertyKey: Scalars['String']['input'];
};

export type FieldData = {
  __typename?: 'FieldData';
  assetClassName?: Maybe<Scalars['String']['output']>;
  businessObject: BusinessObject;
  fieldMeta: Scalars['JSON']['output'];
  fieldSet: Scalars['JSON']['output'];
  fieldSetType: FieldSetType;
  investmentId: Scalars['Int']['output'];
  strategyName?: Maybe<Scalars['String']['output']>;
  version: Scalars['String']['output'];
};

export type FieldDefinition = {
  __typename?: 'FieldDefinition';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  fieldKey: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  metadata: Scalars['JSON']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['Int']['output']>;
  ownerType: Scalars['String']['output'];
};

export type FieldDocument = {
  __typename?: 'FieldDocument';
  document?: Maybe<Document>;
  id: Scalars['Float']['output'];
};

export type FieldDocumentInput = {
  id: Scalars['Float']['input'];
};

export type FieldEntityWithMetadata = {
  __typename?: 'FieldEntityWithMetadata';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  documents: Array<FieldDocument>;
  fieldKey: Scalars['String']['output'];
  fieldMeta?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  owner?: Maybe<FieldOwner>;
  ownerId: Scalars['Float']['output'];
  ownerType: FieldOwnerType;
  periodType?: Maybe<Scalars['String']['output']>;
  semanticDistance?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<FieldState>;
  value?: Maybe<Scalars['JSON']['output']>;
};

export type FieldFilter = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  fieldKey?: InputMaybe<Scalars['String']['input']>;
  fieldKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  knowledgeBaseId?: InputMaybe<Scalars['Int']['input']>;
  modifyUser?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  ownerType?: InputMaybe<Scalars['String']['input']>;
  owners?: InputMaybe<Array<FieldOwnerFilter>>;
  semanticQuery?: InputMaybe<Scalars['String']['input']>;
  showOnlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type FieldHistoryFilter = {
  fieldKey: Scalars['String']['input'];
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  ownerType?: InputMaybe<Scalars['String']['input']>;
  showOnlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FieldHistorySort = {
  field: FieldHistorySortEnum;
  order: SortInput;
};

export enum FieldHistorySortEnum {
  Id = 'id',
  ModifyDate = 'modifyDate'
}

export type FieldKeySearchResult = {
  __typename?: 'FieldKeySearchResult';
  hasMore: Scalars['Boolean']['output'];
  items: Array<FieldKeyWithMetadata>;
  total: Scalars['Int']['output'];
};

export type FieldKeyWithMetadata = {
  __typename?: 'FieldKeyWithMetadata';
  category?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  fieldKey: Scalars['String']['output'];
  questionText: Scalars['String']['output'];
  section?: Maybe<Scalars['String']['output']>;
};

export type FieldList = {
  __typename?: 'FieldList';
  items: Array<FieldEntityWithMetadata>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FieldOwner = {
  __typename?: 'FieldOwner';
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type FieldOwnerFilter = {
  id: Scalars['Int']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export enum FieldOwnerType {
  Company = 'company',
  Firm = 'firm',
  Investment = 'investment'
}

export type FieldSetConfig = {
  __typename?: 'FieldSetConfig';
  hide_image_upload?: Maybe<Scalars['Boolean']['output']>;
};

export type FieldSetMapping = {
  __typename?: 'FieldSetMapping';
  portal: Array<Scalars['Int']['output']>;
};

export enum FieldSetType {
  Affiliations = 'affiliations',
  Application = 'application',
  Impact = 'impact',
  Investment = 'investment',
  OngoingReporting = 'ongoingReporting',
  Operations = 'operations'
}

export type FieldSort = {
  field: FieldSortEnum;
  order: SortInput;
};

export enum FieldSortEnum {
  Id = 'id',
  ModifyDate = 'modifyDate',
  Owner = 'owner',
  SemanticRelevance = 'semanticRelevance',
  TextSearchRelevance = 'textSearchRelevance'
}

export enum FieldState {
  Draft = 'draft',
  Mgr = 'mgr',
  MgrDraft = 'mgrDraft',
  MgrDraftLegacy = 'mgrDraftLegacy',
  RangerGenerated = 'rangerGenerated'
}

export type FieldValue = {
  __typename?: 'FieldValue';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['JSON']['output']>;
};

export type FieldValueInput = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  citations?: InputMaybe<Array<CitationInput>>;
  documentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  fieldKey: Scalars['String']['input'];
  notApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  periodType?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type FinancialDataProvider = {
  __typename?: 'FinancialDataProvider';
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  deleteDate?: Maybe<Scalars['String']['output']>;
  deleteUser?: Maybe<Scalars['String']['output']>;
  fdpWebsites: Array<FdpWebsites>;
  id: Scalars['Int']['output'];
  logins: Array<FdpLogin>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type FinancialDataProviderFilter = {
  fdpLoginId?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialDataProviderInput = {
  fdpWebsites?: InputMaybe<Array<FdpWebsitesInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialDataProviderList = {
  __typename?: 'FinancialDataProviderList';
  items: Array<FinancialDataProvider>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FinancialDataProviderSort = {
  field: FinancialDataProviderSortEnum;
  order: SortInput;
};

export enum FinancialDataProviderSortEnum {
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type FinancialPeriodEnum = {
  __typename?: 'FinancialPeriodEnum';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type FinancialPeriodEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FinancialPeriodEnumList = {
  __typename?: 'FinancialPeriodEnumList';
  items: Array<FinancialPeriodEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FinancialPeriodEnumSort = {
  field: FinancialPeriodEnumSortEnum;
  order: SortInput;
};

export enum FinancialPeriodEnumSortEnum {
  Id = 'id'
}

export type Firm = {
  __typename?: 'Firm';
  ITCount?: Maybe<Scalars['Int']['output']>;
  access: EntityAccess;
  administrativeCount?: Maybe<Scalars['Int']['output']>;
  analystCount?: Maybe<Scalars['Int']['output']>;
  assetResolutionAnalystCount?: Maybe<Scalars['Int']['output']>;
  cik?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  crd?: Maybe<Scalars['String']['output']>;
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  dataOrganizationId?: Maybe<Scalars['Int']['output']>;
  diligenceTabs?: Maybe<Array<TemplateAttachment>>;
  email?: Maybe<Scalars['String']['output']>;
  employeeTotal?: Maybe<Scalars['Int']['output']>;
  families?: Maybe<Array<Family>>;
  fdpLogins?: Maybe<Array<FdpLogin>>;
  fieldData?: Maybe<FieldData>;
  fieldHistory?: Maybe<Array<Field>>;
  fields?: Maybe<FirmFields>;
  firmDEIList?: Maybe<FirmDeiList>;
  firmDEIs?: Maybe<Array<FirmDei>>;
  firmEmailDomains?: Maybe<Array<Scalars['String']['output']>>;
  firmEmployments?: Maybe<Array<FirmEmployment>>;
  firmFDPLogins?: Maybe<Array<FirmFdpLogins>>;
  firmGroupId: Scalars['Int']['output'];
  firmInstitutionsList?: Maybe<FirmInstitutionsList>;
  firmIrEmail?: Maybe<Scalars['String']['output']>;
  firmTags?: Maybe<Array<FirmTags>>;
  firmXImpact?: Maybe<Array<FirmXImpact>>;
  generalCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  impactTags?: Maybe<Array<ImpactEnum>>;
  inceptionDate?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Use `intraLinks` instead */
  intraLink?: Maybe<IntraLink>;
  /** @deprecated Use `firmFDPLogin` table instead */
  intraLinkId?: Maybe<Scalars['Int']['output']>;
  investmentCount?: Maybe<Scalars['Int']['output']>;
  investments?: Maybe<InvestmentList>;
  investorRelationsCount?: Maybe<Scalars['Int']['output']>;
  isCompany?: Maybe<Scalars['Boolean']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isPartner?: Maybe<Scalars['Boolean']['output']>;
  isStaffMWDBE?: Maybe<Scalars['Boolean']['output']>;
  latestFirmDEI?: Maybe<FirmDei>;
  latestNewsMonitoringPull?: Maybe<Scalars['DateTime']['output']>;
  legalCount?: Maybe<Scalars['Int']['output']>;
  lei?: Maybe<Scalars['String']['output']>;
  linkedIn?: Maybe<Scalars['String']['output']>;
  middleBackOfficeCount?: Maybe<Scalars['Int']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  newsMonitoringStartDate?: Maybe<Scalars['DateTime']['output']>;
  operationsCount?: Maybe<Scalars['Int']['output']>;
  otherAddresses?: Maybe<Array<Address>>;
  ownershipDiversity?: Maybe<FirmOwnershipDiversity>;
  portalFirm?: Maybe<PortalFirm>;
  portfolioManagerCount?: Maybe<Scalars['Int']['output']>;
  primaryAddress?: Maybe<Address>;
  primaryAddressId: Scalars['Int']['output'];
  registeredWithIds?: Maybe<Array<Scalars['Int']['output']>>;
  registeredWithOther?: Maybe<Scalars['String']['output']>;
  registrations?: Maybe<Array<FirmRegistration>>;
  researchAndUnderwritingAnalystCount?: Maybe<Scalars['Int']['output']>;
  riskCount?: Maybe<Scalars['Int']['output']>;
  sourcingAnalystCount?: Maybe<Scalars['Int']['output']>;
  stockSymbol?: Maybe<Scalars['String']['output']>;
  templateOptions?: Maybe<Array<Scalars['String']['output']>>;
  traderCount?: Maybe<Scalars['Int']['output']>;
  ukHfsbSignatory?: Maybe<Scalars['Boolean']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  yearFounded?: Maybe<Scalars['Int']['output']>;
};


export type FirmFieldDataArgs = {
  fieldSetType: FieldSetType;
  state?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type FirmFieldHistoryArgs = {
  filter?: InputMaybe<FieldHistoryFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FieldHistorySort>>;
};


export type FirmFieldsArgs = {
  state?: InputMaybe<Scalars['String']['input']>;
};


export type FirmFirmDeiListArgs = {
  filter?: InputMaybe<FirmDeiFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmDeiSort>>;
};


export type FirmFirmDeIsArgs = {
  filter?: InputMaybe<FirmDeiFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmDeiSort>>;
};


export type FirmFirmEmploymentsArgs = {
  filter?: InputMaybe<FirmEmploymentFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmEmploymentSort>>;
};


export type FirmFirmInstitutionsListArgs = {
  filter?: InputMaybe<FirmInstitutionsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmInstitutionsSort>>;
};


export type FirmFirmTagsArgs = {
  filter?: InputMaybe<FirmTagsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmTagsSort>>;
};


export type FirmInvestmentsArgs = {
  page?: InputMaybe<PageInput>;
  searchFilters?: InputMaybe<Array<InvestmentSearchFilters>>;
  sort?: InputMaybe<Array<InvestmentSort>>;
};


export type FirmLatestFirmDeiArgs = {
  geographyEnumId?: InputMaybe<Scalars['Int']['input']>;
};


export type FirmTemplateOptionsArgs = {
  fieldSetType: FieldSetType;
};

export type FirmAttributes = {
  email?: InputMaybe<Scalars['String']['input']>;
  employeeTotal?: InputMaybe<Scalars['Int']['input']>;
  firmTags?: InputMaybe<Array<FirmTagsInput>>;
  impactTags?: InputMaybe<Array<Scalars['Int']['input']>>;
  isStaffMWDBE?: InputMaybe<Scalars['Boolean']['input']>;
  linkedIn?: InputMaybe<Scalars['String']['input']>;
  primaryAddress?: InputMaybe<AddressInput>;
  stockSymbol?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  yearFounded?: InputMaybe<Scalars['Int']['input']>;
};

export type FirmAum = {
  __typename?: 'FirmAum';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Array<AumRecord>>;
};

export type FirmDei = {
  __typename?: 'FirmDEI';
  asOfDate: Scalars['Date']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  deleteUser?: Maybe<Scalars['String']['output']>;
  diversityStatsEnum: DiversityStatsEnum;
  diversityStatsEnumId?: Maybe<Scalars['Int']['output']>;
  firm: Firm;
  firmDEIRecords: Array<FirmDeiRecord>;
  firmId: Scalars['Int']['output'];
  geographyEnum: GeographyEnum;
  geographyEnumId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isCompleted: Scalars['Boolean']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
};


export type FirmDeiFirmDeiRecordsArgs = {
  filter?: InputMaybe<FirmDeiRecordFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmDeiRecordSort>>;
};

export type FirmDeiCreateOrUpdate = {
  asOfDate: Scalars['Date']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  diversityStatsEnumId?: InputMaybe<Scalars['Int']['input']>;
  firmDEIRecords?: InputMaybe<Array<FirmDeiRecordInput>>;
  firmId: Scalars['Int']['input'];
  geographyEnumId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FirmDeiFilter = {
  asOfDate?: InputMaybe<Scalars['Date']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  geographyEnumId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  mostRecentMeasure?: InputMaybe<Scalars['Boolean']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  throughCurrentMonth?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FirmDeiList = {
  __typename?: 'FirmDEIList';
  items: Array<FirmDei>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FirmDeiRecord = {
  __typename?: 'FirmDEIRecord';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deiCategory1Enum: DeiCategory1Enum;
  deiCategory1EnumId: Scalars['Int']['output'];
  deiCategory2Enum: DeiCategory2Enum;
  deiCategory2EnumId?: Maybe<Scalars['Int']['output']>;
  firmDEI: FirmDei;
  firmDEIId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  measureEnum: MeasureEnum;
  measureEnumId: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  percentValue?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type FirmDeiRecordFilter = {
  deiCategory1EnumId?: InputMaybe<Scalars['Int']['input']>;
  deiCategory2EnumId?: InputMaybe<Scalars['Int']['input']>;
  firmDEIId?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  measureEnumId?: InputMaybe<Scalars['Int']['input']>;
};

export type FirmDeiRecordInput = {
  deiCategory1EnumId?: InputMaybe<Scalars['Int']['input']>;
  deiCategory2EnumId?: InputMaybe<Scalars['Int']['input']>;
  firmDEIId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  measureEnumId?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FirmDeiRecordSort = {
  field: FirmDeiRecordSortEnum;
  order: SortInput;
};

export enum FirmDeiRecordSortEnum {
  AsOfDate = 'asOfDate',
  Id = 'id'
}

export type FirmDeiSort = {
  field: FirmDeiSortEnum;
  order: SortInput;
};

export enum FirmDeiSortEnum {
  AsOfDate = 'asOfDate',
  Id = 'id',
  IsCompleted = 'isCompleted'
}

export type FirmEmployment = {
  __typename?: 'FirmEmployment';
  auditContactTypeEnumId?: Maybe<Scalars['Int']['output']>;
  authToTrade?: Maybe<Scalars['Boolean']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  contactType?: Maybe<ContactTypeEnum>;
  contactTypeEnumId?: Maybe<Scalars['Int']['output']>;
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  dataContact?: Maybe<Scalars['Boolean']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  employeeRole?: Maybe<EmployeeRoleEnum>;
  employeeRoleEnumId?: Maybe<Scalars['Int']['output']>;
  faceOfFirm?: Maybe<Scalars['Boolean']['output']>;
  firm: Firm;
  firmId: Scalars['Int']['output'];
  focusStrategyEnumId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  investmentFirmEmployments?: Maybe<Array<InvestmentFirmEmployment>>;
  isAdminContact?: Maybe<Scalars['Boolean']['output']>;
  isDataEntryContact?: Maybe<Scalars['Boolean']['output']>;
  isFounder?: Maybe<Scalars['Boolean']['output']>;
  isKeyPersonnel?: Maybe<Scalars['Boolean']['output']>;
  jobDesc?: Maybe<Scalars['String']['output']>;
  leftDate?: Maybe<Scalars['Date']['output']>;
  leftInd?: Maybe<Scalars['Boolean']['output']>;
  leftReason?: Maybe<Scalars['String']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  outsideAffil?: Maybe<Scalars['Boolean']['output']>;
  person?: Maybe<Person>;
  personId: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['Date']['output']>;
  uniqueId: Scalars['String']['output'];
};


export type FirmEmploymentInvestmentFirmEmploymentsArgs = {
  filter?: InputMaybe<InvestmentFirmEmploymentFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentFirmEmploymentSort>>;
};

export type FirmEmploymentFilterInput = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  contactTypeEnumIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  employeeRoleId?: InputMaybe<Scalars['Int']['input']>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  investmentEmployment?: InputMaybe<InvestmentFirmEmploymentFilterInput>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  investmentIdOrIsKeyPersonnel?: InputMaybe<InvestmentIdOrIsKeyPersonnel>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  isKeyPersonnel?: InputMaybe<Scalars['Boolean']['input']>;
  isPartner?: InputMaybe<Scalars['Boolean']['input']>;
  personId?: InputMaybe<Scalars['Int']['input']>;
  targetInvestmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type FirmEmploymentFilters = {
  firmId?: InputMaybe<Scalars['Int']['input']>;
  investmentEmployment?: InputMaybe<InvestmentFirmEmploymentFilters>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  isPartner?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FirmEmploymentInput = {
  auditContactTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  authToTrade?: InputMaybe<Scalars['Boolean']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  contactTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  dataContact?: InputMaybe<Scalars['Boolean']['input']>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  employeeRoleEnumId?: InputMaybe<Scalars['Int']['input']>;
  faceOfFirm?: InputMaybe<Scalars['Boolean']['input']>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  focusStrategyEnumId?: InputMaybe<Scalars['Int']['input']>;
  isAdminContact?: InputMaybe<Scalars['Boolean']['input']>;
  isDataEntryContact?: InputMaybe<Scalars['Boolean']['input']>;
  isFounder?: InputMaybe<Scalars['Boolean']['input']>;
  isKeyPersonnel?: InputMaybe<Scalars['Boolean']['input']>;
  jobDesc?: InputMaybe<Scalars['String']['input']>;
  leftDate?: InputMaybe<Scalars['Date']['input']>;
  leftInd?: InputMaybe<Scalars['Boolean']['input']>;
  leftReason?: InputMaybe<Scalars['String']['input']>;
  outsideAffil?: InputMaybe<Scalars['Boolean']['input']>;
  personId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type FirmEmploymentList = {
  __typename?: 'FirmEmploymentList';
  items: Array<FirmEmployment>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FirmEmploymentSort = {
  field: FirmEmploymentSortEnum;
  order: SortInput;
};

export enum FirmEmploymentSortEnum {
  FirmDefault = 'firmDefault',
  FirmName = 'firmName',
  Id = 'id',
  PersonDefault = 'personDefault',
  PersonName = 'personName'
}

export type FirmEngagement = {
  __typename?: 'FirmEngagement';
  access: EntityAccess;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  documentCount: Scalars['Int']['output'];
  firm?: Maybe<Firm>;
  firmEngagementGroupId: Scalars['Int']['output'];
  firmEngagementType?: Maybe<FirmEngagementTypeEnum>;
  firmEngagementTypeEnumId: Scalars['Int']['output'];
  firmId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  imageDocument?: Maybe<Document>;
  imageDocumentId?: Maybe<Scalars['Int']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  noteCount: Scalars['Int']['output'];
};

export type FirmEngagementFilter = {
  firmEngagementTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  firmIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type FirmEngagementInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  firmEngagementGroupId?: InputMaybe<Scalars['Int']['input']>;
  firmEngagementTypeEnumId: Scalars['Int']['input'];
  firmId: Scalars['Int']['input'];
  imageDocumentId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type FirmEngagementList = {
  __typename?: 'FirmEngagementList';
  items: Array<FirmEngagement>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FirmEngagementSort = {
  field: FirmEngagementSortEnum;
  order: SortInput;
};

export enum FirmEngagementSortEnum {
  CreateDate = 'createDate',
  FirmEngagementTypeEnumId = 'firmEngagementTypeEnumId',
  Id = 'id',
  ModifyDate = 'modifyDate',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type FirmEngagementTypeEnum = {
  __typename?: 'FirmEngagementTypeEnum';
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type FirmEngagementTypeEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FirmEngagementTypeEnumList = {
  __typename?: 'FirmEngagementTypeEnumList';
  items: Array<FirmEngagementTypeEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FirmEngagementTypeEnumSort = {
  field: FirmEngagementTypeEnumSortEnum;
  order: SortInput;
};

export enum FirmEngagementTypeEnumSortEnum {
  DisplayOrder = 'displayOrder',
  Id = 'id',
  Name = 'name'
}

export type FirmFdpLogins = {
  __typename?: 'FirmFDPLogins';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  fdpLogin: FdpLogin;
  fdpLoginId: Scalars['Int']['output'];
  fdpWebsite?: Maybe<FdpWebsites>;
  fdpWebsiteId?: Maybe<Scalars['Int']['output']>;
  firm: Firm;
  firmId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  investmentFDPLogins?: Maybe<Array<InvestmentFdpLogins>>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
};

export type FirmFdpLoginsFilter = {
  fdpLoginId?: InputMaybe<Scalars['Int']['input']>;
  fdpWebsiteId?: InputMaybe<Scalars['Int']['input']>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type FirmFdpLoginsInput = {
  fdpLoginId?: InputMaybe<Scalars['Int']['input']>;
  fdpWebsiteId?: InputMaybe<Scalars['Int']['input']>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type FirmFdpLoginsList = {
  __typename?: 'FirmFDPLoginsList';
  items: Array<FirmFdpLogins>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FirmFdpLoginsSort = {
  field: FirmFdpLoginsSortEnum;
  order: SortInput;
};

export enum FirmFdpLoginsSortEnum {
  FdpLoginId = 'fdpLoginId',
  FirmId = 'firmId',
  NameSearchRank = 'nameSearchRank'
}

export type FirmFields = {
  __typename?: 'FirmFields';
  firmAum?: Maybe<FirmAum>;
  firmId: Scalars['ID']['output'];
  state?: Maybe<Scalars['String']['output']>;
  values: Array<FieldValue>;
};

export type FirmFilterInput = {
  fuzzyTerm?: InputMaybe<Scalars['String']['input']>;
  includeCompanies?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isFunded?: InputMaybe<Scalars['Boolean']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type FirmFundAssets = {
  __typename?: 'FirmFundAssets';
  asOfDate: Scalars['DateTime']['output'];
  firmAUM?: Maybe<Scalars['Float']['output']>;
  firmAumCurrency?: Maybe<Scalars['String']['output']>;
  firmId: Scalars['Int']['output'];
  flow: AumFlow;
  investmentAUM?: Maybe<Scalars['Float']['output']>;
  investmentAumCurrency?: Maybe<Scalars['String']['output']>;
  investmentId: Scalars['Int']['output'];
  prevInvestmentAUM?: Maybe<Scalars['Float']['output']>;
  prevStrategyAUM?: Maybe<Scalars['Float']['output']>;
  strategyAUM?: Maybe<Scalars['Float']['output']>;
  strategyAumCurrency?: Maybe<Scalars['String']['output']>;
};

export type FirmFundAssetsFilter = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FirmFundAssetsList = {
  __typename?: 'FirmFundAssetsList';
  items: Array<FirmFundAssets>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FirmFundAssetsSort = {
  field: FirmFundAssetsSortEnum;
  order: SortInput;
};

export enum FirmFundAssetsSortEnum {
  AsOfDate = 'asOfDate',
  Id = 'id'
}

export type FirmInput = {
  ITCount?: InputMaybe<Scalars['Int']['input']>;
  administrativeCount?: InputMaybe<Scalars['Int']['input']>;
  analystCount?: InputMaybe<Scalars['Int']['input']>;
  assetResolutionAnalystCount?: InputMaybe<Scalars['Int']['input']>;
  cik?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  crd?: InputMaybe<Scalars['String']['input']>;
  dataOrganizationId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employeeTotal?: InputMaybe<Scalars['Int']['input']>;
  fdpLogins?: InputMaybe<Array<Scalars['Int']['input']>>;
  firmEmailDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  firmIrEmail?: InputMaybe<Scalars['String']['input']>;
  firmTags?: InputMaybe<Array<FirmTagsInput>>;
  fundLinks?: InputMaybe<Array<FundLink>>;
  generalCount?: InputMaybe<Scalars['Int']['input']>;
  impactTags?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** @deprecated Use `fdpLoginIds` instead */
  intraLinkId?: InputMaybe<Scalars['Int']['input']>;
  investmentCount?: InputMaybe<Scalars['Int']['input']>;
  investorRelationsCount?: InputMaybe<Scalars['Int']['input']>;
  isCompany?: InputMaybe<Scalars['Boolean']['input']>;
  isPartner?: InputMaybe<Scalars['Boolean']['input']>;
  isStaffMWDBE?: InputMaybe<Scalars['Boolean']['input']>;
  legalCount?: InputMaybe<Scalars['Int']['input']>;
  lei?: InputMaybe<Scalars['String']['input']>;
  linkedIn?: InputMaybe<Scalars['String']['input']>;
  middleBackOfficeCount?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  operationsCount?: InputMaybe<Scalars['Int']['input']>;
  otherAddresses?: InputMaybe<Array<AddressInput>>;
  ownershipDiversity?: InputMaybe<FirmOwnershipDiversityInput>;
  portfolioManagerCount?: InputMaybe<Scalars['Int']['input']>;
  primaryAddress?: InputMaybe<AddressInput>;
  registeredWithIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  registeredWithOther?: InputMaybe<Scalars['String']['input']>;
  researchAndUnderwritingAnalystCount?: InputMaybe<Scalars['Int']['input']>;
  riskCount?: InputMaybe<Scalars['Int']['input']>;
  sourcingAnalystCount?: InputMaybe<Scalars['Int']['input']>;
  stockSymbol?: InputMaybe<Scalars['String']['input']>;
  traderCount?: InputMaybe<Scalars['Int']['input']>;
  ukHfsbSignatory?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  yearFounded?: InputMaybe<Scalars['Int']['input']>;
};

export type FirmInstitutions = {
  __typename?: 'FirmInstitutions';
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  deleteUser?: Maybe<Scalars['String']['output']>;
  /** End date of engagement with service provider. */
  endDate?: Maybe<Scalars['Date']['output']>;
  firm: Firm;
  firmId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  institution: Institution;
  institutionId: Scalars['Int']['output'];
  institutionInstitutionTypeEnumId?: Maybe<Scalars['Int']['output']>;
  institutionsInstitutionTypeEnumList: InstitutionsInstitutionTypeEnumList;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  officeLocationServiceType?: Maybe<InstitutionsInstitutionTypeEnum>;
  /** Start date of engagement with service provider. */
  startDate?: Maybe<Scalars['Date']['output']>;
};


export type FirmInstitutionsInstitutionsInstitutionTypeEnumListArgs = {
  filter?: InputMaybe<InstitutionsInstitutionTypeEnumFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InstitutionsInstitutionTypeEnumSort>>;
};

export type FirmInstitutionsFilter = {
  firmId?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  institutionId?: InputMaybe<Scalars['Int']['input']>;
  institutionTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
};

export type FirmInstitutionsInput = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  institutionId?: InputMaybe<Scalars['Int']['input']>;
  institutionInstitutionTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type FirmInstitutionsList = {
  __typename?: 'FirmInstitutionsList';
  items: Array<FirmInstitutions>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FirmInstitutionsSort = {
  field: FirmInstitutionsSortEnum;
  order: SortInput;
};

export enum FirmInstitutionsSortEnum {
  Id = 'id',
  InstitutionName = 'institutionName',
  Name = 'name'
}

export type FirmList = {
  __typename?: 'FirmList';
  items: Array<Firm>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FirmOwnershipDiversity = {
  __typename?: 'FirmOwnershipDiversity';
  LGBTQPercent?: Maybe<Scalars['Float']['output']>;
  africanAmericanPercent?: Maybe<Scalars['Float']['output']>;
  asOfDate: Scalars['Date']['output'];
  asianPercent?: Maybe<Scalars['Float']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  disabledPercent?: Maybe<Scalars['Float']['output']>;
  diversePercent?: Maybe<Scalars['Float']['output']>;
  firmId: Scalars['Int']['output'];
  hispanicPercent?: Maybe<Scalars['Float']['output']>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  nativeAmericanPercent?: Maybe<Scalars['Float']['output']>;
  otherPercent?: Maybe<Scalars['Float']['output']>;
  veteranOrDisabledPercent?: Maybe<Scalars['Float']['output']>;
  veteranPercent?: Maybe<Scalars['Float']['output']>;
  womenPercent?: Maybe<Scalars['Float']['output']>;
};

export type FirmOwnershipDiversityInput = {
  LGBTQPercent?: InputMaybe<Scalars['Float']['input']>;
  africanAmericanPercent?: InputMaybe<Scalars['Float']['input']>;
  asOfDate?: InputMaybe<Scalars['Date']['input']>;
  asianPercent?: InputMaybe<Scalars['Float']['input']>;
  disabledPercent?: InputMaybe<Scalars['Float']['input']>;
  diversePercent?: InputMaybe<Scalars['Float']['input']>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  hispanicPercent?: InputMaybe<Scalars['Float']['input']>;
  nativeAmericanPercent?: InputMaybe<Scalars['Float']['input']>;
  otherPercent?: InputMaybe<Scalars['Float']['input']>;
  veteranOrDisabledPercent?: InputMaybe<Scalars['Float']['input']>;
  veteranPercent?: InputMaybe<Scalars['Float']['input']>;
  womenPercent?: InputMaybe<Scalars['Float']['input']>;
};

export type FirmProfileBuilderResponse = {
  __typename?: 'FirmProfileBuilderResponse';
  answer?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['Int']['output']>;
  firmProfile?: Maybe<GeneratedFirmProfile>;
};

export type FirmRegistration = {
  __typename?: 'FirmRegistration';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type FirmSearchFilters = {
  ACCESS?: InputMaybe<EntityAccessSearchFilter>;
  DEI?: InputMaybe<DeiFilter>;
  FIRM_ENTITY?: InputMaybe<EntitySearchFilter>;
  HEADQUARTERS?: InputMaybe<LocationFilter>;
  MWDBE?: InputMaybe<MwdbeFilter>;
};

export type FirmSort = {
  field: FirmSortEnum;
  order: SortInput;
};

export enum FirmSortEnum {
  FuzzyRank = 'fuzzyRank',
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type FirmTags = {
  __typename?: 'FirmTags';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  firmId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  tag: Tag;
  tagId: Scalars['Int']['output'];
};

export type FirmTagsFilter = {
  firmId?: InputMaybe<Scalars['Int']['input']>;
  tagClassId?: InputMaybe<Scalars['Int']['input']>;
  tagClassIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tagId?: InputMaybe<Scalars['Int']['input']>;
};

export type FirmTagsInput = {
  firmId?: InputMaybe<Scalars['Int']['input']>;
  tagId?: InputMaybe<Scalars['Int']['input']>;
};

export type FirmTagsSort = {
  field: FirmTagsSortEnum;
  order: SortInput;
};

export enum FirmTagsSortEnum {
  Id = 'id',
  Name = 'name'
}

export type FirmTeamStructure = {
  __typename?: 'FirmTeamStructure';
  admin?: Maybe<Scalars['Int']['output']>;
  analyst?: Maybe<Scalars['Int']['output']>;
  general?: Maybe<Scalars['Int']['output']>;
  investment?: Maybe<Scalars['Int']['output']>;
  investorRelations?: Maybe<Scalars['Int']['output']>;
  legal?: Maybe<Scalars['Int']['output']>;
  operations?: Maybe<Scalars['Int']['output']>;
  portfolioManager?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  trader?: Maybe<Scalars['Int']['output']>;
};

export type FirmXImpact = {
  __typename?: 'FirmXImpact';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  firm: Firm;
  firmId: Scalars['Int']['output'];
  impactEnum: ImpactEnum;
  impactEnumId: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
};

export type FirmsDynamicShareRule = {
  investmentSet?: InputMaybe<GroupShareInvestmentSetFilter>;
};

export type FirmsDynamicShareRuleOutput = {
  __typename?: 'FirmsDynamicShareRuleOutput';
  investmentSet?: Maybe<GroupShareInvestmentSetFilterOutput>;
};

export type FloatRangeFilter = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export enum FormatOptions {
  Docx = 'docx',
  Pdf = 'pdf'
}

export type FundHoldingDetail = {
  __typename?: 'FundHoldingDetail';
  afsSecurityMappingId?: Maybe<Scalars['Int']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  /** Source AFS document ID for linking back to the document */
  documentId?: Maybe<Scalars['Int']['output']>;
  fairValue: Scalars['Float']['output'];
  fundLegalName: Scalars['String']['output'];
  /** AfsHolding row ID — used for delete/edit mutations */
  holdingId: Scalars['Int']['output'];
  /** Original holding name as it appears in this fund's AFS document */
  holdingName: Scalars['String']['output'];
  identifierType?: Maybe<Scalars['String']['output']>;
  identifierValue?: Maybe<Scalars['String']['output']>;
  investmentId: Scalars['Int']['output'];
  /** Look-through value: (portfolioBalance / fundNetAssets) * holdingFairValue */
  lookthroughValue?: Maybe<Scalars['Float']['output']>;
  manuallyVerified?: Maybe<Scalars['Boolean']['output']>;
  /** Computed match type: 'aiMatched' (identifier-based automated match), 'proxy' (user-selected representative), 'manual' (user-verified), or null (unmatched) */
  matchType?: Maybe<Scalars['String']['output']>;
  percentageOfNav?: Maybe<Scalars['Float']['output']>;
  periodEndDate?: Maybe<Scalars['String']['output']>;
  /** Portfolio's balance in this fund at AFS period end */
  portfolioBalance?: Maybe<Scalars['Float']['output']>;
  securityMasterName?: Maybe<Scalars['String']['output']>;
  securityType?: Maybe<Scalars['String']['output']>;
  /** 1-based PDF page where this holding appears in the Schedule of Investments */
  sourcePage?: Maybe<Scalars['Int']['output']>;
  /** Short verbatim quote for highlighting the holding in the document viewer */
  sourceQuote?: Maybe<Scalars['String']['output']>;
  suggestedSecurityMasterId?: Maybe<Scalars['Int']['output']>;
  suggestedSecurityMasterName?: Maybe<Scalars['String']['output']>;
};

export type FundLink = {
  investmentId: Scalars['Int']['input'];
  linkId?: InputMaybe<Scalars['Int']['input']>;
};

export type FundLinks = {
  __typename?: 'FundLinks';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type FundingTypeEnum = {
  __typename?: 'FundingTypeEnum';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type FundingTypeEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FundingTypeEnumList = {
  __typename?: 'FundingTypeEnumList';
  items: Array<FundingTypeEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FundingTypeEnumSort = {
  field: FundingTypeEnumSortEnum;
  order: SortInput;
};

export enum FundingTypeEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type FundsXProxies = {
  __typename?: 'FundsXProxies';
  createDate?: Maybe<Scalars['Date']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  investment: Investment;
  investmentId: Scalars['Int']['output'];
  modifyDate?: Maybe<Scalars['Date']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  proxy: Investment;
  proxyId: Scalars['Int']['output'];
  proxyScalingFactor?: Maybe<Scalars['Float']['output']>;
  rank: Scalars['Int']['output'];
};

export type FundsXProxiesFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  investmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  proxyId?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
};

export type FundsXProxiesInput = {
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  proxyId?: InputMaybe<Scalars['Int']['input']>;
  proxyScalingFactor?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
};

export type FundsXProxiesList = {
  __typename?: 'FundsXProxiesList';
  items: Array<FundsXProxies>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FundsXProxiesSort = {
  field: FundsXProxiesSortEnum;
  order: SortInput;
};

export enum FundsXProxiesSortEnum {
  Id = 'id',
  Rank = 'rank'
}

export type GeneratedAddress = {
  __typename?: 'GeneratedAddress';
  city?: Maybe<Scalars['String']['output']>;
  countryEnumId?: Maybe<Scalars['Int']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  fax2?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  line3?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phone2?: Maybe<Scalars['String']['output']>;
  stateEnumId?: Maybe<Scalars['Int']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type GeneratedFirmEmployment = {
  __typename?: 'GeneratedFirmEmployment';
  employeeRoleEnumId?: Maybe<Scalars['Int']['output']>;
  firmId?: Maybe<Scalars['Int']['output']>;
  firmName?: Maybe<Scalars['String']['output']>;
  isFounder?: Maybe<Scalars['Boolean']['output']>;
  isKeyPersonnel?: Maybe<Scalars['Boolean']['output']>;
  jobDescription?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type GeneratedFirmProfile = {
  __typename?: 'GeneratedFirmProfile';
  administrativeCount?: Maybe<Scalars['Int']['output']>;
  analystCount?: Maybe<Scalars['Int']['output']>;
  cik?: Maybe<Scalars['String']['output']>;
  crd?: Maybe<Scalars['String']['output']>;
  employeeTotal?: Maybe<Scalars['Int']['output']>;
  firmIrEmail?: Maybe<Scalars['String']['output']>;
  investmentCount?: Maybe<Scalars['Int']['output']>;
  investorRelationsCount?: Maybe<Scalars['Int']['output']>;
  legalCount?: Maybe<Scalars['Int']['output']>;
  lei?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  operationsCount?: Maybe<Scalars['Int']['output']>;
  portfolioManagerCount?: Maybe<Scalars['Int']['output']>;
  primaryAddress?: Maybe<GeneratedAddress>;
  registeredWithIds?: Maybe<Array<Scalars['Int']['output']>>;
  traderCount?: Maybe<Scalars['Int']['output']>;
  yearFounded?: Maybe<Scalars['Int']['output']>;
};

export type GeneratedInvestmentFees = {
  __typename?: 'GeneratedInvestmentFees';
  abnormalFees?: Maybe<Scalars['Boolean']['output']>;
  abnormalFeesNotes?: Maybe<Scalars['String']['output']>;
  annualReset?: Maybe<Scalars['Boolean']['output']>;
  feeStructureChanged?: Maybe<Scalars['Boolean']['output']>;
  feeStructureChangedNotes?: Maybe<Scalars['String']['output']>;
  hasMgmtFeeStepDown?: Maybe<Scalars['Boolean']['output']>;
  highWaterMark?: Maybe<Scalars['Boolean']['output']>;
  hurdle?: Maybe<Scalars['Boolean']['output']>;
  hurdleBenchmark?: Maybe<Scalars['String']['output']>;
  incentiveFee?: Maybe<Scalars['Float']['output']>;
  incentiveFeeCalcEnumId?: Maybe<Scalars['Int']['output']>;
  incentiveFeeFreqEnumId?: Maybe<Scalars['Int']['output']>;
  mgmtFee?: Maybe<Scalars['Float']['output']>;
  mgmtFeeCalcEnumId?: Maybe<Scalars['Int']['output']>;
  mgmtFeeFreqEnumId?: Maybe<Scalars['Int']['output']>;
  otherFee?: Maybe<Scalars['Float']['output']>;
  otherFeeCalcEnumId?: Maybe<Scalars['Int']['output']>;
  otherFeeFreqEnumId?: Maybe<Scalars['Int']['output']>;
  peIncentiveFeeCalcEnumId?: Maybe<Scalars['Int']['output']>;
  peMgmtFeeCalcEnumId?: Maybe<Scalars['Int']['output']>;
  peMgmtFeeDuringCommitment?: Maybe<Scalars['Float']['output']>;
  peMgmtFeeDuringCommitmentCalcEnumId?: Maybe<Scalars['Int']['output']>;
  peMgmtFeeDuringHarvest?: Maybe<Scalars['Float']['output']>;
  peMgmtFeeDuringHarvestCalcEnumId?: Maybe<Scalars['Int']['output']>;
  peMgmtFeeStepDownCalcEnumId?: Maybe<Scalars['Int']['output']>;
  peMgmtFeeStepDownPercent?: Maybe<Scalars['Float']['output']>;
  standardShareClassRates?: Maybe<Scalars['Boolean']['output']>;
};

export type GeneratedInvestmentProfile = {
  __typename?: 'GeneratedInvestmentProfile';
  assetClassEnumId?: Maybe<Scalars['Int']['output']>;
  committedCapital?: Maybe<Scalars['Float']['output']>;
  currencyDenominationEnumId?: Maybe<Scalars['Int']['output']>;
  firmId?: Maybe<Scalars['Int']['output']>;
  firmName?: Maybe<Scalars['String']['output']>;
  gpCommitted?: Maybe<Scalars['Float']['output']>;
  inceptionDate?: Maybe<Scalars['Date']['output']>;
  isImpact?: Maybe<Scalars['Boolean']['output']>;
  marketEnumId?: Maybe<Scalars['Int']['output']>;
  maxTargetNetIRR?: Maybe<Scalars['Float']['output']>;
  maxTargetNetMOIC?: Maybe<Scalars['Float']['output']>;
  minTargetNetIRR?: Maybe<Scalars['Float']['output']>;
  minTargetNetMOIC?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  peLegalLifeYrs?: Maybe<Scalars['Int']['output']>;
  peStrategyEnumId?: Maybe<Scalars['Int']['output']>;
  primaryBenchmarkId?: Maybe<Scalars['Int']['output']>;
  primaryGeographicFocusId?: Maybe<Scalars['Int']['output']>;
  secondaryBenchmarkId?: Maybe<Scalars['Int']['output']>;
  strategyEnumId?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  targetRaise?: Maybe<Scalars['Float']['output']>;
  vehicleTypeEnumId?: Maybe<Scalars['Int']['output']>;
  vintageYear?: Maybe<Scalars['Int']['output']>;
};

export type GeneratedLiquidity = {
  __typename?: 'GeneratedLiquidity';
  cashAvailableDays?: Maybe<Scalars['Int']['output']>;
  exceptions?: Maybe<Scalars['String']['output']>;
  gatePercentCapital?: Maybe<Scalars['Float']['output']>;
  gatePercentNav?: Maybe<Scalars['Float']['output']>;
  hasGate?: Maybe<Scalars['Boolean']['output']>;
  hasHoldback?: Maybe<Scalars['Boolean']['output']>;
  hasLockup?: Maybe<Scalars['Boolean']['output']>;
  hasRollover?: Maybe<Scalars['Boolean']['output']>;
  holdbackPercent?: Maybe<Scalars['Float']['output']>;
  liquidityMonthlyValue?: Maybe<Scalars['Int']['output']>;
  liquidityUnitId?: Maybe<Scalars['Int']['output']>;
  liquidityValue?: Maybe<Scalars['Int']['output']>;
  lockupEndBizDays?: Maybe<Scalars['Boolean']['output']>;
  lockupEndValueId?: Maybe<Scalars['Int']['output']>;
  lockupMonthlyValue?: Maybe<Scalars['Int']['output']>;
  lockupUnitId?: Maybe<Scalars['Int']['output']>;
  lockupValue?: Maybe<Scalars['Int']['output']>;
  modelingNotes?: Maybe<Scalars['String']['output']>;
  noticeBizDays?: Maybe<Scalars['Boolean']['output']>;
  noticeUnitId?: Maybe<Scalars['Int']['output']>;
  noticeValue?: Maybe<Scalars['Int']['output']>;
  rolloverUnitId?: Maybe<Scalars['Int']['output']>;
  rolloverValue?: Maybe<Scalars['Int']['output']>;
  secondLockupEndBizDays?: Maybe<Scalars['Boolean']['output']>;
  secondLockupEndValueId?: Maybe<Scalars['Int']['output']>;
  subscriptionUnitId?: Maybe<Scalars['Int']['output']>;
  subscriptionValue?: Maybe<Scalars['Int']['output']>;
  workoutId?: Maybe<Scalars['Int']['output']>;
};

export type GeneratedPeLiquidity = {
  __typename?: 'GeneratedPeLiquidity';
  catchupPercent?: Maybe<Scalars['Float']['output']>;
  compoundingPeriodId?: Maybe<Scalars['Int']['output']>;
  hasCatchupProvision?: Maybe<Scalars['Boolean']['output']>;
  isCompounded?: Maybe<Scalars['Boolean']['output']>;
  optionOfExtensionId?: Maybe<Scalars['Int']['output']>;
  preferredReturn?: Maybe<Scalars['Float']['output']>;
};

export type GeneratedPersonDiversity = {
  __typename?: 'GeneratedPersonDiversity';
  africanAmerican?: Maybe<Scalars['Boolean']['output']>;
  asian?: Maybe<Scalars['Boolean']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  hawaiianOrPacificIslander?: Maybe<Scalars['Boolean']['output']>;
  hispanic?: Maybe<Scalars['Boolean']['output']>;
  lgbtq?: Maybe<Scalars['Boolean']['output']>;
  nativeAmerican?: Maybe<Scalars['Boolean']['output']>;
  nonBinary?: Maybe<Scalars['Boolean']['output']>;
  other?: Maybe<Scalars['Boolean']['output']>;
  veteran?: Maybe<Scalars['Boolean']['output']>;
  woman?: Maybe<Scalars['Boolean']['output']>;
};

export type GeneratedPersonProfile = {
  __typename?: 'GeneratedPersonProfile';
  biography?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  diversity?: Maybe<GeneratedPersonDiversity>;
  educationSummary?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email2?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  fax2?: Maybe<Scalars['String']['output']>;
  firmEmployment?: Maybe<GeneratedFirmEmployment>;
  firstName?: Maybe<Scalars['String']['output']>;
  isCFA?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phone2?: Maybe<Scalars['String']['output']>;
  pronouns?: Maybe<Scalars['String']['output']>;
  titleEnumId?: Maybe<Scalars['Int']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  workExperienceSummary?: Maybe<Scalars['String']['output']>;
};

export type GeneratedShareClassProfile = {
  __typename?: 'GeneratedShareClassProfile';
  FAS157?: Maybe<Scalars['Int']['output']>;
  currencyDenominationEnumId?: Maybe<Scalars['Int']['output']>;
  investmentFees?: Maybe<GeneratedInvestmentFees>;
  isRcgNegotiated?: Maybe<Scalars['Boolean']['output']>;
  liquidity?: Maybe<GeneratedLiquidity>;
  name?: Maybe<Scalars['String']['output']>;
  otherFees?: Maybe<Scalars['String']['output']>;
  peLiquidity?: Maybe<GeneratedPeLiquidity>;
  restricted?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type GenericContentItem = {
  __typename?: 'GenericContentItem';
  collapsed_text?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Array<GenericContentItem>>;
  display_name?: Maybe<Scalars['String']['output']>;
  display_options?: Maybe<DisplayOptions>;
  display_type?: Maybe<Scalars['String']['output']>;
  expanded?: Maybe<Scalars['Boolean']['output']>;
  expanded_text?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  question_text?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type GenericField = {
  __typename?: 'GenericField';
  allowNotApplicable?: Maybe<Scalars['Boolean']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  conditionalDescriptionKey?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  displaySort?: Maybe<DisplaySort>;
  displayType?: Maybe<Scalars['String']['output']>;
  editRoute?: Maybe<Scalars['String']['output']>;
  managerRestricted?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<Scalars['String']['output']>>;
  period?: Maybe<Scalars['String']['output']>;
  questionText?: Maybe<Scalars['String']['output']>;
  readOnly?: Maybe<Scalars['Boolean']['output']>;
  section?: Maybe<Scalars['String']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
  translations?: Maybe<GenericFieldTranslations>;
  value: GenericProp;
};

export type GenericFieldSet = {
  __typename?: 'GenericFieldSet';
  access_level: Scalars['String']['output'];
  config?: Maybe<FieldSetConfig>;
  content: Array<GenericContentItem>;
  description: Scalars['String']['output'];
  display_name: Scalars['String']['output'];
  key: Scalars['String']['output'];
  mapping?: Maybe<FieldSetMapping>;
  type: Scalars['String']['output'];
};

export type GenericFieldTranslations = {
  __typename?: 'GenericFieldTranslations';
  falseText?: Maybe<Scalars['String']['output']>;
  trueText?: Maybe<Scalars['String']['output']>;
};

export type GenericProp = {
  __typename?: 'GenericProp';
  arrayDepth: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  displayType?: Maybe<Scalars['String']['output']>;
  enumValues?: Maybe<Array<Scalars['String']['output']>>;
  hideChangelog?: Maybe<Scalars['Boolean']['output']>;
  hideMultiStateView?: Maybe<Scalars['Boolean']['output']>;
  hideTimeStamp?: Maybe<Scalars['Boolean']['output']>;
  isEmail?: Maybe<Scalars['Boolean']['output']>;
  isNumericString?: Maybe<Scalars['Boolean']['output']>;
  isScalar: Scalars['Boolean']['output'];
  isUUID?: Maybe<Scalars['Boolean']['output']>;
  isUrl?: Maybe<Scalars['Boolean']['output']>;
  length?: Maybe<LengthConstraint>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nullable: Scalars['Boolean']['output'];
  options?: Maybe<Array<Scalars['String']['output']>>;
  propertyKey: Scalars['String']['output'];
  props: Array<GenericProp>;
  returnTypeName: Scalars['String']['output'];
};

export type GeographicFocusEnum = {
  __typename?: 'GeographicFocusEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  investments: Array<Investment>;
  name: Scalars['String']['output'];
};

export type GeographicFocusEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type GeographicFocusEnumList = {
  __typename?: 'GeographicFocusEnumList';
  items: Array<GeographicFocusEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type GeographicFocusEnumSort = {
  field: GeographicFocusEnumSortEnum;
  order: SortInput;
};

export enum GeographicFocusEnumSortEnum {
  DisplayOrder = 'displayOrder',
  Id = 'id',
  Name = 'name'
}

export type GeographyEnum = {
  __typename?: 'GeographyEnum';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

export type GeographyEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type GeographyEnumList = {
  __typename?: 'GeographyEnumList';
  items: Array<GeographyEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type GeographyEnumSort = {
  field: GeographyEnumSortEnum;
  order: SortInput;
};

export enum GeographyEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type GlobalProviderInstitutionInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isCorporate?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Int']['input']>;
};

export type GlobalProviderInstitutions = {
  __typename?: 'GlobalProviderInstitutions';
  id: Scalars['Int']['output'];
  institution: Institution;
  institutionId: Scalars['Int']['output'];
  isCorporate: Scalars['Boolean']['output'];
  provider: ServiceProviderFirm;
  providerId: Scalars['Int']['output'];
};

export type GlobalProviderInstitutionsFilterInput = {
  institutionId?: InputMaybe<Scalars['Int']['input']>;
  providerId?: InputMaybe<Scalars['Int']['input']>;
};

export type GlobalProviderInstitutionsList = {
  __typename?: 'GlobalProviderInstitutionsList';
  items: Array<GlobalProviderInstitutions>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type GlobalProviderInstitutionsSort = {
  field: GlobalProviderInstitutionsSortEnum;
  order: SortInput;
};

export enum GlobalProviderInstitutionsSortEnum {
  Institution = 'institution',
  Provider = 'provider'
}

export type GlobalProviderNoteTypeEnum = {
  __typename?: 'GlobalProviderNoteTypeEnum';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type GlobalProviderNoteTypeEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type GlobalProviderNoteTypeEnumList = {
  __typename?: 'GlobalProviderNoteTypeEnumList';
  items: Array<GlobalProviderNoteTypeEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type GlobalProviderNoteTypeEnumSort = {
  field: GlobalProviderNoteTypeEnumSortEnum;
  order: SortInput;
};

export enum GlobalProviderNoteTypeEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export enum GroupEntityType {
  ApplicationFlag = 'applicationFlag',
  Deal = 'deal',
  Document = 'document',
  Firm = 'firm',
  FirmEngagement = 'firmEngagement',
  Investment = 'investment',
  Person = 'person',
  Portfolio = 'portfolio'
}

export type GroupInvestmentSetSubscription = {
  __typename?: 'GroupInvestmentSetSubscription';
  group?: Maybe<User>;
  groupId: Scalars['Int']['output'];
};

export type GroupShareDefinition = {
  __typename?: 'GroupShareDefinition';
  createDate: Scalars['DateTime']['output'];
  createUser?: Maybe<Scalars['String']['output']>;
  dynamicDefinition?: Maybe<Scalars['String']['output']>;
  dynamicDefinitionStructured?: Maybe<DynamicDefinitionOutput>;
  entityAccessId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  lastExecuted?: Maybe<Scalars['DateTime']['output']>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser?: Maybe<Scalars['String']['output']>;
  sourceGroup?: Maybe<User>;
  sourceGroupId: Scalars['Int']['output'];
  targetGroup?: Maybe<User>;
  targetGroupId: Scalars['Int']['output'];
};

export type GroupShareDefinitionFilter = {
  entityAccessId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  sourceGroupId?: InputMaybe<Scalars['Int']['input']>;
  targetGroupId?: InputMaybe<Scalars['Int']['input']>;
};

export type GroupShareDefinitionInput = {
  dynamicDefinition?: InputMaybe<DynamicDefinitionInput>;
  entityAccessId: Scalars['Int']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  sourceGroupId: Scalars['Int']['input'];
  targetGroupId: Scalars['Int']['input'];
};

export type GroupShareDefinitionList = {
  __typename?: 'GroupShareDefinitionList';
  items: Array<GroupShareDefinition>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type GroupShareDefinitionSort = {
  field: GroupShareDefinitionSortEnum;
  order: SortInput;
};

export enum GroupShareDefinitionSortEnum {
  CreateDate = 'createDate',
  Id = 'id',
  LastExecuted = 'lastExecuted',
  ModifyDate = 'modifyDate'
}

export type GroupShareInvestmentSetFilter = {
  setId: Scalars['Int']['input'];
};

export type GroupShareInvestmentSetFilterOutput = {
  __typename?: 'GroupShareInvestmentSetFilterOutput';
  setId: Scalars['Int']['output'];
};

export type GroupStatsInvestment = {
  __typename?: 'GroupStatsInvestment';
  exposure?: Maybe<Exposure>;
  id: Scalars['Int']['output'];
  isEntitled: Scalars['Boolean']['output'];
  list?: Maybe<InvestmentListEnum>;
  name: Scalars['String']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
  strategy: StrategyEnum;
  subStrategy?: Maybe<SubStrategyEnum>;
};


export type GroupStatsInvestmentExposureArgs = {
  categoryId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  positionType: PositionType;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GroupStatsList = {
  __typename?: 'GroupStatsList';
  items: Array<GroupStatsInvestment>;
  nextPage: NextPage;
  stats: StatsGroup;
  total: Scalars['Int']['output'];
};

export type Guideline = {
  __typename?: 'Guideline';
  arguments: Array<GuidelineArgument>;
  entitySourceId?: Maybe<Scalars['Float']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  frequency: Scalars['Float']['output'];
  isInternal: Scalars['Boolean']['output'];
  limit?: Maybe<GuidelineLimit>;
  metricInfoId?: Maybe<Scalars['Float']['output']>;
  nodeId: Scalars['Float']['output'];
  resultCardinality: Scalars['Float']['output'];
  resultType: Scalars['Float']['output'];
  results: Array<GuidelineResult>;
};

export type GuidelineArgument = {
  __typename?: 'GuidelineArgument';
  guidelineId: Scalars['Float']['output'];
  parameterName: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type GuidelineArgumentInput = {
  parameterName: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type GuidelineBreachSummary = {
  __typename?: 'GuidelineBreachSummary';
  breachCount: Scalars['Int']['output'];
  investmentId: Scalars['Int']['output'];
  investmentName: Scalars['String']['output'];
  totalGuidelines: Scalars['Int']['output'];
};

export type GuidelineLimit = {
  __typename?: 'GuidelineLimit';
  guidelineId: Scalars['Float']['output'];
  limitValue: Scalars['String']['output'];
  relationToResult?: Maybe<Scalars['Float']['output']>;
};

export type GuidelineNode = {
  __typename?: 'GuidelineNode';
  children: Array<GuidelineNode>;
  description?: Maybe<Scalars['String']['output']>;
  guideline?: Maybe<Guideline>;
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Float']['output']>;
  siblingIndex: Scalars['Float']['output'];
};

export type GuidelineNote = {
  __typename?: 'GuidelineNote';
  guidelineDate: Scalars['DateTime']['output'];
  investmentId: Scalars['Float']['output'];
  noteText?: Maybe<Scalars['String']['output']>;
};

export type GuidelineResult = {
  __typename?: 'GuidelineResult';
  createDate?: Maybe<Scalars['DateTime']['output']>;
  date: Scalars['DateTime']['output'];
  guidelineId: Scalars['Float']['output'];
  isCompliant: Scalars['Boolean']['output'];
  isError: Scalars['Boolean']['output'];
  isOverride: Scalars['Boolean']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type GuidelineSet = {
  __typename?: 'GuidelineSet';
  effectiveDate: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  investmentId: Scalars['Float']['output'];
  nodes: Array<GuidelineNode>;
};

export type GuidelineSetDeleteResult = {
  __typename?: 'GuidelineSetDeleteResult';
  success: Scalars['Boolean']['output'];
};

export type HistoricalPeriodInput = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type IPieData = {
  name: Scalars['String']['input'];
  y: Scalars['Float']['input'];
};

export type IconEnum = {
  __typename?: 'IconEnum';
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type IconEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IconEnumList = {
  __typename?: 'IconEnumList';
  items: Array<IconEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type IconEnumSort = {
  field: IconEnumSortEnum;
  order: SortInput;
};

export enum IconEnumSortEnum {
  DisplayOrder = 'displayOrder',
  Id = 'id',
  Name = 'name'
}

export type IdpInfo = {
  __typename?: 'IdpInfo';
  authType: UserAuthType;
  cognitoIdpIdentifier?: Maybe<Scalars['String']['output']>;
  found: Scalars['Boolean']['output'];
};

export type ImpactCategoryEnum = {
  __typename?: 'ImpactCategoryEnum';
  atlasKey: Scalars['Boolean']['output'];
  displayOrder: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  impactEnums: Array<ImpactEnum>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ImpactCategoryEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ImpactCategoryEnumList = {
  __typename?: 'ImpactCategoryEnumList';
  items: Array<ImpactCategoryEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type ImpactCategoryEnumSort = {
  field: ImpactCategoryEnumSortEnum;
  order: SortInput;
};

export enum ImpactCategoryEnumSortEnum {
  Id = 'id'
}

export type ImpactEnum = {
  __typename?: 'ImpactEnum';
  atlasKey: Scalars['String']['output'];
  displayOrder: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  impactCategory: ImpactCategoryEnum;
  impactEnumCategoryId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ImpactSearchFilter = {
  /** Defaults to false */
  isOr?: InputMaybe<Scalars['Boolean']['input']>;
  values: Array<EntityKey>;
};

export type ImportGuidelineNodeInput = {
  arguments?: InputMaybe<Array<GuidelineArgumentInput>>;
  children?: InputMaybe<Array<ImportGuidelineNodeInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<Scalars['Int']['input']>;
  limitRelationToResult?: InputMaybe<Scalars['Int']['input']>;
  limitValue?: InputMaybe<Scalars['String']['input']>;
  metricInfoId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  resultCardinality?: InputMaybe<Scalars['Int']['input']>;
  resultType?: InputMaybe<Scalars['Int']['input']>;
};

export type ImportResult = {
  __typename?: 'ImportResult';
  guidelinesCreated: Scalars['Int']['output'];
  nodesCreated: Scalars['Int']['output'];
};

export type ImportRiskFromS3Input = {
  conversationArtifactId?: InputMaybe<Scalars['Int']['input']>;
  errorRowLimit?: InputMaybe<Scalars['Int']['input']>;
  isEstimated?: InputMaybe<Scalars['Boolean']['input']>;
  notify?: InputMaybe<Scalars['Boolean']['input']>;
  s3Bucket?: InputMaybe<Scalars['String']['input']>;
  s3Key?: InputMaybe<Scalars['String']['input']>;
  validateOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImportRiskFromS3Result = {
  __typename?: 'ImportRiskFromS3Result';
  jobId?: Maybe<Scalars['String']['output']>;
  jobName: Scalars['String']['output'];
  queueName: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
};

export type ImportRiskMeasuresStatus = {
  __typename?: 'ImportRiskMeasuresStatus';
  id: Scalars['ID']['output'];
  returnValue?: Maybe<RiskFileParse>;
  status: AsyncTaskStatus;
};

export type InactiveInvestmentFilter = {
  /** Defaults to false */
  hideInactive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IndexCalcTypeEnum = {
  __typename?: 'IndexCalcTypeEnum';
  description: Scalars['String']['output'];
  displayOrder: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  indexCalcType: Scalars['String']['output'];
};

export type IndexCalcTypeEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type IndexCalcTypeEnumList = {
  __typename?: 'IndexCalcTypeEnumList';
  items: Array<IndexCalcTypeEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type IndexCalcTypeEnumSort = {
  field: IndexCalcTypeEnumSortEnum;
  order: SortInput;
};

export enum IndexCalcTypeEnumSortEnum {
  Id = 'id',
  IndexCalcType = 'indexCalcType'
}

export type Institution = {
  __typename?: 'Institution';
  address: Address;
  addressesId: Scalars['Int']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  globalProviderInstitution?: Maybe<GlobalProviderInstitutions>;
  globalProviderInstitutionsList?: Maybe<GlobalProviderInstitutionsList>;
  id: Scalars['Int']['output'];
  institutionInstitutionTypesList: Array<Scalars['Int']['output']>;
  institutionNameWithLocation: Scalars['String']['output'];
  institutionSelectionStatus?: Maybe<InstitutionSelectionStatusEnum>;
  institutionSelectionStatusEnum?: Maybe<InstitutionSelectionStatusEnum>;
  institutionSelectionStatusEnumId?: Maybe<Scalars['Int']['output']>;
  institutionsInstitutionTypeEnumList: InstitutionsInstitutionTypeEnumList;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  name: Scalars['String']['output'];
};


export type InstitutionGlobalProviderInstitutionArgs = {
  filter?: InputMaybe<GlobalProviderInstitutionsFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<GlobalProviderInstitutionsSort>>;
};


export type InstitutionGlobalProviderInstitutionsListArgs = {
  filter?: InputMaybe<GlobalProviderInstitutionsFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<GlobalProviderInstitutionsSort>>;
};


export type InstitutionInstitutionInstitutionTypesListArgs = {
  filter?: InputMaybe<InstitutionsInstitutionTypeEnumFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InstitutionsInstitutionTypeEnumSort>>;
};


export type InstitutionInstitutionsInstitutionTypeEnumListArgs = {
  filter?: InputMaybe<InstitutionsInstitutionTypeEnumFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InstitutionsInstitutionTypeEnumSort>>;
};

export type InstitutionEmployment = {
  __typename?: 'InstitutionEmployment';
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  institution: Institution;
  institutionId: Scalars['Int']['output'];
  isPrimaryContact?: Maybe<Scalars['Boolean']['output']>;
  leftDate?: Maybe<Scalars['Date']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  person: Person;
  personId: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type InstitutionEmploymentFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  institutionId?: InputMaybe<Scalars['Int']['input']>;
  personId?: InputMaybe<Scalars['Int']['input']>;
};

export type InstitutionEmploymentInput = {
  institutionId?: InputMaybe<Scalars['Int']['input']>;
  isPrimaryContact?: InputMaybe<Scalars['Boolean']['input']>;
  leftDate?: InputMaybe<Scalars['Date']['input']>;
  personId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type InstitutionEmploymentList = {
  __typename?: 'InstitutionEmploymentList';
  items: Array<InstitutionEmployment>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InstitutionEmploymentSort = {
  field: InstitutionEmploymentSortEnum;
  order: SortInput;
};

export enum InstitutionEmploymentSortEnum {
  Id = 'id'
}

export type InstitutionFilterInput = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  institutionTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type InstitutionInput = {
  address?: InputMaybe<AddressInput>;
  globalProviderInstitution?: InputMaybe<GlobalProviderInstitutionInput>;
  institutionInstitutionTypesList?: InputMaybe<Array<Scalars['Int']['input']>>;
  institutionSelectionStatusEnumId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InstitutionList = {
  __typename?: 'InstitutionList';
  items: Array<Institution>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InstitutionSelectionStatusEnum = {
  __typename?: 'InstitutionSelectionStatusEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type InstitutionSelectionStatusEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type InstitutionSelectionStatusEnumList = {
  __typename?: 'InstitutionSelectionStatusEnumList';
  items: Array<InstitutionSelectionStatusEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InstitutionSelectionStatusEnumSort = {
  field: InstitutionSelectionStatusEnumSortEnum;
  order: SortInput;
};

export enum InstitutionSelectionStatusEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type InstitutionSort = {
  field: InstitutionSortEnum;
  order: SortInput;
};

export enum InstitutionSortEnum {
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type InstitutionTypeEnum = {
  __typename?: 'InstitutionTypeEnum';
  displayOrder: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type InstitutionTypeEnumFilterInput = {
  q?: InputMaybe<Scalars['String']['input']>;
};

export type InstitutionTypeEnumList = {
  __typename?: 'InstitutionTypeEnumList';
  items: Array<InstitutionTypeEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InstitutionTypeEnumSort = {
  field: InstitutionTypeEnumSortEnum;
  order: SortInput;
};

export enum InstitutionTypeEnumSortEnum {
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type InstitutionsInstitutionTypeEnum = {
  __typename?: 'InstitutionsInstitutionTypeEnum';
  id: Scalars['Int']['output'];
  institutionId: Scalars['Int']['output'];
  institutionTypeEnum: InstitutionTypeEnum;
  institutionTypeEnumId: Scalars['Int']['output'];
};

export type InstitutionsInstitutionTypeEnumFilterInput = {
  institutionId?: InputMaybe<Scalars['Int']['input']>;
  institutionTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type InstitutionsInstitutionTypeEnumList = {
  __typename?: 'InstitutionsInstitutionTypeEnumList';
  items: Array<InstitutionsInstitutionTypeEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InstitutionsInstitutionTypeEnumSort = {
  field: InstitutionsInstitutionTypeEnumSortEnum;
  order: SortInput;
};

export enum InstitutionsInstitutionTypeEnumSortEnum {
  DisplayOrder = 'displayOrder',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type IntRangeFilter = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type IntraLink = {
  __typename?: 'IntraLink';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  securityQuestion?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type Investment = {
  __typename?: 'Investment';
  HFRIInvestmentId?: Maybe<Scalars['Int']['output']>;
  NAVClassification?: Maybe<NavClassificationEnum>;
  NAVClassificationEnumId?: Maybe<Scalars['Int']['output']>;
  RICId?: Maybe<Scalars['String']['output']>;
  access?: Maybe<EntityAccess>;
  accessRequest?: Maybe<Scalars['Boolean']['output']>;
  accountTypeEnumId?: Maybe<Scalars['Int']['output']>;
  accountingIsCommodityFuture?: Maybe<Scalars['Boolean']['output']>;
  advisor?: Maybe<Firm>;
  advisorId?: Maybe<Scalars['Int']['output']>;
  advisorTypeEnumId?: Maybe<Scalars['Int']['output']>;
  alphaVantageTicker?: Maybe<Scalars['String']['output']>;
  assetClass?: Maybe<AssetClass2Enum>;
  assetClassEnumId?: Maybe<Scalars['Int']['output']>;
  assets?: Maybe<Array<FirmFundAssets>>;
  atlasInvestmentId?: Maybe<Scalars['ID']['output']>;
  axysCodes: Array<InvestmentAxysCode>;
  bloombergCode?: Maybe<Scalars['String']['output']>;
  bloombergField?: Maybe<Scalars['String']['output']>;
  burgissId?: Maybe<Scalars['UUID']['output']>;
  closeDateFundSize?: Maybe<Array<CloseDateFundSize>>;
  cogencyLink?: Maybe<CogencyLink>;
  committedCapital?: Maybe<Scalars['Float']['output']>;
  committedCapitalCurrency?: Maybe<CurrencyDenominationEnum>;
  committedCapitalCurrencyId?: Maybe<Scalars['Int']['output']>;
  completeness?: Maybe<Array<MemoizedInvestmentCompletenessSummary>>;
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  currencyDenominationEnum?: Maybe<CurrencyDenominationEnum>;
  currencyDenominationEnumId?: Maybe<Scalars['Int']['output']>;
  derivedPrivateQuartileGroupCategory?: Maybe<PrivateQuartileGroupCategory>;
  diligenceTabs?: Maybe<Array<TemplateAttachment>>;
  domicileCountry?: Maybe<CountryEnum>;
  domicileCountryId?: Maybe<Scalars['Int']['output']>;
  domicileFundLinkId?: Maybe<Scalars['Int']['output']>;
  domicileLink?: Maybe<FundLinks>;
  domicileUSState?: Maybe<StateEnum>;
  domicileUSStateId?: Maybe<Scalars['Int']['output']>;
  evestmentId?: Maybe<Scalars['Int']['output']>;
  exposure?: Maybe<Exposure>;
  extensionPeriodYrs?: Maybe<Scalars['Int']['output']>;
  faceOfInvestment?: Maybe<InvestmentFirmEmployment>;
  family?: Maybe<Family>;
  familyId?: Maybe<Scalars['Int']['output']>;
  fdpLogins?: Maybe<Array<FdpLogin>>;
  fieldData?: Maybe<FieldData>;
  fieldHistory?: Maybe<Array<Field>>;
  fields?: Maybe<InvestmentFields>;
  firm?: Maybe<Firm>;
  firmId?: Maybe<Scalars['Int']['output']>;
  fiscalYearEndMonth?: Maybe<Scalars['Int']['output']>;
  fundLinkId?: Maybe<Scalars['Int']['output']>;
  fundsXProxies?: Maybe<Array<FundsXProxies>>;
  gapAnalysis?: Maybe<DiligenceGapAnalysis>;
  gpCommitted?: Maybe<Scalars['Float']['output']>;
  gpCommittedCurrency?: Maybe<CurrencyDenominationEnum>;
  gpCommittedCurrencyId?: Maybe<Scalars['Int']['output']>;
  groupStats: GroupStatsList;
  hardCap?: Maybe<Scalars['Float']['output']>;
  harvestPeriodYrs?: Maybe<Scalars['Int']['output']>;
  hasPricingData?: Maybe<Scalars['Boolean']['output']>;
  holdingPortfolios: BalancesList;
  id: Scalars['Int']['output'];
  impactTags?: Maybe<Array<ImpactEnum>>;
  inceptionDate?: Maybe<Scalars['Date']['output']>;
  indexCalcTypeEnum?: Maybe<IndexCalcTypeEnum>;
  indexCalcTypeEnumId?: Maybe<Scalars['Int']['output']>;
  investmentFirmEmployments: Array<InvestmentFirmEmployment>;
  investmentGroupId?: Maybe<Scalars['Int']['output']>;
  investmentInstitutionsList?: Maybe<InvestmentInstitutionsList>;
  investmentPeriodYrs?: Maybe<Scalars['Int']['output']>;
  investmentRegulatorsList?: Maybe<InvestmentRegulatorsList>;
  investmentStructure?: Maybe<InvestmentStructureEnum>;
  investmentStructureEnumId?: Maybe<Scalars['Int']['output']>;
  investmentTags?: Maybe<Array<InvestmentTags>>;
  investmentXImpact?: Maybe<Array<InvestmentXImpact>>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isESG?: Maybe<Scalars['Boolean']['output']>;
  isEntitled?: Maybe<Scalars['Boolean']['output']>;
  isImpact?: Maybe<Scalars['Boolean']['output']>;
  isInActive?: Maybe<Scalars['Boolean']['output']>;
  isLiquidated?: Maybe<Scalars['Boolean']['output']>;
  isManagerUnwillingToProvideAUM?: Maybe<Scalars['Boolean']['output']>;
  isManagerUnwillingToProvidePerformance?: Maybe<Scalars['Boolean']['output']>;
  isManagerUnwillingToProvidePositions?: Maybe<Scalars['Boolean']['output']>;
  isManagerUnwillingToProvideRisk?: Maybe<Scalars['Boolean']['output']>;
  isOffshore?: Maybe<Scalars['Boolean']['output']>;
  isPartner?: Maybe<Scalars['Boolean']['output']>;
  isPortfolio?: Maybe<Scalars['Boolean']['output']>;
  isRegisteredInvestmentCompany?: Maybe<Scalars['Boolean']['output']>;
  isSubAdvised?: Maybe<Scalars['Boolean']['output']>;
  isWorkInProgress?: Maybe<Scalars['Boolean']['output']>;
  latestFirmAUM?: Maybe<DatedAsset>;
  latestInvestmentAUM?: Maybe<DatedAsset>;
  latestNote?: Maybe<Notes>;
  latestStrategyAUM?: Maybe<DatedAsset>;
  legalStructure?: Maybe<LegalStructureEnum>;
  legalStructureEnumId?: Maybe<Scalars['Int']['output']>;
  links?: Maybe<FundLinks>;
  liquidationDate?: Maybe<Scalars['Date']['output']>;
  liquidationNote?: Maybe<Scalars['String']['output']>;
  list?: Maybe<InvestmentListEnum>;
  listEnumId?: Maybe<Scalars['Int']['output']>;
  listItems?: Maybe<Array<InvestmentSetItems>>;
  llmPerformanceMTD?: Maybe<Array<LlmPerformance>>;
  managerAttributes?: Maybe<Array<VManagerAttribute>>;
  market?: Maybe<AssetClassEnum>;
  marketEnumId?: Maybe<Scalars['Int']['output']>;
  maxExpectedVolatility?: Maybe<Scalars['Float']['output']>;
  maxGrossExposure?: Maybe<Scalars['Float']['output']>;
  maxNetExposure?: Maybe<Scalars['Float']['output']>;
  maxTargetNetIRR?: Maybe<Scalars['Float']['output']>;
  maxTargetNetMOIC?: Maybe<Scalars['Float']['output']>;
  minExpectedVolatility?: Maybe<Scalars['Float']['output']>;
  minGrossExposure?: Maybe<Scalars['Float']['output']>;
  minNetExposure?: Maybe<Scalars['Float']['output']>;
  minTargetNetIRR?: Maybe<Scalars['Float']['output']>;
  minTargetNetMOIC?: Maybe<Scalars['Float']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Has RockCreek signed an NDA precluding them from sharing fund data with 3rd Parties? */
  ndaSigned?: Maybe<Scalars['Boolean']['output']>;
  notesList?: Maybe<NotesList>;
  organizationStructure?: Maybe<OrganizationStructureEnum>;
  organizationStructureEnumId?: Maybe<Scalars['Int']['output']>;
  otherGeographicFocusIds?: Maybe<Array<Scalars['Int']['output']>>;
  otherGeographicFocuses?: Maybe<Array<GeographicFocusEnum>>;
  peFundNumber?: Maybe<PeFundNumberEnum>;
  peFundNumberEnumId?: Maybe<Scalars['Int']['output']>;
  peLegalLifeYrs?: Maybe<Scalars['Int']['output']>;
  peStrategy?: Maybe<PeStrategyEnum>;
  peStrategyEnumId?: Maybe<Scalars['Int']['output']>;
  peSubStrategy?: Maybe<PeSubStrategyEnum>;
  peSubStrategyEnumId?: Maybe<Scalars['Int']['output']>;
  peersAutoList: InvestmentList;
  peersList: InvestmentList;
  peersStats: GroupStatsList;
  performanceAnalysis?: Maybe<PerformanceAnalytics>;
  performanceMTD?: Maybe<Array<PerformanceMtd>>;
  performanceMTDCurrencyConverted?: Maybe<Array<PerformanceMtd>>;
  performancePeriodRange?: Maybe<PerformancePeriodRange>;
  performancePrivate?: Maybe<Array<PerformancePrivate>>;
  performanceQuarterly?: Maybe<Array<PerformanceQuarterly>>;
  performanceSource?: Maybe<Scalars['String']['output']>;
  performanceSourceEnum: Array<PerformanceSourceEnum>;
  performanceSourceEnumId?: Maybe<Scalars['Int']['output']>;
  performanceStats?: Maybe<PerformanceStatistics>;
  portalSubmitted?: Maybe<PortalSubmitted>;
  portfolioConfig?: Maybe<PortfolioConfig>;
  positions?: Maybe<PositionList>;
  pricingFrequency?: Maybe<PricingFrequencyEnum>;
  pricingFrequencyEnumId?: Maybe<Scalars['Int']['output']>;
  primaryAssignment?: Maybe<Scalars['String']['output']>;
  primaryBenchmark?: Maybe<Investment>;
  primaryBenchmarkId?: Maybe<Scalars['Int']['output']>;
  primaryFundAdvisor?: Maybe<User>;
  primaryGeographicFocus?: Maybe<GeographicFocusEnum>;
  primaryGeographicFocusId?: Maybe<Scalars['Int']['output']>;
  primaryPortfolio?: Maybe<Portfolio>;
  primaryPortfolioManager?: Maybe<InvestmentFirmEmployment>;
  publishedFieldState?: Maybe<Scalars['String']['output']>;
  registeredAddressProvider?: Maybe<Institution>;
  reportingDate?: Maybe<Scalars['Date']['output']>;
  reportingDateReason?: Maybe<Scalars['String']['output']>;
  reportingLinkId?: Maybe<Scalars['Int']['output']>;
  secondaryAssignment?: Maybe<Scalars['String']['output']>;
  secondaryBenchmark?: Maybe<Investment>;
  secondaryBenchmarkId?: Maybe<Scalars['Int']['output']>;
  secondaryFundAdvisor?: Maybe<User>;
  shareClassNote?: Maybe<Scalars['String']['output']>;
  shareClasses?: Maybe<Array<ShareClass>>;
  sharingOrganizationIconUrl?: Maybe<Scalars['String']['output']>;
  sharingOrganizationName?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  strategy?: Maybe<StrategyEnum>;
  strategyEnumId?: Maybe<Scalars['Int']['output']>;
  subStrategy?: Maybe<SubStrategyEnum>;
  subStrategyEnumId?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  tagAttributes?: Maybe<TagAttributes>;
  targetRaise?: Maybe<Scalars['Float']['output']>;
  templateOptions?: Maybe<Array<Scalars['String']['output']>>;
  uniqueSecurityCode?: Maybe<Scalars['String']['output']>;
  vehicleType?: Maybe<VehicleTypeEnum>;
  vehicleTypeEnumId?: Maybe<Scalars['Int']['output']>;
  vintageYear?: Maybe<Scalars['Int']['output']>;
};


export type InvestmentAssetsArgs = {
  filter?: InputMaybe<FirmFundAssetsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmFundAssetsSort>>;
};


export type InvestmentCompletenessArgs = {
  memoized: Scalars['Boolean']['input'];
};


export type InvestmentExposureArgs = {
  categoryId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  positionType: PositionType;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type InvestmentFdpLoginsArgs = {
  filter?: InputMaybe<FdpLoginFilter>;
};


export type InvestmentFieldDataArgs = {
  fieldSetType: FieldSetType;
  state?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type InvestmentFieldHistoryArgs = {
  filter?: InputMaybe<FieldHistoryFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FieldHistorySort>>;
};


export type InvestmentFieldsArgs = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  periodType?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type InvestmentGroupStatsArgs = {
  asOfDate: Scalars['Date']['input'];
  dependentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  filter?: InputMaybe<InvestmentFilterInput>;
  includeBenchmarks?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<PageInput>;
  priorTrackRecord?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Array<InvestmentSort>>;
  wrtInvestmentId?: InputMaybe<Scalars['Int']['input']>;
};


export type InvestmentHoldingPortfoliosArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
};


export type InvestmentInvestmentFirmEmploymentsArgs = {
  filter?: InputMaybe<InvestmentFirmEmploymentFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentFirmEmploymentSort>>;
};


export type InvestmentInvestmentInstitutionsListArgs = {
  filter?: InputMaybe<InvestmentInstitutionsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentInstitutionsSort>>;
};


export type InvestmentInvestmentRegulatorsListArgs = {
  filter?: InputMaybe<InvestmentRegulatorsFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentRegulatorsSort>>;
};


export type InvestmentLatestNoteArgs = {
  noteMetaId: Scalars['Int']['input'];
};


export type InvestmentLlmPerformanceMtdArgs = {
  filter?: InputMaybe<PerformanceMtdFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PerformanceMtdSort>>;
};


export type InvestmentNotesListArgs = {
  filter?: InputMaybe<NotesFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<NotesSort>>;
};


export type InvestmentPeersAutoListArgs = {
  filter?: InputMaybe<InvestmentPeersFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentSort>>;
};


export type InvestmentPeersListArgs = {
  filter?: InputMaybe<InvestmentPeersFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentSort>>;
};


export type InvestmentPeersStatsArgs = {
  asOfDate: Scalars['Date']['input'];
  filter?: InputMaybe<InvestmentFilterInput>;
  includeBenchmarks?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentSort>>;
  wrtInvestmentId?: InputMaybe<Scalars['Int']['input']>;
};


export type InvestmentPerformanceAnalysisArgs = {
  benchmarkIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  defaultBenchmarks?: InputMaybe<Scalars['Boolean']['input']>;
};


export type InvestmentPerformanceMtdArgs = {
  filter?: InputMaybe<PerformanceMtdFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PerformanceMtdSort>>;
};


export type InvestmentPerformanceMtdCurrencyConvertedArgs = {
  filter?: InputMaybe<PerformanceMtdFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PerformanceMtdSort>>;
  toCurrencyId: Scalars['Int']['input'];
};


export type InvestmentPerformancePeriodRangeArgs = {
  returnType?: InputMaybe<ReturnTypes>;
};


export type InvestmentPerformancePrivateArgs = {
  filter?: InputMaybe<PerformancePrivateFilter>;
  page?: InputMaybe<PageInput>;
  privateQuartileGroupCategoryId?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PerformancePrivateSort>>;
};


export type InvestmentPerformanceQuarterlyArgs = {
  filter?: InputMaybe<PerformanceQuarterlyFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PerformanceQuarterlySort>>;
};


export type InvestmentPerformanceStatsArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
};


export type InvestmentPositionsArgs = {
  filter?: InputMaybe<PositionFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PositionSort>>;
};


export type InvestmentShareClassesArgs = {
  filter?: InputMaybe<ShareClassFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ShareClassSort>>;
};


export type InvestmentTemplateOptionsArgs = {
  fieldSetType: FieldSetType;
};

export type InvestmentAccessRequest = {
  __typename?: 'InvestmentAccessRequest';
  completeDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  investmentId: Scalars['Int']['output'];
  requestDate: Scalars['Date']['output'];
  userId: Scalars['Int']['output'];
};

export type InvestmentAccessRequestInput = {
  investmentId: Scalars['Int']['input'];
};

export type InvestmentAssignmentOption = {
  __typename?: 'InvestmentAssignmentOption';
  commonName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPrimary: Scalars['Boolean']['output'];
  isSecondary: Scalars['Boolean']['output'];
  userName: Scalars['String']['output'];
};

export type InvestmentAssignmentOptionFilter = {
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  isSecondary?: InputMaybe<Scalars['Boolean']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentAssignmentOptionList = {
  __typename?: 'InvestmentAssignmentOptionList';
  items: Array<InvestmentAssignmentOption>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InvestmentAssignmentOptionSort = {
  field: InvestmentAssignmentOptionSortEnum;
  order: SortInput;
};

export enum InvestmentAssignmentOptionSortEnum {
  CommonName = 'commonName',
  Id = 'id',
  NameSearchRank = 'nameSearchRank',
  UserName = 'userName'
}

export type InvestmentAum = {
  __typename?: 'InvestmentAum';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Array<AumRecord>>;
};

export type InvestmentAxysCode = {
  __typename?: 'InvestmentAxysCode';
  axysCode: AxysCode;
  axysCodeId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  investmentId: Scalars['Int']['output'];
};

export type InvestmentAxysCodeFilter = {
  investmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type InvestmentAxysCodeInput = {
  code: Scalars['String']['input'];
  investmentId: Scalars['Int']['input'];
};

export type InvestmentAxysCodeList = {
  __typename?: 'InvestmentAxysCodeList';
  items: Array<InvestmentAxysCode>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InvestmentAxysCodeSort = {
  field: InvestmentAxysCodeSortEnum;
  order: SortInput;
};

export enum InvestmentAxysCodeSortEnum {
  Id = 'id'
}

export type InvestmentBulk = {
  __typename?: 'InvestmentBulk';
  atlasInvestmentId: Scalars['ID']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type InvestmentCalculation = {
  __typename?: 'InvestmentCalculation';
  categoryId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type InvestmentCalculationFilter = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  investmentSetId?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentCalculationList = {
  __typename?: 'InvestmentCalculationList';
  items: Array<InvestmentCalculation>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InvestmentCalculationSort = {
  field: InvestmentCalculationSortEnum;
  order: SortInput;
};

export enum InvestmentCalculationSortEnum {
  Id = 'id',
  Name = 'name'
}

export type InvestmentFdpLogins = {
  __typename?: 'InvestmentFDPLogins';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  fdpLogin: FdpLogin;
  fdpLoginId: Scalars['Int']['output'];
  fdpWebsite?: Maybe<FdpWebsites>;
  fdpWebsiteId?: Maybe<Scalars['Int']['output']>;
  firmFDPLogin: FirmFdpLogins;
  id: Scalars['Int']['output'];
  investment: Investment;
  investmentId: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
};

export type InvestmentFdpLoginsFilter = {
  fdpLoginId?: InputMaybe<Scalars['Int']['input']>;
  fdpWebsiteId?: InputMaybe<Scalars['Int']['input']>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type InvestmentFdpLoginsInput = {
  fdpLoginId?: InputMaybe<Scalars['Int']['input']>;
  fdpWebsiteId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type InvestmentFdpLoginsList = {
  __typename?: 'InvestmentFDPLoginsList';
  items: Array<InvestmentFdpLogins>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InvestmentFdpLoginsSort = {
  field: InvestmentFdpLoginsSortEnum;
  order: SortInput;
};

export enum InvestmentFdpLoginsSortEnum {
  FdpLoginId = 'fdpLoginId',
  InvestmentId = 'investmentId'
}

export type InvestmentFamilyInvestment = {
  __typename?: 'InvestmentFamilyInvestment';
  committedCapital?: Maybe<Scalars['Float']['output']>;
  firmId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  inceptionDate?: Maybe<Scalars['Date']['output']>;
  isEntitled?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  performancePrivate?: Maybe<Array<PerformancePrivate>>;
  shortName?: Maybe<Scalars['String']['output']>;
  targetRaise?: Maybe<Scalars['Float']['output']>;
  vintageYear?: Maybe<Scalars['Int']['output']>;
};


export type InvestmentFamilyInvestmentPerformancePrivateArgs = {
  filter?: InputMaybe<PerformancePrivateFilter>;
  page?: InputMaybe<PageInput>;
  privateQuartileGroupCategoryId?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PerformancePrivateSort>>;
};

export type InvestmentFees = {
  __typename?: 'InvestmentFees';
  abnormalFees?: Maybe<Scalars['Boolean']['output']>;
  abnormalFeesNotes?: Maybe<Scalars['String']['output']>;
  annualReset?: Maybe<Scalars['Boolean']['output']>;
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  feeStructureChanged?: Maybe<Scalars['Boolean']['output']>;
  feeStructureChangedNotes?: Maybe<Scalars['String']['output']>;
  hasMgmtFeeStepDown?: Maybe<Scalars['Boolean']['output']>;
  highWaterMark?: Maybe<Scalars['Boolean']['output']>;
  hurdle?: Maybe<Scalars['Boolean']['output']>;
  hurdleBenchmark?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  incentiveFee?: Maybe<Scalars['Float']['output']>;
  incentiveFeeCalc?: Maybe<FeeCalcEnum>;
  incentiveFeeCalcEnumId?: Maybe<Scalars['Int']['output']>;
  incentiveFeeFreq?: Maybe<FeeFreqEnum>;
  incentiveFeeFreqEnumId?: Maybe<Scalars['Int']['output']>;
  mgmtFee?: Maybe<Scalars['Float']['output']>;
  mgmtFeeCalc?: Maybe<FeeCalcEnum>;
  mgmtFeeCalcEnumId?: Maybe<Scalars['Int']['output']>;
  mgmtFeeFreq?: Maybe<FeeFreqEnum>;
  mgmtFeeFreqEnumId?: Maybe<Scalars['Int']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  otherFee?: Maybe<Scalars['Float']['output']>;
  otherFeeCalc?: Maybe<FeeCalcEnum>;
  otherFeeCalcEnumId?: Maybe<Scalars['Int']['output']>;
  otherFeeFreq?: Maybe<FeeFreqEnum>;
  otherFeeFreqEnumId?: Maybe<Scalars['Int']['output']>;
  peGP?: Maybe<Scalars['Float']['output']>;
  peIncentiveFeeCalc?: Maybe<PeInctFeeCalcEnum>;
  peIncentiveFeeCalcEnumId?: Maybe<Scalars['Int']['output']>;
  peLP?: Maybe<Scalars['Float']['output']>;
  peMgmtFeeCalc?: Maybe<PeMgmtFeeCalcEnum>;
  peMgmtFeeCalcEnumId?: Maybe<Scalars['Int']['output']>;
  peMgmtFeeDuringCommitment?: Maybe<Scalars['Float']['output']>;
  peMgmtFeeDuringCommitmentCalc?: Maybe<PeMgmtFeeCalcEnum>;
  peMgmtFeeDuringCommitmentCalcEnumId?: Maybe<Scalars['Int']['output']>;
  peMgmtFeeDuringHarvest?: Maybe<Scalars['Float']['output']>;
  peMgmtFeeDuringHarvestCalc?: Maybe<PeMgmtFeeCalcEnum>;
  peMgmtFeeDuringHarvestCalcEnumId?: Maybe<Scalars['Int']['output']>;
  peMgmtFeeStepDownCalc?: Maybe<PeMgmtFeeCalcEnum>;
  peMgmtFeeStepDownCalcEnumId?: Maybe<Scalars['Int']['output']>;
  peMgmtFeeStepDownPercent?: Maybe<Scalars['Float']['output']>;
  pePlacementFeesPaid?: Maybe<Scalars['Boolean']['output']>;
  shareClassId: Scalars['Int']['output'];
  standardShareClassRates?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentFeesFilter = {
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  shareClassId?: InputMaybe<Scalars['Int']['input']>;
};

export type InvestmentFeesInput = {
  abnormalFees?: InputMaybe<Scalars['Boolean']['input']>;
  abnormalFeesNotes?: InputMaybe<Scalars['String']['input']>;
  annualReset?: InputMaybe<Scalars['Boolean']['input']>;
  feeStructureChanged?: InputMaybe<Scalars['Boolean']['input']>;
  feeStructureChangedNotes?: InputMaybe<Scalars['String']['input']>;
  hasMgmtFeeStepDown?: InputMaybe<Scalars['Boolean']['input']>;
  highWaterMark?: InputMaybe<Scalars['Boolean']['input']>;
  hurdle?: InputMaybe<Scalars['Boolean']['input']>;
  hurdleBenchmark?: InputMaybe<Scalars['String']['input']>;
  incentiveFee?: InputMaybe<Scalars['Float']['input']>;
  incentiveFeeCalcEnumId?: InputMaybe<Scalars['Int']['input']>;
  incentiveFeeFreqEnumId?: InputMaybe<Scalars['Int']['input']>;
  mgmtFee?: InputMaybe<Scalars['Float']['input']>;
  mgmtFeeCalcEnumId?: InputMaybe<Scalars['Int']['input']>;
  mgmtFeeFreqEnumId?: InputMaybe<Scalars['Int']['input']>;
  otherFee?: InputMaybe<Scalars['Float']['input']>;
  otherFeeCalcEnumId?: InputMaybe<Scalars['Int']['input']>;
  otherFeeFreqEnumId?: InputMaybe<Scalars['Int']['input']>;
  peIncentiveFeeCalcEnumId?: InputMaybe<Scalars['Int']['input']>;
  peMgmtFeeCalcEnumId?: InputMaybe<Scalars['Int']['input']>;
  peMgmtFeeDuringCommitment?: InputMaybe<Scalars['Float']['input']>;
  peMgmtFeeDuringCommitmentCalcEnumId?: InputMaybe<Scalars['Int']['input']>;
  peMgmtFeeDuringHarvest?: InputMaybe<Scalars['Float']['input']>;
  peMgmtFeeDuringHarvestCalcEnumId?: InputMaybe<Scalars['Int']['input']>;
  peMgmtFeeStepDownCalcEnumId?: InputMaybe<Scalars['Int']['input']>;
  peMgmtFeeStepDownPercent?: InputMaybe<Scalars['Float']['input']>;
  standardShareClassRates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvestmentFeesList = {
  __typename?: 'InvestmentFeesList';
  items: Array<InvestmentFees>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InvestmentFeesSort = {
  field: InvestmentFeesSortEnum;
  order: SortInput;
};

export enum InvestmentFeesSortEnum {
  Id = 'id'
}

export type InvestmentFields = {
  __typename?: 'InvestmentFields';
  investmentAum?: Maybe<InvestmentAum>;
  investmentId: Scalars['ID']['output'];
  investmentImpactAgricultureGoodsConsumerProducts?: Maybe<InvestmentImpactAgricultureGoodsConsumerProducts>;
  investmentImpactAgricultureGoodsFoodAccess?: Maybe<InvestmentImpactAgricultureGoodsFoodAccess>;
  investmentImpactAgricultureGoodsFoodtech?: Maybe<InvestmentImpactAgricultureGoodsFoodtech>;
  investmentImpactAgricultureGoodsSustainableAgriculture?: Maybe<InvestmentImpactAgricultureGoodsSustainableAgriculture>;
  investmentImpactBusinessQualityGovernanceBoardComposition?: Maybe<InvestmentImpactBusinessQualityGovernanceBoardComposition>;
  investmentImpactBusinessQualityGovernanceCorporateGovernance?: Maybe<InvestmentImpactBusinessQualityGovernanceCorporateGovernance>;
  investmentImpactBusinessQualityGovernanceCorporateSocialResponsibility?: Maybe<InvestmentImpactBusinessQualityGovernanceCorporateSocialResponsibility>;
  investmentImpactBusinessQualityGovernanceFairTrade?: Maybe<InvestmentImpactBusinessQualityGovernanceFairTrade>;
  investmentImpactBusinessQualityGovernanceHumanCapitalManagement?: Maybe<InvestmentImpactBusinessQualityGovernanceHumanCapitalManagement>;
  investmentImpactBusinessQualityGovernanceSupplyChainManagement?: Maybe<InvestmentImpactBusinessQualityGovernanceSupplyChainManagement>;
  investmentImpactCommunityCitiesCommunityDevelopment?: Maybe<InvestmentImpactCommunityCitiesCommunityDevelopment>;
  investmentImpactCommunityCitiesHousing?: Maybe<InvestmentImpactCommunityCitiesHousing>;
  investmentImpactCommunityCitiesInfrastructure?: Maybe<InvestmentImpactCommunityCitiesInfrastructure>;
  investmentImpactCommunityCitiesTransportation?: Maybe<InvestmentImpactCommunityCitiesTransportation>;
  investmentImpactCommunityCitiesWasteManagementRecycling?: Maybe<InvestmentImpactCommunityCitiesWasteManagementRecycling>;
  investmentImpactCommunityCitiesWorkforceDevelopment?: Maybe<InvestmentImpactCommunityCitiesWorkforceDevelopment>;
  investmentImpactDiversityEmpowermentImmigrantsRefugees?: Maybe<InvestmentImpactDiversityEmpowermentImmigrantsRefugees>;
  investmentImpactDiversityEmpowermentUnderrepresentedMinorities?: Maybe<InvestmentImpactDiversityEmpowermentUnderrepresentedMinorities>;
  investmentImpactDiversityEmpowermentUnderservedCommunities?: Maybe<InvestmentImpactDiversityEmpowermentUnderservedCommunities>;
  investmentImpactDiversityEmpowermentWomenGirls?: Maybe<InvestmentImpactDiversityEmpowermentWomenGirls>;
  investmentImpactEducationWellnessEducation?: Maybe<InvestmentImpactEducationWellnessEducation>;
  investmentImpactEducationWellnessHealth?: Maybe<InvestmentImpactEducationWellnessHealth>;
  investmentImpactEducationWellnessInformationAccess?: Maybe<InvestmentImpactEducationWellnessInformationAccess>;
  investmentImpactEnergyProductionTechnologyEnergyEfficiency?: Maybe<InvestmentImpactEnergyProductionTechnologyEnergyEfficiency>;
  investmentImpactEnergyProductionTechnologyGeothermal?: Maybe<InvestmentImpactEnergyProductionTechnologyGeothermal>;
  investmentImpactEnergyProductionTechnologyGreenTech?: Maybe<InvestmentImpactEnergyProductionTechnologyGreenTech>;
  investmentImpactEnergyProductionTechnologyRecycling?: Maybe<InvestmentImpactEnergyProductionTechnologyRecycling>;
  investmentImpactEnergyProductionTechnologySolar?: Maybe<InvestmentImpactEnergyProductionTechnologySolar>;
  investmentImpactEnergyProductionTechnologyWind?: Maybe<InvestmentImpactEnergyProductionTechnologyWind>;
  investmentImpactEnvironmentNaturalResourceCarbon?: Maybe<InvestmentImpactEnvironmentNaturalResourceCarbon>;
  investmentImpactEnvironmentNaturalResourceConservation?: Maybe<InvestmentImpactEnvironmentNaturalResourceConservation>;
  investmentImpactEnvironmentNaturalResourceLandUsage?: Maybe<InvestmentImpactEnvironmentNaturalResourceLandUsage>;
  investmentImpactEnvironmentNaturalResourceWasteManagement?: Maybe<InvestmentImpactEnvironmentNaturalResourceWasteManagement>;
  investmentImpactEnvironmentNaturalResourceWater?: Maybe<InvestmentImpactEnvironmentNaturalResourceWater>;
  investmentImpactExclusionsAdultEntertainment?: Maybe<InvestmentImpactExclusionsAdultEntertainment>;
  investmentImpactExclusionsAlcohol?: Maybe<InvestmentImpactExclusionsAlcohol>;
  investmentImpactExclusionsCoal?: Maybe<InvestmentImpactExclusionsCoal>;
  investmentImpactExclusionsDefense?: Maybe<InvestmentImpactExclusionsDefense>;
  investmentImpactExclusionsGambling?: Maybe<InvestmentImpactExclusionsGambling>;
  investmentImpactExclusionsOil?: Maybe<InvestmentImpactExclusionsOil>;
  investmentImpactExclusionsTobacco?: Maybe<InvestmentImpactExclusionsTobacco>;
  investmentImpactExclusionsWeapons?: Maybe<InvestmentImpactExclusionsWeapons>;
  investmentImpactFinanceAccessFintech?: Maybe<InvestmentImpactFinanceAccessFintech>;
  investmentImpactFinanceAccessMicrofinancing?: Maybe<InvestmentImpactFinanceAccessMicrofinancing>;
  investmentImpactFinanceAccessMicroinsurance?: Maybe<InvestmentImpactFinanceAccessMicroinsurance>;
  investmentImpactFinanceAccessSmeBizdev?: Maybe<InvestmentImpactFinanceAccessSmeBizdev>;
  investmentOrEnvironmentOpportunitySet?: Maybe<InvestmentOrEnvironmentOpportunitySet>;
  investmentOrExposuresPortfolioActivity?: Maybe<InvestmentOrExposuresPortfolioActivity>;
  investmentOrFactSheet?: Maybe<InvestmentOrFactSheet>;
  investmentOrFirmAndTeamChanges?: Maybe<InvestmentOrFirmAndTeamChanges>;
  investmentOrFirmUpdate?: Maybe<InvestmentOrFirmUpdate>;
  investmentOrHeadlines?: Maybe<InvestmentOrHeadlines>;
  investmentOrLongTermPerformanceAttribution?: Maybe<InvestmentOrLongTermPerformanceAttribution>;
  investmentOrPerformanceAttribution?: Maybe<InvestmentOrPerformanceAttribution>;
  investmentOrThingsToMonitor?: Maybe<InvestmentOrThingsToMonitor>;
  investmentStrategyAum?: Maybe<InvestmentStrategyAum>;
  state?: Maybe<Scalars['String']['output']>;
  values: Array<FieldValue>;
};

export type InvestmentFieldsInput = {
  investmentOrEnvironmentOpportunitySet?: InputMaybe<InvestmentOrEnvironmentOpportunitySetInput>;
  investmentOrExposuresPortfolioActivity?: InputMaybe<InvestmentOrExposuresPortfolioActivityInput>;
  investmentOrFactSheet?: InputMaybe<InvestmentOrFactSheetInput>;
  investmentOrFirmAndTeamChanges?: InputMaybe<InvestmentOrFirmAndTeamChangesInput>;
  investmentOrFirmUpdate?: InputMaybe<InvestmentOrFirmUpdateInput>;
  investmentOrHeadlines?: InputMaybe<InvestmentOrHeadlinesInput>;
  investmentOrLongTermPerformanceAttribution?: InputMaybe<InvestmentOrLongTermPerformanceAttributionInput>;
  investmentOrPerformanceAttribution?: InputMaybe<InvestmentOrPerformanceAttributionInput>;
  investmentOrThingsToMonitor?: InputMaybe<InvestmentOrThingsToMonitorInput>;
};

export type InvestmentFilterInput = {
  HFRIInvestmentId?: InputMaybe<Scalars['Int']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  burgissId?: InputMaybe<Scalars['UUID']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  evestmentId?: InputMaybe<Scalars['Int']['input']>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  firmIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  peFundNumberIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  portfolioFilters?: InputMaybe<RcgPortfolioFilters>;
  q?: InputMaybe<Scalars['String']['input']>;
  strategy?: InputMaybe<InvestmentStrategyFilterInput>;
};

export type InvestmentFirmEmployment = {
  __typename?: 'InvestmentFirmEmployment';
  employeeRole?: Maybe<EmployeeRoleEnum>;
  employeeRoleEnumId?: Maybe<Scalars['Int']['output']>;
  faceOfInvestment?: Maybe<Scalars['Boolean']['output']>;
  firmEmployment?: Maybe<FirmEmployment>;
  firmEmploymentId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  investment?: Maybe<Investment>;
  investmentId: Scalars['Int']['output'];
  leftDate?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type InvestmentFirmEmploymentFilterInput = {
  employeeRoleId?: InputMaybe<Scalars['Int']['input']>;
  firmEmploymentId?: InputMaybe<Scalars['Int']['input']>;
  fundEmployeeRoleId?: InputMaybe<Scalars['Int']['input']>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  personId?: InputMaybe<Scalars['Int']['input']>;
};

export type InvestmentFirmEmploymentFilters = {
  atlasInvestmentId?: InputMaybe<Scalars['String']['input']>;
  employeeRole?: InputMaybe<Scalars['String']['input']>;
  fundEmployeeRoleId?: InputMaybe<Scalars['Int']['input']>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvestmentFirmEmploymentInput = {
  employeeRoleEnumId?: InputMaybe<Scalars['Int']['input']>;
  faceOfInvestment?: InputMaybe<Scalars['Boolean']['input']>;
  firmEmploymentId?: InputMaybe<Scalars['Int']['input']>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  leftDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type InvestmentFirmEmploymentList = {
  __typename?: 'InvestmentFirmEmploymentList';
  items: Array<InvestmentFirmEmployment>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InvestmentFirmEmploymentRoleEnum = {
  __typename?: 'InvestmentFirmEmploymentRoleEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type InvestmentFirmEmploymentRoleEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentFirmEmploymentRoleEnumList = {
  __typename?: 'InvestmentFirmEmploymentRoleEnumList';
  items: Array<InvestmentFirmEmploymentRoleEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InvestmentFirmEmploymentRoleEnumSort = {
  field: InvestmentFirmEmploymentRoleEnumSortEnum;
  order: SortInput;
};

export enum InvestmentFirmEmploymentRoleEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type InvestmentFirmEmploymentSort = {
  field: InvestmentFirmEmploymentSortEnum;
  order: SortInput;
};

export enum InvestmentFirmEmploymentSortEnum {
  EmployeeRole = 'employeeRole',
  FirmEmploymentDefault = 'firmEmploymentDefault',
  Id = 'id',
  InvestmentDefault = 'investmentDefault'
}

export type InvestmentIdOrIsKeyPersonnel = {
  investmentId: Scalars['Int']['input'];
};

export type InvestmentIdToRefresh = {
  __typename?: 'InvestmentIdToRefresh';
  id: Scalars['Int']['output'];
  investment?: Maybe<Investment>;
};

export type InvestmentImpactAgricultureGoodsConsumerProducts = {
  __typename?: 'InvestmentImpactAgricultureGoodsConsumerProducts';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactAgricultureGoodsFoodAccess = {
  __typename?: 'InvestmentImpactAgricultureGoodsFoodAccess';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactAgricultureGoodsFoodtech = {
  __typename?: 'InvestmentImpactAgricultureGoodsFoodtech';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactAgricultureGoodsSustainableAgriculture = {
  __typename?: 'InvestmentImpactAgricultureGoodsSustainableAgriculture';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactBusinessQualityGovernanceBoardComposition = {
  __typename?: 'InvestmentImpactBusinessQualityGovernanceBoardComposition';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactBusinessQualityGovernanceCorporateGovernance = {
  __typename?: 'InvestmentImpactBusinessQualityGovernanceCorporateGovernance';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactBusinessQualityGovernanceCorporateSocialResponsibility = {
  __typename?: 'InvestmentImpactBusinessQualityGovernanceCorporateSocialResponsibility';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactBusinessQualityGovernanceFairTrade = {
  __typename?: 'InvestmentImpactBusinessQualityGovernanceFairTrade';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactBusinessQualityGovernanceHumanCapitalManagement = {
  __typename?: 'InvestmentImpactBusinessQualityGovernanceHumanCapitalManagement';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactBusinessQualityGovernanceSupplyChainManagement = {
  __typename?: 'InvestmentImpactBusinessQualityGovernanceSupplyChainManagement';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactCommunityCitiesCommunityDevelopment = {
  __typename?: 'InvestmentImpactCommunityCitiesCommunityDevelopment';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactCommunityCitiesHousing = {
  __typename?: 'InvestmentImpactCommunityCitiesHousing';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactCommunityCitiesInfrastructure = {
  __typename?: 'InvestmentImpactCommunityCitiesInfrastructure';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactCommunityCitiesTransportation = {
  __typename?: 'InvestmentImpactCommunityCitiesTransportation';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactCommunityCitiesWasteManagementRecycling = {
  __typename?: 'InvestmentImpactCommunityCitiesWasteManagementRecycling';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactCommunityCitiesWorkforceDevelopment = {
  __typename?: 'InvestmentImpactCommunityCitiesWorkforceDevelopment';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactDiversityEmpowermentImmigrantsRefugees = {
  __typename?: 'InvestmentImpactDiversityEmpowermentImmigrantsRefugees';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactDiversityEmpowermentUnderrepresentedMinorities = {
  __typename?: 'InvestmentImpactDiversityEmpowermentUnderrepresentedMinorities';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactDiversityEmpowermentUnderservedCommunities = {
  __typename?: 'InvestmentImpactDiversityEmpowermentUnderservedCommunities';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactDiversityEmpowermentWomenGirls = {
  __typename?: 'InvestmentImpactDiversityEmpowermentWomenGirls';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactEducationWellnessEducation = {
  __typename?: 'InvestmentImpactEducationWellnessEducation';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactEducationWellnessHealth = {
  __typename?: 'InvestmentImpactEducationWellnessHealth';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactEducationWellnessInformationAccess = {
  __typename?: 'InvestmentImpactEducationWellnessInformationAccess';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactEnergyProductionTechnologyEnergyEfficiency = {
  __typename?: 'InvestmentImpactEnergyProductionTechnologyEnergyEfficiency';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactEnergyProductionTechnologyGeothermal = {
  __typename?: 'InvestmentImpactEnergyProductionTechnologyGeothermal';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactEnergyProductionTechnologyGreenTech = {
  __typename?: 'InvestmentImpactEnergyProductionTechnologyGreenTech';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactEnergyProductionTechnologyRecycling = {
  __typename?: 'InvestmentImpactEnergyProductionTechnologyRecycling';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactEnergyProductionTechnologySolar = {
  __typename?: 'InvestmentImpactEnergyProductionTechnologySolar';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactEnergyProductionTechnologyWind = {
  __typename?: 'InvestmentImpactEnergyProductionTechnologyWind';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactEnvironmentNaturalResourceCarbon = {
  __typename?: 'InvestmentImpactEnvironmentNaturalResourceCarbon';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactEnvironmentNaturalResourceConservation = {
  __typename?: 'InvestmentImpactEnvironmentNaturalResourceConservation';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactEnvironmentNaturalResourceLandUsage = {
  __typename?: 'InvestmentImpactEnvironmentNaturalResourceLandUsage';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactEnvironmentNaturalResourceWasteManagement = {
  __typename?: 'InvestmentImpactEnvironmentNaturalResourceWasteManagement';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactEnvironmentNaturalResourceWater = {
  __typename?: 'InvestmentImpactEnvironmentNaturalResourceWater';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactExclusionsAdultEntertainment = {
  __typename?: 'InvestmentImpactExclusionsAdultEntertainment';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactExclusionsAlcohol = {
  __typename?: 'InvestmentImpactExclusionsAlcohol';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactExclusionsCoal = {
  __typename?: 'InvestmentImpactExclusionsCoal';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactExclusionsDefense = {
  __typename?: 'InvestmentImpactExclusionsDefense';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactExclusionsGambling = {
  __typename?: 'InvestmentImpactExclusionsGambling';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactExclusionsOil = {
  __typename?: 'InvestmentImpactExclusionsOil';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactExclusionsTobacco = {
  __typename?: 'InvestmentImpactExclusionsTobacco';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactExclusionsWeapons = {
  __typename?: 'InvestmentImpactExclusionsWeapons';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactFinanceAccessFintech = {
  __typename?: 'InvestmentImpactFinanceAccessFintech';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactFinanceAccessMicrofinancing = {
  __typename?: 'InvestmentImpactFinanceAccessMicrofinancing';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactFinanceAccessMicroinsurance = {
  __typename?: 'InvestmentImpactFinanceAccessMicroinsurance';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactFinanceAccessSmeBizdev = {
  __typename?: 'InvestmentImpactFinanceAccessSmeBizdev';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentInput = {
  HFRIInvestmentId?: InputMaybe<Scalars['Int']['input']>;
  NAVClassificationEnumId?: InputMaybe<Scalars['Int']['input']>;
  RICId?: InputMaybe<Scalars['String']['input']>;
  accountTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  accountingIsCommodityFuture?: InputMaybe<Scalars['Boolean']['input']>;
  advisorId?: InputMaybe<Scalars['Int']['input']>;
  advisorTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  alphaVantageTicker?: InputMaybe<Scalars['String']['input']>;
  assetClassEnumId?: InputMaybe<Scalars['Int']['input']>;
  atlasInvestmentId?: InputMaybe<Scalars['ID']['input']>;
  bloombergCode?: InputMaybe<Scalars['String']['input']>;
  bloombergField?: InputMaybe<Scalars['String']['input']>;
  burgissId?: InputMaybe<Scalars['UUID']['input']>;
  committedCapital?: InputMaybe<Scalars['Float']['input']>;
  committedCapitalCurrencyId?: InputMaybe<Scalars['Int']['input']>;
  createDate?: InputMaybe<Scalars['DateTime']['input']>;
  createUser?: InputMaybe<Scalars['String']['input']>;
  currencyDenominationEnumId?: InputMaybe<Scalars['Int']['input']>;
  /** used to save LLM Profile Builder source documents to investment. */
  documents?: InputMaybe<Array<DocumentInput>>;
  domicileCountryId?: InputMaybe<Scalars['Int']['input']>;
  domicileFundLinkId?: InputMaybe<Scalars['Int']['input']>;
  domicileUSStateId?: InputMaybe<Scalars['Int']['input']>;
  evestmentId?: InputMaybe<Scalars['Int']['input']>;
  extensionPeriodYrs?: InputMaybe<Scalars['Int']['input']>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  fiscalYearEndMonth?: InputMaybe<Scalars['Int']['input']>;
  fundLinkId?: InputMaybe<Scalars['Int']['input']>;
  gpCommitted?: InputMaybe<Scalars['Float']['input']>;
  gpCommittedCurrencyId?: InputMaybe<Scalars['Int']['input']>;
  hardCap?: InputMaybe<Scalars['Float']['input']>;
  harvestPeriodYrs?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  impactTags?: InputMaybe<Array<Scalars['Int']['input']>>;
  inceptionDate?: InputMaybe<Scalars['Date']['input']>;
  indexCalcTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  investmentGroupId?: InputMaybe<Scalars['Int']['input']>;
  investmentPeriodYrs?: InputMaybe<Scalars['Int']['input']>;
  investmentStructureEnumId?: InputMaybe<Scalars['Int']['input']>;
  investmentTags?: InputMaybe<Array<TagsInput>>;
  isESG?: InputMaybe<Scalars['Boolean']['input']>;
  isImpact?: InputMaybe<Scalars['Boolean']['input']>;
  isLiquidated?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerUnwillingToProvideAUM?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerUnwillingToProvidePerformance?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerUnwillingToProvidePositions?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerUnwillingToProvideRisk?: InputMaybe<Scalars['Boolean']['input']>;
  isOffshore?: InputMaybe<Scalars['Boolean']['input']>;
  isPartner?: InputMaybe<Scalars['Boolean']['input']>;
  isRegisteredInvestmentCompany?: InputMaybe<Scalars['Boolean']['input']>;
  isSubAdvised?: InputMaybe<Scalars['Boolean']['input']>;
  isWorkInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  legalStructureEnumId?: InputMaybe<Scalars['Int']['input']>;
  liquidationDate?: InputMaybe<Scalars['Date']['input']>;
  liquidationNote?: InputMaybe<Scalars['String']['input']>;
  listEnumId?: InputMaybe<Scalars['Int']['input']>;
  marketEnumId?: InputMaybe<Scalars['Int']['input']>;
  maxExpectedVolatility?: InputMaybe<Scalars['Float']['input']>;
  maxGrossExposure?: InputMaybe<Scalars['Float']['input']>;
  maxNetExposure?: InputMaybe<Scalars['Float']['input']>;
  maxTargetNetIRR?: InputMaybe<Scalars['Float']['input']>;
  maxTargetNetMOIC?: InputMaybe<Scalars['Float']['input']>;
  minExpectedVolatility?: InputMaybe<Scalars['Float']['input']>;
  minGrossExposure?: InputMaybe<Scalars['Float']['input']>;
  minNetExposure?: InputMaybe<Scalars['Float']['input']>;
  minTargetNetIRR?: InputMaybe<Scalars['Float']['input']>;
  minTargetNetMOIC?: InputMaybe<Scalars['Float']['input']>;
  modifyDate?: InputMaybe<Scalars['DateTime']['input']>;
  modifyUser?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ndaSigned?: InputMaybe<Scalars['Boolean']['input']>;
  organizationStructureEnumId?: InputMaybe<Scalars['Int']['input']>;
  otherGeographicFocusIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  peFundNumberEnumId?: InputMaybe<Scalars['Int']['input']>;
  peLegalLifeYrs?: InputMaybe<Scalars['Int']['input']>;
  peStrategyEnumId?: InputMaybe<Scalars['Int']['input']>;
  peSubStrategyEnumId?: InputMaybe<Scalars['Int']['input']>;
  peerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  performanceSourceEnumId?: InputMaybe<Scalars['Int']['input']>;
  pricingFrequencyEnumId?: InputMaybe<Scalars['Int']['input']>;
  primaryAssignment?: InputMaybe<Scalars['String']['input']>;
  primaryBenchmarkId?: InputMaybe<Scalars['Int']['input']>;
  primaryGeographicFocusId?: InputMaybe<Scalars['Int']['input']>;
  reportingDate?: InputMaybe<Scalars['Date']['input']>;
  reportingDateReason?: InputMaybe<Scalars['String']['input']>;
  reportingLinkId?: InputMaybe<Scalars['Int']['input']>;
  secondaryAssignment?: InputMaybe<Scalars['String']['input']>;
  secondaryBenchmarkId?: InputMaybe<Scalars['Int']['input']>;
  shareClassNote?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  strategyEnumId?: InputMaybe<Scalars['Int']['input']>;
  subStrategyEnumId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  targetRaise?: InputMaybe<Scalars['Float']['input']>;
  vehicleTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  vintageYear?: InputMaybe<Scalars['Int']['input']>;
};

export type InvestmentInstitutions = {
  __typename?: 'InvestmentInstitutions';
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  deleteUser?: Maybe<Scalars['String']['output']>;
  /** End date of engagement with service provider. */
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  institution: Institution;
  institutionId: Scalars['Int']['output'];
  institutionInstitutionTypeEnumId: Scalars['Int']['output'];
  institutionsInstitutionTypeEnumList: InstitutionsInstitutionTypeEnumList;
  investment: Investment;
  investmentId: Scalars['Int']['output'];
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  officeLocationServiceType: InstitutionsInstitutionTypeEnum;
  /** Start date of engagement with service provider. */
  startDate?: Maybe<Scalars['Date']['output']>;
};


export type InvestmentInstitutionsInstitutionsInstitutionTypeEnumListArgs = {
  filter?: InputMaybe<InstitutionsInstitutionTypeEnumFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InstitutionsInstitutionTypeEnumSort>>;
};

export type InvestmentInstitutionsFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  institutionId?: InputMaybe<Scalars['Int']['input']>;
  institutionTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentInstitutionsInput = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  institutionId?: InputMaybe<Scalars['Int']['input']>;
  institutionInstitutionTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type InvestmentInstitutionsList = {
  __typename?: 'InvestmentInstitutionsList';
  items: Array<InvestmentInstitutions>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InvestmentInstitutionsSort = {
  field: InvestmentInstitutionsSortEnum;
  order: SortInput;
};

export enum InvestmentInstitutionsSortEnum {
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type InvestmentList = {
  __typename?: 'InvestmentList';
  items: Array<Investment>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InvestmentListEnum = {
  __typename?: 'InvestmentListEnum';
  count?: Maybe<Scalars['Int']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type InvestmentListEnumFilter = {
  availableOnCreation?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type InvestmentListEnumList = {
  __typename?: 'InvestmentListEnumList';
  items: Array<InvestmentListEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InvestmentListEnumSort = {
  field: InvestmentListEnumSortEnum;
  order: SortInput;
};

export enum InvestmentListEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type InvestmentMatchResult = {
  __typename?: 'InvestmentMatchResult';
  firmName?: Maybe<Scalars['String']['output']>;
  fuzzyScore: Scalars['Float']['output'];
  investmentId: Scalars['Int']['output'];
  investmentName: Scalars['String']['output'];
};

export enum InvestmentMatchStatus {
  Matched = 'MATCHED',
  NotFound = 'NOT_FOUND',
  NoAccess = 'NO_ACCESS'
}

export type InvestmentNoteUsers = {
  __typename?: 'InvestmentNoteUsers';
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type InvestmentNoteUsersFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentNoteUsersList = {
  __typename?: 'InvestmentNoteUsersList';
  items: Array<InvestmentNoteUsers>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InvestmentNoteUsersSort = {
  field: InvestmentNoteUsersSortEnum;
  order: SortInput;
};

export enum InvestmentNoteUsersSortEnum {
  CreateUser = 'createUser',
  Id = 'id'
}

export type InvestmentOrEnvironmentOpportunitySet = {
  __typename?: 'InvestmentOrEnvironmentOpportunitySet';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type InvestmentOrEnvironmentOpportunitySetInput = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  citations?: InputMaybe<Array<CitationInput>>;
  createDate: Scalars['DateTime']['input'];
  createUser: Scalars['String']['input'];
  deleteDate?: InputMaybe<Scalars['DateTime']['input']>;
  documentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Used for reading, not for writing. */
  documents?: InputMaybe<Array<FieldDocumentInput>>;
  fieldKey: Scalars['String']['input'];
  id: Scalars['String']['input'];
  modifyDate: Scalars['DateTime']['input'];
  modifyUser: Scalars['String']['input'];
  notApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId: Scalars['Int']['input'];
  ownerType: Scalars['String']['input'];
  periodType?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentOrExposuresPortfolioActivity = {
  __typename?: 'InvestmentOrExposuresPortfolioActivity';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type InvestmentOrExposuresPortfolioActivityInput = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  citations?: InputMaybe<Array<CitationInput>>;
  createDate: Scalars['DateTime']['input'];
  createUser: Scalars['String']['input'];
  deleteDate?: InputMaybe<Scalars['DateTime']['input']>;
  documentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Used for reading, not for writing. */
  documents?: InputMaybe<Array<FieldDocumentInput>>;
  fieldKey: Scalars['String']['input'];
  id: Scalars['String']['input'];
  modifyDate: Scalars['DateTime']['input'];
  modifyUser: Scalars['String']['input'];
  notApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId: Scalars['Int']['input'];
  ownerType: Scalars['String']['input'];
  periodType?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentOrFactSheet = {
  __typename?: 'InvestmentOrFactSheet';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type InvestmentOrFactSheetInput = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  citations?: InputMaybe<Array<CitationInput>>;
  createDate: Scalars['DateTime']['input'];
  createUser: Scalars['String']['input'];
  deleteDate?: InputMaybe<Scalars['DateTime']['input']>;
  documentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Used for reading, not for writing. */
  documents?: InputMaybe<Array<FieldDocumentInput>>;
  fieldKey: Scalars['String']['input'];
  id: Scalars['String']['input'];
  modifyDate: Scalars['DateTime']['input'];
  modifyUser: Scalars['String']['input'];
  notApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId: Scalars['Int']['input'];
  ownerType: Scalars['String']['input'];
  periodType?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentOrFirmAndTeamChanges = {
  __typename?: 'InvestmentOrFirmAndTeamChanges';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type InvestmentOrFirmAndTeamChangesInput = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  citations?: InputMaybe<Array<CitationInput>>;
  createDate: Scalars['DateTime']['input'];
  createUser: Scalars['String']['input'];
  deleteDate?: InputMaybe<Scalars['DateTime']['input']>;
  documentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Used for reading, not for writing. */
  documents?: InputMaybe<Array<FieldDocumentInput>>;
  fieldKey: Scalars['String']['input'];
  id: Scalars['String']['input'];
  modifyDate: Scalars['DateTime']['input'];
  modifyUser: Scalars['String']['input'];
  notApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId: Scalars['Int']['input'];
  ownerType: Scalars['String']['input'];
  periodType?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentOrFirmUpdate = {
  __typename?: 'InvestmentOrFirmUpdate';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type InvestmentOrFirmUpdateInput = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  citations?: InputMaybe<Array<CitationInput>>;
  createDate: Scalars['DateTime']['input'];
  createUser: Scalars['String']['input'];
  deleteDate?: InputMaybe<Scalars['DateTime']['input']>;
  documentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Used for reading, not for writing. */
  documents?: InputMaybe<Array<FieldDocumentInput>>;
  fieldKey: Scalars['String']['input'];
  id: Scalars['String']['input'];
  modifyDate: Scalars['DateTime']['input'];
  modifyUser: Scalars['String']['input'];
  notApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId: Scalars['Int']['input'];
  ownerType: Scalars['String']['input'];
  periodType?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentOrHeadlines = {
  __typename?: 'InvestmentOrHeadlines';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type InvestmentOrHeadlinesInput = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  citations?: InputMaybe<Array<CitationInput>>;
  createDate: Scalars['DateTime']['input'];
  createUser: Scalars['String']['input'];
  deleteDate?: InputMaybe<Scalars['DateTime']['input']>;
  documentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Used for reading, not for writing. */
  documents?: InputMaybe<Array<FieldDocumentInput>>;
  fieldKey: Scalars['String']['input'];
  id: Scalars['String']['input'];
  modifyDate: Scalars['DateTime']['input'];
  modifyUser: Scalars['String']['input'];
  notApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId: Scalars['Int']['input'];
  ownerType: Scalars['String']['input'];
  periodType?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentOrLongTermPerformanceAttribution = {
  __typename?: 'InvestmentOrLongTermPerformanceAttribution';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type InvestmentOrLongTermPerformanceAttributionInput = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  citations?: InputMaybe<Array<CitationInput>>;
  createDate: Scalars['DateTime']['input'];
  createUser: Scalars['String']['input'];
  deleteDate?: InputMaybe<Scalars['DateTime']['input']>;
  documentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Used for reading, not for writing. */
  documents?: InputMaybe<Array<FieldDocumentInput>>;
  fieldKey: Scalars['String']['input'];
  id: Scalars['String']['input'];
  modifyDate: Scalars['DateTime']['input'];
  modifyUser: Scalars['String']['input'];
  notApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId: Scalars['Int']['input'];
  ownerType: Scalars['String']['input'];
  periodType?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentOrPerformanceAttribution = {
  __typename?: 'InvestmentOrPerformanceAttribution';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type InvestmentOrPerformanceAttributionInput = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  citations?: InputMaybe<Array<CitationInput>>;
  createDate: Scalars['DateTime']['input'];
  createUser: Scalars['String']['input'];
  deleteDate?: InputMaybe<Scalars['DateTime']['input']>;
  documentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Used for reading, not for writing. */
  documents?: InputMaybe<Array<FieldDocumentInput>>;
  fieldKey: Scalars['String']['input'];
  id: Scalars['String']['input'];
  modifyDate: Scalars['DateTime']['input'];
  modifyUser: Scalars['String']['input'];
  notApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId: Scalars['Int']['input'];
  ownerType: Scalars['String']['input'];
  periodType?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentOrThingsToMonitor = {
  __typename?: 'InvestmentOrThingsToMonitor';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type InvestmentOrThingsToMonitorInput = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  citations?: InputMaybe<Array<CitationInput>>;
  createDate: Scalars['DateTime']['input'];
  createUser: Scalars['String']['input'];
  deleteDate?: InputMaybe<Scalars['DateTime']['input']>;
  documentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Used for reading, not for writing. */
  documents?: InputMaybe<Array<FieldDocumentInput>>;
  fieldKey: Scalars['String']['input'];
  id: Scalars['String']['input'];
  modifyDate: Scalars['DateTime']['input'];
  modifyUser: Scalars['String']['input'];
  notApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId: Scalars['Int']['input'];
  ownerType: Scalars['String']['input'];
  periodType?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentPeersFilterInput = {
  excludeSelf?: InputMaybe<Scalars['Boolean']['input']>;
  investmentFilter?: InputMaybe<InvestmentFilterInput>;
};

export type InvestmentPrivateQuartileGroupCategory = {
  __typename?: 'InvestmentPrivateQuartileGroupCategory';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  investment?: Maybe<Investment>;
  investmentId: Scalars['Int']['output'];
  isDefault: Scalars['Boolean']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  privateQuartileGroupCategory?: Maybe<PrivateQuartileGroupCategory>;
  privateQuartileGroupCategoryId: Scalars['Int']['output'];
};

export type InvestmentPrivateQuartileGroupCategoryFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDerived?: InputMaybe<Scalars['Boolean']['input']>;
  privateQuartileGroupCategoryId?: InputMaybe<Scalars['Int']['input']>;
};

export type InvestmentPrivateQuartileGroupCategoryInput = {
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  privateQuartileGroupCategoryId?: InputMaybe<Scalars['Int']['input']>;
};

export type InvestmentPrivateQuartileGroupCategoryList = {
  __typename?: 'InvestmentPrivateQuartileGroupCategoryList';
  items: Array<InvestmentPrivateQuartileGroupCategory>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InvestmentPrivateQuartileGroupCategorySort = {
  field: InvestmentPrivateQuartileGroupCategorySortEnum;
  order: SortInput;
};

export enum InvestmentPrivateQuartileGroupCategorySortEnum {
  Id = 'id',
  Rank = 'rank'
}

export type InvestmentRegulators = {
  __typename?: 'InvestmentRegulators';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inspectionDate?: Maybe<Scalars['Date']['output']>;
  investment: Investment;
  investmentId: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  registrationDate?: Maybe<Scalars['Date']['output']>;
  registrationNum?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Scalars['String']['output']>;
};

export type InvestmentRegulatorsFilterInput = {
  investmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type InvestmentRegulatorsList = {
  __typename?: 'InvestmentRegulatorsList';
  items: Array<InvestmentRegulators>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InvestmentRegulatorsSort = {
  field: InvestmentRegulatorsSortEnum;
  order: SortInput;
};

export enum InvestmentRegulatorsSortEnum {
  Name = 'name'
}

export type InvestmentRiskCategoryFilter = {
  level: Scalars['Int']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentRiskCategorySort = {
  field: InvestmentRiskCategorySortEnum;
  order: SortInput;
};

export enum InvestmentRiskCategorySortEnum {
  Id = 'id',
  Name = 'name'
}

export type InvestmentRiskInvestmentFilter = {
  q?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentRiskInvestmentSort = {
  field: InvestmentRiskInvestmentSortEnum;
  order: SortInput;
};

export enum InvestmentRiskInvestmentSortEnum {
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type InvestmentSearchFilters = {
  ACCESS?: InputMaybe<EntityAccessSearchFilter>;
  ASSET_CLASS_STRATEGY?: InputMaybe<AssetClassStrategyFilter>;
  COMPLETENESS?: InputMaybe<CompletenessSearchFilter>;
  DYNAMIC_LIST?: InputMaybe<DynamicListFilter>;
  FIRM_ENTITY?: InputMaybe<EntitySearchFilter>;
  FUZZY_TERM?: InputMaybe<QuerySearchFilter>;
  IMPACT?: InputMaybe<ImpactSearchFilter>;
  INACTIVE?: InputMaybe<InactiveInvestmentFilter>;
  INCEPTION_DATE?: InputMaybe<DateRangeFilter>;
  INVESTMENT_ENTITY?: InputMaybe<EntitySearchFilter>;
  INVESTMENT_LIST?: InputMaybe<EntitySearchFilter>;
  INVESTMENT_SET?: InputMaybe<InvestmentSetSearchFilter>;
  PERFORMANCE?: InputMaybe<PerformanceSearchFilter>;
  PERFORMANCE_PRIVATE?: InputMaybe<PerformancePrivateSearchFilter>;
  PORTFOLIO?: InputMaybe<PortfolioSearchFilter>;
  POSITIONS?: InputMaybe<PositionsSearchFilter>;
  PRIMARY_GEOGRAPHY?: InputMaybe<EntitySearchFilter>;
  SEARCH_TERM?: InputMaybe<QuerySearchFilter>;
  SET?: InputMaybe<SetSearchFilter>;
  SHARED_CONTENT?: InputMaybe<SharedContentFilter>;
  SIZE?: InputMaybe<FloatRangeFilter>;
  TAG_ENTITY?: InputMaybe<EntitySearchFilter>;
  TYPE?: InputMaybe<EntitySearchFilter>;
  VINTAGE_YEAR?: InputMaybe<IntRangeFilter>;
  VOLATILITY?: InputMaybe<VolatilitySearchFilter>;
  VOLATILITY_PRIVATE?: InputMaybe<VolatilityPrivateSearchFilter>;
};

export type InvestmentSet = {
  __typename?: 'InvestmentSet';
  accessLevel: AccessLevel;
  accessLevelId?: Maybe<Scalars['Int']['output']>;
  calculations: InvestmentCalculationList;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  description: Scalars['String']['output'];
  groupSubscriptions: Array<GroupInvestmentSetSubscription>;
  id: Scalars['Int']['output'];
  investmentSetItems: Array<InvestmentSetItems>;
  investments: InvestmentList;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isDynamic?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  organizationSubscriptions: Array<OrganizationInvestmentSetSubscription>;
  setId?: Maybe<Scalars['Int']['output']>;
  updateDate?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
  userSubscriptions: Array<UserInvestmentSetSubscription>;
};


export type InvestmentSetCalculationsArgs = {
  filter?: InputMaybe<InvestmentCalculationFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentCalculationSort>>;
};


export type InvestmentSetInvestmentsArgs = {
  filters?: InputMaybe<Array<InvestmentSearchFilters>>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentSort>>;
};

export type InvestmentSetFilter = {
  createUser?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  subscribed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvestmentSetInput = {
  accessLevelId?: InputMaybe<Scalars['Int']['input']>;
  calculationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  investmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDynamic?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  setId?: InputMaybe<Scalars['Int']['input']>;
  subscriptionGroupIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  subscriptionOrganizationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  subscriptionUserIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type InvestmentSetItems = {
  __typename?: 'InvestmentSetItems';
  investmentId: Scalars['Int']['output'];
  investmentSetId: Scalars['Int']['output'];
};

export type InvestmentSetList = {
  __typename?: 'InvestmentSetList';
  items: Array<InvestmentSet>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InvestmentSetSearchFilter = {
  investmentSetId?: InputMaybe<Scalars['Int']['input']>;
};

export type InvestmentSetSort = {
  field: InvestmentSetSortEnum;
  order: SortInput;
};

export enum InvestmentSetSortEnum {
  CreateDate = 'createDate',
  Id = 'id',
  Name = 'name'
}

export type InvestmentSort = {
  field: InvestmentSortEnum;
  order: SortInput;
};

export enum InvestmentSortEnum {
  AssetClass = 'assetClass',
  AssetClassAndStrategy = 'assetClassAndStrategy',
  FundLinkDefault = 'fundLinkDefault',
  FuzzyRank = 'fuzzyRank',
  GeographicFocus = 'geographicFocus',
  Id = 'id',
  ModifyDate = 'modifyDate',
  Name = 'name',
  NameSearchRank = 'nameSearchRank',
  Strategy = 'strategy',
  VintageYear = 'vintageYear'
}

export type InvestmentStrategyAum = {
  __typename?: 'InvestmentStrategyAum';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Array<AumRecord>>;
};

export type InvestmentStrategyFilterInput = {
  strategyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  subStrategyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type InvestmentStructureEnum = {
  __typename?: 'InvestmentStructureEnum';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type InvestmentStructureEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type InvestmentStructureEnumList = {
  __typename?: 'InvestmentStructureEnumList';
  items: Array<InvestmentStructureEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InvestmentStructureEnumSort = {
  field: InvestmentStructureEnumSortEnum;
  order: SortInput;
};

export enum InvestmentStructureEnumSortEnum {
  Id = 'id'
}

export type InvestmentTags = {
  __typename?: 'InvestmentTags';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  investment: Investment;
  investmentId: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  tag: Tag;
  tagClassId: Scalars['Int']['output'];
  tagId: Scalars['Int']['output'];
};

export type InvestmentTagsFilterInput = {
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  tagClassId?: InputMaybe<Scalars['Int']['input']>;
  tagId?: InputMaybe<Scalars['Int']['input']>;
};

export type InvestmentTagsList = {
  __typename?: 'InvestmentTagsList';
  items: Array<InvestmentTags>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InvestmentTagsSort = {
  field: InvestmentTagsSortEnum;
  order: SortInput;
};

export enum InvestmentTagsSortEnum {
  Id = 'id'
}

export type InvestmentXImpact = {
  __typename?: 'InvestmentXImpact';
  impactEnum: ImpactEnum;
  impactEnumId: Scalars['Int']['output'];
  investmentId: Scalars['Int']['output'];
};

export type InvestmentsDynamicShareRule = {
  investmentSet?: InputMaybe<GroupShareInvestmentSetFilter>;
};

export type InvestmentsDynamicShareRuleOutput = {
  __typename?: 'InvestmentsDynamicShareRuleOutput';
  investmentSet?: Maybe<GroupShareInvestmentSetFilterOutput>;
};

export type InvestmentsFamily = {
  __typename?: 'InvestmentsFamily';
  family: Family;
  familyFirmId: Scalars['Int']['output'];
  familyId: Scalars['Int']['output'];
  fundFirmId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  investment?: Maybe<InvestmentFamilyInvestment>;
  investmentId: Scalars['Int']['output'];
};

export type InvestmentsFamilyFilterInput = {
  familyId?: InputMaybe<Scalars['Int']['input']>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type InvestmentsFamilyInput = {
  familyId: Scalars['Int']['input'];
  investmentId: Scalars['Int']['input'];
};

export type InvestmentsFamilySort = {
  field: InvestmentsFamilySortEnum;
  order: SortInput;
};

export enum InvestmentsFamilySortEnum {
  Id = 'id',
  VintageYear = 'vintageYear'
}

export type JobSchedule = {
  __typename?: 'JobSchedule';
  args?: Maybe<Scalars['JSON']['output']>;
  cron: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isPreview: Scalars['Boolean']['output'];
  jobName: Scalars['String']['output'];
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  previewAllowed: Scalars['Boolean']['output'];
};

export type JobScheduleUpdateInput = {
  args?: InputMaybe<Scalars['JSON']['input']>;
  cron: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};

export type KnowledgeBaseEntity = {
  __typename?: 'KnowledgeBaseEntity';
  document?: Maybe<Document>;
  note?: Maybe<Notes>;
};

export enum KnowledgeBaseEntityType {
  Company = 'COMPANY',
  Document = 'DOCUMENT',
  Engagement = 'ENGAGEMENT',
  Firm = 'FIRM',
  Investment = 'INVESTMENT',
  Note = 'NOTE'
}

export type KnowledgeBaseFilter = {
  companyFilters?: InputMaybe<Array<CompanySearchFilters>>;
  date?: InputMaybe<DateRangeFilter>;
  dealFilter?: InputMaybe<DealFilter>;
  documentsFilter?: InputMaybe<DocumentFilter>;
  entityTypes?: InputMaybe<Array<KnowledgeBaseEntityType>>;
  firmEngagementId?: InputMaybe<Scalars['Int']['input']>;
  firmFilter?: InputMaybe<FirmFilterInput>;
  firmFilters?: InputMaybe<Array<FirmSearchFilters>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  investmentFilters?: InputMaybe<Array<InvestmentSearchFilters>>;
  knowledgeBaseTagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  modifyDate?: InputMaybe<DateRangeFilter>;
  notesFilter?: InputMaybe<NotesFilter>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type KnowledgeBaseItem = {
  __typename?: 'KnowledgeBaseItem';
  entity: KnowledgeBaseEntity;
  entityId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  tags: Array<KnowledgeBaseTags>;
  type: KnowledgeBaseEntityType;
};

export type KnowledgeBaseList = {
  __typename?: 'KnowledgeBaseList';
  items: Array<KnowledgeBaseItem>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type KnowledgeBaseSort = {
  field: KnowledgeBaseSortEnum;
  order: SortInput;
};

export enum KnowledgeBaseSortEnum {
  CreateDate = 'createDate',
  Date = 'date',
  ModifyDate = 'modifyDate',
  Relevance = 'relevance'
}

export enum KnowledgeBaseStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Ready = 'READY'
}

export type KnowledgeBaseTags = {
  __typename?: 'KnowledgeBaseTags';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['Int']['output'];
};

export type KnowledgeBaseTagsFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type KnowledgeBaseTagsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type KnowledgeBaseTagsList = {
  __typename?: 'KnowledgeBaseTagsList';
  items: Array<KnowledgeBaseTags>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type KnowledgeBaseTagsSort = {
  field: KnowledgeBaseTagsSortEnum;
  order: SortInput;
};

export enum KnowledgeBaseTagsSortEnum {
  Id = 'id'
}

export enum KnowledgeBaseType {
  General = 'GENERAL',
  PublishedDiligence = 'PUBLISHED_DILIGENCE'
}

export type LlmPerformance = {
  __typename?: 'LLMPerformance';
  asOfDate: Scalars['DateTime']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  currency?: Maybe<CurrencyDenominationEnum>;
  currencyId: Scalars['Float']['output'];
  documentId?: Maybe<Scalars['Int']['output']>;
  emailId?: Maybe<Scalars['String']['output']>;
  investmentId: Scalars['Int']['output'];
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  performanceCommentary?: Maybe<Scalars['String']['output']>;
  return?: Maybe<Scalars['Float']['output']>;
  returnMonth: Scalars['Int']['output'];
  returnType: Scalars['String']['output'];
  returnYear: Scalars['Int']['output'];
};

export type LegalStructureEnum = {
  __typename?: 'LegalStructureEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type LegalStructureEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type LegalStructureEnumList = {
  __typename?: 'LegalStructureEnumList';
  items: Array<LegalStructureEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type LegalStructureEnumSort = {
  field: LegalStructureEnumSortEnum;
  order: SortInput;
};

export enum LegalStructureEnumSortEnum {
  Id = 'id'
}

export type LengthConstraint = {
  __typename?: 'LengthConstraint';
  max?: Maybe<Scalars['Int']['output']>;
  min: Scalars['Int']['output'];
};

export type LexSendMessageInput = {
  conversationId?: InputMaybe<Scalars['Int']['input']>;
  requestId: Scalars['String']['input'];
  sessionAttributes?: InputMaybe<Scalars['JSONObject']['input']>;
  sessionId: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type LexSendMessageResult = {
  __typename?: 'LexSendMessageResult';
  conversationId: Scalars['Int']['output'];
};

export type Links = {
  __typename?: 'Links';
  iconEnum?: Maybe<IconEnum>;
  iconEnumId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  orgLinks: Array<OrgLinks>;
  url: Scalars['String']['output'];
};

export type LinksFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LinksInput = {
  iconEnumId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orgLinks?: InputMaybe<Array<OrgLinksInput>>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LinksList = {
  __typename?: 'LinksList';
  items: Array<Links>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type LinksSort = {
  field: LinksSortEnum;
  order: SortInput;
};

export enum LinksSortEnum {
  Id = 'id',
  Name = 'name',
  Url = 'url'
}

export type Liquidity = {
  __typename?: 'Liquidity';
  cashAvailableDays?: Maybe<Scalars['Int']['output']>;
  exceptions?: Maybe<Scalars['String']['output']>;
  gatePercentCapital?: Maybe<Scalars['Float']['output']>;
  gatePercentNav?: Maybe<Scalars['Float']['output']>;
  hasGate?: Maybe<Scalars['Boolean']['output']>;
  hasHoldback?: Maybe<Scalars['Boolean']['output']>;
  hasLockup?: Maybe<Scalars['Boolean']['output']>;
  hasRollover?: Maybe<Scalars['Boolean']['output']>;
  holdbackPercent?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  liquidityMonthlyValue: Scalars['Int']['output'];
  liquidityUnit?: Maybe<CalendarUnitEnum>;
  liquidityUnitId?: Maybe<Scalars['Int']['output']>;
  liquidityValue?: Maybe<Scalars['Int']['output']>;
  lockupEndBasisDate?: Maybe<Scalars['DateTime']['output']>;
  lockupEndBizDays?: Maybe<Scalars['Boolean']['output']>;
  lockupEndUnit?: Maybe<CalendarUnitEnum>;
  lockupEndUnitId?: Maybe<Scalars['Int']['output']>;
  lockupEndValue?: Maybe<LockupEndValueEnum>;
  lockupEndValueId?: Maybe<Scalars['Int']['output']>;
  lockupMonthlyValue: Scalars['Int']['output'];
  lockupUnit?: Maybe<CalendarUnitEnum>;
  lockupUnitId?: Maybe<Scalars['Int']['output']>;
  lockupValue?: Maybe<Scalars['Int']['output']>;
  masterLevelFundGate?: Maybe<Scalars['Boolean']['output']>;
  modelingNotes?: Maybe<Scalars['String']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  noticeBizDays?: Maybe<Scalars['Boolean']['output']>;
  noticeUnit?: Maybe<CalendarUnitEnum>;
  noticeUnitId?: Maybe<Scalars['Int']['output']>;
  noticeValue?: Maybe<Scalars['Int']['output']>;
  rolloverUnit?: Maybe<CalendarUnitEnum>;
  rolloverUnitId?: Maybe<Scalars['Int']['output']>;
  rolloverValue?: Maybe<Scalars['Int']['output']>;
  secondLockupEndBasisDate?: Maybe<Scalars['DateTime']['output']>;
  secondLockupEndBizDays?: Maybe<Scalars['Boolean']['output']>;
  secondLockupEndUnit?: Maybe<CalendarUnitEnum>;
  secondLockupEndUnitId?: Maybe<Scalars['Int']['output']>;
  secondLockupEndValue?: Maybe<LockupEndValueEnum>;
  secondLockupEndValueId?: Maybe<Scalars['Int']['output']>;
  secondLockupUnit?: Maybe<CalendarUnitEnum>;
  secondLockupUnitId?: Maybe<Scalars['Int']['output']>;
  secondLockupValue?: Maybe<Scalars['Int']['output']>;
  shareClassId: Scalars['Int']['output'];
  softLockups: Array<SoftLockup>;
  subscriptionUnit?: Maybe<CalendarUnitEnum>;
  subscriptionUnitId?: Maybe<Scalars['Int']['output']>;
  subscriptionValue?: Maybe<Scalars['Int']['output']>;
  workout?: Maybe<WorkoutEnum>;
  workoutId?: Maybe<Scalars['Int']['output']>;
};


export type LiquiditySoftLockupsArgs = {
  filter?: InputMaybe<SoftLockupFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<SoftLockupSort>>;
};

export type LiquidityFilter = {
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  shareClassId?: InputMaybe<Scalars['Int']['input']>;
};

export type LiquidityInput = {
  cashAvailableDays?: InputMaybe<Scalars['Int']['input']>;
  exceptions?: InputMaybe<Scalars['String']['input']>;
  gatePercentCapital?: InputMaybe<Scalars['Float']['input']>;
  gatePercentNav?: InputMaybe<Scalars['Float']['input']>;
  hasGate?: InputMaybe<Scalars['Boolean']['input']>;
  hasHoldback?: InputMaybe<Scalars['Boolean']['input']>;
  hasLockup?: InputMaybe<Scalars['Boolean']['input']>;
  hasRollover?: InputMaybe<Scalars['Boolean']['input']>;
  holdbackPercent?: InputMaybe<Scalars['Float']['input']>;
  liquidityMonthlyValue?: InputMaybe<Scalars['Int']['input']>;
  liquidityUnitId?: InputMaybe<Scalars['Int']['input']>;
  liquidityValue?: InputMaybe<Scalars['Int']['input']>;
  lockupEndBasisDate?: InputMaybe<Scalars['DateTime']['input']>;
  lockupEndBizDays?: InputMaybe<Scalars['Boolean']['input']>;
  lockupEndValueId?: InputMaybe<Scalars['Int']['input']>;
  lockupMonthlyValue?: InputMaybe<Scalars['Int']['input']>;
  lockupUnitId?: InputMaybe<Scalars['Int']['input']>;
  lockupValue?: InputMaybe<Scalars['Int']['input']>;
  masterLevelFundGate?: InputMaybe<Scalars['Boolean']['input']>;
  modelingNotes?: InputMaybe<Scalars['String']['input']>;
  noticeBizDays?: InputMaybe<Scalars['Boolean']['input']>;
  noticeUnitId?: InputMaybe<Scalars['Int']['input']>;
  noticeValue?: InputMaybe<Scalars['Int']['input']>;
  rolloverUnitId?: InputMaybe<Scalars['Int']['input']>;
  rolloverValue?: InputMaybe<Scalars['Int']['input']>;
  secondLockupEndBasisDate?: InputMaybe<Scalars['DateTime']['input']>;
  secondLockupEndBizDays?: InputMaybe<Scalars['Boolean']['input']>;
  secondLockupEndValueId?: InputMaybe<Scalars['Int']['input']>;
  secondLockupUnitId?: InputMaybe<Scalars['Int']['input']>;
  secondLockupValue?: InputMaybe<Scalars['Int']['input']>;
  subscriptionUnitId?: InputMaybe<Scalars['Int']['input']>;
  subscriptionValue?: InputMaybe<Scalars['Int']['input']>;
  workoutId?: InputMaybe<Scalars['Int']['input']>;
};

export type LiquidityList = {
  __typename?: 'LiquidityList';
  items: Array<Liquidity>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type LiquiditySort = {
  field: LiquiditySortEnum;
  order: SortInput;
};

export enum LiquiditySortEnum {
  Id = 'id'
}

export type LlmCandidatePerformance = {
  __typename?: 'LlmCandidatePerformance';
  baselineCostUsd?: Maybe<Scalars['Float']['output']>;
  baselineLatencyMs: Scalars['Float']['output'];
  candidateCostUsd?: Maybe<Scalars['Float']['output']>;
  candidateLatencyMs: Scalars['Float']['output'];
};

export type LlmCandidateScore = {
  __typename?: 'LlmCandidateScore';
  baseline: Scalars['Float']['output'];
  candidate: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type LlmEvaluator = {
  __typename?: 'LlmEvaluator';
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
  langfuseSyncedVersion?: Maybe<Scalars['Int']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
  scoreType: Scalars['String']['output'];
  taskKeys: Array<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type LlmEvaluatorInput = {
  description: Scalars['String']['input'];
  key: Scalars['String']['input'];
  model?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
  scoreType: Scalars['String']['input'];
};

export type LlmModel = {
  __typename?: 'LlmModel';
  api: LlmModelApi;
  bedrockModelId: Scalars['String']['output'];
  behavior: Array<LlmModelBehavior>;
  benchmarkSlug?: Maybe<Scalars['String']['output']>;
  benchmarksFetchedAt?: Maybe<Scalars['DateTime']['output']>;
  blendedPricePer1M?: Maybe<Scalars['Float']['output']>;
  cachePoint: Scalars['Boolean']['output'];
  cacheReadPer1M?: Maybe<Scalars['Float']['output']>;
  cacheWritePer1M?: Maybe<Scalars['Float']['output']>;
  contextWindow: Scalars['Int']['output'];
  costPerIntelligence?: Maybe<Scalars['Float']['output']>;
  defaultEffort?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  effortBenchmarks?: Maybe<Array<EffortBenchmark>>;
  effortField?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  inputPer1M?: Maybe<Scalars['Float']['output']>;
  intelligenceIndex?: Maybe<Scalars['Float']['output']>;
  isDefault: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  maxOutputTokens: Scalars['Int']['output'];
  outputPer1M?: Maybe<Scalars['Float']['output']>;
  outputTokensPerSecond?: Maybe<Scalars['Float']['output']>;
  pricesFetchedAt?: Maybe<Scalars['DateTime']['output']>;
  rating?: Maybe<Scalars['JSON']['output']>;
  roles: Array<LlmModelRole>;
  secondsToFirstAnswerToken?: Maybe<Scalars['Float']['output']>;
  supportsEffort: Scalars['Boolean']['output'];
  supportsVision: Scalars['Boolean']['output'];
  thinkingOff?: Maybe<Scalars['String']['output']>;
  usage: LlmModelUsage;
  verification?: Maybe<Scalars['JSON']['output']>;
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
  verifiedBy?: Maybe<Scalars['String']['output']>;
  verifiedRoles: Array<LlmModelRole>;
};

export enum LlmModelApi {
  Converse = 'Converse',
  Messages = 'Messages'
}

export type LlmModelBehavior = {
  __typename?: 'LlmModelBehavior';
  behavior: Scalars['String']['output'];
  feature: Scalars['String']['output'];
  limited: Scalars['Boolean']['output'];
};

export type LlmModelCatalogEntry = {
  __typename?: 'LlmModelCatalogEntry';
  bedrockModelId: Scalars['String']['output'];
  benchmarkSlug?: Maybe<Scalars['String']['output']>;
  blendedPricePer1M?: Maybe<Scalars['Float']['output']>;
  costPerIntelligence?: Maybe<Scalars['Float']['output']>;
  intelligenceIndex?: Maybe<Scalars['Float']['output']>;
  modelName: Scalars['String']['output'];
  outputTokensPerSecond?: Maybe<Scalars['Float']['output']>;
  priceSource?: Maybe<Scalars['String']['output']>;
  providerName: Scalars['String']['output'];
  requiresHumanReview?: Maybe<Scalars['Boolean']['output']>;
};

export type LlmModelInput = {
  api: LlmModelApi;
  bedrockModelId: Scalars['String']['input'];
  benchmarkSlug?: InputMaybe<Scalars['String']['input']>;
  cacheReadPer1M?: InputMaybe<Scalars['Float']['input']>;
  cacheWritePer1M?: InputMaybe<Scalars['Float']['input']>;
  contextWindow: Scalars['Int']['input'];
  defaultEffort?: InputMaybe<ChatEffort>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  inputPer1M?: InputMaybe<Scalars['Float']['input']>;
  key: Scalars['String']['input'];
  maxOutputTokens: Scalars['Int']['input'];
  outputPer1M?: InputMaybe<Scalars['Float']['input']>;
  roles: Array<LlmModelRole>;
  supportsEffort: Scalars['Boolean']['input'];
  supportsVision: Scalars['Boolean']['input'];
};

export type LlmModelPreview = {
  __typename?: 'LlmModelPreview';
  accountRetentionMode: Scalars['String']['output'];
  api: LlmModelApi;
  bedrockModelId: Scalars['String']['output'];
  benchmarkSlug?: Maybe<Scalars['String']['output']>;
  benchmarksAvailable: Scalars['Boolean']['output'];
  cacheReadPer1M?: Maybe<Scalars['Float']['output']>;
  cacheWritePer1M?: Maybe<Scalars['Float']['output']>;
  contextWindow?: Maybe<Scalars['Int']['output']>;
  displayName: Scalars['String']['output'];
  inputPer1M?: Maybe<Scalars['Float']['output']>;
  intelligenceIndex?: Maybe<Scalars['Float']['output']>;
  lifecycleStatus: Scalars['String']['output'];
  limitsFound: Scalars['Boolean']['output'];
  maxOutputTokens?: Maybe<Scalars['Int']['output']>;
  outputPer1M?: Maybe<Scalars['Float']['output']>;
  outputTokensPerSecond?: Maybe<Scalars['Float']['output']>;
  priceSource?: Maybe<Scalars['String']['output']>;
  providerName: Scalars['String']['output'];
  refused: Scalars['Boolean']['output'];
  retentionModes?: Maybe<Array<Scalars['String']['output']>>;
  retentionProblem?: Maybe<Scalars['String']['output']>;
  secondsToFirstAnswerToken?: Maybe<Scalars['Float']['output']>;
  suggestedKey: Scalars['String']['output'];
  supportsEffort: Scalars['Boolean']['output'];
  supportsVision: Scalars['Boolean']['output'];
};

export enum LlmModelRole {
  Background = 'Background',
  Chat = 'Chat',
  Subagent = 'Subagent'
}

export type LlmModelUpdateInput = {
  api?: InputMaybe<LlmModelApi>;
  bedrockModelId?: InputMaybe<Scalars['String']['input']>;
  benchmarkSlug?: InputMaybe<Scalars['String']['input']>;
  cacheReadPer1M?: InputMaybe<Scalars['Float']['input']>;
  cacheWritePer1M?: InputMaybe<Scalars['Float']['input']>;
  contextWindow?: InputMaybe<Scalars['Int']['input']>;
  defaultEffort?: InputMaybe<ChatEffort>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  inputPer1M?: InputMaybe<Scalars['Float']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  maxOutputTokens?: InputMaybe<Scalars['Int']['input']>;
  outputPer1M?: InputMaybe<Scalars['Float']['input']>;
  roles?: InputMaybe<Array<LlmModelRole>>;
  supportsEffort?: InputMaybe<Scalars['Boolean']['input']>;
  supportsVision?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LlmModelUsage = {
  __typename?: 'LlmModelUsage';
  agents: Array<Scalars['String']['output']>;
  isDefault: Scalars['Boolean']['output'];
  tasks: Array<Scalars['String']['output']>;
};

export type LlmTask = {
  __typename?: 'LlmTask';
  candidates: Array<LlmTaskCandidate>;
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  eligibleModelKeys: Array<Scalars['String']['output']>;
  evaluatorKeys: Array<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  langfuseDatasetName: Scalars['String']['output'];
  modelKey: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  prompts: Array<LlmTaskPrompt>;
  requiresMessagesApi: Scalars['Boolean']['output'];
  requiresVision: Scalars['Boolean']['output'];
  version: Scalars['Int']['output'];
  versions: Array<LlmTaskVersion>;
};

export type LlmTaskCandidate = {
  __typename?: 'LlmTaskCandidate';
  baseVersion: Scalars['Int']['output'];
  baselineRunUrl?: Maybe<Scalars['String']['output']>;
  candidateRunUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  decidedAt?: Maybe<Scalars['DateTime']['output']>;
  decidedBy?: Maybe<Scalars['String']['output']>;
  evaluatedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  itemCount?: Maybe<Scalars['Int']['output']>;
  modelKey?: Maybe<Scalars['String']['output']>;
  overrideReason?: Maybe<Scalars['String']['output']>;
  performance?: Maybe<LlmCandidatePerformance>;
  promotedVersion?: Maybe<Scalars['Int']['output']>;
  prompts: Array<LlmTaskCandidatePrompt>;
  scores?: Maybe<Array<LlmCandidateScore>>;
  status: Scalars['String']['output'];
  statusMessage?: Maybe<Scalars['String']['output']>;
  taskKey: Scalars['String']['output'];
};

export type LlmTaskCandidatePrompt = {
  __typename?: 'LlmTaskCandidatePrompt';
  name: Scalars['String']['output'];
  template: Scalars['String']['output'];
};

export type LlmTaskPrompt = {
  __typename?: 'LlmTaskPrompt';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  history: Array<LlmTaskPrompt>;
  langfuseName: Scalars['String']['output'];
  langfuseSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  langfuseVersion?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  taskKey: Scalars['String']['output'];
  template: Scalars['String']['output'];
  variables: Array<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type LlmTaskPromptInput = {
  name: Scalars['String']['input'];
  template: Scalars['String']['input'];
};

export type LlmTaskVersion = {
  __typename?: 'LlmTaskVersion';
  changedAt: Scalars['DateTime']['output'];
  changedBy: Scalars['String']['output'];
  modelKey: Scalars['String']['output'];
  taskKey: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type LocationFilter = {
  city?: InputMaybe<Scalars['String']['input']>;
  countryEnum?: InputMaybe<Scalars['Int']['input']>;
  stateEnum?: InputMaybe<Scalars['Int']['input']>;
};

export type LockupEndValueEnum = {
  __typename?: 'LockupEndValueEnum';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type LockupEndValueEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type LockupEndValueEnumList = {
  __typename?: 'LockupEndValueEnumList';
  items: Array<LockupEndValueEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type LockupEndValueEnumSort = {
  field: LockupEndValueEnumSortEnum;
  order: SortInput;
};

export enum LockupEndValueEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type ManagerSummary = {
  __typename?: 'ManagerSummary';
  auditOpinionType?: Maybe<Scalars['String']['output']>;
  auditorName?: Maybe<Scalars['String']['output']>;
  documentId?: Maybe<Scalars['Int']['output']>;
  extractionId?: Maybe<Scalars['Int']['output']>;
  /** Fund legal name as reported in the AFS document */
  fundLegalName?: Maybe<Scalars['String']['output']>;
  investmentId?: Maybe<Scalars['Int']['output']>;
  /** Investment name from portfolio (Sirius name) */
  investmentName?: Maybe<Scalars['String']['output']>;
  level3SharePct?: Maybe<Scalars['Float']['output']>;
  leverageRatio?: Maybe<Scalars['Float']['output']>;
  netAssets?: Maybe<Scalars['Float']['output']>;
  periodEndDate?: Maybe<Scalars['String']['output']>;
  portfolioBalance?: Maybe<Scalars['Float']['output']>;
  /** Document ID of an uploaded but unextracted AFS document */
  unextractedDocumentId?: Maybe<Scalars['Int']['output']>;
};

export type ManagerTags = {
  __typename?: 'ManagerTags';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  date: Scalars['DateTime']['output'];
  manager?: Maybe<Investment>;
  managerId: Scalars['Int']['output'];
  portfolioId: Scalars['Int']['output'];
  tag: Scalars['String']['output'];
  tag2?: Maybe<Scalars['String']['output']>;
  tag3?: Maybe<Scalars['String']['output']>;
  tag4?: Maybe<Scalars['String']['output']>;
};

export type ManagerTagsFilter = {
  managerId?: InputMaybe<Scalars['Int']['input']>;
  modelStartDate?: InputMaybe<Scalars['Date']['input']>;
  modelStopDate?: InputMaybe<Scalars['Date']['input']>;
  portfolioId?: InputMaybe<Scalars['Int']['input']>;
};

export type ManagerTagsList = {
  __typename?: 'ManagerTagsList';
  items: Array<ManagerTags>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type ManagerTagsSort = {
  field: ManagerTagsSortEnum;
  order: SortInput;
};

export enum ManagerTagsSortEnum {
  Date = 'date',
  ManagerId = 'managerId',
  PortfolioId = 'portfolioId'
}

export type ManyCloseDateFundSize = {
  closeDates: Array<CloseDateShort>;
  investmentId: Scalars['Int']['input'];
};

export type ManyPerformanceMtd = {
  /** If omitted, uses the currency of the latest record. */
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  investmentId: Scalars['Int']['input'];
  months: Array<PerformanceMtdShort>;
  returnType: ReturnTypes;
};

export type ManyPerformancePrivate = {
  investmentId: Scalars['Int']['input'];
  quarters: Array<PerformancePrivateShort>;
};

export type ManyPerformanceQuarterly = {
  investmentId: Scalars['Int']['input'];
  quarters: Array<PerformanceQuarterlyShort>;
  returnType: ReturnTypes;
};

export type McpToolBundleType = {
  __typename?: 'McpToolBundleType';
  description: Scalars['String']['output'];
  key: SiriusMcpCategory;
  title: Scalars['String']['output'];
  tools: Array<McpToolRefType>;
};

export type McpToolRefType = {
  __typename?: 'McpToolRefType';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type MeasureEnum = {
  __typename?: 'MeasureEnum';
  description: Scalars['String']['output'];
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  measureTypeEnum?: Maybe<MeasureTypeEnum>;
  measureTypeEnumId?: Maybe<Scalars['Int']['output']>;
  questionText?: Maybe<Scalars['String']['output']>;
};

export type MeasureEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  measureTypeEnumIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type MeasureEnumList = {
  __typename?: 'MeasureEnumList';
  items: Array<MeasureEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type MeasureEnumSort = {
  field: MeasureEnumSortEnum;
  order: SortInput;
};

export enum MeasureEnumSortEnum {
  DisplayOrder = 'displayOrder',
  Id = 'id',
  Name = 'name'
}

export type MeasureTypeEnum = {
  __typename?: 'MeasureTypeEnum';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MeasureTypeEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type MeasureTypeEnumList = {
  __typename?: 'MeasureTypeEnumList';
  items: Array<MeasureTypeEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type MeasureTypeEnumSort = {
  field: MeasureTypeEnumSortEnum;
  order: SortInput;
};

export enum MeasureTypeEnumSortEnum {
  Id = 'id'
}

export type MemoizedInvestmentCompletenessSummary = {
  __typename?: 'MemoizedInvestmentCompletenessSummary';
  category: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  level: Scalars['Int']['output'];
  percentComplete: Scalars['Float']['output'];
  subcategory: Scalars['String']['output'];
  weight: Scalars['Float']['output'];
};

export type MessageStream = {
  __typename?: 'MessageStream';
  /** position of chunk within a content block */
  blockIndex?: Maybe<Scalars['Int']['output']>;
  contentType?: Maybe<MessageType>;
  event: MessageStreamEvent;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  /** position of message within an array of messages (mostly relevant for tool-use) */
  messageIndex?: Maybe<Scalars['Int']['output']>;
};

export enum MessageStreamEvent {
  ContextCompressing = 'contextCompressing',
  ContextEditing = 'contextEditing',
  Heartbeat = 'heartbeat',
  Message = 'message',
  Retrying = 'retrying',
  Start = 'start',
  Stop = 'stop',
  ToolCall = 'toolCall',
  ToolStart = 'toolStart'
}

export enum MessageType {
  CustomPayload = 'CustomPayload',
  ImageResponseCard = 'ImageResponseCard',
  PlainText = 'PlainText',
  Ssml = 'SSML'
}

export type MetricInfo = {
  __typename?: 'MetricInfo';
  category: Scalars['String']['output'];
  defaultFormat?: Maybe<Scalars['String']['output']>;
  defaultResultType: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  implemented: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parameters: Array<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  aamOptimizationRun: AamOptimizationRun;
  /** Activates the user in Okta. */
  activateUser: User;
  addAdEntriesXApplicationFlags: AdEntriesXApplicationFlags;
  addAdEntriesXApplicationsXSets: AdEntriesXApplicationsXSets;
  addAsyncTaskStatus: AsyncTaskStatus;
  addChatSkillSchedule: ChatSkillSchedule;
  addCogencyLink: CogencyLink;
  addCompany: Company;
  addCompanyValuation: CompanyValuation;
  addCustomAnalytics: CustomAnalytics;
  addCustomIndexInvestment: CustomIndexInvestment;
  addDeal: Deal;
  addDocument?: Maybe<Document>;
  addDocumentQueueSignedURI: Array<DocumentQueue>;
  addEmailDomainXOrganization: EmailDomainXOrganization;
  addFamily: Family;
  addFdpLogin: FdpLogin;
  addFdpWebsites: FdpWebsites;
  addFinancialDataProvider: FinancialDataProvider;
  addFirm?: Maybe<Firm>;
  addFirmEmployment?: Maybe<FirmEmployment>;
  addFirmEngagement: FirmEngagement;
  addFirmFDPLogins: FirmFdpLogins;
  addFirmInstitutions?: Maybe<FirmInstitutions>;
  addFundsXProxies: FundsXProxies;
  addGroupShareDefinition: GroupShareDefinition;
  addInstitution: Institution;
  addInstitutionEmployment: InstitutionEmployment;
  addInvestment?: Maybe<Investment>;
  addInvestmentAccessRequest: InvestmentAccessRequest;
  addInvestmentAxysCode: InvestmentAxysCode;
  addInvestmentFDPLogins: InvestmentFdpLogins;
  addInvestmentFirmEmployment: InvestmentFirmEmployment;
  addInvestmentFirmEmploymentRecords: Array<InvestmentFirmEmployment>;
  addInvestmentInstitutions?: Maybe<InvestmentInstitutions>;
  addInvestmentPrivateQuartileGroupCategory: InvestmentPrivateQuartileGroupCategory;
  addInvestmentSet: InvestmentSet;
  addInvestmentsFamily: InvestmentsFamily;
  addKnowledgeBaseTags: KnowledgeBaseTags;
  addLinks: Links;
  addNote: Notes;
  /** Subscribe a user or a group to an event type. Exactly one of userId or groupId. */
  addNotificationSubscription: NotificationSubscription;
  addOrUpdateAUM?: Maybe<FirmFundAssetsList>;
  addOrUpdateAssumeUser?: Maybe<Scalars['Int']['output']>;
  addOrUpdateCloseDateSize: Array<CloseDateFundSize>;
  addOrUpdateCogencyLink: CogencyLink;
  /** @deprecated Use `bulkUpsertPerformanceMTD` instead */
  addOrUpdatePerformanceMTD: PerformanceMtdList;
  addOrUpdatePerformancePrivate: PerformancePrivateList;
  /** @deprecated Use `bulkUpsertPerformanceQuarterly` instead */
  addOrUpdatePerformanceQuarterly: PerformanceQuarterlyList;
  addOrUpdateUserSettings: UserSettings;
  addPerson?: Maybe<Person>;
  addPersonEducation: PersonEducation;
  addPersonWorkExperience: PersonWorkExperience;
  addPortalOrganization: PortalOrganization;
  addPortalServiceProviderFirm: PortalServiceProviderFirms;
  addPortfolioConfig: PortfolioConfig;
  addPortfolioFDPLogins: PortfolioFdpLogins;
  addRecentlyViewedInvestment: RecentlyViewedInvestment;
  addSavedEntitySearch: SavedEntitySearch;
  addSavedKnowledgeBase: SavedKnowledgeBase;
  addServiceProviderDocuments: ServiceProviderDocuments;
  addServiceProviderFirm: ServiceProviderFirm;
  addServiceProviderNotes: ServiceProviderNotes;
  addSet: Set;
  addShareClass?: Maybe<ShareClass>;
  addStoredPrompts: StoredPrompts;
  addTempFiles: Array<TempFile>;
  addUserActivity: UserActivity;
  addUsersXGroups: UsersXGroups;
  advPull: AsyncTaskStatus;
  advServiceProviderParse: AsyncTaskStatus;
  alphaVantage_extract_fxMonthly: ExtractResult;
  alphaVantage_load_fxMonthly: Scalars['Boolean']['output'];
  alphaVantage_transform_fxMonthly: TransformResult;
  analyseDiligenceGaps: DiligenceGapAnalysis;
  approveMutationPlan: MutationPlan;
  assignAfsHoldingMapping: AfsSecurityMapping;
  bloombergDiligenceExtract: Array<BloombergPullResponse>;
  bloombergDiligenceLoad: Scalars['Boolean']['output'];
  bulkAddAdvSummaryEmailNotification: Array<AdvSummaryEmailNotification>;
  bulkHardDeleteDocuments: Array<Scalars['Int']['output']>;
  bulkUpsertPerformanceMTD?: Maybe<PerformanceMtdList>;
  bulkUpsertPerformancePrivate: PerformancePrivateList;
  bulkUpsertPerformanceQuarterly: PerformanceQuarterlyList;
  cancelMutationPlan: Scalars['Boolean']['output'];
  caseStudySlides: AsyncTaskStatus;
  clearUserSetting: UserSettings;
  computeGuidelineMetrics: ComputeMetricsResult;
  confirmNoticeFundMapping: NoticeFundMapping;
  /** Confirm organization icon upload, validate the uploaded object, and store the key */
  confirmOrganizationIconUpload: Organization;
  confirmPmeMappings: PmeUpload;
  copyInvestmentOverview: AsyncTaskStatus;
  copyPortfolio?: Maybe<Portfolio>;
  copyRiskMeasures: Scalars['Int']['output'];
  createChatAgent: ChatAgent;
  createChatSkill: ChatSkill;
  createFieldDefinition: FieldDefinition;
  createGuidelineNode: GuidelineNode;
  createGuidelineSet: GuidelineSet;
  createLlmModel: LlmModel;
  createOrUpdateFirmDEI: FirmDei;
  createOrganization: Organization;
  createPortfolio?: Maybe<Portfolio>;
  createTemplate: Template;
  createTemplateAttachment: TemplateAttachment;
  createUser: User;
  createUserGroup: User;
  /** Deletes the user in Okta. This is an aggressive operation, all configuration will be lost. */
  deactivateUser: User;
  deleteAdEntriesXApplicationFlags: Scalars['Int']['output'];
  deleteAdEntriesXApplicationsXSets: Scalars['Int']['output'];
  deleteAfsHolding: AfsHolding;
  deleteAssumeUser?: Maybe<Scalars['Int']['output']>;
  deleteChatAgent: Scalars['Boolean']['output'];
  deleteChatSkill: Scalars['Boolean']['output'];
  deleteChatSkillSchedule: Scalars['Int']['output'];
  /** Delete a share class nothing refers to. */
  deleteClientShareClass: Scalars['Boolean']['output'];
  deleteCompanyFieldValues: CompanyFields;
  deleteCompanyValuation: Scalars['Int']['output'];
  deleteConversation: Scalars['Int']['output'];
  deleteDocument: Scalars['Int']['output'];
  deleteDocumentQueue: Scalars['ID']['output'];
  deleteEmailDomainXOrganization: Scalars['Int']['output'];
  deleteFdpLogin: Scalars['Int']['output'];
  deleteFdpWebsites: Scalars['Int']['output'];
  deleteFieldDefinition: Scalars['Boolean']['output'];
  deleteFirm: Scalars['ID']['output'];
  deleteFirmDei: Scalars['ID']['output'];
  deleteFirmEmployment: Scalars['Int']['output'];
  deleteFirmEngagement: Scalars['Int']['output'];
  deleteFirmFieldValues: FirmFields;
  deleteFirmInstitutions: Scalars['Int']['output'];
  deleteFundsXProxies: Scalars['Int']['output'];
  deleteGroupShareDefinition: Scalars['Int']['output'];
  deleteGuidelineNode: Scalars['Boolean']['output'];
  deleteGuidelineSet: GuidelineSetDeleteResult;
  deleteInvestment: Scalars['Boolean']['output'];
  deleteInvestmentAxysCode: Scalars['Int']['output'];
  deleteInvestmentFieldValues: InvestmentFields;
  deleteInvestmentFields: InvestmentFields;
  deleteInvestmentFirmEmployment: Scalars['Int']['output'];
  deleteInvestmentInstitutions: Scalars['Int']['output'];
  deleteInvestmentPrivateQuartileGroupCategory: Scalars['Int']['output'];
  deleteInvestmentSet: Scalars['Int']['output'];
  deleteInvestmentsFamily: Scalars['Int']['output'];
  deleteLinks: Scalars['Int']['output'];
  deleteNote: Notes;
  deleteNoticeNotificationConfig: Scalars['Boolean']['output'];
  deletePersonEducation: Scalars['Int']['output'];
  deletePersonWorkExperience: Scalars['Int']['output'];
  deletePortalFirm: Scalars['ID']['output'];
  deletePortalOrganization: Scalars['ID']['output'];
  deletePortalServiceProviderFirm: Scalars['Int']['output'];
  deletePortalSubmitted: Scalars['ID']['output'];
  deletePortalUser: Scalars['ID']['output'];
  deletePortfolio?: Maybe<Scalars['Boolean']['output']>;
  /** Remove a report's recipients row. */
  deleteReportRecipient: Scalars['Boolean']['output'];
  deleteRiskMeasures: Scalars['Int']['output'];
  deleteSavedKnowledgeBase: Scalars['Int']['output'];
  deleteShareClass: Scalars['Int']['output'];
  deleteStoredPrompts: Scalars['ID']['output'];
  deleteTemplateAttachment: Scalars['Boolean']['output'];
  deleteUsersXGroups: Scalars['ID']['output'];
  discardLlmTaskCandidate: LlmTaskCandidate;
  documentText_archiveAssistant?: Maybe<AsyncTaskStatus>;
  embedNotes: AsyncTaskStatus;
  evaluateLlmTaskCandidate: LlmTaskCandidate;
  firmNewsLoad: AsyncTaskStatus;
  flipSolutionsToPostgres: Scalars['Boolean']['output'];
  gDeltProjectNewsLoad: AsyncTaskStatus;
  generateEmRiskReports: Scalars['Boolean']['output'];
  generateEmbeddings: Scalars['Boolean']['output'];
  /** Give every member of a group write access to an organization skill. Owner (or super user) only. */
  grantChatSkillGroupAccess: ChatSkillGroup;
  importCalculatedIndices: AsyncTaskStatus;
  importCitcoHoldings: AsyncTaskStatus;
  /** Import Portfolio Returns: copy funds' monthly returns from the NAV model, then refresh their share classes from `start` (omit for their whole history). Omit rcgFundIds for every fund with a share class. Runs in the background. */
  importClientPortfolioReturns: AsyncTaskStatus;
  importGuidelineDefinitions: ImportResult;
  importHfrPerformance: AsyncTaskStatus;
  importRiskFromS3?: Maybe<ImportRiskFromS3Result>;
  importRiskMeasures: AsyncTaskStatus;
  importSalesforceSnapshot: AsyncTaskStatus;
  importSecurityMaster: AsyncTaskStatus;
  investmentReport: AsyncTaskStatus;
  /** Streams an LLM answer to the chatMessages subscription for sessionId */
  lexSendMessage: LexSendMessageResult;
  /** Link a queue item you own to the recorded email it came from. A no-op if already linked. Returns the link id. */
  linkDocumentQueueEmail: Scalars['String']['output'];
  /** Mark the given notifications read. Returns how many rows changed; ids belonging to another user match nothing. */
  markNotificationsRead: Scalars['Int']['output'];
  markRangerFieldsStale: Array<RangerStaleFieldInfo>;
  modifyGuidelineSetDate: GuidelineSet;
  moveGuidelineNode: GuidelineNode;
  newsNotify: AsyncTaskStatus;
  /** Leave the current user a notification. The recipient is always the caller — there is no way to notify anyone else. conversationId links the notification back to the conversation it came from and must belong to the caller. Returns false when the identical message already landed today (a retry), true when a new one was written. */
  notifyCurrentUser: Scalars['Boolean']['output'];
  optInToChatSkill: UserChatSkill;
  /** Deactivate an organization skill for the current user only — it stays active for everyone else */
  optOutOfChatSkill: Scalars['Boolean']['output'];
  persistConversationArtifact: ConversationArtifact;
  processDocumentQueue: Scalars['ID']['output'];
  promoteIntakeFirms: AsyncTaskStatus;
  promoteIntakeInvestments: AsyncTaskStatus;
  promoteLlmTaskCandidate: LlmTask;
  proposeLlmTaskChange: LlmTaskCandidate;
  publishDocumentQueues: Array<DocumentPublishResult>;
  publishFirmFieldDrafts: FirmFields;
  publishInvestmentFieldDrafts: InvestmentFields;
  rangerDueDilligenceDrafts: AsyncTaskStatus;
  reconcileNewPortalFirm: Scalars['Int']['output'];
  /** Record an inbound email's metadata, keyed by the mail provider's message id. A no-op if it is already recorded. Returns the email id. */
  recordEmailMetadata: Scalars['String']['output'];
  refreshAssetAllocation: AsyncTaskStatus;
  refreshInvestmentRisk: AsyncTaskStatus;
  refreshLlmModelBenchmarks: Array<LlmModel>;
  refreshLlmModelPrices: Array<LlmModel>;
  /** Refresh NAV model statements for a month from the prior month and the managers' returns, then rebuild the sub-portfolios and primary portfolios that read them. Requires the primary-portfolio editor role, and update access to each fund named; without rcgFundIds, refreshes every fund not fed from Solovis/Cogency and not a sub-portfolio. */
  refreshNavModel: AsyncTaskStatus;
  rematchDocumentQueueEntities: Array<Scalars['ID']['output']>;
  rematerializeSavedKnowledgeBase: Scalars['Int']['output'];
  removeNotificationSubscription: Scalars['Boolean']['output'];
  reorderGuidelineNode: GuidelineNode;
  replaceLlmModel: Array<LlmTaskCandidate>;
  reprocessDocumentQueues: Array<Scalars['ID']['output']>;
  rerunStaleRangerFields: AsyncTaskStatus;
  resaveDocuments: Scalars['JSONObject']['output'];
  resetSystemConfiguration: Scalars['Boolean']['output'];
  restoreAfsHolding: AfsHolding;
  retryFailedSteps: MutationPlan;
  revokeChatSkillGroupAccess: Scalars['Boolean']['output'];
  rollbackSolutionsToSqlServer: Scalars['Boolean']['output'];
  /** Enqueue an out-of-cycle run for this schedule immediately, without affecting its recurrence. */
  runChatSkillScheduleNow: Scalars['Boolean']['output'];
  /** Set a share class's addition and redemption for a month, both entered as positive amounts; both zero or null deletes the month's cash flow. */
  saveClientCashFlow: Scalars['Boolean']['output'];
  /** Save a month's actual end balances, entered fees and final returns for some share classes. Send only the rows that changed. For a derived share class only the final returns may be sent. */
  saveClientMonthEntries: Scalars['Boolean']['output'];
  /** Create or edit a share class and its fee schedules. Returns its id. */
  saveClientShareClass: Scalars['Int']['output'];
  /** Set a switch between two share classes for a month; an amount of zero deletes it. */
  saveClientSwitch: Scalars['Boolean']['output'];
  /** Save funds' estimate overrides for a month. Send only the funds that changed; a reconciled month is refused. */
  saveEarlyEstimates: Scalars['Boolean']['output'];
  saveFirmFieldDrafts: FirmFields;
  saveInvestmentFieldDrafts: InvestmentFields;
  saveLlmEvaluator: LlmEvaluator;
  /** Add a report's recipients, or edit them. */
  saveReportRecipient: ReportRecipientRow;
  /** Sends an email from the notification sender to users in the caller's organization. The body (text and/or html) is always prefixed with an automated-email disclaimer naming the user it was sent on behalf of. Attachments must be entitlement-checked documents or the caller's own temp uploads. */
  sendUserEmail: Scalars['Boolean']['output'];
  setCurrentTemplateVersion: Template;
  /** Hand a queue item you own to the user it was uploaded for. Returns the queue item id. */
  setDocumentQueueUser: Scalars['ID']['output'];
  setGuidelineArguments: Array<GuidelineArgument>;
  setJobScheduleEnabled: Scalars['Boolean']['output'];
  setJobSchedulePreviewAllowed: Scalars['Boolean']['output'];
  setLlmTaskDataset: LlmTask;
  setLlmTaskEvaluators: LlmTask;
  /** Set how the current user is told about one kind of event. Affects only their own delivery. */
  setNotificationChannels: Scalars['Boolean']['output'];
  setOrganizationSubscriber: Organization;
  setSolutionsShadowReads: Scalars['Boolean']['output'];
  setSolutionsSyncEnabled: Scalars['Boolean']['output'];
  /** Upsert a system configuration. Creates if key doesn't exist, updates if it does. */
  setSystemConfiguration: SystemConfiguration;
  sharePortfolio?: Maybe<Portfolio>;
  solovisCommitments: AsyncTaskStatus;
  solovisIdLoad: AsyncTaskStatus;
  solovisLiquidityLoad: AsyncTaskStatus;
  solovisPerformance: AsyncTaskStatus;
  solovisTrans: AsyncTaskStatus;
  stageMutationPlan: MutationPlan;
  stopChat: Scalars['Boolean']['output'];
  swapGuidelineNodeOrder: GuidelineNode;
  triggerAfsExtraction: Scalars['Int']['output'];
  triggerBatchReports: AsyncTaskStatus;
  triggerBoardDocumentProcessing: Scalars['String']['output'];
  triggerNoticeLegExtraction: Scalars['Int']['output'];
  triggerSolutionsSyncReconcile: Scalars['Boolean']['output'];
  updateAdEntriesXApplicationFlags: AdEntriesXApplicationFlags;
  updateAdEntriesXApplicationsXSets: AdEntriesXApplicationsXSets;
  updateAfsHolding: AfsHolding;
  updateAfsSecurityMapping: AfsSecurityMapping;
  updateChatAgent: ChatAgent;
  updateChatSkill: ChatSkill;
  updateChatSkillSchedule: ChatSkillSchedule;
  updateCompany: Company;
  updateCompanyFieldValues: CompanyFields;
  updateCompanyValuation: CompanyValuation;
  updateCustomAnalytics: CustomAnalytics;
  updateCustomIndexInvestment: CustomIndexInvestment;
  updateDeal: Deal;
  updateDocument: Document;
  updateEmailDomainXOrganization: EmailDomainXOrganization;
  updateFamily: Family;
  updateFdpLogin: FdpLogin;
  updateFdpWebsites: FdpWebsites;
  updateFieldDefinition: FieldDefinition;
  updateFinancialDataProvider: FinancialDataProvider;
  updateFirm: Firm;
  updateFirmEmployment: FirmEmployment;
  updateFirmEngagement: FirmEngagement;
  updateFirmFDPLogins: FirmFdpLogins;
  updateFirmFieldValues: FirmFields;
  updateFirmInstitutions: FirmInstitutions;
  updateFundsXProxies: FundsXProxies;
  updateGroupShareDefinition: GroupShareDefinition;
  updateGuideline: Guideline;
  updateGuidelineNode: GuidelineNode;
  updateGuidelineNote: GuidelineNote;
  updateGuidelineResult: GuidelineResult;
  updateInstitution: Institution;
  updateInstitutionEmployment: InstitutionEmployment;
  updateInvestment: Investment;
  updateInvestmentFDPLogins: InvestmentFdpLogins;
  updateInvestmentFieldValues: InvestmentFields;
  updateInvestmentFields: InvestmentFields;
  updateInvestmentFirmEmployment: InvestmentFirmEmployment;
  updateInvestmentInstitutions: InvestmentInstitutions;
  updateInvestmentPrivateQuartileGroupCategory: InvestmentPrivateQuartileGroupCategory;
  updateInvestmentSet: InvestmentSet;
  updateJobSchedule: JobSchedule;
  updateKnowledgeBaseTags: KnowledgeBaseTags;
  updateLinks: Links;
  updateLlmModel: LlmModel;
  updateMutationStepInput: MutationStep;
  updateNote: Notes;
  updateNoticeExtractionClient: NoticeExtraction;
  updateNoticeLeg: NoticeLeg;
  updateOrganization: Organization;
  updatePerformanceCommentary: PerformanceMtd;
  updatePerson: Person;
  updatePersonEducation: PersonEducation;
  updatePersonWorkExperience: PersonWorkExperience;
  updatePortalFirm: PortalFirm;
  updatePortalOrganization: PortalOrganization;
  updatePortalSubmitted: PortalSubmitted;
  updatePortalUser: PortalUser;
  updatePortfolio?: Maybe<Portfolio>;
  updatePortfolioConfig: PortfolioConfig;
  updatePortfolioEntries?: Maybe<Scalars['Boolean']['output']>;
  updatePortfolioFDPLogins: PortfolioFdpLogins;
  updateRiskRefreshList: RiskRefreshListList;
  updateSavedEntitySearch: SavedEntitySearch;
  updateSavedKnowledgeBase: SavedKnowledgeBase;
  updateServiceProviderDocuments: ServiceProviderDocuments;
  updateServiceProviderFirm: ServiceProviderFirm;
  updateServiceProviderNotes: ServiceProviderNotes;
  updateSet: Set;
  updateShareClass: ShareClass;
  updateTemplateAttachment: TemplateAttachment;
  updateUser: User;
  updateUserGroup: User;
  updateUsersXGroups: UsersXGroups;
  uploadPmeFile: AsyncTaskStatus;
  upsertNoticeNotificationConfig: NoticeNotificationConfig;
  verifyLlmModel: LlmModel;
};


export type MutationAamOptimizationRunArgs = {
  config: AamOptimizationInput;
  conversationId?: InputMaybe<Scalars['Int']['input']>;
  portfolioId: Scalars['Int']['input'];
};


export type MutationActivateUserArgs = {
  id: Scalars['Int']['input'];
};


export type MutationAddAdEntriesXApplicationFlagsArgs = {
  input: AdEntriesXApplicationFlagsInput;
};


export type MutationAddAdEntriesXApplicationsXSetsArgs = {
  input: AdEntriesXApplicationsXSetsInput;
};


export type MutationAddAsyncTaskStatusArgs = {
  input: AsyncTaskStatusInput;
};


export type MutationAddChatSkillScheduleArgs = {
  input: ChatSkillScheduleInput;
};


export type MutationAddCogencyLinkArgs = {
  input: CogencyLinkInput;
};


export type MutationAddCompanyArgs = {
  input: CompanyInput;
};


export type MutationAddCompanyValuationArgs = {
  input: CompanyValuationInput;
};


export type MutationAddCustomAnalyticsArgs = {
  input: CustomAnalyticsInput;
};


export type MutationAddCustomIndexInvestmentArgs = {
  input: CustomIndexInvestmentInput;
};


export type MutationAddDealArgs = {
  input: DealInput;
};


export type MutationAddDocumentArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  input: DocumentInput;
};


export type MutationAddDocumentQueueSignedUriArgs = {
  names: Array<Scalars['String']['input']>;
};


export type MutationAddEmailDomainXOrganizationArgs = {
  input: EmailDomainXOrganizationInput;
};


export type MutationAddFamilyArgs = {
  input: FamilyInput;
};


export type MutationAddFdpLoginArgs = {
  input: FdpLoginInput;
};


export type MutationAddFdpWebsitesArgs = {
  input: FdpWebsitesInput;
};


export type MutationAddFinancialDataProviderArgs = {
  input: FinancialDataProviderInput;
};


export type MutationAddFirmArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  input: FirmInput;
};


export type MutationAddFirmEmploymentArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  input: FirmEmploymentInput;
};


export type MutationAddFirmEngagementArgs = {
  input: FirmEngagementInput;
};


export type MutationAddFirmFdpLoginsArgs = {
  input: FirmFdpLoginsInput;
};


export type MutationAddFirmInstitutionsArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  input: FirmInstitutionsInput;
};


export type MutationAddFundsXProxiesArgs = {
  input: FundsXProxiesInput;
};


export type MutationAddGroupShareDefinitionArgs = {
  input: GroupShareDefinitionInput;
};


export type MutationAddInstitutionArgs = {
  input: InstitutionInput;
};


export type MutationAddInstitutionEmploymentArgs = {
  input: InstitutionEmploymentInput;
};


export type MutationAddInvestmentArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  input: InvestmentInput;
};


export type MutationAddInvestmentAccessRequestArgs = {
  input: InvestmentAccessRequestInput;
};


export type MutationAddInvestmentAxysCodeArgs = {
  input: InvestmentAxysCodeInput;
};


export type MutationAddInvestmentFdpLoginsArgs = {
  input: InvestmentFdpLoginsInput;
};


export type MutationAddInvestmentFirmEmploymentArgs = {
  input: InvestmentFirmEmploymentInput;
};


export type MutationAddInvestmentFirmEmploymentRecordsArgs = {
  input: Array<InvestmentFirmEmploymentInput>;
};


export type MutationAddInvestmentInstitutionsArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  input: InvestmentInstitutionsInput;
};


export type MutationAddInvestmentPrivateQuartileGroupCategoryArgs = {
  input: InvestmentPrivateQuartileGroupCategoryInput;
};


export type MutationAddInvestmentSetArgs = {
  input: InvestmentSetInput;
};


export type MutationAddInvestmentsFamilyArgs = {
  input: InvestmentsFamilyInput;
};


export type MutationAddKnowledgeBaseTagsArgs = {
  input: KnowledgeBaseTagsInput;
};


export type MutationAddLinksArgs = {
  input: LinksInput;
};


export type MutationAddNoteArgs = {
  input: NotesInput;
};


export type MutationAddNotificationSubscriptionArgs = {
  eventType: NotificationEventType;
  groupId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAddOrUpdateAumArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  input: Array<AumEntry>;
  investmentId: Scalars['Int']['input'];
};


export type MutationAddOrUpdateAssumeUserArgs = {
  input: AssumeUserInput;
};


export type MutationAddOrUpdateCloseDateSizeArgs = {
  input: ManyCloseDateFundSize;
};


export type MutationAddOrUpdateCogencyLinkArgs = {
  id: Scalars['Int']['input'];
  input: CogencyLinkInput;
};


export type MutationAddOrUpdatePerformanceMtdArgs = {
  input: ManyPerformanceMtd;
};


export type MutationAddOrUpdatePerformancePrivateArgs = {
  input: ManyPerformancePrivate;
};


export type MutationAddOrUpdatePerformanceQuarterlyArgs = {
  input: ManyPerformanceQuarterly;
};


export type MutationAddOrUpdateUserSettingsArgs = {
  input: UserSettingsInput;
};


export type MutationAddPersonArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  input: PersonInput;
};


export type MutationAddPersonEducationArgs = {
  input: PersonEducationInput;
};


export type MutationAddPersonWorkExperienceArgs = {
  input: PersonWorkExperienceInput;
};


export type MutationAddPortalOrganizationArgs = {
  input: PortalOrganizationCreateInput;
};


export type MutationAddPortalServiceProviderFirmArgs = {
  input: PortalServiceProviderFirmInput;
};


export type MutationAddPortfolioConfigArgs = {
  input: PortfolioConfigInput;
};


export type MutationAddPortfolioFdpLoginsArgs = {
  input: PortfolioFdpLoginsInput;
};


export type MutationAddRecentlyViewedInvestmentArgs = {
  input: RecentlyViewedInvestmentInput;
};


export type MutationAddSavedEntitySearchArgs = {
  input: SavedEntitySearchInput;
};


export type MutationAddSavedKnowledgeBaseArgs = {
  input: SavedKnowledgeBaseInput;
};


export type MutationAddServiceProviderDocumentsArgs = {
  input: ServiceProviderDocumentsInput;
};


export type MutationAddServiceProviderFirmArgs = {
  input: ServiceProviderFirmInput;
};


export type MutationAddServiceProviderNotesArgs = {
  input: ServiceProviderNotesInput;
};


export type MutationAddSetArgs = {
  input: SetInput;
};


export type MutationAddShareClassArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  input: ShareClassInput;
};


export type MutationAddStoredPromptsArgs = {
  input: StoredPromptsInput;
};


export type MutationAddTempFilesArgs = {
  input: Array<TempFileUpload>;
};


export type MutationAddUserActivityArgs = {
  input: UserActivityInput;
};


export type MutationAddUsersXGroupsArgs = {
  input: UsersXGroupsInput;
};


export type MutationAdvPullArgs = {
  firmIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  timeStamp: Scalars['String']['input'];
};


export type MutationAdvServiceProviderParseArgs = {
  docId: Scalars['Int']['input'];
};


export type MutationAlphaVantage_Extract_FxMonthlyArgs = {
  fromCurrency: Scalars['String']['input'];
  replace: Scalars['Boolean']['input'];
  toCurrency: Scalars['String']['input'];
};


export type MutationAlphaVantage_Load_FxMonthlyArgs = {
  transformKey: Scalars['String']['input'];
};


export type MutationAlphaVantage_Transform_FxMonthlyArgs = {
  extractBodyKey: Scalars['String']['input'];
  extractHeadKey: Scalars['String']['input'];
  replace: Scalars['Boolean']['input'];
};


export type MutationAnalyseDiligenceGapsArgs = {
  investmentId: Scalars['Int']['input'];
  run?: InputMaybe<DiligenceDraftRunInput>;
};


export type MutationApproveMutationPlanArgs = {
  planId: Scalars['Int']['input'];
};


export type MutationAssignAfsHoldingMappingArgs = {
  holdingId: Scalars['Int']['input'];
  isProxy?: Scalars['Boolean']['input'];
  securityMasterId: Scalars['Int']['input'];
};


export type MutationBloombergDiligenceExtractArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  investmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBloombergDiligenceLoadArgs = {
  inputs: Array<BloombergPullLoadInput>;
};


export type MutationBulkAddAdvSummaryEmailNotificationArgs = {
  input: AdvSummaryEmailNotificationBulkInput;
};


export type MutationBulkHardDeleteDocumentsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationBulkUpsertPerformanceMtdArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  input: Array<ManyPerformanceMtd>;
};


export type MutationBulkUpsertPerformancePrivateArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  input: Array<ManyPerformancePrivate>;
};


export type MutationBulkUpsertPerformanceQuarterlyArgs = {
  input: Array<ManyPerformanceQuarterly>;
};


export type MutationCancelMutationPlanArgs = {
  planId: Scalars['Int']['input'];
};


export type MutationCaseStudySlidesArgs = {
  aiShorten?: InputMaybe<Scalars['Boolean']['input']>;
  asOfDate?: InputMaybe<Scalars['String']['input']>;
  assetType: CaseStudyAssetType;
  conversationId?: InputMaybe<Scalars['Int']['input']>;
  investmentId: Scalars['Int']['input'];
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  shareClassId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationClearUserSettingArgs = {
  input: ClearSettingInput;
};


export type MutationComputeGuidelineMetricsArgs = {
  date: Scalars['DateTime']['input'];
  investmentId: Scalars['Int']['input'];
  setId: Scalars['Int']['input'];
};


export type MutationConfirmNoticeFundMappingArgs = {
  investmentId: Scalars['Int']['input'];
  mappingId: Scalars['Int']['input'];
};


export type MutationConfirmOrganizationIconUploadArgs = {
  organizationId: Scalars['Int']['input'];
};


export type MutationConfirmPmeMappingsArgs = {
  mappings: Array<PmeMappingConfirmationInput>;
  uploadId: Scalars['Int']['input'];
};


export type MutationCopyInvestmentOverviewArgs = {
  destFirmGroupId: Scalars['Int']['input'];
  destInvestmentGroupId: Scalars['Int']['input'];
  fundIds: Array<Scalars['Int']['input']>;
};


export type MutationCopyPortfolioArgs = {
  asOfDate?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['Int']['input'];
  input: PortfolioInput;
};


export type MutationCopyRiskMeasuresArgs = {
  sourceInvestmentId: Scalars['Int']['input'];
  targetInvestmentId: Scalars['Int']['input'];
};


export type MutationCreateChatAgentArgs = {
  input: ChatAgentInput;
};


export type MutationCreateChatSkillArgs = {
  input: ChatSkillInput;
};


export type MutationCreateFieldDefinitionArgs = {
  input: CreateFieldDefinitionInput;
};


export type MutationCreateGuidelineNodeArgs = {
  guidelineInput?: InputMaybe<CreateGuidelineInput>;
  input: CreateGuidelineNodeInput;
  investmentId: Scalars['Int']['input'];
  setId: Scalars['Int']['input'];
};


export type MutationCreateGuidelineSetArgs = {
  input: CreateGuidelineSetInput;
  investmentId: Scalars['Int']['input'];
};


export type MutationCreateLlmModelArgs = {
  input: LlmModelInput;
};


export type MutationCreateOrUpdateFirmDeiArgs = {
  input: FirmDeiCreateOrUpdate;
};


export type MutationCreateOrganizationArgs = {
  input: OrganizationCreateInput;
};


export type MutationCreatePortfolioArgs = {
  input: PortfolioInput;
};


export type MutationCreateTemplateArgs = {
  input: CreateTemplateInput;
};


export type MutationCreateTemplateAttachmentArgs = {
  input: CreateTemplateAttachmentInput;
};


export type MutationCreateUserArgs = {
  input: UserCreateInput;
};


export type MutationCreateUserGroupArgs = {
  input: UserGroupCreateInput;
};


export type MutationDeactivateUserArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteAdEntriesXApplicationFlagsArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteAdEntriesXApplicationsXSetsArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteAfsHoldingArgs = {
  holdingId: Scalars['Int']['input'];
};


export type MutationDeleteChatAgentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteChatSkillArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteChatSkillScheduleArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteClientShareClassArgs = {
  shareClassId: Scalars['Int']['input'];
};


export type MutationDeleteCompanyFieldValuesArgs = {
  companyId: Scalars['Int']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  values: Array<FieldValueInput>;
};


export type MutationDeleteCompanyValuationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteConversationArgs = {
  conversationId: Scalars['Int']['input'];
};


export type MutationDeleteDocumentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteDocumentQueueArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEmailDomainXOrganizationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteFdpLoginArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteFdpWebsitesArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteFieldDefinitionArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteFirmArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFirmDeiArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFirmEmploymentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteFirmEngagementArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteFirmFieldValuesArgs = {
  firmId: Scalars['Int']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  values: Array<FieldValueInput>;
};


export type MutationDeleteFirmInstitutionsArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteFundsXProxiesArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteGroupShareDefinitionArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteGuidelineNodeArgs = {
  investmentId: Scalars['Int']['input'];
  nodeId: Scalars['Int']['input'];
};


export type MutationDeleteGuidelineSetArgs = {
  investmentId: Scalars['Int']['input'];
};


export type MutationDeleteInvestmentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteInvestmentAxysCodeArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteInvestmentFieldValuesArgs = {
  investmentId: Scalars['Int']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  values: Array<FieldValueInput>;
};


export type MutationDeleteInvestmentFieldsArgs = {
  fields: InvestmentFieldsInput;
  investmentId: Scalars['Int']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteInvestmentFirmEmploymentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteInvestmentInstitutionsArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteInvestmentPrivateQuartileGroupCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteInvestmentSetArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteInvestmentsFamilyArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteLinksArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteNoteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteNoticeNotificationConfigArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeletePersonEducationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeletePersonWorkExperienceArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeletePortalFirmArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePortalOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePortalServiceProviderFirmArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeletePortalSubmittedArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePortalUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePortfolioArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteReportRecipientArgs = {
  reportId: Scalars['Int']['input'];
};


export type MutationDeleteRiskMeasuresArgs = {
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  investmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  listType: DeleteInvestmentRiskListType;
  maxDate?: InputMaybe<Scalars['DateTime']['input']>;
  minDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationDeleteSavedKnowledgeBaseArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteShareClassArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteStoredPromptsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTemplateAttachmentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteUsersXGroupsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDiscardLlmTaskCandidateArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDocumentText_ArchiveAssistantArgs = {
  documentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  forceIfSameText?: InputMaybe<Scalars['Boolean']['input']>;
  needsExtraction?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationEmbedNotesArgs = {
  timeStamp: Scalars['String']['input'];
};


export type MutationEvaluateLlmTaskCandidateArgs = {
  id: Scalars['Int']['input'];
};


export type MutationFlipSolutionsToPostgresArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationGenerateEmRiskReportsArgs = {
  emailRecipients?: Array<Scalars['String']['input']>;
  reports: Array<EmRiskReportConfigInput>;
};


export type MutationGenerateEmbeddingsArgs = {
  documentId: Scalars['Int']['input'];
};


export type MutationGrantChatSkillGroupAccessArgs = {
  chatSkillId: Scalars['Int']['input'];
  groupId: Scalars['Int']['input'];
};


export type MutationImportCalculatedIndicesArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationImportCitcoHoldingsArgs = {
  asOfDate: Scalars['Date']['input'];
  file: Scalars['Upload']['input'];
};


export type MutationImportClientPortfolioReturnsArgs = {
  rcgFundIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  start?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationImportGuidelineDefinitionsArgs = {
  investmentId: Scalars['Int']['input'];
  nodes: Array<ImportGuidelineNodeInput>;
  setId: Scalars['Int']['input'];
};


export type MutationImportHfrPerformanceArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationImportRiskFromS3Args = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  input: ImportRiskFromS3Input;
};


export type MutationImportRiskMeasuresArgs = {
  conversationArtifactId?: InputMaybe<Scalars['Int']['input']>;
  errorRowLimit?: InputMaybe<Scalars['Int']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  isEstimated: Scalars['Boolean']['input'];
  notify?: InputMaybe<Scalars['Boolean']['input']>;
  validateOnly: Scalars['Boolean']['input'];
};


export type MutationImportSalesforceSnapshotArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationImportSecurityMasterArgs = {
  file: Scalars['Upload']['input'];
  target: SecurityMasterImportTarget;
};


export type MutationInvestmentReportArgs = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  conversationId?: InputMaybe<Scalars['Int']['input']>;
  elements?: InputMaybe<Array<ReportStructure>>;
  format: FormatOptions;
  includeHoldings?: InputMaybe<Scalars['Boolean']['input']>;
  includeImpactAreas?: InputMaybe<Scalars['Boolean']['input']>;
  includeReportFund?: InputMaybe<Scalars['Boolean']['input']>;
  investmentId: Scalars['Int']['input'];
  reportType: ReportTypeOptions;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  subSections?: InputMaybe<Array<SubSections>>;
};


export type MutationLexSendMessageArgs = {
  input: LexSendMessageInput;
};


export type MutationLinkDocumentQueueEmailArgs = {
  documentQueueId: Scalars['ID']['input'];
  emailId: Scalars['String']['input'];
};


export type MutationMarkNotificationsReadArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationMarkRangerFieldsStaleArgs = {
  documentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  investmentId: Scalars['Int']['input'];
  noteIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type MutationModifyGuidelineSetDateArgs = {
  effectiveDate: Scalars['DateTime']['input'];
  investmentId: Scalars['Int']['input'];
};


export type MutationMoveGuidelineNodeArgs = {
  investmentId: Scalars['Int']['input'];
  newParentId?: InputMaybe<Scalars['Int']['input']>;
  nodeId: Scalars['Int']['input'];
  siblingIndex: Scalars['Int']['input'];
};


export type MutationNotifyCurrentUserArgs = {
  conversationId?: InputMaybe<Scalars['Int']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
};


export type MutationOptInToChatSkillArgs = {
  chatSkillId: Scalars['Int']['input'];
};


export type MutationOptOutOfChatSkillArgs = {
  chatSkillId: Scalars['Int']['input'];
};


export type MutationPersistConversationArtifactArgs = {
  input: PersistConversationArtifactInput;
};


export type MutationProcessDocumentQueueArgs = {
  documentQueueId: Scalars['ID']['input'];
};


export type MutationPromoteIntakeFirmsArgs = {
  dei: Scalars['Boolean']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  firms: Scalars['Boolean']['input'];
  resetShouldUpdate: Scalars['Boolean']['input'];
};


export type MutationPromoteIntakeInvestmentsArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  steps?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationPromoteLlmTaskCandidateArgs = {
  id: Scalars['Int']['input'];
  overrideReason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProposeLlmTaskChangeArgs = {
  key: Scalars['String']['input'];
  modelKey?: InputMaybe<Scalars['String']['input']>;
  prompts?: Array<LlmTaskPromptInput>;
};


export type MutationPublishDocumentQueuesArgs = {
  input: Array<DocumentQueuePublishInput>;
};


export type MutationPublishFirmFieldDraftsArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  fieldKeys: Array<Scalars['String']['input']>;
  firmId: Scalars['Int']['input'];
};


export type MutationPublishInvestmentFieldDraftsArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  fieldKeys: Array<Scalars['String']['input']>;
  investmentId: Scalars['Int']['input'];
};


export type MutationRangerDueDilligenceDraftsArgs = {
  customPromptsInput?: InputMaybe<Array<CustomPromptsInput>>;
  fieldKeys: Array<Scalars['String']['input']>;
  investmentId: Scalars['Int']['input'];
  ragLimits?: InputMaybe<Scalars['Int']['input']>;
  retain?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationReconcileNewPortalFirmArgs = {
  input: ReconcileNewPortalFirmInput;
};


export type MutationRecordEmailMetadataArgs = {
  input: EmailMetadataInput;
};


export type MutationRefreshAssetAllocationArgs = {
  portfolioIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type MutationRefreshInvestmentRiskArgs = {
  investmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  listType: RefreshInvestmentRiskListType;
  partitionCount?: InputMaybe<Scalars['Int']['input']>;
  partitionIndex?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRefreshNavModelArgs = {
  rcgFundIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  tranDate: Scalars['Date']['input'];
};


export type MutationRematchDocumentQueueEntitiesArgs = {
  documentQueueIds: Array<Scalars['ID']['input']>;
};


export type MutationRematerializeSavedKnowledgeBaseArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveNotificationSubscriptionArgs = {
  id: Scalars['Int']['input'];
};


export type MutationReorderGuidelineNodeArgs = {
  investmentId: Scalars['Int']['input'];
  nodeId: Scalars['Int']['input'];
  siblingIndex: Scalars['Int']['input'];
};


export type MutationReplaceLlmModelArgs = {
  id: Scalars['Int']['input'];
  replacementKey: Scalars['String']['input'];
};


export type MutationReprocessDocumentQueuesArgs = {
  documentQueueIds: Array<Scalars['ID']['input']>;
};


export type MutationRerunStaleRangerFieldsArgs = {
  fieldKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  investmentId: Scalars['Int']['input'];
};


export type MutationResaveDocumentsArgs = {
  credentials: ResaveDocumentCredentials;
  ids: Array<Scalars['Int']['input']>;
};


export type MutationResetSystemConfigurationArgs = {
  key: SystemConfigurationKey;
};


export type MutationRestoreAfsHoldingArgs = {
  holdingId: Scalars['Int']['input'];
};


export type MutationRetryFailedStepsArgs = {
  planId: Scalars['Int']['input'];
};


export type MutationRevokeChatSkillGroupAccessArgs = {
  chatSkillId: Scalars['Int']['input'];
  groupId: Scalars['Int']['input'];
};


export type MutationRollbackSolutionsToSqlServerArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRunChatSkillScheduleNowArgs = {
  id: Scalars['Int']['input'];
};


export type MutationSaveClientCashFlowArgs = {
  addition?: InputMaybe<Scalars['Float']['input']>;
  month: Scalars['Date']['input'];
  redemption?: InputMaybe<Scalars['Float']['input']>;
  shareClassId: Scalars['Int']['input'];
};


export type MutationSaveClientMonthEntriesArgs = {
  entries: Array<ClientMonthEntryInput>;
  month: Scalars['Date']['input'];
};


export type MutationSaveClientShareClassArgs = {
  input: ClientShareClassInput;
};


export type MutationSaveClientSwitchArgs = {
  amount: Scalars['Float']['input'];
  fromShareClassId: Scalars['Int']['input'];
  month: Scalars['Date']['input'];
  toShareClassId: Scalars['Int']['input'];
};


export type MutationSaveEarlyEstimatesArgs = {
  estimates: Array<EarlyEstimateInput>;
  month: Scalars['Date']['input'];
};


export type MutationSaveFirmFieldDraftsArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  firmId: Scalars['Int']['input'];
  values: Array<FieldValueInput>;
};


export type MutationSaveInvestmentFieldDraftsArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  investmentId: Scalars['Int']['input'];
  values: Array<FieldValueInput>;
};


export type MutationSaveLlmEvaluatorArgs = {
  input: LlmEvaluatorInput;
};


export type MutationSaveReportRecipientArgs = {
  input: ReportRecipientInput;
};


export type MutationSendUserEmailArgs = {
  attachments?: InputMaybe<Array<EmailAttachmentInput>>;
  body?: InputMaybe<Scalars['String']['input']>;
  cc?: InputMaybe<Array<Scalars['String']['input']>>;
  emails: Array<Scalars['String']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
};


export type MutationSetCurrentTemplateVersionArgs = {
  templateId: Scalars['Int']['input'];
};


export type MutationSetDocumentQueueUserArgs = {
  documentQueueId: Scalars['ID']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationSetGuidelineArgumentsArgs = {
  arguments: Array<GuidelineArgumentInput>;
  guidelineId: Scalars['Int']['input'];
  investmentId: Scalars['Int']['input'];
};


export type MutationSetJobScheduleEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};


export type MutationSetJobSchedulePreviewAllowedArgs = {
  allowed: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};


export type MutationSetLlmTaskDatasetArgs = {
  dataset?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
};


export type MutationSetLlmTaskEvaluatorsArgs = {
  evaluatorKeys: Array<Scalars['String']['input']>;
  key: Scalars['String']['input'];
};


export type MutationSetNotificationChannelsArgs = {
  email: Scalars['Boolean']['input'];
  eventType: NotificationEventType;
  muted?: InputMaybe<Scalars['Boolean']['input']>;
  toast: Scalars['Boolean']['input'];
};


export type MutationSetOrganizationSubscriberArgs = {
  organizationId: Scalars['Int']['input'];
  subscriberOrganizationId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSetSolutionsShadowReadsArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationSetSolutionsSyncEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  entity: Scalars['String']['input'];
};


export type MutationSetSystemConfigurationArgs = {
  input: SystemConfigurationInput;
};


export type MutationSharePortfolioArgs = {
  id: Scalars['Int']['input'];
  input: SharePortfolioInput;
};


export type MutationSolovisPerformanceArgs = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type MutationSolovisTransArgs = {
  endMonth: Scalars['Int']['input'];
  endYear: Scalars['Int']['input'];
  startMonth: Scalars['Int']['input'];
  startYear: Scalars['Int']['input'];
};


export type MutationStageMutationPlanArgs = {
  input: StageMutationPlanInput;
};


export type MutationStopChatArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationSwapGuidelineNodeOrderArgs = {
  direction: Scalars['String']['input'];
  investmentId: Scalars['Int']['input'];
  nodeId: Scalars['Int']['input'];
};


export type MutationTriggerAfsExtractionArgs = {
  documentId: Scalars['Int']['input'];
};


export type MutationTriggerBatchReportsArgs = {
  input: BatchReportsInput;
};


export type MutationTriggerBoardDocumentProcessingArgs = {
  documentQueueIds: Array<Scalars['String']['input']>;
  existingSpreadsheetId?: InputMaybe<Scalars['Int']['input']>;
  investmentId: Scalars['Int']['input'];
};


export type MutationTriggerNoticeLegExtractionArgs = {
  documentId: Scalars['Int']['input'];
};


export type MutationTriggerSolutionsSyncReconcileArgs = {
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  deep?: InputMaybe<Scalars['Boolean']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  maxBatchesPerEntity?: InputMaybe<Scalars['Int']['input']>;
  maxOrphanFraction?: InputMaybe<Scalars['Float']['input']>;
  mode: SyncMode;
  throttleMs?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateAdEntriesXApplicationFlagsArgs = {
  id: Scalars['Int']['input'];
  input: AdEntriesXApplicationFlagsInput;
};


export type MutationUpdateAdEntriesXApplicationsXSetsArgs = {
  id: Scalars['Int']['input'];
  input: AdEntriesXApplicationsXSetsInput;
};


export type MutationUpdateAfsHoldingArgs = {
  fairValue?: InputMaybe<Scalars['Float']['input']>;
  holdingId: Scalars['Int']['input'];
  holdingName?: InputMaybe<Scalars['String']['input']>;
  holdingType?: InputMaybe<Scalars['String']['input']>;
  percentageOfNav?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdateAfsSecurityMappingArgs = {
  isProxy?: Scalars['Boolean']['input'];
  mappingId: Scalars['Int']['input'];
  securityMasterId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateChatAgentArgs = {
  id: Scalars['Int']['input'];
  input: ChatAgentUpdateInput;
};


export type MutationUpdateChatSkillArgs = {
  id: Scalars['Int']['input'];
  input: ChatSkillUpdateInput;
};


export type MutationUpdateChatSkillScheduleArgs = {
  id: Scalars['Int']['input'];
  input: ChatSkillScheduleInput;
};


export type MutationUpdateCompanyArgs = {
  id: Scalars['Int']['input'];
  input: CompanyInput;
};


export type MutationUpdateCompanyFieldValuesArgs = {
  companyId: Scalars['Int']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  values: Array<FieldValueInput>;
};


export type MutationUpdateCompanyValuationArgs = {
  id: Scalars['Int']['input'];
  input: CompanyValuationInput;
};


export type MutationUpdateCustomAnalyticsArgs = {
  id: Scalars['String']['input'];
  input: CustomAnalyticsInput;
};


export type MutationUpdateCustomIndexInvestmentArgs = {
  id: Scalars['Int']['input'];
  input: CustomIndexInvestmentInput;
};


export type MutationUpdateDealArgs = {
  id: Scalars['Int']['input'];
  input: DealInput;
};


export type MutationUpdateDocumentArgs = {
  id: Scalars['Int']['input'];
  input: DocumentUpdateInput;
};


export type MutationUpdateEmailDomainXOrganizationArgs = {
  id: Scalars['Int']['input'];
  input: EmailDomainXOrganizationInput;
};


export type MutationUpdateFamilyArgs = {
  id: Scalars['Int']['input'];
  input: FamilyInput;
};


export type MutationUpdateFdpLoginArgs = {
  id: Scalars['Int']['input'];
  input: FdpLoginInput;
};


export type MutationUpdateFdpWebsitesArgs = {
  id: Scalars['Int']['input'];
  input: FdpWebsitesInput;
};


export type MutationUpdateFieldDefinitionArgs = {
  input: UpdateFieldDefinitionInput;
};


export type MutationUpdateFinancialDataProviderArgs = {
  id: Scalars['Int']['input'];
  input: FinancialDataProviderInput;
};


export type MutationUpdateFirmArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  input: FirmInput;
};


export type MutationUpdateFirmEmploymentArgs = {
  id: Scalars['Int']['input'];
  input: FirmEmploymentInput;
};


export type MutationUpdateFirmEngagementArgs = {
  id: Scalars['Int']['input'];
  input: FirmEngagementInput;
};


export type MutationUpdateFirmFdpLoginsArgs = {
  id: Scalars['Int']['input'];
  input: FirmFdpLoginsInput;
};


export type MutationUpdateFirmFieldValuesArgs = {
  firmId: Scalars['Int']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  values: Array<FieldValueInput>;
};


export type MutationUpdateFirmInstitutionsArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  input: FirmInstitutionsInput;
};


export type MutationUpdateFundsXProxiesArgs = {
  id: Scalars['Int']['input'];
  input: FundsXProxiesInput;
};


export type MutationUpdateGroupShareDefinitionArgs = {
  id: Scalars['Int']['input'];
  input: GroupShareDefinitionInput;
};


export type MutationUpdateGuidelineArgs = {
  guidelineId: Scalars['Int']['input'];
  input: UpdateGuidelineInput;
  investmentId: Scalars['Int']['input'];
};


export type MutationUpdateGuidelineNodeArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  investmentId: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['Int']['input'];
};


export type MutationUpdateGuidelineNoteArgs = {
  date: Scalars['DateTime']['input'];
  input: UpdateGuidelineNoteInput;
  investmentId: Scalars['Int']['input'];
};


export type MutationUpdateGuidelineResultArgs = {
  date: Scalars['DateTime']['input'];
  guidelineId: Scalars['Int']['input'];
  input: UpdateGuidelineResultInput;
  investmentId: Scalars['Int']['input'];
};


export type MutationUpdateInstitutionArgs = {
  id: Scalars['Int']['input'];
  input: InstitutionInput;
};


export type MutationUpdateInstitutionEmploymentArgs = {
  id: Scalars['Int']['input'];
  input: InstitutionEmploymentInput;
};


export type MutationUpdateInvestmentArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  input: InvestmentInput;
};


export type MutationUpdateInvestmentFdpLoginsArgs = {
  id: Scalars['Int']['input'];
  input: InvestmentFdpLoginsInput;
};


export type MutationUpdateInvestmentFieldValuesArgs = {
  investmentId: Scalars['Int']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  values: Array<FieldValueInput>;
};


export type MutationUpdateInvestmentFieldsArgs = {
  fields: InvestmentFieldsInput;
  investmentId: Scalars['Int']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateInvestmentFirmEmploymentArgs = {
  id: Scalars['Int']['input'];
  input: InvestmentFirmEmploymentInput;
};


export type MutationUpdateInvestmentInstitutionsArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  input: InvestmentInstitutionsInput;
};


export type MutationUpdateInvestmentPrivateQuartileGroupCategoryArgs = {
  id: Scalars['Int']['input'];
  input: InvestmentPrivateQuartileGroupCategoryInput;
};


export type MutationUpdateInvestmentSetArgs = {
  id: Scalars['Int']['input'];
  input: InvestmentSetInput;
};


export type MutationUpdateJobScheduleArgs = {
  input: JobScheduleUpdateInput;
};


export type MutationUpdateKnowledgeBaseTagsArgs = {
  id: Scalars['Int']['input'];
  input: KnowledgeBaseTagsInput;
};


export type MutationUpdateLinksArgs = {
  id: Scalars['Int']['input'];
  input: LinksInput;
};


export type MutationUpdateLlmModelArgs = {
  id: Scalars['Int']['input'];
  input: LlmModelUpdateInput;
};


export type MutationUpdateMutationStepInputArgs = {
  input: Scalars['JSON']['input'];
  stepId: Scalars['Int']['input'];
};


export type MutationUpdateNoteArgs = {
  id: Scalars['Int']['input'];
  input: NotesInput;
};


export type MutationUpdateNoticeExtractionClientArgs = {
  clientInvestmentId: Scalars['Int']['input'];
  extractionId: Scalars['Int']['input'];
};


export type MutationUpdateNoticeLegArgs = {
  input: UpdateNoticeLegInput;
  legId: Scalars['Int']['input'];
};


export type MutationUpdateOrganizationArgs = {
  id: Scalars['Int']['input'];
  input: OrganizationInput;
};


export type MutationUpdatePerformanceCommentaryArgs = {
  input: PerformanceCommentaryInput;
};


export type MutationUpdatePersonArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  input: PersonInput;
};


export type MutationUpdatePersonEducationArgs = {
  id: Scalars['Int']['input'];
  input: PersonEducationInput;
};


export type MutationUpdatePersonWorkExperienceArgs = {
  id: Scalars['Int']['input'];
  input: PersonWorkExperienceInput;
};


export type MutationUpdatePortalFirmArgs = {
  id: Scalars['String']['input'];
  input: PortalFirmInput;
};


export type MutationUpdatePortalOrganizationArgs = {
  id: Scalars['ID']['input'];
  input: PortalOrganizationInput;
};


export type MutationUpdatePortalSubmittedArgs = {
  id: Scalars['String']['input'];
  input: PortalSubmittedInput;
};


export type MutationUpdatePortalUserArgs = {
  id: Scalars['ID']['input'];
  input: PortalUserInput;
};


export type MutationUpdatePortfolioArgs = {
  id: Scalars['Int']['input'];
  input: PortfolioInput;
};


export type MutationUpdatePortfolioConfigArgs = {
  id: Scalars['Int']['input'];
  input: PortfolioConfigInput;
};


export type MutationUpdatePortfolioEntriesArgs = {
  input: Array<PortfolioEntryInput>;
  portfolioId: Scalars['Int']['input'];
};


export type MutationUpdatePortfolioFdpLoginsArgs = {
  id: Scalars['Int']['input'];
  input: PortfolioFdpLoginsInput;
};


export type MutationUpdateRiskRefreshListArgs = {
  input: RiskRefreshListInput;
};


export type MutationUpdateSavedEntitySearchArgs = {
  id: Scalars['Int']['input'];
  input: SavedEntitySearchInput;
};


export type MutationUpdateSavedKnowledgeBaseArgs = {
  id: Scalars['Int']['input'];
  input: SavedKnowledgeBaseInput;
};


export type MutationUpdateServiceProviderDocumentsArgs = {
  id: Scalars['Int']['input'];
  input: ServiceProviderDocumentsInput;
};


export type MutationUpdateServiceProviderFirmArgs = {
  id: Scalars['Int']['input'];
  input: ServiceProviderFirmInput;
};


export type MutationUpdateServiceProviderNotesArgs = {
  id: Scalars['Int']['input'];
  input: ServiceProviderNotesInput;
};


export type MutationUpdateSetArgs = {
  id: Scalars['Int']['input'];
  input: SetInput;
};


export type MutationUpdateShareClassArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  input: ShareClassInput;
};


export type MutationUpdateTemplateAttachmentArgs = {
  input: UpdateTemplateAttachmentInput;
};


export type MutationUpdateUserArgs = {
  id: Scalars['Int']['input'];
  input: UserUpdateInput;
};


export type MutationUpdateUserGroupArgs = {
  id: Scalars['Int']['input'];
  input: UserGroupUpdateInput;
};


export type MutationUpdateUsersXGroupsArgs = {
  id: Scalars['ID']['input'];
  input: UsersXGroupsInput;
};


export type MutationUploadPmeFileArgs = {
  file: Scalars['Upload']['input'];
  investmentId: Scalars['Int']['input'];
};


export type MutationUpsertNoticeNotificationConfigArgs = {
  input: NoticeNotificationConfigInput;
};


export type MutationVerifyLlmModelArgs = {
  id: Scalars['Int']['input'];
};

export type MutationAccess = {
  __typename?: 'MutationAccess';
  canAccess: Scalars['Boolean']['output'];
  fieldAccess?: Maybe<Array<FieldAccess>>;
};

export type MutationPlan = {
  __typename?: 'MutationPlan';
  approvedBy?: Maybe<Scalars['Int']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  createdBy: Scalars['Int']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  rolledBackAt?: Maybe<Scalars['DateTime']['output']>;
  status: MutationPlanStatus;
  steps: Array<MutationStep>;
  title: Scalars['String']['output'];
};

export enum MutationPlanStatus {
  Completed = 'COMPLETED',
  Executing = 'EXECUTING',
  Failed = 'FAILED',
  RolledBack = 'ROLLED_BACK',
  Staged = 'STAGED'
}

export type MutationStep = {
  __typename?: 'MutationStep';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  dataSources?: Maybe<Scalars['JSON']['output']>;
  dependsOnStepId?: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  fieldSchema?: Maybe<Scalars['JSON']['output']>;
  filePreviewUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  input: Scalars['JSON']['output'];
  liveSnapshot?: Maybe<Scalars['JSON']['output']>;
  lockedFields?: Maybe<Array<Scalars['String']['output']>>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  mutationName: Scalars['String']['output'];
  outputMapping?: Maybe<Scalars['JSON']['output']>;
  planId: Scalars['Int']['output'];
  previousState?: Maybe<Scalars['JSON']['output']>;
  result?: Maybe<Scalars['JSON']['output']>;
  resultLinks?: Maybe<Scalars['JSON']['output']>;
  sequence: Scalars['Int']['output'];
  status: MutationStepStatus;
  valueLabels?: Maybe<Scalars['JSON']['output']>;
};

export type MutationStepInput = {
  dataSources?: InputMaybe<Scalars['JSON']['input']>;
  dependsOnStepIndex?: InputMaybe<Scalars['Int']['input']>;
  description: Scalars['String']['input'];
  input: Scalars['JSON']['input'];
  mutationName: Scalars['String']['input'];
  outputMapping?: InputMaybe<Scalars['JSON']['input']>;
};

export enum MutationStepStatus {
  Executing = 'EXECUTING',
  Failed = 'FAILED',
  Pending = 'PENDING',
  RolledBack = 'ROLLED_BACK',
  Succeeded = 'SUCCEEDED'
}

export type MwdbeFilter = {
  categories?: InputMaybe<Array<OwnershipDiversityType>>;
  ownershipPercentage: OwnershipPercentageType;
};

export type NavClassificationEnum = {
  __typename?: 'NAVClassificationEnum';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type NavClassificationEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NavClassificationEnumList = {
  __typename?: 'NAVClassificationEnumList';
  items: Array<NavClassificationEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type NavClassificationEnumSort = {
  field: NavClassificationEnumSortEnum;
  order: SortInput;
};

export enum NavClassificationEnumSortEnum {
  Id = 'id'
}

/** One NAV model row: a manager's (or accounting entity's) allocation within an RCG fund for a month. */
export type NavModelAllocation = {
  __typename?: 'NavModelAllocation';
  endingAllocation?: Maybe<Scalars['Float']['output']>;
  managerId: Scalars['Int']['output'];
  managerName?: Maybe<Scalars['String']['output']>;
  rcgFundName?: Maybe<Scalars['String']['output']>;
  /** The manager's strategy code, or 'Acct' for accounting rows. */
  strategy?: Maybe<Scalars['String']['output']>;
};

/** One row of a primary portfolio's monthly NAV statement: a manager or accounting line, a subtotal, or the portfolio summary. date is the statement month-end; isAccounting marks accounting lines (cash, receivables, liabilities) and their subtotal; redemptions are negative; isFinal means reconciled rather than estimated. Returns are fractions (0.012 = 1.2%); balances are in the portfolio's base currency. */
export type NavStatementRow = {
  __typename?: 'NavStatementRow';
  /** The reconciled return on a line; P/L over net beginning allocation on a subtotal. */
  actualReturn?: Maybe<Scalars['Float']['output']>;
  additions: Scalars['Float']['output'];
  /** Net beginning allocation: prior month-end balance + additions + redemptions. */
  adjBegBal?: Maybe<Scalars['Float']['output']>;
  /** The manager's Diligence asset class. Null on subtotal rows and on lines whose fund has none. */
  assetClass?: Maybe<Scalars['String']['output']>;
  /** Prior month-end balance. */
  begBal?: Maybe<Scalars['Float']['output']>;
  begWeight: Scalars['Float']['output'];
  date: Scalars['Date']['output'];
  /** Actual return when final, else the estimate. */
  effectiveReturn?: Maybe<Scalars['Float']['output']>;
  endBal?: Maybe<Scalars['Float']['output']>;
  endWeight: Scalars['Float']['output'];
  estimatedReturn?: Maybe<Scalars['Float']['output']>;
  estimatedReturnDate?: Maybe<Scalars['Date']['output']>;
  isAccounting: Scalars['Boolean']['output'];
  isFinal: Scalars['Boolean']['output'];
  manager?: Maybe<Scalars['String']['output']>;
  /** Null on subtotal rows. */
  managerId?: Maybe<Scalars['Int']['output']>;
  managerShortName?: Maybe<Scalars['String']['output']>;
  profitLoss?: Maybe<Scalars['Float']['output']>;
  redemptions: Scalars['Float']['output'];
  rowType: NavStatementRowType;
  sidePocketAmount?: Maybe<Scalars['Float']['output']>;
  strategy?: Maybe<Scalars['String']['output']>;
  strategyId?: Maybe<Scalars['Int']['output']>;
};

/** The level of a NAV statement row. */
export enum NavStatementRowType {
  Accounting = 'ACCOUNTING',
  Manager = 'MANAGER',
  Portfolio = 'PORTFOLIO',
  Strategy = 'STRATEGY'
}

export type NextPage = {
  __typename?: 'NextPage';
  hasMore: Scalars['Boolean']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
};

export type NoteCategoryEnum = {
  __typename?: 'NoteCategoryEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  noteCategory?: Maybe<Scalars['String']['output']>;
  noteTypes: Array<NoteTypeEnum>;
};

export type NoteCategoryEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NoteCategoryEnumList = {
  __typename?: 'NoteCategoryEnumList';
  items: Array<NoteCategoryEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type NoteCategoryEnumSort = {
  field: NoteCategoryEnumSortEnum;
  order: SortInput;
};

export enum NoteCategoryEnumSortEnum {
  Id = 'id'
}

export type NoteEntityAssignmentInput = {
  businessObjectEnumId: Scalars['Int']['input'];
  entityId: Scalars['Int']['input'];
};

export type NoteMetaEnum = {
  __typename?: 'NoteMetaEnum';
  amtLabel?: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Int']['output'];
  hideExternally: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isAmt?: Maybe<Scalars['Boolean']['output']>;
  isAvg?: Maybe<Scalars['Boolean']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isDeprecated?: Maybe<Scalars['Boolean']['output']>;
  isForPartnerFund?: Maybe<Scalars['Boolean']['output']>;
  isMax?: Maybe<Scalars['Boolean']['output']>;
  isMin?: Maybe<Scalars['Boolean']['output']>;
  isYesNo?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  noteType: NoteTypeEnum;
  noteTypeEnumId: Scalars['Int']['output'];
  textRequiredIf?: Maybe<Scalars['Boolean']['output']>;
};

export type NoteMetaEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  noteCategoryEnumId?: InputMaybe<Scalars['Int']['input']>;
  noteTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteMetaEnumList = {
  __typename?: 'NoteMetaEnumList';
  items: Array<NoteMetaEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type NoteMetaEnumSort = {
  field: NoteMetaEnumSortEnum;
  order: SortInput;
};

export enum NoteMetaEnumSortEnum {
  Id = 'id'
}

export type NoteTypeEnum = {
  __typename?: 'NoteTypeEnum';
  alias?: Maybe<Scalars['String']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  noteCategory: NoteCategoryEnum;
  noteCategoryEnumId: Scalars['Int']['output'];
  noteMetaEnums: Array<NoteMetaEnum>;
  noteType?: Maybe<Scalars['String']['output']>;
};

export type Notes = {
  __typename?: 'Notes';
  accessLevelId: Scalars['Int']['output'];
  amtValue?: Maybe<Scalars['Float']['output']>;
  avgValue?: Maybe<Scalars['Float']['output']>;
  canEdit: Scalars['Boolean']['output'];
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  createUserFullName?: Maybe<Scalars['String']['output']>;
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  deleteUser?: Maybe<Scalars['String']['output']>;
  editedText?: Maybe<Scalars['String']['output']>;
  entityAssignments: Array<NotesXEntity>;
  id: Scalars['Int']['output'];
  isVectorized?: Maybe<Scalars['Boolean']['output']>;
  maxValue?: Maybe<Scalars['Float']['output']>;
  minValue?: Maybe<Scalars['Float']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  noteDate?: Maybe<Scalars['Date']['output']>;
  noteMeta: NoteMetaEnum;
  noteMetaId: Scalars['Float']['output'];
  organizationId: Scalars['Int']['output'];
  tags: Array<KnowledgeBaseTags>;
  text?: Maybe<Scalars['String']['output']>;
  yesNoResponse?: Maybe<Scalars['Boolean']['output']>;
};

export type NotesDateRange = {
  max?: InputMaybe<Scalars['DateTime']['input']>;
  min?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotesFilter = {
  accessLevelIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  companyFilters?: InputMaybe<Array<CompanySearchFilters>>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  createDate?: InputMaybe<NotesDateRange>;
  createUsers?: InputMaybe<Array<Scalars['String']['input']>>;
  dealId?: InputMaybe<Scalars['Int']['input']>;
  dealIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  firmEngagementId?: InputMaybe<Scalars['Int']['input']>;
  firmFilters?: InputMaybe<Array<FirmSearchFilters>>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  firmIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  investmentFilters?: InputMaybe<Array<InvestmentSearchFilters>>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  investmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  knowledgeBaseTagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  noteCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  noteDate?: InputMaybe<NotesDateRange>;
  noteMetaId?: InputMaybe<Scalars['Int']['input']>;
  noteMetaIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  noteTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type NotesInput = {
  accessLevelId: Scalars['Float']['input'];
  editedText?: InputMaybe<Scalars['String']['input']>;
  /** Entity assignments for this note. Zero-to-many — a note may be attached to multiple investments, firms, companies, and/or deals. Replace semantics: the supplied list becomes the full set on update. */
  entityAssignments?: InputMaybe<Array<NoteEntityAssignmentInput>>;
  /** Knowledge base tag IDs to associate with this note */
  knowledgeBaseTagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  noteDate?: InputMaybe<Scalars['Date']['input']>;
  noteMetaId: Scalars['Float']['input'];
  notifyTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Organization IDs to notify. If not provided, all organizations with shouldReceiveInvestmentEmails users will be notified. */
  notifyTeamOrganizationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type NotesList = {
  __typename?: 'NotesList';
  items: Array<Notes>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type NotesMetaCount = {
  __typename?: 'NotesMetaCount';
  count: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  noteMeta: NoteMetaEnum;
};

export type NotesSort = {
  field: NotesSortEnum;
  order: SortInput;
};

export enum NotesSortEnum {
  Id = 'id',
  TextSearchRank = 'textSearchRank'
}

export type NotesXEntity = {
  __typename?: 'NotesXEntity';
  businessObjectTypeEnumId: Scalars['Int']['output'];
  company?: Maybe<Company>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deal?: Maybe<Deal>;
  entityId: Scalars['Int']['output'];
  entityName?: Maybe<Scalars['String']['output']>;
  firm?: Maybe<Firm>;
  firmEngagement?: Maybe<FirmEngagement>;
  id: Scalars['Int']['output'];
  investment?: Maybe<Investment>;
  notesId: Scalars['Int']['output'];
};

export type NoticeExtraction = {
  __typename?: 'NoticeExtraction';
  administrator?: Maybe<Scalars['String']['output']>;
  clientInvestment?: Maybe<Investment>;
  clientManuallyCorrected: Scalars['Boolean']['output'];
  clientMapping?: Maybe<NoticeFundMapping>;
  clientMatchConfidence?: Maybe<Scalars['Float']['output']>;
  clientMatchStatus?: Maybe<InvestmentMatchStatus>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Document>;
  documentId: Scalars['Int']['output'];
  dueDate?: Maybe<Scalars['Date']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  fieldSources?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  legs: Array<NoticeLeg>;
  legsBalance: Scalars['Boolean']['output'];
  legsTotal: Scalars['Float']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  needsReview: Scalars['Boolean']['output'];
  noticeDate?: Maybe<Scalars['Date']['output']>;
  noticeType?: Maybe<NoticeType>;
  rawClientName?: Maybe<Scalars['String']['output']>;
  reviewReasons: Array<NoticeReviewReason>;
  status: NoticeExtractionStatus;
  totalAmount?: Maybe<Scalars['Float']['output']>;
};

export type NoticeExtractionList = {
  __typename?: 'NoticeExtractionList';
  items: Array<NoticeExtraction>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
  truncated: Scalars['Boolean']['output'];
};

export enum NoticeExtractionStatus {
  Completed = 'completed',
  Failed = 'failed',
  NotApplicable = 'not_applicable',
  Pending = 'pending',
  Processing = 'processing'
}

export type NoticeFundMapping = {
  __typename?: 'NoticeFundMapping';
  confidence?: Maybe<Scalars['Float']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  investment?: Maybe<Investment>;
  llmReasoning?: Maybe<Scalars['String']['output']>;
  manuallyVerified: Scalars['Boolean']['output'];
  mappingKind: NoticeMappingKind;
  matchStatus: InvestmentMatchStatus;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  needsReview: Scalars['Boolean']['output'];
  rawFundName: Scalars['String']['output'];
  verifiedBy?: Maybe<Scalars['String']['output']>;
  verifiedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type NoticeLeg = {
  __typename?: 'NoticeLeg';
  amount: Scalars['Float']['output'];
  category: NoticeLegCategory;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fundMapping?: Maybe<NoticeFundMapping>;
  id: Scalars['Int']['output'];
  investment?: Maybe<Investment>;
  manuallyCorrected: Scalars['Boolean']['output'];
  matchConfidence?: Maybe<Scalars['Float']['output']>;
  matchStatus?: Maybe<InvestmentMatchStatus>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  noticeExtraction: NoticeExtraction;
  noticeExtractionId: Scalars['Int']['output'];
  rawFundName: Scalars['String']['output'];
  sourcePage?: Maybe<Scalars['Int']['output']>;
  sourceQuote?: Maybe<Scalars['String']['output']>;
};

export enum NoticeLegCategory {
  CcForManagementFee = 'CCForManagementFee',
  CcForPartnershipExpense = 'CCForPartnershipExpense',
  CapitalCall = 'CapitalCall',
  CapitalCallForInvestment = 'CapitalCallForInvestment',
  CarriedInterest = 'CarriedInterest',
  DistributionOfIncome = 'DistributionOfIncome',
  EqualizationInterestExpense = 'EqualizationInterestExpense',
  EqualizationInterestIncome = 'EqualizationInterestIncome',
  Interest = 'Interest',
  Redemption = 'Redemption',
  ReturnOfCapital = 'ReturnOfCapital',
  Subscription = 'Subscription',
  TaxWithholding = 'TaxWithholding',
  Unsure = 'Unsure'
}

export type NoticeLegCategoryTotal = {
  __typename?: 'NoticeLegCategoryTotal';
  category: NoticeLegCategory;
  total: Scalars['Float']['output'];
};

export type NoticeLegsByInvestmentResult = {
  __typename?: 'NoticeLegsByInvestmentResult';
  categoryTotals: Array<NoticeLegCategoryTotal>;
  clients: Array<Investment>;
  items: Array<NoticeLeg>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
  truncated: Scalars['Boolean']['output'];
};

export enum NoticeMappingKind {
  Client = 'CLIENT',
  Fund = 'FUND'
}

export type NoticeNotificationConfig = {
  __typename?: 'NoticeNotificationConfig';
  clientInvestment?: Maybe<Investment>;
  clientInvestmentId: Scalars['Int']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  includeAttachment: Scalars['Boolean']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  noticeType?: Maybe<NoticeType>;
  powerAutomateOverlaps: Array<Scalars['String']['output']>;
  recipients: Scalars['String']['output'];
};

export type NoticeNotificationConfigInput = {
  clientInvestmentId: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  includeAttachment: Scalars['Boolean']['input'];
  noticeType?: InputMaybe<NoticeType>;
  recipients: Scalars['String']['input'];
};

export enum NoticeReviewReason {
  ExtractionFailed = 'EXTRACTION_FAILED',
  LowConfidenceClient = 'LOW_CONFIDENCE_CLIENT',
  LowConfidenceFund = 'LOW_CONFIDENCE_FUND',
  Unbalanced = 'UNBALANCED',
  UnmappedClient = 'UNMAPPED_CLIENT',
  UnmappedFund = 'UNMAPPED_FUND',
  UnsureCategory = 'UNSURE_CATEGORY'
}

export enum NoticeType {
  CapitalCall = 'CAPITAL_CALL',
  Distribution = 'DISTRIBUTION'
}

export type Notification = {
  __typename?: 'Notification';
  createdAt: Scalars['DateTime']['output'];
  detail?: Maybe<Scalars['String']['output']>;
  eventType: NotificationEventType;
  hasArtifact: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  readAt?: Maybe<Scalars['DateTime']['output']>;
  reason: Scalars['String']['output'];
  subjectId: Scalars['BigInt']['output'];
  subjectType: NotificationSubjectType;
  userId: Scalars['Int']['output'];
};

export enum NotificationCategory {
  Collaboration = 'COLLABORATION',
  Compliance = 'COMPLIANCE',
  YourWork = 'YOUR_WORK'
}

export type NotificationEventPreference = {
  __typename?: 'NotificationEventPreference';
  category: NotificationCategory;
  email: Scalars['Boolean']['output'];
  emailable: Scalars['Boolean']['output'];
  eventType: NotificationEventType;
  muted: Scalars['Boolean']['output'];
  requiresSubscription: Scalars['Boolean']['output'];
  subscribedDirectly: Scalars['Boolean']['output'];
  subscribedViaGroup: Scalars['Boolean']['output'];
  toast: Scalars['Boolean']['output'];
  usingDefaults: Scalars['Boolean']['output'];
};

export enum NotificationEventType {
  AgentMessage = 'AGENT_MESSAGE',
  GuidelineBreach = 'GUIDELINE_BREACH',
  NoteAdded = 'NOTE_ADDED',
  NoteMention = 'NOTE_MENTION',
  SkillRunCompleted = 'SKILL_RUN_COMPLETED',
  SkillRunFailed = 'SKILL_RUN_FAILED',
  TaskCompleted = 'TASK_COMPLETED',
  TaskFailed = 'TASK_FAILED'
}

export type NotificationFilter = {
  eventTypes?: InputMaybe<Array<NotificationEventType>>;
  search?: InputMaybe<Scalars['String']['input']>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationRecipientOrganization = {
  __typename?: 'NotificationRecipientOrganization';
  id: Scalars['Int']['output'];
  /** True if this org appears because it has a group share on one of the note's entities */
  isShared?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  users: Array<NotificationRecipientUser>;
};

export type NotificationRecipientUser = {
  __typename?: 'NotificationRecipientUser';
  commonName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  organizationId: Scalars['Int']['output'];
};

export type NotificationRecipientsList = {
  __typename?: 'NotificationRecipientsList';
  organizations: Array<NotificationRecipientOrganization>;
};

export enum NotificationSubjectType {
  AsyncTask = 'ASYNC_TASK',
  Conversation = 'CONVERSATION',
  Investment = 'INVESTMENT',
  Note = 'NOTE'
}

export type NotificationSubscription = {
  __typename?: 'NotificationSubscription';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  eventType: NotificationEventType;
  groupId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  subscriberName?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type OktaUser = {
  __typename?: 'OktaUser';
  activated?: Maybe<Scalars['DateTime']['output']>;
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  passwordChanged?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  statusChanged?: Maybe<Scalars['DateTime']['output']>;
};

export type OperatingStatusEnum = {
  __typename?: 'OperatingStatusEnum';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type OperatingStatusEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type OperatingStatusEnumList = {
  __typename?: 'OperatingStatusEnumList';
  items: Array<OperatingStatusEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type OperatingStatusEnumSort = {
  field: OperatingStatusEnumSortEnum;
  order: SortInput;
};

export enum OperatingStatusEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type OrgLinks = {
  __typename?: 'OrgLinks';
  expirationDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  link?: Maybe<Links>;
  linkId: Scalars['Int']['output'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int']['output'];
};

export type OrgLinksFilter = {
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  linkId?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};

export type OrgLinksInput = {
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  linkId?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};

export type OrgLinksList = {
  __typename?: 'OrgLinksList';
  items: Array<OrgLinks>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type OrgLinksSort = {
  field: OrgLinksSortEnum;
  order: SortInput;
};

export enum OrgLinksSortEnum {
  Id = 'id',
  LinkId = 'linkId',
  OrganizationId = 'organizationId'
}

export type Organization = {
  __typename?: 'Organization';
  clientId?: Maybe<Scalars['ID']['output']>;
  cognitoIdpIdentifier?: Maybe<Scalars['String']['output']>;
  emailDomainMappings: Array<EmailDomainXOrganization>;
  id: Scalars['Int']['output'];
  intakeOrganizationId?: Maybe<Scalars['ID']['output']>;
  managedOrganizations: Array<Organization>;
  name: Scalars['String']['output'];
  orgLinks: Array<OrgLinks>;
  smallIconUrl?: Maybe<Scalars['String']['output']>;
};

export type OrganizationCreateInput = {
  createDefaultEntityGroups?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type OrganizationFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationInput = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orgLinks?: InputMaybe<Array<OrgLinksInput>>;
};

export type OrganizationInvestmentSetSubscription = {
  __typename?: 'OrganizationInvestmentSetSubscription';
  organization: Organization;
  organizationId: Scalars['Int']['output'];
};

export type OrganizationList = {
  __typename?: 'OrganizationList';
  items: Array<Organization>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type OrganizationSort = {
  field: OrganizationSortEnum;
  order: SortInput;
};

export enum OrganizationSortEnum {
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type OrganizationStructureEnum = {
  __typename?: 'OrganizationStructureEnum';
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type OrganizationStructureEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type OrganizationStructureEnumList = {
  __typename?: 'OrganizationStructureEnumList';
  items: Array<OrganizationStructureEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type OrganizationStructureEnumSort = {
  field: OrganizationStructureEnumSortEnum;
  order: SortInput;
};

export enum OrganizationStructureEnumSortEnum {
  Id = 'id'
}

export enum OwnershipDiversityType {
  AfricanAmerican = 'africanAmerican',
  Asian = 'asian',
  Disabled = 'disabled',
  Hispanic = 'hispanic',
  Lgbtq = 'lgbtq',
  NativeAmerican = 'nativeAmerican',
  Other = 'other',
  Veteran = 'veteran',
  Women = 'women'
}

export enum OwnershipPercentageType {
  Any = 'any',
  Majority = 'majority',
  Minority = 'minority'
}

export type PeFundNumberEnum = {
  __typename?: 'PEFundNumberEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type PeFundNumberEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type PeFundNumberEnumList = {
  __typename?: 'PEFundNumberEnumList';
  items: Array<PeFundNumberEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PeFundNumberEnumSort = {
  field: PeFundNumberEnumSortEnum;
  order: SortInput;
};

export enum PeFundNumberEnumSortEnum {
  DisplayOrder = 'displayOrder',
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type PeStrategyEnum = {
  __typename?: 'PEStrategyEnum';
  code: Scalars['String']['output'];
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  peSubStrategies: Array<PeStrategyEnum>;
  subStrategies: Array<PeSubStrategyEnum>;
};

export type PeStrategyEnumFilterInput = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PeStrategyEnumList = {
  __typename?: 'PEStrategyEnumList';
  items: Array<PeStrategyEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PeStrategyEnumSort = {
  field: PeStrategyEnumSortEnum;
  order: SortInput;
};

export enum PeStrategyEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type PeSubStrategyEnum = {
  __typename?: 'PESubStrategyEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  peStrategy: PeStrategyEnum;
  peStrategyEnumId: Scalars['Int']['output'];
};

export enum Prud {
  Delete = 'delete',
  Preview = 'preview',
  Read = 'read',
  Update = 'update'
}

export type PageContentItem = {
  anchor?: InputMaybe<Scalars['String']['input']>;
  data: Scalars['String']['input'];
  description: Scalars['String']['input'];
  id: Scalars['String']['input'];
  type: PageContentType;
};

export enum PageContentType {
  Html = 'html',
  Json = 'json',
  Text = 'text'
}

export type PageContext = {
  items: Array<PageContentItem>;
  params: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type PageInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PeInctFeeCalcEnum = {
  __typename?: 'PeInctFeeCalcEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type PeInctFeeCalcEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PeInctFeeCalcEnumList = {
  __typename?: 'PeInctFeeCalcEnumList';
  items: Array<PeInctFeeCalcEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PeInctFeeCalcEnumSort = {
  field: PeInctFeeCalcEnumSortEnum;
  order: SortInput;
};

export enum PeInctFeeCalcEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type PeLiquidity = {
  __typename?: 'PeLiquidity';
  catchupPercent?: Maybe<Scalars['Float']['output']>;
  compoundingPeriod?: Maybe<CompoundingPeriodEnum>;
  compoundingPeriodId?: Maybe<Scalars['Int']['output']>;
  hasCatchupProvision?: Maybe<Scalars['Boolean']['output']>;
  hasExtensionOption?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  isCompounded?: Maybe<Scalars['Boolean']['output']>;
  optionOfExtension?: Maybe<RightOfExtensionEnum>;
  optionOfExtensionId?: Maybe<Scalars['Int']['output']>;
  preferredReturn?: Maybe<Scalars['Float']['output']>;
  shareClassId: Scalars['Int']['output'];
};

export type PeLiquidityFilter = {
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  shareClassId?: InputMaybe<Scalars['Int']['input']>;
};

export type PeLiquidityInput = {
  catchupPercent?: InputMaybe<Scalars['Float']['input']>;
  compoundingPeriodId?: InputMaybe<Scalars['Int']['input']>;
  hasCatchupProvision?: InputMaybe<Scalars['Boolean']['input']>;
  isCompounded?: InputMaybe<Scalars['Boolean']['input']>;
  optionOfExtensionId?: InputMaybe<Scalars['Int']['input']>;
  preferredReturn?: InputMaybe<Scalars['Float']['input']>;
};

export type PeLiquidityList = {
  __typename?: 'PeLiquidityList';
  items: Array<PeLiquidity>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PeLiquiditySort = {
  field: PeLiquiditySortEnum;
  order: SortInput;
};

export enum PeLiquiditySortEnum {
  Id = 'id'
}

export type PeMgmtFeeCalcEnum = {
  __typename?: 'PeMgmtFeeCalcEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type PeMgmtFeeCalcEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PeMgmtFeeCalcEnumList = {
  __typename?: 'PeMgmtFeeCalcEnumList';
  items: Array<PeMgmtFeeCalcEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PeMgmtFeeCalcEnumSort = {
  field: PeMgmtFeeCalcEnumSortEnum;
  order: SortInput;
};

export enum PeMgmtFeeCalcEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type PeersList = {
  __typename?: 'PeersList';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  groupId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type: PeersListEnum;
  typeEnumId: Scalars['Int']['output'];
};

export type PeersListEnum = {
  __typename?: 'PeersListEnum';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type PeersSummaryDetail = {
  DPIQuartile?: InputMaybe<Scalars['Float']['input']>;
  IRRQuartile?: InputMaybe<Scalars['Float']['input']>;
  TVPIQuartile?: InputMaybe<Scalars['Float']['input']>;
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  dpi?: InputMaybe<Scalars['Float']['input']>;
  grouping?: InputMaybe<Scalars['String']['input']>;
  investment_name: Scalars['String']['input'];
  irr?: InputMaybe<Scalars['Float']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  tvpi?: InputMaybe<Scalars['Float']['input']>;
  vintage?: InputMaybe<Scalars['Float']['input']>;
};

export type PerformanceAnalytics = {
  __typename?: 'PerformanceAnalytics';
  cumulative: BenchmarkTimeSeries;
  drawdown?: Maybe<Array<TimeSeriesRecord>>;
  growth1000?: Maybe<BenchmarkTimeSeries>;
  investmentId: Scalars['Int']['output'];
  returnDistribution?: Maybe<ReturnDistributionRecord>;
};


export type PerformanceAnalyticsCumulativeArgs = {
  benchmarkIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  defaultBenchmarks?: InputMaybe<Scalars['Boolean']['input']>;
  excessReturnBenchmarkId?: InputMaybe<Scalars['Int']['input']>;
  priorTrackRecord?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PerformanceAnalyticsDrawdownArgs = {
  excessReturnBenchmarkId?: InputMaybe<Scalars['Int']['input']>;
};


export type PerformanceAnalyticsGrowth1000Args = {
  benchmarkIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  defaultBenchmarks?: InputMaybe<Scalars['Boolean']['input']>;
  priorTrackRecord?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PerformanceAnalyticsReturnDistributionArgs = {
  excessReturnBenchmarkId?: InputMaybe<Scalars['Int']['input']>;
};

export type PerformanceCommentaryInput = {
  comment: Scalars['String']['input'];
  investmentId: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type PerformanceDateRange = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Combined Performance Lag and Unit so types match the check constraint (both defined or both null) */
export type PerformanceLag = {
  __typename?: 'PerformanceLag';
  lag: Scalars['Int']['output'];
  lagUnit: CalendarUnitEnum;
  lagUnitId: Scalars['Int']['output'];
};

export type PerformanceLagInput = {
  lag?: InputMaybe<Scalars['Int']['input']>;
  lagUnitId?: InputMaybe<Scalars['Int']['input']>;
};

export type PerformanceMtd = {
  __typename?: 'PerformanceMTD';
  asOfDate: Scalars['DateTime']['output'];
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser: Scalars['String']['output'];
  currency: CurrencyDenominationEnum;
  currencyId: Scalars['Float']['output'];
  investmentId: Scalars['Int']['output'];
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  performanceCommentary?: Maybe<Scalars['String']['output']>;
  /** The commentary note entity for this month, for consumers that need editedText (edited commentary takes precedence over the original text). performanceCommentary above resolves the original text only. */
  performanceCommentaryNote?: Maybe<Notes>;
  return?: Maybe<Scalars['Float']['output']>;
  returnMonth: Scalars['Int']['output'];
  returnType: Scalars['String']['output'];
  returnYear: Scalars['Int']['output'];
};

export type PerformanceMtdFilter = {
  /**
   * Matches on the year and month
   * @deprecated Use dateRange instead
   */
  asOfDateRange?: InputMaybe<PerformanceDateRange>;
  /** Matches on the year and month */
  dateRange?: InputMaybe<PerformanceMtdDateRange>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  priorTrackRecord?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches on the year and month */
  returnRange?: InputMaybe<PerformanceDateRange>;
  returnType?: InputMaybe<ReturnTypes>;
};

export type PerformanceMtdList = {
  __typename?: 'PerformanceMTDList';
  items: Array<PerformanceMtd>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PerformanceMtdShort = {
  asOfDate: Scalars['DateTime']['input'];
  /** Null values are treated as deletes. */
  fundReturn?: InputMaybe<Scalars['Float']['input']>;
  performanceCommentary?: InputMaybe<Scalars['String']['input']>;
  returnMonth: Scalars['Int']['input'];
  returnYear: Scalars['Int']['input'];
};

export type PerformanceMtdSort = {
  field: PerformanceMtdSortEnum;
  order: SortInput;
};

export enum PerformanceMtdSortEnum {
  AsOfDate = 'asOfDate',
  Id = 'id',
  Return = 'return'
}

export type PerformanceMtdBulkFilter = {
  /** Matches on year and month, inclusive. */
  asOfDateRange?: InputMaybe<PerformanceDateRange>;
  /** Matches on year and month, inclusive. */
  dateRange?: InputMaybe<PerformanceMtdDateRange>;
  investmentIds: Array<Scalars['Int']['input']>;
  priorTrackRecord?: InputMaybe<Scalars['Boolean']['input']>;
  returnType?: InputMaybe<ReturnTypes>;
};

export type PerformanceMtdBulkInvestment = {
  __typename?: 'PerformanceMtdBulkInvestment';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  performanceMTD: Array<PerformanceMtdBulkPerformance>;
};

export type PerformanceMtdBulkPerformance = {
  __typename?: 'PerformanceMtdBulkPerformance';
  asOfDate: Scalars['DateTime']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  currencyId?: Maybe<Scalars['Float']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  return?: Maybe<Scalars['Float']['output']>;
  returnMonth: Scalars['Int']['output'];
  returnType: Scalars['String']['output'];
  returnYear: Scalars['Int']['output'];
};

export type PerformanceMtdBulkSort = {
  field: PerformanceMtdBulkSortEnum;
  order: SortInput;
};

export enum PerformanceMtdBulkSortEnum {
  AsOfDate = 'asOfDate'
}

export type PerformanceMtdDateRange = {
  end?: InputMaybe<Scalars['Date']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
};

export type PerformancePeriodRange = {
  __typename?: 'PerformancePeriodRange';
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
};

export type PerformancePrivate = {
  __typename?: 'PerformancePrivate';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  dpi?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  investment?: Maybe<Investment>;
  investmentId: Scalars['Int']['output'];
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  netIRR?: Maybe<Scalars['Float']['output']>;
  relativeStats?: Maybe<PerformancePrivateRelativeStats>;
  returnQuarter: Scalars['Int']['output'];
  returnYear: Scalars['Int']['output'];
  tvpi?: Maybe<Scalars['Float']['output']>;
};


export type PerformancePrivateRelativeStatsArgs = {
  privateQuartileGroupCategoryId?: InputMaybe<Scalars['Int']['input']>;
};

export type PerformancePrivateFilter = {
  /** Matches on the year and quarter, inclusive. */
  asOfDateRange?: InputMaybe<PerformanceDateRange>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type PerformancePrivateList = {
  __typename?: 'PerformancePrivateList';
  items: Array<PerformancePrivate>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PerformancePrivateRelativeStats = {
  __typename?: 'PerformancePrivateRelativeStats';
  asOfDate: Scalars['DateTime']['output'];
  investmentId?: Maybe<Scalars['Int']['output']>;
  privateQuartileGroup?: Maybe<PrivateQuartileGroup>;
  privateQuartileGroupCategory?: Maybe<PrivateQuartileGroupCategory>;
  privateQuartileGroupCategoryId?: Maybe<Scalars['Int']['output']>;
  privateQuartileGroupId?: Maybe<Scalars['Int']['output']>;
  /** Value between 1 and 4 describing the quartile of the relative DPI. */
  relativeDPIQuartile?: Maybe<Scalars['Int']['output']>;
  /** Value between 1 and 4 describing the quartile of the relative IRR. */
  relativeIRRQuartile?: Maybe<Scalars['Int']['output']>;
  /** Value between 1 and 4 describing the quartile of the relative TVPI. */
  relativeTVPIQuartile?: Maybe<Scalars['Int']['output']>;
};

export type PerformancePrivateSearchFilter = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  statType: PerformancePrivateStatType;
};

export type PerformancePrivateShort = {
  dpi?: InputMaybe<Scalars['Float']['input']>;
  netIRR?: InputMaybe<Scalars['Float']['input']>;
  returnQuarter: Scalars['Int']['input'];
  returnYear: Scalars['Int']['input'];
  tvpi?: InputMaybe<Scalars['Float']['input']>;
};

export type PerformancePrivateSort = {
  field: PerformancePrivateSortEnum;
  order: SortInput;
};

export enum PerformancePrivateSortEnum {
  AsOfDate = 'asOfDate'
}

export enum PerformancePrivateStatType {
  Dpi = 'dpi',
  NetIrr = 'netIRR',
  Tvpi = 'tvpi'
}

export type PerformanceQuarterly = {
  __typename?: 'PerformanceQuarterly';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  investmentId: Scalars['Int']['output'];
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  return?: Maybe<Scalars['Float']['output']>;
  returnQuarter: Scalars['Int']['output'];
  returnType: Scalars['String']['output'];
  returnYear: Scalars['Int']['output'];
};

export type PerformanceQuarterlyFilterInput = {
  /** Matches on year and quarter, inclusive. */
  asOfDateRange?: InputMaybe<PerformanceDateRange>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  priorTrackRecord?: InputMaybe<Scalars['Boolean']['input']>;
  returnRange?: InputMaybe<PerformanceReturnRange>;
  returnType?: InputMaybe<ReturnTypes>;
};

export type PerformanceQuarterlyList = {
  __typename?: 'PerformanceQuarterlyList';
  items: Array<PerformanceQuarterly>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PerformanceQuarterlyShort = {
  /** Null values act as deletes */
  fundReturn?: InputMaybe<Scalars['Float']['input']>;
  returnQuarter: Scalars['Int']['input'];
  returnYear: Scalars['Int']['input'];
};

export type PerformanceQuarterlySort = {
  field: PerformanceQuarterlySortEnum;
  order: SortInput;
};

export enum PerformanceQuarterlySortEnum {
  AsOfDate = 'asOfDate',
  Return = 'return'
}

export type PerformanceReturnRange = {
  end?: InputMaybe<Scalars['Float']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
};

export type PerformanceSearchFilter = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  statType: PerformanceStatType;
};

export type PerformanceSourceEnum = {
  __typename?: 'PerformanceSourceEnum';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type PerformanceSourceEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type PerformanceSourceEnumList = {
  __typename?: 'PerformanceSourceEnumList';
  items: Array<PerformanceSourceEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PerformanceSourceEnumSort = {
  field: PerformanceSourceEnumSortEnum;
  order: SortInput;
};

export enum PerformanceSourceEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export enum PerformanceStatType {
  CompoundReturn1m = 'compoundReturn1m',
  CompoundReturn1y = 'compoundReturn1y',
  CompoundReturn1yAnnualized = 'compoundReturn1yAnnualized',
  CompoundReturn3y = 'compoundReturn3y',
  CompoundReturn3yAnnualized = 'compoundReturn3yAnnualized',
  CompoundReturn5y = 'compoundReturn5y',
  CompoundReturn5yAnnualized = 'compoundReturn5yAnnualized',
  CompoundReturnItd = 'compoundReturnItd',
  CompoundReturnItdAnnualized = 'compoundReturnItdAnnualized',
  CompoundReturnYtd = 'compoundReturnYtd',
  MaxDrawDown3y = 'maxDrawDown3y',
  MaxDrawDown5y = 'maxDrawDown5y',
  PercentProfitablePeriods3y = 'percentProfitablePeriods3y',
  SharpeRatio3y = 'sharpeRatio3y',
  SharpeRatio3yAnnualized = 'sharpeRatio3yAnnualized',
  SharpeRatio5y = 'sharpeRatio5y',
  SharpeRatio5yAnnualized = 'sharpeRatio5yAnnualized',
  StandardDeviation1yAnnualized = 'standardDeviation1yAnnualized',
  StandardDeviation3y = 'standardDeviation3y',
  StandardDeviation3yAnnualized = 'standardDeviation3yAnnualized',
  StandardDeviation5yAnnualized = 'standardDeviation5yAnnualized',
  StandardDeviationItd = 'standardDeviationItd',
  StandardDeviationYtd = 'standardDeviationYtd'
}

export type PerformanceStatistics = {
  __typename?: 'PerformanceStatistics';
  compoundReturn1m?: Maybe<Scalars['Float']['output']>;
  compoundReturn1y?: Maybe<Scalars['Float']['output']>;
  compoundReturn1yAnnualized?: Maybe<Scalars['Float']['output']>;
  compoundReturn3m?: Maybe<Scalars['Float']['output']>;
  compoundReturn3y?: Maybe<Scalars['Float']['output']>;
  compoundReturn3yAnnualized?: Maybe<Scalars['Float']['output']>;
  compoundReturn5y?: Maybe<Scalars['Float']['output']>;
  compoundReturn5yAnnualized?: Maybe<Scalars['Float']['output']>;
  compoundReturnItd?: Maybe<Scalars['Float']['output']>;
  compoundReturnItdAnnualized?: Maybe<Scalars['Float']['output']>;
  compoundReturnYtd?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  investmentId: Scalars['Int']['output'];
  maxDrawDown3y?: Maybe<Scalars['Float']['output']>;
  percentProfitablePeriods3y?: Maybe<Scalars['Float']['output']>;
  sharpeRatio3y?: Maybe<Scalars['Float']['output']>;
  sharpeRatio3yAnnualized?: Maybe<Scalars['Float']['output']>;
  standardDeviation1yAnnualized?: Maybe<Scalars['Float']['output']>;
  standardDeviation3y?: Maybe<Scalars['Float']['output']>;
  standardDeviation3yAnnualized?: Maybe<Scalars['Float']['output']>;
  standardDeviation5yAnnualized?: Maybe<Scalars['Float']['output']>;
  standardDeviationItdAnnualized?: Maybe<Scalars['Float']['output']>;
  standardDeviationYtd?: Maybe<Scalars['Float']['output']>;
  startDate: Scalars['Date']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PersistConversationArtifactInput = {
  /** Human-readable name, e.g. a filename */
  artifactName: Scalars['String']['input'];
  artifactType: ConversationArtifactType;
  /** The artifact payload to persist (text/JSON string). */
  content: Scalars['String']['input'];
  /** MIME content type, e.g. application/json. Defaults to text/plain. */
  contentType?: InputMaybe<Scalars['String']['input']>;
  conversationId: Scalars['Int']['input'];
  /** Optional structured metadata about the artifact. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
};

export type Person = {
  __typename?: 'Person';
  biography?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  createDate?: Maybe<Scalars['String']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  diversity?: Maybe<PersonDiversity>;
  education: Array<PersonEducation>;
  educationSummary?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email2?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  fax2?: Maybe<Scalars['String']['output']>;
  firmEmployment: Array<FirmEmployment>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  hasPhoto: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isCFA?: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  latestNewsMonitoringPull?: Maybe<Scalars['DateTime']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  modifyDate?: Maybe<Scalars['String']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  newsMonitoringStartDate?: Maybe<Scalars['DateTime']['output']>;
  personGroupId: Scalars['Int']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  phone2?: Maybe<Scalars['String']['output']>;
  photoLink?: Maybe<Scalars['String']['output']>;
  photoType?: Maybe<Scalars['String']['output']>;
  pronouns?: Maybe<Scalars['String']['output']>;
  titleEnum?: Maybe<TitleEnum>;
  titleEnumId?: Maybe<Scalars['Int']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  uniqueId?: Maybe<Scalars['String']['output']>;
  workExperience: Array<PersonWorkExperience>;
  workExperienceSummary?: Maybe<Scalars['String']['output']>;
};


export type PersonFirmEmploymentArgs = {
  filter?: InputMaybe<FirmEmploymentFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmEmploymentSort>>;
};

export type PersonDiversity = {
  __typename?: 'PersonDiversity';
  africanAmerican?: Maybe<Scalars['Boolean']['output']>;
  asian?: Maybe<Scalars['Boolean']['output']>;
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  hawaiianOrPacificIslander?: Maybe<Scalars['Boolean']['output']>;
  hispanic?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  lgbtq?: Maybe<Scalars['Boolean']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  nativeAmerican?: Maybe<Scalars['Boolean']['output']>;
  nonBinary?: Maybe<Scalars['Boolean']['output']>;
  other?: Maybe<Scalars['Boolean']['output']>;
  person: Person;
  veteran?: Maybe<Scalars['Boolean']['output']>;
  woman?: Maybe<Scalars['Boolean']['output']>;
};

export type PersonDiversityInput = {
  africanAmerican?: InputMaybe<Scalars['Boolean']['input']>;
  asian?: InputMaybe<Scalars['Boolean']['input']>;
  createDate?: InputMaybe<Scalars['DateTime']['input']>;
  createUser?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  hawaiianOrPacificIslander?: InputMaybe<Scalars['Boolean']['input']>;
  hispanic?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lgbtq?: InputMaybe<Scalars['Boolean']['input']>;
  modifyDate?: InputMaybe<Scalars['DateTime']['input']>;
  modifyUser?: InputMaybe<Scalars['String']['input']>;
  nativeAmerican?: InputMaybe<Scalars['Boolean']['input']>;
  nonBinary?: InputMaybe<Scalars['Boolean']['input']>;
  other?: InputMaybe<Scalars['Boolean']['input']>;
  veteran?: InputMaybe<Scalars['Boolean']['input']>;
  woman?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonEducation = {
  __typename?: 'PersonEducation';
  degree?: Maybe<DegreeEnum>;
  degreeEnumId?: Maybe<Scalars['Int']['output']>;
  graduationYear?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  person: Person;
  personId: Scalars['Int']['output'];
  school: SchoolEnum;
  schoolEnumId?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type PersonEducationFilterInput = {
  personId?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonEducationInput = {
  degreeEnumId?: InputMaybe<Scalars['Int']['input']>;
  graduationYear?: InputMaybe<Scalars['Int']['input']>;
  personId?: InputMaybe<Scalars['Int']['input']>;
  schoolEnumId?: InputMaybe<Scalars['Int']['input']>;
  schoolName?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type PersonEducationList = {
  __typename?: 'PersonEducationList';
  items: Array<PersonEducation>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PersonEducationSort = {
  field: PersonEducationSortEnum;
  order: SortInput;
};

export enum PersonEducationSortEnum {
  GraduationYear = 'graduationYear',
  Id = 'id'
}

export type PersonFilterInput = {
  q?: InputMaybe<Scalars['String']['input']>;
};

export type PersonInput = {
  biography?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  diversity?: InputMaybe<PersonDiversityInput>;
  educationSummary?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email2?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  fax2?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isCFA?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  newsMonitoringStartDate?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phone2?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['Upload']['input']>;
  photoType?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  titleEnumId?: InputMaybe<Scalars['Int']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  workExperienceSummary?: InputMaybe<Scalars['String']['input']>;
};

export type PersonList = {
  __typename?: 'PersonList';
  items: Array<Person>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PersonProfileBuilderResponse = {
  __typename?: 'PersonProfileBuilderResponse';
  answer?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['Int']['output']>;
  personProfile?: Maybe<GeneratedPersonProfile>;
};

export type PersonSearchFilters = {
  ACCESS?: InputMaybe<EntityAccessSearchFilter>;
};

export type PersonSort = {
  field: PersonSortEnum;
  order: SortInput;
};

export enum PersonSortEnum {
  Email = 'email',
  FirstName = 'firstName',
  Id = 'id',
  LastName = 'lastName',
  MiddleName = 'middleName',
  Name = 'name',
  NameSearchRank = 'nameSearchRank',
  Phone = 'phone'
}

export type PersonWorkExperience = {
  __typename?: 'PersonWorkExperience';
  company?: Maybe<CompanyEnum>;
  companyEnumId?: Maybe<Scalars['Int']['output']>;
  fromYear?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  person: Person;
  personId: Scalars['Int']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  toYear?: Maybe<Scalars['Int']['output']>;
};

export type PersonWorkExperienceFilterInput = {
  personId?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonWorkExperienceInput = {
  companyName: Scalars['String']['input'];
  fromYear?: InputMaybe<Scalars['Int']['input']>;
  personId: Scalars['Int']['input'];
  summary?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  toYear?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonWorkExperienceList = {
  __typename?: 'PersonWorkExperienceList';
  items: Array<PersonWorkExperience>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PersonWorkExperienceSort = {
  field: PersonWorkExperienceSortEnum;
  order: SortInput;
};

export enum PersonWorkExperienceSortEnum {
  Default = 'default',
  FromYear = 'fromYear',
  Id = 'id',
  ToYear = 'toYear'
}

export type PersonsDynamicShareRule = {
  investmentSet?: InputMaybe<GroupShareInvestmentSetFilter>;
};

export type PersonsDynamicShareRuleOutput = {
  __typename?: 'PersonsDynamicShareRuleOutput';
  investmentSet?: Maybe<GroupShareInvestmentSetFilterOutput>;
};

export type PieChartSeries = {
  colorByPoint: Scalars['Boolean']['input'];
  data: Array<IPieData>;
  name?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type PmeAttributeStratification = {
  __typename?: 'PmeAttributeStratification';
  attributeName: Scalars['String']['output'];
  groups: Array<PmeMetricGroup>;
};

export type PmeCashflow = {
  __typename?: 'PmeCashflow';
  amount: Scalars['Float']['output'];
  cashflowDate: Scalars['Date']['output'];
  cashflowType: Scalars['String']['output'];
  company?: Maybe<Scalars['String']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  feeBasis: PmeCashflowFeeBasis;
  fund?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  mappedInvestmentId?: Maybe<Scalars['Int']['output']>;
  mappedInvestmentName?: Maybe<Scalars['String']['output']>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  uploadId: Scalars['Int']['output'];
};

export enum PmeCashflowFeeBasis {
  Gross = 'GROSS',
  Net = 'NET'
}

export type PmeCashflowListResult = {
  __typename?: 'PmeCashflowListResult';
  items: Array<PmeCashflow>;
  summary: PmeCashflowSummary;
  totalCount: Scalars['Int']['output'];
};

export type PmeCashflowSummary = {
  __typename?: 'PmeCashflowSummary';
  count: Scalars['Int']['output'];
  totalContributions: Scalars['Float']['output'];
  totalDistributions: Scalars['Float']['output'];
};

export type PmeFileParse = {
  __typename?: 'PmeFileParse';
  cashflowCount: Scalars['Int']['output'];
  parsingErrors: Array<PmeParsingError>;
  positionCount: Scalars['Int']['output'];
  uniqueFunds: Array<Scalars['String']['output']>;
  uploadId: Scalars['Int']['output'];
};

export type PmeMappingConfirmationInput = {
  confirmedInvestmentId: Scalars['Int']['input'];
  sourceFundName: Scalars['String']['input'];
};

export type PmeMappingSuggestionResult = {
  __typename?: 'PmeMappingSuggestionResult';
  confidence: Scalars['Float']['output'];
  confirmedInvestmentId?: Maybe<Scalars['Int']['output']>;
  confirmedInvestmentName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  matchStatus: InvestmentMatchStatus;
  sourceFundName: Scalars['String']['output'];
  suggestedInvestmentId?: Maybe<Scalars['Int']['output']>;
  suggestedInvestmentName?: Maybe<Scalars['String']['output']>;
};

export type PmeMetricGroup = {
  __typename?: 'PmeMetricGroup';
  dealCount: Scalars['Int']['output'];
  directAlpha?: Maybe<Scalars['Float']['output']>;
  dpi?: Maybe<Scalars['Float']['output']>;
  groupId?: Maybe<Scalars['Int']['output']>;
  groupName: Scalars['String']['output'];
  invested: Scalars['Float']['output'];
  irr?: Maybe<Scalars['Float']['output']>;
  ksPme?: Maybe<Scalars['Float']['output']>;
  loss?: Maybe<Scalars['Float']['output']>;
  lossRate?: Maybe<Scalars['Float']['output']>;
  moic?: Maybe<Scalars['Float']['output']>;
  realized: Scalars['Float']['output'];
  totalValue: Scalars['Float']['output'];
  unrealized: Scalars['Float']['output'];
};

export type PmeParsingError = {
  __typename?: 'PmeParsingError';
  message: Scalars['String']['output'];
  row: Scalars['Int']['output'];
  tab: Scalars['String']['output'];
};

export type PmePositionAttribute = {
  __typename?: 'PmePositionAttribute';
  attributeName: Scalars['String']['output'];
  attributeValue?: Maybe<Scalars['String']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  positionId: Scalars['Int']['output'];
};

export type PmePositionListResult = {
  __typename?: 'PmePositionListResult';
  items: Array<PmePositionWithAttributes>;
  summary: PmePositionSummary;
  totalCount: Scalars['Int']['output'];
};

export type PmePositionSummary = {
  __typename?: 'PmePositionSummary';
  count: Scalars['Int']['output'];
  totalInvested: Scalars['Float']['output'];
  totalRealized: Scalars['Float']['output'];
  totalUnrealized: Scalars['Float']['output'];
  totalValue: Scalars['Float']['output'];
  weightedMoic?: Maybe<Scalars['Float']['output']>;
};

export type PmePositionWithAttributes = {
  __typename?: 'PmePositionWithAttributes';
  attributes: Array<PmePositionAttribute>;
  company?: Maybe<Scalars['String']['output']>;
  dpi?: Maybe<Scalars['Float']['output']>;
  fund?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  invested?: Maybe<Scalars['Float']['output']>;
  irr?: Maybe<Scalars['Float']['output']>;
  mappedInvestmentId?: Maybe<Scalars['Int']['output']>;
  mappedInvestmentName?: Maybe<Scalars['String']['output']>;
  moic?: Maybe<Scalars['Float']['output']>;
  realized?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  strategy?: Maybe<Scalars['String']['output']>;
  totalValue?: Maybe<Scalars['Float']['output']>;
  tvpi?: Maybe<Scalars['Float']['output']>;
  unrealized?: Maybe<Scalars['Float']['output']>;
  uploadId: Scalars['Int']['output'];
  year?: Maybe<Scalars['Int']['output']>;
};

export type PmeSummaryResult = {
  __typename?: 'PmeSummaryResult';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  byAttribute: Array<PmeAttributeStratification>;
  byFund: Array<PmeMetricGroup>;
  byStatus: Array<PmeMetricGroup>;
  byStrategy: Array<PmeMetricGroup>;
  byYear: Array<PmeMetricGroup>;
  netByFund: Array<PmeMetricGroup>;
  total: PmeMetricGroup;
};

export type PmeUpload = {
  __typename?: 'PmeUpload';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  investmentId: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type PmeUploadStatusResult = {
  __typename?: 'PmeUploadStatusResult';
  id: Scalars['ID']['output'];
  returnValue?: Maybe<PmeFileParse>;
  status: AsyncTaskStatus;
};

export type PortalEmailDomainOrganization = {
  __typename?: 'PortalEmailDomainOrganization';
  emailDomain: Scalars['String']['output'];
  id: Scalars['String']['output'];
  organization: PortalOrganization;
  organizationId: Scalars['String']['output'];
};

export type PortalFirm = {
  __typename?: 'PortalFirm';
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  deleteUser?: Maybe<Scalars['String']['output']>;
  firmType?: Maybe<PortalFirmTypeEnum>;
  firmTypeEnumId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['String']['output'];
  migratedAt?: Maybe<Scalars['DateTime']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization: PortalOrganization;
  organizationId: Scalars['String']['output'];
  portalServiceProviderFirms: Array<PortalServiceProviderFirms>;
  profileInput?: Maybe<Scalars['JSON']['output']>;
  rcgFirm?: Maybe<Firm>;
  rcgFirmId?: Maybe<Scalars['ID']['output']>;
  shouldUpdate?: Maybe<Scalars['Boolean']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  sizeSymbol?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type PortalFirmFilter = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  rcgFirmId?: InputMaybe<Scalars['ID']['input']>;
  shouldUpdate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PortalFirmInput = {
  firmTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  rcgFirmId?: InputMaybe<Scalars['ID']['input']>;
  shouldUpdate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PortalFirmList = {
  __typename?: 'PortalFirmList';
  items: Array<PortalFirm>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PortalFirmSort = {
  field: PortalFirmSortEnum;
  order: SortInput;
};

export enum PortalFirmSortEnum {
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type PortalFirmTypeEnum = {
  __typename?: 'PortalFirmTypeEnum';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PortalFirmTypeEnumFilter = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PortalFirmTypeEnumList = {
  __typename?: 'PortalFirmTypeEnumList';
  items: Array<PortalFirmTypeEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PortalFirmTypeEnumSort = {
  field: PortalFirmTypeEnumSortEnum;
  order: SortInput;
};

export enum PortalFirmTypeEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type PortalOrganization = {
  __typename?: 'PortalOrganization';
  allowMultiFirm?: Maybe<Scalars['Boolean']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser?: Maybe<Scalars['String']['output']>;
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  deleteUser?: Maybe<Scalars['String']['output']>;
  emailDomainMappings: Array<PortalEmailDomainOrganization>;
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  portalServiceProviderFirms: Array<PortalServiceProviderFirms>;
  primaryFirm?: Maybe<PortalFirm>;
  users: Array<PortalUser>;
};

export type PortalOrganizationCreateInput = {
  name: Scalars['String']['input'];
};

export type PortalOrganizationFilter = {
  q?: InputMaybe<Scalars['String']['input']>;
};

export type PortalOrganizationInput = {
  allowMultiFirm?: InputMaybe<Scalars['Boolean']['input']>;
  emailDomainMappings?: InputMaybe<Array<EmailDomainOrganizationInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  portalServiceProviderFirms?: InputMaybe<Array<PortalServiceProviderFirmInput>>;
  users?: InputMaybe<Array<PortalOrganizationUserInput>>;
};

export type PortalOrganizationList = {
  __typename?: 'PortalOrganizationList';
  items: Array<PortalOrganization>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PortalOrganizationSort = {
  field: PortalOrganizationSortEnum;
  order: SortInput;
};

export enum PortalOrganizationSortEnum {
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type PortalOrganizationUserInput = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type PortalServiceProviderFirmFilter = {
  firmId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type PortalServiceProviderFirmInput = {
  firmId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type PortalServiceProviderFirmSort = {
  field: PortalServiceProviderFirmSortEnum;
  order: SortInput;
};

export enum PortalServiceProviderFirmSortEnum {
  Name = 'name'
}

export type PortalServiceProviderFirms = {
  __typename?: 'PortalServiceProviderFirms';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  firm: PortalFirm;
  firmId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  organization: PortalOrganization;
  organizationId: Scalars['String']['output'];
};

export type PortalServiceProviderFirmsList = {
  __typename?: 'PortalServiceProviderFirmsList';
  items: Array<PortalServiceProviderFirms>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PortalSubmitted = {
  __typename?: 'PortalSubmitted';
  createUser?: Maybe<Scalars['String']['output']>;
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  deleteUser?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firm: PortalFirm;
  firmId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  migratedAt?: Maybe<Scalars['DateTime']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rcgFund?: Maybe<Investment>;
  rcgFundId?: Maybe<Scalars['ID']['output']>;
  shouldUpdate?: Maybe<Scalars['Boolean']['output']>;
  source_id?: Maybe<Scalars['ID']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  user_input?: Maybe<Scalars['JSON']['output']>;
};

export type PortalSubmittedFilter = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  rcgFundId?: InputMaybe<Scalars['ID']['input']>;
  shouldUpdate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PortalSubmittedInput = {
  firmId?: InputMaybe<Scalars['ID']['input']>;
  rcgFundId?: InputMaybe<Scalars['ID']['input']>;
  shouldUpdate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PortalSubmittedList = {
  __typename?: 'PortalSubmittedList';
  items: Array<PortalSubmitted>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PortalSubmittedSort = {
  field: PortalSubmittedSortEnum;
  order: SortInput;
};

export enum PortalSubmittedSortEnum {
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type PortalUser = {
  __typename?: 'PortalUser';
  createDate: Scalars['DateTime']['output'];
  createUser?: Maybe<Scalars['String']['output']>;
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  deleteUser?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<PortalOrganization>;
  organizationId?: Maybe<Scalars['String']['output']>;
};

export type PortalUserFilter = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type PortalUserInput = {
  deleteDate?: InputMaybe<Scalars['DateTime']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type PortalUserList = {
  __typename?: 'PortalUserList';
  items: Array<PortalUser>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PortalUserSort = {
  field: PortalUserSortEnum;
  order: SortInput;
};

export enum PortalUserSortEnum {
  Email = 'email',
  FirstName = 'firstName',
  Id = 'id',
  LastName = 'lastName',
  NameSearchRank = 'nameSearchRank',
  OrganizationId = 'organizationId',
  OrganizationName = 'organizationName'
}

export type Portfolio = {
  __typename?: 'Portfolio';
  baseCurrency?: Maybe<Scalars['String']['output']>;
  briefNm: Scalars['String']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  dateRange: PortfolioDateRange;
  entries?: Maybe<Array<PortfolioEntry>>;
  id: Scalars['Int']['output'];
  investment?: Maybe<Investment>;
  investmentId?: Maybe<Scalars['Int']['output']>;
  isEntitledToEdit?: Maybe<Scalars['Boolean']['output']>;
  isPrimary: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** The months this portfolio has a NAV statement for (ascending month-ends); empty unless it is a primary portfolio linked to an RCG fund. Requires read access to that fund. */
  navDates?: Maybe<Array<Scalars['Date']['output']>>;
  portfolioGroupId?: Maybe<Scalars['Int']['output']>;
  shareType: Scalars['Int']['output'];
  sharedWith?: Maybe<Array<User>>;
  sharedWithAll?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};


export type PortfolioEntriesArgs = {
  date: Scalars['Date']['input'];
  lookthrough?: InputMaybe<Scalars['Boolean']['input']>;
  periods: Scalars['Int']['input'];
};

export type PortfolioAfsLookthroughResult = {
  __typename?: 'PortfolioAfsLookthroughResult';
  aggregatedHoldings: Array<AggregatedHoldingResult>;
  /** Number of managers with completed AFS extractions */
  extractionCount: Scalars['Int']['output'];
  managers: Array<ManagerSummary>;
  significantExposureCount: Scalars['Int']['output'];
  /** Total number of managers in the portfolio */
  totalManagerCount: Scalars['Int']['output'];
  totalNetAssets: Scalars['Float']['output'];
  totalPortfolioValue: Scalars['Float']['output'];
  weightedLevel3Pct?: Maybe<Scalars['Float']['output']>;
  weightedLeverage?: Maybe<Scalars['Float']['output']>;
};

export type PortfolioAllocationInput = {
  additions: Scalars['Float']['input'];
  date: Scalars['Date']['input'];
  redemptions: Scalars['Float']['input'];
};

export enum PortfolioCategoryEnum {
  Primary = 'primary',
  Shared = 'shared',
  User = 'user'
}

export type PortfolioCommitment = {
  __typename?: 'PortfolioCommitment';
  amount: Scalars['Float']['output'];
  isPreInvestment: Scalars['Boolean']['output'];
};

export type PortfolioConfig = {
  __typename?: 'PortfolioConfig';
  clientVisibleTabs?: Maybe<Array<ClientVisibleTabs>>;
  id: Scalars['Int']['output'];
  lag?: Maybe<Scalars['Int']['output']>;
  lagUnitId?: Maybe<Scalars['Int']['output']>;
  lookthroughEnabled?: Maybe<Scalars['Boolean']['output']>;
  lookthroughInvestments?: Maybe<Array<Investment>>;
  /** Combined Performance Lag and Unit so types match the check constraint (both defined or both null) */
  performanceLag?: Maybe<PerformanceLag>;
  portfolio: Investment;
  portfolioId: Scalars['Int']['output'];
  showInvestments?: Maybe<Scalars['Boolean']['output']>;
  tileImage?: Maybe<Document>;
  tileImageId?: Maybe<Scalars['Int']['output']>;
};

export type PortfolioConfigFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  lookthroughEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  portfolioIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
  showInvestments?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PortfolioConfigInput = {
  clientVisibleTabs?: InputMaybe<Array<ClientVisibleTabs>>;
  lookthroughEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lookthroughInvestmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  performanceLag?: InputMaybe<PerformanceLagInput>;
  portfolioId?: InputMaybe<Scalars['Int']['input']>;
  showInvestments?: InputMaybe<Scalars['Boolean']['input']>;
  tileImageId?: InputMaybe<Scalars['Int']['input']>;
};

export type PortfolioConfigList = {
  __typename?: 'PortfolioConfigList';
  items: Array<PortfolioConfig>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PortfolioConfigSort = {
  field: PortfolioConfigSortEnum;
  order: SortInput;
};

export enum PortfolioConfigSortEnum {
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type PortfolioDateRange = {
  __typename?: 'PortfolioDateRange';
  end: Scalars['Date']['output'];
  start: Scalars['Date']['output'];
};

export type PortfolioEntry = {
  __typename?: 'PortfolioEntry';
  balances: Array<WeightedBalance>;
  commitment?: Maybe<PortfolioCommitment>;
  initBalance: WeightedBalance;
  initTran?: Maybe<PortfolioTran>;
  isLinked?: Maybe<Scalars['Boolean']['output']>;
  isLookthrough?: Maybe<Scalars['Boolean']['output']>;
  liquidity?: Maybe<PortfolioLiquidity>;
  managerId: Scalars['Int']['output'];
};

export type PortfolioEntryInput = {
  allocations?: InputMaybe<Array<PortfolioAllocationInput>>;
  link?: InputMaybe<Scalars['Boolean']['input']>;
  managerId: Scalars['Int']['input'];
  tag?: InputMaybe<PortfolioTagInput>;
};

export type PortfolioFdpLogins = {
  __typename?: 'PortfolioFDPLogins';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  fdpLogin: FdpLogin;
  fdpLoginId: Scalars['Int']['output'];
  fdpWebsite?: Maybe<FdpWebsites>;
  fdpWebsiteId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  portfolio: Investment;
  portfolioId: Scalars['Int']['output'];
};

export type PortfolioFdpLoginsFilter = {
  fdpLoginId?: InputMaybe<Scalars['Int']['input']>;
  fdpWebsiteId?: InputMaybe<Scalars['Int']['input']>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  portfolioId?: InputMaybe<Scalars['Int']['input']>;
};

export type PortfolioFdpLoginsInput = {
  fdpLoginId?: InputMaybe<Scalars['Int']['input']>;
  fdpWebsiteId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  portfolioId?: InputMaybe<Scalars['Int']['input']>;
};

export type PortfolioFdpLoginsList = {
  __typename?: 'PortfolioFDPLoginsList';
  items: Array<PortfolioFdpLogins>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PortfolioFdpLoginsSort = {
  field: PortfolioFdpLoginsSortEnum;
  order: SortInput;
};

export enum PortfolioFdpLoginsSortEnum {
  FdpLoginId = 'fdpLoginId',
  Id = 'id',
  PortfolioId = 'portfolioId'
}

export type PortfolioFilter = {
  category?: InputMaybe<PortfolioCategoryEnum>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  investmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  nameSearch?: InputMaybe<Scalars['String']['input']>;
};

export type PortfolioInput = {
  baseCurrency?: InputMaybe<Scalars['String']['input']>;
  briefNm: Scalars['String']['input'];
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  portfolioGroupId?: InputMaybe<Scalars['Int']['input']>;
  shareType?: InputMaybe<PortfolioShareEnum>;
  shareUserIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PortfolioLiquidity = {
  __typename?: 'PortfolioLiquidity';
  frequency?: Maybe<Scalars['Int']['output']>;
  nextNotice?: Maybe<Scalars['Date']['output']>;
  nextRedemption?: Maybe<Scalars['Date']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

export type PortfolioList = {
  __typename?: 'PortfolioList';
  items: Array<Portfolio>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PortfolioSearchFilter = {
  isPortfolio?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PortfolioShareEnum {
  All = 'all',
  None = 'none',
  Some = 'some'
}

export type PortfolioSort = {
  field: PortfolioSortEnum;
  order: SortInput;
};

export enum PortfolioSortEnum {
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type PortfolioTagInput = {
  clientTag?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['Date']['input'];
  guidelineTag?: InputMaybe<Scalars['String']['input']>;
  openTag?: InputMaybe<Scalars['String']['input']>;
  teamTag?: InputMaybe<Scalars['String']['input']>;
};

export type PortfolioTran = {
  __typename?: 'PortfolioTran';
  beginBalance: Scalars['Float']['output'];
  date: Scalars['Date']['output'];
  estimatedReturn?: Maybe<Scalars['Float']['output']>;
  estimatedReturnDate?: Maybe<Scalars['Date']['output']>;
};

export type Position = {
  __typename?: 'Position';
  DPI?: Maybe<Scalars['Float']['output']>;
  MOIC?: Maybe<Scalars['Float']['output']>;
  RVPI?: Maybe<Scalars['Float']['output']>;
  assetClass?: Maybe<Scalars['String']['output']>;
  category2?: Maybe<Scalars['String']['output']>;
  /** The position's category4 label. 'proxy' marks a modelled (proxy) position rather than a reported holding, which top-holdings reports exclude. */
  category4?: Maybe<Scalars['String']['output']>;
  categoryLevel: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  gicsSubSector?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initialInvestmentDate?: Maybe<Scalars['Date']['output']>;
  investedAmount?: Maybe<Scalars['Float']['output']>;
  investmentId: Scalars['Int']['output'];
  isin?: Maybe<Scalars['String']['output']>;
  marketCap?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  percentChange?: Maybe<PositionPercentChange>;
  realizedAmount?: Maybe<Scalars['Float']['output']>;
  reportDate: Scalars['DateTime']['output'];
  ric?: Maybe<Scalars['String']['output']>;
  secType?: Maybe<Scalars['String']['output']>;
  sector?: Maybe<Scalars['String']['output']>;
  securityMasterId?: Maybe<Scalars['Int']['output']>;
  sourceDate: Scalars['DateTime']['output'];
  ticker: Scalars['String']['output'];
  totalValue?: Maybe<Scalars['Float']['output']>;
  unrealizedAmount?: Maybe<Scalars['Float']['output']>;
  weight: Scalars['Float']['output'];
};

export type PositionFilterInput = {
  /** Optionally restrict the search to a subset of investments. Entitlements still apply on top of this list. */
  investmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** When true (default), only consider each investment's most recent snapshot. Ignored if reportDate is provided. */
  mostRecent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Restrict to a specific position report date. If omitted and mostRecent is true (default), the latest report date per investment is used. */
  reportDate?: InputMaybe<Scalars['DateTime']['input']>;
  riskTier?: InputMaybe<Scalars['String']['input']>;
};

export type PositionList = {
  __typename?: 'PositionList';
  items: Array<Position>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PositionPercentChange = {
  __typename?: 'PositionPercentChange';
  categoryLevel: Scalars['String']['output'];
  percentChange?: Maybe<Scalars['Float']['output']>;
  priorReportDate?: Maybe<Scalars['DateTime']['output']>;
  priorWeight?: Maybe<Scalars['Float']['output']>;
  reportDate: Scalars['DateTime']['output'];
  weight: Scalars['Float']['output'];
};

export type PositionSort = {
  field: PositionSortEnum;
  order: SortInput;
};

export enum PositionSortEnum {
  Name = 'name',
  ReportDate = 'reportDate',
  Weight = 'weight'
}

/** exposure position types */
export enum PositionType {
  Gross = 'GROSS',
  Long = 'LONG',
  Net = 'NET',
  PercentGross = 'PERCENT_GROSS',
  Short = 'SHORT'
}

export type PositionsSearchFilter = {
  /** When true (default), only consider each investment's most recent position snapshot. Ignored if reportDate is provided. */
  mostRecent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Limit position exposure to a specific report date. If omitted and mostRecent is true (default), the latest report date per investment is used. */
  reportDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Match positions whose security issuer name contains any of these substrings (case-insensitive, min 3 chars each). */
  securityNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Match positions whose ticker equals any of these values (case-insensitive). */
  tickers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PresignedTempUrlInput = {
  filename?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
};

export type PresignedTempUrlResult = {
  __typename?: 'PresignedTempUrlResult';
  bucket?: Maybe<Scalars['String']['output']>;
  /** The s3 key containing the auto-generated unique filename. Will have the same file extension as the original filename, if provided. */
  key?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type PricingFrequencyEnum = {
  __typename?: 'PricingFrequencyEnum';
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PricingFrequencyEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PricingFrequencyEnumList = {
  __typename?: 'PricingFrequencyEnumList';
  items: Array<PricingFrequencyEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PricingFrequencyEnumSort = {
  field: PricingFrequencyEnumSortEnum;
  order: SortInput;
};

export enum PricingFrequencyEnumSortEnum {
  Id = 'id'
}

export type PrivateQuartileGroup = {
  __typename?: 'PrivateQuartileGroup';
  asOfDate: Scalars['DateTime']['output'];
  capitalization: Scalars['Float']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  dpi5th: Scalars['Float']['output'];
  dpi25th: Scalars['Float']['output'];
  dpi50th: Scalars['Float']['output'];
  dpi75th: Scalars['Float']['output'];
  dpi95th: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  irr5th: Scalars['Float']['output'];
  irr25th: Scalars['Float']['output'];
  irr50th: Scalars['Float']['output'];
  irr75th: Scalars['Float']['output'];
  irr95th: Scalars['Float']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  numberOfFunds: Scalars['Int']['output'];
  numberOfResults: Scalars['Int']['output'];
  pooledDPI: Scalars['Float']['output'];
  pooledIRR: Scalars['Float']['output'];
  pooledTVPI: Scalars['Float']['output'];
  privateQuartileGroupCategoryId: Scalars['Int']['output'];
  tvpi5th: Scalars['Float']['output'];
  tvpi25th: Scalars['Float']['output'];
  tvpi50th: Scalars['Float']['output'];
  tvpi75th: Scalars['Float']['output'];
  tvpi95th: Scalars['Float']['output'];
};

export type PrivateQuartileGroupCategory = {
  __typename?: 'PrivateQuartileGroupCategory';
  assetClassTier1: Scalars['String']['output'];
  assetClassTier2: Scalars['String']['output'];
  assetClassTier3: Scalars['String']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  displayLabel?: Maybe<Scalars['String']['output']>;
  geographyTier1: Scalars['String']['output'];
  geographyTier2: Scalars['String']['output'];
  geographyTier3: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  uniqueLabel: Scalars['String']['output'];
  vintageYear: Scalars['Int']['output'];
};

export type PrivateQuartileGroupCategoryFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type PrivateQuartileGroupCategoryList = {
  __typename?: 'PrivateQuartileGroupCategoryList';
  items: Array<PrivateQuartileGroupCategory>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PrivateQuartileGroupCategorySort = {
  field: PrivateQuartileGroupCategorySortEnum;
  order: SortInput;
};

export enum PrivateQuartileGroupCategorySortEnum {
  Id = 'id'
}

export type ProfileBuilderResponse = {
  __typename?: 'ProfileBuilderResponse';
  answer?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['Int']['output']>;
  investmentProfile?: Maybe<GeneratedInvestmentProfile>;
};

export type Query = {
  __typename?: 'Query';
  aamOptimizationOptions: AamOptimizationOptions;
  aamOptimizationReport: Scalars['String']['output'];
  accountTypeEnum?: Maybe<AccountTypeEnum>;
  accountTypeEnumList: AccountTypeEnumList;
  accountTypeEnumMany: Array<Maybe<AccountTypeEnum>>;
  accountingManagerList: AccountingManagerList;
  adEntriesXApplicationFlags?: Maybe<AdEntriesXApplicationFlags>;
  adEntriesXApplicationFlagsList: AdEntriesXApplicationFlagsList;
  adEntriesXApplicationFlagsMany: Array<Maybe<AdEntriesXApplicationFlags>>;
  adEntriesXApplicationsXSets?: Maybe<AdEntriesXApplicationsXSets>;
  adEntriesXApplicationsXSetsList: AdEntriesXApplicationsXSetsList;
  adEntriesXApplicationsXSetsMany: Array<Maybe<AdEntriesXApplicationsXSets>>;
  address?: Maybe<Address>;
  addressSearch: Array<AddressSearchItem>;
  /** What changed between the firm's two most recent stored Form ADV filings, per item (default: every item) */
  advCompare: AdvComparison;
  /** The review of the firm's latest Form ADV Part 1. When it has not been reviewed yet, a review is queued and returned as `task`. */
  advReview: AdvReview;
  advSummaryEmailNotification?: Maybe<AdvSummaryEmailNotification>;
  advisorTypeEnum?: Maybe<AdvisorTypeEnum>;
  advisorTypeEnumList: AdvisorTypeEnumList;
  advisorTypeEnumMany: Array<Maybe<AdvisorTypeEnum>>;
  afsAccountingReview: Scalars['String']['output'];
  afsExtraction?: Maybe<AfsExtraction>;
  afsExtractionsByInvestment: Array<AfsExtraction>;
  afsExtractionsByPortfolio: Array<AfsExtraction>;
  afsHoldingsList: AfsHoldingList;
  agency?: Maybe<Agency>;
  agencyList: AgencyList;
  agencyMany: Array<Maybe<Agency>>;
  /** Every notification subscription, for the administration screen. */
  allNotificationSubscriptions: Array<NotificationSubscription>;
  application?: Maybe<Application>;
  applicationFlag?: Maybe<ApplicationFlags>;
  applicationFlagList: ApplicationFlagList;
  applicationFlagMany: Array<Maybe<ApplicationFlags>>;
  applicationList: ApplicationList;
  applicationMany: Array<Maybe<Application>>;
  assetClass2Enum?: Maybe<AssetClass2Enum>;
  assetClass2EnumList: AssetClass2EnumList;
  assetClass2EnumMany: Array<Maybe<AssetClass2Enum>>;
  assetClassEnum?: Maybe<AssetClassEnum>;
  assetClassEnumList: AssetClassEnumList;
  assetClassEnumMany: Array<Maybe<AssetClassEnum>>;
  assetClassOptions: AssetClass2EnumList;
  asyncDocumentProcess?: Maybe<Scalars['String']['output']>;
  asyncTaskStatus?: Maybe<AsyncTaskStatus>;
  auditContactTypeEnum?: Maybe<AuditContactTypeEnum>;
  auditContactTypeEnumList: AuditContactTypeEnumList;
  auditContactTypeEnumMany: Array<Maybe<AuditContactTypeEnum>>;
  availableFields: Array<FieldDefinition>;
  availableMetrics: Array<MetricInfo>;
  /** Browse every organization skill, active or deactivated for the caller */
  availableOrgChatSkills: Array<ChatSkill>;
  axysCode?: Maybe<AxysCode>;
  axysCodeList: AxysCodeList;
  axysCodeMany: Array<Maybe<AxysCode>>;
  /** Sorted Desc, available dates for the balances. */
  balanceDates: Array<Scalars['Date']['output']>;
  balancesList: BalancesList;
  bloombergDiligenceExtractStatus: Array<BbgDistributionsResponse>;
  bulkPersonProfileFromFilesBuilder: BulkPersonProfileBuilderResponse;
  businessObjectEnum?: Maybe<BusinessObjectEnum>;
  businessObjectEnumList: BusinessObjectEnumList;
  businessObjectEnumMany: Array<Maybe<BusinessObjectEnum>>;
  calendarUnitEnum?: Maybe<CalendarUnitEnum>;
  calendarUnitEnumList: CalendarUnitEnumList;
  calendarUnitEnumMany: Array<Maybe<CalendarUnitEnum>>;
  caseStudyReport?: Maybe<Scalars['String']['output']>;
  chat: QuestionResponse;
  chatAgent?: Maybe<ChatAgent>;
  chatAgentCapabilities: ChatAgentCapabilities;
  chatAgentHistory: Array<ChatAgentHistory>;
  chatAgentList: ChatAgentList;
  chatAgentMany: Array<Maybe<ChatAgent>>;
  chatAgentsByScope: Array<ChatAgent>;
  chatSkill?: Maybe<ChatSkill>;
  /** Groups in an organization that can be granted write access to a skill */
  chatSkillGrantableGroups: Array<ChatSkillGrantableGroup>;
  /** Groups holding write access on a skill — visible to anyone who may edit it */
  chatSkillGroupAccess: Array<ChatSkillGroup>;
  /** Version history snapshots for a skill, newest first — restricted to users who may edit it */
  chatSkillHistory: Array<ChatSkillHistory>;
  chatSkillList: ChatSkillList;
  chatSkillMany: Array<Maybe<ChatSkill>>;
  chatSkillSchedule?: Maybe<ChatSkillSchedule>;
  chatSkillScheduleList: ChatSkillScheduleList;
  chatSkillScheduleMany: Array<Maybe<ChatSkillSchedule>>;
  chatSkillsByScope: Array<ChatSkill>;
  client?: Maybe<Client>;
  /** Allocation rows: for some funds (omit for all), one share class, and/or one month. withFlowsOnly keeps months with an addition, redemption or switch. */
  clientAllocations: Array<ClientAllocationRow>;
  /** A client's capital changes in a fund, by share class and month, newest first. */
  clientCapitalFlows: Array<ClientCapitalFlowRow>;
  clientFeeOptions: ClientFeeOptions;
  /** The clients with a share class in the fund, or every client when rcgFundId is omitted. */
  clientInvestmentClients: Array<ClientInvestmentClient>;
  /** Every RCG fund a client can hold share classes in. */
  clientInvestmentFunds: Array<ClientInvestmentFund>;
  clientList: ClientList;
  clientMany: Array<Maybe<Client>>;
  /** A fund's share classes, optionally one client's. */
  clientShareClasses: Array<ClientShareClassRow>;
  /** The switches between a client's share classes in a fund. */
  clientSwitches: Array<ClientSwitchRow>;
  closeDateFundSize: Array<CloseDateFundSize>;
  clusterReport: Scalars['String']['output'];
  cogencyLink?: Maybe<CogencyLink>;
  company?: Maybe<Company>;
  companyEnum?: Maybe<CompanyEnum>;
  companyEnumList: CompanyEnumList;
  companyEnumMany: Array<Maybe<CompanyEnum>>;
  companyFields: CompanyFields;
  companyList: CompanyList;
  companyMany: Array<Maybe<Company>>;
  companyTypeEnum: CompanyTypeEnum;
  companyTypeEnumList: CompanyTypeEnumList;
  companyTypeEnumMany: Array<Maybe<CompanyTypeEnum>>;
  companyValuation?: Maybe<CompanyValuation>;
  companyValuationList: CompanyValuationList;
  companyValuationMany: Array<Maybe<CompanyValuation>>;
  compoundingPeriodEnum?: Maybe<CompoundingPeriodEnum>;
  compoundingPeriodEnumList: CompoundingPeriodEnumList;
  compoundingPeriodEnumMany: Array<Maybe<CompoundingPeriodEnum>>;
  contactTypeEnum?: Maybe<ContactTypeEnum>;
  contactTypeEnumList: ContactTypeEnumList;
  contactTypeEnumMany: Array<Maybe<ContactTypeEnum>>;
  conversationArtifacts: Array<ConversationArtifact>;
  countryEnum?: Maybe<CountryEnum>;
  countryEnumList: CountryEnumList;
  countryEnumMany: Array<Maybe<CountryEnum>>;
  /** Credit position of every user in an organization for this month. */
  creditUsageByUser: Array<UserCreditUsage>;
  currencyDenominationEnum?: Maybe<CurrencyDenominationEnum>;
  currencyDenominationEnumList: CurrencyDenominationEnumList;
  currencyDenominationEnumMany: Array<Maybe<CurrencyDenominationEnum>>;
  currentUser: CurrentUser;
  currentUserPrimaryOrganizationGroupId?: Maybe<Scalars['Int']['output']>;
  currentUserSettings?: Maybe<UserSettings>;
  customAnalytics: CustomAnalytics;
  customAnalyticsList: CustomAnalyticsList;
  customIndexGroup?: Maybe<CustomIndexGroup>;
  customIndexInvestment?: Maybe<CustomIndexInvestment>;
  customIndexInvestmentList: CustomIndexInvestmentList;
  customIndexInvestmentMany: Array<Maybe<CustomIndexInvestment>>;
  customIndexPreview: Array<PerformanceMtd>;
  cusumReport: Scalars['String']['output'];
  deal?: Maybe<Deal>;
  dealAvailableFilterOptions: DealFilterOptions;
  dealList: DealList;
  dealMany: Array<Maybe<Deal>>;
  dealMarketingEnum?: Maybe<DealMarketingEnum>;
  dealMarketingEnumList: DealMarketingEnumList;
  dealMarketingEnumMany: Array<Maybe<DealMarketingEnum>>;
  dealStructureEnum?: Maybe<DealStructureEnum>;
  dealStructureEnumList: DealStructureEnumList;
  dealStructureEnumMany: Array<Maybe<DealStructureEnum>>;
  dealTags?: Maybe<DealTags>;
  degreeEnum?: Maybe<DegreeEnum>;
  degreeEnumList: DegreeEnumList;
  degreeEnumMany: Array<Maybe<DegreeEnum>>;
  deiCategory1Enum?: Maybe<DeiCategory1Enum>;
  deiCategory1EnumList: DeiCategory1EnumList;
  deiCategory1EnumMany: Array<Maybe<DeiCategory1Enum>>;
  deiCategory2Enum?: Maybe<DeiCategory2Enum>;
  deiCategory2EnumList: DeiCategory2EnumList;
  deiCategory2EnumMany: Array<Maybe<DeiCategory2Enum>>;
  differenceRiskReport: Scalars['String']['output'];
  diversityStatsEnum?: Maybe<DiversityStatsEnum>;
  diversityStatsEnumList: DiversityStatsEnumList;
  diversityStatsEnumMany: Array<Maybe<DiversityStatsEnum>>;
  document?: Maybe<Document>;
  documentAccessLevel?: Maybe<DocumentAccessLevel>;
  documentAccessLevelList: DocumentAccessLevelList;
  documentAccessLevelMany: Array<Maybe<DocumentAccessLevel>>;
  documentCountByDocumentType: Array<DocumentCountByDocumentType>;
  documentDownloadBatch: DocumentBatch;
  documentFileExtensions: Array<Scalars['String']['output']>;
  documentMany: Array<Maybe<Document>>;
  documentQueue?: Maybe<DocumentQueue>;
  documentQueueList: DocumentQueueList;
  documentQueueMany: Array<Maybe<DocumentQueue>>;
  documentTypeEnum?: Maybe<DocumentTypeEnum>;
  documentTypeEnumList: DocumentTypeEnumList;
  documentTypeEnumMany: Array<Maybe<DocumentTypeEnum>>;
  documentTypeSuggestion: Scalars['Float']['output'];
  documents: DocumentList;
  dryRunMutationStep: DryRunMutationStepResult;
  /** Every RCG fund in the NAV model with its estimate for the month (any day of it; the month-end is used). */
  earlyEstimates: Array<EarlyEstimateRow>;
  emRiskReport: Scalars['String']['output'];
  emailDomainXOrganization?: Maybe<EmailDomainXOrganization>;
  emailDomainXOrganizationList: EmailDomainXOrganizationList;
  emailDomainXOrganizationMany: Array<Maybe<EmailDomainXOrganization>>;
  employeeRoleEnum?: Maybe<EmployeeRoleEnum>;
  employeeRoleEnumList: EmployeeRoleEnumList;
  employeeRoleEnumMany: Array<Maybe<EmployeeRoleEnum>>;
  exceptionReport: Scalars['String']['output'];
  exposure: Exposure;
  exposureReport: Scalars['String']['output'];
  family?: Maybe<Family>;
  familyList: FamilyList;
  familyMany: Array<Maybe<Family>>;
  fdpLogin?: Maybe<FdpLogin>;
  fdpLoginAuthenticatorEnum?: Maybe<FdpLoginAuthenticatorEnum>;
  fdpLoginAuthenticatorEnumList: FdpLoginAuthenticatorEnumList;
  fdpLoginAuthenticatorEnumMany: Array<Maybe<FdpLoginAuthenticatorEnum>>;
  fdpLoginList: FdpLoginList;
  fdpLoginMany: Array<Maybe<FdpLogin>>;
  fdpWebsites?: Maybe<FdpWebsites>;
  fdpWebsitesList: FdpWebsitesList;
  fdpWebsitesMany: Array<Maybe<FdpWebsites>>;
  feeCalcEnum?: Maybe<FeeCalcEnum>;
  feeCalcEnumList: FeeCalcEnumList;
  feeCalcEnumMany: Array<Maybe<FeeCalcEnum>>;
  feeFreqEnum?: Maybe<FeeFreqEnum>;
  feeFreqEnumList: FeeFreqEnumList;
  feeFreqEnumMany: Array<Maybe<FeeFreqEnum>>;
  fieldKeysByQuestion: FieldKeySearchResult;
  fieldList: FieldList;
  fieldListDownload: FieldList;
  financialDataProvider?: Maybe<FinancialDataProvider>;
  financialDataProviderList: FinancialDataProviderList;
  financialDataProviderMany: Array<Maybe<FinancialDataProvider>>;
  financialPeriodEnum?: Maybe<FinancialPeriodEnum>;
  financialPeriodEnumList: FinancialPeriodEnumList;
  financialPeriodEnumMany: Array<Maybe<FinancialPeriodEnum>>;
  findSavedKnowledgeBaseByFilters?: Maybe<SavedKnowledgeBase>;
  firm?: Maybe<Firm>;
  firmDEI?: Maybe<FirmDei>;
  firmDEIList: FirmDeiList;
  firmDEIMany: Array<Maybe<FirmDei>>;
  firmEmployment?: Maybe<FirmEmployment>;
  firmEmploymentList: FirmEmploymentList;
  firmEmploymentMany: Array<Maybe<FirmEmployment>>;
  firmEmployments?: Maybe<Array<FirmEmployment>>;
  firmEngagement?: Maybe<FirmEngagement>;
  firmEngagementList: FirmEngagementList;
  firmEngagementMany: Array<Maybe<FirmEngagement>>;
  firmEngagementTypeEnum?: Maybe<FirmEngagementTypeEnum>;
  firmEngagementTypeEnumList: FirmEngagementTypeEnumList;
  firmFDPLogins?: Maybe<FirmFdpLogins>;
  firmFDPLoginsList: FirmFdpLoginsList;
  firmFDPLoginsMany: Array<Maybe<FirmFdpLogins>>;
  firmFields: FirmFields;
  firmInstitutions?: Maybe<FirmInstitutions>;
  firmInstitutionsList: FirmInstitutionsList;
  firmInstitutionsMany: Array<Maybe<FirmInstitutions>>;
  firmList: FirmList;
  firmMany: Array<Maybe<Firm>>;
  firmProfileFromUrlBuilder: FirmProfileBuilderResponse;
  firmTags?: Maybe<FirmTags>;
  firmTeamStructure: FirmTeamStructure;
  fundingTypeEnum?: Maybe<FundingTypeEnum>;
  fundingTypeEnumList: FundingTypeEnumList;
  fundingTypeEnumMany: Array<Maybe<FundingTypeEnum>>;
  fundsXProxies?: Maybe<FundsXProxies>;
  fundsXProxiesList: FundsXProxiesList;
  fxRate?: Maybe<FxRate>;
  generateNoteEmbedding: Scalars['Boolean']['output'];
  geographicFocusEnum?: Maybe<GeographicFocusEnum>;
  geographicFocusEnumList: GeographicFocusEnumList;
  geographicFocusEnumMany: Array<Maybe<GeographicFocusEnum>>;
  geographyEnum?: Maybe<GeographyEnum>;
  geographyEnumList: GeographyEnumList;
  geographyEnumMany: Array<Maybe<GeographyEnum>>;
  getDocumentQueueUploadUrl: Scalars['String']['output'];
  /** Get a presigned URL to upload an organization icon. contentType must be image/png or image/jpeg. */
  getOrganizationIconUploadUrl: Scalars['String']['output'];
  getRangerDueDiligenceDrafts?: Maybe<Scalars['String']['output']>;
  globalProviderInstitutions?: Maybe<GlobalProviderInstitutions>;
  globalProviderInstitutionsList: GlobalProviderInstitutionsList;
  globalProviderNoteTypeEnum?: Maybe<GlobalProviderNoteTypeEnum>;
  globalProviderNoteTypeEnumList: GlobalProviderNoteTypeEnumList;
  globalProviderNoteTypeEnumMany: Array<Maybe<GlobalProviderNoteTypeEnum>>;
  groupShareDefinition?: Maybe<GroupShareDefinition>;
  groupShareDefinitionList: GroupShareDefinitionList;
  groupShareDefinitionMany: Array<Maybe<GroupShareDefinition>>;
  guidelineBreaches: Array<GuidelineBreachSummary>;
  guidelineNotes: Array<GuidelineNote>;
  guidelineSet?: Maybe<GuidelineSet>;
  guidelineSets: Array<GuidelineSet>;
  heatmapReport: Scalars['String']['output'];
  highChart: Chart;
  iconEnum?: Maybe<IconEnum>;
  iconEnumList: IconEnumList;
  iconEnumMany: Array<Maybe<IconEnum>>;
  impactCategoryEnumList: ImpactCategoryEnumList;
  impactEnum?: Maybe<ImpactEnum>;
  importRiskMeasuresStatus?: Maybe<ImportRiskMeasuresStatus>;
  indexCalcTypeEnum?: Maybe<IndexCalcTypeEnum>;
  indexCalcTypeEnumList: IndexCalcTypeEnumList;
  indexCalcTypeEnumMany: Array<Maybe<IndexCalcTypeEnum>>;
  institution?: Maybe<Institution>;
  institutionEmployment?: Maybe<InstitutionEmployment>;
  institutionEmploymentList: InstitutionEmploymentList;
  institutionEmploymentMany: Array<Maybe<InstitutionEmployment>>;
  institutionList: InstitutionList;
  institutionMany: Array<Maybe<Institution>>;
  institutionSelectionStatusEnum?: Maybe<InstitutionSelectionStatusEnum>;
  institutionSelectionStatusEnumList: InstitutionSelectionStatusEnumList;
  institutionSelectionStatusEnumMany: Array<Maybe<InstitutionSelectionStatusEnum>>;
  institutionTypeEnum?: Maybe<InstitutionTypeEnum>;
  institutionTypeEnumList: InstitutionTypeEnumList;
  institutionTypeEnumMany: Array<Maybe<InstitutionTypeEnum>>;
  institutionsInstitutionTypeEnum?: Maybe<InstitutionsInstitutionTypeEnum>;
  institutionsInstitutionTypeEnumList: InstitutionsInstitutionTypeEnumList;
  institutionsInstitutionTypeEnumMany: Array<Maybe<InstitutionsInstitutionTypeEnum>>;
  intraLink?: Maybe<IntraLink>;
  investment: Investment;
  investmentAccessRequest?: Maybe<InvestmentAccessRequest>;
  investmentAssignmentOption?: Maybe<InvestmentAssignmentOption>;
  investmentAssignmentOptionList: InvestmentAssignmentOptionList;
  investmentAssignmentOptionMany: Array<Maybe<InvestmentAssignmentOption>>;
  investmentAxysCode?: Maybe<InvestmentAxysCode>;
  investmentAxysCodeList: InvestmentAxysCodeList;
  investmentAxysCodeMany: Array<Maybe<InvestmentAxysCode>>;
  investmentBulk: Array<InvestmentBulk>;
  investmentCompletenessHead: Array<MemoizedInvestmentCompletenessSummary>;
  investmentFDPLogins?: Maybe<InvestmentFdpLogins>;
  investmentFDPLoginsList: InvestmentFdpLoginsList;
  investmentFDPLoginsMany: Array<Maybe<InvestmentFdpLogins>>;
  investmentFees: InvestmentFees;
  investmentFeesList: InvestmentFeesList;
  investmentFeesMany: Array<InvestmentFees>;
  investmentFields: InvestmentFields;
  investmentFirmEmployment?: Maybe<InvestmentFirmEmployment>;
  investmentFirmEmploymentList: InvestmentFirmEmploymentList;
  investmentFirmEmploymentMany: Array<Maybe<InvestmentFirmEmployment>>;
  investmentFirmEmploymentRoleEnum?: Maybe<InvestmentFirmEmploymentRoleEnum>;
  investmentFirmEmploymentRoleEnumList: InvestmentFirmEmploymentRoleEnumList;
  investmentFirmEmploymentRoleEnumMany: Array<Maybe<InvestmentFirmEmploymentRoleEnum>>;
  investmentFirmEmployments: Array<Maybe<InvestmentFirmEmployment>>;
  investmentInstitutions?: Maybe<InvestmentInstitutions>;
  investmentInstitutionsList: InvestmentInstitutionsList;
  investmentInstitutionsMany: Array<Maybe<InvestmentInstitutions>>;
  investmentList: InvestmentList;
  investmentListEnum?: Maybe<InvestmentListEnum>;
  investmentListEnumList: InvestmentListEnumList;
  investmentListEnumMany: Array<Maybe<InvestmentListEnum>>;
  investmentMany: Array<Maybe<Investment>>;
  investmentMatch: Array<InvestmentMatchResult>;
  investmentNoteUsersList?: Maybe<InvestmentNoteUsersList>;
  investmentPrivateQuartileGroupCategory?: Maybe<InvestmentPrivateQuartileGroupCategory>;
  investmentPrivateQuartileGroupCategoryList: InvestmentPrivateQuartileGroupCategoryList;
  investmentPrivateQuartileGroupCategoryMany: Array<Maybe<InvestmentPrivateQuartileGroupCategory>>;
  investmentProfileBuilder: ProfileBuilderResponse;
  investmentReportSync: Scalars['String']['output'];
  investmentRiskCategoryList: StringIdNameList;
  investmentRiskInvestmentList: InvestmentList;
  investmentSet?: Maybe<InvestmentSet>;
  investmentSetList: InvestmentSetList;
  investmentStructureEnum?: Maybe<InvestmentStructureEnum>;
  investmentStructureEnumList: InvestmentStructureEnumList;
  investmentStructureEnumMany: Array<Maybe<InvestmentStructureEnum>>;
  investmentSummary?: Maybe<NotesList>;
  investmentTags?: Maybe<InvestmentTags>;
  investmentTagsList: InvestmentTagsList;
  investmentTagsMany: Array<Maybe<InvestmentTags>>;
  investments: Array<Investment>;
  jobSchedules: Array<JobSchedule>;
  knowledgeBaseList: KnowledgeBaseList;
  knowledgeBaseTags?: Maybe<KnowledgeBaseTags>;
  knowledgeBaseTagsList: KnowledgeBaseTagsList;
  knowledgeBaseTagsMany: Array<Maybe<KnowledgeBaseTags>>;
  latestFirmAUM?: Maybe<DatedAsset>;
  latestFirmDEI?: Maybe<FirmDei>;
  latestInvestmentAUM?: Maybe<DatedAsset>;
  latestStrategyAUM?: Maybe<DatedAsset>;
  legalStructureEnum?: Maybe<LegalStructureEnum>;
  legalStructureEnumList: LegalStructureEnumList;
  legalStructureEnumMany: Array<Maybe<LegalStructureEnum>>;
  links?: Maybe<Links>;
  linksList: LinksList;
  linksMany: Array<Maybe<Links>>;
  liquidity?: Maybe<Liquidity>;
  liquidityList: LiquidityList;
  liquidityMany: Array<Maybe<Liquidity>>;
  llmEvaluators: Array<LlmEvaluator>;
  llmModelCatalog: Array<LlmModelCatalogEntry>;
  llmModels: Array<LlmModel>;
  llmTaskLangfuseEnabled: Scalars['Boolean']['output'];
  llmTasks: Array<LlmTask>;
  loadConversation: Array<ConversationHistory>;
  lockupEndValueEnum?: Maybe<LockupEndValueEnum>;
  lockupEndValueEnumList: LockupEndValueEnumList;
  lockupEndValueEnumMany: Array<Maybe<LockupEndValueEnum>>;
  lookupIdpByEmail: IdpInfo;
  managerQuarterlyReport: Scalars['String']['output'];
  managerTagsList: ManagerTagsList;
  measureEnum?: Maybe<MeasureEnum>;
  measureEnumList: MeasureEnumList;
  measureEnumMany: Array<Maybe<MeasureEnum>>;
  measureTypeEnum?: Maybe<MeasureTypeEnum>;
  measureTypeEnumList: MeasureTypeEnumList;
  measureTypeEnumMany: Array<Maybe<MeasureTypeEnum>>;
  mentionableUsers: UserList;
  multiCusumReport: Scalars['String']['output'];
  multiperiodRiskReport: Scalars['String']['output'];
  mutationPlan?: Maybe<MutationPlan>;
  mutationPlansByConversation: Array<MutationPlan>;
  /** How many of the current user's notifications are hidden by muted event types. */
  mutedNotificationCount: Scalars['Int']['output'];
  /** Get all skills active for the current user: system + personal + every org skill in their organization they have not deactivated */
  myActiveChatSkills: Array<ChatSkill>;
  myConversations: ConversationList;
  /** The current user's credit allotment, use and remainder for this calendar month (UTC). Charged to the assumed user when impersonating. */
  myCreditUsage: CreditUsage;
  myMutationPlans: Array<MutationPlan>;
  mySpawnableChatAgents: Array<ChatAgent>;
  navClassificationEnum?: Maybe<NavClassificationEnum>;
  navClassificationEnumList: NavClassificationEnumList;
  navClassificationEnumMany: Array<Maybe<NavClassificationEnum>>;
  /** Every NAV model allocation row for an RCG fund on a month-end transaction date. */
  navModelAllocations: Array<NavModelAllocation>;
  /** The RCG fund's NAV model inception: its earliest manager-row transaction date. */
  navModelInceptionDate?: Maybe<Scalars['Date']['output']>;
  /** A primary portfolio's NAV statement for one month: its RCG fund's managers grouped by strategy with subtotals, the accounting lines and their subtotal when includeCash, and the portfolio summary. Requires read access to the portfolio and to its RCG fund. */
  navStatement: Array<NavStatementRow>;
  noteCategoryEnum?: Maybe<NoteCategoryEnum>;
  noteCategoryEnumList?: Maybe<NoteCategoryEnumList>;
  noteMetaEnum?: Maybe<NoteMetaEnum>;
  noteMetaEnumList: NoteMetaEnumList;
  noteMetaEnumMany: Array<Maybe<NoteMetaEnum>>;
  noteTypeEnum?: Maybe<NoteTypeEnum>;
  notes?: Maybe<Notes>;
  notesList: NotesList;
  notesMany: Array<Maybe<Notes>>;
  notesMetaCounts: Array<NotesMetaCount>;
  notesReportFile: AsyncTaskStatus;
  noticeExtraction: NoticeExtraction;
  noticeExtractionByDocument?: Maybe<NoticeExtraction>;
  noticeExtractionsNeedingReview: NoticeExtractionList;
  noticeLegsByInvestment: NoticeLegsByInvestmentResult;
  noticeNotificationConfigs: Array<NoticeNotificationConfig>;
  noticeNotificationOverlaps: Array<Scalars['String']['output']>;
  /** A fresh download link for a notification's file. Null when the notification has no file or the file has expired from its bucket. */
  notificationArtifactUrl?: Maybe<Scalars['String']['output']>;
  /** Every event type the current user can receive, with their effective delivery settings. */
  notificationEventPreferences: Array<NotificationEventPreference>;
  notificationRecipients?: Maybe<NotificationRecipientsList>;
  /** The caller's own notifications, newest first. Optional filter narrows by event type, read state, arrival time or text — all applied in SQL, so a match outside the most recent page is still found. */
  notifications: Array<Notification>;
  operatingStatusEnum?: Maybe<OperatingStatusEnum>;
  operatingStatusEnumList: OperatingStatusEnumList;
  operatingStatusEnumMany: Array<Maybe<OperatingStatusEnum>>;
  orgLinks?: Maybe<OrgLinks>;
  orgLinksList: OrgLinksList;
  orgLinksMany: Array<Maybe<OrgLinks>>;
  organization?: Maybe<Organization>;
  organizationList: OrganizationList;
  organizationStructureEnum?: Maybe<OrganizationStructureEnum>;
  organizationStructureEnumList: OrganizationStructureEnumList;
  organizationStructureEnumMany: Array<Maybe<OrganizationStructureEnum>>;
  organizationTemplates: Array<Template>;
  peFundNumberEnum?: Maybe<PeFundNumberEnum>;
  peFundNumberEnumList: PeFundNumberEnumList;
  peFundNumberEnumMany: Array<Maybe<PeFundNumberEnum>>;
  peInctFeeCalcEnum?: Maybe<PeInctFeeCalcEnum>;
  peInctFeeCalcEnumList: PeInctFeeCalcEnumList;
  peInctFeeCalcEnumMany: Array<Maybe<PeInctFeeCalcEnum>>;
  peLiquidity: PeLiquidity;
  peLiquidityList: PeLiquidityList;
  peLiquidityMany: Array<PeLiquidity>;
  peMgmtFeeCalcEnum?: Maybe<PeMgmtFeeCalcEnum>;
  peMgmtFeeCalcEnumList: PeMgmtFeeCalcEnumList;
  peMgmtFeeCalcEnumMany: Array<Maybe<PeMgmtFeeCalcEnum>>;
  peStrategyEnum?: Maybe<PeStrategyEnum>;
  peStrategyEnumList: PeStrategyEnumList;
  peStrategyEnumMany: Array<Maybe<PeStrategyEnum>>;
  peersList: PeersList;
  peersListEnum?: Maybe<PeersListEnum>;
  peersStatSummary: Scalars['String']['output'];
  performanceAnalytics: PerformanceAnalytics;
  performanceMTDBulk: Array<PerformanceMtdBulkInvestment>;
  performanceReport: Scalars['String']['output'];
  performanceSourceEnum?: Maybe<PerformanceSourceEnum>;
  performanceSourceEnumList: PerformanceSourceEnumList;
  performanceSourceEnumMany: Array<Maybe<PerformanceSourceEnum>>;
  person?: Maybe<Person>;
  personEducation?: Maybe<PersonEducation>;
  personEducationList: PersonEducationList;
  personEducationMany: Array<Maybe<PersonEducation>>;
  personList: PersonList;
  personMany: Array<Maybe<Person>>;
  personProfileFromFilesBuilder: PersonProfileBuilderResponse;
  personProfileFromUrlBuilder: PersonProfileBuilderResponse;
  personWorkExperience?: Maybe<PersonWorkExperience>;
  personWorkExperienceList: PersonWorkExperienceList;
  personWorkExperienceMany: Array<Maybe<PersonWorkExperience>>;
  pieChart: Chart;
  pmeCashflows: PmeCashflowListResult;
  pmeLatestUpload?: Maybe<PmeUpload>;
  pmeMappingSuggestions: Array<PmeMappingSuggestionResult>;
  pmePositions: PmePositionListResult;
  pmeSummaryMetrics?: Maybe<PmeSummaryResult>;
  pmeUploadStatus?: Maybe<PmeUploadStatusResult>;
  porfolioConfigByPortfolioId?: Maybe<PortfolioConfig>;
  portalEmailDomainOrganizationList: EmailDomainOrganizationList;
  portalFirm?: Maybe<PortalFirm>;
  portalFirmList: PortalFirmList;
  portalFirmMany: Array<Maybe<PortalFirm>>;
  portalFirmTypeEnum?: Maybe<PortalFirmTypeEnum>;
  portalFirmTypeEnumList: PortalFirmTypeEnumList;
  portalFirmTypeEnumMany: Array<Maybe<PortalFirmTypeEnum>>;
  portalOrganization?: Maybe<PortalOrganization>;
  portalOrganizationList: PortalOrganizationList;
  portalOrganizationMany: Array<Maybe<PortalOrganization>>;
  portalServiceProviderFirm: PortalServiceProviderFirms;
  portalServiceProviderFirmsList: PortalServiceProviderFirmsList;
  portalSubmitted?: Maybe<PortalSubmitted>;
  portalSubmittedList: PortalSubmittedList;
  portalUser?: Maybe<PortalUser>;
  portalUserList: PortalUserList;
  portalUserMany: Array<Maybe<PortalUser>>;
  portfolio?: Maybe<Portfolio>;
  portfolioAfsLookthrough: PortfolioAfsLookthroughResult;
  portfolioConfig?: Maybe<PortfolioConfig>;
  portfolioConfigList: PortfolioConfigList;
  portfolioConfigMany: Array<Maybe<PortfolioConfig>>;
  portfolioFDPLogins?: Maybe<PortfolioFdpLogins>;
  portfolioFDPLoginsList: PortfolioFdpLoginsList;
  portfolioFDPLoginsMany: Array<Maybe<PortfolioFdpLogins>>;
  portfolioFactSheet: Scalars['String']['output'];
  portfolioGenomeReport: Scalars['String']['output'];
  portfolioList: PortfolioList;
  /** Sorted Desc, available position dates */
  positionReportDates: Array<Scalars['Date']['output']>;
  positionsReport: Scalars['String']['output'];
  presignedTempUrl?: Maybe<PresignedTempUrlResult>;
  previewLlmModel: LlmModelPreview;
  pricingFrequencyEnum?: Maybe<PricingFrequencyEnum>;
  pricingFrequencyEnumList: PricingFrequencyEnumList;
  pricingFrequencyEnumMany: Array<Maybe<PricingFrequencyEnum>>;
  privateQuartileGroupCategory?: Maybe<PrivateQuartileGroupCategory>;
  privateQuartileGroupCategoryList: PrivateQuartileGroupCategoryList;
  privateQuartileGroupCategoryMany: Array<Maybe<PrivateQuartileGroupCategory>>;
  proxyPositionsReport: Scalars['String']['output'];
  rangerDraftStatus: RangerDraftStatus;
  recentlyViewedInvestmentList: RecentlyViewedInvestmentList;
  report?: Maybe<Scalars['String']['output']>;
  /** Every scheduled report's recipients. */
  reportRecipients: Array<ReportRecipientRow>;
  resultEnum?: Maybe<ResultEnum>;
  resultEnumList: ResultEnumList;
  resultEnumMany: Array<Maybe<ResultEnum>>;
  rightOfExtensionEnum?: Maybe<RightOfExtensionEnum>;
  rightOfExtensionEnumList: RightOfExtensionEnumList;
  rightOfExtensionEnumMany: Array<Maybe<RightOfExtensionEnum>>;
  riskCategory?: Maybe<RiskCategory>;
  riskCategoryList?: Maybe<RiskCategoryList>;
  riskCategoryPartitions?: Maybe<Array<RiskCategoryPartition>>;
  /** Every risk measure recorded for one investment on one report date, as raw tier/category tuples. Zero and null measures are omitted. */
  riskMeasures: Array<RiskMeasureRecord>;
  riskRefreshList?: Maybe<RiskRefreshListList>;
  riskTiers: Array<RiskTierInfo>;
  riskVisualizationsData: ComputePortfolioBenchmarksResponse;
  savedEntitySearch?: Maybe<SavedEntitySearch>;
  savedEntitySearchList: SavedEntitySearchList;
  savedKnowledgeBase?: Maybe<SavedKnowledgeBase>;
  savedKnowledgeBaseList: SavedKnowledgeBaseList;
  schoolEnum?: Maybe<SchoolEnum>;
  schoolEnumList: SchoolEnumList;
  schoolEnumMany: Array<Maybe<SchoolEnum>>;
  securityMasterList: SecurityMasterList;
  securityMasterMeasurements?: Maybe<SecurityMasterMeasurements>;
  sendDocumentsNotifications: ClientDocumentNotificationStatus;
  serviceProviderDocumentType?: Maybe<ServiceProviderDocumentType>;
  serviceProviderDocumentTypeList: ServiceProviderDocumentTypeList;
  serviceProviderDocumentTypeMany: Array<Maybe<ServiceProviderDocumentType>>;
  serviceProviderDocuments?: Maybe<ServiceProviderDocuments>;
  serviceProviderDocumentsList: ServiceProviderDocumentsList;
  serviceProviderDocumentsMany: Array<Maybe<ServiceProviderDocuments>>;
  serviceProviderFirm?: Maybe<ServiceProviderFirm>;
  serviceProviderFirmList: ServiceProviderFirmList;
  serviceProviderFirmMany: Array<Maybe<ServiceProviderFirm>>;
  serviceProviderNotes?: Maybe<ServiceProviderNotes>;
  serviceProviderNotesList: ServiceProviderNotesList;
  serviceProviderNotesMany: Array<Maybe<ServiceProviderNotes>>;
  set?: Maybe<Set>;
  setList: SetList;
  setMany: Array<Maybe<Set>>;
  shareClass?: Maybe<ShareClass>;
  shareClassList: ShareClassList;
  shareClassMany: Array<Maybe<ShareClass>>;
  shareClassProfileBuilder: ShareClassProfileBuilderResponse;
  sharedGroupEntity?: Maybe<SharedGroupEntity>;
  sharedGroupEntityList: SharedGroupEntityList;
  sharedGroupEntityMany: Array<Maybe<SharedGroupEntity>>;
  siriusChat: SiriusChat;
  softLockup?: Maybe<SoftLockup>;
  softLockupList: SoftLockupList;
  softLockupMany: Array<Maybe<SoftLockup>>;
  solutionsCutoverReadiness: SolutionsCutoverReadiness;
  solutionsSyncStatus: Array<SyncEntityStatus>;
  stageEnum?: Maybe<StageEnum>;
  stageEnumList: StageEnumList;
  stageEnumMany: Array<Maybe<StageEnum>>;
  stateEnum?: Maybe<StateEnum>;
  stateEnumList: StateEnumList;
  stateEnumMany: Array<Maybe<StateEnum>>;
  statsGroup: StatsGroup;
  storedPromptFromFieldKey?: Maybe<StoredPrompts>;
  storedPrompts?: Maybe<StoredPrompts>;
  storedPromptsList: StoredPromptsList;
  storyboardGen: Scalars['String']['output'];
  strategyEnum?: Maybe<StrategyEnum>;
  strategyEnumList: StrategyEnumList;
  strategyEnumMany: Array<Maybe<StrategyEnum>>;
  strategyOptions: StrategyEnumList;
  stressTestReport: Scalars['String']['output'];
  subStrategyEnum?: Maybe<SubStrategyEnum>;
  subStrategyEnumList: SubStrategyEnumList;
  subStrategyEnumMany: Array<Maybe<SubStrategyEnum>>;
  summaryRiskReport: Scalars['String']['output'];
  /** Get a configuration value by key. Returns cached value with fallback to database and defaults. */
  systemConfigValue?: Maybe<Scalars['JSON']['output']>;
  systemConfiguration?: Maybe<SystemConfiguration>;
  systemConfigurationByKey?: Maybe<SystemConfiguration>;
  systemConfigurationList: SystemConfigurationList;
  systemConfigurationMany: Array<Maybe<SystemConfiguration>>;
  systemConfigurations: Array<SystemConfigEntry>;
  tableauToken: Scalars['String']['output'];
  tag?: Maybe<Tag>;
  tagClass?: Maybe<TagClass>;
  tagClassList: TagClassList;
  tagClassMany: Array<Maybe<TagClass>>;
  tagList: TagList;
  tagMany: Array<Maybe<Tag>>;
  teamMemberList: PersonList;
  templateAttachments: Array<TemplateAttachment>;
  titleEnum?: Maybe<TitleEnum>;
  titleEnumList: TitleEnumList;
  titleEnumMany: Array<Maybe<TitleEnum>>;
  typeAssetClassStrategyOptions?: Maybe<TypeAssetClassStrategyOptions>;
  typeAssetClassStrategyOptionsList: TypeAssetClassStrategyOptionsList;
  user?: Maybe<User>;
  userActivity?: Maybe<UserActivity>;
  userActivityList: UserActivityList;
  userList: UserList;
  userMutationAccessible: MutationAccess;
  userSettings?: Maybe<UserSettings>;
  users: Array<User>;
  usersXGroups?: Maybe<UsersXGroups>;
  usersXGroupsList: UsersXGroupsList;
  usersXGroupsMany: Array<Maybe<UsersXGroups>>;
  vehicleTypeEnum?: Maybe<VehicleTypeEnum>;
  vehicleTypeEnumList: VehicleTypeEnumList;
  vehicleTypeEnumMany: Array<Maybe<VehicleTypeEnum>>;
  vehicleTypeOptions: VehicleTypeEnumList;
  workoutEnum?: Maybe<WorkoutEnum>;
  workoutEnumList: WorkoutEnumList;
  workoutEnumMany: Array<Maybe<WorkoutEnum>>;
};


export type QueryAamOptimizationReportArgs = {
  config: AamOptimizationInput;
  exportAs?: Scalars['String']['input'];
  portfolioId: Scalars['Int']['input'];
};


export type QueryAccountTypeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAccountTypeEnumListArgs = {
  filter?: InputMaybe<AccountTypeEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<AccountTypeEnumSort>>;
};


export type QueryAccountTypeEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryAccountingManagerListArgs = {
  filter?: InputMaybe<AccountingManagerFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<AccountingManagerSort>>;
};


export type QueryAdEntriesXApplicationFlagsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAdEntriesXApplicationFlagsListArgs = {
  filter?: InputMaybe<AdEntriesXApplicationFlagsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<AdEntriesXApplicationFlagsSort>>;
};


export type QueryAdEntriesXApplicationFlagsManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryAdEntriesXApplicationsXSetsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAdEntriesXApplicationsXSetsListArgs = {
  filter?: InputMaybe<AdEntriesXApplicationsXSetsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<AdEntriesXApplicationsXSetsSort>>;
};


export type QueryAdEntriesXApplicationsXSetsManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryAddressArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAddressSearchArgs = {
  isCompany?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdvCompareArgs = {
  firmId: Scalars['Int']['input'];
  items?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryAdvReviewArgs = {
  firmId: Scalars['Int']['input'];
};


export type QueryAdvSummaryEmailNotificationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAdvisorTypeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAdvisorTypeEnumListArgs = {
  filter?: InputMaybe<AdvisorTypeEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<AdvisorTypeEnumSort>>;
};


export type QueryAdvisorTypeEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryAfsAccountingReviewArgs = {
  key: Scalars['String']['input'];
};


export type QueryAfsExtractionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAfsExtractionsByInvestmentArgs = {
  investmentId: Scalars['Int']['input'];
};


export type QueryAfsExtractionsByPortfolioArgs = {
  portfolioId: Scalars['Int']['input'];
};


export type QueryAfsHoldingsListArgs = {
  afsExtractionId: Scalars['Int']['input'];
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<AfsHoldingSortInput>>;
};


export type QueryAgencyArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAgencyListArgs = {
  filter?: InputMaybe<AgencyFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<AgencySort>>;
};


export type QueryAgencyManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryApplicationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryApplicationFlagArgs = {
  id: Scalars['Int']['input'];
};


export type QueryApplicationFlagListArgs = {
  filter?: InputMaybe<ApplicationFlagFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ApplicationFlagSort>>;
};


export type QueryApplicationFlagManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryApplicationListArgs = {
  filter?: InputMaybe<ApplicationFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ApplicationSort>>;
};


export type QueryApplicationManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryAssetClass2EnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAssetClass2EnumListArgs = {
  filter?: InputMaybe<AssetClass2EnumFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<AssetClass2EnumSort>>;
};


export type QueryAssetClass2EnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryAssetClassEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAssetClassEnumListArgs = {
  filter?: InputMaybe<AssetClassEnumFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<AssetClassEnumSort>>;
};


export type QueryAssetClassEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryAssetClassOptionsArgs = {
  filter?: InputMaybe<TypeAssetClassStrategyOptionsFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<TypeAssetClassStrategyOptionsSort>>;
};


export type QueryAsyncDocumentProcessArgs = {
  documentId: Scalars['Int']['input'];
  processName: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};


export type QueryAsyncTaskStatusArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAuditContactTypeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAuditContactTypeEnumListArgs = {
  filter?: InputMaybe<AuditContactTypeEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<AuditContactTypeEnumSort>>;
};


export type QueryAuditContactTypeEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryAvailableFieldsArgs = {
  entityLevel: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAvailableOrgChatSkillsArgs = {
  organizationId: Scalars['Int']['input'];
};


export type QueryAxysCodeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAxysCodeListArgs = {
  filter?: InputMaybe<AxysCodeFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<AxysCodeSort>>;
};


export type QueryAxysCodeManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryBalanceDatesArgs = {
  portfolioId: Scalars['Int']['input'];
};


export type QueryBalancesListArgs = {
  filter?: InputMaybe<BalancesFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<BalancesSort>>;
};


export type QueryBloombergDiligenceExtractStatusArgs = {
  datasetIds: Array<Scalars['String']['input']>;
};


export type QueryBulkPersonProfileFromFilesBuilderArgs = {
  bucket: Scalars['String']['input'];
  conversationId?: InputMaybe<Scalars['Int']['input']>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  keys: Array<Scalars['String']['input']>;
};


export type QueryBusinessObjectEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryBusinessObjectEnumListArgs = {
  filter?: InputMaybe<BusinessObjectEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<BusinessObjectEnumSort>>;
};


export type QueryBusinessObjectEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryCalendarUnitEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCalendarUnitEnumListArgs = {
  filter?: InputMaybe<CalendarUnitEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CalendarUnitEnumSort>>;
};


export type QueryCalendarUnitEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryCaseStudyReportArgs = {
  id: Scalars['String']['input'];
};


export type QueryChatArgs = {
  chatContext?: InputMaybe<ChatContext>;
  conversationId?: InputMaybe<Scalars['Int']['input']>;
  effort?: InputMaybe<ChatEffort>;
  excludedMcpCategories?: InputMaybe<Array<SiriusMcpCategory>>;
  model?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  tools?: InputMaybe<Array<ChatToolType>>;
};


export type QueryChatAgentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryChatAgentHistoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryChatAgentListArgs = {
  filter?: InputMaybe<ChatAgentFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ChatAgentSort>>;
};


export type QueryChatAgentManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryChatAgentsByScopeArgs = {
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  scope: ChatSkillScope;
};


export type QueryChatSkillArgs = {
  id: Scalars['Int']['input'];
};


export type QueryChatSkillGrantableGroupsArgs = {
  organizationId: Scalars['Int']['input'];
  q?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatSkillGroupAccessArgs = {
  chatSkillId: Scalars['Int']['input'];
};


export type QueryChatSkillHistoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryChatSkillListArgs = {
  filter?: InputMaybe<ChatSkillFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ChatSkillSort>>;
};


export type QueryChatSkillManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryChatSkillScheduleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryChatSkillScheduleListArgs = {
  filter?: InputMaybe<ChatSkillScheduleFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ChatSkillScheduleSort>>;
};


export type QueryChatSkillScheduleManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryChatSkillsByScopeArgs = {
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  scope: ChatSkillScope;
};


export type QueryClientArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClientAllocationsArgs = {
  month?: InputMaybe<Scalars['Date']['input']>;
  rcgFundIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  shareClassId?: InputMaybe<Scalars['Int']['input']>;
  withFlowsOnly?: Scalars['Boolean']['input'];
};


export type QueryClientCapitalFlowsArgs = {
  clientId: Scalars['Int']['input'];
  rcgFundId: Scalars['Int']['input'];
};


export type QueryClientInvestmentClientsArgs = {
  rcgFundId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryClientListArgs = {
  filter?: InputMaybe<ClientFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ClientSort>>;
};


export type QueryClientManyArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryClientShareClassesArgs = {
  clientId?: InputMaybe<Scalars['Int']['input']>;
  rcgFundId: Scalars['Int']['input'];
};


export type QueryClientSwitchesArgs = {
  clientId: Scalars['Int']['input'];
  rcgFundId: Scalars['Int']['input'];
};


export type QueryCloseDateFundSizeArgs = {
  investmentId: Scalars['Int']['input'];
};


export type QueryClusterReportArgs = {
  benchmarks?: InputMaybe<Array<BenchmarkWeightInput>>;
  calculationDate: Scalars['Date']['input'];
  currency?: Scalars['String']['input'];
  customBenchmarkName?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['Date']['input'];
  excludeCash?: Scalars['Boolean']['input'];
  exportAs?: Scalars['String']['input'];
  hideNames?: Scalars['Boolean']['input'];
  portfolioId: Scalars['Int']['input'];
  quarterly?: Scalars['Boolean']['input'];
  strategies: Array<Scalars['String']['input']>;
  tag: Scalars['String']['input'];
  timePeriod: Scalars['Int']['input'];
};


export type QueryCogencyLinkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCompanyArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCompanyEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCompanyEnumListArgs = {
  filter?: InputMaybe<CompanyEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CompanyEnumSort>>;
};


export type QueryCompanyEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryCompanyFieldsArgs = {
  companyId: Scalars['Int']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompanyListArgs = {
  filter?: InputMaybe<CompanyFilter>;
  page?: InputMaybe<PageInput>;
  searchFilters?: InputMaybe<Array<CompanySearchFilters>>;
  sort?: InputMaybe<Array<CompanySort>>;
};


export type QueryCompanyManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryCompanyTypeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCompanyTypeEnumListArgs = {
  filter?: InputMaybe<CompanyTypeEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CompanyTypeEnumSort>>;
};


export type QueryCompanyTypeEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryCompanyValuationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCompanyValuationListArgs = {
  filter?: InputMaybe<CompanyValuationFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CompanyValuationSort>>;
};


export type QueryCompanyValuationManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryCompoundingPeriodEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCompoundingPeriodEnumListArgs = {
  filter?: InputMaybe<CompoundingPeriodEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CompoundingPeriodEnumSort>>;
};


export type QueryCompoundingPeriodEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryContactTypeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryContactTypeEnumListArgs = {
  filter?: InputMaybe<ContactTypeEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ContactTypeEnumSort>>;
};


export type QueryContactTypeEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryConversationArtifactsArgs = {
  conversationId: Scalars['Int']['input'];
};


export type QueryCountryEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCountryEnumListArgs = {
  filter?: InputMaybe<CountryEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CountryEnumSort>>;
};


export type QueryCountryEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryCreditUsageByUserArgs = {
  organizationId: Scalars['Int']['input'];
};


export type QueryCurrencyDenominationEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCurrencyDenominationEnumListArgs = {
  filter?: InputMaybe<CurrencyDenominationEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CurrencyDenominationEnumSort>>;
};


export type QueryCurrencyDenominationEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryCustomAnalyticsArgs = {
  id: Scalars['String']['input'];
};


export type QueryCustomAnalyticsListArgs = {
  filter?: InputMaybe<CustomAnalyticsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CustomAnalyticsSort>>;
};


export type QueryCustomIndexGroupArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCustomIndexInvestmentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCustomIndexInvestmentListArgs = {
  filter?: InputMaybe<CustomIndexInvestmentFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CustomIndexInvestmentSort>>;
};


export type QueryCustomIndexInvestmentManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryCustomIndexPreviewArgs = {
  input: CustomIndexInvestmentInput;
};


export type QueryCusumReportArgs = {
  benchmarkId: Scalars['Int']['input'];
  currency?: Scalars['String']['input'];
  endDate: Scalars['Date']['input'];
  exportAs?: Scalars['String']['input'];
  investmentId: Scalars['Int']['input'];
  sendEmail?: Scalars['Boolean']['input'];
  startDate: Scalars['Date']['input'];
};


export type QueryDealArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDealAvailableFilterOptionsArgs = {
  filter?: InputMaybe<DealFilter>;
};


export type QueryDealListArgs = {
  filter?: InputMaybe<DealFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DealSort>>;
};


export type QueryDealManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryDealMarketingEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDealMarketingEnumListArgs = {
  filter?: InputMaybe<DealMarketingEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DealMarketingEnumSort>>;
};


export type QueryDealMarketingEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryDealStructureEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDealStructureEnumListArgs = {
  filter?: InputMaybe<DealStructureEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DealStructureEnumSort>>;
};


export type QueryDealStructureEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryDealTagsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDegreeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDegreeEnumListArgs = {
  filter?: InputMaybe<DegreeEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DegreeEnumSort>>;
};


export type QueryDegreeEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryDeiCategory1EnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDeiCategory1EnumListArgs = {
  filter?: InputMaybe<DeiCategory1EnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DeiCategory1EnumSort>>;
};


export type QueryDeiCategory1EnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryDeiCategory2EnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDeiCategory2EnumListArgs = {
  filter?: InputMaybe<DeiCategory2EnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DeiCategory2EnumSort>>;
};


export type QueryDeiCategory2EnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryDifferenceRiskReportArgs = {
  alloc1: AllocationInput;
  alloc2: AllocationInput;
  currency?: Scalars['String']['input'];
  exportAs?: Scalars['String']['input'];
  portfolioId: Scalars['Int']['input'];
};


export type QueryDiversityStatsEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDiversityStatsEnumListArgs = {
  filter?: InputMaybe<DiversityStatsEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DiversityStatsEnumSort>>;
};


export type QueryDiversityStatsEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryDocumentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDocumentAccessLevelArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDocumentAccessLevelListArgs = {
  filter?: InputMaybe<DocumentAccessLevelFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DocumentAccessLevelSort>>;
};


export type QueryDocumentAccessLevelManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryDocumentCountByDocumentTypeArgs = {
  filter?: InputMaybe<DocumentFilter>;
  includeYear?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DocumentCountByDocumentTypeSort>>;
};


export type QueryDocumentDownloadBatchArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryDocumentManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryDocumentQueueArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentQueueListArgs = {
  filter?: InputMaybe<DocumentQueueFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DocumentQueueSort>>;
};


export type QueryDocumentQueueManyArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryDocumentTypeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDocumentTypeEnumListArgs = {
  filter?: InputMaybe<DocumentTypeEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DocumentTypeEnumSort>>;
};


export type QueryDocumentTypeEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryDocumentTypeSuggestionArgs = {
  text: Scalars['String']['input'];
};


export type QueryDocumentsArgs = {
  filter?: InputMaybe<DocumentFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DocumentSort>>;
};


export type QueryDryRunMutationStepArgs = {
  input: Scalars['JSON']['input'];
  mutationName: Scalars['String']['input'];
};


export type QueryEarlyEstimatesArgs = {
  month: Scalars['Date']['input'];
};


export type QueryEmRiskReportArgs = {
  benchmarks: Array<BenchmarkWeightInput>;
  calculationDate: Scalars['Date']['input'];
  currency?: Scalars['String']['input'];
  customBenchmarkName?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['Date']['input'];
  excludeCash?: Scalars['Boolean']['input'];
  exportAs: Scalars['String']['input'];
  hideNames?: Scalars['Boolean']['input'];
  performanceBenchmarkId?: InputMaybe<Scalars['Int']['input']>;
  performanceBenchmarkName?: InputMaybe<Scalars['String']['input']>;
  portfolioId: Scalars['Int']['input'];
  quarterly?: Scalars['Boolean']['input'];
  strategies: Array<Scalars['String']['input']>;
  tag: Scalars['String']['input'];
  timePeriod: Scalars['Int']['input'];
};


export type QueryEmailDomainXOrganizationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryEmailDomainXOrganizationListArgs = {
  filter?: InputMaybe<EmailDomainXOrganizationFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<EmailDomainXOrganizationSort>>;
};


export type QueryEmailDomainXOrganizationManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryEmployeeRoleEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryEmployeeRoleEnumListArgs = {
  filter?: InputMaybe<EmployeeRoleEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<EmployeeRoleEnumSort>>;
};


export type QueryEmployeeRoleEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryExceptionReportArgs = {
  calculationTimePeriod?: Scalars['Int']['input'];
  currency?: Scalars['String']['input'];
  endDate: Scalars['Date']['input'];
  exportAs?: Scalars['String']['input'];
  portfolioId: Scalars['Int']['input'];
  quarterly?: Scalars['Boolean']['input'];
  timePeriod?: Scalars['Int']['input'];
};


export type QueryExposureArgs = {
  categoryId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  investmentId: Scalars['Int']['input'];
  positionType: PositionType;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryExposureReportArgs = {
  benchmarks: Array<BenchmarkWeightInput>;
  calculationDate: Scalars['Date']['input'];
  currency?: Scalars['String']['input'];
  customBenchmarkName?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['Date']['input'];
  exportAs?: Scalars['String']['input'];
  exposureTypes?: Array<Scalars['String']['input']>;
  includeRiskReport?: Scalars['Boolean']['input'];
  portfolioId: Scalars['Int']['input'];
  strategies: Array<Scalars['String']['input']>;
  tag: Scalars['String']['input'];
};


export type QueryFamilyArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFamilyListArgs = {
  filter?: InputMaybe<FamilyFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FamilySort>>;
};


export type QueryFamilyManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryFdpLoginArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFdpLoginAuthenticatorEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFdpLoginAuthenticatorEnumListArgs = {
  filter?: InputMaybe<FdpLoginAuthenticatorEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FdpLoginAuthenticatorEnumSort>>;
};


export type QueryFdpLoginAuthenticatorEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryFdpLoginListArgs = {
  filter?: InputMaybe<FdpLoginFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FdpLoginSort>>;
};


export type QueryFdpLoginManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryFdpWebsitesArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFdpWebsitesListArgs = {
  filter?: InputMaybe<FdpWebsitesFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FdpWebsitesSort>>;
};


export type QueryFdpWebsitesManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryFeeCalcEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFeeCalcEnumListArgs = {
  filter?: InputMaybe<FeeCalcEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FeeCalcEnumSort>>;
};


export type QueryFeeCalcEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryFeeFreqEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFeeFreqEnumListArgs = {
  filter?: InputMaybe<FeeFreqEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FeeFreqEnumSort>>;
};


export type QueryFeeFreqEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryFieldKeysByQuestionArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  maxDistance?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  ownerType?: InputMaybe<Scalars['String']['input']>;
  q: Scalars['String']['input'];
};


export type QueryFieldListArgs = {
  filter?: InputMaybe<FieldFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FieldSort>>;
};


export type QueryFieldListDownloadArgs = {
  filter?: InputMaybe<FieldFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FieldSort>>;
};


export type QueryFinancialDataProviderArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFinancialDataProviderListArgs = {
  filter?: InputMaybe<FinancialDataProviderFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FinancialDataProviderSort>>;
};


export type QueryFinancialDataProviderManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryFinancialPeriodEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFinancialPeriodEnumListArgs = {
  filter?: InputMaybe<FinancialPeriodEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FinancialPeriodEnumSort>>;
};


export type QueryFinancialPeriodEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryFindSavedKnowledgeBaseByFiltersArgs = {
  filters: KnowledgeBaseFilter;
};


export type QueryFirmArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFirmDeiArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFirmDeiListArgs = {
  filter?: InputMaybe<FirmDeiFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmDeiSort>>;
};


export type QueryFirmDeiManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryFirmEmploymentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFirmEmploymentListArgs = {
  filter?: InputMaybe<FirmEmploymentFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmEmploymentSort>>;
};


export type QueryFirmEmploymentManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryFirmEmploymentsArgs = {
  filters?: InputMaybe<FirmEmploymentFilters>;
};


export type QueryFirmEngagementArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFirmEngagementListArgs = {
  filter?: InputMaybe<FirmEngagementFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmEngagementSort>>;
};


export type QueryFirmEngagementManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryFirmEngagementTypeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFirmEngagementTypeEnumListArgs = {
  filter?: InputMaybe<FirmEngagementTypeEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmEngagementTypeEnumSort>>;
};


export type QueryFirmFdpLoginsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFirmFdpLoginsListArgs = {
  filter?: InputMaybe<FirmFdpLoginsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmFdpLoginsSort>>;
};


export type QueryFirmFdpLoginsManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryFirmFieldsArgs = {
  firmId: Scalars['Int']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFirmInstitutionsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFirmInstitutionsListArgs = {
  filter?: InputMaybe<FirmInstitutionsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmInstitutionsSort>>;
};


export type QueryFirmInstitutionsManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryFirmListArgs = {
  filter?: InputMaybe<FirmFilterInput>;
  firmSearchFilters?: InputMaybe<Array<FirmSearchFilters>>;
  investmentSearchFilters?: InputMaybe<Array<InvestmentSearchFilters>>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmSort>>;
};


export type QueryFirmManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryFirmProfileFromUrlBuilderArgs = {
  firmId?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFirmTagsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFirmTeamStructureArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFundingTypeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFundingTypeEnumListArgs = {
  filter?: InputMaybe<FundingTypeEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FundingTypeEnumSort>>;
};


export type QueryFundingTypeEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryFundsXProxiesArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFundsXProxiesListArgs = {
  filter?: InputMaybe<FundsXProxiesFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FundsXProxiesSort>>;
};


export type QueryFxRateArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGenerateNoteEmbeddingArgs = {
  noteId: Scalars['Int']['input'];
};


export type QueryGeographicFocusEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGeographicFocusEnumListArgs = {
  filter?: InputMaybe<GeographicFocusEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<GeographicFocusEnumSort>>;
};


export type QueryGeographicFocusEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryGeographyEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGeographyEnumListArgs = {
  filter?: InputMaybe<GeographyEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<GeographyEnumSort>>;
};


export type QueryGeographyEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryGetDocumentQueueUploadUrlArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetOrganizationIconUploadUrlArgs = {
  contentType: Scalars['String']['input'];
  organizationId: Scalars['Int']['input'];
};


export type QueryGetRangerDueDiligenceDraftsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGlobalProviderInstitutionsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGlobalProviderInstitutionsListArgs = {
  filter?: InputMaybe<GlobalProviderInstitutionsFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<GlobalProviderInstitutionsSort>>;
};


export type QueryGlobalProviderNoteTypeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGlobalProviderNoteTypeEnumListArgs = {
  filter?: InputMaybe<GlobalProviderNoteTypeEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<GlobalProviderNoteTypeEnumSort>>;
};


export type QueryGlobalProviderNoteTypeEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryGroupShareDefinitionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGroupShareDefinitionListArgs = {
  filter?: InputMaybe<GroupShareDefinitionFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<GroupShareDefinitionSort>>;
};


export type QueryGroupShareDefinitionManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryGuidelineBreachesArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryGuidelineNotesArgs = {
  investmentId: Scalars['Int']['input'];
};


export type QueryGuidelineSetArgs = {
  id: Scalars['Int']['input'];
  investmentId: Scalars['Int']['input'];
};


export type QueryGuidelineSetsArgs = {
  investmentId: Scalars['Int']['input'];
};


export type QueryHeatmapReportArgs = {
  benchmarks: Array<BenchmarkWeightInput>;
  calculationDate: Scalars['Date']['input'];
  currency?: Scalars['String']['input'];
  customBenchmarkName?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['Date']['input'];
  excludeCash?: Scalars['Boolean']['input'];
  hideNames?: Scalars['Boolean']['input'];
  portfolioId: Scalars['Int']['input'];
  quarterly?: Scalars['Boolean']['input'];
  strategies: Array<Scalars['String']['input']>;
  tag: Scalars['String']['input'];
  timePeriod: Scalars['Int']['input'];
};


export type QueryHighChartArgs = {
  chartOptions?: InputMaybe<Scalars['JSON']['input']>;
  chartType: ChartType;
};


export type QueryIconEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryIconEnumListArgs = {
  filter?: InputMaybe<IconEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<IconEnumSort>>;
};


export type QueryIconEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryImpactCategoryEnumListArgs = {
  filter?: InputMaybe<ImpactCategoryEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ImpactCategoryEnumSort>>;
};


export type QueryImpactEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryImportRiskMeasuresStatusArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIndexCalcTypeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryIndexCalcTypeEnumListArgs = {
  filter?: InputMaybe<IndexCalcTypeEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<IndexCalcTypeEnumSort>>;
};


export type QueryIndexCalcTypeEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInstitutionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInstitutionEmploymentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInstitutionEmploymentListArgs = {
  filter?: InputMaybe<InstitutionEmploymentFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InstitutionEmploymentSort>>;
};


export type QueryInstitutionEmploymentManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInstitutionListArgs = {
  filter?: InputMaybe<InstitutionFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InstitutionSort>>;
};


export type QueryInstitutionManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInstitutionSelectionStatusEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInstitutionSelectionStatusEnumListArgs = {
  filter?: InputMaybe<InstitutionSelectionStatusEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InstitutionSelectionStatusEnumSort>>;
};


export type QueryInstitutionSelectionStatusEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInstitutionTypeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInstitutionTypeEnumListArgs = {
  filter?: InputMaybe<InstitutionTypeEnumFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InstitutionTypeEnumSort>>;
};


export type QueryInstitutionTypeEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInstitutionsInstitutionTypeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInstitutionsInstitutionTypeEnumListArgs = {
  filter?: InputMaybe<InstitutionsInstitutionTypeEnumFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InstitutionsInstitutionTypeEnumSort>>;
};


export type QueryInstitutionsInstitutionTypeEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryIntraLinkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvestmentArgs = {
  atlasInvestmentId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInvestmentAccessRequestArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvestmentAssignmentOptionArgs = {
  id: Scalars['String']['input'];
};


export type QueryInvestmentAssignmentOptionListArgs = {
  filter?: InputMaybe<InvestmentAssignmentOptionFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentAssignmentOptionSort>>;
};


export type QueryInvestmentAssignmentOptionManyArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryInvestmentAxysCodeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvestmentAxysCodeListArgs = {
  filter?: InputMaybe<InvestmentAxysCodeFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentAxysCodeSort>>;
};


export type QueryInvestmentAxysCodeManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInvestmentBulkArgs = {
  filter?: InputMaybe<InvestmentFilterInput>;
  firmSearchFilters?: InputMaybe<Array<FirmSearchFilters>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchFilters?: InputMaybe<Array<InvestmentSearchFilters>>;
  sort?: InputMaybe<Array<InvestmentSort>>;
};


export type QueryInvestmentFdpLoginsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvestmentFdpLoginsListArgs = {
  filter?: InputMaybe<InvestmentFdpLoginsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentFdpLoginsSort>>;
};


export type QueryInvestmentFdpLoginsManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInvestmentFeesArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvestmentFeesListArgs = {
  filter?: InputMaybe<InvestmentFeesFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentFeesSort>>;
};


export type QueryInvestmentFeesManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInvestmentFieldsArgs = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  investmentId: Scalars['Int']['input'];
  periodType?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInvestmentFirmEmploymentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvestmentFirmEmploymentListArgs = {
  filter?: InputMaybe<InvestmentFirmEmploymentFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentFirmEmploymentSort>>;
};


export type QueryInvestmentFirmEmploymentManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInvestmentFirmEmploymentRoleEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvestmentFirmEmploymentRoleEnumListArgs = {
  filter?: InputMaybe<InvestmentFirmEmploymentRoleEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentFirmEmploymentRoleEnumSort>>;
};


export type QueryInvestmentFirmEmploymentRoleEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInvestmentFirmEmploymentsArgs = {
  filters?: InputMaybe<InvestmentFirmEmploymentFilters>;
};


export type QueryInvestmentInstitutionsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvestmentInstitutionsListArgs = {
  filter?: InputMaybe<InvestmentInstitutionsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentInstitutionsSort>>;
};


export type QueryInvestmentInstitutionsManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInvestmentListArgs = {
  filter?: InputMaybe<InvestmentFilterInput>;
  firmSearchFilters?: InputMaybe<Array<FirmSearchFilters>>;
  page?: InputMaybe<PageInput>;
  searchFilters?: InputMaybe<Array<InvestmentSearchFilters>>;
  sort?: InputMaybe<Array<InvestmentSort>>;
};


export type QueryInvestmentListEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvestmentListEnumListArgs = {
  filter?: InputMaybe<InvestmentListEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentListEnumSort>>;
};


export type QueryInvestmentListEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInvestmentManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInvestmentMatchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  term: Scalars['String']['input'];
};


export type QueryInvestmentNoteUsersListArgs = {
  filter?: InputMaybe<InvestmentNoteUsersFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentNoteUsersSort>>;
};


export type QueryInvestmentPrivateQuartileGroupCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvestmentPrivateQuartileGroupCategoryListArgs = {
  filter?: InputMaybe<InvestmentPrivateQuartileGroupCategoryFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentPrivateQuartileGroupCategorySort>>;
};


export type QueryInvestmentPrivateQuartileGroupCategoryManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInvestmentProfileBuilderArgs = {
  Keys: Array<Scalars['String']['input']>;
  bucket: Scalars['String']['input'];
  conversationId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInvestmentReportSyncArgs = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  elements?: InputMaybe<Array<ReportStructure>>;
  format: FormatOptions;
  includeHoldings?: InputMaybe<Scalars['Boolean']['input']>;
  includeImpactAreas?: InputMaybe<Scalars['Boolean']['input']>;
  includeReportFund?: InputMaybe<Scalars['Boolean']['input']>;
  investmentId: Scalars['Int']['input'];
  reportType: ReportTypeOptions;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  subSections?: InputMaybe<Array<SubSections>>;
};


export type QueryInvestmentRiskCategoryListArgs = {
  filter?: InputMaybe<InvestmentRiskCategoryFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentRiskCategorySort>>;
};


export type QueryInvestmentRiskInvestmentListArgs = {
  filter?: InputMaybe<InvestmentRiskInvestmentFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentRiskInvestmentSort>>;
};


export type QueryInvestmentSetArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvestmentSetListArgs = {
  filter?: InputMaybe<InvestmentSetFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentSetSort>>;
};


export type QueryInvestmentStructureEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvestmentStructureEnumListArgs = {
  filter?: InputMaybe<InvestmentStructureEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentStructureEnumSort>>;
};


export type QueryInvestmentStructureEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInvestmentSummaryArgs = {
  investmentId: Array<Scalars['Int']['input']>;
};


export type QueryInvestmentTagsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvestmentTagsListArgs = {
  filter?: InputMaybe<InvestmentTagsFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentTagsSort>>;
};


export type QueryInvestmentTagsManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryKnowledgeBaseListArgs = {
  filter?: InputMaybe<KnowledgeBaseFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<KnowledgeBaseSort>>;
};


export type QueryKnowledgeBaseTagsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryKnowledgeBaseTagsListArgs = {
  filter?: InputMaybe<KnowledgeBaseTagsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<KnowledgeBaseTagsSort>>;
};


export type QueryKnowledgeBaseTagsManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryLatestFirmAumArgs = {
  firmId: Scalars['Int']['input'];
};


export type QueryLatestFirmDeiArgs = {
  entityId: Scalars['Int']['input'];
  geographyEnumId?: InputMaybe<Scalars['Int']['input']>;
  isCompany: Scalars['Boolean']['input'];
};


export type QueryLatestInvestmentAumArgs = {
  investmentId: Scalars['Int']['input'];
};


export type QueryLatestStrategyAumArgs = {
  investmentId: Scalars['Int']['input'];
};


export type QueryLegalStructureEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLegalStructureEnumListArgs = {
  filter?: InputMaybe<LegalStructureEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<LegalStructureEnumSort>>;
};


export type QueryLegalStructureEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryLinksArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLinksListArgs = {
  filter?: InputMaybe<LinksFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<LinksSort>>;
};


export type QueryLinksManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryLiquidityArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLiquidityListArgs = {
  filter?: InputMaybe<LiquidityFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<LiquiditySort>>;
};


export type QueryLiquidityManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryLoadConversationArgs = {
  conversationId: Scalars['Int']['input'];
};


export type QueryLockupEndValueEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLockupEndValueEnumListArgs = {
  filter?: InputMaybe<LockupEndValueEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<LockupEndValueEnumSort>>;
};


export type QueryLockupEndValueEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryLookupIdpByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryManagerQuarterlyReportArgs = {
  asOfDate: Scalars['Date']['input'];
  calculationBenchmarkId?: InputMaybe<Scalars['Int']['input']>;
  comparableBetaBenchmarkId?: InputMaybe<Scalars['Int']['input']>;
  currency?: Scalars['String']['input'];
  exportAs?: Scalars['String']['input'];
  investmentId: Scalars['Int']['input'];
  performanceBenchmarkId?: InputMaybe<Scalars['Int']['input']>;
  sections?: InputMaybe<Array<Scalars['String']['input']>>;
  sendEmail?: Scalars['Boolean']['input'];
};


export type QueryManagerTagsListArgs = {
  filter?: InputMaybe<ManagerTagsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ManagerTagsSort>>;
};


export type QueryMeasureEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMeasureEnumListArgs = {
  filter?: InputMaybe<MeasureEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<MeasureEnumSort>>;
};


export type QueryMeasureEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryMeasureTypeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMeasureTypeEnumListArgs = {
  filter?: InputMaybe<MeasureTypeEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<MeasureTypeEnumSort>>;
};


export type QueryMeasureTypeEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryMentionableUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMultiCusumReportArgs = {
  allocationDate: Scalars['Date']['input'];
  analysisDate: Scalars['Date']['input'];
  benchmarks: Array<BenchmarkWeightInput>;
  currency?: Scalars['String']['input'];
  customBenchmarkName?: InputMaybe<Scalars['String']['input']>;
  exportAs?: Scalars['String']['input'];
  periods?: Scalars['Int']['input'];
  portfolioId: Scalars['Int']['input'];
  strategies: Array<Scalars['String']['input']>;
  tag: Scalars['String']['input'];
};


export type QueryMultiperiodRiskReportArgs = {
  allocations: Array<AllocationInput>;
  currency?: Scalars['String']['input'];
  exportAs?: Scalars['String']['input'];
  includeManagers?: Scalars['Boolean']['input'];
  portfolioId: Scalars['Int']['input'];
};


export type QueryMutationPlanArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMutationPlansByConversationArgs = {
  conversationId: Scalars['Int']['input'];
};


export type QueryMyConversationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sources?: InputMaybe<Array<ConversationSource>>;
};


export type QueryNavClassificationEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryNavClassificationEnumListArgs = {
  filter?: InputMaybe<NavClassificationEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<NavClassificationEnumSort>>;
};


export type QueryNavClassificationEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryNavModelAllocationsArgs = {
  investmentId: Scalars['Int']['input'];
  tranDate: Scalars['Date']['input'];
};


export type QueryNavModelInceptionDateArgs = {
  investmentId: Scalars['Int']['input'];
};


export type QueryNavStatementArgs = {
  date: Scalars['Date']['input'];
  includeCash?: Scalars['Boolean']['input'];
  portfolioId: Scalars['Int']['input'];
};


export type QueryNoteCategoryEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryNoteCategoryEnumListArgs = {
  filter?: InputMaybe<NoteCategoryEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<NoteCategoryEnumSort>>;
};


export type QueryNoteMetaEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryNoteMetaEnumListArgs = {
  filter?: InputMaybe<NoteMetaEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<NoteMetaEnumSort>>;
};


export type QueryNoteMetaEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryNoteTypeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryNotesArgs = {
  id: Scalars['Int']['input'];
};


export type QueryNotesListArgs = {
  filter?: InputMaybe<NotesFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<NotesSort>>;
};


export type QueryNotesManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryNotesMetaCountsArgs = {
  filter?: InputMaybe<NotesFilter>;
};


export type QueryNotesReportFileArgs = {
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  notesFilter?: InputMaybe<NotesFilter>;
  requestId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};


export type QueryNoticeExtractionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryNoticeExtractionByDocumentArgs = {
  documentId: Scalars['Int']['input'];
};


export type QueryNoticeExtractionsNeedingReviewArgs = {
  page?: InputMaybe<PageInput>;
};


export type QueryNoticeLegsByInvestmentArgs = {
  category?: InputMaybe<NoticeLegCategory>;
  clientInvestmentId?: InputMaybe<Scalars['Int']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  investmentId: Scalars['Int']['input'];
  page?: InputMaybe<PageInput>;
};


export type QueryNoticeNotificationOverlapsArgs = {
  clientInvestmentId?: InputMaybe<Scalars['Int']['input']>;
  noticeType?: InputMaybe<NoticeType>;
};


export type QueryNotificationArtifactUrlArgs = {
  id: Scalars['Int']['input'];
};


export type QueryNotificationRecipientsArgs = {
  entityAssignments?: InputMaybe<Array<NoteEntityAssignmentInput>>;
};


export type QueryNotificationsArgs = {
  filter?: InputMaybe<NotificationFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOperatingStatusEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOperatingStatusEnumListArgs = {
  filter?: InputMaybe<OperatingStatusEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<OperatingStatusEnumSort>>;
};


export type QueryOperatingStatusEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryOrgLinksArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOrgLinksListArgs = {
  filter?: InputMaybe<OrgLinksFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<OrgLinksSort>>;
};


export type QueryOrgLinksManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryOrganizationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOrganizationListArgs = {
  filter?: InputMaybe<OrganizationFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<OrganizationSort>>;
};


export type QueryOrganizationStructureEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOrganizationStructureEnumListArgs = {
  filter?: InputMaybe<OrganizationStructureEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<OrganizationStructureEnumSort>>;
};


export type QueryOrganizationStructureEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryOrganizationTemplatesArgs = {
  fieldSetGroup?: InputMaybe<Scalars['String']['input']>;
  fieldSetType?: InputMaybe<FieldSetType>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPeFundNumberEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPeFundNumberEnumListArgs = {
  filter?: InputMaybe<PeFundNumberEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PeFundNumberEnumSort>>;
};


export type QueryPeFundNumberEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryPeInctFeeCalcEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPeInctFeeCalcEnumListArgs = {
  filter?: InputMaybe<PeInctFeeCalcEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PeInctFeeCalcEnumSort>>;
};


export type QueryPeInctFeeCalcEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryPeLiquidityArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPeLiquidityListArgs = {
  filter?: InputMaybe<PeLiquidityFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PeLiquiditySort>>;
};


export type QueryPeLiquidityManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryPeMgmtFeeCalcEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPeMgmtFeeCalcEnumListArgs = {
  filter?: InputMaybe<PeMgmtFeeCalcEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PeMgmtFeeCalcEnumSort>>;
};


export type QueryPeMgmtFeeCalcEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryPeStrategyEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPeStrategyEnumListArgs = {
  filter?: InputMaybe<PeStrategyEnumFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PeStrategyEnumSort>>;
};


export type QueryPeStrategyEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryPeersListArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPeersListEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPeersStatSummaryArgs = {
  peersData: Array<PeersSummaryDetail>;
};


export type QueryPerformanceAnalyticsArgs = {
  investmentId: Scalars['Int']['input'];
};


export type QueryPerformanceMtdBulkArgs = {
  filter: PerformanceMtdBulkFilter;
  sort?: InputMaybe<Array<PerformanceMtdBulkSort>>;
};


export type QueryPerformanceReportArgs = {
  currency?: Scalars['String']['input'];
  date: Scalars['Date']['input'];
  exportAs?: Scalars['String']['input'];
  portfolioId: Scalars['Int']['input'];
  strategies?: InputMaybe<Array<Scalars['String']['input']>>;
  tag?: Scalars['String']['input'];
  timePeriod?: Scalars['Int']['input'];
};


export type QueryPerformanceSourceEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPerformanceSourceEnumListArgs = {
  filter?: InputMaybe<PerformanceSourceEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PerformanceSourceEnumSort>>;
};


export type QueryPerformanceSourceEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryPersonArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPersonEducationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPersonEducationListArgs = {
  filter?: InputMaybe<PersonEducationFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PersonEducationSort>>;
};


export type QueryPersonEducationManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryPersonListArgs = {
  filter?: InputMaybe<PersonFilterInput>;
  page?: InputMaybe<PageInput>;
  personSearchFilters?: InputMaybe<Array<PersonSearchFilters>>;
  sort?: InputMaybe<Array<PersonSort>>;
};


export type QueryPersonManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryPersonProfileFromFilesBuilderArgs = {
  bucket: Scalars['String']['input'];
  conversationId?: InputMaybe<Scalars['Int']['input']>;
  keys: Array<Scalars['String']['input']>;
};


export type QueryPersonProfileFromUrlBuilderArgs = {
  personId?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPersonWorkExperienceArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPersonWorkExperienceListArgs = {
  filter?: InputMaybe<PersonWorkExperienceFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PersonWorkExperienceSort>>;
};


export type QueryPersonWorkExperienceManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryPieChartArgs = {
  allowDecimals?: InputMaybe<Scalars['Boolean']['input']>;
  dataSeries: Array<PieChartSeries>;
  diameter?: InputMaybe<Scalars['Int']['input']>;
  fontSize: Scalars['Int']['input'];
  formatSuffix?: InputMaybe<Scalars['String']['input']>;
  height: Scalars['Float']['input'];
  innerSize?: InputMaybe<Scalars['Int']['input']>;
  legendAlign?: InputMaybe<AlignValue>;
  legendItemMarginTop?: InputMaybe<Scalars['Int']['input']>;
  legendSymbolHeight?: InputMaybe<Scalars['Int']['input']>;
  showAnimation?: InputMaybe<Scalars['Boolean']['input']>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryPmeCashflowsArgs = {
  cashflowType?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  fundName?: InputMaybe<Scalars['String']['input']>;
  investmentId: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPmeLatestUploadArgs = {
  investmentId: Scalars['Int']['input'];
};


export type QueryPmeMappingSuggestionsArgs = {
  uploadId: Scalars['Int']['input'];
};


export type QueryPmePositionsArgs = {
  company?: InputMaybe<Scalars['String']['input']>;
  fundName?: InputMaybe<Scalars['String']['input']>;
  investmentId: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  strategy?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPmeSummaryMetricsArgs = {
  investmentId: Scalars['Int']['input'];
};


export type QueryPmeUploadStatusArgs = {
  id: Scalars['ID']['input'];
  investmentId: Scalars['Int']['input'];
};


export type QueryPorfolioConfigByPortfolioIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPortalEmailDomainOrganizationListArgs = {
  filter?: InputMaybe<EmailDomainOrganizationFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<EmailDomainOrganizationSort>>;
};


export type QueryPortalFirmArgs = {
  id: Scalars['String']['input'];
};


export type QueryPortalFirmListArgs = {
  filter?: InputMaybe<PortalFirmFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PortalFirmSort>>;
};


export type QueryPortalFirmManyArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryPortalFirmTypeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPortalFirmTypeEnumListArgs = {
  filter?: InputMaybe<PortalFirmTypeEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PortalFirmTypeEnumSort>>;
};


export type QueryPortalFirmTypeEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryPortalOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPortalOrganizationListArgs = {
  filter?: InputMaybe<PortalOrganizationFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PortalOrganizationSort>>;
};


export type QueryPortalOrganizationManyArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryPortalServiceProviderFirmArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPortalServiceProviderFirmsListArgs = {
  filter?: InputMaybe<PortalServiceProviderFirmFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PortalServiceProviderFirmSort>>;
};


export type QueryPortalSubmittedArgs = {
  id: Scalars['String']['input'];
};


export type QueryPortalSubmittedListArgs = {
  filter?: InputMaybe<PortalSubmittedFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PortalSubmittedSort>>;
};


export type QueryPortalUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPortalUserListArgs = {
  filter?: InputMaybe<PortalUserFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PortalUserSort>>;
};


export type QueryPortalUserManyArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryPortfolioArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPortfolioAfsLookthroughArgs = {
  periodEnd?: InputMaybe<Scalars['String']['input']>;
  periodStart?: InputMaybe<Scalars['String']['input']>;
  portfolioId: Scalars['Int']['input'];
};


export type QueryPortfolioConfigArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPortfolioConfigListArgs = {
  filter?: InputMaybe<PortfolioConfigFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PortfolioConfigSort>>;
};


export type QueryPortfolioConfigManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryPortfolioFdpLoginsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPortfolioFdpLoginsListArgs = {
  filter?: InputMaybe<PortfolioFdpLoginsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PortfolioFdpLoginsSort>>;
};


export type QueryPortfolioFdpLoginsManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryPortfolioFactSheetArgs = {
  accountName?: InputMaybe<Scalars['String']['input']>;
  additionalBenchmarkNames?: InputMaybe<Array<Scalars['String']['input']>>;
  additionalBenchmarks?: InputMaybe<Array<Scalars['Int']['input']>>;
  additionalIndexNames?: InputMaybe<Array<Scalars['String']['input']>>;
  additionalIndexes?: InputMaybe<Array<Scalars['Int']['input']>>;
  betaIndex?: InputMaybe<Scalars['Int']['input']>;
  betaName?: InputMaybe<Scalars['String']['input']>;
  coveredFund?: InputMaybe<Scalars['Int']['input']>;
  currency?: Scalars['String']['input'];
  date: Scalars['Date']['input'];
  excludeCash?: Scalars['Boolean']['input'];
  footnote?: InputMaybe<Scalars['String']['input']>;
  fundTerms?: InputMaybe<Scalars['Int']['input']>;
  hideNames?: Scalars['Boolean']['input'];
  portfolioId: Scalars['Int']['input'];
  separateAccount?: InputMaybe<Scalars['Int']['input']>;
  strategies?: InputMaybe<Array<Scalars['String']['input']>>;
  tag?: Scalars['String']['input'];
  useProxies?: Scalars['Boolean']['input'];
  vehicleType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPortfolioGenomeReportArgs = {
  currency?: Scalars['String']['input'];
  date: Scalars['Date']['input'];
  excludeCash?: Scalars['Boolean']['input'];
  portfolioId: Scalars['Int']['input'];
  strategies?: InputMaybe<Array<Scalars['String']['input']>>;
  tag?: Scalars['String']['input'];
};


export type QueryPortfolioListArgs = {
  filter?: InputMaybe<PortfolioFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PortfolioSort>>;
};


export type QueryPositionReportDatesArgs = {
  investmentId: Scalars['Int']['input'];
};


export type QueryPositionsReportArgs = {
  aggregate?: Scalars['Boolean']['input'];
  calculationDate: Scalars['Date']['input'];
  currency?: Scalars['String']['input'];
  date: Scalars['Date']['input'];
  excludeCash?: Scalars['Boolean']['input'];
  exportAs?: Scalars['String']['input'];
  portfolioId: Scalars['Int']['input'];
  useProxyPositions?: Scalars['Boolean']['input'];
};


export type QueryPresignedTempUrlArgs = {
  input: PresignedTempUrlInput;
};


export type QueryPreviewLlmModelArgs = {
  bedrockModelId: Scalars['String']['input'];
  benchmarkSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPricingFrequencyEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPricingFrequencyEnumListArgs = {
  filter?: InputMaybe<PricingFrequencyEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PricingFrequencyEnumSort>>;
};


export type QueryPricingFrequencyEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryPrivateQuartileGroupCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPrivateQuartileGroupCategoryListArgs = {
  filter?: InputMaybe<PrivateQuartileGroupCategoryFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PrivateQuartileGroupCategorySort>>;
};


export type QueryPrivateQuartileGroupCategoryManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryProxyPositionsReportArgs = {
  asOfDate: Scalars['Date']['input'];
  currency?: Scalars['String']['input'];
  exportAs?: Scalars['String']['input'];
  investmentId: Scalars['Int']['input'];
  sendEmail?: Scalars['Boolean']['input'];
};


export type QueryRangerDraftStatusArgs = {
  investmentId: Scalars['Int']['input'];
};


export type QueryRecentlyViewedInvestmentListArgs = {
  filter?: InputMaybe<RecentlyViewedInvestmentFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<RecentlyViewedInvestmentSort>>;
};


export type QueryReportArgs = {
  format: FormatOptions;
  id: Scalars['ID']['input'];
};


export type QueryResultEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryResultEnumListArgs = {
  filter?: InputMaybe<ResultEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ResultEnumSort>>;
};


export type QueryResultEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryRightOfExtensionEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRightOfExtensionEnumListArgs = {
  filter?: InputMaybe<RightOfExtensionEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<RightOfExtensionEnumSort>>;
};


export type QueryRightOfExtensionEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryRiskCategoryArgs = {
  id: Scalars['String']['input'];
};


export type QueryRiskCategoryListArgs = {
  filter?: InputMaybe<RiskCategoryFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<RiskCategorySort>>;
};


export type QueryRiskMeasuresArgs = {
  investmentId: Scalars['Int']['input'];
  reportDate: Scalars['Date']['input'];
};


export type QueryRiskRefreshListArgs = {
  filter?: InputMaybe<RiskRefreshListFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<RiskRefreshListSort>>;
};


export type QueryRiskVisualizationsDataArgs = {
  portfolioId: Scalars['Int']['input'];
};


export type QuerySavedEntitySearchArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySavedEntitySearchListArgs = {
  filter?: InputMaybe<SavedEntitySearchFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<SavedEntitySearchSort>>;
};


export type QuerySavedKnowledgeBaseArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySavedKnowledgeBaseListArgs = {
  filter?: InputMaybe<SavedKnowledgeBaseFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<SavedKnowledgeBaseSort>>;
};


export type QuerySchoolEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySchoolEnumListArgs = {
  filter?: InputMaybe<SchoolEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<SchoolEnumSort>>;
};


export type QuerySchoolEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QuerySecurityMasterListArgs = {
  filter?: InputMaybe<SecurityMasterFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<SecurityMasterSort>>;
};


export type QuerySecurityMasterMeasurementsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryServiceProviderDocumentTypeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryServiceProviderDocumentTypeListArgs = {
  filter?: InputMaybe<ServiceProviderDocumentTypeFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ServiceProviderDocumentTypeSort>>;
};


export type QueryServiceProviderDocumentTypeManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryServiceProviderDocumentsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryServiceProviderDocumentsListArgs = {
  filter?: InputMaybe<ServiceProviderDocumentsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ServiceProviderDocumentsSort>>;
};


export type QueryServiceProviderDocumentsManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryServiceProviderFirmArgs = {
  id: Scalars['Int']['input'];
};


export type QueryServiceProviderFirmListArgs = {
  filter?: InputMaybe<ServiceProviderFirmFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ServiceProviderFirmSort>>;
};


export type QueryServiceProviderFirmManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryServiceProviderNotesArgs = {
  id: Scalars['Int']['input'];
};


export type QueryServiceProviderNotesListArgs = {
  filter?: InputMaybe<ServiceProviderNotesFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ServiceProviderNotesSort>>;
};


export type QueryServiceProviderNotesManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QuerySetArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySetListArgs = {
  filter?: InputMaybe<SetFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<SetSort>>;
};


export type QuerySetManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryShareClassArgs = {
  id: Scalars['Int']['input'];
};


export type QueryShareClassListArgs = {
  filter?: InputMaybe<ShareClassFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ShareClassSort>>;
};


export type QueryShareClassManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryShareClassProfileBuilderArgs = {
  Keys: Array<Scalars['String']['input']>;
  bucket: Scalars['String']['input'];
  conversationId?: InputMaybe<Scalars['Int']['input']>;
  investmentId: Scalars['Int']['input'];
};


export type QuerySharedGroupEntityArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySharedGroupEntityListArgs = {
  filter?: InputMaybe<SharedGroupEntityFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<SharedGroupEntitySort>>;
};


export type QuerySharedGroupEntityManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QuerySoftLockupArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySoftLockupListArgs = {
  filter?: InputMaybe<SoftLockupFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<SoftLockupSort>>;
};


export type QuerySoftLockupManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryStageEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryStageEnumListArgs = {
  filter?: InputMaybe<StageEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<StageEnumSort>>;
};


export type QueryStageEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryStateEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryStateEnumListArgs = {
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<StateEnumSort>>;
};


export type QueryStateEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryStatsGroupArgs = {
  groupKey: StatsGroupKey;
};


export type QueryStoredPromptFromFieldKeyArgs = {
  fieldKey: Scalars['String']['input'];
};


export type QueryStoredPromptsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStoredPromptsListArgs = {
  filter?: InputMaybe<StoredPromptsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<StoredPromptsSort>>;
};


export type QueryStoryboardGenArgs = {
  calculationPeriods?: Scalars['Int']['input'];
  currency?: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['Date']['input']>;
  exportAs?: Scalars['String']['input'];
  portfolioId: Scalars['Int']['input'];
  quarterly?: Scalars['Boolean']['input'];
};


export type QueryStrategyEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryStrategyEnumListArgs = {
  filter?: InputMaybe<StrategyEnumFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<StrategyEnumSort>>;
};


export type QueryStrategyEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryStrategyOptionsArgs = {
  filter?: InputMaybe<TypeAssetClassStrategyOptionsFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<TypeAssetClassStrategyOptionsSort>>;
};


export type QueryStressTestReportArgs = {
  benchmarks: Array<BenchmarkWeightInput>;
  calculationDate: Scalars['Date']['input'];
  currency?: Scalars['String']['input'];
  customBenchmarkName?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['Date']['input'];
  excludeCash?: Scalars['Boolean']['input'];
  exportAs?: Scalars['String']['input'];
  portfolioId: Scalars['Int']['input'];
  quarterly?: Scalars['Boolean']['input'];
  scenarioFactors: Array<ScenarioFactorsInput>;
  strategies: Array<Scalars['String']['input']>;
  tag: Scalars['String']['input'];
  timePeriod: Scalars['Int']['input'];
};


export type QuerySubStrategyEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySubStrategyEnumListArgs = {
  filter?: InputMaybe<SubStrategyEnumFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<SubStrategyEnumSort>>;
};


export type QuerySubStrategyEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QuerySummaryRiskReportArgs = {
  accountName?: InputMaybe<Scalars['String']['input']>;
  benchmarks: Array<BenchmarkWeightInput>;
  calculationDate: Scalars['Date']['input'];
  currency?: Scalars['String']['input'];
  customBenchmarkName?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['Date']['input'];
  excludeCash?: Scalars['Boolean']['input'];
  exportAs: Scalars['String']['input'];
  hideNames?: Scalars['Boolean']['input'];
  portfolioId: Scalars['Int']['input'];
  quarterly?: Scalars['Boolean']['input'];
  strategies: Array<Scalars['String']['input']>;
  tag: Scalars['String']['input'];
  timePeriod: Scalars['Int']['input'];
};


export type QuerySystemConfigValueArgs = {
  key: SystemConfigurationKey;
};


export type QuerySystemConfigurationArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySystemConfigurationByKeyArgs = {
  key: SystemConfigurationKey;
};


export type QuerySystemConfigurationListArgs = {
  filter?: InputMaybe<SystemConfigurationFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<SystemConfigurationSort>>;
};


export type QuerySystemConfigurationManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryTagArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTagClassArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTagClassListArgs = {
  filter?: InputMaybe<TagClassFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<TagClassSort>>;
};


export type QueryTagClassManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryTagListArgs = {
  filter?: InputMaybe<TagFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<TagSort>>;
};


export type QueryTagManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryTeamMemberListArgs = {
  filter?: InputMaybe<TeamFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<TeamSort>>;
};


export type QueryTemplateAttachmentsArgs = {
  entityLevel?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTitleEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTitleEnumListArgs = {
  filter?: InputMaybe<TitleEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<TitleEnumSort>>;
};


export type QueryTitleEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryTypeAssetClassStrategyOptionsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTypeAssetClassStrategyOptionsListArgs = {
  filter?: InputMaybe<TypeAssetClassStrategyOptionsFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<TypeAssetClassStrategyOptionsSort>>;
};


export type QueryUserArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserActivityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserActivityListArgs = {
  filter?: InputMaybe<UserActivityFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<UserActivitySort>>;
};


export type QueryUserListArgs = {
  filter?: InputMaybe<UserFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<UserSort>>;
};


export type QueryUserMutationAccessibleArgs = {
  mutationArgs: Scalars['String']['input'];
  mutationName: Scalars['String']['input'];
};


export type QueryUserSettingsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUsersXGroupsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUsersXGroupsListArgs = {
  filter?: InputMaybe<UsersXGroupsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<UsersXGroupsSort>>;
};


export type QueryUsersXGroupsManyArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryVehicleTypeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryVehicleTypeEnumListArgs = {
  filter?: InputMaybe<VehicleTypeEnumFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<VehicleTypeEnumSort>>;
};


export type QueryVehicleTypeEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryVehicleTypeOptionsArgs = {
  filter?: InputMaybe<TypeAssetClassStrategyOptionsFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<TypeAssetClassStrategyOptionsSort>>;
};


export type QueryWorkoutEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryWorkoutEnumListArgs = {
  filter?: InputMaybe<WorkoutEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<WorkoutEnumSort>>;
};


export type QueryWorkoutEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};

export type QuerySearchFilter = {
  value: Scalars['String']['input'];
};

export type QuestionResponse = {
  __typename?: 'QuestionResponse';
  answer?: Maybe<Scalars['String']['output']>;
  consultedExcerpts?: Maybe<Array<ConsultedExcerpts>>;
  conversationId?: Maybe<Scalars['Int']['output']>;
  effort?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  tools?: Maybe<Array<ToolResult>>;
  wasStopped?: Maybe<Scalars['Boolean']['output']>;
};

export type RcgPortfolioFilters = {
  isPortfolio?: InputMaybe<Scalars['Boolean']['input']>;
  managerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  portfolioIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type RangerChatPayload = {
  __typename?: 'RangerChatPayload';
  answer?: Maybe<Scalars['String']['output']>;
  consultedExcerpts?: Maybe<Array<ConsultedExcerpts>>;
  conversationId?: Maybe<Scalars['Int']['output']>;
  effort?: Maybe<Scalars['String']['output']>;
  messageStream: MessageStream;
  model?: Maybe<Scalars['String']['output']>;
  sessionId: Scalars['String']['output'];
  tools?: Maybe<Array<ToolResult>>;
};

export type RangerDraftStatus = {
  __typename?: 'RangerDraftStatus';
  investmentId: Scalars['Int']['output'];
  lastRun?: Maybe<RangerRerunSummary>;
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  staleFields: Array<RangerStaleFieldInfo>;
};

export type RangerRerunFieldOutcome = {
  __typename?: 'RangerRerunFieldOutcome';
  citations: Array<Citation>;
  fieldKey: Scalars['String']['output'];
  newValue?: Maybe<Scalars['JSON']['output']>;
  oldValue?: Maybe<Scalars['JSON']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  triggeredBy: Array<Citation>;
};

export type RangerRerunSummary = {
  __typename?: 'RangerRerunSummary';
  fields: Array<RangerRerunFieldOutcome>;
  ranAt: Scalars['DateTime']['output'];
  runId: Scalars['String']['output'];
};

export type RangerStaleFieldInfo = {
  __typename?: 'RangerStaleFieldInfo';
  artifacts: Array<Citation>;
  fieldKey: Scalars['String']['output'];
  markedAt: Scalars['DateTime']['output'];
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
};

export type RecentlyViewedInvestment = {
  __typename?: 'RecentlyViewedInvestment';
  createDate: Scalars['DateTime']['output'];
  investment: Investment;
  investmentId: Scalars['Int']['output'];
  user: User;
  userId: Scalars['Int']['output'];
};

export type RecentlyViewedInvestmentFilter = {
  investmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type RecentlyViewedInvestmentInput = {
  investmentId: Scalars['Int']['input'];
};

export type RecentlyViewedInvestmentList = {
  __typename?: 'RecentlyViewedInvestmentList';
  items: Array<RecentlyViewedInvestment>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type RecentlyViewedInvestmentSort = {
  field: RecentlyViewedInvestmentSortEnum;
  order: SortInput;
};

export enum RecentlyViewedInvestmentSortEnum {
  CreateDate = 'createDate',
  Id = 'id'
}

export type ReconcileNewPortalFirmInput = {
  name: Scalars['String']['input'];
  portalFirmId: Scalars['ID']['input'];
  user: ExternalUserInput;
};

export enum RefreshInvestmentRiskListType {
  All = 'ALL',
  Custom = 'CUSTOM',
  Database = 'DATABASE'
}

export enum RelativeDateUnit {
  D = 'd',
  M = 'm',
  W = 'w',
  Y = 'y'
}

export type ReportFilePayload = {
  __typename?: 'ReportFilePayload';
  error?: Maybe<Scalars['Boolean']['output']>;
  requestId: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ReportRecipientInput = {
  recipients: Array<Scalars['String']['input']>;
  /** Omit to add a report. */
  reportId?: InputMaybe<Scalars['Int']['input']>;
  reportName: Scalars['String']['input'];
};

/** A scheduled report and the addresses it is mailed to. */
export type ReportRecipientRow = {
  __typename?: 'ReportRecipientRow';
  /** Email addresses, stored ';'-separated. */
  recipients?: Maybe<Array<Scalars['String']['output']>>;
  reportId: Scalars['Int']['output'];
  reportName: Scalars['String']['output'];
};

export enum ReportStructure {
  Analytics = 'Analytics',
  Diligence = 'Diligence',
  Overview = 'Overview',
  Team = 'Team'
}

export enum ReportTypeOptions {
  CaseStudy = 'CaseStudy',
  Complete = 'Complete',
  Custom = 'Custom',
  OnePage = 'OnePage',
  Ranger = 'Ranger',
  Summary = 'Summary',
  TwoPage = 'TwoPage'
}

export type ResaveDocumentCredentials = {
  accessKeyId: Scalars['String']['input'];
  roleArn: Scalars['String']['input'];
  secretAccessKey: Scalars['String']['input'];
};

export type ResultEnum = {
  __typename?: 'ResultEnum';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ResultEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ResultEnumList = {
  __typename?: 'ResultEnumList';
  items: Array<ResultEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type ResultEnumSort = {
  field: ResultEnumSortEnum;
  order: SortInput;
};

export enum ResultEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type ReturnDistributionRecord = {
  __typename?: 'ReturnDistributionRecord';
  negative2to0?: Maybe<Scalars['Int']['output']>;
  negative4to2?: Maybe<Scalars['Int']['output']>;
  negative6to4?: Maybe<Scalars['Int']['output']>;
  negative8to6?: Maybe<Scalars['Int']['output']>;
  negative10to8?: Maybe<Scalars['Int']['output']>;
  overPositive10?: Maybe<Scalars['Int']['output']>;
  positive0to2?: Maybe<Scalars['Int']['output']>;
  positive2to4?: Maybe<Scalars['Int']['output']>;
  positive4to6?: Maybe<Scalars['Int']['output']>;
  positive6to8?: Maybe<Scalars['Int']['output']>;
  positive8to10?: Maybe<Scalars['Int']['output']>;
  underNegative10?: Maybe<Scalars['Int']['output']>;
};

export enum ReturnTypes {
  Gross = 'GROSS',
  Net = 'NET'
}

export type RightOfExtensionEnum = {
  __typename?: 'RightOfExtensionEnum';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type RightOfExtensionEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type RightOfExtensionEnumList = {
  __typename?: 'RightOfExtensionEnumList';
  items: Array<RightOfExtensionEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type RightOfExtensionEnumSort = {
  field: RightOfExtensionEnumSortEnum;
  order: SortInput;
};

export enum RightOfExtensionEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type RiskCategory = {
  __typename?: 'RiskCategory';
  category1?: Maybe<Scalars['String']['output']>;
  category2?: Maybe<Scalars['String']['output']>;
  category3?: Maybe<Scalars['String']['output']>;
  category4?: Maybe<Scalars['String']['output']>;
  category5?: Maybe<Scalars['String']['output']>;
  display1?: Maybe<Scalars['Int']['output']>;
  display2?: Maybe<Scalars['Int']['output']>;
  display3?: Maybe<Scalars['Int']['output']>;
  display4?: Maybe<Scalars['Int']['output']>;
  display5?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
};

export type RiskCategoryFilter = {
  display1?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type RiskCategoryList = {
  __typename?: 'RiskCategoryList';
  items: Array<RiskCategory>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type RiskCategoryPartition = {
  __typename?: 'RiskCategoryPartition';
  category1?: Maybe<Scalars['String']['output']>;
  count: Scalars['Int']['output'];
  display1?: Maybe<Scalars['Int']['output']>;
};

export type RiskCategorySort = {
  field: RiskCategorySortEnum;
  order: SortInput;
};

export enum RiskCategorySortEnum {
  Category1 = 'category1',
  Category2 = 'category2',
  Id = 'id'
}

export type RiskFileParse = {
  __typename?: 'RiskFileParse';
  errorCount: Scalars['Int']['output'];
  errorRows: Array<RiskFileRow>;
  totalCount: Scalars['Int']['output'];
  validInvestments: Array<RiskIdName>;
};

export type RiskFileRow = {
  __typename?: 'RiskFileRow';
  error?: Maybe<Scalars['String']['output']>;
  line: Scalars['Int']['output'];
  parsed?: Maybe<RockCreekMeasure>;
  raw?: Maybe<RiskMeasureRaw>;
};

export type RiskIdName = {
  __typename?: 'RiskIdName';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type RiskMeasureRaw = {
  __typename?: 'RiskMeasureRaw';
  category1: Scalars['String']['output'];
  category2: Scalars['String']['output'];
  category3: Scalars['String']['output'];
  category4: Scalars['String']['output'];
  category5: Scalars['String']['output'];
  investmentId: Scalars['String']['output'];
  measure: Scalars['String']['output'];
  reportDate: Scalars['String']['output'];
  tier1: Scalars['String']['output'];
  tier2: Scalars['String']['output'];
};

/** One raw VFactManagerRisk measure row: the full tier/category tuple plus its value, with no family filtering or label coalescing. For consumers that need the whole measure set for a manager on a report date (e.g. the proxy-position engine keys on tier2 + category1..5) rather than one hardcoded exposure dimension. */
export type RiskMeasureRecord = {
  __typename?: 'RiskMeasureRecord';
  category1: Scalars['String']['output'];
  category2: Scalars['String']['output'];
  category3: Scalars['String']['output'];
  category4: Scalars['String']['output'];
  category5: Scalars['String']['output'];
  tier1: Scalars['String']['output'];
  tier2: Scalars['String']['output'];
  /** DefaultMeasureFilled, raw -- NOT a percentage like ExposureRecord.weight. */
  value?: Maybe<Scalars['Float']['output']>;
};

export type RiskRefreshListFilter = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type RiskRefreshListInput = {
  add?: InputMaybe<Array<Scalars['Int']['input']>>;
  remove?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type RiskRefreshListList = {
  __typename?: 'RiskRefreshListList';
  items: Array<InvestmentIdToRefresh>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type RiskRefreshListSort = {
  field: RiskRefreshListSortEnum;
  order: SortInput;
};

export enum RiskRefreshListSortEnum {
  Id = 'id'
}

export type RiskTierInfo = {
  __typename?: 'RiskTierInfo';
  definition?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  noNegative?: Maybe<Scalars['Boolean']['output']>;
  tier1: Scalars['String']['output'];
  tier2: Scalars['String']['output'];
};

export type RockCreekMeasure = {
  __typename?: 'RockCreekMeasure';
  appCode?: Maybe<Scalars['Int']['output']>;
  categoryId: Scalars['String']['output'];
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  investmentId: Scalars['Int']['output'];
  measure: Scalars['Float']['output'];
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  reportDate: Scalars['Date']['output'];
  tierId: Scalars['String']['output'];
};

export type SavedEntitySearch = {
  __typename?: 'SavedEntitySearch';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  data: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export enum SavedEntitySearchEntityTypeEnum {
  Company = 'company',
  Investment = 'investment'
}

export type SavedEntitySearchFilter = {
  entityType?: InputMaybe<SavedEntitySearchEntityTypeEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameSearch?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type SavedEntitySearchInput = {
  data: Scalars['String']['input'];
  entityType: SavedEntitySearchEntityTypeEnum;
  name: Scalars['String']['input'];
  organizationId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type SavedEntitySearchList = {
  __typename?: 'SavedEntitySearchList';
  items: Array<SavedEntitySearch>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type SavedEntitySearchSort = {
  field: SavedEntitySearchSortEnum;
  order: SortInput;
};

export enum SavedEntitySearchSortEnum {
  EntityType = 'entityType',
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type SavedKnowledgeBase = {
  __typename?: 'SavedKnowledgeBase';
  companyCount?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  documentCount?: Maybe<Scalars['Int']['output']>;
  engagementCount?: Maybe<Scalars['Int']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  filters: Scalars['JSONObject']['output'];
  firmCount?: Maybe<Scalars['Int']['output']>;
  groupId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  investmentCount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  noteCount?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['Int']['output'];
};

export type SavedKnowledgeBaseFilterInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<SavedKnowledgeBaseScope>;
  status?: InputMaybe<KnowledgeBaseStatus>;
  type?: InputMaybe<KnowledgeBaseType>;
};

export type SavedKnowledgeBaseInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<KnowledgeBaseFilter>;
  groupId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<KnowledgeBaseType>;
};

export type SavedKnowledgeBaseList = {
  __typename?: 'SavedKnowledgeBaseList';
  items: Array<SavedKnowledgeBase>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export enum SavedKnowledgeBaseScope {
  Org = 'ORG',
  User = 'USER'
}

export type SavedKnowledgeBaseSort = {
  field: SavedKnowledgeBaseSortEnum;
  order: SortInput;
};

export enum SavedKnowledgeBaseSortEnum {
  CreatedAt = 'createdAt',
  Name = 'name'
}

export type ScenarioFactorsInput = {
  factors?: InputMaybe<Array<FactorInput>>;
  historicalPeriod?: InputMaybe<HistoricalPeriodInput>;
  scenarioId: Scalars['String']['input'];
  scenarioName: Scalars['String']['input'];
};

export type SchoolEnum = {
  __typename?: 'SchoolEnum';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  uniqueId: Scalars['String']['output'];
};

export type SchoolEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type SchoolEnumList = {
  __typename?: 'SchoolEnumList';
  items: Array<SchoolEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type SchoolEnumSort = {
  field: SchoolEnumSortEnum;
  order: SortInput;
};

export enum SchoolEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type SearchSetting = {
  __typename?: 'SearchSetting';
  id: Scalars['Int']['output'];
  type: SettingEntityType;
};

export type SearchSettingInput = {
  id: Scalars['Int']['input'];
  type: SettingEntityType;
};

export type SecurityMaster = {
  __typename?: 'SecurityMaster';
  assetClass?: Maybe<Scalars['String']['output']>;
  axysSecuritySymbol?: Maybe<Scalars['String']['output']>;
  barraCUSIP?: Maybe<Scalars['String']['output']>;
  barraCountryOfExposure?: Maybe<Scalars['String']['output']>;
  barraCurrency?: Maybe<Scalars['String']['output']>;
  barraISIN?: Maybe<Scalars['String']['output']>;
  barraId?: Maybe<Scalars['String']['output']>;
  barraLocalid?: Maybe<Scalars['String']['output']>;
  barraSedol?: Maybe<Scalars['String']['output']>;
  bbgIdSdg?: Maybe<Scalars['String']['output']>;
  blankPositionName?: Maybe<Scalars['String']['output']>;
  citcoSecurityId?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  cusipSdg?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  diligenceStrategyBucketing?: Maybe<Scalars['String']['output']>;
  em?: Maybe<Scalars['String']['output']>;
  emerging?: Maybe<Scalars['String']['output']>;
  equitySdg?: Maybe<Scalars['String']['output']>;
  esg?: Maybe<Scalars['String']['output']>;
  firearmsExposure?: Maybe<Scalars['String']['output']>;
  gicsSubIndustry?: Maybe<Scalars['String']['output']>;
  gicsSubIndustryName?: Maybe<Scalars['String']['output']>;
  gicsSubSector?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  hfrName?: Maybe<Scalars['String']['output']>;
  hfrid?: Maybe<Scalars['String']['output']>;
  historicalReturnProxy?: Maybe<Scalars['String']['output']>;
  historicalReturnProxyScaling?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAfricanAmericanLatinoCEO?: Maybe<Scalars['String']['output']>;
  isAfricanAmericanLatinoCoFounder?: Maybe<Scalars['String']['output']>;
  isFemaleCEO?: Maybe<Scalars['String']['output']>;
  isFemaleCoFounder?: Maybe<Scalars['String']['output']>;
  isImpactOriented?: Maybe<Scalars['String']['output']>;
  isin?: Maybe<Scalars['String']['output']>;
  isinSdg?: Maybe<Scalars['String']['output']>;
  jpmSecurityId?: Maybe<Scalars['String']['output']>;
  lastUpdate?: Maybe<Scalars['DateTime']['output']>;
  localId?: Maybe<Scalars['String']['output']>;
  markerCap?: Maybe<Scalars['String']['output']>;
  mktCapAmt?: Maybe<Scalars['Float']['output']>;
  mwbeCarry?: Maybe<Scalars['Float']['output']>;
  mwbeGP?: Maybe<Scalars['Float']['output']>;
  nameSdg?: Maybe<Scalars['String']['output']>;
  privateRegion?: Maybe<Scalars['String']['output']>;
  privateSector?: Maybe<Scalars['String']['output']>;
  rcgFundIdSdg?: Maybe<Scalars['Int']['output']>;
  rcgId?: Maybe<Scalars['Int']['output']>;
  rcgIdentifierType?: Maybe<Scalars['String']['output']>;
  rcgReportName?: Maybe<Scalars['String']['output']>;
  ric?: Maybe<Scalars['String']['output']>;
  rockCreekLinkedSecurity?: Maybe<Scalars['String']['output']>;
  sdg?: Maybe<Scalars['String']['output']>;
  secType?: Maybe<Scalars['String']['output']>;
  sector?: Maybe<Scalars['String']['output']>;
  security?: Maybe<Scalars['String']['output']>;
  sedol?: Maybe<Scalars['String']['output']>;
  sedolSdg?: Maybe<Scalars['String']['output']>;
  stateStreetId?: Maybe<Scalars['String']['output']>;
  ticker?: Maybe<Scalars['String']['output']>;
  totalDiverseGPs?: Maybe<Scalars['Float']['output']>;
  totalWomanGPs?: Maybe<Scalars['Float']['output']>;
  totalofGPs?: Maybe<Scalars['Float']['output']>;
  trBusinessSummary?: Maybe<Scalars['String']['output']>;
  trCO2EmissionTotal?: Maybe<Scalars['Int']['output']>;
  trPolicyDiversityOpportunity?: Maybe<Scalars['String']['output']>;
  trSocialPillarScore?: Maybe<Scalars['Float']['output']>;
  trTRESGCommunityScore?: Maybe<Scalars['Float']['output']>;
  trTargetsDiversityOpportunity?: Maybe<Scalars['String']['output']>;
  trpe?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  webAddress?: Maybe<Scalars['String']['output']>;
};

export type SecurityMasterFilter = {
  assetClass?: InputMaybe<Scalars['String']['input']>;
  barraCUSIP?: InputMaybe<Scalars['String']['input']>;
  citcoSecurityId?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['Int']['input']>;
  esg?: InputMaybe<Scalars['String']['input']>;
  gicsSubSector?: InputMaybe<Scalars['String']['input']>;
  hasHistoricalReturnProxy?: InputMaybe<Scalars['Boolean']['input']>;
  hasHistoricalReturnProxyScaling?: InputMaybe<Scalars['Boolean']['input']>;
  isin?: InputMaybe<Scalars['String']['input']>;
  isins?: InputMaybe<Array<Scalars['String']['input']>>;
  lastUpdate?: InputMaybe<DateRangeFilter>;
  mktCapAmt?: InputMaybe<FloatRangeFilter>;
  /** Substring search across Security, Ticker, ISIN, CUSIP and SEDOL. Every whitespace-separated word must match. Sort by `nameSearchRank` DESC for best-match-first. */
  q?: InputMaybe<Scalars['String']['input']>;
  ric?: InputMaybe<Scalars['String']['input']>;
  secType?: InputMaybe<Scalars['String']['input']>;
  sector?: InputMaybe<Scalars['String']['input']>;
  security?: InputMaybe<Scalars['String']['input']>;
  sedol?: InputMaybe<Scalars['String']['input']>;
  ticker?: InputMaybe<Scalars['String']['input']>;
  tickers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum SecurityMasterImportTarget {
  Measurements = 'measurements',
  SecurityMaster = 'securityMaster'
}

export type SecurityMasterList = {
  __typename?: 'SecurityMasterList';
  items: Array<SecurityMaster>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type SecurityMasterMeasurements = {
  __typename?: 'SecurityMasterMeasurements';
  asOfDate: Scalars['DateTime']['output'];
  createdDate: Scalars['DateTime']['output'];
  createdUser: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  measure: SecurityMasterMeasurementsEnum;
  measureId: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  secMasterId: Scalars['Int']['output'];
  source?: Maybe<SecurityMasterMeasurementsSourceEnum>;
  sourceField?: Maybe<SecurityMasterMeasurementsSourceFieldEnum>;
  sourceFieldId?: Maybe<Scalars['Int']['output']>;
  sourceId?: Maybe<Scalars['Int']['output']>;
  unit?: Maybe<SecurityMasterMeasurementsUnitEnum>;
  unitId?: Maybe<Scalars['Int']['output']>;
  valueQual?: Maybe<Scalars['String']['output']>;
  valueQuant?: Maybe<Scalars['Float']['output']>;
};

export type SecurityMasterMeasurementsEnum = {
  __typename?: 'SecurityMasterMeasurementsEnum';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SecurityMasterMeasurementsSourceEnum = {
  __typename?: 'SecurityMasterMeasurementsSourceEnum';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SecurityMasterMeasurementsSourceFieldEnum = {
  __typename?: 'SecurityMasterMeasurementsSourceFieldEnum';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SecurityMasterMeasurementsUnitEnum = {
  __typename?: 'SecurityMasterMeasurementsUnitEnum';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SecurityMasterSort = {
  field: SecurityMasterSortEnum;
  order: SortInput;
};

export enum SecurityMasterSortEnum {
  HistoricalReturnProxy = 'historicalReturnProxy',
  HistoricalReturnProxyScaling = 'historicalReturnProxyScaling',
  Id = 'id',
  LastUpdate = 'lastUpdate',
  NameSearchRank = 'nameSearchRank',
  RcgId = 'rcgId'
}

export type ServiceProviderDocumentType = {
  __typename?: 'ServiceProviderDocumentType';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ServiceProviderDocumentTypeFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceProviderDocumentTypeList = {
  __typename?: 'ServiceProviderDocumentTypeList';
  items: Array<ServiceProviderDocumentType>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type ServiceProviderDocumentTypeSort = {
  field: ServiceProviderDocumentTypeSortEnum;
  order: SortInput;
};

export enum ServiceProviderDocumentTypeSortEnum {
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type ServiceProviderDocuments = {
  __typename?: 'ServiceProviderDocuments';
  documentDate?: Maybe<Scalars['Date']['output']>;
  documentType?: Maybe<ServiceProviderDocumentType>;
  documentTypeId: Scalars['Int']['output'];
  fileName: Scalars['String']['output'];
  fileType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  serviceProviderFirm?: Maybe<ServiceProviderFirm>;
  serviceProviderFirmId: Scalars['Int']['output'];
  uploadedBy?: Maybe<Scalars['String']['output']>;
  uploadedDate?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ServiceProviderDocumentsFilter = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
  serviceProviderFirmId?: InputMaybe<Scalars['Int']['input']>;
};

export type ServiceProviderDocumentsInput = {
  documentDate?: InputMaybe<Scalars['Date']['input']>;
  documentTypeId?: InputMaybe<Scalars['Int']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  serviceProviderFirmId?: InputMaybe<Scalars['Int']['input']>;
};

export type ServiceProviderDocumentsList = {
  __typename?: 'ServiceProviderDocumentsList';
  items: Array<ServiceProviderDocuments>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type ServiceProviderDocumentsSort = {
  field: ServiceProviderDocumentsSortEnum;
  order: SortInput;
};

export enum ServiceProviderDocumentsSortEnum {
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type ServiceProviderFirm = {
  __typename?: 'ServiceProviderFirm';
  comments?: Maybe<Scalars['String']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isEvaluating?: Maybe<Scalars['Boolean']['output']>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  name: Scalars['String']['output'];
  officeLocations?: Maybe<Array<GlobalProviderInstitutions>>;
  registeredWithOther?: Maybe<Scalars['String']['output']>;
  tierLevel?: Maybe<Scalars['Int']['output']>;
  yearFounded?: Maybe<Scalars['Int']['output']>;
};

export type ServiceProviderFirmFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  institutionTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  isEvaluating?: InputMaybe<Scalars['Boolean']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceProviderFirmInput = {
  isEvaluating?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tierLevel?: InputMaybe<Scalars['Int']['input']>;
  yearFounded?: InputMaybe<Scalars['Int']['input']>;
};

export type ServiceProviderFirmList = {
  __typename?: 'ServiceProviderFirmList';
  items: Array<ServiceProviderFirm>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type ServiceProviderFirmSort = {
  field: ServiceProviderFirmSortEnum;
  order: SortInput;
};

export enum ServiceProviderFirmSortEnum {
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type ServiceProviderNotes = {
  __typename?: 'ServiceProviderNotes';
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  deleteUser?: Maybe<Scalars['String']['output']>;
  eventDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  isDeleted?: Maybe<Scalars['String']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  noteText: Scalars['String']['output'];
  providerId?: Maybe<Scalars['Int']['output']>;
  providerNoteTypeEnum?: Maybe<GlobalProviderNoteTypeEnum>;
  providerNoteTypeEnumId?: Maybe<Scalars['Int']['output']>;
  serviceProviderFirm?: Maybe<ServiceProviderFirm>;
};

export type ServiceProviderNotesFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  providerId?: InputMaybe<Scalars['Int']['input']>;
  providerNoteTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceProviderNotesInput = {
  eventDate?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  noteText?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['Int']['input']>;
  providerNoteTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
};

export type ServiceProviderNotesList = {
  __typename?: 'ServiceProviderNotesList';
  items: Array<ServiceProviderNotes>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type ServiceProviderNotesSort = {
  field: ServiceProviderNotesSortEnum;
  order: SortInput;
};

export enum ServiceProviderNotesSortEnum {
  Id = 'id',
  TextSearchRank = 'textSearchRank'
}

export type Set = {
  __typename?: 'Set';
  description?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  expression: Scalars['String']['output'];
  expressionPg?: Maybe<Scalars['String']['output']>;
  givesAccess: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isBaseSet: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  setType: Scalars['Int']['output'];
  subscriptionLevelEnumId: Scalars['Int']['output'];
};

export type SetFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  myCuratedSets?: InputMaybe<Scalars['Boolean']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  setType?: InputMaybe<SetType>;
  subscriptionLevelEnumId?: InputMaybe<SetSubscriptionLevel>;
};

export type SetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  expression?: InputMaybe<Scalars['String']['input']>;
  expressionPg?: InputMaybe<Scalars['String']['input']>;
  givesAccess?: InputMaybe<Scalars['Boolean']['input']>;
  isBaseSet?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  setType?: InputMaybe<Scalars['Int']['input']>;
  subscriptionLevelEnumId?: InputMaybe<Scalars['Int']['input']>;
};

export type SetList = {
  __typename?: 'SetList';
  items: Array<Set>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type SetSearchFilter = {
  setId: Scalars['Int']['input'];
};

export type SetSort = {
  field: SetSortEnum;
  order: SortInput;
};

export enum SetSortEnum {
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export enum SetSubscriptionLevel {
  AutoSubscribe = 'AutoSubscribe',
  NotSubscribeable = 'NotSubscribeable',
  Subscribeable = 'Subscribeable'
}

export enum SetType {
  Investment = 'Investment',
  Set = 'Set'
}

export type Setting = {
  __typename?: 'Setting';
  chatPreferences?: Maybe<ChatPreferences>;
  defaultInvestmentView?: Maybe<SearchSetting>;
};

export enum SettingEntityType {
  InvestmentSet = 'investmentSet',
  SavedEntitySearch = 'savedEntitySearch'
}

export type SettingInput = {
  chatPreferences?: InputMaybe<ChatPreferencesInput>;
  defaultInvestmentView?: InputMaybe<SearchSettingInput>;
};

export type ShareClass = {
  __typename?: 'ShareClass';
  FAS157?: Maybe<Scalars['Int']['output']>;
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  currencyDenominationEnumId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  investment?: Maybe<Investment>;
  investmentFees?: Maybe<InvestmentFees>;
  investmentId: Scalars['Int']['output'];
  isRcgNegotiated?: Maybe<Scalars['Boolean']['output']>;
  liquidity?: Maybe<Liquidity>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  otherFees?: Maybe<Scalars['String']['output']>;
  peLiquidity?: Maybe<PeLiquidity>;
  restricted?: Maybe<Scalars['Boolean']['output']>;
  softLockups?: Maybe<Array<SoftLockup>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ShareClassFilter = {
  id?: InputMaybe<Scalars['Int']['input']>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type ShareClassInput = {
  FAS157?: InputMaybe<Scalars['Int']['input']>;
  currencyDenominationEnumId?: InputMaybe<Scalars['Int']['input']>;
  investmentFees?: InputMaybe<InvestmentFeesInput>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  isRcgNegotiated?: InputMaybe<Scalars['Boolean']['input']>;
  liquidity?: InputMaybe<LiquidityInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  otherFees?: InputMaybe<Scalars['String']['input']>;
  peLiquidity?: InputMaybe<PeLiquidityInput>;
  restricted?: InputMaybe<Scalars['Boolean']['input']>;
  softLockups?: InputMaybe<Array<SoftLockupInput>>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ShareClassList = {
  __typename?: 'ShareClassList';
  items: Array<ShareClass>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type ShareClassProfileBuilderResponse = {
  __typename?: 'ShareClassProfileBuilderResponse';
  answer?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['Int']['output']>;
  shareClassProfiles?: Maybe<Array<GeneratedShareClassProfile>>;
};

export type ShareClassSort = {
  field: ShareClassSortEnum;
  order: SortInput;
};

export enum ShareClassSortEnum {
  Id = 'id',
  Name = 'name'
}

export type SharePortfolioInput = {
  shareWithAllUsers?: InputMaybe<Scalars['Boolean']['input']>;
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type SharedContentFilter = {
  /** excludeShared hides investments shared into the user's groups from groups the user does not belong to; onlyShared returns only those shared investments. */
  mode?: InputMaybe<SharedContentMode>;
};

export enum SharedContentMode {
  ExcludeShared = 'excludeShared',
  OnlyShared = 'onlyShared'
}

export type SharedGroupEntity = {
  __typename?: 'SharedGroupEntity';
  createDate: Scalars['DateTime']['output'];
  createUser?: Maybe<Scalars['String']['output']>;
  entityId: Scalars['Int']['output'];
  groupShareDefinition?: Maybe<GroupShareDefinition>;
  groupShareDefinitionId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser?: Maybe<Scalars['String']['output']>;
  sourceGroup?: Maybe<User>;
  sourceGroupId: Scalars['Int']['output'];
  targetGroup?: Maybe<User>;
  targetGroupId: Scalars['Int']['output'];
};

export type SharedGroupEntityFilter = {
  entityId?: InputMaybe<Scalars['Int']['input']>;
  groupShareDefinitionId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  sourceGroupId?: InputMaybe<Scalars['Int']['input']>;
  targetGroupId?: InputMaybe<Scalars['Int']['input']>;
};

export type SharedGroupEntityList = {
  __typename?: 'SharedGroupEntityList';
  items: Array<SharedGroupEntity>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type SharedGroupEntitySort = {
  field: SharedGroupEntitySortEnum;
  order: SortInput;
};

export enum SharedGroupEntitySortEnum {
  CreateDate = 'createDate',
  Id = 'id',
  ModifyDate = 'modifyDate'
}

export enum SharedQueueTypeEnum {
  ManagerInbox = 'MANAGER_INBOX',
  MyQueue = 'MY_QUEUE',
  OperationsInbox = 'OPERATIONS_INBOX'
}

export type SiriusChat = {
  __typename?: 'SiriusChat';
  asyncLambda: Scalars['String']['output'];
  investmentPerformance: SiriusChat_InvestmentPerformanceResult;
  syncLambda: SyncLambdaResult;
  topPositionsTrends: SyncLambdaResult;
};


export type SiriusChatAsyncLambdaArgs = {
  input: Scalars['JSONObject']['input'];
  label: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};


export type SiriusChatInvestmentPerformanceArgs = {
  input: SiriusChat_InvestmentPerformanceInput;
};


export type SiriusChatSyncLambdaArgs = {
  input: Scalars['JSONObject']['input'];
  label: Scalars['String']['input'];
};


export type SiriusChatTopPositionsTrendsArgs = {
  input: Scalars['JSONObject']['input'];
};

export type SiriusChat_InvestmentPerformanceInput = {
  endDate: Scalars['Date']['input'];
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  investmentName?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['Date']['input'];
};

export type SiriusChat_InvestmentPerformanceResult = {
  __typename?: 'SiriusChat_InvestmentPerformanceResult';
  ann?: Maybe<Scalars['Float']['output']>;
  cum?: Maybe<Scalars['Float']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum SiriusMcpCategory {
  Authoring = 'Authoring',
  Diligence = 'Diligence',
  Extraction = 'Extraction',
  Firms = 'Firms',
  KnowledgeBase = 'KnowledgeBase',
  Market = 'Market',
  Mutations = 'Mutations',
  Navigation = 'Navigation',
  Notifications = 'Notifications',
  PerformanceRisk = 'PerformanceRisk',
  Portfolio = 'Portfolio',
  Reference = 'Reference',
  Reporting = 'Reporting',
  Search = 'Search'
}

export type SoftLockup = {
  __typename?: 'SoftLockup';
  cashAvailableDays?: Maybe<Scalars['Int']['output']>;
  hasRedemptionFee?: Maybe<Scalars['Boolean']['output']>;
  holdBackPercent?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  liquidityId: Scalars['Int']['output'];
  liquidityUnit?: Maybe<CalendarUnitEnum>;
  liquidityUnitId?: Maybe<Scalars['Int']['output']>;
  liquidityValue?: Maybe<Scalars['Int']['output']>;
  lockupEndRedemptionOn?: Maybe<FinancialPeriodEnum>;
  lockupEndRedemptionOnId?: Maybe<Scalars['Int']['output']>;
  noticeBizDays?: Maybe<Scalars['Boolean']['output']>;
  noticeValue?: Maybe<Scalars['Int']['output']>;
  redemptionFee: Scalars['Float']['output'];
  redemptionOnBizDays?: Maybe<Scalars['Boolean']['output']>;
  secondLockupEndRedemptionOn?: Maybe<FinancialPeriodEnum>;
  secondLockupEndRedemptionOnId?: Maybe<Scalars['Int']['output']>;
  termBeginMonth: Scalars['Int']['output'];
  termEndMonth: Scalars['Int']['output'];
};

export type SoftLockupFilter = {
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  liquidityId?: InputMaybe<Scalars['Int']['input']>;
  shareClassId?: InputMaybe<Scalars['Int']['input']>;
};

export type SoftLockupInput = {
  cashAvailableDays?: InputMaybe<Scalars['Int']['input']>;
  holdBackPercent?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  liquidityUnitId?: InputMaybe<Scalars['Int']['input']>;
  liquidityValue?: InputMaybe<Scalars['Int']['input']>;
  lockupEndRedemptionOnId?: InputMaybe<Scalars['Int']['input']>;
  noticeBizDays?: InputMaybe<Scalars['Boolean']['input']>;
  noticeValue?: InputMaybe<Scalars['Int']['input']>;
  redemptionFee?: InputMaybe<Scalars['Float']['input']>;
  redemptionOnBizDays?: InputMaybe<Scalars['Boolean']['input']>;
  secondLockupEndRedemptionOnId?: InputMaybe<Scalars['Int']['input']>;
  termBeginMonth?: InputMaybe<Scalars['Int']['input']>;
  termEndMonth?: InputMaybe<Scalars['Int']['input']>;
};

export type SoftLockupList = {
  __typename?: 'SoftLockupList';
  items: Array<SoftLockup>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type SoftLockupSort = {
  field: SoftLockupSortEnum;
  order: SortInput;
};

export enum SoftLockupSortEnum {
  Id = 'id'
}

export type SolutionsCutoverReadiness = {
  __typename?: 'SolutionsCutoverReadiness';
  appOwned: Scalars['Int']['output'];
  blockers: Array<SolutionsReadinessBlocker>;
  ready: Scalars['Boolean']['output'];
};

export type SolutionsReadinessBlocker = {
  __typename?: 'SolutionsReadinessBlocker';
  entities: Array<Scalars['String']['output']>;
  more: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
};

/** sort direction */
export enum SortInput {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StageEnum = {
  __typename?: 'StageEnum';
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type StageEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type StageEnumList = {
  __typename?: 'StageEnumList';
  items: Array<StageEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type StageEnumSort = {
  field: StageEnumSortEnum;
  order: SortInput;
};

export enum StageEnumSortEnum {
  DisplayOrder = 'displayOrder',
  Id = 'id',
  Name = 'name'
}

export type StageMutationPlanInput = {
  conversationId?: InputMaybe<Scalars['Int']['input']>;
  steps: Array<MutationStepInput>;
  title: Scalars['String']['input'];
};

export type StateEnum = {
  __typename?: 'StateEnum';
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type StateEnumList = {
  __typename?: 'StateEnumList';
  items: Array<StateEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type StateEnumSort = {
  field: StateEnumSortEnum;
  order: SortInput;
};

export enum StateEnumSortEnum {
  Name = 'name'
}

export type StatsGroup = {
  __typename?: 'StatsGroup';
  alpha?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  asOfDate: Array<Maybe<Scalars['DateTime']['output']>>;
  beta: Array<Maybe<Scalars['Float']['output']>>;
  compoundReturn: Array<Maybe<Scalars['Float']['output']>>;
  correlation: Array<Maybe<Scalars['Float']['output']>>;
  correlationMatrix?: Maybe<Array<Maybe<Array<Maybe<Scalars['Float']['output']>>>>>;
  inceptionDate: Array<Maybe<Scalars['DateTime']['output']>>;
  infoRatio: Array<Maybe<Scalars['Float']['output']>>;
  kurtosis: Array<Maybe<Scalars['Float']['output']>>;
  lengthOfMaxDrawDown?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  maxDrawDown?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  percentProfitablePeriods?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  recoveryFromMaxDrawDown: Array<Maybe<Scalars['Float']['output']>>;
  returnsStream?: Maybe<Array<Maybe<Array<Maybe<Scalars['Float']['output']>>>>>;
  sharpeRatio?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  skewness: Array<Maybe<Scalars['Float']['output']>>;
  stdDev?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  trackingError: Array<Maybe<Scalars['Float']['output']>>;
};


export type StatsGroupAlphaArgs = {
  annualized: Scalars['Boolean']['input'];
  rangeLimit?: InputMaybe<Scalars['Int']['input']>;
  rangeOffset?: InputMaybe<Scalars['Int']['input']>;
  rangeUnit?: InputMaybe<StatsRangeUnit>;
};


export type StatsGroupBetaArgs = {
  annualized: Scalars['Boolean']['input'];
  rangeLimit?: InputMaybe<Scalars['Int']['input']>;
  rangeOffset?: InputMaybe<Scalars['Int']['input']>;
  rangeUnit?: InputMaybe<StatsRangeUnit>;
};


export type StatsGroupCompoundReturnArgs = {
  annualized: Scalars['Boolean']['input'];
  rangeLimit?: InputMaybe<Scalars['Int']['input']>;
  rangeOffset?: InputMaybe<Scalars['Int']['input']>;
  rangeUnit?: InputMaybe<StatsRangeUnit>;
};


export type StatsGroupCorrelationArgs = {
  annualized: Scalars['Boolean']['input'];
  rangeLimit?: InputMaybe<Scalars['Int']['input']>;
  rangeOffset?: InputMaybe<Scalars['Int']['input']>;
  rangeUnit?: InputMaybe<StatsRangeUnit>;
};


export type StatsGroupCorrelationMatrixArgs = {
  annualized: Scalars['Boolean']['input'];
  rangeLimit?: InputMaybe<Scalars['Int']['input']>;
  rangeOffset?: InputMaybe<Scalars['Int']['input']>;
  rangeUnit?: InputMaybe<StatsRangeUnit>;
};


export type StatsGroupInfoRatioArgs = {
  annualized: Scalars['Boolean']['input'];
  rangeLimit?: InputMaybe<Scalars['Int']['input']>;
  rangeOffset?: InputMaybe<Scalars['Int']['input']>;
  rangeUnit?: InputMaybe<StatsRangeUnit>;
};


export type StatsGroupKurtosisArgs = {
  rangeLimit?: InputMaybe<Scalars['Int']['input']>;
  rangeOffset?: InputMaybe<Scalars['Int']['input']>;
  rangeUnit?: InputMaybe<StatsRangeUnit>;
};


export type StatsGroupLengthOfMaxDrawDownArgs = {
  rangeLimit?: InputMaybe<Scalars['Int']['input']>;
  rangeOffset?: InputMaybe<Scalars['Int']['input']>;
  rangeUnit?: InputMaybe<StatsRangeUnit>;
};


export type StatsGroupMaxDrawDownArgs = {
  rangeLimit?: InputMaybe<Scalars['Int']['input']>;
  rangeOffset?: InputMaybe<Scalars['Int']['input']>;
  rangeUnit?: InputMaybe<StatsRangeUnit>;
};


export type StatsGroupPercentProfitablePeriodsArgs = {
  rangeLimit?: InputMaybe<Scalars['Int']['input']>;
  rangeOffset?: InputMaybe<Scalars['Int']['input']>;
  rangeUnit?: InputMaybe<StatsRangeUnit>;
};


export type StatsGroupRecoveryFromMaxDrawDownArgs = {
  rangeLimit?: InputMaybe<Scalars['Int']['input']>;
  rangeOffset?: InputMaybe<Scalars['Int']['input']>;
  rangeUnit?: InputMaybe<StatsRangeUnit>;
};


export type StatsGroupReturnsStreamArgs = {
  rangeLimit?: InputMaybe<Scalars['Int']['input']>;
  rangeOffset?: InputMaybe<Scalars['Int']['input']>;
  rangeUnit?: InputMaybe<StatsRangeUnit>;
};


export type StatsGroupSharpeRatioArgs = {
  annualized: Scalars['Boolean']['input'];
  rangeLimit?: InputMaybe<Scalars['Int']['input']>;
  rangeOffset?: InputMaybe<Scalars['Int']['input']>;
  rangeUnit?: InputMaybe<StatsRangeUnit>;
};


export type StatsGroupSkewnessArgs = {
  rangeLimit?: InputMaybe<Scalars['Int']['input']>;
  rangeOffset?: InputMaybe<Scalars['Int']['input']>;
  rangeUnit?: InputMaybe<StatsRangeUnit>;
};


export type StatsGroupStdDevArgs = {
  annualized: Scalars['Boolean']['input'];
  rangeLimit?: InputMaybe<Scalars['Int']['input']>;
  rangeOffset?: InputMaybe<Scalars['Int']['input']>;
  rangeUnit?: InputMaybe<StatsRangeUnit>;
};


export type StatsGroupTrackingErrorArgs = {
  annualized: Scalars['Boolean']['input'];
  rangeLimit?: InputMaybe<Scalars['Int']['input']>;
  rangeOffset?: InputMaybe<Scalars['Int']['input']>;
  rangeUnit?: InputMaybe<StatsRangeUnit>;
};

export type StatsGroupKey = {
  asOfDate: Scalars['DateTime']['input'];
  /** The investment at position zero is the independent investment (i.e. base investment); the others are dependent investments (e.g. peers or benchmarks). */
  investmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** If true, includes performance data before the fund's inception date (prior track record). */
  priorTrackRecord?: InputMaybe<Scalars['Boolean']['input']>;
  /** The 'with respect to' investment. It is the _other_ investment used for various _relative_ statistics, such as beta and tracking error. Required when such statistics are queried. */
  wrtInvestmentId?: InputMaybe<Scalars['Int']['input']>;
};

export enum StatsRangeUnit {
  I = 'I',
  M = 'M',
  Q = 'Q',
  Y = 'Y'
}

export type StoredPrompts = {
  __typename?: 'StoredPrompts';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  deleteUserId?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
};

export type StoredPromptsFilter = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type StoredPromptsInput = {
  prompt?: InputMaybe<Scalars['String']['input']>;
};

export type StoredPromptsList = {
  __typename?: 'StoredPromptsList';
  items: Array<StoredPrompts>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type StoredPromptsSort = {
  field: StoredPromptsSortEnum;
  order: SortInput;
};

export enum StoredPromptsSortEnum {
  CreateDate = 'createDate',
  Id = 'id'
}

export type StrategyEnum = {
  __typename?: 'StrategyEnum';
  code: Scalars['String']['output'];
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subStrategies: Array<SubStrategyEnum>;
};

export type StrategyEnumFilterInput = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type StrategyEnumList = {
  __typename?: 'StrategyEnumList';
  items: Array<StrategyEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type StrategyEnumSort = {
  field: StrategyEnumSortEnum;
  order: SortInput;
};

export enum StrategyEnumSortEnum {
  DisplayOrder = 'displayOrder',
  Id = 'id',
  Name = 'name'
}

export type StringIdName = {
  __typename?: 'StringIdName';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type StringIdNameList = {
  __typename?: 'StringIdNameList';
  items: Array<StringIdName>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export enum SubSections {
  AnalyticsAssetClassExposure = 'Analytics_asset_class_exposure',
  AnalyticsBenchmarkReturns = 'Analytics_benchmark_returns',
  AnalyticsCumulativeReturns = 'Analytics_cumulative_returns',
  AnalyticsDistributionOfReturns = 'Analytics_distribution_of_returns',
  AnalyticsDrawdowns = 'Analytics_drawdowns',
  AnalyticsFirmAum = 'Analytics_firm_aum',
  AnalyticsGrowthOf_1000 = 'Analytics_growth_of_1000',
  AnalyticsInvestmentAum = 'Analytics_investment_aum',
  AnalyticsPortfolioExposure = 'Analytics_portfolio_exposure',
  AnalyticsRegionExposure = 'Analytics_region_exposure',
  AnalyticsRiskVsReturns = 'Analytics_risk_vs_returns',
  AnalyticsSectorExposure = 'Analytics_sector_exposure',
  AnalyticsStrategyAum = 'Analytics_strategy_aum',
  AnalyticsUpDownCapture = 'Analytics_up_down_capture',
  DiligenceImpact = 'Diligence_impact',
  DiligenceInvestment = 'Diligence_investment',
  DiligenceOperations = 'Diligence_operations',
  OverviewBenchmarkStatisticsData = 'Overview_benchmark_statistics_data',
  OverviewClassificationsTileData = 'Overview_classifications_tile_data',
  OverviewContactsData = 'Overview_contacts_data',
  OverviewFirmTileData = 'Overview_firm_tile_data',
  OverviewFundTermsData = 'Overview_fund_terms_data',
  OverviewFundTileData = 'Overview_fund_tile_data',
  OverviewInvestmentSummaryData = 'Overview_investment_summary_data',
  OverviewMaxDrawDownStatisticsData = 'Overview_max_draw_down_statistics_data',
  OverviewPeerStatisticsData = 'Overview_peer_statistics_data',
  OverviewPerformanceData = 'Overview_performance_data',
  OverviewPositionsData = 'Overview_positions_data',
  OverviewPrivateInvestmentFamilyData = 'Overview_private_investment_family_data',
  OverviewPrivatePerformanceData = 'Overview_private_performance_data',
  OverviewPrivatePositionsData = 'Overview_private_positions_data',
  OverviewRiskBenchmarkStatisticsData = 'Overview_risk_benchmark_statistics_data',
  OverviewRiskStatisticsData = 'Overview_risk_statistics_data',
  OverviewServiceProvidersData = 'Overview_service_providers_data',
  OverviewStatusTileData = 'Overview_status_tile_data',
  TeamKeyPersonnel = 'Team_key_personnel',
  TeamTeamSummary = 'Team_team_summary'
}

export type SubStrategyEnum = {
  __typename?: 'SubStrategyEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  strategy: StrategyEnum;
  strategyId: Scalars['Int']['output'];
};

export type SubStrategyEnumFilterInput = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  strategyId?: InputMaybe<Scalars['Int']['input']>;
};

export type SubStrategyEnumList = {
  __typename?: 'SubStrategyEnumList';
  items: Array<SubStrategyEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type SubStrategyEnumSort = {
  field: SubStrategyEnumSortEnum;
  order: SortInput;
};

export enum SubStrategyEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type Subscription = {
  __typename?: 'Subscription';
  chatMessages: ChatSubscriptionPayload;
  /** Fires when a report started from a chat finishes, either way. Re-fetch the file through the report query; the event carries no link. */
  chatTaskFinished: ChatTaskFinishedPayload;
  rangerChatSubscription: RangerChatPayload;
  reportFileSubscription: ReportFilePayload;
};


export type SubscriptionChatMessagesArgs = {
  sessionId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionChatTaskFinishedArgs = {
  taskId: Scalars['String']['input'];
};


export type SubscriptionRangerChatSubscriptionArgs = {
  sessionId: Scalars['String']['input'];
};


export type SubscriptionReportFileSubscriptionArgs = {
  sessionId: Scalars['String']['input'];
};

export type SyncEntityStatus = {
  __typename?: 'SyncEntityStatus';
  backfillComplete: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  entity: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  lastDriftCount?: Maybe<Scalars['Int']['output']>;
  lastReconcileAt?: Maybe<Scalars['DateTime']['output']>;
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  lastRunError?: Maybe<Scalars['String']['output']>;
  lastRunMode?: Maybe<Scalars['String']['output']>;
  lastRunStatus?: Maybe<Scalars['String']['output']>;
  mirrorRows?: Maybe<Scalars['Float']['output']>;
  owner: Scalars['String']['output'];
  pgTable: Scalars['String']['output'];
  readFrom: Scalars['String']['output'];
  rowsSynced: Scalars['Float']['output'];
  sourceDb: Scalars['String']['output'];
  sourceRows?: Maybe<Scalars['Float']['output']>;
  sourceTable: Scalars['String']['output'];
  state: Scalars['String']['output'];
  writeTo: Scalars['String']['output'];
};

export type SyncLambdaResult = {
  __typename?: 'SyncLambdaResult';
  result: Scalars['String']['output'];
  urls?: Maybe<Array<Scalars['String']['output']>>;
};

export enum SyncMode {
  Backfill = 'backfill',
  Repair = 'repair',
  Verify = 'verify'
}

export type SystemConfigEntry = {
  __typename?: 'SystemConfigEntry';
  defaultValue?: Maybe<Scalars['JSON']['output']>;
  isOverridden: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['JSON']['output']>;
};

export type SystemConfiguration = {
  __typename?: 'SystemConfiguration';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  key: SystemConfigurationKey;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  value: Scalars['JSON']['output'];
};

export type SystemConfigurationFilterInput = {
  key?: InputMaybe<SystemConfigurationKey>;
};

export type SystemConfigurationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  key: SystemConfigurationKey;
  value: Scalars['JSON']['input'];
};

export enum SystemConfigurationKey {
  BatchReportConcurrency = 'BATCH_REPORT_CONCURRENCY',
  DdDraftsConcurrency = 'DD_DRAFTS_CONCURRENCY',
  KnowledgeBaseItemLimit = 'KNOWLEDGE_BASE_ITEM_LIMIT',
  KnowledgeBaseNoteLimit = 'KNOWLEDGE_BASE_NOTE_LIMIT',
  LlmGuardrailJudge = 'LLM_GUARDRAIL_JUDGE',
  LlmGuardrailMode = 'LLM_GUARDRAIL_MODE',
  RangerStalenessDocumentTypeIds = 'RANGER_STALENESS_DOCUMENT_TYPE_IDS',
  RangerStalenessMaxDistance = 'RANGER_STALENESS_MAX_DISTANCE',
  SentryProfileSampleRate = 'SENTRY_PROFILE_SAMPLE_RATE',
  SentryTracesSampleRate = 'SENTRY_TRACES_SAMPLE_RATE',
  SolovisDataIssueRecipients = 'SOLOVIS_DATA_ISSUE_RECIPIENTS',
  SolutionsForwardCapture = 'SOLUTIONS_FORWARD_CAPTURE'
}

export type SystemConfigurationList = {
  __typename?: 'SystemConfigurationList';
  items: Array<SystemConfiguration>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type SystemConfigurationSort = {
  field: SystemConfigurationSortEnum;
  order: SortInput;
};

export enum SystemConfigurationSortEnum {
  Key = 'key',
  Modifydate = 'modifydate'
}

export type Tag = {
  __typename?: 'Tag';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  investmentTags: VInvestmentTagsList;
  name: Scalars['String']['output'];
  tagClass: TagClass;
  tagClassId: Scalars['Int']['output'];
};


export type TagInvestmentTagsArgs = {
  filter?: InputMaybe<VInvestmentTagsFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<VInvestmentTagsSort>>;
};

export type TagAttributes = {
  __typename?: 'TagAttributes';
  countryFocus?: Maybe<Array<Tag>>;
  creditQualityFocus?: Maybe<Array<Tag>>;
  creditSectorFocus?: Maybe<Array<Tag>>;
  decisionMakingProcess?: Maybe<Array<Tag>>;
  durationFocus?: Maybe<Array<Tag>>;
  exposureBias?: Maybe<Array<Tag>>;
  geographicFocus?: Maybe<Array<Tag>>;
  investmentId?: Maybe<Scalars['Int']['output']>;
  marketCap?: Maybe<Array<Tag>>;
  marketFocus?: Maybe<Array<Tag>>;
  realEstateFocus?: Maybe<Array<Tag>>;
  regionalFocus?: Maybe<Array<Tag>>;
  sdgGoals?: Maybe<Array<Tag>>;
  sectorFocus?: Maybe<Array<Tag>>;
  styleBias?: Maybe<Array<Tag>>;
};

export type TagClass = {
  __typename?: 'TagClass';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  tags: TagList;
};


export type TagClassTagsArgs = {
  filter?: InputMaybe<TagFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<TagSort>>;
};

export type TagClassFilterInput = {
  idRange?: InputMaybe<IntRangeFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TagClassList = {
  __typename?: 'TagClassList';
  items: Array<TagClass>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type TagClassSort = {
  field: TagClassSortEnum;
  order: SortInput;
};

export enum TagClassSortEnum {
  DisplayOrder = 'displayOrder',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type TagFilterInput = {
  investmentCountGTE?: InputMaybe<Scalars['Int']['input']>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otherTags?: InputMaybe<Array<Scalars['Int']['input']>>;
  tagClassId?: InputMaybe<Scalars['Int']['input']>;
  tagClassIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type TagList = {
  __typename?: 'TagList';
  items: Array<TagListItem>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type TagListItem = {
  __typename?: 'TagListItem';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  investmentCount: Scalars['Int']['output'];
  investmentTags: VInvestmentTagsList;
  name: Scalars['String']['output'];
  nameSearchRank?: Maybe<Scalars['Float']['output']>;
  tagClass: TagClass;
  tagClassId: Scalars['Int']['output'];
};


export type TagListItemInvestmentTagsArgs = {
  filter?: InputMaybe<VInvestmentTagsFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<VInvestmentTagsSort>>;
};

export type TagSort = {
  field: TagSortEnum;
  order: SortInput;
};

export enum TagSortEnum {
  DisplayOrder = 'displayOrder',
  InvestmentCount = 'investmentCount',
  Name = 'name',
  NameSearchRank = 'nameSearchRank',
  TagClassId = 'tagClassId',
  TagClassName = 'tagClassName'
}

export type TagsInput = {
  id: Scalars['Int']['input'];
  tagClassId: Scalars['Int']['input'];
};

export type TeamFilterInput = {
  firmEmployment?: InputMaybe<FirmEmploymentFilterInput>;
};

export type TeamSort = {
  field: TeamSortEnum;
  order: SortInput;
};

export enum TeamSortEnum {
  EmployeeRole = 'employeeRole'
}

export type TempFile = {
  __typename?: 'TempFile';
  bucket: Scalars['String']['output'];
  filename?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  suggestions?: Maybe<TempFileSuggestions>;
};

export type TempFileSuggestions = {
  __typename?: 'TempFileSuggestions';
  date?: Maybe<Scalars['Date']['output']>;
  documentTypeEnumId?: Maybe<Scalars['Int']['output']>;
};

export type TempFileUpload = {
  file: Scalars['Upload']['input'];
};

export type Template = {
  __typename?: 'Template';
  content: Scalars['JSON']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  fieldSetGroup: Scalars['String']['output'];
  fieldSetType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isCurrent: Scalars['Boolean']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['Int']['output']>;
  version: Scalars['String']['output'];
};

export type TemplateAttachment = {
  __typename?: 'TemplateAttachment';
  assetClassName?: Maybe<Scalars['String']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  displayOrder: Scalars['Int']['output'];
  entityLevel: Scalars['String']['output'];
  fieldSetType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  organizationId: Scalars['Int']['output'];
  vehicleType?: Maybe<Scalars['String']['output']>;
};

export type TimeSeriesRecord = {
  __typename?: 'TimeSeriesRecord';
  month: Scalars['Int']['output'];
  value?: Maybe<Scalars['Float']['output']>;
  year: Scalars['Int']['output'];
};

export type TitleEnum = {
  __typename?: 'TitleEnum';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type TitleEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type TitleEnumList = {
  __typename?: 'TitleEnumList';
  items: Array<TitleEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type TitleEnumSort = {
  field: TitleEnumSortEnum;
  order: SortInput;
};

export enum TitleEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type ToolResult = {
  __typename?: 'ToolResult';
  params: Scalars['JSONObject']['output'];
  results: Scalars['JSONObject']['output'];
  tool: ChatToolType;
  toolCallId?: Maybe<Scalars['String']['output']>;
  toolId: Scalars['String']['output'];
  toolName?: Maybe<Scalars['String']['output']>;
};

export type TransformResult = {
  __typename?: 'TransformResult';
  skipped: Scalars['Boolean']['output'];
  transformKey: Scalars['String']['output'];
  writeResult?: Maybe<Scalars['JSONObject']['output']>;
};

export type TypeAssetClassStrategyOptions = {
  __typename?: 'TypeAssetClassStrategyOptions';
  assetClass: AssetClass2Enum;
  assetClassId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  strategy?: Maybe<StrategyEnum>;
  strategyId?: Maybe<Scalars['Int']['output']>;
  vehicleType: VehicleTypeEnum;
  vehicleTypeId: Scalars['Int']['output'];
};

export type TypeAssetClassStrategyOptionsFilterInput = {
  assetClassId?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  strategyId?: InputMaybe<Scalars['Int']['input']>;
  vehicleTypeId?: InputMaybe<Scalars['Int']['input']>;
};

export type TypeAssetClassStrategyOptionsList = {
  __typename?: 'TypeAssetClassStrategyOptionsList';
  items: Array<TypeAssetClassStrategyOptions>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type TypeAssetClassStrategyOptionsSort = {
  field: TypeAssetClassStrategyOptionsSortEnum;
  order: SortInput;
};

export enum TypeAssetClassStrategyOptionsSortEnum {
  AssetClass = 'assetClass',
  AssetClassId = 'assetClassId',
  Id = 'id',
  Strategy = 'strategy',
  StrategyId = 'strategyId',
  VehicleType = 'vehicleType',
  VehicleTypeId = 'vehicleTypeId'
}

export type UpdateFieldDefinitionInput = {
  columns?: InputMaybe<Array<FieldColumnInput>>;
  displayName: Scalars['String']['input'];
  displayType: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  questionText?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGuidelineInput = {
  format?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<Scalars['Int']['input']>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  limitRelationToResult?: InputMaybe<Scalars['Int']['input']>;
  limitValue?: InputMaybe<Scalars['String']['input']>;
  metricInfoId?: InputMaybe<Scalars['Int']['input']>;
  resultCardinality?: InputMaybe<Scalars['Int']['input']>;
  resultType?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateGuidelineNoteInput = {
  noteText?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGuidelineResultInput = {
  isCompliant?: InputMaybe<Scalars['Boolean']['input']>;
  isOverride?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNoticeLegInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  category?: InputMaybe<NoticeLegCategory>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTemplateAttachmentInput = {
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  access: EntityAccess;
  commonName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  entryType: AdEntryType;
  entryTypeId: Scalars['Int']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  flags: UserFlags;
  groupEntityType?: Maybe<GroupEntityType>;
  groupIds?: Maybe<Array<Scalars['Int']['output']>>;
  groups?: Maybe<Array<User>>;
  id: Scalars['Int']['output'];
  imageType?: Maybe<Scalars['String']['output']>;
  imageTypeSm?: Maybe<Scalars['String']['output']>;
  isGroup: Scalars['Boolean']['output'];
  isPrimaryOrganizationGroup?: Maybe<Scalars['Boolean']['output']>;
  isUser: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  oktaUser?: Maybe<OktaUser>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']['output']>;
  pushProfileChanges?: Maybe<Scalars['Boolean']['output']>;
  roleIds: Array<Scalars['Int']['output']>;
  roles: Array<ApplicationFlags>;
  sets?: Maybe<Array<Set>>;
  sub?: Maybe<Scalars['String']['output']>;
  userIds?: Maybe<Array<Scalars['Int']['output']>>;
  userName: Scalars['String']['output'];
  userSettings?: Maybe<UserSettings>;
  username?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<User>>;
};

export type UserActivity = {
  __typename?: 'UserActivity';
  adEntryId?: Maybe<Scalars['Int']['output']>;
  applicationId: Scalars['Int']['output'];
  createDate: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  rcgApplicationVersion: Scalars['String']['output'];
  requestUri: Scalars['String']['output'];
  requestUtc: Scalars['DateTime']['output'];
};

export type UserActivityFilter = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type UserActivityInput = {
  applicationId: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  rcgApplicationVersion?: InputMaybe<Scalars['String']['input']>;
  requestUri: Scalars['String']['input'];
  requestUtc: Scalars['DateTime']['input'];
};

export type UserActivityList = {
  __typename?: 'UserActivityList';
  items: Array<UserActivity>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type UserActivitySort = {
  field: UserActivitySortEnum;
  order: SortInput;
};

export enum UserActivitySortEnum {
  CreateDate = 'createDate',
  Id = 'id'
}

/** The authentication type for a user */
export enum UserAuthType {
  CustomAuth = 'CUSTOM_AUTH',
  NotFound = 'NOT_FOUND',
  Saml = 'SAML'
}

export type UserChatSkill = {
  __typename?: 'UserChatSkill';
  chatSkillId: Scalars['Int']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  optedOut: Scalars['Boolean']['output'];
  userId: Scalars['Int']['output'];
};

export type UserCreateInput = {
  commonName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  organizationId: Scalars['Int']['input'];
};

export type UserCreditUsage = {
  __typename?: 'UserCreditUsage';
  allotment: Scalars['Int']['output'];
  periodEnd: Scalars['Date']['output'];
  periodStart: Scalars['Date']['output'];
  remaining: Scalars['Float']['output'];
  used: Scalars['Float']['output'];
  userId: Scalars['Int']['output'];
};

export type UserFilterInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Array<Scalars['String']['input']>>;
  groupEntityType?: InputMaybe<GroupEntityType>;
  groupId?: InputMaybe<Scalars['Int']['input']>;
  groupMembers?: InputMaybe<Array<Scalars['Int']['input']>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  isGroup?: InputMaybe<Scalars['Boolean']['input']>;
  isUser?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['Int']['input']>;
  userNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UserFlags = {
  __typename?: 'UserFlags';
  /** No one should have this access, placeholder role. */
  ABSOLUTELY_NO_ONE: Scalars['Boolean']['output'];
  /** Is this user able to acess data collection administrative functionality? */
  DCAdmin: Scalars['Boolean']['output'];
  /** User is a RECFReviewer. */
  RECFReviewer: Scalars['Boolean']['output'];
  /** If this is false, then this user has miss assigned roles, contact support. */
  anyUser: Scalars['Boolean']['output'];
  /** User is a business applicant user. */
  businessApplicant: Scalars['Boolean']['output'];
  /** Is this user able to assume another user? */
  canAssumeUser: Scalars['Boolean']['output'];
  /** Has access to portfolio configuration settings. */
  canManagePortfolioConfig: Scalars['Boolean']['output'];
  /** Has access to chat features in Sirius */
  canSiriusChat: Scalars['Boolean']['output'];
  /** Is this user able to update companies? */
  canUpdateCompany: Scalars['Boolean']['output'];
  /** Is this user able to upload documents? */
  canUploadDocuments: Scalars['Boolean']['output'];
  /** Can edit features of client docs */
  clientDocsAdmin: Scalars['Boolean']['output'];
  /** Core users involved in Rock Creek's investment business, as opposed to lending activities, business applicants */
  coreUser: Scalars['Boolean']['output'];
  /** use group based entitlements will become default in the future */
  groupBasedEntitlements: Scalars['Boolean']['output'];
  /** Can view investment pages in Sirius */
  investmentPageAccess: Scalars['Boolean']['output'];
  /** Does this user have edit access to the advisor fund fields (eg. IsSubAdvised). */
  isAdvisorFundManager: Scalars['Boolean']['output'];
  /** Allows saving changes to the Admin :: Bloomberg page. */
  isBloombergCodeUpdateUser: Scalars['Boolean']['output'];
  /** User is a member of the client services team. */
  isClientServicesUser: Scalars['Boolean']['output'];
  /** Is this user a client of Rock Creek? */
  isClientUser: Scalars['Boolean']['output'];
  /** Does this user manage internal Rock Creek legal/compliance data? */
  isComplianceUser: Scalars['Boolean']['output'];
  /** Is this user allowed to manage data for rock creek? */
  isDataManager: Scalars['Boolean']['output'];
  /** Can edit primary portfolios */
  isEditPrimary: Scalars['Boolean']['output'];
  /** Is this user a data intake user / manages external data? */
  isPortalUser: Scalars['Boolean']['output'];
  /** Does this user manage internal Rock Creek reporting data? */
  isReportingUser: Scalars['Boolean']['output'];
  /** Does this user manage internal Rock Creek risk data? */
  isRiskUser: Scalars['Boolean']['output'];
  /** Is this user a member of Rock Creek Group? */
  isRockCreek: Scalars['Boolean']['output'];
  /** User is able to receive Rock Creek investment emails. */
  isRockCreekInvestmentEmailUser: Scalars['Boolean']['output'];
  /** User is a service provider manager, they may access service providers in data collection and manage data relating. */
  isServiceProviderManager: Scalars['Boolean']['output'];
  /** Is this user a subscription user? */
  isSubscriptionUser: Scalars['Boolean']['output'];
  /** Is this user able to perform adminstrative functions? */
  isSuperUser: Scalars['Boolean']['output'];
  /** User is the machine user. */
  machineUser: Scalars['Boolean']['output'];
  /** If the user has access to odc manager entered data */
  managerDataAccess: Scalars['Boolean']['output'];
  /** This user will write data as manager entered. */
  managerDataEntry: Scalars['Boolean']['output'];
  /** Should receive investment emails. */
  shouldReceiveInvestmentEmails: Scalars['Boolean']['output'];
  /** If the user has access to odc subscriber entered data (XDD) */
  subscriberDataAccess: Scalars['Boolean']['output'];
};

export type UserGroupCreateInput = {
  commonName: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  groupEntityType?: InputMaybe<GroupEntityType>;
  organizationId: Scalars['Int']['input'];
};

export type UserGroupUpdateInput = {
  commonName?: InputMaybe<Scalars['String']['input']>;
};

export type UserInvestmentSetSubscription = {
  __typename?: 'UserInvestmentSetSubscription';
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type UserList = {
  __typename?: 'UserList';
  items: Array<User>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type UserSettings = {
  __typename?: 'UserSettings';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  data: Setting;
  id: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  user: User;
  userId: Scalars['Int']['output'];
};

export type UserSettingsInput = {
  data: SettingInput;
  userId: Scalars['Int']['input'];
};

export type UserSort = {
  field: UserSortEnum;
  order: SortInput;
};

export enum UserSortEnum {
  Name = 'name'
}

export type UserUpdateInput = {
  commonName?: InputMaybe<Scalars['String']['input']>;
};

export type UsersXGroups = {
  __typename?: 'UsersXGroups';
  group: User;
  groupId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  user: User;
  userId: Scalars['Int']['output'];
};

export type UsersXGroupsFilter = {
  groupId?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type UsersXGroupsInput = {
  groupId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type UsersXGroupsList = {
  __typename?: 'UsersXGroupsList';
  items: Array<UsersXGroups>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type UsersXGroupsSort = {
  field: UsersXGroupsSortEnum;
  order: SortInput;
};

export enum UsersXGroupsSortEnum {
  Id = 'id'
}

export type VInvestmentTag = {
  __typename?: 'VInvestmentTag';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  investment: Investment;
  investmentId: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  partitionKey: Scalars['Int']['output'];
  sourceTagClassId: Scalars['Int']['output'];
  sourceTagId: Scalars['Int']['output'];
  tag: VTag;
  tagClassId: Scalars['Int']['output'];
  tagId: Scalars['Int']['output'];
};

export type VInvestmentTagsFilterInput = {
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  tagClassId?: InputMaybe<Scalars['Int']['input']>;
  tagId?: InputMaybe<Scalars['Int']['input']>;
};

export type VInvestmentTagsList = {
  __typename?: 'VInvestmentTagsList';
  items: Array<VInvestmentTag>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type VInvestmentTagsSort = {
  field: VInvestmentTagsSortEnum;
  order: SortInput;
};

export enum VInvestmentTagsSortEnum {
  Id = 'id'
}

export type VManagerAttribute = {
  __typename?: 'VManagerAttribute';
  managerId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
  valueAbbrev?: Maybe<Scalars['String']['output']>;
  valueId?: Maybe<Scalars['ID']['output']>;
};

export type VTag = {
  __typename?: 'VTag';
  displayOrder: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  partitionKey: Scalars['Int']['output'];
  sourceTagClassId: Scalars['Int']['output'];
  sourceTagId: Scalars['Int']['output'];
  tagClassId: Scalars['Int']['output'];
};

export type ValidationError = {
  __typename?: 'ValidationError';
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type VehicleTypeEnum = {
  __typename?: 'VehicleTypeEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  typeAssetClassStrategyOptions: Array<TypeAssetClassStrategyOptions>;
};

export type VehicleTypeEnumFilterInput = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type VehicleTypeEnumList = {
  __typename?: 'VehicleTypeEnumList';
  items: Array<VehicleTypeEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type VehicleTypeEnumSort = {
  field: VehicleTypeEnumSortEnum;
  order: SortInput;
};

export enum VehicleTypeEnumSortEnum {
  Name = 'name'
}

export type VolatilityPrivateSearchFilter = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  statType: PerformancePrivateStatType;
};

export type VolatilitySearchFilter = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  statType: PerformanceStatType;
};

export type WeightedBalance = {
  __typename?: 'WeightedBalance';
  acctManager?: Maybe<AccountingManager>;
  additions: Scalars['Float']['output'];
  date: Scalars['DateTime']['output'];
  endBalance: Scalars['Float']['output'];
  manager?: Maybe<Investment>;
  managerId: Scalars['Int']['output'];
  performance: Scalars['Float']['output'];
  portfolio?: Maybe<Portfolio>;
  portfolioId: Scalars['Int']['output'];
  redemptions: Scalars['Float']['output'];
  redemptionsSource?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<ManagerTags>;
  weight: Scalars['Float']['output'];
};

export type WorkoutEnum = {
  __typename?: 'WorkoutEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorkoutEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type WorkoutEnumList = {
  __typename?: 'WorkoutEnumList';
  items: Array<WorkoutEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type WorkoutEnumSort = {
  field: WorkoutEnumSortEnum;
  order: SortInput;
};

export enum WorkoutEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type ClientInvestmentFundsQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientInvestmentFundsQuery = { __typename?: 'Query', clientInvestmentFunds: Array<{ __typename?: 'ClientInvestmentFund', rcgFundId: number, name: string, groupId?: number | null, groupName: string, isCombined?: boolean | null }> };

export type ClientInvestmentClientsQueryVariables = Exact<{
  rcgFundId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ClientInvestmentClientsQuery = { __typename?: 'Query', clientInvestmentClients: Array<{ __typename?: 'ClientInvestmentClient', clientId: number, name: string }> };

export type ClientFeeOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientFeeOptionsQuery = { __typename?: 'Query', clientFeeOptions: { __typename?: 'ClientFeeOptions', aum?: Array<{ __typename?: 'ClientFeeOption', id: number, label: string }> | null, rate?: Array<{ __typename?: 'ClientFeeOption', id: number, label: string }> | null, unit?: Array<{ __typename?: 'ClientFeeOption', id: number, label: string }> | null } };

export type ClientShareClassesQueryVariables = Exact<{
  rcgFundId: Scalars['Int']['input'];
  clientId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ClientShareClassesQuery = { __typename?: 'Query', clientShareClasses: Array<{ __typename?: 'ClientShareClassRow', shareClassId: number, name: string, rcgFundId: number, clientId: number, unfunded?: boolean | null, feeAumOptionId: number, feeRateOptionId: number, feeUnitOptionId: number, deletable?: boolean | null, derived?: boolean | null, mgmtTiers: Array<{ __typename?: 'ClientFeeTierRow', threshold: number, rate: number, isFlat: boolean }>, adminTiers: Array<{ __typename?: 'ClientFeeTierRow', threshold: number, rate: number, isFlat: boolean }> }> };

export type ClientCapitalFlowsQueryVariables = Exact<{
  rcgFundId: Scalars['Int']['input'];
  clientId: Scalars['Int']['input'];
}>;


export type ClientCapitalFlowsQuery = { __typename?: 'Query', clientCapitalFlows: Array<{ __typename?: 'ClientCapitalFlowRow', shareClassId: number, date: string, addition?: number | null, redemption?: number | null, switchIn?: number | null, switchOut?: number | null }> };

export type ClientSwitchesQueryVariables = Exact<{
  rcgFundId: Scalars['Int']['input'];
  clientId: Scalars['Int']['input'];
}>;


export type ClientSwitchesQuery = { __typename?: 'Query', clientSwitches: Array<{ __typename?: 'ClientSwitchRow', fromShareClassId: number, toShareClassId: number, date: string, amount: number }> };

export type ClientAllocationsQueryVariables = Exact<{
  rcgFundIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  shareClassId?: InputMaybe<Scalars['Int']['input']>;
  month?: InputMaybe<Scalars['Date']['input']>;
  withFlowsOnly?: Scalars['Boolean']['input'];
}>;


export type ClientAllocationsQuery = { __typename?: 'Query', clientAllocations: Array<{ __typename?: 'ClientAllocationRow', shareClassId: number, shareClassName: string, rcgFundId: number, rcgFundName: string, clientId: number, clientName: string, derived?: boolean | null, date: string, begBal: number, addition?: number | null, redemption?: number | null, switchIn?: number | null, switchOut?: number | null, adjBegBal?: number | null, mgmtFeeRate?: number | null, mgmtFee?: number | null, adminFeeRate?: number | null, adminFee?: number | null, incentiveFee?: number | null, estGrossReturn?: number | null, estNetReturn?: number | null, estGrossEndBal?: number | null, estNetEndBal?: number | null, actGrossReturn?: number | null, actNetReturn?: number | null, actGrossEndBal?: number | null, actNetEndBal?: number | null, finalGrossReturn?: number | null, finalNetReturn?: number | null, effGrossReturn?: number | null, effNetReturn?: number | null, grossEndBal?: number | null, netEndBal?: number | null, pl?: number | null, enteredMgmtFee?: number | null, enteredAdminFee?: number | null, enteredIncentiveFee?: number | null }> };

export type ClientInvestmentsAsyncTaskStatusQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ClientInvestmentsAsyncTaskStatusQuery = { __typename?: 'Query', asyncTaskStatus?: { __typename?: 'AsyncTaskStatus', id?: string | null, endDate?: string | null, error?: string | null } | null };

export type SaveClientShareClassMutationVariables = Exact<{
  input: ClientShareClassInput;
}>;


export type SaveClientShareClassMutation = { __typename?: 'Mutation', saveClientShareClass: number };

export type DeleteClientShareClassMutationVariables = Exact<{
  shareClassId: Scalars['Int']['input'];
}>;


export type DeleteClientShareClassMutation = { __typename?: 'Mutation', deleteClientShareClass: boolean };

export type SaveClientCashFlowMutationVariables = Exact<{
  shareClassId: Scalars['Int']['input'];
  month: Scalars['Date']['input'];
  addition?: InputMaybe<Scalars['Float']['input']>;
  redemption?: InputMaybe<Scalars['Float']['input']>;
}>;


export type SaveClientCashFlowMutation = { __typename?: 'Mutation', saveClientCashFlow: boolean };

export type SaveClientSwitchMutationVariables = Exact<{
  fromShareClassId: Scalars['Int']['input'];
  toShareClassId: Scalars['Int']['input'];
  month: Scalars['Date']['input'];
  amount: Scalars['Float']['input'];
}>;


export type SaveClientSwitchMutation = { __typename?: 'Mutation', saveClientSwitch: boolean };

export type SaveClientMonthEntriesMutationVariables = Exact<{
  month: Scalars['Date']['input'];
  entries: Array<ClientMonthEntryInput> | ClientMonthEntryInput;
}>;


export type SaveClientMonthEntriesMutation = { __typename?: 'Mutation', saveClientMonthEntries: boolean };

export type ImportClientPortfolioReturnsMutationVariables = Exact<{
  rcgFundIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
}>;


export type ImportClientPortfolioReturnsMutation = { __typename?: 'Mutation', importClientPortfolioReturns: { __typename?: 'AsyncTaskStatus', id?: string | null, label: string, startDate: string } };

export type CompleteApplicationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: CompanyInput;
}>;


export type CompleteApplicationMutation = { __typename?: 'Mutation', updateCompany: { __typename?: 'Company', id: number, applicationCompletedAt?: string | null } };

export type GetApplicantCompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApplicantCompanyQuery = { __typename?: 'Query', companyList: { __typename?: 'CompanyList', items: Array<{ __typename?: 'Company', id: number, name: string, applicationCompletedAt?: string | null }> } };

export type GetUploadUrlQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUploadUrlQuery = { __typename?: 'Query', getDocumentQueueUploadUrl: string };

export type RematchDocumentQueueEntitiesMutationVariables = Exact<{
  documentQueueIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RematchDocumentQueueEntitiesMutation = { __typename?: 'Mutation', rematchDocumentQueueEntities: Array<string> };

export type EarlyEstimatesQueryVariables = Exact<{
  month: Scalars['Date']['input'];
}>;


export type EarlyEstimatesQuery = { __typename?: 'Query', earlyEstimates: Array<{ __typename?: 'EarlyEstimateRow', rcgFundId: number, name: string, isEstimate?: boolean | null, systemGrossEndBal?: number | null, systemNetEndBal?: number | null, systemGrossReturn?: number | null, systemSpread?: number | null, netReturn?: number | null, grossEndBal?: number | null, netEndBal?: number | null, grossReturn?: number | null, spread?: number | null, version?: string | null }> };

export type SaveEarlyEstimatesMutationVariables = Exact<{
  month: Scalars['Date']['input'];
  estimates: Array<EarlyEstimateInput> | EarlyEstimateInput;
}>;


export type SaveEarlyEstimatesMutation = { __typename?: 'Mutation', saveEarlyEstimates: boolean };

export type GetOrganizationIconUploadUrlQueryVariables = Exact<{
  organizationId: Scalars['Int']['input'];
  contentType: Scalars['String']['input'];
}>;


export type GetOrganizationIconUploadUrlQuery = { __typename?: 'Query', getOrganizationIconUploadUrl: string };

export type ConfirmOrganizationIconUploadMutationVariables = Exact<{
  organizationId: Scalars['Int']['input'];
}>;


export type ConfirmOrganizationIconUploadMutation = { __typename?: 'Mutation', confirmOrganizationIconUpload: { __typename?: 'Organization', id: number, smallIconUrl?: string | null } };

export type ReportRecipientsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReportRecipientsQuery = { __typename?: 'Query', reportRecipients: Array<{ __typename?: 'ReportRecipientRow', reportId: number, reportName: string, recipients?: Array<string> | null }> };

export type SaveReportRecipientMutationVariables = Exact<{
  input: ReportRecipientInput;
}>;


export type SaveReportRecipientMutation = { __typename?: 'Mutation', saveReportRecipient: { __typename?: 'ReportRecipientRow', reportId: number } };

export type DeleteReportRecipientMutationVariables = Exact<{
  reportId: Scalars['Int']['input'];
}>;


export type DeleteReportRecipientMutation = { __typename?: 'Mutation', deleteReportRecipient: boolean };

export type GetListAccountTypeEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<AccountTypeEnumSort> | AccountTypeEnumSort>;
}>;


export type GetListAccountTypeEnumQuery = { __typename?: 'Query', accountTypeEnumList: { __typename?: 'AccountTypeEnumList', total: number, items: Array<{ __typename?: 'AccountTypeEnum', id: number, name: string }> } };

export type GetOneAccountTypeEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneAccountTypeEnumQuery = { __typename?: 'Query', accountTypeEnum?: { __typename?: 'AccountTypeEnum', id: number, name: string } | null };

export type GetManyAccountTypeEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyAccountTypeEnumQuery = { __typename?: 'Query', accountTypeEnumMany: Array<{ __typename?: 'AccountTypeEnum', id: number, name: string } | null> };

export type AdEntriesXApplicationFlagsAttributesFragment = { __typename?: 'AdEntriesXApplicationFlags', id: number, userId: number, applicationFlagId: number, applicationFlag: { __typename?: 'ApplicationFlags', id: number, name: string, description?: string | null }, user: { __typename?: 'User', id: number, commonName: string, email?: string | null } };

export type GetListAdEntriesXApplicationFlagsQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<AdEntriesXApplicationFlagsSort> | AdEntriesXApplicationFlagsSort>;
  filter?: InputMaybe<AdEntriesXApplicationFlagsFilter>;
}>;


export type GetListAdEntriesXApplicationFlagsQuery = { __typename?: 'Query', adEntriesXApplicationFlagsList: { __typename?: 'AdEntriesXApplicationFlagsList', total: number, items: Array<{ __typename?: 'AdEntriesXApplicationFlags', id: number, userId: number, applicationFlagId: number, applicationFlag: { __typename?: 'ApplicationFlags', id: number, name: string, description?: string | null }, user: { __typename?: 'User', id: number, commonName: string, email?: string | null } }> } };

export type GetOneAdEntriesXApplicationFlagsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneAdEntriesXApplicationFlagsQuery = { __typename?: 'Query', adEntriesXApplicationFlags?: { __typename?: 'AdEntriesXApplicationFlags', id: number, userId: number, applicationFlagId: number, applicationFlag: { __typename?: 'ApplicationFlags', id: number, name: string, description?: string | null }, user: { __typename?: 'User', id: number, commonName: string, email?: string | null } } | null };

export type GetManyAdEntriesXApplicationFlagsQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyAdEntriesXApplicationFlagsQuery = { __typename?: 'Query', adEntriesXApplicationFlagsMany: Array<{ __typename?: 'AdEntriesXApplicationFlags', id: number, userId: number, applicationFlagId: number, applicationFlag: { __typename?: 'ApplicationFlags', id: number, name: string, description?: string | null }, user: { __typename?: 'User', id: number, commonName: string, email?: string | null } } | null> };

export type CreateAdEntriesXApplicationFlagsMutationVariables = Exact<{
  input: AdEntriesXApplicationFlagsInput;
}>;


export type CreateAdEntriesXApplicationFlagsMutation = { __typename?: 'Mutation', addAdEntriesXApplicationFlags: { __typename?: 'AdEntriesXApplicationFlags', id: number } };

export type UpdateAdEntriesXApplicationFlagsMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: AdEntriesXApplicationFlagsInput;
}>;


export type UpdateAdEntriesXApplicationFlagsMutation = { __typename?: 'Mutation', updateAdEntriesXApplicationFlags: { __typename?: 'AdEntriesXApplicationFlags', id: number } };

export type DeleteAdEntriesXApplicationFlagsMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteAdEntriesXApplicationFlagsMutation = { __typename?: 'Mutation', deleteAdEntriesXApplicationFlags: number };

export type AdEntriesXApplicationsXSetsAttributesFragment = { __typename?: 'AdEntriesXApplicationsXSets', id: number, entryId: number, setId: number, applicationId: number, set: { __typename?: 'Set', id: number, name: string }, entry: { __typename?: 'User', id: number, commonName: string, email?: string | null }, application: { __typename?: 'Application', id: number, name?: string | null } };

export type GetListAdEntriesXApplicationsXSetsQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<AdEntriesXApplicationsXSetsSort> | AdEntriesXApplicationsXSetsSort>;
  filter?: InputMaybe<AdEntriesXApplicationsXSetsFilter>;
}>;


export type GetListAdEntriesXApplicationsXSetsQuery = { __typename?: 'Query', adEntriesXApplicationsXSetsList: { __typename?: 'AdEntriesXApplicationsXSetsList', total: number, items: Array<{ __typename?: 'AdEntriesXApplicationsXSets', id: number, entryId: number, setId: number, applicationId: number, set: { __typename?: 'Set', id: number, name: string }, entry: { __typename?: 'User', id: number, commonName: string, email?: string | null }, application: { __typename?: 'Application', id: number, name?: string | null } }> } };

export type GetOneAdEntriesXApplicationsXSetsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneAdEntriesXApplicationsXSetsQuery = { __typename?: 'Query', adEntriesXApplicationsXSets?: { __typename?: 'AdEntriesXApplicationsXSets', id: number, entryId: number, setId: number, applicationId: number, set: { __typename?: 'Set', id: number, name: string }, entry: { __typename?: 'User', id: number, commonName: string, email?: string | null }, application: { __typename?: 'Application', id: number, name?: string | null } } | null };

export type GetManyAdEntriesXApplicationsXSetsQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyAdEntriesXApplicationsXSetsQuery = { __typename?: 'Query', adEntriesXApplicationsXSetsMany: Array<{ __typename?: 'AdEntriesXApplicationsXSets', id: number, entryId: number, setId: number, applicationId: number, set: { __typename?: 'Set', id: number, name: string }, entry: { __typename?: 'User', id: number, commonName: string, email?: string | null }, application: { __typename?: 'Application', id: number, name?: string | null } } | null> };

export type CreateAdEntriesXApplicationsXSetsMutationVariables = Exact<{
  input: AdEntriesXApplicationsXSetsInput;
}>;


export type CreateAdEntriesXApplicationsXSetsMutation = { __typename?: 'Mutation', addAdEntriesXApplicationsXSets: { __typename?: 'AdEntriesXApplicationsXSets', id: number } };

export type UpdateAdEntriesXApplicationsXSetsMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: AdEntriesXApplicationsXSetsInput;
}>;


export type UpdateAdEntriesXApplicationsXSetsMutation = { __typename?: 'Mutation', updateAdEntriesXApplicationsXSets: { __typename?: 'AdEntriesXApplicationsXSets', id: number } };

export type DeleteAdEntriesXApplicationsXSetsMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteAdEntriesXApplicationsXSetsMutation = { __typename?: 'Mutation', deleteAdEntriesXApplicationsXSets: number };

export type GetListAdvisorTypeEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<AdvisorTypeEnumSort> | AdvisorTypeEnumSort>;
}>;


export type GetListAdvisorTypeEnumQuery = { __typename?: 'Query', advisorTypeEnumList: { __typename?: 'AdvisorTypeEnumList', total: number, items: Array<{ __typename?: 'AdvisorTypeEnum', id: number, name: string }> } };

export type GetOneAdvisorTypeEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneAdvisorTypeEnumQuery = { __typename?: 'Query', advisorTypeEnum?: { __typename?: 'AdvisorTypeEnum', id: number, name: string } | null };

export type GetManyAdvisorTypeEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyAdvisorTypeEnumQuery = { __typename?: 'Query', advisorTypeEnumMany: Array<{ __typename?: 'AdvisorTypeEnum', id: number, name: string } | null> };

export type GetListAgencyQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<AgencySort> | AgencySort>;
}>;


export type GetListAgencyQuery = { __typename?: 'Query', agencyList: { __typename?: 'AgencyList', total: number, items: Array<{ __typename?: 'Agency', id: number, name?: string | null, shortName?: string | null }> } };

export type GetOneAgencyQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneAgencyQuery = { __typename?: 'Query', agency?: { __typename?: 'Agency', id: number, name?: string | null, shortName?: string | null } | null };

export type GetManyAgencyQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyAgencyQuery = { __typename?: 'Query', agencyMany: Array<{ __typename?: 'Agency', id: number, name?: string | null, shortName?: string | null } | null> };

export type ApplicationAttributesFragment = { __typename?: 'Application', id: number, name?: string | null };

export type GetListApplicationQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ApplicationSort> | ApplicationSort>;
  filter?: InputMaybe<ApplicationFilter>;
}>;


export type GetListApplicationQuery = { __typename?: 'Query', applicationList: { __typename?: 'ApplicationList', total: number, items: Array<{ __typename?: 'Application', id: number, name?: string | null }> } };

export type GetOneApplicationQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneApplicationQuery = { __typename?: 'Query', application?: { __typename?: 'Application', id: number, name?: string | null } | null };

export type GetManyApplicationQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyApplicationQuery = { __typename?: 'Query', applicationMany: Array<{ __typename?: 'Application', id: number, name?: string | null } | null> };

export type GetListApplicationFlagQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ApplicationFlagSort> | ApplicationFlagSort>;
  filter?: InputMaybe<ApplicationFlagFilter>;
}>;


export type GetListApplicationFlagQuery = { __typename?: 'Query', applicationFlagList: { __typename?: 'ApplicationFlagList', total: number, items: Array<{ __typename?: 'ApplicationFlags', id: number, name: string, description?: string | null, applicationId: number }> } };

export type GetOneApplicationFlagQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneApplicationFlagQuery = { __typename?: 'Query', applicationFlag?: { __typename?: 'ApplicationFlags', id: number, name: string, description?: string | null, applicationId: number } | null };

export type GetManyApplicationFlagQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyApplicationFlagQuery = { __typename?: 'Query', applicationFlagMany: Array<{ __typename?: 'ApplicationFlags', id: number, name: string, description?: string | null, applicationId: number } | null> };

export type GetListAssetClass2EnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<AssetClass2EnumSort> | AssetClass2EnumSort>;
}>;


export type GetListAssetClass2EnumQuery = { __typename?: 'Query', assetClass2EnumList: { __typename?: 'AssetClass2EnumList', total: number, items: Array<{ __typename?: 'AssetClass2Enum', id: number, name: string, marketId: number }> } };

export type GetListAssetClass2EnumOptionsQueryVariables = Exact<{
  filter?: InputMaybe<TypeAssetClassStrategyOptionsFilterInput>;
  sort?: InputMaybe<Array<TypeAssetClassStrategyOptionsSort> | TypeAssetClassStrategyOptionsSort>;
}>;


export type GetListAssetClass2EnumOptionsQuery = { __typename?: 'Query', assetClassOptions: { __typename?: 'AssetClass2EnumList', total: number, items: Array<{ __typename?: 'AssetClass2Enum', id: number, name: string }> } };

export type GetOneAssetClass2EnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneAssetClass2EnumQuery = { __typename?: 'Query', assetClass2Enum?: { __typename?: 'AssetClass2Enum', id: number, name: string, marketId: number } | null };

export type GetManyAssetClass2EnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyAssetClass2EnumQuery = { __typename?: 'Query', assetClass2EnumMany: Array<{ __typename?: 'AssetClass2Enum', id: number, name: string, marketId: number } | null> };

export type GetListMarketEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<AssetClassEnumSort> | AssetClassEnumSort>;
}>;


export type GetListMarketEnumQuery = { __typename?: 'Query', assetClassEnumList: { __typename?: 'AssetClassEnumList', total: number, items: Array<{ __typename?: 'AssetClassEnum', id: number, name: string }> } };

export type GetOneMarketEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneMarketEnumQuery = { __typename?: 'Query', assetClassEnum?: { __typename?: 'AssetClassEnum', id: number, name: string } | null };

export type GetManyMarketEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyMarketEnumQuery = { __typename?: 'Query', assetClassEnumMany: Array<{ __typename?: 'AssetClassEnum', id: number, name: string } | null> };

export type GetOneAsyncTaskStatusQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOneAsyncTaskStatusQuery = { __typename?: 'Query', asyncTaskStatus?: { __typename?: 'AsyncTaskStatus', id?: string | null, startDate: string, endDate?: string | null, error?: string | null } | null };

export type GetListAuditContactTypeEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<AuditContactTypeEnumSort> | AuditContactTypeEnumSort>;
}>;


export type GetListAuditContactTypeEnumQuery = { __typename?: 'Query', auditContactTypeEnumList: { __typename?: 'AuditContactTypeEnumList', total: number, items: Array<{ __typename?: 'AuditContactTypeEnum', id: number, name: string }> } };

export type GetOneAuditContactTypeEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneAuditContactTypeEnumQuery = { __typename?: 'Query', auditContactTypeEnum?: { __typename?: 'AuditContactTypeEnum', id: number, name: string } | null };

export type GetManyAuditContactTypeEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyAuditContactTypeEnumQuery = { __typename?: 'Query', auditContactTypeEnumMany: Array<{ __typename?: 'AuditContactTypeEnum', id: number, name: string } | null> };

export type GetOneInvestmentAumQueryVariables = Exact<{
  investmentId: Scalars['Int']['input'];
}>;


export type GetOneInvestmentAumQuery = { __typename?: 'Query', investment: { __typename?: 'Investment', id: number, name: string, inceptionDate?: string | null, firmId?: number | null, portalSubmitted?: { __typename?: 'PortalSubmitted', migratedAt?: string | null } | null, fdpLogins?: Array<{ __typename?: 'FDPLogin', id: number, username: string, password: string, securityQuestion?: string | null, notes?: string | null, email?: string | null, mfaUser?: string | null, financialDataProvider: { __typename?: 'FinancialDataProvider', id: number, name: string, fdpWebsites: Array<{ __typename?: 'FDPWebsites', id: number, website: string }> } }> | null, firm?: { __typename?: 'Firm', id: number, name: string, firmEmployments?: Array<{ __typename?: 'FirmEmployment', id: number, person?: { __typename?: 'Person', id: number, lastName: string, firstName?: string | null, middleName?: string | null, email?: string | null, phone?: string | null } | null }> | null, primaryAddress?: { __typename?: 'Address', id: number, website?: string | null, webUserId?: string | null, webPassword?: string | null } | null } | null, assets?: Array<{ __typename?: 'FirmFundAssets', asOfDate: string, firmAUM?: number | null, investmentAUM?: number | null, strategyAUM?: number | null, flow: { __typename?: 'AumFlow', strategy?: number | null, investment?: number | null } }> | null } };

export type BulkUpdateAumMutationVariables = Exact<{
  investmentId: Scalars['Int']['input'];
  entries: Array<AumEntry> | AumEntry;
}>;


export type BulkUpdateAumMutation = { __typename?: 'Mutation', addOrUpdateAUM?: { __typename?: 'FirmFundAssetsList', items: Array<{ __typename?: 'FirmFundAssets', asOfDate: string, investmentAUM?: number | null, firmAUM?: number | null, strategyAUM?: number | null, flow: { __typename?: 'AumFlow', strategy?: number | null, investment?: number | null } }> } | null };

export type GetListAxysCodeQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<AxysCodeSort> | AxysCodeSort>;
  filter?: InputMaybe<AxysCodeFilter>;
}>;


export type GetListAxysCodeQuery = { __typename?: 'Query', axysCodeList: { __typename?: 'AxysCodeList', total: number, items: Array<{ __typename?: 'AxysCode', id: number, code: string }> } };

export type GetOneAxysCodeQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneAxysCodeQuery = { __typename?: 'Query', axysCode?: { __typename?: 'AxysCode', id: number, code: string } | null };

export type GetManyAxysCodeQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyAxysCodeQuery = { __typename?: 'Query', axysCodeMany: Array<{ __typename?: 'AxysCode', id: number, code: string } | null> };

export type GetListBusinessObjectEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<BusinessObjectEnumSort> | BusinessObjectEnumSort>;
  filter?: InputMaybe<BusinessObjectEnumFilter>;
}>;


export type GetListBusinessObjectEnumQuery = { __typename?: 'Query', businessObjectEnumList: { __typename?: 'BusinessObjectEnumList', total: number, items: Array<{ __typename?: 'BusinessObjectEnum', id: number, name: string }> } };

export type GetOneBusinessObjectEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneBusinessObjectEnumQuery = { __typename?: 'Query', businessObjectEnum?: { __typename?: 'BusinessObjectEnum', id: number, name: string } | null };

export type GetManyBusinessObjectEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyBusinessObjectEnumQuery = { __typename?: 'Query', businessObjectEnumMany: Array<{ __typename?: 'BusinessObjectEnum', id: number, name: string } | null> };

export type GetListCalendarUnitEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CalendarUnitEnumSort> | CalendarUnitEnumSort>;
}>;


export type GetListCalendarUnitEnumQuery = { __typename?: 'Query', calendarUnitEnumList: { __typename?: 'CalendarUnitEnumList', total: number, items: Array<{ __typename?: 'CalendarUnitEnum', id: number, name: string }> } };

export type GetOneCalendarUnitEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneCalendarUnitEnumQuery = { __typename?: 'Query', calendarUnitEnum?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null };

export type GetManyCalendarUnitEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyCalendarUnitEnumQuery = { __typename?: 'Query', calendarUnitEnumMany: Array<{ __typename?: 'CalendarUnitEnum', id: number, name: string } | null> };

export type ClientAttributesFragment = { __typename?: 'Client', id: string, clientName?: string | null, clientType?: string | null };

export type GetListClientQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ClientSort> | ClientSort>;
  filter?: InputMaybe<ClientFilter>;
}>;


export type GetListClientQuery = { __typename?: 'Query', clientList: { __typename?: 'ClientList', total: number, items: Array<{ __typename?: 'Client', id: string, clientName?: string | null, clientType?: string | null }> } };

export type GetOneClientQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOneClientQuery = { __typename?: 'Query', client?: { __typename?: 'Client', id: string, clientName?: string | null, clientType?: string | null } | null };

export type GetManyClientQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetManyClientQuery = { __typename?: 'Query', clientMany: Array<{ __typename?: 'Client', id: string, clientName?: string | null, clientType?: string | null } | null> };

export type GetOneInvestmentCloseDatesQueryVariables = Exact<{
  investmentId: Scalars['Int']['input'];
}>;


export type GetOneInvestmentCloseDatesQuery = { __typename?: 'Query', investment: { __typename?: 'Investment', id: number, name: string, closeDateFundSize?: Array<{ __typename?: 'CloseDateFundSize', fundSize: number, closeDate: string }> | null } };

export type UpdateInvestmentCloseDatesMutationVariables = Exact<{
  investmentId: Scalars['Int']['input'];
  closeDates: Array<CloseDateShort> | CloseDateShort;
}>;


export type UpdateInvestmentCloseDatesMutation = { __typename?: 'Mutation', addOrUpdateCloseDateSize: Array<{ __typename?: 'CloseDateFundSize', fundSize: number, closeDate: string }> };

export type CompanyAttributesFragment = { __typename?: 'Company', id: number, firmId: number, name: string, summary?: string | null, isBusinessApplication: boolean, ndaSigned?: boolean | null, operatingStatusEnumId?: string | null, lastFundingTypeEnumId?: string | null, companyTypeEnumId?: string | null, primaryAssignment?: string | null, operatingStatus?: { __typename?: 'OperatingStatusEnum', id: string, name: string } | null, lastFundingType?: { __typename?: 'FundingTypeEnum', id: string, name?: string | null } | null, companyType?: { __typename?: 'CompanyTypeEnum', id: string, name: string } | null, firmAttributes: { __typename?: 'Firm', id: number, isCompany?: boolean | null, stockSymbol?: string | null, primaryAddressId: number, isStaffMWDBE?: boolean | null, employeeTotal?: number | null, yearFounded?: number | null, email?: string | null, linkedIn?: string | null, website?: string | null, primaryAddress?: { __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, zipCode?: string | null, countryEnumId?: number | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null, website?: string | null } | null, firmTags?: Array<{ __typename?: 'FirmTags', firmId: number, tagId: number, tag: { __typename?: 'Tag', id: number, name: string, tagClassId: number, tagClass: { __typename?: 'TagClass', id: number, name: string } } }> | null, firmXImpact?: Array<{ __typename?: 'FirmXImpact', firmId: number, impactEnumId: number, impactEnum: { __typename?: 'ImpactEnum', id: number, name: string } }> | null, impactTags?: Array<{ __typename?: 'ImpactEnum', id: number, name: string }> | null, firmEmployments?: Array<{ __typename?: 'FirmEmployment', id: number, firmId: number, personId: number, employeeRoleEnumId?: number | null, contactTypeEnumId?: number | null, leftInd?: boolean | null, leftDate?: string | null, leftReason?: string | null, authToTrade?: boolean | null, outsideAffil?: boolean | null, startDate?: string | null, jobDesc?: string | null, focusStrategyEnumId?: number | null, dataContact?: boolean | null, isFounder?: boolean | null, isKeyPersonnel?: boolean | null, auditContactTypeEnumId?: number | null, isDataEntryContact?: boolean | null, displayOrder?: number | null, comments?: string | null, person?: { __typename?: 'Person', id: number, firstName?: string | null, lastName: string, middleName?: string | null, email?: string | null, phone?: string | null } | null }> | null } };

export type GetListCompanyQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CompanySort> | CompanySort>;
  filter?: InputMaybe<CompanyFilter>;
}>;


export type GetListCompanyQuery = { __typename?: 'Query', companyList: { __typename?: 'CompanyList', total: number, items: Array<{ __typename?: 'Company', id: number, firmId: number, name: string, summary?: string | null, isBusinessApplication: boolean, ndaSigned?: boolean | null, operatingStatusEnumId?: string | null, lastFundingTypeEnumId?: string | null, companyTypeEnumId?: string | null, primaryAssignment?: string | null, operatingStatus?: { __typename?: 'OperatingStatusEnum', id: string, name: string } | null, lastFundingType?: { __typename?: 'FundingTypeEnum', id: string, name?: string | null } | null, companyType?: { __typename?: 'CompanyTypeEnum', id: string, name: string } | null, firmAttributes: { __typename?: 'Firm', id: number, isCompany?: boolean | null, stockSymbol?: string | null, primaryAddressId: number, isStaffMWDBE?: boolean | null, employeeTotal?: number | null, yearFounded?: number | null, email?: string | null, linkedIn?: string | null, website?: string | null, primaryAddress?: { __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, zipCode?: string | null, countryEnumId?: number | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null, website?: string | null } | null, firmTags?: Array<{ __typename?: 'FirmTags', firmId: number, tagId: number, tag: { __typename?: 'Tag', id: number, name: string, tagClassId: number, tagClass: { __typename?: 'TagClass', id: number, name: string } } }> | null, firmXImpact?: Array<{ __typename?: 'FirmXImpact', firmId: number, impactEnumId: number, impactEnum: { __typename?: 'ImpactEnum', id: number, name: string } }> | null, impactTags?: Array<{ __typename?: 'ImpactEnum', id: number, name: string }> | null, firmEmployments?: Array<{ __typename?: 'FirmEmployment', id: number, firmId: number, personId: number, employeeRoleEnumId?: number | null, contactTypeEnumId?: number | null, leftInd?: boolean | null, leftDate?: string | null, leftReason?: string | null, authToTrade?: boolean | null, outsideAffil?: boolean | null, startDate?: string | null, jobDesc?: string | null, focusStrategyEnumId?: number | null, dataContact?: boolean | null, isFounder?: boolean | null, isKeyPersonnel?: boolean | null, auditContactTypeEnumId?: number | null, isDataEntryContact?: boolean | null, displayOrder?: number | null, comments?: string | null, person?: { __typename?: 'Person', id: number, firstName?: string | null, lastName: string, middleName?: string | null, email?: string | null, phone?: string | null } | null }> | null } }> } };

export type GetOneCompanyQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneCompanyQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: number, firmId: number, name: string, summary?: string | null, isBusinessApplication: boolean, ndaSigned?: boolean | null, operatingStatusEnumId?: string | null, lastFundingTypeEnumId?: string | null, companyTypeEnumId?: string | null, primaryAssignment?: string | null, operatingStatus?: { __typename?: 'OperatingStatusEnum', id: string, name: string } | null, lastFundingType?: { __typename?: 'FundingTypeEnum', id: string, name?: string | null } | null, companyType?: { __typename?: 'CompanyTypeEnum', id: string, name: string } | null, firmAttributes: { __typename?: 'Firm', id: number, isCompany?: boolean | null, stockSymbol?: string | null, primaryAddressId: number, isStaffMWDBE?: boolean | null, employeeTotal?: number | null, yearFounded?: number | null, email?: string | null, linkedIn?: string | null, website?: string | null, primaryAddress?: { __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, zipCode?: string | null, countryEnumId?: number | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null, website?: string | null } | null, firmTags?: Array<{ __typename?: 'FirmTags', firmId: number, tagId: number, tag: { __typename?: 'Tag', id: number, name: string, tagClassId: number, tagClass: { __typename?: 'TagClass', id: number, name: string } } }> | null, firmXImpact?: Array<{ __typename?: 'FirmXImpact', firmId: number, impactEnumId: number, impactEnum: { __typename?: 'ImpactEnum', id: number, name: string } }> | null, impactTags?: Array<{ __typename?: 'ImpactEnum', id: number, name: string }> | null, firmEmployments?: Array<{ __typename?: 'FirmEmployment', id: number, firmId: number, personId: number, employeeRoleEnumId?: number | null, contactTypeEnumId?: number | null, leftInd?: boolean | null, leftDate?: string | null, leftReason?: string | null, authToTrade?: boolean | null, outsideAffil?: boolean | null, startDate?: string | null, jobDesc?: string | null, focusStrategyEnumId?: number | null, dataContact?: boolean | null, isFounder?: boolean | null, isKeyPersonnel?: boolean | null, auditContactTypeEnumId?: number | null, isDataEntryContact?: boolean | null, displayOrder?: number | null, comments?: string | null, person?: { __typename?: 'Person', id: number, firstName?: string | null, lastName: string, middleName?: string | null, email?: string | null, phone?: string | null } | null }> | null } } | null };

export type GetManyCompanyQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyCompanyQuery = { __typename?: 'Query', companyMany: Array<{ __typename?: 'Company', id: number, firmId: number, name: string, summary?: string | null, isBusinessApplication: boolean, ndaSigned?: boolean | null, operatingStatusEnumId?: string | null, lastFundingTypeEnumId?: string | null, companyTypeEnumId?: string | null, primaryAssignment?: string | null, operatingStatus?: { __typename?: 'OperatingStatusEnum', id: string, name: string } | null, lastFundingType?: { __typename?: 'FundingTypeEnum', id: string, name?: string | null } | null, companyType?: { __typename?: 'CompanyTypeEnum', id: string, name: string } | null, firmAttributes: { __typename?: 'Firm', id: number, isCompany?: boolean | null, stockSymbol?: string | null, primaryAddressId: number, isStaffMWDBE?: boolean | null, employeeTotal?: number | null, yearFounded?: number | null, email?: string | null, linkedIn?: string | null, website?: string | null, primaryAddress?: { __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, zipCode?: string | null, countryEnumId?: number | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null, website?: string | null } | null, firmTags?: Array<{ __typename?: 'FirmTags', firmId: number, tagId: number, tag: { __typename?: 'Tag', id: number, name: string, tagClassId: number, tagClass: { __typename?: 'TagClass', id: number, name: string } } }> | null, firmXImpact?: Array<{ __typename?: 'FirmXImpact', firmId: number, impactEnumId: number, impactEnum: { __typename?: 'ImpactEnum', id: number, name: string } }> | null, impactTags?: Array<{ __typename?: 'ImpactEnum', id: number, name: string }> | null, firmEmployments?: Array<{ __typename?: 'FirmEmployment', id: number, firmId: number, personId: number, employeeRoleEnumId?: number | null, contactTypeEnumId?: number | null, leftInd?: boolean | null, leftDate?: string | null, leftReason?: string | null, authToTrade?: boolean | null, outsideAffil?: boolean | null, startDate?: string | null, jobDesc?: string | null, focusStrategyEnumId?: number | null, dataContact?: boolean | null, isFounder?: boolean | null, isKeyPersonnel?: boolean | null, auditContactTypeEnumId?: number | null, isDataEntryContact?: boolean | null, displayOrder?: number | null, comments?: string | null, person?: { __typename?: 'Person', id: number, firstName?: string | null, lastName: string, middleName?: string | null, email?: string | null, phone?: string | null } | null }> | null } } | null> };

export type CreateCompanyMutationVariables = Exact<{
  input: CompanyInput;
}>;


export type CreateCompanyMutation = { __typename?: 'Mutation', addCompany: { __typename?: 'Company', id: number } };

export type UpdateCompanyMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: CompanyInput;
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', updateCompany: { __typename?: 'Company', id: number } };

export type GetListCompanyEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CompanyEnumSort> | CompanyEnumSort>;
  filter?: InputMaybe<CompanyEnumFilter>;
}>;


export type GetListCompanyEnumQuery = { __typename?: 'Query', companyEnumList: { __typename?: 'CompanyEnumList', total: number, items: Array<{ __typename?: 'CompanyEnum', id: number, name: string }> } };

export type GetOneCompanyEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneCompanyEnumQuery = { __typename?: 'Query', companyEnum?: { __typename?: 'CompanyEnum', id: number, name: string } | null };

export type GetManyCompanyEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyCompanyEnumQuery = { __typename?: 'Query', companyEnumMany: Array<{ __typename?: 'CompanyEnum', id: number, name: string } | null> };

export type GetListCompanyTypeEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CompanyTypeEnumSort> | CompanyTypeEnumSort>;
}>;


export type GetListCompanyTypeEnumQuery = { __typename?: 'Query', companyTypeEnumList: { __typename?: 'CompanyTypeEnumList', total: number, items: Array<{ __typename?: 'CompanyTypeEnum', id: string, name: string }> } };

export type GetOneCompanyTypeEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneCompanyTypeEnumQuery = { __typename?: 'Query', companyTypeEnum: { __typename?: 'CompanyTypeEnum', id: string, name: string } };

export type GetManyCompanyTypeEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyCompanyTypeEnumQuery = { __typename?: 'Query', companyTypeEnumMany: Array<{ __typename?: 'CompanyTypeEnum', id: string, name: string } | null> };

export type CompanyValuationAttributesFragment = { __typename?: 'CompanyValuation', id: number, companyId: number, valuation?: number | null, asOfDate: string };

export type GetListCompanyValuationQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CompanyValuationSort> | CompanyValuationSort>;
  filter?: InputMaybe<CompanyValuationFilter>;
}>;


export type GetListCompanyValuationQuery = { __typename?: 'Query', companyValuationList: { __typename?: 'CompanyValuationList', total: number, items: Array<{ __typename?: 'CompanyValuation', id: number, companyId: number, valuation?: number | null, asOfDate: string }> } };

export type GetOneCompanyValuationQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneCompanyValuationQuery = { __typename?: 'Query', companyValuation?: { __typename?: 'CompanyValuation', id: number, companyId: number, valuation?: number | null, asOfDate: string } | null };

export type GetManyCompanyValuationQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyCompanyValuationQuery = { __typename?: 'Query', companyValuationMany: Array<{ __typename?: 'CompanyValuation', id: number, companyId: number, valuation?: number | null, asOfDate: string } | null> };

export type CreateCompanyValuationMutationVariables = Exact<{
  input: CompanyValuationInput;
}>;


export type CreateCompanyValuationMutation = { __typename?: 'Mutation', addCompanyValuation: { __typename?: 'CompanyValuation', id: number } };

export type UpdateCompanyValuationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: CompanyValuationInput;
}>;


export type UpdateCompanyValuationMutation = { __typename?: 'Mutation', updateCompanyValuation: { __typename?: 'CompanyValuation', id: number } };

export type DeleteCompanyValuationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteCompanyValuationMutation = { __typename?: 'Mutation', deleteCompanyValuation: number };

export type GetListCompoundingPeriodEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CompoundingPeriodEnumSort> | CompoundingPeriodEnumSort>;
}>;


export type GetListCompoundingPeriodEnumQuery = { __typename?: 'Query', compoundingPeriodEnumList: { __typename?: 'CompoundingPeriodEnumList', total: number, items: Array<{ __typename?: 'CompoundingPeriodEnum', id: number, name?: string | null }> } };

export type GetOneCompoundingPeriodEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneCompoundingPeriodEnumQuery = { __typename?: 'Query', compoundingPeriodEnum?: { __typename?: 'CompoundingPeriodEnum', id: number, name?: string | null } | null };

export type GetManyCompoundingPeriodEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyCompoundingPeriodEnumQuery = { __typename?: 'Query', compoundingPeriodEnumMany: Array<{ __typename?: 'CompoundingPeriodEnum', id: number, name?: string | null } | null> };

export type GetListContactTypeEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ContactTypeEnumSort> | ContactTypeEnumSort>;
}>;


export type GetListContactTypeEnumQuery = { __typename?: 'Query', contactTypeEnumList: { __typename?: 'ContactTypeEnumList', total: number, items: Array<{ __typename?: 'ContactTypeEnum', id: number, name?: string | null }> } };

export type GetOneContactTypeEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneContactTypeEnumQuery = { __typename?: 'Query', contactTypeEnum?: { __typename?: 'ContactTypeEnum', id: number, name?: string | null } | null };

export type GetManyContactTypeEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyContactTypeEnumQuery = { __typename?: 'Query', contactTypeEnumMany: Array<{ __typename?: 'ContactTypeEnum', id: number, name?: string | null } | null> };

export type GetListCountryEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CountryEnumSort> | CountryEnumSort>;
  filter?: InputMaybe<CountryEnumFilter>;
}>;


export type GetListCountryEnumQuery = { __typename?: 'Query', countryEnumList: { __typename?: 'CountryEnumList', total: number, items: Array<{ __typename?: 'CountryEnum', id: number, name: string }> } };

export type GetOneCountryEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneCountryEnumQuery = { __typename?: 'Query', countryEnum?: { __typename?: 'CountryEnum', id: number, name: string } | null };

export type GetManyCountryEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyCountryEnumQuery = { __typename?: 'Query', countryEnumMany: Array<{ __typename?: 'CountryEnum', id: number, name: string } | null> };

export type GetListCurrencyDenominationEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CurrencyDenominationEnumSort> | CurrencyDenominationEnumSort>;
  filter?: InputMaybe<CurrencyDenominationEnumFilter>;
}>;


export type GetListCurrencyDenominationEnumQuery = { __typename?: 'Query', currencyDenominationEnumList: { __typename?: 'CurrencyDenominationEnumList', total: number, items: Array<{ __typename?: 'CurrencyDenominationEnum', id: number, name: string }> } };

export type GetOneCurrencyDenominationEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneCurrencyDenominationEnumQuery = { __typename?: 'Query', currencyDenominationEnum?: { __typename?: 'CurrencyDenominationEnum', id: number, name: string } | null };

export type GetManyCurrencyDenominationEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyCurrencyDenominationEnumQuery = { __typename?: 'Query', currencyDenominationEnumMany: Array<{ __typename?: 'CurrencyDenominationEnum', id: number, name: string } | null> };

export type CurrentUserAttributesFragment = { __typename?: 'CurrentUser', id: number, currentUserId: number, isAssumed?: boolean | null, assumedUserId?: number | null, organizationId?: number | null, sub?: string | null, username?: string | null, userName: string, commonName: string, email?: string | null, imageType?: string | null, imageTypeSm?: string | null, entryTypeId: number, organization: { __typename?: 'Organization', id: number, name: string }, flags: { __typename?: 'UserFlags', DCAdmin: boolean, isRockCreek: boolean, isSubscriptionUser: boolean, isRiskUser: boolean, isReportingUser: boolean, isServiceProviderManager: boolean, isDataManager: boolean, businessApplicant: boolean, isSuperUser: boolean, canAssumeUser: boolean, RECFReviewer: boolean, isClientUser: boolean, isPortalUser: boolean, investmentPageAccess: boolean, isClientServicesUser: boolean } };

export type GetOneCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOneCurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'CurrentUser', id: number, currentUserId: number, isAssumed?: boolean | null, assumedUserId?: number | null, organizationId?: number | null, sub?: string | null, username?: string | null, userName: string, commonName: string, email?: string | null, imageType?: string | null, imageTypeSm?: string | null, entryTypeId: number, organization: { __typename?: 'Organization', id: number, name: string }, flags: { __typename?: 'UserFlags', DCAdmin: boolean, isRockCreek: boolean, isSubscriptionUser: boolean, isRiskUser: boolean, isReportingUser: boolean, isServiceProviderManager: boolean, isDataManager: boolean, businessApplicant: boolean, isSuperUser: boolean, canAssumeUser: boolean, RECFReviewer: boolean, isClientUser: boolean, isPortalUser: boolean, investmentPageAccess: boolean, isClientServicesUser: boolean } } };

export type UpdateAssumeUserMutationVariables = Exact<{
  input: AssumeUserInput;
}>;


export type UpdateAssumeUserMutation = { __typename?: 'Mutation', addOrUpdateAssumeUser?: number | null };

export type DeleteAssumeUserMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteAssumeUserMutation = { __typename?: 'Mutation', deleteAssumeUser?: number | null };

export type CustomAnalyticsAttributesFragment = { __typename?: 'CustomAnalytics', id: string, ownerId: number, ownerType: FieldOwnerType, value: any, asOfDate?: string | null, createDate: string, createUser: string, modifyDate: string, modifyUser: string, investment?: { __typename?: 'Investment', id: number, name: string } | null };

export type GetListCustomAnalyticsQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CustomAnalyticsSort> | CustomAnalyticsSort>;
  filter?: InputMaybe<CustomAnalyticsFilter>;
}>;


export type GetListCustomAnalyticsQuery = { __typename?: 'Query', customAnalyticsList: { __typename?: 'CustomAnalyticsList', total: number, items: Array<{ __typename?: 'CustomAnalytics', id: string, ownerId: number, ownerType: FieldOwnerType, value: any, asOfDate?: string | null, createDate: string, createUser: string, modifyDate: string, modifyUser: string, investment?: { __typename?: 'Investment', id: number, name: string } | null }> } };

export type GetOneCustomAnalyticsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetOneCustomAnalyticsQuery = { __typename?: 'Query', customAnalytics: { __typename?: 'CustomAnalytics', id: string, ownerId: number, ownerType: FieldOwnerType, value: any, asOfDate?: string | null, createDate: string, createUser: string, modifyDate: string, modifyUser: string, investment?: { __typename?: 'Investment', id: number, name: string } | null } };

export type CreateCustomAnalyticsMutationVariables = Exact<{
  input: CustomAnalyticsInput;
}>;


export type CreateCustomAnalyticsMutation = { __typename?: 'Mutation', addCustomAnalytics: { __typename?: 'CustomAnalytics', id: string } };

export type UpdateCustomAnalyticsMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: CustomAnalyticsInput;
}>;


export type UpdateCustomAnalyticsMutation = { __typename?: 'Mutation', updateCustomAnalytics: { __typename?: 'CustomAnalytics', id: string } };

export type CustomIndexTermAttributesFragment = { __typename?: 'CustomIndexTerm', id: number, inputInvestmentId: number, multiplierFactor: number, additionFactor: number, additionFactorAfter: number, laggedMonths: number, groupId: number };

export type CustomIndexGroupAttributesFragment = { __typename?: 'CustomIndexGroup', id: number, geReturnDate?: string | null, leReturnDate?: string | null, terms: { __typename?: 'CustomIndexTermList', items: Array<{ __typename?: 'CustomIndexTerm', id: number, inputInvestmentId: number, multiplierFactor: number, additionFactor: number, additionFactorAfter: number, laggedMonths: number, groupId: number }> } };

export type CustomIndexInvestmentAttributesFragment = { __typename?: 'CustomIndexInvestment', id: number, outputInvestment: { __typename?: 'Investment', name: string } };

export type GetListCustomIndexInvestmentQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CustomIndexInvestmentSort> | CustomIndexInvestmentSort>;
  filter?: InputMaybe<CustomIndexInvestmentFilter>;
}>;


export type GetListCustomIndexInvestmentQuery = { __typename?: 'Query', customIndexInvestmentList: { __typename?: 'CustomIndexInvestmentList', total: number, items: Array<{ __typename?: 'CustomIndexInvestment', id: number, outputInvestment: { __typename?: 'Investment', name: string } }> } };

export type GetOneCustomIndexInvestmentQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneCustomIndexInvestmentQuery = { __typename?: 'Query', customIndexInvestment?: { __typename?: 'CustomIndexInvestment', id: number, groups: { __typename?: 'CustomIndexGroupList', items: Array<{ __typename?: 'CustomIndexGroup', id: number, geReturnDate?: string | null, leReturnDate?: string | null, terms: { __typename?: 'CustomIndexTermList', items: Array<{ __typename?: 'CustomIndexTerm', id: number, inputInvestmentId: number, multiplierFactor: number, additionFactor: number, additionFactorAfter: number, laggedMonths: number, groupId: number }> } }> }, outputInvestment: { __typename?: 'Investment', name: string } } | null };

export type GetManyCustomIndexInvestmentQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyCustomIndexInvestmentQuery = { __typename?: 'Query', customIndexInvestmentMany: Array<{ __typename?: 'CustomIndexInvestment', id: number, groups: { __typename?: 'CustomIndexGroupList', items: Array<{ __typename?: 'CustomIndexGroup', id: number, geReturnDate?: string | null, leReturnDate?: string | null, terms: { __typename?: 'CustomIndexTermList', items: Array<{ __typename?: 'CustomIndexTerm', id: number, inputInvestmentId: number, multiplierFactor: number, additionFactor: number, additionFactorAfter: number, laggedMonths: number, groupId: number }> } }> }, outputInvestment: { __typename?: 'Investment', name: string } } | null> };

export type CreateCustomIndexInvestmentMutationVariables = Exact<{
  input: CustomIndexInvestmentInput;
}>;


export type CreateCustomIndexInvestmentMutation = { __typename?: 'Mutation', addCustomIndexInvestment: { __typename?: 'CustomIndexInvestment', id: number } };

export type UpdateCustomIndexInvestmentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: CustomIndexInvestmentInput;
}>;


export type UpdateCustomIndexInvestmentMutation = { __typename?: 'Mutation', updateCustomIndexInvestment: { __typename?: 'CustomIndexInvestment', id: number } };

export type CustomIndexPreviewAttributesFragment = { __typename?: 'PerformanceMTD', investmentId: number, returnYear: number, returnMonth: number, return?: number | null };

export type GetOneCustomIndexPreviewQueryVariables = Exact<{
  input: CustomIndexInvestmentInput;
}>;


export type GetOneCustomIndexPreviewQuery = { __typename?: 'Query', customIndexPreview: Array<{ __typename?: 'PerformanceMTD', investmentId: number, returnYear: number, returnMonth: number, return?: number | null }> };

export type CogencyLinkAttributesFragment = { __typename?: 'CogencyLink', id: number, cogencyId?: number | null, cogStartDate?: string | null, solovisDataEnabled: boolean, solovisTranStartDate?: string | null };

export type GetOneDataLinksQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneDataLinksQuery = { __typename?: 'Query', investment: { __typename?: 'Investment', id: number, name: string, inceptionDate?: string | null, vintageYear?: number | null, firmId?: number | null, portalSubmitted?: { __typename?: 'PortalSubmitted', migratedAt?: string | null } | null, firm?: { __typename?: 'Firm', id: number, name: string } | null, cogencyLink?: { __typename?: 'CogencyLink', id: number, cogencyId?: number | null, cogStartDate?: string | null, solovisDataEnabled: boolean, solovisTranStartDate?: string | null } | null } };

export type AddOrUpdateCogencyLinkMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: CogencyLinkInput;
}>;


export type AddOrUpdateCogencyLinkMutation = { __typename?: 'Mutation', addOrUpdateCogencyLink: { __typename?: 'CogencyLink', id: number } };

export type DealAttributesFragment = { __typename?: 'Deal', id: number, name?: string | null, companyId?: number | null, firmId: number, fundingRoundEnumId?: string | null, stageEnumId?: string | null, dealMarketingEnumId?: string | null, resultEnumId?: string | null, dateReceived?: string | null, expectedCloseDate?: string | null, roundSize?: number | null, isLeadInvestor?: boolean | null, amount?: number | null, preMoneyValuation?: number | null, passedNote?: string | null, summary?: string | null, isImpact?: boolean | null, headquartersEnumId?: number | null, assetClassEnumId?: number | null, strategyEnumId?: number | null, subStrategyEnumId?: number | null, coInvestors?: string | null, dealStructureEnumId?: string | null, rcSource?: string | null, source?: string | null, dealGroupId?: number | null, company?: { __typename?: 'Company', id: number, name: string, firmAttributes: { __typename?: 'Firm', id: number, firmTags?: Array<{ __typename?: 'FirmTags', firmId: number, tagId: number, tag: { __typename?: 'Tag', id: number, name: string, tagClassId: number, tagClass: { __typename?: 'TagClass', id: number, name: string } } }> | null } } | null, dealTags: Array<{ __typename?: 'DealTags', dealId: number, tagId: number, tag: { __typename?: 'Tag', id: number, name: string, tagClassId: number, tagClass: { __typename?: 'TagClass', id: number, name: string } } }>, firm?: { __typename?: 'Firm', id: number, name: string } | null, fundingRound?: { __typename?: 'FundingTypeEnum', id: string, name?: string | null } | null, stage?: { __typename?: 'StageEnum', id: string, name: string } | null, dealMarketing?: { __typename?: 'DealMarketingEnum', id: string, name: string } | null, result?: { __typename?: 'ResultEnum', id: number, name: string } | null, headquarters?: { __typename?: 'CountryEnum', id: number, name: string } | null, assetClass?: { __typename?: 'AssetClass2Enum', id: number, name: string } | null, strategy?: { __typename?: 'StrategyEnum', id: number, name: string } | null, subStrategy?: { __typename?: 'SubStrategyEnum', id: number, name: string } | null, dealStructure?: { __typename?: 'DealStructureEnum', id: string, name: string } | null, rcSourceUser?: { __typename?: 'InvestmentAssignmentOption', id: string, commonName: string } | null };

export type GetListDealQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DealSort> | DealSort>;
  filter?: InputMaybe<DealFilter>;
}>;


export type GetListDealQuery = { __typename?: 'Query', dealList: { __typename?: 'DealList', total: number, items: Array<{ __typename?: 'Deal', id: number, name?: string | null, companyId?: number | null, firmId: number, fundingRoundEnumId?: string | null, stageEnumId?: string | null, dealMarketingEnumId?: string | null, resultEnumId?: string | null, dateReceived?: string | null, expectedCloseDate?: string | null, roundSize?: number | null, isLeadInvestor?: boolean | null, amount?: number | null, preMoneyValuation?: number | null, passedNote?: string | null, summary?: string | null, isImpact?: boolean | null, headquartersEnumId?: number | null, assetClassEnumId?: number | null, strategyEnumId?: number | null, subStrategyEnumId?: number | null, coInvestors?: string | null, dealStructureEnumId?: string | null, rcSource?: string | null, source?: string | null, dealGroupId?: number | null, company?: { __typename?: 'Company', id: number, name: string, firmAttributes: { __typename?: 'Firm', id: number, firmTags?: Array<{ __typename?: 'FirmTags', firmId: number, tagId: number, tag: { __typename?: 'Tag', id: number, name: string, tagClassId: number, tagClass: { __typename?: 'TagClass', id: number, name: string } } }> | null } } | null, dealTags: Array<{ __typename?: 'DealTags', dealId: number, tagId: number, tag: { __typename?: 'Tag', id: number, name: string, tagClassId: number, tagClass: { __typename?: 'TagClass', id: number, name: string } } }>, firm?: { __typename?: 'Firm', id: number, name: string } | null, fundingRound?: { __typename?: 'FundingTypeEnum', id: string, name?: string | null } | null, stage?: { __typename?: 'StageEnum', id: string, name: string } | null, dealMarketing?: { __typename?: 'DealMarketingEnum', id: string, name: string } | null, result?: { __typename?: 'ResultEnum', id: number, name: string } | null, headquarters?: { __typename?: 'CountryEnum', id: number, name: string } | null, assetClass?: { __typename?: 'AssetClass2Enum', id: number, name: string } | null, strategy?: { __typename?: 'StrategyEnum', id: number, name: string } | null, subStrategy?: { __typename?: 'SubStrategyEnum', id: number, name: string } | null, dealStructure?: { __typename?: 'DealStructureEnum', id: string, name: string } | null, rcSourceUser?: { __typename?: 'InvestmentAssignmentOption', id: string, commonName: string } | null }> } };

export type GetOneDealQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneDealQuery = { __typename?: 'Query', deal?: { __typename?: 'Deal', id: number, name?: string | null, companyId?: number | null, firmId: number, fundingRoundEnumId?: string | null, stageEnumId?: string | null, dealMarketingEnumId?: string | null, resultEnumId?: string | null, dateReceived?: string | null, expectedCloseDate?: string | null, roundSize?: number | null, isLeadInvestor?: boolean | null, amount?: number | null, preMoneyValuation?: number | null, passedNote?: string | null, summary?: string | null, isImpact?: boolean | null, headquartersEnumId?: number | null, assetClassEnumId?: number | null, strategyEnumId?: number | null, subStrategyEnumId?: number | null, coInvestors?: string | null, dealStructureEnumId?: string | null, rcSource?: string | null, source?: string | null, dealGroupId?: number | null, company?: { __typename?: 'Company', id: number, name: string, firmAttributes: { __typename?: 'Firm', id: number, firmTags?: Array<{ __typename?: 'FirmTags', firmId: number, tagId: number, tag: { __typename?: 'Tag', id: number, name: string, tagClassId: number, tagClass: { __typename?: 'TagClass', id: number, name: string } } }> | null } } | null, dealTags: Array<{ __typename?: 'DealTags', dealId: number, tagId: number, tag: { __typename?: 'Tag', id: number, name: string, tagClassId: number, tagClass: { __typename?: 'TagClass', id: number, name: string } } }>, firm?: { __typename?: 'Firm', id: number, name: string } | null, fundingRound?: { __typename?: 'FundingTypeEnum', id: string, name?: string | null } | null, stage?: { __typename?: 'StageEnum', id: string, name: string } | null, dealMarketing?: { __typename?: 'DealMarketingEnum', id: string, name: string } | null, result?: { __typename?: 'ResultEnum', id: number, name: string } | null, headquarters?: { __typename?: 'CountryEnum', id: number, name: string } | null, assetClass?: { __typename?: 'AssetClass2Enum', id: number, name: string } | null, strategy?: { __typename?: 'StrategyEnum', id: number, name: string } | null, subStrategy?: { __typename?: 'SubStrategyEnum', id: number, name: string } | null, dealStructure?: { __typename?: 'DealStructureEnum', id: string, name: string } | null, rcSourceUser?: { __typename?: 'InvestmentAssignmentOption', id: string, commonName: string } | null } | null };

export type GetManyDealQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyDealQuery = { __typename?: 'Query', dealMany: Array<{ __typename?: 'Deal', id: number, name?: string | null, companyId?: number | null, firmId: number, fundingRoundEnumId?: string | null, stageEnumId?: string | null, dealMarketingEnumId?: string | null, resultEnumId?: string | null, dateReceived?: string | null, expectedCloseDate?: string | null, roundSize?: number | null, isLeadInvestor?: boolean | null, amount?: number | null, preMoneyValuation?: number | null, passedNote?: string | null, summary?: string | null, isImpact?: boolean | null, headquartersEnumId?: number | null, assetClassEnumId?: number | null, strategyEnumId?: number | null, subStrategyEnumId?: number | null, coInvestors?: string | null, dealStructureEnumId?: string | null, rcSource?: string | null, source?: string | null, dealGroupId?: number | null, company?: { __typename?: 'Company', id: number, name: string, firmAttributes: { __typename?: 'Firm', id: number, firmTags?: Array<{ __typename?: 'FirmTags', firmId: number, tagId: number, tag: { __typename?: 'Tag', id: number, name: string, tagClassId: number, tagClass: { __typename?: 'TagClass', id: number, name: string } } }> | null } } | null, dealTags: Array<{ __typename?: 'DealTags', dealId: number, tagId: number, tag: { __typename?: 'Tag', id: number, name: string, tagClassId: number, tagClass: { __typename?: 'TagClass', id: number, name: string } } }>, firm?: { __typename?: 'Firm', id: number, name: string } | null, fundingRound?: { __typename?: 'FundingTypeEnum', id: string, name?: string | null } | null, stage?: { __typename?: 'StageEnum', id: string, name: string } | null, dealMarketing?: { __typename?: 'DealMarketingEnum', id: string, name: string } | null, result?: { __typename?: 'ResultEnum', id: number, name: string } | null, headquarters?: { __typename?: 'CountryEnum', id: number, name: string } | null, assetClass?: { __typename?: 'AssetClass2Enum', id: number, name: string } | null, strategy?: { __typename?: 'StrategyEnum', id: number, name: string } | null, subStrategy?: { __typename?: 'SubStrategyEnum', id: number, name: string } | null, dealStructure?: { __typename?: 'DealStructureEnum', id: string, name: string } | null, rcSourceUser?: { __typename?: 'InvestmentAssignmentOption', id: string, commonName: string } | null } | null> };

export type CreateDealMutationVariables = Exact<{
  input: DealInput;
}>;


export type CreateDealMutation = { __typename?: 'Mutation', addDeal: { __typename?: 'Deal', id: number, name?: string | null, companyId?: number | null, firmId: number, fundingRoundEnumId?: string | null, stageEnumId?: string | null, dealMarketingEnumId?: string | null, resultEnumId?: string | null, dateReceived?: string | null, expectedCloseDate?: string | null, roundSize?: number | null, isLeadInvestor?: boolean | null, amount?: number | null, preMoneyValuation?: number | null, passedNote?: string | null, summary?: string | null, isImpact?: boolean | null, headquartersEnumId?: number | null, assetClassEnumId?: number | null, strategyEnumId?: number | null, subStrategyEnumId?: number | null, coInvestors?: string | null, dealStructureEnumId?: string | null, rcSource?: string | null, source?: string | null, dealGroupId?: number | null, company?: { __typename?: 'Company', id: number, name: string, firmAttributes: { __typename?: 'Firm', id: number, firmTags?: Array<{ __typename?: 'FirmTags', firmId: number, tagId: number, tag: { __typename?: 'Tag', id: number, name: string, tagClassId: number, tagClass: { __typename?: 'TagClass', id: number, name: string } } }> | null } } | null, dealTags: Array<{ __typename?: 'DealTags', dealId: number, tagId: number, tag: { __typename?: 'Tag', id: number, name: string, tagClassId: number, tagClass: { __typename?: 'TagClass', id: number, name: string } } }>, firm?: { __typename?: 'Firm', id: number, name: string } | null, fundingRound?: { __typename?: 'FundingTypeEnum', id: string, name?: string | null } | null, stage?: { __typename?: 'StageEnum', id: string, name: string } | null, dealMarketing?: { __typename?: 'DealMarketingEnum', id: string, name: string } | null, result?: { __typename?: 'ResultEnum', id: number, name: string } | null, headquarters?: { __typename?: 'CountryEnum', id: number, name: string } | null, assetClass?: { __typename?: 'AssetClass2Enum', id: number, name: string } | null, strategy?: { __typename?: 'StrategyEnum', id: number, name: string } | null, subStrategy?: { __typename?: 'SubStrategyEnum', id: number, name: string } | null, dealStructure?: { __typename?: 'DealStructureEnum', id: string, name: string } | null, rcSourceUser?: { __typename?: 'InvestmentAssignmentOption', id: string, commonName: string } | null } };

export type UpdateDealMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: DealInput;
}>;


export type UpdateDealMutation = { __typename?: 'Mutation', updateDeal: { __typename?: 'Deal', id: number, name?: string | null, companyId?: number | null, firmId: number, fundingRoundEnumId?: string | null, stageEnumId?: string | null, dealMarketingEnumId?: string | null, resultEnumId?: string | null, dateReceived?: string | null, expectedCloseDate?: string | null, roundSize?: number | null, isLeadInvestor?: boolean | null, amount?: number | null, preMoneyValuation?: number | null, passedNote?: string | null, summary?: string | null, isImpact?: boolean | null, headquartersEnumId?: number | null, assetClassEnumId?: number | null, strategyEnumId?: number | null, subStrategyEnumId?: number | null, coInvestors?: string | null, dealStructureEnumId?: string | null, rcSource?: string | null, source?: string | null, dealGroupId?: number | null, company?: { __typename?: 'Company', id: number, name: string, firmAttributes: { __typename?: 'Firm', id: number, firmTags?: Array<{ __typename?: 'FirmTags', firmId: number, tagId: number, tag: { __typename?: 'Tag', id: number, name: string, tagClassId: number, tagClass: { __typename?: 'TagClass', id: number, name: string } } }> | null } } | null, dealTags: Array<{ __typename?: 'DealTags', dealId: number, tagId: number, tag: { __typename?: 'Tag', id: number, name: string, tagClassId: number, tagClass: { __typename?: 'TagClass', id: number, name: string } } }>, firm?: { __typename?: 'Firm', id: number, name: string } | null, fundingRound?: { __typename?: 'FundingTypeEnum', id: string, name?: string | null } | null, stage?: { __typename?: 'StageEnum', id: string, name: string } | null, dealMarketing?: { __typename?: 'DealMarketingEnum', id: string, name: string } | null, result?: { __typename?: 'ResultEnum', id: number, name: string } | null, headquarters?: { __typename?: 'CountryEnum', id: number, name: string } | null, assetClass?: { __typename?: 'AssetClass2Enum', id: number, name: string } | null, strategy?: { __typename?: 'StrategyEnum', id: number, name: string } | null, subStrategy?: { __typename?: 'SubStrategyEnum', id: number, name: string } | null, dealStructure?: { __typename?: 'DealStructureEnum', id: string, name: string } | null, rcSourceUser?: { __typename?: 'InvestmentAssignmentOption', id: string, commonName: string } | null } };

export type GetListDealFilterOptionsQueryVariables = Exact<{
  filter?: InputMaybe<DealFilter>;
}>;


export type GetListDealFilterOptionsQuery = { __typename?: 'Query', dealAvailableFilterOptions: { __typename?: 'DealFilterOptions', rcSourceOptions?: Array<string> | null, headQuarterOptions?: Array<{ __typename?: 'CountryEnum', id: number, name: string }> | null, fundingTypeOptions?: Array<{ __typename?: 'FundingTypeEnum', id: string, name?: string | null }> | null, dealStructureOptions?: Array<{ __typename?: 'DealStructureEnum', id: string, name: string }> | null, stageOptions?: Array<{ __typename?: 'StageEnum', id: string, name: string, displayOrder: number }> | null, dealMarketingOptions?: Array<{ __typename?: 'DealMarketingEnum', id: string, name: string, displayOrder: number }> | null, resultOptions?: Array<{ __typename?: 'ResultEnum', id: number, name: string }> | null, assetClassOptions?: Array<{ __typename?: 'AssetClass2Enum', id: number, name: string }> | null } };

export type GetListDealMarketingEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DealMarketingEnumSort> | DealMarketingEnumSort>;
}>;


export type GetListDealMarketingEnumQuery = { __typename?: 'Query', dealMarketingEnumList: { __typename?: 'DealMarketingEnumList', total: number, items: Array<{ __typename?: 'DealMarketingEnum', id: string, name: string }> } };

export type GetOneDealMarketingEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneDealMarketingEnumQuery = { __typename?: 'Query', dealMarketingEnum?: { __typename?: 'DealMarketingEnum', id: string, name: string } | null };

export type GetManyDealMarketingEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyDealMarketingEnumQuery = { __typename?: 'Query', dealMarketingEnumMany: Array<{ __typename?: 'DealMarketingEnum', id: string, name: string } | null> };

export type GetListDealStructureEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DealStructureEnumSort> | DealStructureEnumSort>;
}>;


export type GetListDealStructureEnumQuery = { __typename?: 'Query', dealStructureEnumList: { __typename?: 'DealStructureEnumList', total: number, items: Array<{ __typename?: 'DealStructureEnum', id: string, name: string }> } };

export type GetOneDealStructureEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneDealStructureEnumQuery = { __typename?: 'Query', dealStructureEnum?: { __typename?: 'DealStructureEnum', id: string, name: string } | null };

export type GetManyDealStructureEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyDealStructureEnumQuery = { __typename?: 'Query', dealStructureEnumMany: Array<{ __typename?: 'DealStructureEnum', id: string, name: string } | null> };

export type GetListDegreeEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DegreeEnumSort> | DegreeEnumSort>;
}>;


export type GetListDegreeEnumQuery = { __typename?: 'Query', degreeEnumList: { __typename?: 'DegreeEnumList', total: number, items: Array<{ __typename?: 'DegreeEnum', id: number, name?: string | null }> } };

export type GetOneDegreeEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneDegreeEnumQuery = { __typename?: 'Query', degreeEnum?: { __typename?: 'DegreeEnum', id: number, name?: string | null } | null };

export type GetManyDegreeEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyDegreeEnumQuery = { __typename?: 'Query', degreeEnumMany: Array<{ __typename?: 'DegreeEnum', id: number, name?: string | null } | null> };

export type GetListDeiCategory1EnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DeiCategory1EnumSort> | DeiCategory1EnumSort>;
}>;


export type GetListDeiCategory1EnumQuery = { __typename?: 'Query', deiCategory1EnumList: { __typename?: 'DeiCategory1EnumList', total: number, items: Array<{ __typename?: 'DeiCategory1Enum', id: number, description: string }> } };

export type GetOneDeiCategory1EnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneDeiCategory1EnumQuery = { __typename?: 'Query', deiCategory1Enum?: { __typename?: 'DeiCategory1Enum', id: number, description: string } | null };

export type GetManyDeiCategory1EnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyDeiCategory1EnumQuery = { __typename?: 'Query', deiCategory1EnumMany: Array<{ __typename?: 'DeiCategory1Enum', id: number, description: string } | null> };

export type GetListDeiCategory2EnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DeiCategory2EnumSort> | DeiCategory2EnumSort>;
}>;


export type GetListDeiCategory2EnumQuery = { __typename?: 'Query', deiCategory2EnumList: { __typename?: 'DeiCategory2EnumList', total: number, items: Array<{ __typename?: 'DeiCategory2Enum', id: number, description: string }> } };

export type GetOneDeiCategory2EnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneDeiCategory2EnumQuery = { __typename?: 'Query', deiCategory2Enum?: { __typename?: 'DeiCategory2Enum', id: number, description: string } | null };

export type GetManyDeiCategory2EnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyDeiCategory2EnumQuery = { __typename?: 'Query', deiCategory2EnumMany: Array<{ __typename?: 'DeiCategory2Enum', id: number, description: string } | null> };

export type GetListDiversityStatsEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DiversityStatsEnumSort> | DiversityStatsEnumSort>;
}>;


export type GetListDiversityStatsEnumQuery = { __typename?: 'Query', diversityStatsEnumList: { __typename?: 'DiversityStatsEnumList', total: number, items: Array<{ __typename?: 'DiversityStatsEnum', id: string, value?: string | null }> } };

export type GetOneDiversityStatsEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneDiversityStatsEnumQuery = { __typename?: 'Query', diversityStatsEnum?: { __typename?: 'DiversityStatsEnum', id: string, value?: string | null } | null };

export type GetManyDiversityStatsEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyDiversityStatsEnumQuery = { __typename?: 'Query', diversityStatsEnumMany: Array<{ __typename?: 'DiversityStatsEnum', id: string, value?: string | null } | null> };

export type DocumentAttributesFragment = { __typename?: 'Document', id: number, name: string, date: string, digest: string, signedUrl?: string | null, signedThumbnailUrl?: string | null, documentTypeEnumId: number, accessLevel: number, isGallery?: boolean | null, isApproved?: boolean | null, notifyUsers?: boolean | null, entityAssociations: Array<{ __typename?: 'DocumentXEntity', id: number, businessObjectTypeEnumId: number, entityId: number, entityName?: string | null }>, documentTypeEnum: { __typename?: 'DocumentTypeEnum', id: number, name: string, documentCategoryEnumId?: number | null }, documentAccessLevel: { __typename?: 'DocumentAccessLevel', id: number, name: string } };

export type GetDocumentsListQueryVariables = Exact<{
  filter?: InputMaybe<DocumentFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DocumentSort> | DocumentSort>;
}>;


export type GetDocumentsListQuery = { __typename?: 'Query', documents: { __typename?: 'DocumentList', total: number, items: Array<{ __typename?: 'Document', id: number, name: string, date: string, digest: string, signedUrl?: string | null, signedThumbnailUrl?: string | null, documentTypeEnumId: number, accessLevel: number, isGallery?: boolean | null, isApproved?: boolean | null, notifyUsers?: boolean | null, entityAssociations: Array<{ __typename?: 'DocumentXEntity', id: number, businessObjectTypeEnumId: number, entityId: number, entityName?: string | null }>, documentTypeEnum: { __typename?: 'DocumentTypeEnum', id: number, name: string, documentCategoryEnumId?: number | null }, documentAccessLevel: { __typename?: 'DocumentAccessLevel', id: number, name: string } }> } };

export type GetOneDocumentQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneDocumentQuery = { __typename?: 'Query', document?: { __typename?: 'Document', id: number, name: string, date: string, digest: string, signedUrl?: string | null, signedThumbnailUrl?: string | null, documentTypeEnumId: number, accessLevel: number, isGallery?: boolean | null, isApproved?: boolean | null, notifyUsers?: boolean | null, entityAssociations: Array<{ __typename?: 'DocumentXEntity', id: number, businessObjectTypeEnumId: number, entityId: number, entityName?: string | null }>, documentTypeEnum: { __typename?: 'DocumentTypeEnum', id: number, name: string, documentCategoryEnumId?: number | null }, documentAccessLevel: { __typename?: 'DocumentAccessLevel', id: number, name: string } } | null };

export type UpdateDocumentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  file?: InputMaybe<Scalars['Upload']['input']>;
  documentTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  accessLevel?: InputMaybe<Scalars['Int']['input']>;
  isGallery?: InputMaybe<Scalars['Boolean']['input']>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  notifyUsers?: InputMaybe<Scalars['Boolean']['input']>;
  entities?: InputMaybe<Array<EntityAssociationInput> | EntityAssociationInput>;
  allowDuplicateFile?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateDocumentMutation = { __typename?: 'Mutation', updateDocument: { __typename?: 'Document', id: number } };

export type AddDocumentMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  documentTypeEnumId: Scalars['Int']['input'];
  date: Scalars['Date']['input'];
  accessLevel?: InputMaybe<Scalars['Int']['input']>;
  isGallery?: InputMaybe<Scalars['Boolean']['input']>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  notifyUsers?: InputMaybe<Scalars['Boolean']['input']>;
  entities?: InputMaybe<Array<EntityAssociationInput> | EntityAssociationInput>;
  allowDuplicateFile?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AddDocumentMutation = { __typename?: 'Mutation', addDocument?: { __typename?: 'Document', id: number } | null };

export type DeleteDocumentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteDocumentMutation = { __typename?: 'Mutation', deleteDocument: number };

export type GetListDocumentAccessLevelQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DocumentAccessLevelSort> | DocumentAccessLevelSort>;
}>;


export type GetListDocumentAccessLevelQuery = { __typename?: 'Query', documentAccessLevelList: { __typename?: 'DocumentAccessLevelList', total: number, items: Array<{ __typename?: 'DocumentAccessLevel', id: number, name: string }> } };

export type GetOneDocumentAccessLevelQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneDocumentAccessLevelQuery = { __typename?: 'Query', documentAccessLevel?: { __typename?: 'DocumentAccessLevel', id: number, name: string } | null };

export type GetManyDocumentAccessLevelQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyDocumentAccessLevelQuery = { __typename?: 'Query', documentAccessLevelMany: Array<{ __typename?: 'DocumentAccessLevel', id: number, name: string } | null> };

export type AddDocumentQueueSignedUriMutationVariables = Exact<{
  names: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AddDocumentQueueSignedUriMutation = { __typename?: 'Mutation', addDocumentQueueSignedURI: Array<{ __typename?: 'DocumentQueue', url?: string | null, documentQueueId: string }> };

export type ProcessDocumentQueueMutationVariables = Exact<{
  queueId: Scalars['ID']['input'];
}>;


export type ProcessDocumentQueueMutation = { __typename?: 'Mutation', processDocumentQueue: string };

export type PublishDocumentQueuesMutationVariables = Exact<{
  input: Array<DocumentQueuePublishInput> | DocumentQueuePublishInput;
}>;


export type PublishDocumentQueuesMutation = { __typename?: 'Mutation', publishDocumentQueues: Array<{ __typename?: 'DocumentPublishResult', documentQueueId: string, success: boolean, documentId?: number | null, documentName?: string | null, error?: string | null }> };

export type GetDocumentQueueListQueryVariables = Exact<{
  filter?: InputMaybe<DocumentQueueFilter>;
  sort?: InputMaybe<Array<DocumentQueueSort> | DocumentQueueSort>;
  page?: InputMaybe<PageInput>;
}>;


export type GetDocumentQueueListQuery = { __typename?: 'Query', documentQueueList: { __typename?: 'DocumentQueueList', total: number, items: Array<{ __typename?: 'DocumentQueue', id: string, name: string, userId: number, queueDate: string, documentsId?: number | null, s3Bucket: string, s3Key: string, hash?: string | null, llmEntityId?: number | null, llmEntityNotes?: string | null, llmEntityTypeId?: number | null, llmEntityTypeNotes?: string | null, llmAsOfDate?: string | null, llmAsOfDateNotes?: string | null, llmDocumentTypeEnumId?: number | null, llmDocumentTypeEnumNotes?: string | null, llmSuggestedName?: string | null, llmSuggestedNameNotes?: string | null, llmProcessedAt?: string | null, duplicateDocuments?: Array<{ __typename?: 'Document', id: number }> | null, emailMaps: Array<{ __typename?: 'DocumentQueueEmailMap', id: string, emailMetadata: { __typename?: 'EmailMetadata', subject?: string | null, id: string, fromAddress?: string | null, toAddress?: string | null, receivedDate?: string | null } }> }> } };

export type GetOneDocumentQueueQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOneDocumentQueueQuery = { __typename?: 'Query', documentQueue?: { __typename?: 'DocumentQueue', id: string, name: string, userId: number, queueDate: string, documentsId?: number | null, hash?: string | null, llmEntityId?: number | null, llmEntityNotes?: string | null, llmEntityTypeId?: number | null, llmEntityTypeNotes?: string | null, llmAsOfDate?: string | null, llmAsOfDateNotes?: string | null, llmDocumentTypeEnumId?: number | null, llmDocumentTypeEnumNotes?: string | null, llmSuggestedName?: string | null, llmSuggestedNameNotes?: string | null, llmProcessedAt?: string | null, emailMaps: Array<{ __typename?: 'DocumentQueueEmailMap', id: string, emailMetadata: { __typename?: 'EmailMetadata', subject?: string | null, id: string, fromAddress?: string | null, toAddress?: string | null } }> } | null };

export type TransferToDocumentsMutationVariables = Exact<{
  input: Array<DocumentQueuePublishInput> | DocumentQueuePublishInput;
}>;


export type TransferToDocumentsMutation = { __typename?: 'Mutation', publishDocumentQueues: Array<{ __typename?: 'DocumentPublishResult', documentQueueId: string, success: boolean, documentId?: number | null, error?: string | null }> };

export type DeleteDocumentQueueMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteDocumentQueueMutation = { __typename?: 'Mutation', deleteDocumentQueue: string };

export type GetDocumentTypeEnumListQueryVariables = Exact<{
  sort?: InputMaybe<Array<DocumentTypeEnumSort> | DocumentTypeEnumSort>;
  filter?: InputMaybe<DocumentTypeEnumFilter>;
}>;


export type GetDocumentTypeEnumListQuery = { __typename?: 'Query', documentTypeEnumList: { __typename?: 'DocumentTypeEnumList', total: number, items: Array<{ __typename?: 'DocumentTypeEnum', id: number, name: string, documentCategoryEnumId?: number | null }> } };

export type GetDocumentTypeEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetDocumentTypeEnumQuery = { __typename?: 'Query', documentTypeEnum?: { __typename?: 'DocumentTypeEnum', id: number, name: string, documentCategoryEnumId?: number | null } | null };

export type DocumentTypeSuggestionQueryVariables = Exact<{
  text: Scalars['String']['input'];
}>;


export type DocumentTypeSuggestionQuery = { __typename?: 'Query', documentTypeSuggestion: number };

export type EmailDomainXOrganizationAttributesFragment = { __typename?: 'EmailDomainXOrganization', id: number, emailDomain: string, organizationId: number, organization: { __typename?: 'Organization', id: number, name: string } };

export type GetListEmailDomainXOrganizationQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<EmailDomainXOrganizationSort> | EmailDomainXOrganizationSort>;
  filter?: InputMaybe<EmailDomainXOrganizationFilter>;
}>;


export type GetListEmailDomainXOrganizationQuery = { __typename?: 'Query', emailDomainXOrganizationList: { __typename?: 'EmailDomainXOrganizationList', total: number, items: Array<{ __typename?: 'EmailDomainXOrganization', id: number, emailDomain: string, organizationId: number, organization: { __typename?: 'Organization', id: number, name: string } }> } };

export type GetOneEmailDomainXOrganizationQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneEmailDomainXOrganizationQuery = { __typename?: 'Query', emailDomainXOrganization?: { __typename?: 'EmailDomainXOrganization', id: number, emailDomain: string, organizationId: number, organization: { __typename?: 'Organization', id: number, name: string } } | null };

export type GetManyEmailDomainXOrganizationQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyEmailDomainXOrganizationQuery = { __typename?: 'Query', emailDomainXOrganizationMany: Array<{ __typename?: 'EmailDomainXOrganization', id: number, emailDomain: string, organizationId: number, organization: { __typename?: 'Organization', id: number, name: string } } | null> };

export type CreateEmailDomainXOrganizationMutationVariables = Exact<{
  input: EmailDomainXOrganizationInput;
}>;


export type CreateEmailDomainXOrganizationMutation = { __typename?: 'Mutation', addEmailDomainXOrganization: { __typename?: 'EmailDomainXOrganization', id: number, emailDomain: string, organizationId: number, organization: { __typename?: 'Organization', id: number, name: string } } };

export type UpdateEmailDomainXOrganizationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: EmailDomainXOrganizationInput;
}>;


export type UpdateEmailDomainXOrganizationMutation = { __typename?: 'Mutation', updateEmailDomainXOrganization: { __typename?: 'EmailDomainXOrganization', id: number, emailDomain: string, organizationId: number, organization: { __typename?: 'Organization', id: number, name: string } } };

export type DeleteEmailDomainXOrganizationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteEmailDomainXOrganizationMutation = { __typename?: 'Mutation', deleteEmailDomainXOrganization: number };

export type GetListEmployeeRoleEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<EmployeeRoleEnumSort> | EmployeeRoleEnumSort>;
  filter?: InputMaybe<EmployeeRoleEnumFilter>;
}>;


export type GetListEmployeeRoleEnumQuery = { __typename?: 'Query', employeeRoleEnumList: { __typename?: 'EmployeeRoleEnumList', total: number, items: Array<{ __typename?: 'EmployeeRoleEnum', id: number, name: string }> } };

export type GetOneEmployeeRoleEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneEmployeeRoleEnumQuery = { __typename?: 'Query', employeeRoleEnum?: { __typename?: 'EmployeeRoleEnum', id: number, name: string } | null };

export type GetManyEmployeeRoleEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyEmployeeRoleEnumQuery = { __typename?: 'Query', employeeRoleEnumMany: Array<{ __typename?: 'EmployeeRoleEnum', id: number, name: string } | null> };

export type GetListFamilyQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FamilySort> | FamilySort>;
  filter?: InputMaybe<FamilyFilterInput>;
}>;


export type GetListFamilyQuery = { __typename?: 'Query', familyList: { __typename?: 'FamilyList', total: number, items: Array<{ __typename?: 'Family', id: number, name: string, firmId: number, firm: { __typename?: 'Firm', id: number, name: string }, investmentsFamily: Array<{ __typename?: 'InvestmentsFamily', id: number, familyId: number, investmentId: number, family: { __typename?: 'Family', id: number, name: string, firmId: number }, investment?: { __typename?: 'InvestmentFamilyInvestment', id: number, name: string, firmId: number } | null }> }> } };

export type GetOneFamilyQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneFamilyQuery = { __typename?: 'Query', family?: { __typename?: 'Family', id: number, name: string, firmId: number, firm: { __typename?: 'Firm', id: number, name: string }, investmentsFamily: Array<{ __typename?: 'InvestmentsFamily', id: number, familyId: number, investmentId: number, family: { __typename?: 'Family', id: number, name: string, firmId: number }, investment?: { __typename?: 'InvestmentFamilyInvestment', id: number, name: string, firmId: number } | null }> } | null };

export type GetManyFamilyQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyFamilyQuery = { __typename?: 'Query', familyMany: Array<{ __typename?: 'Family', id: number, name: string, firmId: number, firm: { __typename?: 'Firm', id: number, name: string }, investmentsFamily: Array<{ __typename?: 'InvestmentsFamily', id: number, familyId: number, investmentId: number, family: { __typename?: 'Family', id: number, name: string, firmId: number }, investment?: { __typename?: 'InvestmentFamilyInvestment', id: number, name: string, firmId: number } | null }> } | null> };

export type GetManyReferenceFamilyQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FamilySort> | FamilySort>;
  filter?: InputMaybe<FamilyFilterInput>;
}>;


export type GetManyReferenceFamilyQuery = { __typename?: 'Query', familyList: { __typename?: 'FamilyList', total: number, items: Array<{ __typename?: 'Family', id: number, name: string, firmId: number, firm: { __typename?: 'Firm', id: number, name: string }, investmentsFamily: Array<{ __typename?: 'InvestmentsFamily', id: number, familyId: number, investmentId: number, family: { __typename?: 'Family', id: number, name: string, firmId: number }, investment?: { __typename?: 'InvestmentFamilyInvestment', id: number, name: string, firmId: number } | null }> }> } };

export type CreateFamilyMutationVariables = Exact<{
  input: FamilyInput;
}>;


export type CreateFamilyMutation = { __typename?: 'Mutation', addFamily: { __typename?: 'Family', id: number } };

export type UpdateFamilyMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: FamilyInput;
}>;


export type UpdateFamilyMutation = { __typename?: 'Mutation', updateFamily: { __typename?: 'Family', id: number } };

export type FdpLoginAttributesFragment = { __typename?: 'FDPLogin', id: number, username: string, password: string, securityQuestion?: string | null, notes?: string | null, email?: string | null, mfaUser?: string | null, imageLink?: string | null, modifyUser?: string | null, modifyDate?: string | null, financialDataProviderId: number, authenticatorEnumId?: number | null, financialDataProvider: { __typename?: 'FinancialDataProvider', id: number, name: string, fdpWebsites: Array<{ __typename?: 'FDPWebsites', id: number, website: string }> }, authenticatorEnum?: { __typename?: 'FDPLoginAuthenticatorEnum', id: number, name: string } | null, firmFDPLogins?: Array<{ __typename?: 'FirmFDPLogins', id: number, firmId: number, fdpLoginId: number, fdpWebsiteId?: number | null, firm: { __typename?: 'Firm', id: number, name: string, isCompany?: boolean | null }, fdpWebsite?: { __typename?: 'FDPWebsites', id: number, website: string, financialDataProviderId: number } | null, investmentFDPLogins?: Array<{ __typename?: 'InvestmentFDPLogins', id: number, fdpLoginId: number, investmentId: number, fdpWebsiteId?: number | null, investment: { __typename?: 'Investment', id: number, name: string }, fdpWebsite?: { __typename?: 'FDPWebsites', id: number, website: string, financialDataProviderId: number } | null }> | null }> | null, portfolioFDPLogins?: Array<{ __typename?: 'PortfolioFDPLogins', id: number, portfolioId: number, fdpLoginId: number, fdpWebsiteId?: number | null, portfolio: { __typename?: 'Investment', id: number, name: string }, fdpWebsite?: { __typename?: 'FDPWebsites', id: number, website: string, financialDataProviderId: number } | null }> | null, investmentFDPLogins?: Array<{ __typename?: 'InvestmentFDPLogins', id: number, fdpLoginId: number, investmentId: number, fdpWebsiteId?: number | null, investment: { __typename?: 'Investment', id: number, name: string }, fdpWebsite?: { __typename?: 'FDPWebsites', id: number, website: string, financialDataProviderId: number } | null }> | null, firms?: Array<{ __typename?: 'Firm', id: number, name: string, isCompany?: boolean | null }> | null, investments?: Array<{ __typename?: 'Investment', id: number, name: string }> | null, portfolios?: Array<{ __typename?: 'Investment', id: number, name: string }> | null };

export type GetListFdpLoginQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FdpLoginSort> | FdpLoginSort>;
  filter?: InputMaybe<FdpLoginFilter>;
}>;


export type GetListFdpLoginQuery = { __typename?: 'Query', fdpLoginList: { __typename?: 'FdpLoginList', total: number, items: Array<{ __typename?: 'FDPLogin', id: number, username: string, password: string, securityQuestion?: string | null, notes?: string | null, email?: string | null, mfaUser?: string | null, imageLink?: string | null, modifyUser?: string | null, modifyDate?: string | null, financialDataProviderId: number, authenticatorEnumId?: number | null, financialDataProvider: { __typename?: 'FinancialDataProvider', id: number, name: string, fdpWebsites: Array<{ __typename?: 'FDPWebsites', id: number, website: string }> }, authenticatorEnum?: { __typename?: 'FDPLoginAuthenticatorEnum', id: number, name: string } | null, firmFDPLogins?: Array<{ __typename?: 'FirmFDPLogins', id: number, firmId: number, fdpLoginId: number, fdpWebsiteId?: number | null, firm: { __typename?: 'Firm', id: number, name: string, isCompany?: boolean | null }, fdpWebsite?: { __typename?: 'FDPWebsites', id: number, website: string, financialDataProviderId: number } | null, investmentFDPLogins?: Array<{ __typename?: 'InvestmentFDPLogins', id: number, fdpLoginId: number, investmentId: number, fdpWebsiteId?: number | null, investment: { __typename?: 'Investment', id: number, name: string }, fdpWebsite?: { __typename?: 'FDPWebsites', id: number, website: string, financialDataProviderId: number } | null }> | null }> | null, portfolioFDPLogins?: Array<{ __typename?: 'PortfolioFDPLogins', id: number, portfolioId: number, fdpLoginId: number, fdpWebsiteId?: number | null, portfolio: { __typename?: 'Investment', id: number, name: string }, fdpWebsite?: { __typename?: 'FDPWebsites', id: number, website: string, financialDataProviderId: number } | null }> | null, investmentFDPLogins?: Array<{ __typename?: 'InvestmentFDPLogins', id: number, fdpLoginId: number, investmentId: number, fdpWebsiteId?: number | null, investment: { __typename?: 'Investment', id: number, name: string }, fdpWebsite?: { __typename?: 'FDPWebsites', id: number, website: string, financialDataProviderId: number } | null }> | null, firms?: Array<{ __typename?: 'Firm', id: number, name: string, isCompany?: boolean | null }> | null, investments?: Array<{ __typename?: 'Investment', id: number, name: string }> | null, portfolios?: Array<{ __typename?: 'Investment', id: number, name: string }> | null }> } };

export type GetOneFdpLoginQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneFdpLoginQuery = { __typename?: 'Query', fdpLogin?: { __typename?: 'FDPLogin', id: number, username: string, password: string, securityQuestion?: string | null, notes?: string | null, email?: string | null, mfaUser?: string | null, imageLink?: string | null, modifyUser?: string | null, modifyDate?: string | null, financialDataProviderId: number, authenticatorEnumId?: number | null, financialDataProvider: { __typename?: 'FinancialDataProvider', id: number, name: string, fdpWebsites: Array<{ __typename?: 'FDPWebsites', id: number, website: string }> }, authenticatorEnum?: { __typename?: 'FDPLoginAuthenticatorEnum', id: number, name: string } | null, firmFDPLogins?: Array<{ __typename?: 'FirmFDPLogins', id: number, firmId: number, fdpLoginId: number, fdpWebsiteId?: number | null, firm: { __typename?: 'Firm', id: number, name: string, isCompany?: boolean | null }, fdpWebsite?: { __typename?: 'FDPWebsites', id: number, website: string, financialDataProviderId: number } | null, investmentFDPLogins?: Array<{ __typename?: 'InvestmentFDPLogins', id: number, fdpLoginId: number, investmentId: number, fdpWebsiteId?: number | null, investment: { __typename?: 'Investment', id: number, name: string }, fdpWebsite?: { __typename?: 'FDPWebsites', id: number, website: string, financialDataProviderId: number } | null }> | null }> | null, portfolioFDPLogins?: Array<{ __typename?: 'PortfolioFDPLogins', id: number, portfolioId: number, fdpLoginId: number, fdpWebsiteId?: number | null, portfolio: { __typename?: 'Investment', id: number, name: string }, fdpWebsite?: { __typename?: 'FDPWebsites', id: number, website: string, financialDataProviderId: number } | null }> | null, investmentFDPLogins?: Array<{ __typename?: 'InvestmentFDPLogins', id: number, fdpLoginId: number, investmentId: number, fdpWebsiteId?: number | null, investment: { __typename?: 'Investment', id: number, name: string }, fdpWebsite?: { __typename?: 'FDPWebsites', id: number, website: string, financialDataProviderId: number } | null }> | null, firms?: Array<{ __typename?: 'Firm', id: number, name: string, isCompany?: boolean | null }> | null, investments?: Array<{ __typename?: 'Investment', id: number, name: string }> | null, portfolios?: Array<{ __typename?: 'Investment', id: number, name: string }> | null } | null };

export type GetManyFdpLoginQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyFdpLoginQuery = { __typename?: 'Query', fdpLoginMany: Array<{ __typename?: 'FDPLogin', id: number, username: string, password: string, securityQuestion?: string | null, notes?: string | null, email?: string | null, mfaUser?: string | null, imageLink?: string | null, modifyUser?: string | null, modifyDate?: string | null, financialDataProviderId: number, authenticatorEnumId?: number | null, financialDataProvider: { __typename?: 'FinancialDataProvider', id: number, name: string, fdpWebsites: Array<{ __typename?: 'FDPWebsites', id: number, website: string }> }, authenticatorEnum?: { __typename?: 'FDPLoginAuthenticatorEnum', id: number, name: string } | null, firmFDPLogins?: Array<{ __typename?: 'FirmFDPLogins', id: number, firmId: number, fdpLoginId: number, fdpWebsiteId?: number | null, firm: { __typename?: 'Firm', id: number, name: string, isCompany?: boolean | null }, fdpWebsite?: { __typename?: 'FDPWebsites', id: number, website: string, financialDataProviderId: number } | null, investmentFDPLogins?: Array<{ __typename?: 'InvestmentFDPLogins', id: number, fdpLoginId: number, investmentId: number, fdpWebsiteId?: number | null, investment: { __typename?: 'Investment', id: number, name: string }, fdpWebsite?: { __typename?: 'FDPWebsites', id: number, website: string, financialDataProviderId: number } | null }> | null }> | null, portfolioFDPLogins?: Array<{ __typename?: 'PortfolioFDPLogins', id: number, portfolioId: number, fdpLoginId: number, fdpWebsiteId?: number | null, portfolio: { __typename?: 'Investment', id: number, name: string }, fdpWebsite?: { __typename?: 'FDPWebsites', id: number, website: string, financialDataProviderId: number } | null }> | null, investmentFDPLogins?: Array<{ __typename?: 'InvestmentFDPLogins', id: number, fdpLoginId: number, investmentId: number, fdpWebsiteId?: number | null, investment: { __typename?: 'Investment', id: number, name: string }, fdpWebsite?: { __typename?: 'FDPWebsites', id: number, website: string, financialDataProviderId: number } | null }> | null, firms?: Array<{ __typename?: 'Firm', id: number, name: string, isCompany?: boolean | null }> | null, investments?: Array<{ __typename?: 'Investment', id: number, name: string }> | null, portfolios?: Array<{ __typename?: 'Investment', id: number, name: string }> | null } | null> };

export type CreateFdpLoginMutationVariables = Exact<{
  input: FdpLoginInput;
}>;


export type CreateFdpLoginMutation = { __typename?: 'Mutation', addFdpLogin: { __typename?: 'FDPLogin', id: number } };

export type UpdateFdpLoginMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: FdpLoginInput;
}>;


export type UpdateFdpLoginMutation = { __typename?: 'Mutation', updateFdpLogin: { __typename?: 'FDPLogin', id: number } };

export type DeleteFdpLoginMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteFdpLoginMutation = { __typename?: 'Mutation', deleteFdpLogin: number };

export type GetListFdpLoginAuthenticatorEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FdpLoginAuthenticatorEnumSort> | FdpLoginAuthenticatorEnumSort>;
}>;


export type GetListFdpLoginAuthenticatorEnumQuery = { __typename?: 'Query', fdpLoginAuthenticatorEnumList: { __typename?: 'FdpLoginAuthenticatorEnumList', total: number, items: Array<{ __typename?: 'FDPLoginAuthenticatorEnum', id: number, name: string }> } };

export type GetOneFdpLoginAuthenticatorEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneFdpLoginAuthenticatorEnumQuery = { __typename?: 'Query', fdpLoginAuthenticatorEnum?: { __typename?: 'FDPLoginAuthenticatorEnum', id: number, name: string } | null };

export type GetManyFdpLoginAuthenticatorEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyFdpLoginAuthenticatorEnumQuery = { __typename?: 'Query', fdpLoginAuthenticatorEnumMany: Array<{ __typename?: 'FDPLoginAuthenticatorEnum', id: number, name: string } | null> };

export type FdpWebsitesAttributesFragment = { __typename?: 'FDPWebsites', id: number, website: string, financialDataProviderId: number };

export type GetListFdpWebsitesQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FdpWebsitesSort> | FdpWebsitesSort>;
  filter?: InputMaybe<FdpWebsitesFilter>;
}>;


export type GetListFdpWebsitesQuery = { __typename?: 'Query', fdpWebsitesList: { __typename?: 'FdpWebsitesList', total: number, items: Array<{ __typename?: 'FDPWebsites', id: number, website: string, financialDataProviderId: number }> } };

export type GetOneFdpWebsitesQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneFdpWebsitesQuery = { __typename?: 'Query', fdpWebsites?: { __typename?: 'FDPWebsites', id: number, website: string, financialDataProviderId: number } | null };

export type GetManyFdpWebsitesQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyFdpWebsitesQuery = { __typename?: 'Query', fdpWebsitesMany: Array<{ __typename?: 'FDPWebsites', id: number, website: string, financialDataProviderId: number } | null> };

export type CreateFdpWebsitesMutationVariables = Exact<{
  input: FdpWebsitesInput;
}>;


export type CreateFdpWebsitesMutation = { __typename?: 'Mutation', addFdpWebsites: { __typename?: 'FDPWebsites', id: number } };

export type UpdateFdpWebsitesMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: FdpWebsitesInput;
}>;


export type UpdateFdpWebsitesMutation = { __typename?: 'Mutation', updateFdpWebsites: { __typename?: 'FDPWebsites', id: number } };

export type DeleteFdpWebsitesMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteFdpWebsitesMutation = { __typename?: 'Mutation', deleteFdpWebsites: number };

export type GetListFeeCalcEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FeeCalcEnumSort> | FeeCalcEnumSort>;
}>;


export type GetListFeeCalcEnumQuery = { __typename?: 'Query', feeCalcEnumList: { __typename?: 'FeeCalcEnumList', total: number, items: Array<{ __typename?: 'FeeCalcEnum', id: number, name: string }> } };

export type GetOneFeeCalcEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneFeeCalcEnumQuery = { __typename?: 'Query', feeCalcEnum?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null };

export type GetManyFeeCalcEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyFeeCalcEnumQuery = { __typename?: 'Query', feeCalcEnumMany: Array<{ __typename?: 'FeeCalcEnum', id: number, name: string } | null> };

export type GetListFeeFreqEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FeeFreqEnumSort> | FeeFreqEnumSort>;
}>;


export type GetListFeeFreqEnumQuery = { __typename?: 'Query', feeFreqEnumList: { __typename?: 'FeeFreqEnumList', total: number, items: Array<{ __typename?: 'FeeFreqEnum', id: number, name: string }> } };

export type GetOneFeeFreqEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneFeeFreqEnumQuery = { __typename?: 'Query', feeFreqEnum?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null };

export type GetManyFeeFreqEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyFeeFreqEnumQuery = { __typename?: 'Query', feeFreqEnumMany: Array<{ __typename?: 'FeeFreqEnum', id: number, name: string } | null> };

export type FinancialDataProviderAttributesFragment = { __typename?: 'FinancialDataProvider', id: number, name: string, fdpWebsites: Array<{ __typename?: 'FDPWebsites', id: number, website: string }> };

export type GetListFinancialDataProviderQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FinancialDataProviderSort> | FinancialDataProviderSort>;
  filter?: InputMaybe<FinancialDataProviderFilter>;
}>;


export type GetListFinancialDataProviderQuery = { __typename?: 'Query', financialDataProviderList: { __typename?: 'FinancialDataProviderList', total: number, items: Array<{ __typename?: 'FinancialDataProvider', id: number, name: string, fdpWebsites: Array<{ __typename?: 'FDPWebsites', id: number, website: string }> }> } };

export type GetOneFinancialDataProviderQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneFinancialDataProviderQuery = { __typename?: 'Query', financialDataProvider?: { __typename?: 'FinancialDataProvider', id: number, name: string, fdpWebsites: Array<{ __typename?: 'FDPWebsites', id: number, website: string }> } | null };

export type GetManyFinancialDataProviderQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyFinancialDataProviderQuery = { __typename?: 'Query', financialDataProviderMany: Array<{ __typename?: 'FinancialDataProvider', id: number, name: string, fdpWebsites: Array<{ __typename?: 'FDPWebsites', id: number, website: string }> } | null> };

export type CreateFinancialDataProviderMutationVariables = Exact<{
  input: FinancialDataProviderInput;
}>;


export type CreateFinancialDataProviderMutation = { __typename?: 'Mutation', addFinancialDataProvider: { __typename?: 'FinancialDataProvider', id: number } };

export type UpdateFinancialDataProviderMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: FinancialDataProviderInput;
}>;


export type UpdateFinancialDataProviderMutation = { __typename?: 'Mutation', updateFinancialDataProvider: { __typename?: 'FinancialDataProvider', id: number } };

export type GetListFinancialPeriodEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FinancialPeriodEnumSort> | FinancialPeriodEnumSort>;
}>;


export type GetListFinancialPeriodEnumQuery = { __typename?: 'Query', financialPeriodEnumList: { __typename?: 'FinancialPeriodEnumList', total: number, items: Array<{ __typename?: 'FinancialPeriodEnum', id: number, name: string }> } };

export type GetOneFinancialPeriodEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneFinancialPeriodEnumQuery = { __typename?: 'Query', financialPeriodEnum?: { __typename?: 'FinancialPeriodEnum', id: number, name: string } | null };

export type GetManyFinancialPeriodEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyFinancialPeriodEnumQuery = { __typename?: 'Query', financialPeriodEnumMany: Array<{ __typename?: 'FinancialPeriodEnum', id: number, name: string } | null> };

export type FirmAttributesFragment = { __typename?: 'Firm', id: number, name: string, isCompany?: boolean | null, companyId?: number | null, firmEmailDomains?: Array<string> | null, yearFounded?: number | null, registeredWithIds?: Array<number> | null, registeredWithOther?: string | null, cik?: string | null, lei?: string | null, isStaffMWDBE?: boolean | null, crd?: string | null, ukHfsbSignatory?: boolean | null, employeeTotal?: number | null, portfolioManagerCount?: number | null, investmentCount?: number | null, analystCount?: number | null, traderCount?: number | null, operationsCount?: number | null, administrativeCount?: number | null, investorRelationsCount?: number | null, legalCount?: number | null, firmIrEmail?: string | null, comments?: string | null, dataOrganizationId?: number | null, primaryAddress?: { __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, zipCode?: string | null, countryEnumId?: number | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null, website?: string | null, webUserId?: string | null, webPassword?: string | null } | null, otherAddresses?: Array<{ __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, zipCode?: string | null, countryEnumId?: number | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null }> | null, families?: Array<{ __typename?: 'Family', id: number, name: string, firmId: number }> | null, ownershipDiversity?: { __typename?: 'FirmOwnershipDiversity', asOfDate: string, africanAmericanPercent?: number | null, asianPercent?: number | null, hispanicPercent?: number | null, LGBTQPercent?: number | null, nativeAmericanPercent?: number | null, veteranPercent?: number | null, disabledPercent?: number | null, womenPercent?: number | null, otherPercent?: number | null, diversePercent?: number | null } | null, fdpLogins?: Array<{ __typename?: 'FDPLogin', username: string, password: string, securityQuestion?: string | null, id: number }> | null, portalFirm?: { __typename?: 'PortalFirm', migratedAt?: string | null } | null, firmEmployments?: Array<{ __typename?: 'FirmEmployment', id: number, person?: { __typename?: 'Person', id: number, firstName?: string | null, middleName?: string | null, lastName: string, email?: string | null } | null, employeeRole?: { __typename?: 'EmployeeRoleEnum', id: number, name: string } | null }> | null };

export type GetListFirmQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmSort> | FirmSort>;
  filter?: InputMaybe<FirmFilterInput>;
  searchFilters?: InputMaybe<Array<FirmSearchFilters> | FirmSearchFilters>;
}>;


export type GetListFirmQuery = { __typename?: 'Query', firmList: { __typename?: 'FirmList', total: number, items: Array<{ __typename?: 'Firm', id: number, name: string, isCompany?: boolean | null, companyId?: number | null, firmEmailDomains?: Array<string> | null, yearFounded?: number | null, registeredWithIds?: Array<number> | null, registeredWithOther?: string | null, cik?: string | null, lei?: string | null, isStaffMWDBE?: boolean | null, crd?: string | null, ukHfsbSignatory?: boolean | null, employeeTotal?: number | null, portfolioManagerCount?: number | null, investmentCount?: number | null, analystCount?: number | null, traderCount?: number | null, operationsCount?: number | null, administrativeCount?: number | null, investorRelationsCount?: number | null, legalCount?: number | null, firmIrEmail?: string | null, comments?: string | null, dataOrganizationId?: number | null, primaryAddress?: { __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, zipCode?: string | null, countryEnumId?: number | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null, website?: string | null, webUserId?: string | null, webPassword?: string | null } | null, otherAddresses?: Array<{ __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, zipCode?: string | null, countryEnumId?: number | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null }> | null, families?: Array<{ __typename?: 'Family', id: number, name: string, firmId: number }> | null, ownershipDiversity?: { __typename?: 'FirmOwnershipDiversity', asOfDate: string, africanAmericanPercent?: number | null, asianPercent?: number | null, hispanicPercent?: number | null, LGBTQPercent?: number | null, nativeAmericanPercent?: number | null, veteranPercent?: number | null, disabledPercent?: number | null, womenPercent?: number | null, otherPercent?: number | null, diversePercent?: number | null } | null, fdpLogins?: Array<{ __typename?: 'FDPLogin', username: string, password: string, securityQuestion?: string | null, id: number }> | null, portalFirm?: { __typename?: 'PortalFirm', migratedAt?: string | null } | null, firmEmployments?: Array<{ __typename?: 'FirmEmployment', id: number, person?: { __typename?: 'Person', id: number, firstName?: string | null, middleName?: string | null, lastName: string, email?: string | null } | null, employeeRole?: { __typename?: 'EmployeeRoleEnum', id: number, name: string } | null }> | null }> } };

export type GetOneFirmQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneFirmQuery = { __typename?: 'Query', firm?: { __typename?: 'Firm', id: number, name: string, isCompany?: boolean | null, companyId?: number | null, firmEmailDomains?: Array<string> | null, yearFounded?: number | null, registeredWithIds?: Array<number> | null, registeredWithOther?: string | null, cik?: string | null, lei?: string | null, isStaffMWDBE?: boolean | null, crd?: string | null, ukHfsbSignatory?: boolean | null, employeeTotal?: number | null, portfolioManagerCount?: number | null, investmentCount?: number | null, analystCount?: number | null, traderCount?: number | null, operationsCount?: number | null, administrativeCount?: number | null, investorRelationsCount?: number | null, legalCount?: number | null, firmIrEmail?: string | null, comments?: string | null, dataOrganizationId?: number | null, primaryAddress?: { __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, zipCode?: string | null, countryEnumId?: number | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null, website?: string | null, webUserId?: string | null, webPassword?: string | null } | null, otherAddresses?: Array<{ __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, zipCode?: string | null, countryEnumId?: number | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null }> | null, families?: Array<{ __typename?: 'Family', id: number, name: string, firmId: number }> | null, ownershipDiversity?: { __typename?: 'FirmOwnershipDiversity', asOfDate: string, africanAmericanPercent?: number | null, asianPercent?: number | null, hispanicPercent?: number | null, LGBTQPercent?: number | null, nativeAmericanPercent?: number | null, veteranPercent?: number | null, disabledPercent?: number | null, womenPercent?: number | null, otherPercent?: number | null, diversePercent?: number | null } | null, fdpLogins?: Array<{ __typename?: 'FDPLogin', username: string, password: string, securityQuestion?: string | null, id: number }> | null, portalFirm?: { __typename?: 'PortalFirm', migratedAt?: string | null } | null, firmEmployments?: Array<{ __typename?: 'FirmEmployment', id: number, person?: { __typename?: 'Person', id: number, firstName?: string | null, middleName?: string | null, lastName: string, email?: string | null } | null, employeeRole?: { __typename?: 'EmployeeRoleEnum', id: number, name: string } | null }> | null } | null };

export type GetManyFirmQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyFirmQuery = { __typename?: 'Query', firmMany: Array<{ __typename?: 'Firm', id: number, name: string, isCompany?: boolean | null, companyId?: number | null, firmEmailDomains?: Array<string> | null, yearFounded?: number | null, registeredWithIds?: Array<number> | null, registeredWithOther?: string | null, cik?: string | null, lei?: string | null, isStaffMWDBE?: boolean | null, crd?: string | null, ukHfsbSignatory?: boolean | null, employeeTotal?: number | null, portfolioManagerCount?: number | null, investmentCount?: number | null, analystCount?: number | null, traderCount?: number | null, operationsCount?: number | null, administrativeCount?: number | null, investorRelationsCount?: number | null, legalCount?: number | null, firmIrEmail?: string | null, comments?: string | null, dataOrganizationId?: number | null, primaryAddress?: { __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, zipCode?: string | null, countryEnumId?: number | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null, website?: string | null, webUserId?: string | null, webPassword?: string | null } | null, otherAddresses?: Array<{ __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, zipCode?: string | null, countryEnumId?: number | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null }> | null, families?: Array<{ __typename?: 'Family', id: number, name: string, firmId: number }> | null, ownershipDiversity?: { __typename?: 'FirmOwnershipDiversity', asOfDate: string, africanAmericanPercent?: number | null, asianPercent?: number | null, hispanicPercent?: number | null, LGBTQPercent?: number | null, nativeAmericanPercent?: number | null, veteranPercent?: number | null, disabledPercent?: number | null, womenPercent?: number | null, otherPercent?: number | null, diversePercent?: number | null } | null, fdpLogins?: Array<{ __typename?: 'FDPLogin', username: string, password: string, securityQuestion?: string | null, id: number }> | null, portalFirm?: { __typename?: 'PortalFirm', migratedAt?: string | null } | null, firmEmployments?: Array<{ __typename?: 'FirmEmployment', id: number, person?: { __typename?: 'Person', id: number, firstName?: string | null, middleName?: string | null, lastName: string, email?: string | null } | null, employeeRole?: { __typename?: 'EmployeeRoleEnum', id: number, name: string } | null }> | null } | null> };

export type CreateFirmMutationVariables = Exact<{
  input: FirmInput;
}>;


export type CreateFirmMutation = { __typename?: 'Mutation', addFirm?: { __typename?: 'Firm', id: number, name: string, isCompany?: boolean | null, companyId?: number | null, firmEmailDomains?: Array<string> | null, yearFounded?: number | null, registeredWithIds?: Array<number> | null, registeredWithOther?: string | null, cik?: string | null, lei?: string | null, isStaffMWDBE?: boolean | null, crd?: string | null, ukHfsbSignatory?: boolean | null, employeeTotal?: number | null, portfolioManagerCount?: number | null, investmentCount?: number | null, analystCount?: number | null, traderCount?: number | null, operationsCount?: number | null, administrativeCount?: number | null, investorRelationsCount?: number | null, legalCount?: number | null, firmIrEmail?: string | null, comments?: string | null, dataOrganizationId?: number | null, primaryAddress?: { __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, zipCode?: string | null, countryEnumId?: number | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null, website?: string | null, webUserId?: string | null, webPassword?: string | null } | null, otherAddresses?: Array<{ __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, zipCode?: string | null, countryEnumId?: number | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null }> | null, families?: Array<{ __typename?: 'Family', id: number, name: string, firmId: number }> | null, ownershipDiversity?: { __typename?: 'FirmOwnershipDiversity', asOfDate: string, africanAmericanPercent?: number | null, asianPercent?: number | null, hispanicPercent?: number | null, LGBTQPercent?: number | null, nativeAmericanPercent?: number | null, veteranPercent?: number | null, disabledPercent?: number | null, womenPercent?: number | null, otherPercent?: number | null, diversePercent?: number | null } | null, fdpLogins?: Array<{ __typename?: 'FDPLogin', username: string, password: string, securityQuestion?: string | null, id: number }> | null, portalFirm?: { __typename?: 'PortalFirm', migratedAt?: string | null } | null, firmEmployments?: Array<{ __typename?: 'FirmEmployment', id: number, person?: { __typename?: 'Person', id: number, firstName?: string | null, middleName?: string | null, lastName: string, email?: string | null } | null, employeeRole?: { __typename?: 'EmployeeRoleEnum', id: number, name: string } | null }> | null } | null };

export type UpdateFirmMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: FirmInput;
}>;


export type UpdateFirmMutation = { __typename?: 'Mutation', updateFirm: { __typename?: 'Firm', id: number, name: string, isCompany?: boolean | null, companyId?: number | null, firmEmailDomains?: Array<string> | null, yearFounded?: number | null, registeredWithIds?: Array<number> | null, registeredWithOther?: string | null, cik?: string | null, lei?: string | null, isStaffMWDBE?: boolean | null, crd?: string | null, ukHfsbSignatory?: boolean | null, employeeTotal?: number | null, portfolioManagerCount?: number | null, investmentCount?: number | null, analystCount?: number | null, traderCount?: number | null, operationsCount?: number | null, administrativeCount?: number | null, investorRelationsCount?: number | null, legalCount?: number | null, firmIrEmail?: string | null, comments?: string | null, dataOrganizationId?: number | null, primaryAddress?: { __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, zipCode?: string | null, countryEnumId?: number | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null, website?: string | null, webUserId?: string | null, webPassword?: string | null } | null, otherAddresses?: Array<{ __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, zipCode?: string | null, countryEnumId?: number | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null }> | null, families?: Array<{ __typename?: 'Family', id: number, name: string, firmId: number }> | null, ownershipDiversity?: { __typename?: 'FirmOwnershipDiversity', asOfDate: string, africanAmericanPercent?: number | null, asianPercent?: number | null, hispanicPercent?: number | null, LGBTQPercent?: number | null, nativeAmericanPercent?: number | null, veteranPercent?: number | null, disabledPercent?: number | null, womenPercent?: number | null, otherPercent?: number | null, diversePercent?: number | null } | null, fdpLogins?: Array<{ __typename?: 'FDPLogin', username: string, password: string, securityQuestion?: string | null, id: number }> | null, portalFirm?: { __typename?: 'PortalFirm', migratedAt?: string | null } | null, firmEmployments?: Array<{ __typename?: 'FirmEmployment', id: number, person?: { __typename?: 'Person', id: number, firstName?: string | null, middleName?: string | null, lastName: string, email?: string | null } | null, employeeRole?: { __typename?: 'EmployeeRoleEnum', id: number, name: string } | null }> | null } };

export type DeleteFirmMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteFirmMutation = { __typename?: 'Mutation', deleteFirm: string };

export type FirmDeiAttributesFragment = { __typename?: 'FirmDEI', id: number, asOfDate: string, firmId: number, isCompleted: boolean, geographyEnumId: number, diversityStatsEnumId?: number | null, comments?: string | null, firm: { __typename?: 'Firm', id: number, name: string, isCompany?: boolean | null, companyId?: number | null }, geographyEnum: { __typename?: 'GeographyEnum', id: number, description?: string | null }, firmDEIRecords: Array<{ __typename?: 'FirmDEIRecord', id: number, firmDEIId: number, deiCategory1EnumId: number, deiCategory2EnumId?: number | null, measureEnumId: number, value?: number | null, percentValue?: number | null, deiCategory1Enum: { __typename?: 'DeiCategory1Enum', id: number, description: string }, deiCategory2Enum: { __typename?: 'DeiCategory2Enum', id: number, description: string }, measureEnum: { __typename?: 'MeasureEnum', id: number, description: string } }> };

export type GetListFirmDeiQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmDeiSort> | FirmDeiSort>;
  filter?: InputMaybe<FirmDeiFilter>;
}>;


export type GetListFirmDeiQuery = { __typename?: 'Query', firmDEIList: { __typename?: 'FirmDEIList', total: number, items: Array<{ __typename?: 'FirmDEI', id: number, asOfDate: string, firmId: number, isCompleted: boolean, geographyEnumId: number, diversityStatsEnumId?: number | null, comments?: string | null, firm: { __typename?: 'Firm', id: number, name: string, isCompany?: boolean | null, companyId?: number | null }, geographyEnum: { __typename?: 'GeographyEnum', id: number, description?: string | null }, firmDEIRecords: Array<{ __typename?: 'FirmDEIRecord', id: number, firmDEIId: number, deiCategory1EnumId: number, deiCategory2EnumId?: number | null, measureEnumId: number, value?: number | null, percentValue?: number | null, deiCategory1Enum: { __typename?: 'DeiCategory1Enum', id: number, description: string }, deiCategory2Enum: { __typename?: 'DeiCategory2Enum', id: number, description: string }, measureEnum: { __typename?: 'MeasureEnum', id: number, description: string } }> }> } };

export type GetOneFirmDeiQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneFirmDeiQuery = { __typename?: 'Query', firmDEI?: { __typename?: 'FirmDEI', id: number, asOfDate: string, firmId: number, isCompleted: boolean, geographyEnumId: number, diversityStatsEnumId?: number | null, comments?: string | null, firm: { __typename?: 'Firm', id: number, name: string, isCompany?: boolean | null, companyId?: number | null }, geographyEnum: { __typename?: 'GeographyEnum', id: number, description?: string | null }, firmDEIRecords: Array<{ __typename?: 'FirmDEIRecord', id: number, firmDEIId: number, deiCategory1EnumId: number, deiCategory2EnumId?: number | null, measureEnumId: number, value?: number | null, percentValue?: number | null, deiCategory1Enum: { __typename?: 'DeiCategory1Enum', id: number, description: string }, deiCategory2Enum: { __typename?: 'DeiCategory2Enum', id: number, description: string }, measureEnum: { __typename?: 'MeasureEnum', id: number, description: string } }> } | null };

export type GetManyFirmDeiQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyFirmDeiQuery = { __typename?: 'Query', firmDEIMany: Array<{ __typename?: 'FirmDEI', id: number, asOfDate: string, firmId: number, isCompleted: boolean, geographyEnumId: number, diversityStatsEnumId?: number | null, comments?: string | null, firm: { __typename?: 'Firm', id: number, name: string, isCompany?: boolean | null, companyId?: number | null }, geographyEnum: { __typename?: 'GeographyEnum', id: number, description?: string | null }, firmDEIRecords: Array<{ __typename?: 'FirmDEIRecord', id: number, firmDEIId: number, deiCategory1EnumId: number, deiCategory2EnumId?: number | null, measureEnumId: number, value?: number | null, percentValue?: number | null, deiCategory1Enum: { __typename?: 'DeiCategory1Enum', id: number, description: string }, deiCategory2Enum: { __typename?: 'DeiCategory2Enum', id: number, description: string }, measureEnum: { __typename?: 'MeasureEnum', id: number, description: string } }> } | null> };

export type AddOrUpdateFirmDeiMutationVariables = Exact<{
  input: FirmDeiCreateOrUpdate;
}>;


export type AddOrUpdateFirmDeiMutation = { __typename?: 'Mutation', createOrUpdateFirmDEI: { __typename?: 'FirmDEI', id: number, asOfDate: string, firmId: number, isCompleted: boolean, geographyEnumId: number, diversityStatsEnumId?: number | null, comments?: string | null, firm: { __typename?: 'Firm', id: number, name: string, isCompany?: boolean | null, companyId?: number | null }, geographyEnum: { __typename?: 'GeographyEnum', id: number, description?: string | null }, firmDEIRecords: Array<{ __typename?: 'FirmDEIRecord', id: number, firmDEIId: number, deiCategory1EnumId: number, deiCategory2EnumId?: number | null, measureEnumId: number, value?: number | null, percentValue?: number | null, deiCategory1Enum: { __typename?: 'DeiCategory1Enum', id: number, description: string }, deiCategory2Enum: { __typename?: 'DeiCategory2Enum', id: number, description: string }, measureEnum: { __typename?: 'MeasureEnum', id: number, description: string } }> } };

export type DeleteFirmDeiMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteFirmDeiMutation = { __typename?: 'Mutation', deleteFirmDei: string };

export type FirmEmploymentAttributesFragment = { __typename?: 'FirmEmployment', id: number, firmId: number, personId: number, employeeRoleEnumId?: number | null, contactTypeEnumId?: number | null, faceOfFirm?: boolean | null, leftInd?: boolean | null, leftDate?: string | null, leftReason?: string | null, authToTrade?: boolean | null, outsideAffil?: boolean | null, startDate?: string | null, jobDesc?: string | null, focusStrategyEnumId?: number | null, dataContact?: boolean | null, isFounder?: boolean | null, isKeyPersonnel?: boolean | null, isAdminContact?: boolean | null, auditContactTypeEnumId?: number | null, isDataEntryContact?: boolean | null, displayOrder?: number | null, comments?: string | null, employeeRole?: { __typename?: 'EmployeeRoleEnum', id: number, name: string } | null, contactType?: { __typename?: 'ContactTypeEnum', id: number, name?: string | null } | null, firm: { __typename?: 'Firm', id: number, name: string, companyId?: number | null, isCompany?: boolean | null, fdpLogins?: Array<{ __typename?: 'FDPLogin', id: number, username: string, password: string, securityQuestion?: string | null }> | null, primaryAddress?: { __typename?: 'Address', id: number, website?: string | null, webUserId?: string | null, webPassword?: string | null } | null }, person?: { __typename?: 'Person', id: number, lastName: string, firstName?: string | null, middleName?: string | null, email?: string | null, phone?: string | null } | null };

export type GetListFirmEmploymentQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmEmploymentSort> | FirmEmploymentSort>;
  filter?: InputMaybe<FirmEmploymentFilterInput>;
}>;


export type GetListFirmEmploymentQuery = { __typename?: 'Query', firmEmploymentList: { __typename?: 'FirmEmploymentList', total: number, items: Array<{ __typename?: 'FirmEmployment', id: number, firmId: number, personId: number, employeeRoleEnumId?: number | null, contactTypeEnumId?: number | null, faceOfFirm?: boolean | null, leftInd?: boolean | null, leftDate?: string | null, leftReason?: string | null, authToTrade?: boolean | null, outsideAffil?: boolean | null, startDate?: string | null, jobDesc?: string | null, focusStrategyEnumId?: number | null, dataContact?: boolean | null, isFounder?: boolean | null, isKeyPersonnel?: boolean | null, isAdminContact?: boolean | null, auditContactTypeEnumId?: number | null, isDataEntryContact?: boolean | null, displayOrder?: number | null, comments?: string | null, employeeRole?: { __typename?: 'EmployeeRoleEnum', id: number, name: string } | null, contactType?: { __typename?: 'ContactTypeEnum', id: number, name?: string | null } | null, firm: { __typename?: 'Firm', id: number, name: string, companyId?: number | null, isCompany?: boolean | null, fdpLogins?: Array<{ __typename?: 'FDPLogin', id: number, username: string, password: string, securityQuestion?: string | null }> | null, primaryAddress?: { __typename?: 'Address', id: number, website?: string | null, webUserId?: string | null, webPassword?: string | null } | null }, person?: { __typename?: 'Person', id: number, lastName: string, firstName?: string | null, middleName?: string | null, email?: string | null, phone?: string | null } | null }> } };

export type GetOneFirmEmploymentQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneFirmEmploymentQuery = { __typename?: 'Query', firmEmployment?: { __typename?: 'FirmEmployment', id: number, firmId: number, personId: number, employeeRoleEnumId?: number | null, contactTypeEnumId?: number | null, faceOfFirm?: boolean | null, leftInd?: boolean | null, leftDate?: string | null, leftReason?: string | null, authToTrade?: boolean | null, outsideAffil?: boolean | null, startDate?: string | null, jobDesc?: string | null, focusStrategyEnumId?: number | null, dataContact?: boolean | null, isFounder?: boolean | null, isKeyPersonnel?: boolean | null, isAdminContact?: boolean | null, auditContactTypeEnumId?: number | null, isDataEntryContact?: boolean | null, displayOrder?: number | null, comments?: string | null, employeeRole?: { __typename?: 'EmployeeRoleEnum', id: number, name: string } | null, contactType?: { __typename?: 'ContactTypeEnum', id: number, name?: string | null } | null, firm: { __typename?: 'Firm', id: number, name: string, companyId?: number | null, isCompany?: boolean | null, fdpLogins?: Array<{ __typename?: 'FDPLogin', id: number, username: string, password: string, securityQuestion?: string | null }> | null, primaryAddress?: { __typename?: 'Address', id: number, website?: string | null, webUserId?: string | null, webPassword?: string | null } | null }, person?: { __typename?: 'Person', id: number, lastName: string, firstName?: string | null, middleName?: string | null, email?: string | null, phone?: string | null } | null } | null };

export type GetManyFirmEmploymentQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyFirmEmploymentQuery = { __typename?: 'Query', firmEmploymentMany: Array<{ __typename?: 'FirmEmployment', id: number, firmId: number, personId: number, employeeRoleEnumId?: number | null, contactTypeEnumId?: number | null, faceOfFirm?: boolean | null, leftInd?: boolean | null, leftDate?: string | null, leftReason?: string | null, authToTrade?: boolean | null, outsideAffil?: boolean | null, startDate?: string | null, jobDesc?: string | null, focusStrategyEnumId?: number | null, dataContact?: boolean | null, isFounder?: boolean | null, isKeyPersonnel?: boolean | null, isAdminContact?: boolean | null, auditContactTypeEnumId?: number | null, isDataEntryContact?: boolean | null, displayOrder?: number | null, comments?: string | null, employeeRole?: { __typename?: 'EmployeeRoleEnum', id: number, name: string } | null, contactType?: { __typename?: 'ContactTypeEnum', id: number, name?: string | null } | null, firm: { __typename?: 'Firm', id: number, name: string, companyId?: number | null, isCompany?: boolean | null, fdpLogins?: Array<{ __typename?: 'FDPLogin', id: number, username: string, password: string, securityQuestion?: string | null }> | null, primaryAddress?: { __typename?: 'Address', id: number, website?: string | null, webUserId?: string | null, webPassword?: string | null } | null }, person?: { __typename?: 'Person', id: number, lastName: string, firstName?: string | null, middleName?: string | null, email?: string | null, phone?: string | null } | null } | null> };

export type GetManyReferenceFirmEmploymentQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmEmploymentSort> | FirmEmploymentSort>;
  filter?: InputMaybe<FirmEmploymentFilterInput>;
}>;


export type GetManyReferenceFirmEmploymentQuery = { __typename?: 'Query', firmEmploymentList: { __typename?: 'FirmEmploymentList', total: number, items: Array<{ __typename?: 'FirmEmployment', id: number, firmId: number, personId: number, employeeRoleEnumId?: number | null, contactTypeEnumId?: number | null, faceOfFirm?: boolean | null, leftInd?: boolean | null, leftDate?: string | null, leftReason?: string | null, authToTrade?: boolean | null, outsideAffil?: boolean | null, startDate?: string | null, jobDesc?: string | null, focusStrategyEnumId?: number | null, dataContact?: boolean | null, isFounder?: boolean | null, isKeyPersonnel?: boolean | null, isAdminContact?: boolean | null, auditContactTypeEnumId?: number | null, isDataEntryContact?: boolean | null, displayOrder?: number | null, comments?: string | null, employeeRole?: { __typename?: 'EmployeeRoleEnum', id: number, name: string } | null, contactType?: { __typename?: 'ContactTypeEnum', id: number, name?: string | null } | null, firm: { __typename?: 'Firm', id: number, name: string, companyId?: number | null, isCompany?: boolean | null, fdpLogins?: Array<{ __typename?: 'FDPLogin', id: number, username: string, password: string, securityQuestion?: string | null }> | null, primaryAddress?: { __typename?: 'Address', id: number, website?: string | null, webUserId?: string | null, webPassword?: string | null } | null }, person?: { __typename?: 'Person', id: number, lastName: string, firstName?: string | null, middleName?: string | null, email?: string | null, phone?: string | null } | null }> } };

export type CreateFirmEmploymentMutationVariables = Exact<{
  input: FirmEmploymentInput;
}>;


export type CreateFirmEmploymentMutation = { __typename?: 'Mutation', addFirmEmployment?: { __typename?: 'FirmEmployment', id: number, firmId: number, personId: number, employeeRoleEnumId?: number | null, contactTypeEnumId?: number | null, faceOfFirm?: boolean | null, leftInd?: boolean | null, leftDate?: string | null, leftReason?: string | null, authToTrade?: boolean | null, outsideAffil?: boolean | null, startDate?: string | null, jobDesc?: string | null, focusStrategyEnumId?: number | null, dataContact?: boolean | null, isFounder?: boolean | null, isKeyPersonnel?: boolean | null, isAdminContact?: boolean | null, auditContactTypeEnumId?: number | null, isDataEntryContact?: boolean | null, displayOrder?: number | null, comments?: string | null, employeeRole?: { __typename?: 'EmployeeRoleEnum', id: number, name: string } | null, contactType?: { __typename?: 'ContactTypeEnum', id: number, name?: string | null } | null, firm: { __typename?: 'Firm', id: number, name: string, companyId?: number | null, isCompany?: boolean | null, fdpLogins?: Array<{ __typename?: 'FDPLogin', id: number, username: string, password: string, securityQuestion?: string | null }> | null, primaryAddress?: { __typename?: 'Address', id: number, website?: string | null, webUserId?: string | null, webPassword?: string | null } | null }, person?: { __typename?: 'Person', id: number, lastName: string, firstName?: string | null, middleName?: string | null, email?: string | null, phone?: string | null } | null } | null };

export type UpdateFirmEmploymentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: FirmEmploymentInput;
}>;


export type UpdateFirmEmploymentMutation = { __typename?: 'Mutation', updateFirmEmployment: { __typename?: 'FirmEmployment', id: number, firmId: number, personId: number, employeeRoleEnumId?: number | null, contactTypeEnumId?: number | null, faceOfFirm?: boolean | null, leftInd?: boolean | null, leftDate?: string | null, leftReason?: string | null, authToTrade?: boolean | null, outsideAffil?: boolean | null, startDate?: string | null, jobDesc?: string | null, focusStrategyEnumId?: number | null, dataContact?: boolean | null, isFounder?: boolean | null, isKeyPersonnel?: boolean | null, isAdminContact?: boolean | null, auditContactTypeEnumId?: number | null, isDataEntryContact?: boolean | null, displayOrder?: number | null, comments?: string | null, employeeRole?: { __typename?: 'EmployeeRoleEnum', id: number, name: string } | null, contactType?: { __typename?: 'ContactTypeEnum', id: number, name?: string | null } | null, firm: { __typename?: 'Firm', id: number, name: string, companyId?: number | null, isCompany?: boolean | null, fdpLogins?: Array<{ __typename?: 'FDPLogin', id: number, username: string, password: string, securityQuestion?: string | null }> | null, primaryAddress?: { __typename?: 'Address', id: number, website?: string | null, webUserId?: string | null, webPassword?: string | null } | null }, person?: { __typename?: 'Person', id: number, lastName: string, firstName?: string | null, middleName?: string | null, email?: string | null, phone?: string | null } | null } };

export type DeleteFirmEmploymentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteFirmEmploymentMutation = { __typename?: 'Mutation', deleteFirmEmployment: number };

export type FirmFdpLoginsAttributesFragment = { __typename?: 'FirmFDPLogins', id: number, firmId: number, fdpLoginId: number, fdpWebsiteId?: number | null, firm: { __typename?: 'Firm', id: number, name: string, isCompany?: boolean | null, companyId?: number | null }, fdpWebsite?: { __typename?: 'FDPWebsites', id: number, website: string, financialDataProviderId: number } | null, fdpLogin: { __typename?: 'FDPLogin', id: number, username: string, financialDataProviderId: number, financialDataProvider: { __typename?: 'FinancialDataProvider', id: number, name: string, fdpWebsites: Array<{ __typename?: 'FDPWebsites', id: number, website: string }> } } };

export type GetListFirmFdpLoginsQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmFdpLoginsSort> | FirmFdpLoginsSort>;
  filter?: InputMaybe<FirmFdpLoginsFilter>;
}>;


export type GetListFirmFdpLoginsQuery = { __typename?: 'Query', firmFDPLoginsList: { __typename?: 'FirmFDPLoginsList', total: number, items: Array<{ __typename?: 'FirmFDPLogins', id: number, firmId: number, fdpLoginId: number, fdpWebsiteId?: number | null, firm: { __typename?: 'Firm', id: number, name: string, isCompany?: boolean | null, companyId?: number | null }, fdpWebsite?: { __typename?: 'FDPWebsites', id: number, website: string, financialDataProviderId: number } | null, fdpLogin: { __typename?: 'FDPLogin', id: number, username: string, financialDataProviderId: number, financialDataProvider: { __typename?: 'FinancialDataProvider', id: number, name: string, fdpWebsites: Array<{ __typename?: 'FDPWebsites', id: number, website: string }> } } }> } };

export type GetOneFirmFdpLoginsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneFirmFdpLoginsQuery = { __typename?: 'Query', firmFDPLogins?: { __typename?: 'FirmFDPLogins', id: number, firmId: number, fdpLoginId: number, fdpWebsiteId?: number | null, firm: { __typename?: 'Firm', id: number, name: string, isCompany?: boolean | null, companyId?: number | null }, fdpWebsite?: { __typename?: 'FDPWebsites', id: number, website: string, financialDataProviderId: number } | null, fdpLogin: { __typename?: 'FDPLogin', id: number, username: string, financialDataProviderId: number, financialDataProvider: { __typename?: 'FinancialDataProvider', id: number, name: string, fdpWebsites: Array<{ __typename?: 'FDPWebsites', id: number, website: string }> } } } | null };

export type GetManyFirmFdpLoginsQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyFirmFdpLoginsQuery = { __typename?: 'Query', firmFDPLoginsMany: Array<{ __typename?: 'FirmFDPLogins', id: number, firmId: number, fdpLoginId: number, fdpWebsiteId?: number | null, firm: { __typename?: 'Firm', id: number, name: string, isCompany?: boolean | null, companyId?: number | null }, fdpWebsite?: { __typename?: 'FDPWebsites', id: number, website: string, financialDataProviderId: number } | null, fdpLogin: { __typename?: 'FDPLogin', id: number, username: string, financialDataProviderId: number, financialDataProvider: { __typename?: 'FinancialDataProvider', id: number, name: string, fdpWebsites: Array<{ __typename?: 'FDPWebsites', id: number, website: string }> } } } | null> };

export type CreateFirmFdpLoginsMutationVariables = Exact<{
  input: FirmFdpLoginsInput;
}>;


export type CreateFirmFdpLoginsMutation = { __typename?: 'Mutation', addFirmFDPLogins: { __typename?: 'FirmFDPLogins', id: number } };

export type UpdateFirmFdpLoginsMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: FirmFdpLoginsInput;
}>;


export type UpdateFirmFdpLoginsMutation = { __typename?: 'Mutation', updateFirmFDPLogins: { __typename?: 'FirmFDPLogins', id: number } };

export type FirmInstitutionsAttributesFragment = { __typename?: 'FirmInstitutions', id: number, firmId: number, institutionId: number, startDate?: string | null, endDate?: string | null, institutionInstitutionTypeEnumId?: number | null, firm: { __typename?: 'Firm', id: number, name: string }, institution: { __typename?: 'Institution', id: number, name: string }, officeLocationServiceType?: { __typename?: 'InstitutionsInstitutionTypeEnum', id: number, institutionTypeEnum: { __typename?: 'InstitutionTypeEnum', id: number, name: string } } | null };

export type GetListFirmInstitutionsQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmInstitutionsSort> | FirmInstitutionsSort>;
  filter?: InputMaybe<FirmInstitutionsFilter>;
}>;


export type GetListFirmInstitutionsQuery = { __typename?: 'Query', firmInstitutionsList: { __typename?: 'FirmInstitutionsList', total: number, items: Array<{ __typename?: 'FirmInstitutions', id: number, firmId: number, institutionId: number, startDate?: string | null, endDate?: string | null, institutionInstitutionTypeEnumId?: number | null, firm: { __typename?: 'Firm', id: number, name: string }, institution: { __typename?: 'Institution', id: number, name: string }, officeLocationServiceType?: { __typename?: 'InstitutionsInstitutionTypeEnum', id: number, institutionTypeEnum: { __typename?: 'InstitutionTypeEnum', id: number, name: string } } | null }> } };

export type GetOneFirmInstitutionsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneFirmInstitutionsQuery = { __typename?: 'Query', firmInstitutions?: { __typename?: 'FirmInstitutions', id: number, firmId: number, institutionId: number, startDate?: string | null, endDate?: string | null, institutionInstitutionTypeEnumId?: number | null, firm: { __typename?: 'Firm', id: number, name: string }, institution: { __typename?: 'Institution', id: number, name: string }, officeLocationServiceType?: { __typename?: 'InstitutionsInstitutionTypeEnum', id: number, institutionTypeEnum: { __typename?: 'InstitutionTypeEnum', id: number, name: string } } | null } | null };

export type GetManyFirmInstitutionsQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyFirmInstitutionsQuery = { __typename?: 'Query', firmInstitutionsMany: Array<{ __typename?: 'FirmInstitutions', id: number, firmId: number, institutionId: number, startDate?: string | null, endDate?: string | null, institutionInstitutionTypeEnumId?: number | null, firm: { __typename?: 'Firm', id: number, name: string }, institution: { __typename?: 'Institution', id: number, name: string }, officeLocationServiceType?: { __typename?: 'InstitutionsInstitutionTypeEnum', id: number, institutionTypeEnum: { __typename?: 'InstitutionTypeEnum', id: number, name: string } } | null } | null> };

export type CreateFirmInstitutionsMutationVariables = Exact<{
  input: FirmInstitutionsInput;
}>;


export type CreateFirmInstitutionsMutation = { __typename?: 'Mutation', addFirmInstitutions?: { __typename?: 'FirmInstitutions', id: number } | null };

export type UpdateFirmInstitutionsMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: FirmInstitutionsInput;
}>;


export type UpdateFirmInstitutionsMutation = { __typename?: 'Mutation', updateFirmInstitutions: { __typename?: 'FirmInstitutions', id: number } };

export type DeleteFirmInstitutionsMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteFirmInstitutionsMutation = { __typename?: 'Mutation', deleteFirmInstitutions: number };

export type GetListFundingTypeEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FundingTypeEnumSort> | FundingTypeEnumSort>;
}>;


export type GetListFundingTypeEnumQuery = { __typename?: 'Query', fundingTypeEnumList: { __typename?: 'FundingTypeEnumList', total: number, items: Array<{ __typename?: 'FundingTypeEnum', id: string, name?: string | null }> } };

export type GetOneFundingTypeEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneFundingTypeEnumQuery = { __typename?: 'Query', fundingTypeEnum?: { __typename?: 'FundingTypeEnum', id: string, name?: string | null } | null };

export type GetManyFundingTypeEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyFundingTypeEnumQuery = { __typename?: 'Query', fundingTypeEnumMany: Array<{ __typename?: 'FundingTypeEnum', id: string, name?: string | null } | null> };

export type GetListFundsXProxiesQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FundsXProxiesSort> | FundsXProxiesSort>;
  filter?: InputMaybe<FundsXProxiesFilter>;
}>;


export type GetListFundsXProxiesQuery = { __typename?: 'Query', fundsXProxiesList: { __typename?: 'FundsXProxiesList', total: number, items: Array<{ __typename?: 'FundsXProxies', id: number, investmentId: number, proxyId: number, proxyScalingFactor?: number | null, rank: number, createUser?: string | null, createDate?: string | null, modifyUser?: string | null, modifyDate?: string | null, proxy: { __typename?: 'Investment', id: number, name: string } }> } };

export type GetOneFundsXProxiesQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneFundsXProxiesQuery = { __typename?: 'Query', fundsXProxies?: { __typename?: 'FundsXProxies', id: number, investmentId: number, proxyId: number, proxyScalingFactor?: number | null, rank: number, createUser?: string | null, createDate?: string | null, modifyUser?: string | null, modifyDate?: string | null, proxy: { __typename?: 'Investment', id: number, name: string } } | null };

export type CreateFundsXProxiesMutationVariables = Exact<{
  input: FundsXProxiesInput;
}>;


export type CreateFundsXProxiesMutation = { __typename?: 'Mutation', addFundsXProxies: { __typename?: 'FundsXProxies', id: number, investmentId: number, proxyId: number, proxyScalingFactor?: number | null, rank: number, proxy: { __typename?: 'Investment', id: number, name: string } } };

export type UpdateFundsXProxiesMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: FundsXProxiesInput;
}>;


export type UpdateFundsXProxiesMutation = { __typename?: 'Mutation', updateFundsXProxies: { __typename?: 'FundsXProxies', id: number, investmentId: number, proxyId: number, proxyScalingFactor?: number | null, rank: number, proxy: { __typename?: 'Investment', id: number, name: string } } };

export type DeleteFundsXProxiesMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteFundsXProxiesMutation = { __typename?: 'Mutation', deleteFundsXProxies: number };

export type GetListGeographicFocusEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<GeographicFocusEnumSort> | GeographicFocusEnumSort>;
}>;


export type GetListGeographicFocusEnumQuery = { __typename?: 'Query', geographicFocusEnumList: { __typename?: 'GeographicFocusEnumList', total: number, items: Array<{ __typename?: 'GeographicFocusEnum', id: number, name: string }> } };

export type GetOneGeographicFocusEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneGeographicFocusEnumQuery = { __typename?: 'Query', geographicFocusEnum?: { __typename?: 'GeographicFocusEnum', id: number, name: string } | null };

export type GetManyGeographicFocusEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyGeographicFocusEnumQuery = { __typename?: 'Query', geographicFocusEnumMany: Array<{ __typename?: 'GeographicFocusEnum', id: number, name: string } | null> };

export type GetListGeographyEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<GeographyEnumSort> | GeographyEnumSort>;
  filter?: InputMaybe<GeographyEnumFilter>;
}>;


export type GetListGeographyEnumQuery = { __typename?: 'Query', geographyEnumList: { __typename?: 'GeographyEnumList', total: number, items: Array<{ __typename?: 'GeographyEnum', id: number, description?: string | null }> } };

export type GetOneGeographyEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneGeographyEnumQuery = { __typename?: 'Query', geographyEnum?: { __typename?: 'GeographyEnum', id: number, description?: string | null } | null };

export type GetManyGeographyEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyGeographyEnumQuery = { __typename?: 'Query', geographyEnumMany: Array<{ __typename?: 'GeographyEnum', id: number, description?: string | null } | null> };

export type GlobalProviderNoteTypeEnumAttributesFragment = { __typename?: 'GlobalProviderNoteTypeEnum', id: number, name: string };

export type GetListGlobalProviderNoteTypeEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<GlobalProviderNoteTypeEnumSort> | GlobalProviderNoteTypeEnumSort>;
  filter?: InputMaybe<GlobalProviderNoteTypeEnumFilter>;
}>;


export type GetListGlobalProviderNoteTypeEnumQuery = { __typename?: 'Query', globalProviderNoteTypeEnumList: { __typename?: 'GlobalProviderNoteTypeEnumList', total: number, items: Array<{ __typename?: 'GlobalProviderNoteTypeEnum', id: number, name: string }> } };

export type GetOneGlobalProviderNoteTypeEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneGlobalProviderNoteTypeEnumQuery = { __typename?: 'Query', globalProviderNoteTypeEnum?: { __typename?: 'GlobalProviderNoteTypeEnum', id: number, name: string } | null };

export type GetManyGlobalProviderNoteTypeEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyGlobalProviderNoteTypeEnumQuery = { __typename?: 'Query', globalProviderNoteTypeEnumMany: Array<{ __typename?: 'GlobalProviderNoteTypeEnum', id: number, name: string } | null> };

export type GroupShareDefinitionAttributesFragment = { __typename?: 'GroupShareDefinition', id: number, dynamicDefinition?: string | null, sourceGroupId: number, targetGroupId: number, entityAccessId: number, isActive: boolean, lastExecuted?: string | null, createDate: string, modifyDate: string, createUser?: string | null, modifyUser?: string | null, dynamicDefinitionStructured?: { __typename?: 'DynamicDefinitionOutput', description?: string | null, displayName?: string | null, everything?: boolean | null, investmentsDynamicShare?: { __typename?: 'InvestmentsDynamicShareRuleOutput', investmentSet?: { __typename?: 'GroupShareInvestmentSetFilterOutput', setId: number } | null } | null, firmsDynamicShare?: { __typename?: 'FirmsDynamicShareRuleOutput', investmentSet?: { __typename?: 'GroupShareInvestmentSetFilterOutput', setId: number } | null } | null, personsDynamicShare?: { __typename?: 'PersonsDynamicShareRuleOutput', investmentSet?: { __typename?: 'GroupShareInvestmentSetFilterOutput', setId: number } | null } | null, documentsDynamicShare?: { __typename?: 'DocumentsDynamicShareRuleOutput', documentTypes?: Array<number> | null, investmentSet?: { __typename?: 'GroupShareInvestmentSetFilterOutput', setId: number } | null } | null } | null, sourceGroup?: { __typename?: 'User', id: number, commonName: string, userName: string, organizationId?: number | null, organization?: { __typename?: 'Organization', id: number, name: string } | null } | null, targetGroup?: { __typename?: 'User', id: number, commonName: string, userName: string, organizationId?: number | null, organization?: { __typename?: 'Organization', id: number, name: string } | null } | null };

export type GetListGroupShareDefinitionQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<GroupShareDefinitionSort> | GroupShareDefinitionSort>;
  filter?: InputMaybe<GroupShareDefinitionFilter>;
}>;


export type GetListGroupShareDefinitionQuery = { __typename?: 'Query', groupShareDefinitionList: { __typename?: 'GroupShareDefinitionList', total: number, items: Array<{ __typename?: 'GroupShareDefinition', id: number, dynamicDefinition?: string | null, sourceGroupId: number, targetGroupId: number, entityAccessId: number, isActive: boolean, lastExecuted?: string | null, createDate: string, modifyDate: string, createUser?: string | null, modifyUser?: string | null, dynamicDefinitionStructured?: { __typename?: 'DynamicDefinitionOutput', description?: string | null, displayName?: string | null, everything?: boolean | null, investmentsDynamicShare?: { __typename?: 'InvestmentsDynamicShareRuleOutput', investmentSet?: { __typename?: 'GroupShareInvestmentSetFilterOutput', setId: number } | null } | null, firmsDynamicShare?: { __typename?: 'FirmsDynamicShareRuleOutput', investmentSet?: { __typename?: 'GroupShareInvestmentSetFilterOutput', setId: number } | null } | null, personsDynamicShare?: { __typename?: 'PersonsDynamicShareRuleOutput', investmentSet?: { __typename?: 'GroupShareInvestmentSetFilterOutput', setId: number } | null } | null, documentsDynamicShare?: { __typename?: 'DocumentsDynamicShareRuleOutput', documentTypes?: Array<number> | null, investmentSet?: { __typename?: 'GroupShareInvestmentSetFilterOutput', setId: number } | null } | null } | null, sourceGroup?: { __typename?: 'User', id: number, commonName: string, userName: string, organizationId?: number | null, organization?: { __typename?: 'Organization', id: number, name: string } | null } | null, targetGroup?: { __typename?: 'User', id: number, commonName: string, userName: string, organizationId?: number | null, organization?: { __typename?: 'Organization', id: number, name: string } | null } | null }> } };

export type GetOneGroupShareDefinitionQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneGroupShareDefinitionQuery = { __typename?: 'Query', groupShareDefinition?: { __typename?: 'GroupShareDefinition', id: number, dynamicDefinition?: string | null, sourceGroupId: number, targetGroupId: number, entityAccessId: number, isActive: boolean, lastExecuted?: string | null, createDate: string, modifyDate: string, createUser?: string | null, modifyUser?: string | null, dynamicDefinitionStructured?: { __typename?: 'DynamicDefinitionOutput', description?: string | null, displayName?: string | null, everything?: boolean | null, investmentsDynamicShare?: { __typename?: 'InvestmentsDynamicShareRuleOutput', investmentSet?: { __typename?: 'GroupShareInvestmentSetFilterOutput', setId: number } | null } | null, firmsDynamicShare?: { __typename?: 'FirmsDynamicShareRuleOutput', investmentSet?: { __typename?: 'GroupShareInvestmentSetFilterOutput', setId: number } | null } | null, personsDynamicShare?: { __typename?: 'PersonsDynamicShareRuleOutput', investmentSet?: { __typename?: 'GroupShareInvestmentSetFilterOutput', setId: number } | null } | null, documentsDynamicShare?: { __typename?: 'DocumentsDynamicShareRuleOutput', documentTypes?: Array<number> | null, investmentSet?: { __typename?: 'GroupShareInvestmentSetFilterOutput', setId: number } | null } | null } | null, sourceGroup?: { __typename?: 'User', id: number, commonName: string, userName: string, organizationId?: number | null, organization?: { __typename?: 'Organization', id: number, name: string } | null } | null, targetGroup?: { __typename?: 'User', id: number, commonName: string, userName: string, organizationId?: number | null, organization?: { __typename?: 'Organization', id: number, name: string } | null } | null } | null };

export type GetManyGroupShareDefinitionQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyGroupShareDefinitionQuery = { __typename?: 'Query', groupShareDefinitionMany: Array<{ __typename?: 'GroupShareDefinition', id: number, dynamicDefinition?: string | null, sourceGroupId: number, targetGroupId: number, entityAccessId: number, isActive: boolean, lastExecuted?: string | null, createDate: string, modifyDate: string, createUser?: string | null, modifyUser?: string | null, dynamicDefinitionStructured?: { __typename?: 'DynamicDefinitionOutput', description?: string | null, displayName?: string | null, everything?: boolean | null, investmentsDynamicShare?: { __typename?: 'InvestmentsDynamicShareRuleOutput', investmentSet?: { __typename?: 'GroupShareInvestmentSetFilterOutput', setId: number } | null } | null, firmsDynamicShare?: { __typename?: 'FirmsDynamicShareRuleOutput', investmentSet?: { __typename?: 'GroupShareInvestmentSetFilterOutput', setId: number } | null } | null, personsDynamicShare?: { __typename?: 'PersonsDynamicShareRuleOutput', investmentSet?: { __typename?: 'GroupShareInvestmentSetFilterOutput', setId: number } | null } | null, documentsDynamicShare?: { __typename?: 'DocumentsDynamicShareRuleOutput', documentTypes?: Array<number> | null, investmentSet?: { __typename?: 'GroupShareInvestmentSetFilterOutput', setId: number } | null } | null } | null, sourceGroup?: { __typename?: 'User', id: number, commonName: string, userName: string, organizationId?: number | null, organization?: { __typename?: 'Organization', id: number, name: string } | null } | null, targetGroup?: { __typename?: 'User', id: number, commonName: string, userName: string, organizationId?: number | null, organization?: { __typename?: 'Organization', id: number, name: string } | null } | null } | null> };

export type CreateGroupShareDefinitionMutationVariables = Exact<{
  input: GroupShareDefinitionInput;
}>;


export type CreateGroupShareDefinitionMutation = { __typename?: 'Mutation', addGroupShareDefinition: { __typename?: 'GroupShareDefinition', id: number, dynamicDefinition?: string | null, sourceGroupId: number, targetGroupId: number, entityAccessId: number, isActive: boolean, lastExecuted?: string | null, createDate: string, modifyDate: string, createUser?: string | null, modifyUser?: string | null, dynamicDefinitionStructured?: { __typename?: 'DynamicDefinitionOutput', description?: string | null, displayName?: string | null, everything?: boolean | null, investmentsDynamicShare?: { __typename?: 'InvestmentsDynamicShareRuleOutput', investmentSet?: { __typename?: 'GroupShareInvestmentSetFilterOutput', setId: number } | null } | null, firmsDynamicShare?: { __typename?: 'FirmsDynamicShareRuleOutput', investmentSet?: { __typename?: 'GroupShareInvestmentSetFilterOutput', setId: number } | null } | null, personsDynamicShare?: { __typename?: 'PersonsDynamicShareRuleOutput', investmentSet?: { __typename?: 'GroupShareInvestmentSetFilterOutput', setId: number } | null } | null, documentsDynamicShare?: { __typename?: 'DocumentsDynamicShareRuleOutput', documentTypes?: Array<number> | null, investmentSet?: { __typename?: 'GroupShareInvestmentSetFilterOutput', setId: number } | null } | null } | null, sourceGroup?: { __typename?: 'User', id: number, commonName: string, userName: string, organizationId?: number | null, organization?: { __typename?: 'Organization', id: number, name: string } | null } | null, targetGroup?: { __typename?: 'User', id: number, commonName: string, userName: string, organizationId?: number | null, organization?: { __typename?: 'Organization', id: number, name: string } | null } | null } };

export type UpdateGroupShareDefinitionMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: GroupShareDefinitionInput;
}>;


export type UpdateGroupShareDefinitionMutation = { __typename?: 'Mutation', updateGroupShareDefinition: { __typename?: 'GroupShareDefinition', id: number, dynamicDefinition?: string | null, sourceGroupId: number, targetGroupId: number, entityAccessId: number, isActive: boolean, lastExecuted?: string | null, createDate: string, modifyDate: string, createUser?: string | null, modifyUser?: string | null, dynamicDefinitionStructured?: { __typename?: 'DynamicDefinitionOutput', description?: string | null, displayName?: string | null, everything?: boolean | null, investmentsDynamicShare?: { __typename?: 'InvestmentsDynamicShareRuleOutput', investmentSet?: { __typename?: 'GroupShareInvestmentSetFilterOutput', setId: number } | null } | null, firmsDynamicShare?: { __typename?: 'FirmsDynamicShareRuleOutput', investmentSet?: { __typename?: 'GroupShareInvestmentSetFilterOutput', setId: number } | null } | null, personsDynamicShare?: { __typename?: 'PersonsDynamicShareRuleOutput', investmentSet?: { __typename?: 'GroupShareInvestmentSetFilterOutput', setId: number } | null } | null, documentsDynamicShare?: { __typename?: 'DocumentsDynamicShareRuleOutput', documentTypes?: Array<number> | null, investmentSet?: { __typename?: 'GroupShareInvestmentSetFilterOutput', setId: number } | null } | null } | null, sourceGroup?: { __typename?: 'User', id: number, commonName: string, userName: string, organizationId?: number | null, organization?: { __typename?: 'Organization', id: number, name: string } | null } | null, targetGroup?: { __typename?: 'User', id: number, commonName: string, userName: string, organizationId?: number | null, organization?: { __typename?: 'Organization', id: number, name: string } | null } | null } };

export type DeleteGroupShareDefinitionMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteGroupShareDefinitionMutation = { __typename?: 'Mutation', deleteGroupShareDefinition: number };

export type GetListIconEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<IconEnumSort> | IconEnumSort>;
}>;


export type GetListIconEnumQuery = { __typename?: 'Query', iconEnumList: { __typename?: 'IconEnumList', total: number, items: Array<{ __typename?: 'IconEnum', id: string, name: string }> } };

export type GetOneIconEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneIconEnumQuery = { __typename?: 'Query', iconEnum?: { __typename?: 'IconEnum', id: string, name: string } | null };

export type GetManyIconEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyIconEnumQuery = { __typename?: 'Query', iconEnumMany: Array<{ __typename?: 'IconEnum', id: string, name: string } | null> };

export type GetImpactCategoryEnumListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetImpactCategoryEnumListQuery = { __typename?: 'Query', impactCategoryEnumList: { __typename?: 'ImpactCategoryEnumList', total: number, items: Array<{ __typename?: 'ImpactCategoryEnum', id: number, name?: string | null, impactEnums: Array<{ __typename?: 'ImpactEnum', id: number, name: string, displayOrder: number }> }> } };

export type GetListIndexCalcTypeEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<IndexCalcTypeEnumSort> | IndexCalcTypeEnumSort>;
}>;


export type GetListIndexCalcTypeEnumQuery = { __typename?: 'Query', indexCalcTypeEnumList: { __typename?: 'IndexCalcTypeEnumList', total: number, items: Array<{ __typename?: 'IndexCalcTypeEnum', id: number, indexCalcType: string }> } };

export type GetOneIndexCalcTypeEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneIndexCalcTypeEnumQuery = { __typename?: 'Query', indexCalcTypeEnum?: { __typename?: 'IndexCalcTypeEnum', id: number, indexCalcType: string } | null };

export type GetManyIndexCalcTypeEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyIndexCalcTypeEnumQuery = { __typename?: 'Query', indexCalcTypeEnumMany: Array<{ __typename?: 'IndexCalcTypeEnum', id: number, indexCalcType: string } | null> };

export type InstitutionEmploymentAttributesFragment = { __typename?: 'InstitutionEmployment', id: number, institutionId: number, personId: number, startDate?: string | null, leftDate?: string | null, isPrimaryContact?: boolean | null, person: { __typename?: 'Person', id: number, fullName?: string | null }, institution: { __typename?: 'Institution', id: number, name: string } };

export type GetListInstitutionEmploymentQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InstitutionEmploymentSort> | InstitutionEmploymentSort>;
  filter?: InputMaybe<InstitutionEmploymentFilter>;
}>;


export type GetListInstitutionEmploymentQuery = { __typename?: 'Query', institutionEmploymentList: { __typename?: 'InstitutionEmploymentList', total: number, items: Array<{ __typename?: 'InstitutionEmployment', id: number, institutionId: number, personId: number, startDate?: string | null, leftDate?: string | null, isPrimaryContact?: boolean | null, person: { __typename?: 'Person', id: number, fullName?: string | null }, institution: { __typename?: 'Institution', id: number, name: string } }> } };

export type GetOneInstitutionEmploymentQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneInstitutionEmploymentQuery = { __typename?: 'Query', institutionEmployment?: { __typename?: 'InstitutionEmployment', id: number, institutionId: number, personId: number, startDate?: string | null, leftDate?: string | null, isPrimaryContact?: boolean | null, person: { __typename?: 'Person', id: number, fullName?: string | null }, institution: { __typename?: 'Institution', id: number, name: string } } | null };

export type GetManyInstitutionEmploymentQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyInstitutionEmploymentQuery = { __typename?: 'Query', institutionEmploymentMany: Array<{ __typename?: 'InstitutionEmployment', id: number, institutionId: number, personId: number, startDate?: string | null, leftDate?: string | null, isPrimaryContact?: boolean | null, person: { __typename?: 'Person', id: number, fullName?: string | null }, institution: { __typename?: 'Institution', id: number, name: string } } | null> };

export type CreateInstitutionEmploymentMutationVariables = Exact<{
  input: InstitutionEmploymentInput;
}>;


export type CreateInstitutionEmploymentMutation = { __typename?: 'Mutation', addInstitutionEmployment: { __typename?: 'InstitutionEmployment', id: number } };

export type UpdateInstitutionEmploymentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: InstitutionEmploymentInput;
}>;


export type UpdateInstitutionEmploymentMutation = { __typename?: 'Mutation', updateInstitutionEmployment: { __typename?: 'InstitutionEmployment', id: number } };

export type GetListinstitutionInstitutionTypeEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InstitutionsInstitutionTypeEnumSort> | InstitutionsInstitutionTypeEnumSort>;
  filter?: InputMaybe<InstitutionsInstitutionTypeEnumFilterInput>;
}>;


export type GetListinstitutionInstitutionTypeEnumQuery = { __typename?: 'Query', institutionsInstitutionTypeEnumList: { __typename?: 'InstitutionsInstitutionTypeEnumList', total: number, items: Array<{ __typename?: 'InstitutionsInstitutionTypeEnum', id: number, institutionId: number, institutionTypeEnumId: number, institutionTypeEnum: { __typename?: 'InstitutionTypeEnum', id: number, name: string } }> } };

export type GetOneinstitutionInstitutionTypeEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneinstitutionInstitutionTypeEnumQuery = { __typename?: 'Query', institutionsInstitutionTypeEnum?: { __typename?: 'InstitutionsInstitutionTypeEnum', id: number, institutionId: number, institutionTypeEnumId: number, institutionTypeEnum: { __typename?: 'InstitutionTypeEnum', id: number, name: string } } | null };

export type GetManyinstitutionInstitutionTypeEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyinstitutionInstitutionTypeEnumQuery = { __typename?: 'Query', institutionsInstitutionTypeEnumMany: Array<{ __typename?: 'InstitutionsInstitutionTypeEnum', id: number, institutionId: number, institutionTypeEnumId: number, institutionTypeEnum: { __typename?: 'InstitutionTypeEnum', id: number, name: string } } | null> };

export type InstitutionSelectionStatusEnumAttributesFragment = { __typename?: 'InstitutionSelectionStatusEnum', id: number, name: string };

export type GetListInstitutionSelectionStatusEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InstitutionSelectionStatusEnumSort> | InstitutionSelectionStatusEnumSort>;
  filter?: InputMaybe<InstitutionSelectionStatusEnumFilter>;
}>;


export type GetListInstitutionSelectionStatusEnumQuery = { __typename?: 'Query', institutionSelectionStatusEnumList: { __typename?: 'InstitutionSelectionStatusEnumList', total: number, items: Array<{ __typename?: 'InstitutionSelectionStatusEnum', id: number, name: string }> } };

export type GetOneInstitutionSelectionStatusEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneInstitutionSelectionStatusEnumQuery = { __typename?: 'Query', institutionSelectionStatusEnum?: { __typename?: 'InstitutionSelectionStatusEnum', id: number, name: string } | null };

export type GetManyInstitutionSelectionStatusEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyInstitutionSelectionStatusEnumQuery = { __typename?: 'Query', institutionSelectionStatusEnumMany: Array<{ __typename?: 'InstitutionSelectionStatusEnum', id: number, name: string } | null> };

export type GetListInstitutionTypeEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InstitutionTypeEnumSort> | InstitutionTypeEnumSort>;
  filter?: InputMaybe<InstitutionTypeEnumFilterInput>;
}>;


export type GetListInstitutionTypeEnumQuery = { __typename?: 'Query', institutionTypeEnumList: { __typename?: 'InstitutionTypeEnumList', total: number, items: Array<{ __typename?: 'InstitutionTypeEnum', id: number, name: string }> } };

export type GetOneInstitutionTypeEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneInstitutionTypeEnumQuery = { __typename?: 'Query', institutionTypeEnum?: { __typename?: 'InstitutionTypeEnum', id: number, name: string } | null };

export type GetManyInstitutionTypeEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyInstitutionTypeEnumQuery = { __typename?: 'Query', institutionTypeEnumMany: Array<{ __typename?: 'InstitutionTypeEnum', id: number, name: string } | null> };

export type InvestmentAttributesFragment = { __typename?: 'Investment', id: number, assetClassEnumId?: number | null, atlasInvestmentId?: string | null, targetRaise?: number | null, hardCap?: number | null, committedCapital?: number | null, committedCapitalCurrencyId?: number | null, currencyDenominationEnumId?: number | null, fundLinkId?: number | null, domicileFundLinkId?: number | null, reportingLinkId?: number | null, isLiquidated?: boolean | null, isManagerUnwillingToProvidePerformance?: boolean | null, isManagerUnwillingToProvidePositions?: boolean | null, isManagerUnwillingToProvideRisk?: boolean | null, isManagerUnwillingToProvideAUM?: boolean | null, liquidationDate?: string | null, liquidationNote?: string | null, HFRIInvestmentId?: number | null, evestmentId?: number | null, burgissId?: any | null, bloombergCode?: string | null, bloombergField?: string | null, RICId?: string | null, ndaSigned?: boolean | null, vehicleTypeEnumId?: number | null, marketEnumId?: number | null, createDate?: string | null, createUser?: string | null, domicileCountryId?: number | null, domicileUSStateId?: number | null, familyId?: number | null, firmId?: number | null, gpCommitted?: number | null, gpCommittedCurrencyId?: number | null, inceptionDate?: string | null, isESG?: boolean | null, isImpact?: boolean | null, isOffshore?: boolean | null, isPartner?: boolean | null, isSubAdvised?: boolean | null, accountTypeEnumId?: number | null, advisorTypeEnumId?: number | null, advisorId?: number | null, isWorkInProgress?: boolean | null, shortName?: string | null, listEnumId?: number | null, maxExpectedVolatility?: number | null, maxGrossExposure?: number | null, maxNetExposure?: number | null, maxTargetNetIRR?: number | null, maxTargetNetMOIC?: number | null, minExpectedVolatility?: number | null, minGrossExposure?: number | null, fiscalYearEndMonth?: number | null, minNetExposure?: number | null, minTargetNetIRR?: number | null, minTargetNetMOIC?: number | null, modifyDate?: string | null, modifyUser?: string | null, name: string, peLegalLifeYrs?: number | null, peFundNumberEnumId?: number | null, peStrategyEnumId?: number | null, peSubStrategyEnumId?: number | null, primaryAssignment?: string | null, primaryBenchmarkId?: number | null, secondaryAssignment?: string | null, secondaryBenchmarkId?: number | null, strategyEnumId?: number | null, subStrategyEnumId?: number | null, summary?: string | null, uniqueSecurityCode?: string | null, vintageYear?: number | null, primaryGeographicFocusId?: number | null, otherGeographicFocusIds?: Array<number> | null, investmentStructureEnumId?: number | null, legalStructureEnumId?: number | null, isRegisteredInvestmentCompany?: boolean | null, organizationStructureEnumId?: number | null, NAVClassificationEnumId?: number | null, pricingFrequencyEnumId?: number | null, performanceSource?: string | null, performanceSourceEnumId?: number | null, reportingDate?: string | null, reportingDateReason?: string | null, indexCalcTypeEnumId?: number | null, committedCapitalCurrency?: { __typename?: 'CurrencyDenominationEnum', id: number, name: string } | null, portalSubmitted?: { __typename?: 'PortalSubmitted', migratedAt?: string | null } | null, currencyDenominationEnum?: { __typename?: 'CurrencyDenominationEnum', id: number, name: string } | null, assetClass?: { __typename?: 'AssetClass2Enum', id: number, name: string } | null, vehicleType?: { __typename?: 'VehicleTypeEnum', id: number, name: string } | null, market?: { __typename?: 'AssetClassEnum', id: number, name: string } | null, domicileCountry?: { __typename?: 'CountryEnum', id: number, name: string } | null, domicileUSState?: { __typename?: 'StateEnum', id: number, name: string } | null, family?: { __typename?: 'Family', id: number, name: string } | null, firm?: { __typename?: 'Firm', id: number, name: string, isCompany?: boolean | null, companyId?: number | null } | null, gpCommittedCurrency?: { __typename?: 'CurrencyDenominationEnum', id: number, name: string } | null, advisor?: { __typename?: 'Firm', id: number, name: string } | null, list?: { __typename?: 'InvestmentListEnum', id: number, name: string } | null, peFundNumber?: { __typename?: 'PEFundNumberEnum', id: number, name: string } | null, peStrategy?: { __typename?: 'PEStrategyEnum', id: number, name: string } | null, peSubStrategy?: { __typename?: 'PESubStrategyEnum', id: number, name: string } | null, primaryBenchmark?: { __typename?: 'Investment', id: number, name: string } | null, secondaryBenchmark?: { __typename?: 'Investment', id: number, name: string } | null, strategy?: { __typename?: 'StrategyEnum', id: number, name: string } | null, subStrategy?: { __typename?: 'SubStrategyEnum', id: number, name: string } | null, primaryGeographicFocus?: { __typename?: 'GeographicFocusEnum', id: number, name: string } | null, otherGeographicFocuses?: Array<{ __typename?: 'GeographicFocusEnum', id: number, name: string }> | null, investmentStructure?: { __typename?: 'InvestmentStructureEnum', id: string, name: string } | null, legalStructure?: { __typename?: 'LegalStructureEnum', id: string, name: string } | null, organizationStructure?: { __typename?: 'OrganizationStructureEnum', id: string, name: string } | null, NAVClassification?: { __typename?: 'NAVClassificationEnum', id: string, name: string } | null, pricingFrequency?: { __typename?: 'PricingFrequencyEnum', id: string, name: string } | null, investmentTags?: Array<{ __typename?: 'InvestmentTags', id: number, tagId: number, tagClassId: number, tag: { __typename?: 'Tag', id: number, name: string, tagClassId: number } }> | null, closeDateFundSize?: Array<{ __typename?: 'CloseDateFundSize', fundSize: number, closeDate: string }> | null, investmentXImpact?: Array<{ __typename?: 'InvestmentXImpact', impactEnumId: number, impactEnum: { __typename?: 'ImpactEnum', id: number, name: string } }> | null, registeredAddressProvider?: { __typename?: 'Institution', id: number, name: string, addressesId: number, address: { __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, zipCode?: string | null, countryEnumId?: number | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null } } | null, indexCalcTypeEnum?: { __typename?: 'IndexCalcTypeEnum', id: number, indexCalcType: string } | null, access?: { __typename?: 'EntityAccess', read?: boolean | null, update?: boolean | null, delete?: boolean | null, preview?: boolean | null } | null, fundsXProxies?: Array<{ __typename?: 'FundsXProxies', id: number, investmentId: number, proxyId: number, proxyScalingFactor?: number | null, rank: number, proxy: { __typename?: 'Investment', id: number, name: string } }> | null };

export type GetListInvestmentQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentSort> | InvestmentSort>;
  searchFilters?: InputMaybe<Array<InvestmentSearchFilters> | InvestmentSearchFilters>;
  filter?: InputMaybe<InvestmentFilterInput>;
}>;


export type GetListInvestmentQuery = { __typename?: 'Query', investmentList: { __typename?: 'InvestmentList', total: number, items: Array<{ __typename?: 'Investment', id: number, assetClassEnumId?: number | null, atlasInvestmentId?: string | null, targetRaise?: number | null, hardCap?: number | null, committedCapital?: number | null, committedCapitalCurrencyId?: number | null, currencyDenominationEnumId?: number | null, fundLinkId?: number | null, domicileFundLinkId?: number | null, reportingLinkId?: number | null, isLiquidated?: boolean | null, isManagerUnwillingToProvidePerformance?: boolean | null, isManagerUnwillingToProvidePositions?: boolean | null, isManagerUnwillingToProvideRisk?: boolean | null, isManagerUnwillingToProvideAUM?: boolean | null, liquidationDate?: string | null, liquidationNote?: string | null, HFRIInvestmentId?: number | null, evestmentId?: number | null, burgissId?: any | null, bloombergCode?: string | null, bloombergField?: string | null, RICId?: string | null, ndaSigned?: boolean | null, vehicleTypeEnumId?: number | null, marketEnumId?: number | null, createDate?: string | null, createUser?: string | null, domicileCountryId?: number | null, domicileUSStateId?: number | null, familyId?: number | null, firmId?: number | null, gpCommitted?: number | null, gpCommittedCurrencyId?: number | null, inceptionDate?: string | null, isESG?: boolean | null, isImpact?: boolean | null, isOffshore?: boolean | null, isPartner?: boolean | null, isSubAdvised?: boolean | null, accountTypeEnumId?: number | null, advisorTypeEnumId?: number | null, advisorId?: number | null, isWorkInProgress?: boolean | null, shortName?: string | null, listEnumId?: number | null, maxExpectedVolatility?: number | null, maxGrossExposure?: number | null, maxNetExposure?: number | null, maxTargetNetIRR?: number | null, maxTargetNetMOIC?: number | null, minExpectedVolatility?: number | null, minGrossExposure?: number | null, fiscalYearEndMonth?: number | null, minNetExposure?: number | null, minTargetNetIRR?: number | null, minTargetNetMOIC?: number | null, modifyDate?: string | null, modifyUser?: string | null, name: string, peLegalLifeYrs?: number | null, peFundNumberEnumId?: number | null, peStrategyEnumId?: number | null, peSubStrategyEnumId?: number | null, primaryAssignment?: string | null, primaryBenchmarkId?: number | null, secondaryAssignment?: string | null, secondaryBenchmarkId?: number | null, strategyEnumId?: number | null, subStrategyEnumId?: number | null, summary?: string | null, uniqueSecurityCode?: string | null, vintageYear?: number | null, primaryGeographicFocusId?: number | null, otherGeographicFocusIds?: Array<number> | null, investmentStructureEnumId?: number | null, legalStructureEnumId?: number | null, isRegisteredInvestmentCompany?: boolean | null, organizationStructureEnumId?: number | null, NAVClassificationEnumId?: number | null, pricingFrequencyEnumId?: number | null, performanceSource?: string | null, performanceSourceEnumId?: number | null, reportingDate?: string | null, reportingDateReason?: string | null, indexCalcTypeEnumId?: number | null, committedCapitalCurrency?: { __typename?: 'CurrencyDenominationEnum', id: number, name: string } | null, portalSubmitted?: { __typename?: 'PortalSubmitted', migratedAt?: string | null } | null, currencyDenominationEnum?: { __typename?: 'CurrencyDenominationEnum', id: number, name: string } | null, assetClass?: { __typename?: 'AssetClass2Enum', id: number, name: string } | null, vehicleType?: { __typename?: 'VehicleTypeEnum', id: number, name: string } | null, market?: { __typename?: 'AssetClassEnum', id: number, name: string } | null, domicileCountry?: { __typename?: 'CountryEnum', id: number, name: string } | null, domicileUSState?: { __typename?: 'StateEnum', id: number, name: string } | null, family?: { __typename?: 'Family', id: number, name: string } | null, firm?: { __typename?: 'Firm', id: number, name: string, isCompany?: boolean | null, companyId?: number | null } | null, gpCommittedCurrency?: { __typename?: 'CurrencyDenominationEnum', id: number, name: string } | null, advisor?: { __typename?: 'Firm', id: number, name: string } | null, list?: { __typename?: 'InvestmentListEnum', id: number, name: string } | null, peFundNumber?: { __typename?: 'PEFundNumberEnum', id: number, name: string } | null, peStrategy?: { __typename?: 'PEStrategyEnum', id: number, name: string } | null, peSubStrategy?: { __typename?: 'PESubStrategyEnum', id: number, name: string } | null, primaryBenchmark?: { __typename?: 'Investment', id: number, name: string } | null, secondaryBenchmark?: { __typename?: 'Investment', id: number, name: string } | null, strategy?: { __typename?: 'StrategyEnum', id: number, name: string } | null, subStrategy?: { __typename?: 'SubStrategyEnum', id: number, name: string } | null, primaryGeographicFocus?: { __typename?: 'GeographicFocusEnum', id: number, name: string } | null, otherGeographicFocuses?: Array<{ __typename?: 'GeographicFocusEnum', id: number, name: string }> | null, investmentStructure?: { __typename?: 'InvestmentStructureEnum', id: string, name: string } | null, legalStructure?: { __typename?: 'LegalStructureEnum', id: string, name: string } | null, organizationStructure?: { __typename?: 'OrganizationStructureEnum', id: string, name: string } | null, NAVClassification?: { __typename?: 'NAVClassificationEnum', id: string, name: string } | null, pricingFrequency?: { __typename?: 'PricingFrequencyEnum', id: string, name: string } | null, investmentTags?: Array<{ __typename?: 'InvestmentTags', id: number, tagId: number, tagClassId: number, tag: { __typename?: 'Tag', id: number, name: string, tagClassId: number } }> | null, closeDateFundSize?: Array<{ __typename?: 'CloseDateFundSize', fundSize: number, closeDate: string }> | null, investmentXImpact?: Array<{ __typename?: 'InvestmentXImpact', impactEnumId: number, impactEnum: { __typename?: 'ImpactEnum', id: number, name: string } }> | null, registeredAddressProvider?: { __typename?: 'Institution', id: number, name: string, addressesId: number, address: { __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, zipCode?: string | null, countryEnumId?: number | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null } } | null, indexCalcTypeEnum?: { __typename?: 'IndexCalcTypeEnum', id: number, indexCalcType: string } | null, access?: { __typename?: 'EntityAccess', read?: boolean | null, update?: boolean | null, delete?: boolean | null, preview?: boolean | null } | null, fundsXProxies?: Array<{ __typename?: 'FundsXProxies', id: number, investmentId: number, proxyId: number, proxyScalingFactor?: number | null, rank: number, proxy: { __typename?: 'Investment', id: number, name: string } }> | null }> } };

export type GetOneInvestmentQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneInvestmentQuery = { __typename?: 'Query', investment: { __typename?: 'Investment', id: number, assetClassEnumId?: number | null, atlasInvestmentId?: string | null, targetRaise?: number | null, hardCap?: number | null, committedCapital?: number | null, committedCapitalCurrencyId?: number | null, currencyDenominationEnumId?: number | null, fundLinkId?: number | null, domicileFundLinkId?: number | null, reportingLinkId?: number | null, isLiquidated?: boolean | null, isManagerUnwillingToProvidePerformance?: boolean | null, isManagerUnwillingToProvidePositions?: boolean | null, isManagerUnwillingToProvideRisk?: boolean | null, isManagerUnwillingToProvideAUM?: boolean | null, liquidationDate?: string | null, liquidationNote?: string | null, HFRIInvestmentId?: number | null, evestmentId?: number | null, burgissId?: any | null, bloombergCode?: string | null, bloombergField?: string | null, RICId?: string | null, ndaSigned?: boolean | null, vehicleTypeEnumId?: number | null, marketEnumId?: number | null, createDate?: string | null, createUser?: string | null, domicileCountryId?: number | null, domicileUSStateId?: number | null, familyId?: number | null, firmId?: number | null, gpCommitted?: number | null, gpCommittedCurrencyId?: number | null, inceptionDate?: string | null, isESG?: boolean | null, isImpact?: boolean | null, isOffshore?: boolean | null, isPartner?: boolean | null, isSubAdvised?: boolean | null, accountTypeEnumId?: number | null, advisorTypeEnumId?: number | null, advisorId?: number | null, isWorkInProgress?: boolean | null, shortName?: string | null, listEnumId?: number | null, maxExpectedVolatility?: number | null, maxGrossExposure?: number | null, maxNetExposure?: number | null, maxTargetNetIRR?: number | null, maxTargetNetMOIC?: number | null, minExpectedVolatility?: number | null, minGrossExposure?: number | null, fiscalYearEndMonth?: number | null, minNetExposure?: number | null, minTargetNetIRR?: number | null, minTargetNetMOIC?: number | null, modifyDate?: string | null, modifyUser?: string | null, name: string, peLegalLifeYrs?: number | null, peFundNumberEnumId?: number | null, peStrategyEnumId?: number | null, peSubStrategyEnumId?: number | null, primaryAssignment?: string | null, primaryBenchmarkId?: number | null, secondaryAssignment?: string | null, secondaryBenchmarkId?: number | null, strategyEnumId?: number | null, subStrategyEnumId?: number | null, summary?: string | null, uniqueSecurityCode?: string | null, vintageYear?: number | null, primaryGeographicFocusId?: number | null, otherGeographicFocusIds?: Array<number> | null, investmentStructureEnumId?: number | null, legalStructureEnumId?: number | null, isRegisteredInvestmentCompany?: boolean | null, organizationStructureEnumId?: number | null, NAVClassificationEnumId?: number | null, pricingFrequencyEnumId?: number | null, performanceSource?: string | null, performanceSourceEnumId?: number | null, reportingDate?: string | null, reportingDateReason?: string | null, indexCalcTypeEnumId?: number | null, committedCapitalCurrency?: { __typename?: 'CurrencyDenominationEnum', id: number, name: string } | null, portalSubmitted?: { __typename?: 'PortalSubmitted', migratedAt?: string | null } | null, currencyDenominationEnum?: { __typename?: 'CurrencyDenominationEnum', id: number, name: string } | null, assetClass?: { __typename?: 'AssetClass2Enum', id: number, name: string } | null, vehicleType?: { __typename?: 'VehicleTypeEnum', id: number, name: string } | null, market?: { __typename?: 'AssetClassEnum', id: number, name: string } | null, domicileCountry?: { __typename?: 'CountryEnum', id: number, name: string } | null, domicileUSState?: { __typename?: 'StateEnum', id: number, name: string } | null, family?: { __typename?: 'Family', id: number, name: string } | null, firm?: { __typename?: 'Firm', id: number, name: string, isCompany?: boolean | null, companyId?: number | null } | null, gpCommittedCurrency?: { __typename?: 'CurrencyDenominationEnum', id: number, name: string } | null, advisor?: { __typename?: 'Firm', id: number, name: string } | null, list?: { __typename?: 'InvestmentListEnum', id: number, name: string } | null, peFundNumber?: { __typename?: 'PEFundNumberEnum', id: number, name: string } | null, peStrategy?: { __typename?: 'PEStrategyEnum', id: number, name: string } | null, peSubStrategy?: { __typename?: 'PESubStrategyEnum', id: number, name: string } | null, primaryBenchmark?: { __typename?: 'Investment', id: number, name: string } | null, secondaryBenchmark?: { __typename?: 'Investment', id: number, name: string } | null, strategy?: { __typename?: 'StrategyEnum', id: number, name: string } | null, subStrategy?: { __typename?: 'SubStrategyEnum', id: number, name: string } | null, primaryGeographicFocus?: { __typename?: 'GeographicFocusEnum', id: number, name: string } | null, otherGeographicFocuses?: Array<{ __typename?: 'GeographicFocusEnum', id: number, name: string }> | null, investmentStructure?: { __typename?: 'InvestmentStructureEnum', id: string, name: string } | null, legalStructure?: { __typename?: 'LegalStructureEnum', id: string, name: string } | null, organizationStructure?: { __typename?: 'OrganizationStructureEnum', id: string, name: string } | null, NAVClassification?: { __typename?: 'NAVClassificationEnum', id: string, name: string } | null, pricingFrequency?: { __typename?: 'PricingFrequencyEnum', id: string, name: string } | null, investmentTags?: Array<{ __typename?: 'InvestmentTags', id: number, tagId: number, tagClassId: number, tag: { __typename?: 'Tag', id: number, name: string, tagClassId: number } }> | null, closeDateFundSize?: Array<{ __typename?: 'CloseDateFundSize', fundSize: number, closeDate: string }> | null, investmentXImpact?: Array<{ __typename?: 'InvestmentXImpact', impactEnumId: number, impactEnum: { __typename?: 'ImpactEnum', id: number, name: string } }> | null, registeredAddressProvider?: { __typename?: 'Institution', id: number, name: string, addressesId: number, address: { __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, zipCode?: string | null, countryEnumId?: number | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null } } | null, indexCalcTypeEnum?: { __typename?: 'IndexCalcTypeEnum', id: number, indexCalcType: string } | null, access?: { __typename?: 'EntityAccess', read?: boolean | null, update?: boolean | null, delete?: boolean | null, preview?: boolean | null } | null, fundsXProxies?: Array<{ __typename?: 'FundsXProxies', id: number, investmentId: number, proxyId: number, proxyScalingFactor?: number | null, rank: number, proxy: { __typename?: 'Investment', id: number, name: string } }> | null } };

export type GetManyInvestmentQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyInvestmentQuery = { __typename?: 'Query', investmentMany: Array<{ __typename?: 'Investment', id: number, assetClassEnumId?: number | null, atlasInvestmentId?: string | null, targetRaise?: number | null, hardCap?: number | null, committedCapital?: number | null, committedCapitalCurrencyId?: number | null, currencyDenominationEnumId?: number | null, fundLinkId?: number | null, domicileFundLinkId?: number | null, reportingLinkId?: number | null, isLiquidated?: boolean | null, isManagerUnwillingToProvidePerformance?: boolean | null, isManagerUnwillingToProvidePositions?: boolean | null, isManagerUnwillingToProvideRisk?: boolean | null, isManagerUnwillingToProvideAUM?: boolean | null, liquidationDate?: string | null, liquidationNote?: string | null, HFRIInvestmentId?: number | null, evestmentId?: number | null, burgissId?: any | null, bloombergCode?: string | null, bloombergField?: string | null, RICId?: string | null, ndaSigned?: boolean | null, vehicleTypeEnumId?: number | null, marketEnumId?: number | null, createDate?: string | null, createUser?: string | null, domicileCountryId?: number | null, domicileUSStateId?: number | null, familyId?: number | null, firmId?: number | null, gpCommitted?: number | null, gpCommittedCurrencyId?: number | null, inceptionDate?: string | null, isESG?: boolean | null, isImpact?: boolean | null, isOffshore?: boolean | null, isPartner?: boolean | null, isSubAdvised?: boolean | null, accountTypeEnumId?: number | null, advisorTypeEnumId?: number | null, advisorId?: number | null, isWorkInProgress?: boolean | null, shortName?: string | null, listEnumId?: number | null, maxExpectedVolatility?: number | null, maxGrossExposure?: number | null, maxNetExposure?: number | null, maxTargetNetIRR?: number | null, maxTargetNetMOIC?: number | null, minExpectedVolatility?: number | null, minGrossExposure?: number | null, fiscalYearEndMonth?: number | null, minNetExposure?: number | null, minTargetNetIRR?: number | null, minTargetNetMOIC?: number | null, modifyDate?: string | null, modifyUser?: string | null, name: string, peLegalLifeYrs?: number | null, peFundNumberEnumId?: number | null, peStrategyEnumId?: number | null, peSubStrategyEnumId?: number | null, primaryAssignment?: string | null, primaryBenchmarkId?: number | null, secondaryAssignment?: string | null, secondaryBenchmarkId?: number | null, strategyEnumId?: number | null, subStrategyEnumId?: number | null, summary?: string | null, uniqueSecurityCode?: string | null, vintageYear?: number | null, primaryGeographicFocusId?: number | null, otherGeographicFocusIds?: Array<number> | null, investmentStructureEnumId?: number | null, legalStructureEnumId?: number | null, isRegisteredInvestmentCompany?: boolean | null, organizationStructureEnumId?: number | null, NAVClassificationEnumId?: number | null, pricingFrequencyEnumId?: number | null, performanceSource?: string | null, performanceSourceEnumId?: number | null, reportingDate?: string | null, reportingDateReason?: string | null, indexCalcTypeEnumId?: number | null, committedCapitalCurrency?: { __typename?: 'CurrencyDenominationEnum', id: number, name: string } | null, portalSubmitted?: { __typename?: 'PortalSubmitted', migratedAt?: string | null } | null, currencyDenominationEnum?: { __typename?: 'CurrencyDenominationEnum', id: number, name: string } | null, assetClass?: { __typename?: 'AssetClass2Enum', id: number, name: string } | null, vehicleType?: { __typename?: 'VehicleTypeEnum', id: number, name: string } | null, market?: { __typename?: 'AssetClassEnum', id: number, name: string } | null, domicileCountry?: { __typename?: 'CountryEnum', id: number, name: string } | null, domicileUSState?: { __typename?: 'StateEnum', id: number, name: string } | null, family?: { __typename?: 'Family', id: number, name: string } | null, firm?: { __typename?: 'Firm', id: number, name: string, isCompany?: boolean | null, companyId?: number | null } | null, gpCommittedCurrency?: { __typename?: 'CurrencyDenominationEnum', id: number, name: string } | null, advisor?: { __typename?: 'Firm', id: number, name: string } | null, list?: { __typename?: 'InvestmentListEnum', id: number, name: string } | null, peFundNumber?: { __typename?: 'PEFundNumberEnum', id: number, name: string } | null, peStrategy?: { __typename?: 'PEStrategyEnum', id: number, name: string } | null, peSubStrategy?: { __typename?: 'PESubStrategyEnum', id: number, name: string } | null, primaryBenchmark?: { __typename?: 'Investment', id: number, name: string } | null, secondaryBenchmark?: { __typename?: 'Investment', id: number, name: string } | null, strategy?: { __typename?: 'StrategyEnum', id: number, name: string } | null, subStrategy?: { __typename?: 'SubStrategyEnum', id: number, name: string } | null, primaryGeographicFocus?: { __typename?: 'GeographicFocusEnum', id: number, name: string } | null, otherGeographicFocuses?: Array<{ __typename?: 'GeographicFocusEnum', id: number, name: string }> | null, investmentStructure?: { __typename?: 'InvestmentStructureEnum', id: string, name: string } | null, legalStructure?: { __typename?: 'LegalStructureEnum', id: string, name: string } | null, organizationStructure?: { __typename?: 'OrganizationStructureEnum', id: string, name: string } | null, NAVClassification?: { __typename?: 'NAVClassificationEnum', id: string, name: string } | null, pricingFrequency?: { __typename?: 'PricingFrequencyEnum', id: string, name: string } | null, investmentTags?: Array<{ __typename?: 'InvestmentTags', id: number, tagId: number, tagClassId: number, tag: { __typename?: 'Tag', id: number, name: string, tagClassId: number } }> | null, closeDateFundSize?: Array<{ __typename?: 'CloseDateFundSize', fundSize: number, closeDate: string }> | null, investmentXImpact?: Array<{ __typename?: 'InvestmentXImpact', impactEnumId: number, impactEnum: { __typename?: 'ImpactEnum', id: number, name: string } }> | null, registeredAddressProvider?: { __typename?: 'Institution', id: number, name: string, addressesId: number, address: { __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, zipCode?: string | null, countryEnumId?: number | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null } } | null, indexCalcTypeEnum?: { __typename?: 'IndexCalcTypeEnum', id: number, indexCalcType: string } | null, access?: { __typename?: 'EntityAccess', read?: boolean | null, update?: boolean | null, delete?: boolean | null, preview?: boolean | null } | null, fundsXProxies?: Array<{ __typename?: 'FundsXProxies', id: number, investmentId: number, proxyId: number, proxyScalingFactor?: number | null, rank: number, proxy: { __typename?: 'Investment', id: number, name: string } }> | null } | null> };

export type GetManyReferenceInvestmentQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentSort> | InvestmentSort>;
  filter?: InputMaybe<InvestmentFilterInput>;
}>;


export type GetManyReferenceInvestmentQuery = { __typename?: 'Query', investmentList: { __typename?: 'InvestmentList', total: number, items: Array<{ __typename?: 'Investment', id: number, assetClassEnumId?: number | null, atlasInvestmentId?: string | null, targetRaise?: number | null, hardCap?: number | null, committedCapital?: number | null, committedCapitalCurrencyId?: number | null, currencyDenominationEnumId?: number | null, fundLinkId?: number | null, domicileFundLinkId?: number | null, reportingLinkId?: number | null, isLiquidated?: boolean | null, isManagerUnwillingToProvidePerformance?: boolean | null, isManagerUnwillingToProvidePositions?: boolean | null, isManagerUnwillingToProvideRisk?: boolean | null, isManagerUnwillingToProvideAUM?: boolean | null, liquidationDate?: string | null, liquidationNote?: string | null, HFRIInvestmentId?: number | null, evestmentId?: number | null, burgissId?: any | null, bloombergCode?: string | null, bloombergField?: string | null, RICId?: string | null, ndaSigned?: boolean | null, vehicleTypeEnumId?: number | null, marketEnumId?: number | null, createDate?: string | null, createUser?: string | null, domicileCountryId?: number | null, domicileUSStateId?: number | null, familyId?: number | null, firmId?: number | null, gpCommitted?: number | null, gpCommittedCurrencyId?: number | null, inceptionDate?: string | null, isESG?: boolean | null, isImpact?: boolean | null, isOffshore?: boolean | null, isPartner?: boolean | null, isSubAdvised?: boolean | null, accountTypeEnumId?: number | null, advisorTypeEnumId?: number | null, advisorId?: number | null, isWorkInProgress?: boolean | null, shortName?: string | null, listEnumId?: number | null, maxExpectedVolatility?: number | null, maxGrossExposure?: number | null, maxNetExposure?: number | null, maxTargetNetIRR?: number | null, maxTargetNetMOIC?: number | null, minExpectedVolatility?: number | null, minGrossExposure?: number | null, fiscalYearEndMonth?: number | null, minNetExposure?: number | null, minTargetNetIRR?: number | null, minTargetNetMOIC?: number | null, modifyDate?: string | null, modifyUser?: string | null, name: string, peLegalLifeYrs?: number | null, peFundNumberEnumId?: number | null, peStrategyEnumId?: number | null, peSubStrategyEnumId?: number | null, primaryAssignment?: string | null, primaryBenchmarkId?: number | null, secondaryAssignment?: string | null, secondaryBenchmarkId?: number | null, strategyEnumId?: number | null, subStrategyEnumId?: number | null, summary?: string | null, uniqueSecurityCode?: string | null, vintageYear?: number | null, primaryGeographicFocusId?: number | null, otherGeographicFocusIds?: Array<number> | null, investmentStructureEnumId?: number | null, legalStructureEnumId?: number | null, isRegisteredInvestmentCompany?: boolean | null, organizationStructureEnumId?: number | null, NAVClassificationEnumId?: number | null, pricingFrequencyEnumId?: number | null, performanceSource?: string | null, performanceSourceEnumId?: number | null, reportingDate?: string | null, reportingDateReason?: string | null, indexCalcTypeEnumId?: number | null, committedCapitalCurrency?: { __typename?: 'CurrencyDenominationEnum', id: number, name: string } | null, portalSubmitted?: { __typename?: 'PortalSubmitted', migratedAt?: string | null } | null, currencyDenominationEnum?: { __typename?: 'CurrencyDenominationEnum', id: number, name: string } | null, assetClass?: { __typename?: 'AssetClass2Enum', id: number, name: string } | null, vehicleType?: { __typename?: 'VehicleTypeEnum', id: number, name: string } | null, market?: { __typename?: 'AssetClassEnum', id: number, name: string } | null, domicileCountry?: { __typename?: 'CountryEnum', id: number, name: string } | null, domicileUSState?: { __typename?: 'StateEnum', id: number, name: string } | null, family?: { __typename?: 'Family', id: number, name: string } | null, firm?: { __typename?: 'Firm', id: number, name: string, isCompany?: boolean | null, companyId?: number | null } | null, gpCommittedCurrency?: { __typename?: 'CurrencyDenominationEnum', id: number, name: string } | null, advisor?: { __typename?: 'Firm', id: number, name: string } | null, list?: { __typename?: 'InvestmentListEnum', id: number, name: string } | null, peFundNumber?: { __typename?: 'PEFundNumberEnum', id: number, name: string } | null, peStrategy?: { __typename?: 'PEStrategyEnum', id: number, name: string } | null, peSubStrategy?: { __typename?: 'PESubStrategyEnum', id: number, name: string } | null, primaryBenchmark?: { __typename?: 'Investment', id: number, name: string } | null, secondaryBenchmark?: { __typename?: 'Investment', id: number, name: string } | null, strategy?: { __typename?: 'StrategyEnum', id: number, name: string } | null, subStrategy?: { __typename?: 'SubStrategyEnum', id: number, name: string } | null, primaryGeographicFocus?: { __typename?: 'GeographicFocusEnum', id: number, name: string } | null, otherGeographicFocuses?: Array<{ __typename?: 'GeographicFocusEnum', id: number, name: string }> | null, investmentStructure?: { __typename?: 'InvestmentStructureEnum', id: string, name: string } | null, legalStructure?: { __typename?: 'LegalStructureEnum', id: string, name: string } | null, organizationStructure?: { __typename?: 'OrganizationStructureEnum', id: string, name: string } | null, NAVClassification?: { __typename?: 'NAVClassificationEnum', id: string, name: string } | null, pricingFrequency?: { __typename?: 'PricingFrequencyEnum', id: string, name: string } | null, investmentTags?: Array<{ __typename?: 'InvestmentTags', id: number, tagId: number, tagClassId: number, tag: { __typename?: 'Tag', id: number, name: string, tagClassId: number } }> | null, closeDateFundSize?: Array<{ __typename?: 'CloseDateFundSize', fundSize: number, closeDate: string }> | null, investmentXImpact?: Array<{ __typename?: 'InvestmentXImpact', impactEnumId: number, impactEnum: { __typename?: 'ImpactEnum', id: number, name: string } }> | null, registeredAddressProvider?: { __typename?: 'Institution', id: number, name: string, addressesId: number, address: { __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, zipCode?: string | null, countryEnumId?: number | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null } } | null, indexCalcTypeEnum?: { __typename?: 'IndexCalcTypeEnum', id: number, indexCalcType: string } | null, access?: { __typename?: 'EntityAccess', read?: boolean | null, update?: boolean | null, delete?: boolean | null, preview?: boolean | null } | null, fundsXProxies?: Array<{ __typename?: 'FundsXProxies', id: number, investmentId: number, proxyId: number, proxyScalingFactor?: number | null, rank: number, proxy: { __typename?: 'Investment', id: number, name: string } }> | null }> } };

export type CreateInvestmentMutationVariables = Exact<{
  input: InvestmentInput;
}>;


export type CreateInvestmentMutation = { __typename?: 'Mutation', addInvestment?: { __typename?: 'Investment', id: number } | null };

export type UpdateInvestmentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: InvestmentInput;
}>;


export type UpdateInvestmentMutation = { __typename?: 'Mutation', updateInvestment: { __typename?: 'Investment', id: number } };

export type DeleteInvestmentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteInvestmentMutation = { __typename?: 'Mutation', deleteInvestment: boolean };

export type GetListInvestmentAssignmentOptionQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentAssignmentOptionSort> | InvestmentAssignmentOptionSort>;
  filter?: InputMaybe<InvestmentAssignmentOptionFilter>;
}>;


export type GetListInvestmentAssignmentOptionQuery = { __typename?: 'Query', investmentAssignmentOptionList: { __typename?: 'InvestmentAssignmentOptionList', total: number, items: Array<{ __typename?: 'InvestmentAssignmentOption', id: string, commonName: string, isPrimary: boolean, isSecondary: boolean }> } };

export type GetManyInvestmentAssignmentOptionQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetManyInvestmentAssignmentOptionQuery = { __typename?: 'Query', investmentAssignmentOptionMany: Array<{ __typename?: 'InvestmentAssignmentOption', id: string, commonName: string, isPrimary: boolean, isSecondary: boolean } | null> };

export type InvestmentAxysCodeAttributesFragment = { __typename?: 'InvestmentAxysCode', id: number, axysCodeId: number, investmentId: number, axysCode: { __typename?: 'AxysCode', id: number, code: string } };

export type GetListInvestmentAxysCodeQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentAxysCodeSort> | InvestmentAxysCodeSort>;
  filter?: InputMaybe<InvestmentAxysCodeFilter>;
}>;


export type GetListInvestmentAxysCodeQuery = { __typename?: 'Query', investmentAxysCodeList: { __typename?: 'InvestmentAxysCodeList', total: number, items: Array<{ __typename?: 'InvestmentAxysCode', id: number, axysCodeId: number, investmentId: number, axysCode: { __typename?: 'AxysCode', id: number, code: string } }> } };

export type GetOneInvestmentAxysCodeQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneInvestmentAxysCodeQuery = { __typename?: 'Query', investmentAxysCode?: { __typename?: 'InvestmentAxysCode', id: number, axysCodeId: number, investmentId: number, axysCode: { __typename?: 'AxysCode', id: number, code: string } } | null };

export type GetManyInvestmentAxysCodeQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyInvestmentAxysCodeQuery = { __typename?: 'Query', investmentAxysCodeMany: Array<{ __typename?: 'InvestmentAxysCode', id: number, axysCodeId: number, investmentId: number, axysCode: { __typename?: 'AxysCode', id: number, code: string } } | null> };

export type CreateInvestmentAxysCodeMutationVariables = Exact<{
  input: InvestmentAxysCodeInput;
}>;


export type CreateInvestmentAxysCodeMutation = { __typename?: 'Mutation', addInvestmentAxysCode: { __typename?: 'InvestmentAxysCode', id: number } };

export type DeleteInvestmentAxysCodeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteInvestmentAxysCodeMutation = { __typename?: 'Mutation', deleteInvestmentAxysCode: number };

export type GetBulkInvestmentQueryVariables = Exact<{
  sort?: InputMaybe<Array<InvestmentSort> | InvestmentSort>;
  filter?: InputMaybe<InvestmentFilterInput>;
}>;


export type GetBulkInvestmentQuery = { __typename?: 'Query', investmentBulk: Array<{ __typename?: 'InvestmentBulk', id: number, name: string }> };

export type InvestmentFdpLoginsAttributesFragment = { __typename?: 'InvestmentFDPLogins', id: number, investmentId: number, fdpLoginId: number, fdpWebsiteId?: number | null, fdpWebsite?: { __typename?: 'FDPWebsites', id: number, website: string, financialDataProviderId: number } | null, fdpLogin: { __typename?: 'FDPLogin', id: number, username: string, financialDataProviderId: number, financialDataProvider: { __typename?: 'FinancialDataProvider', id: number, name: string, fdpWebsites: Array<{ __typename?: 'FDPWebsites', id: number, website: string }> } }, firmFDPLogin: { __typename?: 'FirmFDPLogins', id: number, firmId: number, fdpLoginId: number, firm: { __typename?: 'Firm', id: number, name: string } }, investment: { __typename?: 'Investment', id: number, name: string } };

export type GetListInvestmentFdpLoginsQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentFdpLoginsSort> | InvestmentFdpLoginsSort>;
  filter?: InputMaybe<InvestmentFdpLoginsFilter>;
}>;


export type GetListInvestmentFdpLoginsQuery = { __typename?: 'Query', investmentFDPLoginsList: { __typename?: 'InvestmentFDPLoginsList', total: number, items: Array<{ __typename?: 'InvestmentFDPLogins', id: number, investmentId: number, fdpLoginId: number, fdpWebsiteId?: number | null, fdpWebsite?: { __typename?: 'FDPWebsites', id: number, website: string, financialDataProviderId: number } | null, fdpLogin: { __typename?: 'FDPLogin', id: number, username: string, financialDataProviderId: number, financialDataProvider: { __typename?: 'FinancialDataProvider', id: number, name: string, fdpWebsites: Array<{ __typename?: 'FDPWebsites', id: number, website: string }> } }, firmFDPLogin: { __typename?: 'FirmFDPLogins', id: number, firmId: number, fdpLoginId: number, firm: { __typename?: 'Firm', id: number, name: string } }, investment: { __typename?: 'Investment', id: number, name: string } }> } };

export type GetOneInvestmentFdpLoginsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneInvestmentFdpLoginsQuery = { __typename?: 'Query', investmentFDPLogins?: { __typename?: 'InvestmentFDPLogins', id: number, investmentId: number, fdpLoginId: number, fdpWebsiteId?: number | null, fdpWebsite?: { __typename?: 'FDPWebsites', id: number, website: string, financialDataProviderId: number } | null, fdpLogin: { __typename?: 'FDPLogin', id: number, username: string, financialDataProviderId: number, financialDataProvider: { __typename?: 'FinancialDataProvider', id: number, name: string, fdpWebsites: Array<{ __typename?: 'FDPWebsites', id: number, website: string }> } }, firmFDPLogin: { __typename?: 'FirmFDPLogins', id: number, firmId: number, fdpLoginId: number, firm: { __typename?: 'Firm', id: number, name: string } }, investment: { __typename?: 'Investment', id: number, name: string } } | null };

export type GetManyInvestmentFdpLoginsQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyInvestmentFdpLoginsQuery = { __typename?: 'Query', investmentFDPLoginsMany: Array<{ __typename?: 'InvestmentFDPLogins', id: number, investmentId: number, fdpLoginId: number, fdpWebsiteId?: number | null, fdpWebsite?: { __typename?: 'FDPWebsites', id: number, website: string, financialDataProviderId: number } | null, fdpLogin: { __typename?: 'FDPLogin', id: number, username: string, financialDataProviderId: number, financialDataProvider: { __typename?: 'FinancialDataProvider', id: number, name: string, fdpWebsites: Array<{ __typename?: 'FDPWebsites', id: number, website: string }> } }, firmFDPLogin: { __typename?: 'FirmFDPLogins', id: number, firmId: number, fdpLoginId: number, firm: { __typename?: 'Firm', id: number, name: string } }, investment: { __typename?: 'Investment', id: number, name: string } } | null> };

export type CreateInvestmentFdpLoginsMutationVariables = Exact<{
  input: InvestmentFdpLoginsInput;
}>;


export type CreateInvestmentFdpLoginsMutation = { __typename?: 'Mutation', addInvestmentFDPLogins: { __typename?: 'InvestmentFDPLogins', id: number } };

export type UpdateInvestmentFdpLoginsMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: InvestmentFdpLoginsInput;
}>;


export type UpdateInvestmentFdpLoginsMutation = { __typename?: 'Mutation', updateInvestmentFDPLogins: { __typename?: 'InvestmentFDPLogins', id: number } };

export type InvestmentFeesAttributesFragment = { __typename?: 'InvestmentFees', id: number, shareClassId: number, mgmtFee?: number | null, mgmtFeeCalcEnumId?: number | null, mgmtFeeFreqEnumId?: number | null, incentiveFee?: number | null, incentiveFeeCalcEnumId?: number | null, incentiveFeeFreqEnumId?: number | null, otherFee?: number | null, otherFeeCalcEnumId?: number | null, otherFeeFreqEnumId?: number | null, highWaterMark?: boolean | null, hurdle?: boolean | null, hurdleBenchmark?: string | null, annualReset?: boolean | null, peMgmtFeeCalcEnumId?: number | null, peIncentiveFeeCalcEnumId?: number | null, peMgmtFeeDuringCommitment?: number | null, peMgmtFeeDuringCommitmentCalcEnumId?: number | null, peMgmtFeeDuringHarvest?: number | null, peMgmtFeeDuringHarvestCalcEnumId?: number | null, pePlacementFeesPaid?: boolean | null, peGP?: number | null, peLP?: number | null, feeStructureChanged?: boolean | null, feeStructureChangedNotes?: string | null, standardShareClassRates?: boolean | null, abnormalFees?: boolean | null, abnormalFeesNotes?: string | null, hasMgmtFeeStepDown?: boolean | null, peMgmtFeeStepDownPercent?: number | null, peMgmtFeeStepDownCalcEnumId?: number | null, mgmtFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, mgmtFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, incentiveFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, incentiveFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, otherFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, otherFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, peMgmtFeeCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peIncentiveFeeCalc?: { __typename?: 'PeInctFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeDuringCommitmentCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeDuringHarvestCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeStepDownCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null };

export type GetListInvestmentFeesQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentFeesSort> | InvestmentFeesSort>;
  filter?: InputMaybe<InvestmentFeesFilter>;
}>;


export type GetListInvestmentFeesQuery = { __typename?: 'Query', investmentFeesList: { __typename?: 'InvestmentFeesList', total: number, items: Array<{ __typename?: 'InvestmentFees', id: number, shareClassId: number, mgmtFee?: number | null, mgmtFeeCalcEnumId?: number | null, mgmtFeeFreqEnumId?: number | null, incentiveFee?: number | null, incentiveFeeCalcEnumId?: number | null, incentiveFeeFreqEnumId?: number | null, otherFee?: number | null, otherFeeCalcEnumId?: number | null, otherFeeFreqEnumId?: number | null, highWaterMark?: boolean | null, hurdle?: boolean | null, hurdleBenchmark?: string | null, annualReset?: boolean | null, peMgmtFeeCalcEnumId?: number | null, peIncentiveFeeCalcEnumId?: number | null, peMgmtFeeDuringCommitment?: number | null, peMgmtFeeDuringCommitmentCalcEnumId?: number | null, peMgmtFeeDuringHarvest?: number | null, peMgmtFeeDuringHarvestCalcEnumId?: number | null, pePlacementFeesPaid?: boolean | null, peGP?: number | null, peLP?: number | null, feeStructureChanged?: boolean | null, feeStructureChangedNotes?: string | null, standardShareClassRates?: boolean | null, abnormalFees?: boolean | null, abnormalFeesNotes?: string | null, hasMgmtFeeStepDown?: boolean | null, peMgmtFeeStepDownPercent?: number | null, peMgmtFeeStepDownCalcEnumId?: number | null, mgmtFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, mgmtFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, incentiveFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, incentiveFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, otherFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, otherFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, peMgmtFeeCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peIncentiveFeeCalc?: { __typename?: 'PeInctFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeDuringCommitmentCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeDuringHarvestCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeStepDownCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null }> } };

export type GetOneInvestmentFeesQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneInvestmentFeesQuery = { __typename?: 'Query', investmentFees: { __typename?: 'InvestmentFees', id: number, shareClassId: number, mgmtFee?: number | null, mgmtFeeCalcEnumId?: number | null, mgmtFeeFreqEnumId?: number | null, incentiveFee?: number | null, incentiveFeeCalcEnumId?: number | null, incentiveFeeFreqEnumId?: number | null, otherFee?: number | null, otherFeeCalcEnumId?: number | null, otherFeeFreqEnumId?: number | null, highWaterMark?: boolean | null, hurdle?: boolean | null, hurdleBenchmark?: string | null, annualReset?: boolean | null, peMgmtFeeCalcEnumId?: number | null, peIncentiveFeeCalcEnumId?: number | null, peMgmtFeeDuringCommitment?: number | null, peMgmtFeeDuringCommitmentCalcEnumId?: number | null, peMgmtFeeDuringHarvest?: number | null, peMgmtFeeDuringHarvestCalcEnumId?: number | null, pePlacementFeesPaid?: boolean | null, peGP?: number | null, peLP?: number | null, feeStructureChanged?: boolean | null, feeStructureChangedNotes?: string | null, standardShareClassRates?: boolean | null, abnormalFees?: boolean | null, abnormalFeesNotes?: string | null, hasMgmtFeeStepDown?: boolean | null, peMgmtFeeStepDownPercent?: number | null, peMgmtFeeStepDownCalcEnumId?: number | null, mgmtFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, mgmtFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, incentiveFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, incentiveFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, otherFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, otherFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, peMgmtFeeCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peIncentiveFeeCalc?: { __typename?: 'PeInctFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeDuringCommitmentCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeDuringHarvestCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeStepDownCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null } };

export type GetManyInvestmentFeesQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyInvestmentFeesQuery = { __typename?: 'Query', investmentFeesMany: Array<{ __typename?: 'InvestmentFees', id: number, shareClassId: number, mgmtFee?: number | null, mgmtFeeCalcEnumId?: number | null, mgmtFeeFreqEnumId?: number | null, incentiveFee?: number | null, incentiveFeeCalcEnumId?: number | null, incentiveFeeFreqEnumId?: number | null, otherFee?: number | null, otherFeeCalcEnumId?: number | null, otherFeeFreqEnumId?: number | null, highWaterMark?: boolean | null, hurdle?: boolean | null, hurdleBenchmark?: string | null, annualReset?: boolean | null, peMgmtFeeCalcEnumId?: number | null, peIncentiveFeeCalcEnumId?: number | null, peMgmtFeeDuringCommitment?: number | null, peMgmtFeeDuringCommitmentCalcEnumId?: number | null, peMgmtFeeDuringHarvest?: number | null, peMgmtFeeDuringHarvestCalcEnumId?: number | null, pePlacementFeesPaid?: boolean | null, peGP?: number | null, peLP?: number | null, feeStructureChanged?: boolean | null, feeStructureChangedNotes?: string | null, standardShareClassRates?: boolean | null, abnormalFees?: boolean | null, abnormalFeesNotes?: string | null, hasMgmtFeeStepDown?: boolean | null, peMgmtFeeStepDownPercent?: number | null, peMgmtFeeStepDownCalcEnumId?: number | null, mgmtFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, mgmtFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, incentiveFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, incentiveFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, otherFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, otherFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, peMgmtFeeCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peIncentiveFeeCalc?: { __typename?: 'PeInctFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeDuringCommitmentCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeDuringHarvestCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeStepDownCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null }> };

export type GetListInvestmentFirmEmploymentQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentFirmEmploymentSort> | InvestmentFirmEmploymentSort>;
  filter?: InputMaybe<InvestmentFirmEmploymentFilterInput>;
}>;


export type GetListInvestmentFirmEmploymentQuery = { __typename?: 'Query', investmentFirmEmploymentList: { __typename?: 'InvestmentFirmEmploymentList', total: number, items: Array<{ __typename?: 'InvestmentFirmEmployment', id: number, firmEmploymentId: number, investmentId: number, employeeRoleEnumId?: number | null, startDate?: string | null, leftDate?: string | null, faceOfInvestment?: boolean | null, firmEmployment?: { __typename?: 'FirmEmployment', id: number, firm: { __typename?: 'Firm', id: number, name: string }, person?: { __typename?: 'Person', id: number, lastName: string, firstName?: string | null, middleName?: string | null } | null } | null, investment?: { __typename?: 'Investment', id: number, name: string } | null, employeeRole?: { __typename?: 'EmployeeRoleEnum', id: number, name: string } | null }> } };

export type GetOneInvestmentFirmEmploymentQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneInvestmentFirmEmploymentQuery = { __typename?: 'Query', investmentFirmEmployment?: { __typename?: 'InvestmentFirmEmployment', id: number, employeeRoleEnumId?: number | null, startDate?: string | null, leftDate?: string | null, faceOfInvestment?: boolean | null, firmEmployment?: { __typename?: 'FirmEmployment', id: number, firm: { __typename?: 'Firm', id: number, name: string }, person?: { __typename?: 'Person', id: number, lastName: string, firstName?: string | null, middleName?: string | null } | null } | null, investment?: { __typename?: 'Investment', id: number, name: string } | null } | null };

export type GetManyInvestmentFirmEmploymentQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyInvestmentFirmEmploymentQuery = { __typename?: 'Query', investmentFirmEmploymentMany: Array<{ __typename?: 'InvestmentFirmEmployment', id: number, firmEmploymentId: number, investmentId: number } | null> };

export type GetManyReferenceInvestmentFirmEmploymentQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentFirmEmploymentSort> | InvestmentFirmEmploymentSort>;
  filter?: InputMaybe<InvestmentFirmEmploymentFilterInput>;
}>;


export type GetManyReferenceInvestmentFirmEmploymentQuery = { __typename?: 'Query', investmentFirmEmploymentList: { __typename?: 'InvestmentFirmEmploymentList', total: number, items: Array<{ __typename?: 'InvestmentFirmEmployment', id: number, startDate?: string | null, leftDate?: string | null, faceOfInvestment?: boolean | null, firmEmployment?: { __typename?: 'FirmEmployment', id: number, leftInd?: boolean | null, leftDate?: string | null, isKeyPersonnel?: boolean | null, isFounder?: boolean | null, firm: { __typename?: 'Firm', id: number, name: string }, person?: { __typename?: 'Person', id: number, lastName: string, firstName?: string | null, middleName?: string | null } | null, employeeRole?: { __typename?: 'EmployeeRoleEnum', id: number, name: string } | null, contactType?: { __typename?: 'ContactTypeEnum', id: number, name?: string | null } | null } | null, investment?: { __typename?: 'Investment', id: number, name: string } | null, employeeRole?: { __typename?: 'EmployeeRoleEnum', id: number, name: string } | null }> } };

export type CreateInvestmentFirmEmploymentMutationVariables = Exact<{
  input: InvestmentFirmEmploymentInput;
}>;


export type CreateInvestmentFirmEmploymentMutation = { __typename?: 'Mutation', addInvestmentFirmEmployment: { __typename?: 'InvestmentFirmEmployment', id: number } };

export type UpdateInvestmentFirmEmploymentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: InvestmentFirmEmploymentInput;
}>;


export type UpdateInvestmentFirmEmploymentMutation = { __typename?: 'Mutation', updateInvestmentFirmEmployment: { __typename?: 'InvestmentFirmEmployment', id: number } };

export type DeleteInvestmentFirmEmploymentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteInvestmentFirmEmploymentMutation = { __typename?: 'Mutation', deleteInvestmentFirmEmployment: number };

export type CreateInvestmentFirmEmploymentBulkMutationVariables = Exact<{
  input: Array<InvestmentFirmEmploymentInput> | InvestmentFirmEmploymentInput;
}>;


export type CreateInvestmentFirmEmploymentBulkMutation = { __typename?: 'Mutation', addInvestmentFirmEmploymentRecords: Array<{ __typename?: 'InvestmentFirmEmployment', id: number }> };

export type GetListInvestmentFirmEmploymentRoleEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentFirmEmploymentRoleEnumSort> | InvestmentFirmEmploymentRoleEnumSort>;
  filter?: InputMaybe<InvestmentFirmEmploymentRoleEnumFilter>;
}>;


export type GetListInvestmentFirmEmploymentRoleEnumQuery = { __typename?: 'Query', investmentFirmEmploymentRoleEnumList: { __typename?: 'InvestmentFirmEmploymentRoleEnumList', total: number, items: Array<{ __typename?: 'InvestmentFirmEmploymentRoleEnum', id: number, name: string }> } };

export type GetOneInvestmentFirmEmploymentRoleEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneInvestmentFirmEmploymentRoleEnumQuery = { __typename?: 'Query', investmentFirmEmploymentRoleEnum?: { __typename?: 'InvestmentFirmEmploymentRoleEnum', id: number, name: string } | null };

export type GetManyInvestmentFirmEmploymentRoleEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyInvestmentFirmEmploymentRoleEnumQuery = { __typename?: 'Query', investmentFirmEmploymentRoleEnumMany: Array<{ __typename?: 'InvestmentFirmEmploymentRoleEnum', id: number, name: string } | null> };

export type InvestmentInstitutionsAttributesFragment = { __typename?: 'InvestmentInstitutions', id: number, investmentId: number, institutionId: number, startDate?: string | null, endDate?: string | null, institutionInstitutionTypeEnumId: number, investment: { __typename?: 'Investment', id: number, name: string }, institution: { __typename?: 'Institution', id: number, name: string, globalProviderInstitution?: { __typename?: 'GlobalProviderInstitutions', id: number, provider: { __typename?: 'ServiceProviderFirm', id: number, name: string } } | null }, officeLocationServiceType: { __typename?: 'InstitutionsInstitutionTypeEnum', id: number, institutionTypeEnum: { __typename?: 'InstitutionTypeEnum', id: number, name: string } } };

export type GetListInvestmentInstitutionsQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentInstitutionsSort> | InvestmentInstitutionsSort>;
  filter?: InputMaybe<InvestmentInstitutionsFilter>;
}>;


export type GetListInvestmentInstitutionsQuery = { __typename?: 'Query', investmentInstitutionsList: { __typename?: 'InvestmentInstitutionsList', total: number, items: Array<{ __typename?: 'InvestmentInstitutions', id: number, investmentId: number, institutionId: number, startDate?: string | null, endDate?: string | null, institutionInstitutionTypeEnumId: number, investment: { __typename?: 'Investment', id: number, name: string }, institution: { __typename?: 'Institution', id: number, name: string, globalProviderInstitution?: { __typename?: 'GlobalProviderInstitutions', id: number, provider: { __typename?: 'ServiceProviderFirm', id: number, name: string } } | null }, officeLocationServiceType: { __typename?: 'InstitutionsInstitutionTypeEnum', id: number, institutionTypeEnum: { __typename?: 'InstitutionTypeEnum', id: number, name: string } } }> } };

export type GetOneInvestmentInstitutionsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneInvestmentInstitutionsQuery = { __typename?: 'Query', investmentInstitutions?: { __typename?: 'InvestmentInstitutions', id: number, investmentId: number, institutionId: number, startDate?: string | null, endDate?: string | null, institutionInstitutionTypeEnumId: number, investment: { __typename?: 'Investment', id: number, name: string }, institution: { __typename?: 'Institution', id: number, name: string, globalProviderInstitution?: { __typename?: 'GlobalProviderInstitutions', id: number, provider: { __typename?: 'ServiceProviderFirm', id: number, name: string } } | null }, officeLocationServiceType: { __typename?: 'InstitutionsInstitutionTypeEnum', id: number, institutionTypeEnum: { __typename?: 'InstitutionTypeEnum', id: number, name: string } } } | null };

export type GetManyInvestmentInstitutionsQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyInvestmentInstitutionsQuery = { __typename?: 'Query', investmentInstitutionsMany: Array<{ __typename?: 'InvestmentInstitutions', id: number, investmentId: number, institutionId: number, startDate?: string | null, endDate?: string | null, institutionInstitutionTypeEnumId: number, investment: { __typename?: 'Investment', id: number, name: string }, institution: { __typename?: 'Institution', id: number, name: string, globalProviderInstitution?: { __typename?: 'GlobalProviderInstitutions', id: number, provider: { __typename?: 'ServiceProviderFirm', id: number, name: string } } | null }, officeLocationServiceType: { __typename?: 'InstitutionsInstitutionTypeEnum', id: number, institutionTypeEnum: { __typename?: 'InstitutionTypeEnum', id: number, name: string } } } | null> };

export type CreateInvestmentInstitutionsMutationVariables = Exact<{
  input: InvestmentInstitutionsInput;
}>;


export type CreateInvestmentInstitutionsMutation = { __typename?: 'Mutation', addInvestmentInstitutions?: { __typename?: 'InvestmentInstitutions', id: number } | null };

export type UpdateInvestmentInstitutionsMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: InvestmentInstitutionsInput;
}>;


export type UpdateInvestmentInstitutionsMutation = { __typename?: 'Mutation', updateInvestmentInstitutions: { __typename?: 'InvestmentInstitutions', id: number } };

export type DeleteInvestmentInstitutionsMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteInvestmentInstitutionsMutation = { __typename?: 'Mutation', deleteInvestmentInstitutions: number };

export type InvestmentAttributesForPrivateQuartilesFragment = { __typename?: 'Investment', id: number, name: string, firm?: { __typename?: 'Firm', id: number, name: string } | null, derivedPrivateQuartileGroupCategory?: { __typename?: 'PrivateQuartileGroupCategory', id: number, uniqueLabel: string, displayLabel?: string | null } | null };

export type GetOneInvestmentForPrivateQuartilesQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneInvestmentForPrivateQuartilesQuery = { __typename?: 'Query', investment: { __typename?: 'Investment', id: number, name: string, firm?: { __typename?: 'Firm', id: number, name: string } | null, derivedPrivateQuartileGroupCategory?: { __typename?: 'PrivateQuartileGroupCategory', id: number, uniqueLabel: string, displayLabel?: string | null } | null } };

export type GetListInvestmentListEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentListEnumSort> | InvestmentListEnumSort>;
  filter?: InputMaybe<InvestmentListEnumFilter>;
}>;


export type GetListInvestmentListEnumQuery = { __typename?: 'Query', investmentListEnumList: { __typename?: 'InvestmentListEnumList', total: number, items: Array<{ __typename?: 'InvestmentListEnum', id: number, name: string }> } };

export type GetOneInvestmentListEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneInvestmentListEnumQuery = { __typename?: 'Query', investmentListEnum?: { __typename?: 'InvestmentListEnum', id: number, name: string } | null };

export type GetManyInvestmentListEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyInvestmentListEnumQuery = { __typename?: 'Query', investmentListEnumMany: Array<{ __typename?: 'InvestmentListEnum', id: number, name: string } | null> };

export type GetOneInvestmentPeersQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  sort?: InputMaybe<Array<InvestmentSort> | InvestmentSort>;
  filter?: InputMaybe<InvestmentPeersFilterInput>;
}>;


export type GetOneInvestmentPeersQuery = { __typename?: 'Query', investment: { __typename?: 'Investment', id: number, name: string, marketEnumId?: number | null, vintageYear?: number | null, market?: { __typename?: 'AssetClassEnum', id: number, name: string } | null, firm?: { __typename?: 'Firm', id: number, name: string } | null, portalSubmitted?: { __typename?: 'PortalSubmitted', migratedAt?: string | null } | null, peersList: { __typename?: 'InvestmentList', items: Array<{ __typename?: 'Investment', id: number, name: string }> } } };

export type UpdateInvestmentPeersMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  peerIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type UpdateInvestmentPeersMutation = { __typename?: 'Mutation', updateInvestment: { __typename?: 'Investment', id: number } };

export type GetOneInvestmentPeersAutoQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneInvestmentPeersAutoQuery = { __typename?: 'Query', investment: { __typename?: 'Investment', id: number, peersAutoList: { __typename?: 'InvestmentList', items: Array<{ __typename?: 'Investment', id: number, name: string }> } } };

export type InvestmentPrivateQuartileGroupCategoryAttributesFragment = { __typename?: 'InvestmentPrivateQuartileGroupCategory', id: number, investmentId: number, privateQuartileGroupCategoryId: number, isDefault: boolean, investment?: { __typename?: 'Investment', id: number, name: string } | null, privateQuartileGroupCategory?: { __typename?: 'PrivateQuartileGroupCategory', id: number, uniqueLabel: string, displayLabel?: string | null } | null };

export type GetListInvestmentPrivateQuartileGroupCategoryQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentPrivateQuartileGroupCategorySort> | InvestmentPrivateQuartileGroupCategorySort>;
  filter?: InputMaybe<InvestmentPrivateQuartileGroupCategoryFilter>;
}>;


export type GetListInvestmentPrivateQuartileGroupCategoryQuery = { __typename?: 'Query', investmentPrivateQuartileGroupCategoryList: { __typename?: 'InvestmentPrivateQuartileGroupCategoryList', total: number, items: Array<{ __typename?: 'InvestmentPrivateQuartileGroupCategory', id: number, investmentId: number, privateQuartileGroupCategoryId: number, isDefault: boolean, investment?: { __typename?: 'Investment', id: number, name: string } | null, privateQuartileGroupCategory?: { __typename?: 'PrivateQuartileGroupCategory', id: number, uniqueLabel: string, displayLabel?: string | null } | null }> } };

export type GetOneInvestmentPrivateQuartileGroupCategoryQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneInvestmentPrivateQuartileGroupCategoryQuery = { __typename?: 'Query', investmentPrivateQuartileGroupCategory?: { __typename?: 'InvestmentPrivateQuartileGroupCategory', id: number, investmentId: number, privateQuartileGroupCategoryId: number, isDefault: boolean, investment?: { __typename?: 'Investment', id: number, name: string } | null, privateQuartileGroupCategory?: { __typename?: 'PrivateQuartileGroupCategory', id: number, uniqueLabel: string, displayLabel?: string | null } | null } | null };

export type GetManyInvestmentPrivateQuartileGroupCategoryQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyInvestmentPrivateQuartileGroupCategoryQuery = { __typename?: 'Query', investmentPrivateQuartileGroupCategoryMany: Array<{ __typename?: 'InvestmentPrivateQuartileGroupCategory', id: number, investmentId: number, privateQuartileGroupCategoryId: number, isDefault: boolean, investment?: { __typename?: 'Investment', id: number, name: string } | null, privateQuartileGroupCategory?: { __typename?: 'PrivateQuartileGroupCategory', id: number, uniqueLabel: string, displayLabel?: string | null } | null } | null> };

export type CreateInvestmentPrivateQuartileGroupCategoryMutationVariables = Exact<{
  input: InvestmentPrivateQuartileGroupCategoryInput;
}>;


export type CreateInvestmentPrivateQuartileGroupCategoryMutation = { __typename?: 'Mutation', addInvestmentPrivateQuartileGroupCategory: { __typename?: 'InvestmentPrivateQuartileGroupCategory', id: number, investmentId: number, privateQuartileGroupCategoryId: number, isDefault: boolean, investment?: { __typename?: 'Investment', id: number, name: string } | null, privateQuartileGroupCategory?: { __typename?: 'PrivateQuartileGroupCategory', id: number, uniqueLabel: string, displayLabel?: string | null } | null } };

export type UpdateInvestmentPrivateQuartileGroupCategoryMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: InvestmentPrivateQuartileGroupCategoryInput;
}>;


export type UpdateInvestmentPrivateQuartileGroupCategoryMutation = { __typename?: 'Mutation', updateInvestmentPrivateQuartileGroupCategory: { __typename?: 'InvestmentPrivateQuartileGroupCategory', id: number, investmentId: number, privateQuartileGroupCategoryId: number, isDefault: boolean, investment?: { __typename?: 'Investment', id: number, name: string } | null, privateQuartileGroupCategory?: { __typename?: 'PrivateQuartileGroupCategory', id: number, uniqueLabel: string, displayLabel?: string | null } | null } };

export type DeleteInvestmentPrivateQuartileGroupCategoryMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteInvestmentPrivateQuartileGroupCategoryMutation = { __typename?: 'Mutation', deleteInvestmentPrivateQuartileGroupCategory: number };

export type GetInvestmentRiskCategoryListQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentRiskCategorySort> | InvestmentRiskCategorySort>;
  filter?: InputMaybe<InvestmentRiskCategoryFilter>;
}>;


export type GetInvestmentRiskCategoryListQuery = { __typename?: 'Query', investmentRiskCategoryList: { __typename?: 'StringIdNameList', total: number, items: Array<{ __typename?: 'StringIdName', id: string, name: string }> } };

export type RefreshInvestmentRiskMutationVariables = Exact<{
  listType: RefreshInvestmentRiskListType;
  investmentIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type RefreshInvestmentRiskMutation = { __typename?: 'Mutation', refreshInvestmentRisk: { __typename?: 'AsyncTaskStatus', id?: string | null, startDate: string } };

export type CopyRiskMeasuresMutationVariables = Exact<{
  sourceInvestmentId: Scalars['Int']['input'];
  targetInvestmentId: Scalars['Int']['input'];
}>;


export type CopyRiskMeasuresMutation = { __typename?: 'Mutation', copyRiskMeasures: number };

export type DeleteRiskMeasuresMutationVariables = Exact<{
  listType: DeleteInvestmentRiskListType;
  investmentIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  minDate?: InputMaybe<Scalars['DateTime']['input']>;
  maxDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type DeleteRiskMeasuresMutation = { __typename?: 'Mutation', deleteRiskMeasures: number };

export type ImportRiskMeasuresStatusQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ImportRiskMeasuresStatusQuery = { __typename?: 'Query', importRiskMeasuresStatus?: { __typename?: 'ImportRiskMeasuresStatus', id: string, status: { __typename?: 'AsyncTaskStatus', id?: string | null, endDate?: string | null, error?: string | null }, returnValue?: { __typename?: 'RiskFileParse', errorCount: number, totalCount: number, errorRows: Array<{ __typename?: 'RiskFileRow', line: number, error?: string | null, raw?: { __typename?: 'RiskMeasureRaw', investmentId: string, reportDate: string, measure: string, tier1: string, tier2: string, category1: string, category2: string, category3: string, category4: string, category5: string } | null, parsed?: { __typename?: 'RockCreekMeasure', investmentId: number, reportDate: string, measure: number, tierId: string, categoryId: string } | null }>, validInvestments: Array<{ __typename?: 'RiskIdName', id: number, name: string }> } | null } | null };

export type ImportRiskMeasuresMutationVariables = Exact<{
  validateOnly: Scalars['Boolean']['input'];
  isEstimated: Scalars['Boolean']['input'];
  file: Scalars['Upload']['input'];
  notify: Scalars['Boolean']['input'];
}>;


export type ImportRiskMeasuresMutation = { __typename?: 'Mutation', importRiskMeasures: { __typename?: 'AsyncTaskStatus', id?: string | null, startDate: string } };

export type GetInvestmentRiskInvestmentListQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentRiskInvestmentSort> | InvestmentRiskInvestmentSort>;
  filter?: InputMaybe<InvestmentRiskInvestmentFilter>;
}>;


export type GetInvestmentRiskInvestmentListQuery = { __typename?: 'Query', investmentRiskInvestmentList: { __typename?: 'InvestmentList', total: number, items: Array<{ __typename?: 'Investment', id: number, name: string, firm?: { __typename?: 'Firm', id: number, name: string } | null }> } };

export type GetListInvestmentSetQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentSetSort> | InvestmentSetSort>;
  filter?: InputMaybe<InvestmentSetFilter>;
}>;


export type GetListInvestmentSetQuery = { __typename?: 'Query', investmentSetList: { __typename?: 'InvestmentSetList', total: number, items: Array<{ __typename?: 'InvestmentSet', id: number, name: string }> } };

export type GetOneInvestmentSetQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneInvestmentSetQuery = { __typename?: 'Query', investmentSet?: { __typename?: 'InvestmentSet', id: number, name: string, investments: { __typename?: 'InvestmentList', items: Array<{ __typename?: 'Investment', id: number, name: string }> } } | null };

export type GetListInvestmentStructureEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentStructureEnumSort> | InvestmentStructureEnumSort>;
}>;


export type GetListInvestmentStructureEnumQuery = { __typename?: 'Query', investmentStructureEnumList: { __typename?: 'InvestmentStructureEnumList', total: number, items: Array<{ __typename?: 'InvestmentStructureEnum', id: string, name: string }> } };

export type GetOneInvestmentStructureEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneInvestmentStructureEnumQuery = { __typename?: 'Query', investmentStructureEnum?: { __typename?: 'InvestmentStructureEnum', id: string, name: string } | null };

export type GetManyInvestmentStructureEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyInvestmentStructureEnumQuery = { __typename?: 'Query', investmentStructureEnumMany: Array<{ __typename?: 'InvestmentStructureEnum', id: string, name: string } | null> };

export type GetListInvestmentTagsQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentTagsSort> | InvestmentTagsSort>;
  filter?: InputMaybe<InvestmentTagsFilterInput>;
}>;


export type GetListInvestmentTagsQuery = { __typename?: 'Query', investmentTagsList: { __typename?: 'InvestmentTagsList', total: number, items: Array<{ __typename?: 'InvestmentTags', id: number, tagId: number, tagClassId: number, investmentId: number }> } };

export type GetManyInvestmentTagsQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyInvestmentTagsQuery = { __typename?: 'Query', investmentTagsMany: Array<{ __typename?: 'InvestmentTags', id: number, tagId: number, tagClassId: number, investmentId: number } | null> };

export type GetOneInvestmentTagsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneInvestmentTagsQuery = { __typename?: 'Query', investmentTags?: { __typename?: 'InvestmentTags', id: number, tagId: number, tagClassId: number, investmentId: number } | null };

export type InvestmentTermsAttributesFragment = { __typename?: 'Investment', id: number, name: string, marketEnumId?: number | null, investmentPeriodYrs?: number | null, harvestPeriodYrs?: number | null, extensionPeriodYrs?: number | null, peLegalLifeYrs?: number | null, shareClassNote?: string | null, shareClasses?: Array<{ __typename?: 'ShareClass', id: number, investmentId: number, name: string, currencyDenominationEnumId?: number | null, otherFees?: string | null, restricted?: boolean | null, FAS157?: number | null, status?: string | null, isRcgNegotiated?: boolean | null, investment?: { __typename?: 'Investment', id: number, name: string, marketEnumId?: number | null } | null, investmentFees?: { __typename?: 'InvestmentFees', id: number, shareClassId: number, mgmtFee?: number | null, mgmtFeeCalcEnumId?: number | null, mgmtFeeFreqEnumId?: number | null, incentiveFee?: number | null, incentiveFeeCalcEnumId?: number | null, incentiveFeeFreqEnumId?: number | null, otherFee?: number | null, otherFeeCalcEnumId?: number | null, otherFeeFreqEnumId?: number | null, highWaterMark?: boolean | null, hurdle?: boolean | null, hurdleBenchmark?: string | null, annualReset?: boolean | null, peMgmtFeeCalcEnumId?: number | null, peIncentiveFeeCalcEnumId?: number | null, peMgmtFeeDuringCommitment?: number | null, peMgmtFeeDuringCommitmentCalcEnumId?: number | null, peMgmtFeeDuringHarvest?: number | null, peMgmtFeeDuringHarvestCalcEnumId?: number | null, pePlacementFeesPaid?: boolean | null, peGP?: number | null, peLP?: number | null, feeStructureChanged?: boolean | null, feeStructureChangedNotes?: string | null, standardShareClassRates?: boolean | null, abnormalFees?: boolean | null, abnormalFeesNotes?: string | null, hasMgmtFeeStepDown?: boolean | null, peMgmtFeeStepDownPercent?: number | null, peMgmtFeeStepDownCalcEnumId?: number | null, mgmtFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, mgmtFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, incentiveFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, incentiveFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, otherFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, otherFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, peMgmtFeeCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peIncentiveFeeCalc?: { __typename?: 'PeInctFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeDuringCommitmentCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeDuringHarvestCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeStepDownCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null } | null, liquidity?: { __typename?: 'Liquidity', id: number, shareClassId: number, hasGate?: boolean | null, gatePercentNav?: number | null, gatePercentCapital?: number | null, exceptions?: string | null, hasRollover?: boolean | null, rolloverValue?: number | null, rolloverUnitId?: number | null, hasLockup?: boolean | null, lockupValue?: number | null, lockupUnitId?: number | null, lockupEndValueId?: number | null, lockupEndUnitId?: number | null, lockupEndBasisDate?: string | null, lockupEndBizDays?: boolean | null, secondLockupValue?: number | null, secondLockupUnitId?: number | null, secondLockupEndValueId?: number | null, secondLockupEndUnitId?: number | null, secondLockupEndBasisDate?: string | null, secondLockupEndBizDays?: boolean | null, liquidityValue?: number | null, liquidityUnitId?: number | null, noticeValue?: number | null, noticeUnitId?: number | null, noticeBizDays?: boolean | null, subscriptionValue?: number | null, subscriptionUnitId?: number | null, cashAvailableDays?: number | null, hasHoldback?: boolean | null, holdbackPercent?: number | null, workoutId?: number | null, masterLevelFundGate?: boolean | null, lockupMonthlyValue: number, liquidityMonthlyValue: number, modelingNotes?: string | null, modifyDate?: string | null, rolloverUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, lockupUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, lockupEndValue?: { __typename?: 'LockupEndValueEnum', id: number, name?: string | null } | null, lockupEndUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupEndValue?: { __typename?: 'LockupEndValueEnum', id: number, name?: string | null } | null, secondLockupEndUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, liquidityUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, noticeUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, subscriptionUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, workout?: { __typename?: 'WorkoutEnum', id: number, name: string } | null } | null, peLiquidity?: { __typename?: 'PeLiquidity', id: number, shareClassId: number, preferredReturn?: number | null, isCompounded?: boolean | null, compoundingPeriodId?: number | null, hasCatchupProvision?: boolean | null, catchupPercent?: number | null, optionOfExtensionId?: number | null, compoundingPeriod?: { __typename?: 'CompoundingPeriodEnum', id: number, name?: string | null } | null, optionOfExtension?: { __typename?: 'RightOfExtensionEnum', id: number, name?: string | null } | null } | null, softLockups?: Array<{ __typename?: 'SoftLockup', id: number, liquidityId: number, cashAvailableDays?: number | null, lockupEndRedemptionOnId?: number | null, holdBackPercent?: number | null, noticeValue?: number | null, liquidityValue?: number | null, liquidityUnitId?: number | null, noticeBizDays?: boolean | null, redemptionFee: number, redemptionOnBizDays?: boolean | null, secondLockupEndRedemptionOnId?: number | null, termBeginMonth: number, termEndMonth: number, hasRedemptionFee?: boolean | null, lockupEndRedemptionOn?: { __typename?: 'FinancialPeriodEnum', id: number, name: string } | null, liquidityUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupEndRedemptionOn?: { __typename?: 'FinancialPeriodEnum', id: number, name: string } | null }> | null }> | null };

export type GetOneInvestmentTermsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneInvestmentTermsQuery = { __typename?: 'Query', investment: { __typename?: 'Investment', id: number, name: string, marketEnumId?: number | null, investmentPeriodYrs?: number | null, harvestPeriodYrs?: number | null, extensionPeriodYrs?: number | null, peLegalLifeYrs?: number | null, shareClassNote?: string | null, shareClasses?: Array<{ __typename?: 'ShareClass', id: number, investmentId: number, name: string, currencyDenominationEnumId?: number | null, otherFees?: string | null, restricted?: boolean | null, FAS157?: number | null, status?: string | null, isRcgNegotiated?: boolean | null, investment?: { __typename?: 'Investment', id: number, name: string, marketEnumId?: number | null } | null, investmentFees?: { __typename?: 'InvestmentFees', id: number, shareClassId: number, mgmtFee?: number | null, mgmtFeeCalcEnumId?: number | null, mgmtFeeFreqEnumId?: number | null, incentiveFee?: number | null, incentiveFeeCalcEnumId?: number | null, incentiveFeeFreqEnumId?: number | null, otherFee?: number | null, otherFeeCalcEnumId?: number | null, otherFeeFreqEnumId?: number | null, highWaterMark?: boolean | null, hurdle?: boolean | null, hurdleBenchmark?: string | null, annualReset?: boolean | null, peMgmtFeeCalcEnumId?: number | null, peIncentiveFeeCalcEnumId?: number | null, peMgmtFeeDuringCommitment?: number | null, peMgmtFeeDuringCommitmentCalcEnumId?: number | null, peMgmtFeeDuringHarvest?: number | null, peMgmtFeeDuringHarvestCalcEnumId?: number | null, pePlacementFeesPaid?: boolean | null, peGP?: number | null, peLP?: number | null, feeStructureChanged?: boolean | null, feeStructureChangedNotes?: string | null, standardShareClassRates?: boolean | null, abnormalFees?: boolean | null, abnormalFeesNotes?: string | null, hasMgmtFeeStepDown?: boolean | null, peMgmtFeeStepDownPercent?: number | null, peMgmtFeeStepDownCalcEnumId?: number | null, mgmtFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, mgmtFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, incentiveFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, incentiveFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, otherFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, otherFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, peMgmtFeeCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peIncentiveFeeCalc?: { __typename?: 'PeInctFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeDuringCommitmentCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeDuringHarvestCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeStepDownCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null } | null, liquidity?: { __typename?: 'Liquidity', id: number, shareClassId: number, hasGate?: boolean | null, gatePercentNav?: number | null, gatePercentCapital?: number | null, exceptions?: string | null, hasRollover?: boolean | null, rolloverValue?: number | null, rolloverUnitId?: number | null, hasLockup?: boolean | null, lockupValue?: number | null, lockupUnitId?: number | null, lockupEndValueId?: number | null, lockupEndUnitId?: number | null, lockupEndBasisDate?: string | null, lockupEndBizDays?: boolean | null, secondLockupValue?: number | null, secondLockupUnitId?: number | null, secondLockupEndValueId?: number | null, secondLockupEndUnitId?: number | null, secondLockupEndBasisDate?: string | null, secondLockupEndBizDays?: boolean | null, liquidityValue?: number | null, liquidityUnitId?: number | null, noticeValue?: number | null, noticeUnitId?: number | null, noticeBizDays?: boolean | null, subscriptionValue?: number | null, subscriptionUnitId?: number | null, cashAvailableDays?: number | null, hasHoldback?: boolean | null, holdbackPercent?: number | null, workoutId?: number | null, masterLevelFundGate?: boolean | null, lockupMonthlyValue: number, liquidityMonthlyValue: number, modelingNotes?: string | null, modifyDate?: string | null, rolloverUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, lockupUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, lockupEndValue?: { __typename?: 'LockupEndValueEnum', id: number, name?: string | null } | null, lockupEndUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupEndValue?: { __typename?: 'LockupEndValueEnum', id: number, name?: string | null } | null, secondLockupEndUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, liquidityUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, noticeUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, subscriptionUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, workout?: { __typename?: 'WorkoutEnum', id: number, name: string } | null } | null, peLiquidity?: { __typename?: 'PeLiquidity', id: number, shareClassId: number, preferredReturn?: number | null, isCompounded?: boolean | null, compoundingPeriodId?: number | null, hasCatchupProvision?: boolean | null, catchupPercent?: number | null, optionOfExtensionId?: number | null, compoundingPeriod?: { __typename?: 'CompoundingPeriodEnum', id: number, name?: string | null } | null, optionOfExtension?: { __typename?: 'RightOfExtensionEnum', id: number, name?: string | null } | null } | null, softLockups?: Array<{ __typename?: 'SoftLockup', id: number, liquidityId: number, cashAvailableDays?: number | null, lockupEndRedemptionOnId?: number | null, holdBackPercent?: number | null, noticeValue?: number | null, liquidityValue?: number | null, liquidityUnitId?: number | null, noticeBizDays?: boolean | null, redemptionFee: number, redemptionOnBizDays?: boolean | null, secondLockupEndRedemptionOnId?: number | null, termBeginMonth: number, termEndMonth: number, hasRedemptionFee?: boolean | null, lockupEndRedemptionOn?: { __typename?: 'FinancialPeriodEnum', id: number, name: string } | null, liquidityUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupEndRedemptionOn?: { __typename?: 'FinancialPeriodEnum', id: number, name: string } | null }> | null }> | null } };

export type UpdateInvestmentTermsMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: InvestmentInput;
}>;


export type UpdateInvestmentTermsMutation = { __typename?: 'Mutation', updateInvestment: { __typename?: 'Investment', id: number, name: string, marketEnumId?: number | null, investmentPeriodYrs?: number | null, harvestPeriodYrs?: number | null, extensionPeriodYrs?: number | null, peLegalLifeYrs?: number | null, shareClassNote?: string | null, shareClasses?: Array<{ __typename?: 'ShareClass', id: number, investmentId: number, name: string, currencyDenominationEnumId?: number | null, otherFees?: string | null, restricted?: boolean | null, FAS157?: number | null, status?: string | null, isRcgNegotiated?: boolean | null, investment?: { __typename?: 'Investment', id: number, name: string, marketEnumId?: number | null } | null, investmentFees?: { __typename?: 'InvestmentFees', id: number, shareClassId: number, mgmtFee?: number | null, mgmtFeeCalcEnumId?: number | null, mgmtFeeFreqEnumId?: number | null, incentiveFee?: number | null, incentiveFeeCalcEnumId?: number | null, incentiveFeeFreqEnumId?: number | null, otherFee?: number | null, otherFeeCalcEnumId?: number | null, otherFeeFreqEnumId?: number | null, highWaterMark?: boolean | null, hurdle?: boolean | null, hurdleBenchmark?: string | null, annualReset?: boolean | null, peMgmtFeeCalcEnumId?: number | null, peIncentiveFeeCalcEnumId?: number | null, peMgmtFeeDuringCommitment?: number | null, peMgmtFeeDuringCommitmentCalcEnumId?: number | null, peMgmtFeeDuringHarvest?: number | null, peMgmtFeeDuringHarvestCalcEnumId?: number | null, pePlacementFeesPaid?: boolean | null, peGP?: number | null, peLP?: number | null, feeStructureChanged?: boolean | null, feeStructureChangedNotes?: string | null, standardShareClassRates?: boolean | null, abnormalFees?: boolean | null, abnormalFeesNotes?: string | null, hasMgmtFeeStepDown?: boolean | null, peMgmtFeeStepDownPercent?: number | null, peMgmtFeeStepDownCalcEnumId?: number | null, mgmtFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, mgmtFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, incentiveFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, incentiveFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, otherFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, otherFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, peMgmtFeeCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peIncentiveFeeCalc?: { __typename?: 'PeInctFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeDuringCommitmentCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeDuringHarvestCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeStepDownCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null } | null, liquidity?: { __typename?: 'Liquidity', id: number, shareClassId: number, hasGate?: boolean | null, gatePercentNav?: number | null, gatePercentCapital?: number | null, exceptions?: string | null, hasRollover?: boolean | null, rolloverValue?: number | null, rolloverUnitId?: number | null, hasLockup?: boolean | null, lockupValue?: number | null, lockupUnitId?: number | null, lockupEndValueId?: number | null, lockupEndUnitId?: number | null, lockupEndBasisDate?: string | null, lockupEndBizDays?: boolean | null, secondLockupValue?: number | null, secondLockupUnitId?: number | null, secondLockupEndValueId?: number | null, secondLockupEndUnitId?: number | null, secondLockupEndBasisDate?: string | null, secondLockupEndBizDays?: boolean | null, liquidityValue?: number | null, liquidityUnitId?: number | null, noticeValue?: number | null, noticeUnitId?: number | null, noticeBizDays?: boolean | null, subscriptionValue?: number | null, subscriptionUnitId?: number | null, cashAvailableDays?: number | null, hasHoldback?: boolean | null, holdbackPercent?: number | null, workoutId?: number | null, masterLevelFundGate?: boolean | null, lockupMonthlyValue: number, liquidityMonthlyValue: number, modelingNotes?: string | null, modifyDate?: string | null, rolloverUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, lockupUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, lockupEndValue?: { __typename?: 'LockupEndValueEnum', id: number, name?: string | null } | null, lockupEndUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupEndValue?: { __typename?: 'LockupEndValueEnum', id: number, name?: string | null } | null, secondLockupEndUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, liquidityUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, noticeUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, subscriptionUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, workout?: { __typename?: 'WorkoutEnum', id: number, name: string } | null } | null, peLiquidity?: { __typename?: 'PeLiquidity', id: number, shareClassId: number, preferredReturn?: number | null, isCompounded?: boolean | null, compoundingPeriodId?: number | null, hasCatchupProvision?: boolean | null, catchupPercent?: number | null, optionOfExtensionId?: number | null, compoundingPeriod?: { __typename?: 'CompoundingPeriodEnum', id: number, name?: string | null } | null, optionOfExtension?: { __typename?: 'RightOfExtensionEnum', id: number, name?: string | null } | null } | null, softLockups?: Array<{ __typename?: 'SoftLockup', id: number, liquidityId: number, cashAvailableDays?: number | null, lockupEndRedemptionOnId?: number | null, holdBackPercent?: number | null, noticeValue?: number | null, liquidityValue?: number | null, liquidityUnitId?: number | null, noticeBizDays?: boolean | null, redemptionFee: number, redemptionOnBizDays?: boolean | null, secondLockupEndRedemptionOnId?: number | null, termBeginMonth: number, termEndMonth: number, hasRedemptionFee?: boolean | null, lockupEndRedemptionOn?: { __typename?: 'FinancialPeriodEnum', id: number, name: string } | null, liquidityUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupEndRedemptionOn?: { __typename?: 'FinancialPeriodEnum', id: number, name: string } | null }> | null }> | null } };

export type CreateInvestmentsFamilyMutationVariables = Exact<{
  input: InvestmentsFamilyInput;
}>;


export type CreateInvestmentsFamilyMutation = { __typename?: 'Mutation', addInvestmentsFamily: { __typename?: 'InvestmentsFamily', id: number } };

export type DeleteInvestmentsFamilyMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteInvestmentsFamilyMutation = { __typename?: 'Mutation', deleteInvestmentsFamily: number };

export type GetListLegalStructureEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<LegalStructureEnumSort> | LegalStructureEnumSort>;
}>;


export type GetListLegalStructureEnumQuery = { __typename?: 'Query', legalStructureEnumList: { __typename?: 'LegalStructureEnumList', total: number, items: Array<{ __typename?: 'LegalStructureEnum', id: string, name: string }> } };

export type GetOneLegalStructureEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneLegalStructureEnumQuery = { __typename?: 'Query', legalStructureEnum?: { __typename?: 'LegalStructureEnum', id: string, name: string } | null };

export type GetManyLegalStructureEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyLegalStructureEnumQuery = { __typename?: 'Query', legalStructureEnumMany: Array<{ __typename?: 'LegalStructureEnum', id: string, name: string } | null> };

export type LinksAttributesFragment = { __typename?: 'Links', id: number, name: string, url: string, iconEnumId: number, iconEnum?: { __typename?: 'IconEnum', name: string, id: string } | null, orgLinks: Array<{ __typename?: 'OrgLinks', id: string, linkId: number, organizationId: number, expirationDate?: string | null, organization?: { __typename?: 'Organization', id: number, name: string } | null }> };

export type GetListLinksQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<LinksSort> | LinksSort>;
  filter?: InputMaybe<LinksFilter>;
}>;


export type GetListLinksQuery = { __typename?: 'Query', linksList: { __typename?: 'LinksList', total: number, items: Array<{ __typename?: 'Links', id: number, name: string, url: string, iconEnumId: number, iconEnum?: { __typename?: 'IconEnum', name: string, id: string } | null, orgLinks: Array<{ __typename?: 'OrgLinks', id: string, linkId: number, organizationId: number, expirationDate?: string | null, organization?: { __typename?: 'Organization', id: number, name: string } | null }> }> } };

export type GetOneLinkQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneLinkQuery = { __typename?: 'Query', links?: { __typename?: 'Links', id: number, name: string, url: string, iconEnumId: number, iconEnum?: { __typename?: 'IconEnum', name: string, id: string } | null, orgLinks: Array<{ __typename?: 'OrgLinks', id: string, linkId: number, organizationId: number, expirationDate?: string | null, organization?: { __typename?: 'Organization', id: number, name: string } | null }> } | null };

export type GetManyLinksQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyLinksQuery = { __typename?: 'Query', linksMany: Array<{ __typename?: 'Links', id: number, name: string, url: string, iconEnumId: number, iconEnum?: { __typename?: 'IconEnum', name: string, id: string } | null, orgLinks: Array<{ __typename?: 'OrgLinks', id: string, linkId: number, organizationId: number, expirationDate?: string | null, organization?: { __typename?: 'Organization', id: number, name: string } | null }> } | null> };

export type CreateLinksMutationVariables = Exact<{
  input: LinksInput;
}>;


export type CreateLinksMutation = { __typename?: 'Mutation', addLinks: { __typename?: 'Links', id: number, name: string, url: string, iconEnumId: number, iconEnum?: { __typename?: 'IconEnum', name: string, id: string } | null, orgLinks: Array<{ __typename?: 'OrgLinks', id: string, linkId: number, organizationId: number, expirationDate?: string | null, organization?: { __typename?: 'Organization', id: number, name: string } | null }> } };

export type UpdateLinksMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: LinksInput;
}>;


export type UpdateLinksMutation = { __typename?: 'Mutation', updateLinks: { __typename?: 'Links', id: number, name: string, url: string, iconEnumId: number, iconEnum?: { __typename?: 'IconEnum', name: string, id: string } | null, orgLinks: Array<{ __typename?: 'OrgLinks', id: string, linkId: number, organizationId: number, expirationDate?: string | null, organization?: { __typename?: 'Organization', id: number, name: string } | null }> } };

export type DeleteLinksMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteLinksMutation = { __typename?: 'Mutation', deleteLinks: number };

export type LiquidityAttributesFragment = { __typename?: 'Liquidity', id: number, shareClassId: number, hasGate?: boolean | null, gatePercentNav?: number | null, gatePercentCapital?: number | null, exceptions?: string | null, hasRollover?: boolean | null, rolloverValue?: number | null, rolloverUnitId?: number | null, hasLockup?: boolean | null, lockupValue?: number | null, lockupUnitId?: number | null, lockupEndValueId?: number | null, lockupEndUnitId?: number | null, lockupEndBasisDate?: string | null, lockupEndBizDays?: boolean | null, secondLockupValue?: number | null, secondLockupUnitId?: number | null, secondLockupEndValueId?: number | null, secondLockupEndUnitId?: number | null, secondLockupEndBasisDate?: string | null, secondLockupEndBizDays?: boolean | null, liquidityValue?: number | null, liquidityUnitId?: number | null, noticeValue?: number | null, noticeUnitId?: number | null, noticeBizDays?: boolean | null, subscriptionValue?: number | null, subscriptionUnitId?: number | null, cashAvailableDays?: number | null, hasHoldback?: boolean | null, holdbackPercent?: number | null, workoutId?: number | null, masterLevelFundGate?: boolean | null, lockupMonthlyValue: number, liquidityMonthlyValue: number, modelingNotes?: string | null, modifyDate?: string | null, rolloverUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, lockupUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, lockupEndValue?: { __typename?: 'LockupEndValueEnum', id: number, name?: string | null } | null, lockupEndUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupEndValue?: { __typename?: 'LockupEndValueEnum', id: number, name?: string | null } | null, secondLockupEndUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, liquidityUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, noticeUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, subscriptionUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, workout?: { __typename?: 'WorkoutEnum', id: number, name: string } | null };

export type GetListLiquidityQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<LiquiditySort> | LiquiditySort>;
  filter?: InputMaybe<LiquidityFilter>;
}>;


export type GetListLiquidityQuery = { __typename?: 'Query', liquidityList: { __typename?: 'LiquidityList', total: number, items: Array<{ __typename?: 'Liquidity', id: number, shareClassId: number, hasGate?: boolean | null, gatePercentNav?: number | null, gatePercentCapital?: number | null, exceptions?: string | null, hasRollover?: boolean | null, rolloverValue?: number | null, rolloverUnitId?: number | null, hasLockup?: boolean | null, lockupValue?: number | null, lockupUnitId?: number | null, lockupEndValueId?: number | null, lockupEndUnitId?: number | null, lockupEndBasisDate?: string | null, lockupEndBizDays?: boolean | null, secondLockupValue?: number | null, secondLockupUnitId?: number | null, secondLockupEndValueId?: number | null, secondLockupEndUnitId?: number | null, secondLockupEndBasisDate?: string | null, secondLockupEndBizDays?: boolean | null, liquidityValue?: number | null, liquidityUnitId?: number | null, noticeValue?: number | null, noticeUnitId?: number | null, noticeBizDays?: boolean | null, subscriptionValue?: number | null, subscriptionUnitId?: number | null, cashAvailableDays?: number | null, hasHoldback?: boolean | null, holdbackPercent?: number | null, workoutId?: number | null, masterLevelFundGate?: boolean | null, lockupMonthlyValue: number, liquidityMonthlyValue: number, modelingNotes?: string | null, modifyDate?: string | null, rolloverUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, lockupUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, lockupEndValue?: { __typename?: 'LockupEndValueEnum', id: number, name?: string | null } | null, lockupEndUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupEndValue?: { __typename?: 'LockupEndValueEnum', id: number, name?: string | null } | null, secondLockupEndUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, liquidityUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, noticeUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, subscriptionUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, workout?: { __typename?: 'WorkoutEnum', id: number, name: string } | null }> } };

export type GetOneLiquidityQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneLiquidityQuery = { __typename?: 'Query', liquidity?: { __typename?: 'Liquidity', id: number, shareClassId: number, hasGate?: boolean | null, gatePercentNav?: number | null, gatePercentCapital?: number | null, exceptions?: string | null, hasRollover?: boolean | null, rolloverValue?: number | null, rolloverUnitId?: number | null, hasLockup?: boolean | null, lockupValue?: number | null, lockupUnitId?: number | null, lockupEndValueId?: number | null, lockupEndUnitId?: number | null, lockupEndBasisDate?: string | null, lockupEndBizDays?: boolean | null, secondLockupValue?: number | null, secondLockupUnitId?: number | null, secondLockupEndValueId?: number | null, secondLockupEndUnitId?: number | null, secondLockupEndBasisDate?: string | null, secondLockupEndBizDays?: boolean | null, liquidityValue?: number | null, liquidityUnitId?: number | null, noticeValue?: number | null, noticeUnitId?: number | null, noticeBizDays?: boolean | null, subscriptionValue?: number | null, subscriptionUnitId?: number | null, cashAvailableDays?: number | null, hasHoldback?: boolean | null, holdbackPercent?: number | null, workoutId?: number | null, masterLevelFundGate?: boolean | null, lockupMonthlyValue: number, liquidityMonthlyValue: number, modelingNotes?: string | null, modifyDate?: string | null, rolloverUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, lockupUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, lockupEndValue?: { __typename?: 'LockupEndValueEnum', id: number, name?: string | null } | null, lockupEndUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupEndValue?: { __typename?: 'LockupEndValueEnum', id: number, name?: string | null } | null, secondLockupEndUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, liquidityUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, noticeUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, subscriptionUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, workout?: { __typename?: 'WorkoutEnum', id: number, name: string } | null } | null };

export type GetManyLiquidityQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyLiquidityQuery = { __typename?: 'Query', liquidityMany: Array<{ __typename?: 'Liquidity', id: number, shareClassId: number, hasGate?: boolean | null, gatePercentNav?: number | null, gatePercentCapital?: number | null, exceptions?: string | null, hasRollover?: boolean | null, rolloverValue?: number | null, rolloverUnitId?: number | null, hasLockup?: boolean | null, lockupValue?: number | null, lockupUnitId?: number | null, lockupEndValueId?: number | null, lockupEndUnitId?: number | null, lockupEndBasisDate?: string | null, lockupEndBizDays?: boolean | null, secondLockupValue?: number | null, secondLockupUnitId?: number | null, secondLockupEndValueId?: number | null, secondLockupEndUnitId?: number | null, secondLockupEndBasisDate?: string | null, secondLockupEndBizDays?: boolean | null, liquidityValue?: number | null, liquidityUnitId?: number | null, noticeValue?: number | null, noticeUnitId?: number | null, noticeBizDays?: boolean | null, subscriptionValue?: number | null, subscriptionUnitId?: number | null, cashAvailableDays?: number | null, hasHoldback?: boolean | null, holdbackPercent?: number | null, workoutId?: number | null, masterLevelFundGate?: boolean | null, lockupMonthlyValue: number, liquidityMonthlyValue: number, modelingNotes?: string | null, modifyDate?: string | null, rolloverUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, lockupUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, lockupEndValue?: { __typename?: 'LockupEndValueEnum', id: number, name?: string | null } | null, lockupEndUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupEndValue?: { __typename?: 'LockupEndValueEnum', id: number, name?: string | null } | null, secondLockupEndUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, liquidityUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, noticeUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, subscriptionUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, workout?: { __typename?: 'WorkoutEnum', id: number, name: string } | null } | null> };

export type GetListLockupEndValueEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<LockupEndValueEnumSort> | LockupEndValueEnumSort>;
}>;


export type GetListLockupEndValueEnumQuery = { __typename?: 'Query', lockupEndValueEnumList: { __typename?: 'LockupEndValueEnumList', total: number, items: Array<{ __typename?: 'LockupEndValueEnum', id: number, name?: string | null }> } };

export type GetOneLockupEndValueEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneLockupEndValueEnumQuery = { __typename?: 'Query', lockupEndValueEnum?: { __typename?: 'LockupEndValueEnum', id: number, name?: string | null } | null };

export type GetManyLockupEndValueEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyLockupEndValueEnumQuery = { __typename?: 'Query', lockupEndValueEnumMany: Array<{ __typename?: 'LockupEndValueEnum', id: number, name?: string | null } | null> };

export type GetListMeasureEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<MeasureEnumSort> | MeasureEnumSort>;
}>;


export type GetListMeasureEnumQuery = { __typename?: 'Query', measureEnumList: { __typename?: 'MeasureEnumList', total: number, items: Array<{ __typename?: 'MeasureEnum', id: number, description: string, displayOrder?: number | null, questionText?: string | null, measureTypeEnumId?: number | null, measureTypeEnum?: { __typename?: 'MeasureTypeEnum', id: number, name: string } | null }> } };

export type GetOneMeasureEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneMeasureEnumQuery = { __typename?: 'Query', measureEnum?: { __typename?: 'MeasureEnum', id: number, description: string, displayOrder?: number | null, questionText?: string | null, measureTypeEnumId?: number | null, measureTypeEnum?: { __typename?: 'MeasureTypeEnum', id: number, name: string } | null } | null };

export type GetManyMeasureEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyMeasureEnumQuery = { __typename?: 'Query', measureEnumMany: Array<{ __typename?: 'MeasureEnum', id: number, description: string, displayOrder?: number | null, questionText?: string | null, measureTypeEnumId?: number | null, measureTypeEnum?: { __typename?: 'MeasureTypeEnum', id: number, name: string } | null } | null> };

export type GetListMeasureTypeEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<MeasureTypeEnumSort> | MeasureTypeEnumSort>;
}>;


export type GetListMeasureTypeEnumQuery = { __typename?: 'Query', measureTypeEnumList: { __typename?: 'MeasureTypeEnumList', total: number, items: Array<{ __typename?: 'MeasureTypeEnum', id: number, name: string }> } };

export type GetOneMeasureTypeEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneMeasureTypeEnumQuery = { __typename?: 'Query', measureTypeEnum?: { __typename?: 'MeasureTypeEnum', id: number, name: string } | null };

export type GetManyMeasureTypeEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyMeasureTypeEnumQuery = { __typename?: 'Query', measureTypeEnumMany: Array<{ __typename?: 'MeasureTypeEnum', id: number, name: string } | null> };

export type GetListNavClassificationEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<NavClassificationEnumSort> | NavClassificationEnumSort>;
}>;


export type GetListNavClassificationEnumQuery = { __typename?: 'Query', navClassificationEnumList: { __typename?: 'NAVClassificationEnumList', total: number, items: Array<{ __typename?: 'NAVClassificationEnum', id: string, name: string }> } };

export type GetOneNavClassificationEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneNavClassificationEnumQuery = { __typename?: 'Query', navClassificationEnum?: { __typename?: 'NAVClassificationEnum', id: string, name: string } | null };

export type GetManyNavClassificationEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyNavClassificationEnumQuery = { __typename?: 'Query', navClassificationEnumMany: Array<{ __typename?: 'NAVClassificationEnum', id: string, name: string } | null> };

export type GetListNotesMetaEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<NoteMetaEnumSort> | NoteMetaEnumSort>;
  filter?: InputMaybe<NoteMetaEnumFilter>;
}>;


export type GetListNotesMetaEnumQuery = { __typename?: 'Query', noteMetaEnumList: { __typename?: 'NoteMetaEnumList', total: number, items: Array<{ __typename?: 'NoteMetaEnum', id: number, label?: string | null }> } };

export type GetManyNotesMetaEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyNotesMetaEnumQuery = { __typename?: 'Query', noteMetaEnumMany: Array<{ __typename?: 'NoteMetaEnum', id: number, label?: string | null } | null> };

export type NoteAttributesFragment = { __typename?: 'Notes', id: number, noteMetaId: number, noteDate?: string | null, text?: string | null, createUser?: string | null, createDate?: string | null, modifyUser?: string | null, modifyDate?: string | null, accessLevelId: number, entityAssignments: Array<{ __typename?: 'NotesXEntity', id: number, businessObjectTypeEnumId: number, entityId: number, entityName?: string | null }>, noteMeta: { __typename?: 'NoteMetaEnum', id: number, label?: string | null } };

export type GetListNotesQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<NotesSort> | NotesSort>;
  filter?: InputMaybe<NotesFilter>;
}>;


export type GetListNotesQuery = { __typename?: 'Query', notesList: { __typename?: 'NotesList', total: number, items: Array<{ __typename?: 'Notes', id: number, noteMetaId: number, noteDate?: string | null, text?: string | null, createUser?: string | null, createDate?: string | null, modifyUser?: string | null, modifyDate?: string | null, accessLevelId: number, entityAssignments: Array<{ __typename?: 'NotesXEntity', id: number, businessObjectTypeEnumId: number, entityId: number, entityName?: string | null }>, noteMeta: { __typename?: 'NoteMetaEnum', id: number, label?: string | null } }> } };

export type GetOneNotesQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneNotesQuery = { __typename?: 'Query', notes?: { __typename?: 'Notes', id: number, noteMetaId: number, noteDate?: string | null, text?: string | null, createUser?: string | null, createDate?: string | null, modifyUser?: string | null, modifyDate?: string | null, accessLevelId: number, entityAssignments: Array<{ __typename?: 'NotesXEntity', id: number, businessObjectTypeEnumId: number, entityId: number, entityName?: string | null }>, noteMeta: { __typename?: 'NoteMetaEnum', id: number, label?: string | null } } | null };

export type GetManyNotesQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyNotesQuery = { __typename?: 'Query', notesMany: Array<{ __typename?: 'Notes', id: number, noteMetaId: number, noteDate?: string | null, text?: string | null, createUser?: string | null, createDate?: string | null, modifyUser?: string | null, modifyDate?: string | null, accessLevelId: number, entityAssignments: Array<{ __typename?: 'NotesXEntity', id: number, businessObjectTypeEnumId: number, entityId: number, entityName?: string | null }>, noteMeta: { __typename?: 'NoteMetaEnum', id: number, label?: string | null } } | null> };

export type AddNoteMutationVariables = Exact<{
  input: NotesInput;
}>;


export type AddNoteMutation = { __typename?: 'Mutation', addNote: { __typename?: 'Notes', id: number } };

export type UpdateNoteMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: NotesInput;
}>;


export type UpdateNoteMutation = { __typename?: 'Mutation', updateNote: { __typename?: 'Notes', id: number } };

export type InstitutionAttributesFragment = { __typename?: 'Institution', id: number, name: string, institutionNameWithLocation: string, institutionSelectionStatusEnumId?: number | null, addressesId: number, institutionInstitutionTypesList: Array<number>, institutionSelectionStatusEnum?: { __typename?: 'InstitutionSelectionStatusEnum', name: string } | null, address: { __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, zipCode?: string | null, countryEnumId?: number | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null, website?: string | null, webUserId?: string | null, webPassword?: string | null }, globalProviderInstitution?: { __typename?: 'GlobalProviderInstitutions', providerId: number, id: number, isCorporate: boolean } | null };

export type GetListInstitutionQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InstitutionSort> | InstitutionSort>;
  filter?: InputMaybe<InstitutionFilterInput>;
}>;


export type GetListInstitutionQuery = { __typename?: 'Query', institutionList: { __typename?: 'InstitutionList', total: number, items: Array<{ __typename?: 'Institution', id: number, name: string, institutionNameWithLocation: string, institutionSelectionStatusEnumId?: number | null, addressesId: number, institutionInstitutionTypesList: Array<number>, institutionSelectionStatusEnum?: { __typename?: 'InstitutionSelectionStatusEnum', name: string } | null, address: { __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, zipCode?: string | null, countryEnumId?: number | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null, website?: string | null, webUserId?: string | null, webPassword?: string | null }, globalProviderInstitution?: { __typename?: 'GlobalProviderInstitutions', providerId: number, id: number, isCorporate: boolean } | null }> } };

export type GetOneInstitutionQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneInstitutionQuery = { __typename?: 'Query', institution?: { __typename?: 'Institution', id: number, name: string, institutionNameWithLocation: string, institutionSelectionStatusEnumId?: number | null, addressesId: number, institutionInstitutionTypesList: Array<number>, institutionSelectionStatusEnum?: { __typename?: 'InstitutionSelectionStatusEnum', name: string } | null, address: { __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, zipCode?: string | null, countryEnumId?: number | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null, website?: string | null, webUserId?: string | null, webPassword?: string | null }, globalProviderInstitution?: { __typename?: 'GlobalProviderInstitutions', providerId: number, id: number, isCorporate: boolean } | null } | null };

export type GetManyInstitutionQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyInstitutionQuery = { __typename?: 'Query', institutionMany: Array<{ __typename?: 'Institution', id: number, name: string, institutionNameWithLocation: string, institutionSelectionStatusEnumId?: number | null, addressesId: number, institutionInstitutionTypesList: Array<number>, institutionSelectionStatusEnum?: { __typename?: 'InstitutionSelectionStatusEnum', name: string } | null, address: { __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, zipCode?: string | null, countryEnumId?: number | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null, website?: string | null, webUserId?: string | null, webPassword?: string | null }, globalProviderInstitution?: { __typename?: 'GlobalProviderInstitutions', providerId: number, id: number, isCorporate: boolean } | null } | null> };

export type CreateInstitutionMutationVariables = Exact<{
  input: InstitutionInput;
}>;


export type CreateInstitutionMutation = { __typename?: 'Mutation', addInstitution: { __typename?: 'Institution', id: number, name: string, institutionNameWithLocation: string, institutionSelectionStatusEnumId?: number | null, addressesId: number, institutionInstitutionTypesList: Array<number>, institutionSelectionStatusEnum?: { __typename?: 'InstitutionSelectionStatusEnum', name: string } | null, address: { __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, zipCode?: string | null, countryEnumId?: number | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null, website?: string | null, webUserId?: string | null, webPassword?: string | null }, globalProviderInstitution?: { __typename?: 'GlobalProviderInstitutions', providerId: number, id: number, isCorporate: boolean } | null } };

export type UpdateInstitutionMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: InstitutionInput;
}>;


export type UpdateInstitutionMutation = { __typename?: 'Mutation', updateInstitution: { __typename?: 'Institution', id: number, name: string, institutionNameWithLocation: string, institutionSelectionStatusEnumId?: number | null, addressesId: number, institutionInstitutionTypesList: Array<number>, institutionSelectionStatusEnum?: { __typename?: 'InstitutionSelectionStatusEnum', name: string } | null, address: { __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, zipCode?: string | null, countryEnumId?: number | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null, website?: string | null, webUserId?: string | null, webPassword?: string | null }, globalProviderInstitution?: { __typename?: 'GlobalProviderInstitutions', providerId: number, id: number, isCorporate: boolean } | null } };

export type GetListOperatingStatusEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<OperatingStatusEnumSort> | OperatingStatusEnumSort>;
}>;


export type GetListOperatingStatusEnumQuery = { __typename?: 'Query', operatingStatusEnumList: { __typename?: 'OperatingStatusEnumList', total: number, items: Array<{ __typename?: 'OperatingStatusEnum', id: string, name: string }> } };

export type GetOneOperatingStatusEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneOperatingStatusEnumQuery = { __typename?: 'Query', operatingStatusEnum?: { __typename?: 'OperatingStatusEnum', id: string, name: string } | null };

export type GetManyOperatingStatusEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyOperatingStatusEnumQuery = { __typename?: 'Query', operatingStatusEnumMany: Array<{ __typename?: 'OperatingStatusEnum', id: string, name: string } | null> };

export type OrgLinksAttributesFragment = { __typename?: 'OrgLinks', id: string, linkId: number, organizationId: number, expirationDate?: string | null, link?: { __typename?: 'Links', name: string, url: string, iconEnumId: number, iconEnum?: { __typename?: 'IconEnum', name: string, id: string } | null } | null, organization?: { __typename?: 'Organization', id: number, name: string } | null };

export type GetListOrgLinksQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<OrgLinksSort> | OrgLinksSort>;
  filter?: InputMaybe<OrgLinksFilter>;
}>;


export type GetListOrgLinksQuery = { __typename?: 'Query', orgLinksList: { __typename?: 'OrgLinksList', total: number, items: Array<{ __typename?: 'OrgLinks', id: string, linkId: number, organizationId: number, expirationDate?: string | null, link?: { __typename?: 'Links', name: string, url: string, iconEnumId: number, iconEnum?: { __typename?: 'IconEnum', name: string, id: string } | null } | null, organization?: { __typename?: 'Organization', id: number, name: string } | null }> } };

export type GetOneOrgLinksQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneOrgLinksQuery = { __typename?: 'Query', orgLinks?: { __typename?: 'OrgLinks', id: string, linkId: number, organizationId: number, expirationDate?: string | null, link?: { __typename?: 'Links', name: string, url: string, iconEnumId: number, iconEnum?: { __typename?: 'IconEnum', name: string, id: string } | null } | null, organization?: { __typename?: 'Organization', id: number, name: string } | null } | null };

export type GetManyOrgLinksQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyOrgLinksQuery = { __typename?: 'Query', orgLinksMany: Array<{ __typename?: 'OrgLinks', id: string, linkId: number, organizationId: number, expirationDate?: string | null, link?: { __typename?: 'Links', name: string, url: string, iconEnumId: number, iconEnum?: { __typename?: 'IconEnum', name: string, id: string } | null } | null, organization?: { __typename?: 'Organization', id: number, name: string } | null } | null> };

export type OrganizationAttributesFragment = { __typename?: 'Organization', id: number, name: string, clientId?: string | null, intakeOrganizationId?: string | null, smallIconUrl?: string | null, orgLinks: Array<{ __typename?: 'OrgLinks', id: string, organizationId: number, linkId: number, expirationDate?: string | null, link?: { __typename?: 'Links', name: string, url: string, id: number } | null }> };

export type GetListOrganizationQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<OrganizationSort> | OrganizationSort>;
  filter?: InputMaybe<OrganizationFilter>;
}>;


export type GetListOrganizationQuery = { __typename?: 'Query', organizationList: { __typename?: 'OrganizationList', total: number, items: Array<{ __typename?: 'Organization', id: number, name: string, clientId?: string | null, intakeOrganizationId?: string | null, smallIconUrl?: string | null, orgLinks: Array<{ __typename?: 'OrgLinks', id: string, organizationId: number, linkId: number, expirationDate?: string | null, link?: { __typename?: 'Links', name: string, url: string, id: number } | null }> }> } };

export type GetOneOrganizationQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneOrganizationQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: number, name: string, clientId?: string | null, intakeOrganizationId?: string | null, smallIconUrl?: string | null, orgLinks: Array<{ __typename?: 'OrgLinks', id: string, organizationId: number, linkId: number, expirationDate?: string | null, link?: { __typename?: 'Links', name: string, url: string, id: number } | null }> } | null };

export type UpdateOrganizationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: OrganizationInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'Organization', id: number } };

export type CreateOrganizationMutationVariables = Exact<{
  input: OrganizationCreateInput;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization: { __typename?: 'Organization', id: number, name: string, clientId?: string | null, intakeOrganizationId?: string | null, smallIconUrl?: string | null, orgLinks: Array<{ __typename?: 'OrgLinks', id: string, organizationId: number, linkId: number, expirationDate?: string | null, link?: { __typename?: 'Links', name: string, url: string, id: number } | null }> } };

export type GetListOrganizationStructureEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<OrganizationStructureEnumSort> | OrganizationStructureEnumSort>;
}>;


export type GetListOrganizationStructureEnumQuery = { __typename?: 'Query', organizationStructureEnumList: { __typename?: 'OrganizationStructureEnumList', total: number, items: Array<{ __typename?: 'OrganizationStructureEnum', id: string, name: string }> } };

export type GetOneOrganizationStructureEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneOrganizationStructureEnumQuery = { __typename?: 'Query', organizationStructureEnum?: { __typename?: 'OrganizationStructureEnum', id: string, name: string } | null };

export type GetManyOrganizationStructureEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyOrganizationStructureEnumQuery = { __typename?: 'Query', organizationStructureEnumMany: Array<{ __typename?: 'OrganizationStructureEnum', id: string, name: string } | null> };

export type GetListPeFundNumberEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PeFundNumberEnumSort> | PeFundNumberEnumSort>;
  filter?: InputMaybe<PeFundNumberEnumFilter>;
}>;


export type GetListPeFundNumberEnumQuery = { __typename?: 'Query', peFundNumberEnumList: { __typename?: 'PEFundNumberEnumList', total: number, items: Array<{ __typename?: 'PEFundNumberEnum', id: number, name: string }> } };

export type GetOnePeFundNumberEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOnePeFundNumberEnumQuery = { __typename?: 'Query', peFundNumberEnum?: { __typename?: 'PEFundNumberEnum', id: number, name: string } | null };

export type GetManyPeFundNumberEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyPeFundNumberEnumQuery = { __typename?: 'Query', peFundNumberEnumMany: Array<{ __typename?: 'PEFundNumberEnum', id: number, name: string } | null> };

export type GetListPeInctFeeCalcEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PeInctFeeCalcEnumSort> | PeInctFeeCalcEnumSort>;
}>;


export type GetListPeInctFeeCalcEnumQuery = { __typename?: 'Query', peInctFeeCalcEnumList: { __typename?: 'PeInctFeeCalcEnumList', total: number, items: Array<{ __typename?: 'PeInctFeeCalcEnum', id: number, name?: string | null }> } };

export type GetOnePeInctFeeCalcEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOnePeInctFeeCalcEnumQuery = { __typename?: 'Query', peInctFeeCalcEnum?: { __typename?: 'PeInctFeeCalcEnum', id: number, name?: string | null } | null };

export type GetManyPeInctFeeCalcEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyPeInctFeeCalcEnumQuery = { __typename?: 'Query', peInctFeeCalcEnumMany: Array<{ __typename?: 'PeInctFeeCalcEnum', id: number, name?: string | null } | null> };

export type PeLiquidityAttributesFragment = { __typename?: 'PeLiquidity', id: number, shareClassId: number, preferredReturn?: number | null, isCompounded?: boolean | null, compoundingPeriodId?: number | null, hasCatchupProvision?: boolean | null, catchupPercent?: number | null, optionOfExtensionId?: number | null, compoundingPeriod?: { __typename?: 'CompoundingPeriodEnum', id: number, name?: string | null } | null, optionOfExtension?: { __typename?: 'RightOfExtensionEnum', id: number, name?: string | null } | null };

export type GetListPeLiquidityQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PeLiquiditySort> | PeLiquiditySort>;
  filter?: InputMaybe<PeLiquidityFilter>;
}>;


export type GetListPeLiquidityQuery = { __typename?: 'Query', peLiquidityList: { __typename?: 'PeLiquidityList', total: number, items: Array<{ __typename?: 'PeLiquidity', id: number, shareClassId: number, preferredReturn?: number | null, isCompounded?: boolean | null, compoundingPeriodId?: number | null, hasCatchupProvision?: boolean | null, catchupPercent?: number | null, optionOfExtensionId?: number | null, compoundingPeriod?: { __typename?: 'CompoundingPeriodEnum', id: number, name?: string | null } | null, optionOfExtension?: { __typename?: 'RightOfExtensionEnum', id: number, name?: string | null } | null }> } };

export type GetOnePeLiquidityQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOnePeLiquidityQuery = { __typename?: 'Query', peLiquidity: { __typename?: 'PeLiquidity', id: number, shareClassId: number, preferredReturn?: number | null, isCompounded?: boolean | null, compoundingPeriodId?: number | null, hasCatchupProvision?: boolean | null, catchupPercent?: number | null, optionOfExtensionId?: number | null, compoundingPeriod?: { __typename?: 'CompoundingPeriodEnum', id: number, name?: string | null } | null, optionOfExtension?: { __typename?: 'RightOfExtensionEnum', id: number, name?: string | null } | null } };

export type GetManyPeLiquidityQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyPeLiquidityQuery = { __typename?: 'Query', peLiquidityMany: Array<{ __typename?: 'PeLiquidity', id: number, shareClassId: number, preferredReturn?: number | null, isCompounded?: boolean | null, compoundingPeriodId?: number | null, hasCatchupProvision?: boolean | null, catchupPercent?: number | null, optionOfExtensionId?: number | null, compoundingPeriod?: { __typename?: 'CompoundingPeriodEnum', id: number, name?: string | null } | null, optionOfExtension?: { __typename?: 'RightOfExtensionEnum', id: number, name?: string | null } | null }> };

export type GetListPeMgmtFeeCalcEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PeMgmtFeeCalcEnumSort> | PeMgmtFeeCalcEnumSort>;
}>;


export type GetListPeMgmtFeeCalcEnumQuery = { __typename?: 'Query', peMgmtFeeCalcEnumList: { __typename?: 'PeMgmtFeeCalcEnumList', total: number, items: Array<{ __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null }> } };

export type GetOnePeMgmtFeeCalcEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOnePeMgmtFeeCalcEnumQuery = { __typename?: 'Query', peMgmtFeeCalcEnum?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null };

export type GetManyPeMgmtFeeCalcEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyPeMgmtFeeCalcEnumQuery = { __typename?: 'Query', peMgmtFeeCalcEnumMany: Array<{ __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null> };

export type GetListPeStrategyEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PeStrategyEnumSort> | PeStrategyEnumSort>;
}>;


export type GetListPeStrategyEnumQuery = { __typename?: 'Query', peStrategyEnumList: { __typename?: 'PEStrategyEnumList', total: number, items: Array<{ __typename?: 'PEStrategyEnum', id: number, name: string }> } };

export type GetOnePeStrategyEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOnePeStrategyEnumQuery = { __typename?: 'Query', peStrategyEnum?: { __typename?: 'PEStrategyEnum', id: number, name: string } | null };

export type GetManyPeStrategyEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyPeStrategyEnumQuery = { __typename?: 'Query', peStrategyEnumMany: Array<{ __typename?: 'PEStrategyEnum', id: number, name: string } | null> };

export type PerformanceBackgroundQueryVariables = Exact<{
  investmentId: Scalars['Int']['input'];
}>;


export type PerformanceBackgroundQuery = { __typename?: 'Query', investment: { __typename?: 'Investment', id: number, name: string, firmId?: number | null, fdpLogins?: Array<{ __typename?: 'FDPLogin', id: number, username: string, password: string, securityQuestion?: string | null, notes?: string | null, email?: string | null, mfaUser?: string | null, financialDataProvider: { __typename?: 'FinancialDataProvider', id: number, name: string, fdpWebsites: Array<{ __typename?: 'FDPWebsites', id: number, website: string }> } }> | null, firm?: { __typename?: 'Firm', id: number, name: string, firmEmployments?: Array<{ __typename?: 'FirmEmployment', id: number, person?: { __typename?: 'Person', id: number, lastName: string, firstName?: string | null, middleName?: string | null, email?: string | null, phone?: string | null } | null }> | null, primaryAddress?: { __typename?: 'Address', id: number, website?: string | null, webUserId?: string | null, webPassword?: string | null } | null } | null, portalSubmitted?: { __typename?: 'PortalSubmitted', migratedAt?: string | null } | null, latestNote?: { __typename?: 'Notes', id: number, createDate?: string | null, createUser?: string | null, text?: string | null } | null } };

export type GetOneInvestmentPerformanceMtdQueryVariables = Exact<{
  investmentId: Scalars['Int']['input'];
  priorTrackRecord?: InputMaybe<Scalars['Boolean']['input']>;
  returnType?: InputMaybe<ReturnTypes>;
  includeLlm?: Scalars['Boolean']['input'];
}>;


export type GetOneInvestmentPerformanceMtdQuery = { __typename?: 'Query', investment: { __typename?: 'Investment', name: string, id: number, firmId?: number | null, inceptionDate?: string | null, currencyDenominationEnumId?: number | null, performanceSource?: string | null, fdpLogins?: Array<{ __typename?: 'FDPLogin', id: number, username: string, password: string, securityQuestion?: string | null, notes?: string | null, email?: string | null, mfaUser?: string | null, financialDataProvider: { __typename?: 'FinancialDataProvider', id: number, name: string, fdpWebsites: Array<{ __typename?: 'FDPWebsites', id: number, website: string }> } }> | null, firm?: { __typename?: 'Firm', id: number, name: string, firmEmployments?: Array<{ __typename?: 'FirmEmployment', id: number, person?: { __typename?: 'Person', id: number, lastName: string, firstName?: string | null, middleName?: string | null, email?: string | null, phone?: string | null } | null }> | null, primaryAddress?: { __typename?: 'Address', id: number, website?: string | null, webUserId?: string | null, webPassword?: string | null } | null } | null, latestNote?: { __typename?: 'Notes', id: number, createDate?: string | null, createUser?: string | null, text?: string | null } | null, performanceMTD?: Array<{ __typename?: 'PerformanceMTD', returnYear: number, returnMonth: number, return?: number | null, currencyId: number, asOfDate: string, createUser: string, createDate?: string | null, modifyUser?: string | null, modifyDate?: string | null, performanceCommentary?: string | null }> | null, llmPerformanceMTD?: Array<{ __typename?: 'LLMPerformance', returnYear: number, returnMonth: number, return?: number | null, currencyId: number, asOfDate: string, returnType: string, performanceCommentary?: string | null, documentId?: number | null, createUser: string, createDate: string }> | null, portalSubmitted?: { __typename?: 'PortalSubmitted', migratedAt?: string | null } | null } };

export type GetOneInvestmentPerformanceQuarterlyQueryVariables = Exact<{
  investmentId: Scalars['Int']['input'];
  priorTrackRecord?: InputMaybe<Scalars['Boolean']['input']>;
  returnType?: InputMaybe<ReturnTypes>;
}>;


export type GetOneInvestmentPerformanceQuarterlyQuery = { __typename?: 'Query', investment: { __typename?: 'Investment', name: string, id: number, firmId?: number | null, inceptionDate?: string | null, performanceSource?: string | null, latestNote?: { __typename?: 'Notes', id: number, createDate?: string | null, createUser?: string | null, text?: string | null } | null, performanceQuarterly?: Array<{ __typename?: 'PerformanceQuarterly', returnYear: number, returnQuarter: number, returnType: string, return?: number | null }> | null, portalSubmitted?: { __typename?: 'PortalSubmitted', migratedAt?: string | null } | null } };

export type BulkUpdatePerformanceQuarterlyMutationVariables = Exact<{
  investmentId: Scalars['Int']['input'];
  returnType: ReturnTypes;
  quarters: Array<PerformanceQuarterlyShort> | PerformanceQuarterlyShort;
}>;


export type BulkUpdatePerformanceQuarterlyMutation = { __typename?: 'Mutation', addOrUpdatePerformanceQuarterly: { __typename?: 'PerformanceQuarterlyList', items: Array<{ __typename?: 'PerformanceQuarterly', return?: number | null, returnYear: number, returnQuarter: number, returnType: string }> } };

export type BulkUpdatePerformanceMtdMutationVariables = Exact<{
  investmentId: Scalars['Int']['input'];
  returnType: ReturnTypes;
  currencyId: Scalars['Int']['input'];
  months: Array<PerformanceMtdShort> | PerformanceMtdShort;
}>;


export type BulkUpdatePerformanceMtdMutation = { __typename?: 'Mutation', addOrUpdatePerformanceMTD: { __typename?: 'PerformanceMTDList', items: Array<{ __typename?: 'PerformanceMTD', returnYear: number, returnMonth: number, returnType: string, return?: number | null, currencyId: number, asOfDate: string }> } };

export type BloombergDiligenceExtractMutationVariables = Exact<{
  investmentIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type BloombergDiligenceExtractMutation = { __typename?: 'Mutation', bloombergDiligenceExtract: Array<{ __typename?: 'BloombergPullResponse', currency: string, tickers: Array<string>, monthlyId: string, dailyId: string }> };

export type BloombergDiligenceExtractStatusQueryVariables = Exact<{
  datasetIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type BloombergDiligenceExtractStatusQuery = { __typename?: 'Query', bloombergDiligenceExtractStatus: Array<{ __typename?: 'BbgDistributionsResponse', statusCode?: number | null, identifier?: string | null }> };

export type BloombergDiligenceLoadMutationVariables = Exact<{
  inputs: Array<BloombergPullLoadInput> | BloombergPullLoadInput;
}>;


export type BloombergDiligenceLoadMutation = { __typename?: 'Mutation', bloombergDiligenceLoad: boolean };

export type GetPerformanceBackfillInvestmentListQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort: Array<InvestmentRiskInvestmentSort> | InvestmentRiskInvestmentSort;
  filter?: InputMaybe<InvestmentRiskInvestmentFilter>;
}>;


export type GetPerformanceBackfillInvestmentListQuery = { __typename?: 'Query', investmentList: { __typename?: 'InvestmentList', total: number, items: Array<{ __typename?: 'Investment', id: number, name: string, performanceSourceEnumId?: number | null, bloombergCode?: string | null }> } };

export type GetManyPerformanceTwrrMtdQueryVariables = Exact<{
  investmentIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  returnType: ReturnTypes;
  minAsOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  maxAsOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetManyPerformanceTwrrMtdQuery = { __typename?: 'Query', investmentMany: Array<{ __typename?: 'Investment', id: number, performanceMTD?: Array<{ __typename?: 'PerformanceMTD', returnYear: number, returnMonth: number, return?: number | null, asOfDate: string, currency: { __typename?: 'CurrencyDenominationEnum', id: number, name: string } }> | null } | null> };

export type GetManyPerformanceTwrrQtdQueryVariables = Exact<{
  investmentIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  returnType: ReturnTypes;
  minAsOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  maxAsOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetManyPerformanceTwrrQtdQuery = { __typename?: 'Query', investmentMany: Array<{ __typename?: 'Investment', id: number, performanceQuarterly?: Array<{ __typename?: 'PerformanceQuarterly', returnYear: number, returnQuarter: number, return?: number | null }> | null } | null> };

export type GetManyPerformanceIrrQueryVariables = Exact<{
  investmentIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  minAsOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  maxAsOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetManyPerformanceIrrQuery = { __typename?: 'Query', investmentMany: Array<{ __typename?: 'Investment', id: number, performancePrivate?: Array<{ __typename?: 'PerformancePrivate', returnYear: number, returnQuarter: number, netIRR?: number | null }> | null } | null> };

export type BulkUpsertPerformancePrivateMutationVariables = Exact<{
  input: Array<ManyPerformancePrivate> | ManyPerformancePrivate;
}>;


export type BulkUpsertPerformancePrivateMutation = { __typename?: 'Mutation', bulkUpsertPerformancePrivate: { __typename?: 'PerformancePrivateList', total: number } };

export type BulkUpsertPerformanceQuarterlyMutationVariables = Exact<{
  input: Array<ManyPerformanceQuarterly> | ManyPerformanceQuarterly;
}>;


export type BulkUpsertPerformanceQuarterlyMutation = { __typename?: 'Mutation', bulkUpsertPerformanceQuarterly: { __typename?: 'PerformanceQuarterlyList', total: number } };

export type BulkUpsertPerformanceMtdMutationVariables = Exact<{
  input: Array<ManyPerformanceMtd> | ManyPerformanceMtd;
}>;


export type BulkUpsertPerformanceMtdMutation = { __typename?: 'Mutation', bulkUpsertPerformanceMTD?: { __typename?: 'PerformanceMTDList', total: number } | null };

export type GetOneInvestmentPerformancePrivateQueryVariables = Exact<{
  investmentId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetOneInvestmentPerformancePrivateQuery = { __typename?: 'Query', investment: { __typename?: 'Investment', id: number, name: string, vintageYear?: number | null, firm?: { __typename?: 'Firm', id: number, name: string } | null, portalSubmitted?: { __typename?: 'PortalSubmitted', migratedAt?: string | null } | null, performancePrivate?: Array<{ __typename?: 'PerformancePrivate', investmentId: number, returnYear: number, returnQuarter: number, netIRR?: number | null, tvpi?: number | null, dpi?: number | null, investment?: { __typename?: 'Investment', id: number, name: string, vintageYear?: number | null } | null }> | null } };

export type GetListInvestmentPerformancePrivateQueryVariables = Exact<{
  investmentFilter?: InputMaybe<InvestmentFilterInput>;
  performancePrivateFilter?: InputMaybe<PerformancePrivateFilter>;
}>;


export type GetListInvestmentPerformancePrivateQuery = { __typename?: 'Query', investmentList: { __typename?: 'InvestmentList', total: number, items: Array<{ __typename?: 'Investment', id: number, name: string, vintageYear?: number | null, firm?: { __typename?: 'Firm', id: number, name: string } | null, portalSubmitted?: { __typename?: 'PortalSubmitted', migratedAt?: string | null } | null, performancePrivate?: Array<{ __typename?: 'PerformancePrivate', investmentId: number, returnYear: number, returnQuarter: number, netIRR?: number | null, tvpi?: number | null, dpi?: number | null, investment?: { __typename?: 'Investment', id: number, name: string, vintageYear?: number | null } | null }> | null }> } };

export type GetManyInvestmentPerformancePrivateQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  filter?: InputMaybe<PerformancePrivateFilter>;
}>;


export type GetManyInvestmentPerformancePrivateQuery = { __typename?: 'Query', investmentMany: Array<{ __typename?: 'Investment', id: number, name: string, vintageYear?: number | null, firm?: { __typename?: 'Firm', id: number, name: string } | null, portalSubmitted?: { __typename?: 'PortalSubmitted', migratedAt?: string | null } | null, performancePrivate?: Array<{ __typename?: 'PerformancePrivate', investmentId: number, returnYear: number, returnQuarter: number, netIRR?: number | null, tvpi?: number | null, dpi?: number | null, investment?: { __typename?: 'Investment', id: number, name: string, vintageYear?: number | null } | null }> | null } | null> };

export type AddOrUpdatePerformancePrivateMutationVariables = Exact<{
  input: ManyPerformancePrivate;
}>;


export type AddOrUpdatePerformancePrivateMutation = { __typename?: 'Mutation', addOrUpdatePerformancePrivate: { __typename?: 'PerformancePrivateList', items: Array<{ __typename?: 'PerformancePrivate', investmentId: number, returnYear: number, returnQuarter: number, netIRR?: number | null, tvpi?: number | null, dpi?: number | null, investment?: { __typename?: 'Investment', id: number, name: string, vintageYear?: number | null } | null }> } };

export type GetListPerformanceSourceEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PerformanceSourceEnumSort> | PerformanceSourceEnumSort>;
}>;


export type GetListPerformanceSourceEnumQuery = { __typename?: 'Query', performanceSourceEnumList: { __typename?: 'PerformanceSourceEnumList', total: number, items: Array<{ __typename?: 'PerformanceSourceEnum', id: number, name: string }> } };

export type GetOnePerformanceSourceEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOnePerformanceSourceEnumQuery = { __typename?: 'Query', performanceSourceEnum?: { __typename?: 'PerformanceSourceEnum', id: number, name: string } | null };

export type GetManyPerformanceSourceEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyPerformanceSourceEnumQuery = { __typename?: 'Query', performanceSourceEnumMany: Array<{ __typename?: 'PerformanceSourceEnum', id: number, name: string } | null> };

export type GetOnePerformanceStatisticsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  dependentIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  asOfDate: Scalars['Date']['input'];
}>;


export type GetOnePerformanceStatisticsQuery = { __typename?: 'Query', investment: { __typename?: 'Investment', id: number, inceptionDate?: string | null, groupStats: { __typename?: 'GroupStatsList', items: Array<{ __typename?: 'GroupStatsInvestment', id: number }>, stats: { __typename?: 'StatsGroup', compoundReturn1m: Array<number | null>, compoundReturn3m: Array<number | null>, compoundReturn1y: Array<number | null>, compoundReturn3y: Array<number | null>, compoundReturn5y: Array<number | null>, compoundReturnYtd: Array<number | null>, compoundReturnItdAnnualized: Array<number | null>, standardDeviation3y?: Array<number | null> | null, sharpeRatio3y?: Array<number | null> | null, maxDrawDown3y?: Array<number | null> | null, percentProfitablePeriods3y?: Array<number | null> | null, startDate: Array<string | null> } } } };

export type GetManyPerformanceStatisticsQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type GetManyPerformanceStatisticsQuery = { __typename?: 'Query', investmentMany: Array<{ __typename?: 'Investment', performanceStats?: { __typename?: 'PerformanceStatistics', id: number, compoundReturn1m?: number | null, compoundReturn3m?: number | null, compoundReturn1y?: number | null, compoundReturn3y?: number | null, compoundReturn5y?: number | null, compoundReturnYtd?: number | null, compoundReturnItdAnnualized?: number | null, standardDeviation3y?: number | null, sharpeRatio3y?: number | null, maxDrawDown3y?: number | null, percentProfitablePeriods3y?: number | null, startDate: string } | null } | null> };

export type PersonAttributesFragment = { __typename?: 'Person', id: number, fullName?: string | null, firstName?: string | null, middleName?: string | null, lastName: string, pronouns?: string | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null, email?: string | null, email2?: string | null, isCFA?: boolean | null, linkedin?: string | null, twitter?: string | null, biography?: string | null, educationSummary?: string | null, workExperienceSummary?: string | null, newsMonitoringStartDate?: string | null, titleEnumId?: number | null, photoLink?: string | null, diversity?: { __typename?: 'PersonDiversity', africanAmerican?: boolean | null, asian?: boolean | null, hispanic?: boolean | null, lgbtq?: boolean | null, other?: boolean | null, nativeAmerican?: boolean | null, hawaiianOrPacificIslander?: boolean | null, veteran?: boolean | null, disabled?: boolean | null, nonBinary?: boolean | null, woman?: boolean | null } | null };

export type GetListPersonQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PersonSort> | PersonSort>;
  filter?: InputMaybe<PersonFilterInput>;
  searchFilters?: InputMaybe<Array<PersonSearchFilters> | PersonSearchFilters>;
}>;


export type GetListPersonQuery = { __typename?: 'Query', personList: { __typename?: 'PersonList', total: number, items: Array<{ __typename?: 'Person', id: number, fullName?: string | null, firstName?: string | null, middleName?: string | null, lastName: string, pronouns?: string | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null, email?: string | null, email2?: string | null, isCFA?: boolean | null, linkedin?: string | null, twitter?: string | null, biography?: string | null, educationSummary?: string | null, workExperienceSummary?: string | null, newsMonitoringStartDate?: string | null, titleEnumId?: number | null, photoLink?: string | null, firmEmployment: Array<{ __typename?: 'FirmEmployment', firm: { __typename?: 'Firm', id: number, name: string } }>, diversity?: { __typename?: 'PersonDiversity', africanAmerican?: boolean | null, asian?: boolean | null, hispanic?: boolean | null, lgbtq?: boolean | null, other?: boolean | null, nativeAmerican?: boolean | null, hawaiianOrPacificIslander?: boolean | null, veteran?: boolean | null, disabled?: boolean | null, nonBinary?: boolean | null, woman?: boolean | null } | null }> } };

export type GetOnePersonQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOnePersonQuery = { __typename?: 'Query', person?: { __typename?: 'Person', id: number, fullName?: string | null, firstName?: string | null, middleName?: string | null, lastName: string, pronouns?: string | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null, email?: string | null, email2?: string | null, isCFA?: boolean | null, linkedin?: string | null, twitter?: string | null, biography?: string | null, educationSummary?: string | null, workExperienceSummary?: string | null, newsMonitoringStartDate?: string | null, titleEnumId?: number | null, photoLink?: string | null, diversity?: { __typename?: 'PersonDiversity', africanAmerican?: boolean | null, asian?: boolean | null, hispanic?: boolean | null, lgbtq?: boolean | null, other?: boolean | null, nativeAmerican?: boolean | null, hawaiianOrPacificIslander?: boolean | null, veteran?: boolean | null, disabled?: boolean | null, nonBinary?: boolean | null, woman?: boolean | null } | null } | null };

export type GetManyPersonQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyPersonQuery = { __typename?: 'Query', personMany: Array<{ __typename?: 'Person', id: number, fullName?: string | null, firstName?: string | null, middleName?: string | null, lastName: string, pronouns?: string | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null, email?: string | null, email2?: string | null, isCFA?: boolean | null, linkedin?: string | null, twitter?: string | null, biography?: string | null, educationSummary?: string | null, workExperienceSummary?: string | null, newsMonitoringStartDate?: string | null, titleEnumId?: number | null, photoLink?: string | null, diversity?: { __typename?: 'PersonDiversity', africanAmerican?: boolean | null, asian?: boolean | null, hispanic?: boolean | null, lgbtq?: boolean | null, other?: boolean | null, nativeAmerican?: boolean | null, hawaiianOrPacificIslander?: boolean | null, veteran?: boolean | null, disabled?: boolean | null, nonBinary?: boolean | null, woman?: boolean | null } | null } | null> };

export type CreatePersonMutationVariables = Exact<{
  input: PersonInput;
  firmId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreatePersonMutation = { __typename?: 'Mutation', addPerson?: { __typename?: 'Person', id: number, fullName?: string | null, firstName?: string | null, middleName?: string | null, lastName: string, pronouns?: string | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null, email?: string | null, email2?: string | null, isCFA?: boolean | null, linkedin?: string | null, twitter?: string | null, biography?: string | null, educationSummary?: string | null, workExperienceSummary?: string | null, newsMonitoringStartDate?: string | null, titleEnumId?: number | null, photoLink?: string | null, diversity?: { __typename?: 'PersonDiversity', africanAmerican?: boolean | null, asian?: boolean | null, hispanic?: boolean | null, lgbtq?: boolean | null, other?: boolean | null, nativeAmerican?: boolean | null, hawaiianOrPacificIslander?: boolean | null, veteran?: boolean | null, disabled?: boolean | null, nonBinary?: boolean | null, woman?: boolean | null } | null } | null };

export type UpdatePersonMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: PersonInput;
}>;


export type UpdatePersonMutation = { __typename?: 'Mutation', updatePerson: { __typename?: 'Person', id: number, fullName?: string | null, firstName?: string | null, middleName?: string | null, lastName: string, pronouns?: string | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null, email?: string | null, email2?: string | null, isCFA?: boolean | null, linkedin?: string | null, twitter?: string | null, biography?: string | null, educationSummary?: string | null, workExperienceSummary?: string | null, newsMonitoringStartDate?: string | null, titleEnumId?: number | null, photoLink?: string | null, diversity?: { __typename?: 'PersonDiversity', africanAmerican?: boolean | null, asian?: boolean | null, hispanic?: boolean | null, lgbtq?: boolean | null, other?: boolean | null, nativeAmerican?: boolean | null, hawaiianOrPacificIslander?: boolean | null, veteran?: boolean | null, disabled?: boolean | null, nonBinary?: boolean | null, woman?: boolean | null } | null } };

export type PersonEducationAttributesFragment = { __typename?: 'PersonEducation', id: number, degreeEnumId?: number | null, graduationYear?: number | null, person: { __typename?: 'Person', id: number, lastName: string, firstName?: string | null, middleName?: string | null }, degree?: { __typename?: 'DegreeEnum', id: number, name?: string | null } | null, school: { __typename?: 'SchoolEnum', id: number, name: string } };

export type GetListPersonEducationQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PersonEducationSort> | PersonEducationSort>;
  filter?: InputMaybe<PersonEducationFilterInput>;
}>;


export type GetListPersonEducationQuery = { __typename?: 'Query', personEducationList: { __typename?: 'PersonEducationList', total: number, items: Array<{ __typename?: 'PersonEducation', id: number, degreeEnumId?: number | null, graduationYear?: number | null, person: { __typename?: 'Person', id: number, lastName: string, firstName?: string | null, middleName?: string | null }, degree?: { __typename?: 'DegreeEnum', id: number, name?: string | null } | null, school: { __typename?: 'SchoolEnum', id: number, name: string } }> } };

export type GetOnePersonEducationQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOnePersonEducationQuery = { __typename?: 'Query', personEducation?: { __typename?: 'PersonEducation', id: number, degreeEnumId?: number | null, graduationYear?: number | null, person: { __typename?: 'Person', id: number, lastName: string, firstName?: string | null, middleName?: string | null }, degree?: { __typename?: 'DegreeEnum', id: number, name?: string | null } | null, school: { __typename?: 'SchoolEnum', id: number, name: string } } | null };

export type GetManyPersonEducationQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyPersonEducationQuery = { __typename?: 'Query', personEducationMany: Array<{ __typename?: 'PersonEducation', id: number, degreeEnumId?: number | null, graduationYear?: number | null, person: { __typename?: 'Person', id: number, lastName: string, firstName?: string | null, middleName?: string | null }, degree?: { __typename?: 'DegreeEnum', id: number, name?: string | null } | null, school: { __typename?: 'SchoolEnum', id: number, name: string } } | null> };

export type GetManyReferencePersonEducationQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PersonEducationSort> | PersonEducationSort>;
  filter?: InputMaybe<PersonEducationFilterInput>;
}>;


export type GetManyReferencePersonEducationQuery = { __typename?: 'Query', personEducationList: { __typename?: 'PersonEducationList', total: number, items: Array<{ __typename?: 'PersonEducation', id: number, degreeEnumId?: number | null, graduationYear?: number | null, person: { __typename?: 'Person', id: number, lastName: string, firstName?: string | null, middleName?: string | null }, degree?: { __typename?: 'DegreeEnum', id: number, name?: string | null } | null, school: { __typename?: 'SchoolEnum', id: number, name: string } }> } };

export type CreatePersonEducationMutationVariables = Exact<{
  input: PersonEducationInput;
}>;


export type CreatePersonEducationMutation = { __typename?: 'Mutation', addPersonEducation: { __typename?: 'PersonEducation', id: number, degreeEnumId?: number | null, graduationYear?: number | null, person: { __typename?: 'Person', id: number, lastName: string, firstName?: string | null, middleName?: string | null }, degree?: { __typename?: 'DegreeEnum', id: number, name?: string | null } | null, school: { __typename?: 'SchoolEnum', id: number, name: string } } };

export type UpdatePersonEducationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: PersonEducationInput;
}>;


export type UpdatePersonEducationMutation = { __typename?: 'Mutation', updatePersonEducation: { __typename?: 'PersonEducation', id: number, degreeEnumId?: number | null, graduationYear?: number | null, person: { __typename?: 'Person', id: number, lastName: string, firstName?: string | null, middleName?: string | null }, degree?: { __typename?: 'DegreeEnum', id: number, name?: string | null } | null, school: { __typename?: 'SchoolEnum', id: number, name: string } } };

export type DeletePersonEducationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeletePersonEducationMutation = { __typename?: 'Mutation', deletePersonEducation: number };

export type PersonWorkExperienceAttributesFragment = { __typename?: 'PersonWorkExperience', id: number, personId: number, companyEnumId?: number | null, title?: string | null, fromYear?: number | null, toYear?: number | null, person: { __typename?: 'Person', id: number, lastName: string, firstName?: string | null, middleName?: string | null }, company?: { __typename?: 'CompanyEnum', id: number, name: string } | null };

export type GetListPersonWorkExperienceQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PersonWorkExperienceSort> | PersonWorkExperienceSort>;
  filter?: InputMaybe<PersonWorkExperienceFilterInput>;
}>;


export type GetListPersonWorkExperienceQuery = { __typename?: 'Query', personWorkExperienceList: { __typename?: 'PersonWorkExperienceList', total: number, items: Array<{ __typename?: 'PersonWorkExperience', id: number, personId: number, companyEnumId?: number | null, title?: string | null, fromYear?: number | null, toYear?: number | null, person: { __typename?: 'Person', id: number, lastName: string, firstName?: string | null, middleName?: string | null }, company?: { __typename?: 'CompanyEnum', id: number, name: string } | null }> } };

export type GetOnePersonWorkExperienceQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOnePersonWorkExperienceQuery = { __typename?: 'Query', personWorkExperience?: { __typename?: 'PersonWorkExperience', id: number, personId: number, companyEnumId?: number | null, title?: string | null, fromYear?: number | null, toYear?: number | null, person: { __typename?: 'Person', id: number, lastName: string, firstName?: string | null, middleName?: string | null }, company?: { __typename?: 'CompanyEnum', id: number, name: string } | null } | null };

export type GetManyPersonWorkExperienceQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyPersonWorkExperienceQuery = { __typename?: 'Query', personWorkExperienceMany: Array<{ __typename?: 'PersonWorkExperience', id: number, personId: number, companyEnumId?: number | null, title?: string | null, fromYear?: number | null, toYear?: number | null, person: { __typename?: 'Person', id: number, lastName: string, firstName?: string | null, middleName?: string | null }, company?: { __typename?: 'CompanyEnum', id: number, name: string } | null } | null> };

export type GetManyReferencePersonWorkExperienceQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PersonWorkExperienceSort> | PersonWorkExperienceSort>;
  filter?: InputMaybe<PersonWorkExperienceFilterInput>;
}>;


export type GetManyReferencePersonWorkExperienceQuery = { __typename?: 'Query', personWorkExperienceList: { __typename?: 'PersonWorkExperienceList', total: number, items: Array<{ __typename?: 'PersonWorkExperience', id: number, personId: number, companyEnumId?: number | null, title?: string | null, fromYear?: number | null, toYear?: number | null, person: { __typename?: 'Person', id: number, lastName: string, firstName?: string | null, middleName?: string | null }, company?: { __typename?: 'CompanyEnum', id: number, name: string } | null }> } };

export type CreatePersonWorkExperienceMutationVariables = Exact<{
  input: PersonWorkExperienceInput;
}>;


export type CreatePersonWorkExperienceMutation = { __typename?: 'Mutation', addPersonWorkExperience: { __typename?: 'PersonWorkExperience', id: number, personId: number, companyEnumId?: number | null, title?: string | null, fromYear?: number | null, toYear?: number | null, person: { __typename?: 'Person', id: number, lastName: string, firstName?: string | null, middleName?: string | null }, company?: { __typename?: 'CompanyEnum', id: number, name: string } | null } };

export type UpdatePersonWorkExperienceMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: PersonWorkExperienceInput;
}>;


export type UpdatePersonWorkExperienceMutation = { __typename?: 'Mutation', updatePersonWorkExperience: { __typename?: 'PersonWorkExperience', id: number, personId: number, companyEnumId?: number | null, title?: string | null, fromYear?: number | null, toYear?: number | null, person: { __typename?: 'Person', id: number, lastName: string, firstName?: string | null, middleName?: string | null }, company?: { __typename?: 'CompanyEnum', id: number, name: string } | null } };

export type DeletePersonWorkExperienceMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeletePersonWorkExperienceMutation = { __typename?: 'Mutation', deletePersonWorkExperience: number };

export type GetListEmailDomainOrganizationQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<EmailDomainOrganizationSort> | EmailDomainOrganizationSort>;
  filter?: InputMaybe<EmailDomainOrganizationFilter>;
}>;


export type GetListEmailDomainOrganizationQuery = { __typename?: 'Query', portalEmailDomainOrganizationList: { __typename?: 'EmailDomainOrganizationList', total: number, items: Array<{ __typename?: 'PortalEmailDomainOrganization', organizationId: string, emailDomain: string }> } };

export type GetManyReferenceEmailDomainOrganizationQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<EmailDomainOrganizationSort> | EmailDomainOrganizationSort>;
  filter?: InputMaybe<EmailDomainOrganizationFilter>;
}>;


export type GetManyReferenceEmailDomainOrganizationQuery = { __typename?: 'Query', portalEmailDomainOrganizationList: { __typename?: 'EmailDomainOrganizationList', total: number, items: Array<{ __typename?: 'PortalEmailDomainOrganization', organizationId: string, emailDomain: string }> } };

export type PortalFirmAttributesFragment = { __typename?: 'PortalFirm', id: string, name?: string | null, organizationId: string, firmTypeEnumId?: string | null, rcgFirmId?: string | null, shouldUpdate?: boolean | null, deleteDate?: string | null, organization: { __typename?: 'PortalOrganization', id: string, name: string }, rcgFirm?: { __typename?: 'Firm', id: number, name: string } | null, firmType?: { __typename?: 'PortalFirmTypeEnum', id: string, name: string } | null };

export type GetListPortalFirmQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PortalFirmSort> | PortalFirmSort>;
  filter?: InputMaybe<PortalFirmFilter>;
}>;


export type GetListPortalFirmQuery = { __typename?: 'Query', portalFirmList: { __typename?: 'PortalFirmList', total: number, items: Array<{ __typename?: 'PortalFirm', id: string, name?: string | null, organizationId: string, firmTypeEnumId?: string | null, rcgFirmId?: string | null, shouldUpdate?: boolean | null, deleteDate?: string | null, organization: { __typename?: 'PortalOrganization', id: string, name: string }, rcgFirm?: { __typename?: 'Firm', id: number, name: string } | null, firmType?: { __typename?: 'PortalFirmTypeEnum', id: string, name: string } | null }> } };

export type GetManyReferencePortalFirmQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PortalFirmSort> | PortalFirmSort>;
  filter?: InputMaybe<PortalFirmFilter>;
}>;


export type GetManyReferencePortalFirmQuery = { __typename?: 'Query', portalFirmList: { __typename?: 'PortalFirmList', total: number, items: Array<{ __typename?: 'PortalFirm', id: string, name?: string | null, organizationId: string, firmTypeEnumId?: string | null, rcgFirmId?: string | null, shouldUpdate?: boolean | null, deleteDate?: string | null, organization: { __typename?: 'PortalOrganization', id: string, name: string }, rcgFirm?: { __typename?: 'Firm', id: number, name: string } | null, firmType?: { __typename?: 'PortalFirmTypeEnum', id: string, name: string } | null }> } };

export type GetOnePortalFirmQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetOnePortalFirmQuery = { __typename?: 'Query', portalFirm?: { __typename?: 'PortalFirm', id: string, name?: string | null, organizationId: string, firmTypeEnumId?: string | null, rcgFirmId?: string | null, shouldUpdate?: boolean | null, deleteDate?: string | null, organization: { __typename?: 'PortalOrganization', id: string, name: string }, rcgFirm?: { __typename?: 'Firm', id: number, name: string } | null, firmType?: { __typename?: 'PortalFirmTypeEnum', id: string, name: string } | null } | null };

export type GetManyPortalFirmQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetManyPortalFirmQuery = { __typename?: 'Query', portalFirmMany: Array<{ __typename?: 'PortalFirm', id: string, name?: string | null, organizationId: string, firmTypeEnumId?: string | null, rcgFirmId?: string | null, shouldUpdate?: boolean | null, deleteDate?: string | null, organization: { __typename?: 'PortalOrganization', id: string, name: string }, rcgFirm?: { __typename?: 'Firm', id: number, name: string } | null, firmType?: { __typename?: 'PortalFirmTypeEnum', id: string, name: string } | null } | null> };

export type UpdatePortalFirmMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: PortalFirmInput;
}>;


export type UpdatePortalFirmMutation = { __typename?: 'Mutation', updatePortalFirm: { __typename?: 'PortalFirm', id: string, name?: string | null, organizationId: string, firmTypeEnumId?: string | null, rcgFirmId?: string | null, shouldUpdate?: boolean | null, deleteDate?: string | null, organization: { __typename?: 'PortalOrganization', id: string, name: string }, rcgFirm?: { __typename?: 'Firm', id: number, name: string } | null, firmType?: { __typename?: 'PortalFirmTypeEnum', id: string, name: string } | null } };

export type DeletePortalFirmMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletePortalFirmMutation = { __typename?: 'Mutation', deletePortalFirm: string };

export type GetListPortalFirmTypeEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PortalFirmTypeEnumSort> | PortalFirmTypeEnumSort>;
}>;


export type GetListPortalFirmTypeEnumQuery = { __typename?: 'Query', portalFirmTypeEnumList: { __typename?: 'PortalFirmTypeEnumList', total: number, items: Array<{ __typename?: 'PortalFirmTypeEnum', id: string, name: string }> } };

export type GetOnePortalFirmTypeEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOnePortalFirmTypeEnumQuery = { __typename?: 'Query', portalFirmTypeEnum?: { __typename?: 'PortalFirmTypeEnum', id: string, name: string } | null };

export type GetManyPortalFirmTypeEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyPortalFirmTypeEnumQuery = { __typename?: 'Query', portalFirmTypeEnumMany: Array<{ __typename?: 'PortalFirmTypeEnum', id: string, name: string } | null> };

export type PortalOrganizationAttributesFragment = { __typename?: 'PortalOrganization', id: string, name: string, allowMultiFirm?: boolean | null, deleteDate?: string | null, deleteUser?: string | null, organization?: { __typename?: 'Organization', id: number, name: string, intakeOrganizationId?: string | null, clientId?: string | null } | null, primaryFirm?: { __typename?: 'PortalFirm', id: string, name?: string | null } | null, emailDomainMappings: Array<{ __typename?: 'PortalEmailDomainOrganization', emailDomain: string, organizationId: string }>, portalServiceProviderFirms: Array<{ __typename?: 'PortalServiceProviderFirms', id: string, firmId: string, organizationId: string, firm: { __typename?: 'PortalFirm', id: string, name?: string | null, organizationId: string, organization: { __typename?: 'PortalOrganization', id: string, name: string } } }>, users: Array<{ __typename?: 'PortalUser', id: string, firstName?: string | null, lastName?: string | null, email: string }> };

export type GetListPortalOrganizationQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PortalOrganizationSort> | PortalOrganizationSort>;
  filter?: InputMaybe<PortalOrganizationFilter>;
}>;


export type GetListPortalOrganizationQuery = { __typename?: 'Query', portalOrganizationList: { __typename?: 'PortalOrganizationList', total: number, items: Array<{ __typename?: 'PortalOrganization', id: string, name: string, allowMultiFirm?: boolean | null, deleteDate?: string | null, deleteUser?: string | null, organization?: { __typename?: 'Organization', id: number, name: string, intakeOrganizationId?: string | null, clientId?: string | null } | null, primaryFirm?: { __typename?: 'PortalFirm', id: string, name?: string | null } | null, emailDomainMappings: Array<{ __typename?: 'PortalEmailDomainOrganization', emailDomain: string, organizationId: string }>, portalServiceProviderFirms: Array<{ __typename?: 'PortalServiceProviderFirms', id: string, firmId: string, organizationId: string, firm: { __typename?: 'PortalFirm', id: string, name?: string | null, organizationId: string, organization: { __typename?: 'PortalOrganization', id: string, name: string } } }>, users: Array<{ __typename?: 'PortalUser', id: string, firstName?: string | null, lastName?: string | null, email: string }> }> } };

export type GetOnePortalOrganizationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOnePortalOrganizationQuery = { __typename?: 'Query', portalOrganization?: { __typename?: 'PortalOrganization', id: string, name: string, allowMultiFirm?: boolean | null, deleteDate?: string | null, deleteUser?: string | null, organization?: { __typename?: 'Organization', id: number, name: string, intakeOrganizationId?: string | null, clientId?: string | null } | null, primaryFirm?: { __typename?: 'PortalFirm', id: string, name?: string | null } | null, emailDomainMappings: Array<{ __typename?: 'PortalEmailDomainOrganization', emailDomain: string, organizationId: string }>, portalServiceProviderFirms: Array<{ __typename?: 'PortalServiceProviderFirms', id: string, firmId: string, organizationId: string, firm: { __typename?: 'PortalFirm', id: string, name?: string | null, organizationId: string, organization: { __typename?: 'PortalOrganization', id: string, name: string } } }>, users: Array<{ __typename?: 'PortalUser', id: string, firstName?: string | null, lastName?: string | null, email: string }> } | null };

export type GetManyReferencePortalOrganizationQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PortalOrganizationSort> | PortalOrganizationSort>;
  filter?: InputMaybe<PortalOrganizationFilter>;
}>;


export type GetManyReferencePortalOrganizationQuery = { __typename?: 'Query', portalOrganizationList: { __typename?: 'PortalOrganizationList', total: number, items: Array<{ __typename?: 'PortalOrganization', id: string, name: string, allowMultiFirm?: boolean | null, deleteDate?: string | null, deleteUser?: string | null, organization?: { __typename?: 'Organization', id: number, name: string, intakeOrganizationId?: string | null, clientId?: string | null } | null, primaryFirm?: { __typename?: 'PortalFirm', id: string, name?: string | null } | null, emailDomainMappings: Array<{ __typename?: 'PortalEmailDomainOrganization', emailDomain: string, organizationId: string }>, portalServiceProviderFirms: Array<{ __typename?: 'PortalServiceProviderFirms', id: string, firmId: string, organizationId: string, firm: { __typename?: 'PortalFirm', id: string, name?: string | null, organizationId: string, organization: { __typename?: 'PortalOrganization', id: string, name: string } } }>, users: Array<{ __typename?: 'PortalUser', id: string, firstName?: string | null, lastName?: string | null, email: string }> }> } };

export type GetManyPortalOrganizationQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetManyPortalOrganizationQuery = { __typename?: 'Query', portalOrganizationMany: Array<{ __typename?: 'PortalOrganization', id: string, name: string, allowMultiFirm?: boolean | null, deleteDate?: string | null, deleteUser?: string | null, organization?: { __typename?: 'Organization', id: number, name: string, intakeOrganizationId?: string | null, clientId?: string | null } | null, primaryFirm?: { __typename?: 'PortalFirm', id: string, name?: string | null } | null, emailDomainMappings: Array<{ __typename?: 'PortalEmailDomainOrganization', emailDomain: string, organizationId: string }>, portalServiceProviderFirms: Array<{ __typename?: 'PortalServiceProviderFirms', id: string, firmId: string, organizationId: string, firm: { __typename?: 'PortalFirm', id: string, name?: string | null, organizationId: string, organization: { __typename?: 'PortalOrganization', id: string, name: string } } }>, users: Array<{ __typename?: 'PortalUser', id: string, firstName?: string | null, lastName?: string | null, email: string }> } | null> };

export type UpdatePortalOrganizationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: PortalOrganizationInput;
}>;


export type UpdatePortalOrganizationMutation = { __typename?: 'Mutation', updatePortalOrganization: { __typename?: 'PortalOrganization', id: string, name: string, allowMultiFirm?: boolean | null, deleteDate?: string | null, deleteUser?: string | null, organization?: { __typename?: 'Organization', id: number, name: string, intakeOrganizationId?: string | null, clientId?: string | null } | null, primaryFirm?: { __typename?: 'PortalFirm', id: string, name?: string | null } | null, emailDomainMappings: Array<{ __typename?: 'PortalEmailDomainOrganization', emailDomain: string, organizationId: string }>, portalServiceProviderFirms: Array<{ __typename?: 'PortalServiceProviderFirms', id: string, firmId: string, organizationId: string, firm: { __typename?: 'PortalFirm', id: string, name?: string | null, organizationId: string, organization: { __typename?: 'PortalOrganization', id: string, name: string } } }>, users: Array<{ __typename?: 'PortalUser', id: string, firstName?: string | null, lastName?: string | null, email: string }> } };

export type AddPortalOrganizationMutationVariables = Exact<{
  input: PortalOrganizationCreateInput;
}>;


export type AddPortalOrganizationMutation = { __typename?: 'Mutation', addPortalOrganization: { __typename?: 'PortalOrganization', id: string, name: string, allowMultiFirm?: boolean | null, deleteDate?: string | null, deleteUser?: string | null, organization?: { __typename?: 'Organization', id: number, name: string, intakeOrganizationId?: string | null, clientId?: string | null } | null, primaryFirm?: { __typename?: 'PortalFirm', id: string, name?: string | null } | null, emailDomainMappings: Array<{ __typename?: 'PortalEmailDomainOrganization', emailDomain: string, organizationId: string }>, portalServiceProviderFirms: Array<{ __typename?: 'PortalServiceProviderFirms', id: string, firmId: string, organizationId: string, firm: { __typename?: 'PortalFirm', id: string, name?: string | null, organizationId: string, organization: { __typename?: 'PortalOrganization', id: string, name: string } } }>, users: Array<{ __typename?: 'PortalUser', id: string, firstName?: string | null, lastName?: string | null, email: string }> } };

export type DeletePortalOrganizationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletePortalOrganizationMutation = { __typename?: 'Mutation', deletePortalOrganization: string };

export type AddPortalServiceProviderFirmMutationVariables = Exact<{
  input: PortalServiceProviderFirmInput;
}>;


export type AddPortalServiceProviderFirmMutation = { __typename?: 'Mutation', addPortalServiceProviderFirm: { __typename?: 'PortalServiceProviderFirms', id: string, organizationId: string, firmId: string, organization: { __typename?: 'PortalOrganization', id: string, name: string }, firm: { __typename?: 'PortalFirm', id: string, name?: string | null, organizationId: string, organization: { __typename?: 'PortalOrganization', id: string, name: string } } } };

export type GetOnePortalServiceProviderFirmQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOnePortalServiceProviderFirmQuery = { __typename?: 'Query', portalServiceProviderFirm: { __typename?: 'PortalServiceProviderFirms', id: string, organizationId: string, firmId: string, organization: { __typename?: 'PortalOrganization', id: string, name: string }, firm: { __typename?: 'PortalFirm', id: string, name?: string | null, organizationId: string, organization: { __typename?: 'PortalOrganization', id: string, name: string } } } };

export type GetListPortalServiceProviderFirmQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PortalServiceProviderFirmSort> | PortalServiceProviderFirmSort>;
  filter?: InputMaybe<PortalServiceProviderFirmFilter>;
}>;


export type GetListPortalServiceProviderFirmQuery = { __typename?: 'Query', portalServiceProviderFirmsList: { __typename?: 'PortalServiceProviderFirmsList', total: number, items: Array<{ __typename?: 'PortalServiceProviderFirms', id: string, organizationId: string, firmId: string, organization: { __typename?: 'PortalOrganization', id: string, name: string }, firm: { __typename?: 'PortalFirm', id: string, name?: string | null, organizationId: string, organization: { __typename?: 'PortalOrganization', id: string, name: string } } }> } };

export type DeletePortalServiceProviderFirmMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeletePortalServiceProviderFirmMutation = { __typename?: 'Mutation', deletePortalServiceProviderFirm: number };

export type PortalSubmittedFieldsFragment = { __typename?: 'PortalSubmitted', id: string, name?: string | null, shouldUpdate?: boolean | null, rcgFundId?: string | null, firmId: string, deleteDate?: string | null, rcgFund?: { __typename?: 'Investment', id: number, name: string } | null, firm: { __typename?: 'PortalFirm', id: string, name?: string | null } };

export type GetListPortalSubmittedQueryVariables = Exact<{
  filter?: InputMaybe<PortalSubmittedFilter>;
  sort?: InputMaybe<Array<PortalSubmittedSort> | PortalSubmittedSort>;
  page?: InputMaybe<PageInput>;
}>;


export type GetListPortalSubmittedQuery = { __typename?: 'Query', portalSubmittedList: { __typename?: 'PortalSubmittedList', total: number, items: Array<{ __typename?: 'PortalSubmitted', id: string, name?: string | null, shouldUpdate?: boolean | null, rcgFundId?: string | null, firmId: string, deleteDate?: string | null, rcgFund?: { __typename?: 'Investment', id: number, name: string } | null, firm: { __typename?: 'PortalFirm', id: string, name?: string | null } }> } };

export type GetOnePortalSubmittedQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetOnePortalSubmittedQuery = { __typename?: 'Query', portalSubmitted?: { __typename?: 'PortalSubmitted', id: string, name?: string | null, shouldUpdate?: boolean | null, rcgFundId?: string | null, firmId: string, deleteDate?: string | null, rcgFund?: { __typename?: 'Investment', id: number, name: string } | null, firm: { __typename?: 'PortalFirm', id: string, name?: string | null } } | null };

export type UpdatePortalSubmittedMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: PortalSubmittedInput;
}>;


export type UpdatePortalSubmittedMutation = { __typename?: 'Mutation', updatePortalSubmitted: { __typename?: 'PortalSubmitted', id: string, name?: string | null, shouldUpdate?: boolean | null, rcgFundId?: string | null, firmId: string, deleteDate?: string | null, rcgFund?: { __typename?: 'Investment', id: number, name: string } | null, firm: { __typename?: 'PortalFirm', id: string, name?: string | null } } };

export type DeletePortalSubmittedMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletePortalSubmittedMutation = { __typename?: 'Mutation', deletePortalSubmitted: string };

export type GetListPortalUserQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PortalUserSort> | PortalUserSort>;
  filter?: InputMaybe<PortalUserFilter>;
}>;


export type GetListPortalUserQuery = { __typename?: 'Query', portalUserList: { __typename?: 'PortalUserList', total: number, items: Array<{ __typename?: 'PortalUser', id: string, organizationId?: string | null, firstName?: string | null, lastName?: string | null, email: string, deleteDate?: string | null, organization?: { __typename?: 'PortalOrganization', id: string, name: string } | null }> } };

export type GetManyReferencePortalUserQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PortalUserSort> | PortalUserSort>;
  filter?: InputMaybe<PortalUserFilter>;
}>;


export type GetManyReferencePortalUserQuery = { __typename?: 'Query', portalUserList: { __typename?: 'PortalUserList', total: number, items: Array<{ __typename?: 'PortalUser', id: string, organizationId?: string | null, firstName?: string | null, lastName?: string | null, email: string, deleteDate?: string | null, organization?: { __typename?: 'PortalOrganization', id: string, name: string } | null }> } };

export type GetOnePortalUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOnePortalUserQuery = { __typename?: 'Query', portalUser?: { __typename?: 'PortalUser', id: string, organizationId?: string | null, firstName?: string | null, lastName?: string | null, email: string, deleteDate?: string | null, organization?: { __typename?: 'PortalOrganization', id: string, name: string } | null } | null };

export type GetManyPortalUserQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetManyPortalUserQuery = { __typename?: 'Query', portalUserMany: Array<{ __typename?: 'PortalUser', id: string, organizationId?: string | null, firstName?: string | null, lastName?: string | null, email: string, deleteDate?: string | null, organization?: { __typename?: 'PortalOrganization', id: string, name: string } | null } | null> };

export type UpdatePortalUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: PortalUserInput;
}>;


export type UpdatePortalUserMutation = { __typename?: 'Mutation', updatePortalUser: { __typename?: 'PortalUser', id: string } };

export type DeletePortalUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletePortalUserMutation = { __typename?: 'Mutation', deletePortalUser: string };

export type PortfolioConfigAttributesFragment = { __typename?: 'PortfolioConfig', id: number, showInvestments?: boolean | null, portfolioId: number, lookthroughEnabled?: boolean | null, tileImageId?: number | null, clientVisibleTabs?: Array<ClientVisibleTabs> | null, performanceLag?: { __typename?: 'PerformanceLag', lag: number, lagUnitId: number, lagUnit: { __typename?: 'CalendarUnitEnum', id: number, name: string } } | null, portfolio: { __typename?: 'Investment', id: number, name: string }, lookthroughInvestments?: Array<{ __typename?: 'Investment', id: number, name: string }> | null, tileImage?: { __typename?: 'Document', id: number, name: string, signedUrl?: string | null } | null };

export type GetListPortfolioConfigQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PortfolioConfigSort> | PortfolioConfigSort>;
  filter?: InputMaybe<PortfolioConfigFilter>;
}>;


export type GetListPortfolioConfigQuery = { __typename?: 'Query', portfolioConfigList: { __typename?: 'PortfolioConfigList', total: number, items: Array<{ __typename?: 'PortfolioConfig', id: number, showInvestments?: boolean | null, portfolioId: number, lookthroughEnabled?: boolean | null, tileImageId?: number | null, clientVisibleTabs?: Array<ClientVisibleTabs> | null, performanceLag?: { __typename?: 'PerformanceLag', lag: number, lagUnitId: number, lagUnit: { __typename?: 'CalendarUnitEnum', id: number, name: string } } | null, portfolio: { __typename?: 'Investment', id: number, name: string }, lookthroughInvestments?: Array<{ __typename?: 'Investment', id: number, name: string }> | null, tileImage?: { __typename?: 'Document', id: number, name: string, signedUrl?: string | null } | null }> } };

export type GetOnePortfolioConfigQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOnePortfolioConfigQuery = { __typename?: 'Query', portfolioConfig?: { __typename?: 'PortfolioConfig', id: number, showInvestments?: boolean | null, portfolioId: number, lookthroughEnabled?: boolean | null, tileImageId?: number | null, clientVisibleTabs?: Array<ClientVisibleTabs> | null, performanceLag?: { __typename?: 'PerformanceLag', lag: number, lagUnitId: number, lagUnit: { __typename?: 'CalendarUnitEnum', id: number, name: string } } | null, portfolio: { __typename?: 'Investment', id: number, name: string }, lookthroughInvestments?: Array<{ __typename?: 'Investment', id: number, name: string }> | null, tileImage?: { __typename?: 'Document', id: number, name: string, signedUrl?: string | null } | null } | null };

export type GetManyPortfolioConfigQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyPortfolioConfigQuery = { __typename?: 'Query', portfolioConfigMany: Array<{ __typename?: 'PortfolioConfig', id: number, showInvestments?: boolean | null, portfolioId: number, lookthroughEnabled?: boolean | null, tileImageId?: number | null, clientVisibleTabs?: Array<ClientVisibleTabs> | null, performanceLag?: { __typename?: 'PerformanceLag', lag: number, lagUnitId: number, lagUnit: { __typename?: 'CalendarUnitEnum', id: number, name: string } } | null, portfolio: { __typename?: 'Investment', id: number, name: string }, lookthroughInvestments?: Array<{ __typename?: 'Investment', id: number, name: string }> | null, tileImage?: { __typename?: 'Document', id: number, name: string, signedUrl?: string | null } | null } | null> };

export type CreatePortfolioConfigMutationVariables = Exact<{
  input: PortfolioConfigInput;
}>;


export type CreatePortfolioConfigMutation = { __typename?: 'Mutation', addPortfolioConfig: { __typename?: 'PortfolioConfig', id: number } };

export type UpdatePortfolioConfigMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: PortfolioConfigInput;
}>;


export type UpdatePortfolioConfigMutation = { __typename?: 'Mutation', updatePortfolioConfig: { __typename?: 'PortfolioConfig', id: number } };

export type PortfolioFdpLoginsAttributesFragment = { __typename?: 'PortfolioFDPLogins', id: number, portfolioId: number, fdpLoginId: number, fdpWebsiteId?: number | null, fdpWebsite?: { __typename?: 'FDPWebsites', id: number, website: string, financialDataProviderId: number } | null, fdpLogin: { __typename?: 'FDPLogin', id: number, username: string, financialDataProviderId: number, financialDataProvider: { __typename?: 'FinancialDataProvider', id: number, name: string, fdpWebsites: Array<{ __typename?: 'FDPWebsites', id: number, website: string }> } }, portfolio: { __typename?: 'Investment', id: number, name: string } };

export type GetListPortfolioFdpLoginsQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PortfolioFdpLoginsSort> | PortfolioFdpLoginsSort>;
  filter?: InputMaybe<PortfolioFdpLoginsFilter>;
}>;


export type GetListPortfolioFdpLoginsQuery = { __typename?: 'Query', portfolioFDPLoginsList: { __typename?: 'PortfolioFDPLoginsList', total: number, items: Array<{ __typename?: 'PortfolioFDPLogins', id: number, portfolioId: number, fdpLoginId: number, fdpWebsiteId?: number | null, fdpWebsite?: { __typename?: 'FDPWebsites', id: number, website: string, financialDataProviderId: number } | null, fdpLogin: { __typename?: 'FDPLogin', id: number, username: string, financialDataProviderId: number, financialDataProvider: { __typename?: 'FinancialDataProvider', id: number, name: string, fdpWebsites: Array<{ __typename?: 'FDPWebsites', id: number, website: string }> } }, portfolio: { __typename?: 'Investment', id: number, name: string } }> } };

export type GetOnePortfolioFdpLoginsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOnePortfolioFdpLoginsQuery = { __typename?: 'Query', portfolioFDPLogins?: { __typename?: 'PortfolioFDPLogins', id: number, portfolioId: number, fdpLoginId: number, fdpWebsiteId?: number | null, fdpWebsite?: { __typename?: 'FDPWebsites', id: number, website: string, financialDataProviderId: number } | null, fdpLogin: { __typename?: 'FDPLogin', id: number, username: string, financialDataProviderId: number, financialDataProvider: { __typename?: 'FinancialDataProvider', id: number, name: string, fdpWebsites: Array<{ __typename?: 'FDPWebsites', id: number, website: string }> } }, portfolio: { __typename?: 'Investment', id: number, name: string } } | null };

export type GetManyPortfolioFdpLoginsQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyPortfolioFdpLoginsQuery = { __typename?: 'Query', portfolioFDPLoginsMany: Array<{ __typename?: 'PortfolioFDPLogins', id: number, portfolioId: number, fdpLoginId: number, fdpWebsiteId?: number | null, fdpWebsite?: { __typename?: 'FDPWebsites', id: number, website: string, financialDataProviderId: number } | null, fdpLogin: { __typename?: 'FDPLogin', id: number, username: string, financialDataProviderId: number, financialDataProvider: { __typename?: 'FinancialDataProvider', id: number, name: string, fdpWebsites: Array<{ __typename?: 'FDPWebsites', id: number, website: string }> } }, portfolio: { __typename?: 'Investment', id: number, name: string } } | null> };

export type CreatePortfolioFdpLoginsMutationVariables = Exact<{
  input: PortfolioFdpLoginsInput;
}>;


export type CreatePortfolioFdpLoginsMutation = { __typename?: 'Mutation', addPortfolioFDPLogins: { __typename?: 'PortfolioFDPLogins', id: number } };

export type UpdatePortfolioFdpLoginsMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: PortfolioFdpLoginsInput;
}>;


export type UpdatePortfolioFdpLoginsMutation = { __typename?: 'Mutation', updatePortfolioFDPLogins: { __typename?: 'PortfolioFDPLogins', id: number } };

export type GetListPricingFrequencyEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PricingFrequencyEnumSort> | PricingFrequencyEnumSort>;
}>;


export type GetListPricingFrequencyEnumQuery = { __typename?: 'Query', pricingFrequencyEnumList: { __typename?: 'PricingFrequencyEnumList', total: number, items: Array<{ __typename?: 'PricingFrequencyEnum', id: string, name: string }> } };

export type GetOnePricingFrequencyEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOnePricingFrequencyEnumQuery = { __typename?: 'Query', pricingFrequencyEnum?: { __typename?: 'PricingFrequencyEnum', id: string, name: string } | null };

export type GetManyPricingFrequencyEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyPricingFrequencyEnumQuery = { __typename?: 'Query', pricingFrequencyEnumMany: Array<{ __typename?: 'PricingFrequencyEnum', id: string, name: string } | null> };

export type GetListPrivateQuartileGroupCategoryQueryVariables = Exact<{
  filter?: InputMaybe<PrivateQuartileGroupCategoryFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PrivateQuartileGroupCategorySort> | PrivateQuartileGroupCategorySort>;
}>;


export type GetListPrivateQuartileGroupCategoryQuery = { __typename?: 'Query', privateQuartileGroupCategoryList: { __typename?: 'PrivateQuartileGroupCategoryList', total: number, items: Array<{ __typename?: 'PrivateQuartileGroupCategory', id: number, uniqueLabel: string, displayLabel?: string | null }> } };

export type GetOnePrivateQuartileGroupCategoryQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOnePrivateQuartileGroupCategoryQuery = { __typename?: 'Query', privateQuartileGroupCategory?: { __typename?: 'PrivateQuartileGroupCategory', id: number, uniqueLabel: string, displayLabel?: string | null } | null };

export type GetManyPrivateQuartileGroupCategoryQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyPrivateQuartileGroupCategoryQuery = { __typename?: 'Query', privateQuartileGroupCategoryMany: Array<{ __typename?: 'PrivateQuartileGroupCategory', id: number, uniqueLabel: string, displayLabel?: string | null } | null> };

export type GetInvestmentCompletenessHeadQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInvestmentCompletenessHeadQuery = { __typename?: 'Query', investmentCompletenessHead: Array<{ __typename?: 'MemoizedInvestmentCompletenessSummary', category: string, subcategory: string, level: number, percentComplete: number }> };

export type GetListProspectiveInvestmentQueryVariables = Exact<{
  searchFilters?: InputMaybe<Array<InvestmentSearchFilters> | InvestmentSearchFilters>;
  filter?: InputMaybe<InvestmentFilterInput>;
  sort?: InputMaybe<Array<InvestmentSort> | InvestmentSort>;
  page?: InputMaybe<PageInput>;
}>;


export type GetListProspectiveInvestmentQuery = { __typename?: 'Query', investmentList: { __typename?: 'InvestmentList', total: number, items: Array<{ __typename?: 'Investment', id: number, name: string, primaryAssignment?: string | null, completeness?: Array<{ __typename?: 'MemoizedInvestmentCompletenessSummary', category: string, subcategory: string, level: number, percentComplete: number }> | null }> } };

export type GetListResultEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ResultEnumSort> | ResultEnumSort>;
}>;


export type GetListResultEnumQuery = { __typename?: 'Query', resultEnumList: { __typename?: 'ResultEnumList', total: number, items: Array<{ __typename?: 'ResultEnum', id: number, name: string }> } };

export type GetOneResultEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneResultEnumQuery = { __typename?: 'Query', resultEnum?: { __typename?: 'ResultEnum', id: number, name: string } | null };

export type GetManyResultEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyResultEnumQuery = { __typename?: 'Query', resultEnumMany: Array<{ __typename?: 'ResultEnum', id: number, name: string } | null> };

export type GetListRightOfExtensionEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<RightOfExtensionEnumSort> | RightOfExtensionEnumSort>;
}>;


export type GetListRightOfExtensionEnumQuery = { __typename?: 'Query', rightOfExtensionEnumList: { __typename?: 'RightOfExtensionEnumList', total: number, items: Array<{ __typename?: 'RightOfExtensionEnum', id: number, name?: string | null }> } };

export type GetOneRightOfExtensionEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneRightOfExtensionEnumQuery = { __typename?: 'Query', rightOfExtensionEnum?: { __typename?: 'RightOfExtensionEnum', id: number, name?: string | null } | null };

export type GetManyRightOfExtensionEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyRightOfExtensionEnumQuery = { __typename?: 'Query', rightOfExtensionEnumMany: Array<{ __typename?: 'RightOfExtensionEnum', id: number, name?: string | null } | null> };

export type RiskRefreshListQueryVariables = Exact<{ [key: string]: never; }>;


export type RiskRefreshListQuery = { __typename?: 'Query', riskRefreshList?: { __typename?: 'RiskRefreshListList', total: number, items: Array<{ __typename?: 'InvestmentIdToRefresh', id: number, investment?: { __typename?: 'Investment', id: number, name: string, firm?: { __typename?: 'Firm', id: number, name: string } | null } | null }> } | null };

export type UpdateRiskRefreshListMutationVariables = Exact<{
  add?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  remove?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type UpdateRiskRefreshListMutation = { __typename?: 'Mutation', updateRiskRefreshList: { __typename?: 'RiskRefreshListList', items: Array<{ __typename?: 'InvestmentIdToRefresh', id: number }> } };

export type GetListSchoolEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<SchoolEnumSort> | SchoolEnumSort>;
  filter?: InputMaybe<SchoolEnumFilter>;
}>;


export type GetListSchoolEnumQuery = { __typename?: 'Query', schoolEnumList: { __typename?: 'SchoolEnumList', total: number, items: Array<{ __typename?: 'SchoolEnum', id: number, name: string }> } };

export type GetOneSchoolEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneSchoolEnumQuery = { __typename?: 'Query', schoolEnum?: { __typename?: 'SchoolEnum', id: number, name: string } | null };

export type GetManySchoolEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManySchoolEnumQuery = { __typename?: 'Query', schoolEnumMany: Array<{ __typename?: 'SchoolEnum', id: number, name: string } | null> };

export type ServiceProviderDocumentAttributesFragment = { __typename?: 'ServiceProviderDocuments', id: number, url?: string | null, name: string, fileName: string, fileType: string, documentDate?: string | null, serviceProviderFirmId: number, documentTypeId: number, uploadedBy?: string | null, uploadedDate?: string | null, serviceProviderFirm?: { __typename?: 'ServiceProviderFirm', id: number, name: string } | null, documentType?: { __typename?: 'ServiceProviderDocumentType', id: number, name: string } | null };

export type GetListServiceProviderDocumentsQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ServiceProviderDocumentsSort> | ServiceProviderDocumentsSort>;
  filter?: InputMaybe<ServiceProviderDocumentsFilter>;
}>;


export type GetListServiceProviderDocumentsQuery = { __typename?: 'Query', serviceProviderDocumentsList: { __typename?: 'ServiceProviderDocumentsList', total: number, items: Array<{ __typename?: 'ServiceProviderDocuments', id: number, url?: string | null, name: string, fileName: string, fileType: string, documentDate?: string | null, serviceProviderFirmId: number, documentTypeId: number, uploadedBy?: string | null, uploadedDate?: string | null, serviceProviderFirm?: { __typename?: 'ServiceProviderFirm', id: number, name: string } | null, documentType?: { __typename?: 'ServiceProviderDocumentType', id: number, name: string } | null }> } };

export type GetOneServiceProviderDocumentsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneServiceProviderDocumentsQuery = { __typename?: 'Query', serviceProviderDocuments?: { __typename?: 'ServiceProviderDocuments', id: number, url?: string | null, name: string, fileName: string, fileType: string, documentDate?: string | null, serviceProviderFirmId: number, documentTypeId: number, uploadedBy?: string | null, uploadedDate?: string | null, serviceProviderFirm?: { __typename?: 'ServiceProviderFirm', id: number, name: string } | null, documentType?: { __typename?: 'ServiceProviderDocumentType', id: number, name: string } | null } | null };

export type GetManyServiceProviderDocumentsQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyServiceProviderDocumentsQuery = { __typename?: 'Query', serviceProviderDocumentsMany: Array<{ __typename?: 'ServiceProviderDocuments', id: number, url?: string | null, name: string, fileName: string, fileType: string, documentDate?: string | null, serviceProviderFirmId: number, documentTypeId: number, uploadedBy?: string | null, uploadedDate?: string | null, serviceProviderFirm?: { __typename?: 'ServiceProviderFirm', id: number, name: string } | null, documentType?: { __typename?: 'ServiceProviderDocumentType', id: number, name: string } | null } | null> };

export type CreateServiceProviderDocumentMutationVariables = Exact<{
  input: ServiceProviderDocumentsInput;
}>;


export type CreateServiceProviderDocumentMutation = { __typename?: 'Mutation', addServiceProviderDocuments: { __typename?: 'ServiceProviderDocuments', id: number } };

export type UpdateServiceProviderDocumentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: ServiceProviderDocumentsInput;
}>;


export type UpdateServiceProviderDocumentMutation = { __typename?: 'Mutation', updateServiceProviderDocuments: { __typename?: 'ServiceProviderDocuments', id: number } };

export type ServiceProviderDocumentTypeAttributesFragment = { __typename?: 'ServiceProviderDocumentType', id: number, name: string };

export type GetListServiceProviderDocumentTypeQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ServiceProviderDocumentTypeSort> | ServiceProviderDocumentTypeSort>;
  filter?: InputMaybe<ServiceProviderDocumentTypeFilter>;
}>;


export type GetListServiceProviderDocumentTypeQuery = { __typename?: 'Query', serviceProviderDocumentTypeList: { __typename?: 'ServiceProviderDocumentTypeList', total: number, items: Array<{ __typename?: 'ServiceProviderDocumentType', id: number, name: string }> } };

export type GetOneServiceProviderDocumentTypeQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneServiceProviderDocumentTypeQuery = { __typename?: 'Query', serviceProviderDocumentType?: { __typename?: 'ServiceProviderDocumentType', id: number, name: string } | null };

export type GetManyServiceProviderDocumentTypeQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyServiceProviderDocumentTypeQuery = { __typename?: 'Query', serviceProviderDocumentTypeMany: Array<{ __typename?: 'ServiceProviderDocumentType', id: number, name: string } | null> };

export type ServiceProviderFirmAttributesFragment = { __typename?: 'ServiceProviderFirm', id: number, name: string, yearFounded?: number | null, tierLevel?: number | null, isEvaluating?: boolean | null, officeLocations?: Array<{ __typename?: 'GlobalProviderInstitutions', id: number, isCorporate: boolean, institution: { __typename?: 'Institution', id: number, name: string, address: { __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, countryEnumId?: number | null, zipCode?: string | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null, email?: string | null, state?: { __typename?: 'StateEnum', name: string } | null, country?: { __typename?: 'CountryEnum', name: string } | null }, institutionsInstitutionTypeEnumList: { __typename?: 'InstitutionsInstitutionTypeEnumList', items: Array<{ __typename?: 'InstitutionsInstitutionTypeEnum', id: number, institutionTypeEnum: { __typename?: 'InstitutionTypeEnum', id: number, name: string, displayOrder: number } }> }, institutionSelectionStatus?: { __typename?: 'InstitutionSelectionStatusEnum', id: number, name: string, displayOrder?: number | null } | null } }> | null };

export type GetListServiceProviderFirmQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ServiceProviderFirmSort> | ServiceProviderFirmSort>;
  filter?: InputMaybe<ServiceProviderFirmFilter>;
}>;


export type GetListServiceProviderFirmQuery = { __typename?: 'Query', serviceProviderFirmList: { __typename?: 'ServiceProviderFirmList', total: number, items: Array<{ __typename?: 'ServiceProviderFirm', id: number, name: string, yearFounded?: number | null, tierLevel?: number | null, isEvaluating?: boolean | null, officeLocations?: Array<{ __typename?: 'GlobalProviderInstitutions', id: number, isCorporate: boolean, institution: { __typename?: 'Institution', id: number, name: string, address: { __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, countryEnumId?: number | null, zipCode?: string | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null, email?: string | null, state?: { __typename?: 'StateEnum', name: string } | null, country?: { __typename?: 'CountryEnum', name: string } | null }, institutionsInstitutionTypeEnumList: { __typename?: 'InstitutionsInstitutionTypeEnumList', items: Array<{ __typename?: 'InstitutionsInstitutionTypeEnum', id: number, institutionTypeEnum: { __typename?: 'InstitutionTypeEnum', id: number, name: string, displayOrder: number } }> }, institutionSelectionStatus?: { __typename?: 'InstitutionSelectionStatusEnum', id: number, name: string, displayOrder?: number | null } | null } }> | null }> } };

export type GetOneServiceProviderFirmQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneServiceProviderFirmQuery = { __typename?: 'Query', serviceProviderFirm?: { __typename?: 'ServiceProviderFirm', id: number, name: string, yearFounded?: number | null, tierLevel?: number | null, isEvaluating?: boolean | null, officeLocations?: Array<{ __typename?: 'GlobalProviderInstitutions', id: number, isCorporate: boolean, institution: { __typename?: 'Institution', id: number, name: string, address: { __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, countryEnumId?: number | null, zipCode?: string | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null, email?: string | null, state?: { __typename?: 'StateEnum', name: string } | null, country?: { __typename?: 'CountryEnum', name: string } | null }, institutionsInstitutionTypeEnumList: { __typename?: 'InstitutionsInstitutionTypeEnumList', items: Array<{ __typename?: 'InstitutionsInstitutionTypeEnum', id: number, institutionTypeEnum: { __typename?: 'InstitutionTypeEnum', id: number, name: string, displayOrder: number } }> }, institutionSelectionStatus?: { __typename?: 'InstitutionSelectionStatusEnum', id: number, name: string, displayOrder?: number | null } | null } }> | null } | null };

export type GetManyServiceProviderFirmQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyServiceProviderFirmQuery = { __typename?: 'Query', serviceProviderFirmMany: Array<{ __typename?: 'ServiceProviderFirm', id: number, name: string, yearFounded?: number | null, tierLevel?: number | null, isEvaluating?: boolean | null, officeLocations?: Array<{ __typename?: 'GlobalProviderInstitutions', id: number, isCorporate: boolean, institution: { __typename?: 'Institution', id: number, name: string, address: { __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, countryEnumId?: number | null, zipCode?: string | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null, email?: string | null, state?: { __typename?: 'StateEnum', name: string } | null, country?: { __typename?: 'CountryEnum', name: string } | null }, institutionsInstitutionTypeEnumList: { __typename?: 'InstitutionsInstitutionTypeEnumList', items: Array<{ __typename?: 'InstitutionsInstitutionTypeEnum', id: number, institutionTypeEnum: { __typename?: 'InstitutionTypeEnum', id: number, name: string, displayOrder: number } }> }, institutionSelectionStatus?: { __typename?: 'InstitutionSelectionStatusEnum', id: number, name: string, displayOrder?: number | null } | null } }> | null } | null> };

export type CreateServiceProviderFirmMutationVariables = Exact<{
  input: ServiceProviderFirmInput;
}>;


export type CreateServiceProviderFirmMutation = { __typename?: 'Mutation', addServiceProviderFirm: { __typename?: 'ServiceProviderFirm', id: number, name: string, yearFounded?: number | null, tierLevel?: number | null, isEvaluating?: boolean | null, officeLocations?: Array<{ __typename?: 'GlobalProviderInstitutions', id: number, isCorporate: boolean, institution: { __typename?: 'Institution', id: number, name: string, address: { __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, countryEnumId?: number | null, zipCode?: string | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null, email?: string | null, state?: { __typename?: 'StateEnum', name: string } | null, country?: { __typename?: 'CountryEnum', name: string } | null }, institutionsInstitutionTypeEnumList: { __typename?: 'InstitutionsInstitutionTypeEnumList', items: Array<{ __typename?: 'InstitutionsInstitutionTypeEnum', id: number, institutionTypeEnum: { __typename?: 'InstitutionTypeEnum', id: number, name: string, displayOrder: number } }> }, institutionSelectionStatus?: { __typename?: 'InstitutionSelectionStatusEnum', id: number, name: string, displayOrder?: number | null } | null } }> | null } };

export type UpdateServiceProviderFirmMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: ServiceProviderFirmInput;
}>;


export type UpdateServiceProviderFirmMutation = { __typename?: 'Mutation', updateServiceProviderFirm: { __typename?: 'ServiceProviderFirm', id: number, name: string, yearFounded?: number | null, tierLevel?: number | null, isEvaluating?: boolean | null, officeLocations?: Array<{ __typename?: 'GlobalProviderInstitutions', id: number, isCorporate: boolean, institution: { __typename?: 'Institution', id: number, name: string, address: { __typename?: 'Address', id: number, line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, stateEnumId?: number | null, otherState?: string | null, countryEnumId?: number | null, zipCode?: string | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null, email?: string | null, state?: { __typename?: 'StateEnum', name: string } | null, country?: { __typename?: 'CountryEnum', name: string } | null }, institutionsInstitutionTypeEnumList: { __typename?: 'InstitutionsInstitutionTypeEnumList', items: Array<{ __typename?: 'InstitutionsInstitutionTypeEnum', id: number, institutionTypeEnum: { __typename?: 'InstitutionTypeEnum', id: number, name: string, displayOrder: number } }> }, institutionSelectionStatus?: { __typename?: 'InstitutionSelectionStatusEnum', id: number, name: string, displayOrder?: number | null } | null } }> | null } };

export type ServiceProviderNotesAttributesFragment = { __typename?: 'ServiceProviderNotes', id: number, isDeleted?: string | null, noteText: string, eventDate?: string | null, providerNoteTypeEnumId?: number | null, createDate?: string | null, createUser?: string | null, providerId?: number | null, serviceProviderFirm?: { __typename?: 'ServiceProviderFirm', id: number, name: string } | null, providerNoteTypeEnum?: { __typename?: 'GlobalProviderNoteTypeEnum', id: number, name: string } | null };

export type GetListServiceProviderNotesQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ServiceProviderNotesSort> | ServiceProviderNotesSort>;
  filter?: InputMaybe<ServiceProviderNotesFilter>;
}>;


export type GetListServiceProviderNotesQuery = { __typename?: 'Query', serviceProviderNotesList: { __typename?: 'ServiceProviderNotesList', total: number, items: Array<{ __typename?: 'ServiceProviderNotes', id: number, isDeleted?: string | null, noteText: string, eventDate?: string | null, providerNoteTypeEnumId?: number | null, createDate?: string | null, createUser?: string | null, providerId?: number | null, serviceProviderFirm?: { __typename?: 'ServiceProviderFirm', id: number, name: string } | null, providerNoteTypeEnum?: { __typename?: 'GlobalProviderNoteTypeEnum', id: number, name: string } | null }> } };

export type GetOneServiceProviderNotesQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneServiceProviderNotesQuery = { __typename?: 'Query', serviceProviderNotes?: { __typename?: 'ServiceProviderNotes', id: number, isDeleted?: string | null, noteText: string, eventDate?: string | null, providerNoteTypeEnumId?: number | null, createDate?: string | null, createUser?: string | null, providerId?: number | null, serviceProviderFirm?: { __typename?: 'ServiceProviderFirm', id: number, name: string } | null, providerNoteTypeEnum?: { __typename?: 'GlobalProviderNoteTypeEnum', id: number, name: string } | null } | null };

export type GetManyServiceProviderNotesQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyServiceProviderNotesQuery = { __typename?: 'Query', serviceProviderNotesMany: Array<{ __typename?: 'ServiceProviderNotes', id: number, isDeleted?: string | null, noteText: string, eventDate?: string | null, providerNoteTypeEnumId?: number | null, createDate?: string | null, createUser?: string | null, providerId?: number | null, serviceProviderFirm?: { __typename?: 'ServiceProviderFirm', id: number, name: string } | null, providerNoteTypeEnum?: { __typename?: 'GlobalProviderNoteTypeEnum', id: number, name: string } | null } | null> };

export type CreateServiceProviderNotesMutationVariables = Exact<{
  input: ServiceProviderNotesInput;
}>;


export type CreateServiceProviderNotesMutation = { __typename?: 'Mutation', addServiceProviderNotes: { __typename?: 'ServiceProviderNotes', id: number } };

export type UpdateServiceProviderNotesMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: ServiceProviderNotesInput;
}>;


export type UpdateServiceProviderNotesMutation = { __typename?: 'Mutation', updateServiceProviderNotes: { __typename?: 'ServiceProviderNotes', id: number } };

export type SetAttributesFragment = { __typename?: 'Set', id: number, setType: number, name: string, description?: string | null, expression: string, expressionPg?: string | null, isBaseSet: boolean, disabled: boolean, subscriptionLevelEnumId: number, givesAccess: boolean };

export type GetListSetQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<SetSort> | SetSort>;
  filter?: InputMaybe<SetFilter>;
}>;


export type GetListSetQuery = { __typename?: 'Query', setList: { __typename?: 'SetList', total: number, items: Array<{ __typename?: 'Set', id: number, setType: number, name: string, description?: string | null, expression: string, expressionPg?: string | null, isBaseSet: boolean, disabled: boolean, subscriptionLevelEnumId: number, givesAccess: boolean }> } };

export type GetOneSetQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneSetQuery = { __typename?: 'Query', set?: { __typename?: 'Set', id: number, setType: number, name: string, description?: string | null, expression: string, expressionPg?: string | null, isBaseSet: boolean, disabled: boolean, subscriptionLevelEnumId: number, givesAccess: boolean } | null };

export type GetManySetQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManySetQuery = { __typename?: 'Query', setMany: Array<{ __typename?: 'Set', id: number, setType: number, name: string, description?: string | null, expression: string, expressionPg?: string | null, isBaseSet: boolean, disabled: boolean, subscriptionLevelEnumId: number, givesAccess: boolean } | null> };

export type CreateSetMutationVariables = Exact<{
  input: SetInput;
}>;


export type CreateSetMutation = { __typename?: 'Mutation', addSet: { __typename?: 'Set', id: number } };

export type UpdateSetMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: SetInput;
}>;


export type UpdateSetMutation = { __typename?: 'Mutation', updateSet: { __typename?: 'Set', id: number } };

export type ShareClassAttributesFragment = { __typename?: 'ShareClass', id: number, investmentId: number, name: string, currencyDenominationEnumId?: number | null, otherFees?: string | null, restricted?: boolean | null, FAS157?: number | null, status?: string | null, isRcgNegotiated?: boolean | null, investment?: { __typename?: 'Investment', id: number, name: string, marketEnumId?: number | null } | null, investmentFees?: { __typename?: 'InvestmentFees', id: number, shareClassId: number, mgmtFee?: number | null, mgmtFeeCalcEnumId?: number | null, mgmtFeeFreqEnumId?: number | null, incentiveFee?: number | null, incentiveFeeCalcEnumId?: number | null, incentiveFeeFreqEnumId?: number | null, otherFee?: number | null, otherFeeCalcEnumId?: number | null, otherFeeFreqEnumId?: number | null, highWaterMark?: boolean | null, hurdle?: boolean | null, hurdleBenchmark?: string | null, annualReset?: boolean | null, peMgmtFeeCalcEnumId?: number | null, peIncentiveFeeCalcEnumId?: number | null, peMgmtFeeDuringCommitment?: number | null, peMgmtFeeDuringCommitmentCalcEnumId?: number | null, peMgmtFeeDuringHarvest?: number | null, peMgmtFeeDuringHarvestCalcEnumId?: number | null, pePlacementFeesPaid?: boolean | null, peGP?: number | null, peLP?: number | null, feeStructureChanged?: boolean | null, feeStructureChangedNotes?: string | null, standardShareClassRates?: boolean | null, abnormalFees?: boolean | null, abnormalFeesNotes?: string | null, hasMgmtFeeStepDown?: boolean | null, peMgmtFeeStepDownPercent?: number | null, peMgmtFeeStepDownCalcEnumId?: number | null, mgmtFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, mgmtFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, incentiveFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, incentiveFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, otherFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, otherFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, peMgmtFeeCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peIncentiveFeeCalc?: { __typename?: 'PeInctFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeDuringCommitmentCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeDuringHarvestCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeStepDownCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null } | null, liquidity?: { __typename?: 'Liquidity', id: number, shareClassId: number, hasGate?: boolean | null, gatePercentNav?: number | null, gatePercentCapital?: number | null, exceptions?: string | null, hasRollover?: boolean | null, rolloverValue?: number | null, rolloverUnitId?: number | null, hasLockup?: boolean | null, lockupValue?: number | null, lockupUnitId?: number | null, lockupEndValueId?: number | null, lockupEndUnitId?: number | null, lockupEndBasisDate?: string | null, lockupEndBizDays?: boolean | null, secondLockupValue?: number | null, secondLockupUnitId?: number | null, secondLockupEndValueId?: number | null, secondLockupEndUnitId?: number | null, secondLockupEndBasisDate?: string | null, secondLockupEndBizDays?: boolean | null, liquidityValue?: number | null, liquidityUnitId?: number | null, noticeValue?: number | null, noticeUnitId?: number | null, noticeBizDays?: boolean | null, subscriptionValue?: number | null, subscriptionUnitId?: number | null, cashAvailableDays?: number | null, hasHoldback?: boolean | null, holdbackPercent?: number | null, workoutId?: number | null, masterLevelFundGate?: boolean | null, lockupMonthlyValue: number, liquidityMonthlyValue: number, modelingNotes?: string | null, modifyDate?: string | null, rolloverUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, lockupUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, lockupEndValue?: { __typename?: 'LockupEndValueEnum', id: number, name?: string | null } | null, lockupEndUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupEndValue?: { __typename?: 'LockupEndValueEnum', id: number, name?: string | null } | null, secondLockupEndUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, liquidityUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, noticeUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, subscriptionUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, workout?: { __typename?: 'WorkoutEnum', id: number, name: string } | null } | null, peLiquidity?: { __typename?: 'PeLiquidity', id: number, shareClassId: number, preferredReturn?: number | null, isCompounded?: boolean | null, compoundingPeriodId?: number | null, hasCatchupProvision?: boolean | null, catchupPercent?: number | null, optionOfExtensionId?: number | null, compoundingPeriod?: { __typename?: 'CompoundingPeriodEnum', id: number, name?: string | null } | null, optionOfExtension?: { __typename?: 'RightOfExtensionEnum', id: number, name?: string | null } | null } | null, softLockups?: Array<{ __typename?: 'SoftLockup', id: number, liquidityId: number, cashAvailableDays?: number | null, lockupEndRedemptionOnId?: number | null, holdBackPercent?: number | null, noticeValue?: number | null, liquidityValue?: number | null, liquidityUnitId?: number | null, noticeBizDays?: boolean | null, redemptionFee: number, redemptionOnBizDays?: boolean | null, secondLockupEndRedemptionOnId?: number | null, termBeginMonth: number, termEndMonth: number, hasRedemptionFee?: boolean | null, lockupEndRedemptionOn?: { __typename?: 'FinancialPeriodEnum', id: number, name: string } | null, liquidityUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupEndRedemptionOn?: { __typename?: 'FinancialPeriodEnum', id: number, name: string } | null }> | null };

export type GetListShareClassQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ShareClassSort> | ShareClassSort>;
  filter?: InputMaybe<ShareClassFilter>;
}>;


export type GetListShareClassQuery = { __typename?: 'Query', shareClassList: { __typename?: 'ShareClassList', total: number, items: Array<{ __typename?: 'ShareClass', id: number, investmentId: number, name: string, currencyDenominationEnumId?: number | null, otherFees?: string | null, restricted?: boolean | null, FAS157?: number | null, status?: string | null, isRcgNegotiated?: boolean | null, investment?: { __typename?: 'Investment', id: number, name: string, marketEnumId?: number | null } | null, investmentFees?: { __typename?: 'InvestmentFees', id: number, shareClassId: number, mgmtFee?: number | null, mgmtFeeCalcEnumId?: number | null, mgmtFeeFreqEnumId?: number | null, incentiveFee?: number | null, incentiveFeeCalcEnumId?: number | null, incentiveFeeFreqEnumId?: number | null, otherFee?: number | null, otherFeeCalcEnumId?: number | null, otherFeeFreqEnumId?: number | null, highWaterMark?: boolean | null, hurdle?: boolean | null, hurdleBenchmark?: string | null, annualReset?: boolean | null, peMgmtFeeCalcEnumId?: number | null, peIncentiveFeeCalcEnumId?: number | null, peMgmtFeeDuringCommitment?: number | null, peMgmtFeeDuringCommitmentCalcEnumId?: number | null, peMgmtFeeDuringHarvest?: number | null, peMgmtFeeDuringHarvestCalcEnumId?: number | null, pePlacementFeesPaid?: boolean | null, peGP?: number | null, peLP?: number | null, feeStructureChanged?: boolean | null, feeStructureChangedNotes?: string | null, standardShareClassRates?: boolean | null, abnormalFees?: boolean | null, abnormalFeesNotes?: string | null, hasMgmtFeeStepDown?: boolean | null, peMgmtFeeStepDownPercent?: number | null, peMgmtFeeStepDownCalcEnumId?: number | null, mgmtFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, mgmtFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, incentiveFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, incentiveFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, otherFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, otherFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, peMgmtFeeCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peIncentiveFeeCalc?: { __typename?: 'PeInctFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeDuringCommitmentCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeDuringHarvestCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeStepDownCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null } | null, liquidity?: { __typename?: 'Liquidity', id: number, shareClassId: number, hasGate?: boolean | null, gatePercentNav?: number | null, gatePercentCapital?: number | null, exceptions?: string | null, hasRollover?: boolean | null, rolloverValue?: number | null, rolloverUnitId?: number | null, hasLockup?: boolean | null, lockupValue?: number | null, lockupUnitId?: number | null, lockupEndValueId?: number | null, lockupEndUnitId?: number | null, lockupEndBasisDate?: string | null, lockupEndBizDays?: boolean | null, secondLockupValue?: number | null, secondLockupUnitId?: number | null, secondLockupEndValueId?: number | null, secondLockupEndUnitId?: number | null, secondLockupEndBasisDate?: string | null, secondLockupEndBizDays?: boolean | null, liquidityValue?: number | null, liquidityUnitId?: number | null, noticeValue?: number | null, noticeUnitId?: number | null, noticeBizDays?: boolean | null, subscriptionValue?: number | null, subscriptionUnitId?: number | null, cashAvailableDays?: number | null, hasHoldback?: boolean | null, holdbackPercent?: number | null, workoutId?: number | null, masterLevelFundGate?: boolean | null, lockupMonthlyValue: number, liquidityMonthlyValue: number, modelingNotes?: string | null, modifyDate?: string | null, rolloverUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, lockupUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, lockupEndValue?: { __typename?: 'LockupEndValueEnum', id: number, name?: string | null } | null, lockupEndUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupEndValue?: { __typename?: 'LockupEndValueEnum', id: number, name?: string | null } | null, secondLockupEndUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, liquidityUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, noticeUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, subscriptionUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, workout?: { __typename?: 'WorkoutEnum', id: number, name: string } | null } | null, peLiquidity?: { __typename?: 'PeLiquidity', id: number, shareClassId: number, preferredReturn?: number | null, isCompounded?: boolean | null, compoundingPeriodId?: number | null, hasCatchupProvision?: boolean | null, catchupPercent?: number | null, optionOfExtensionId?: number | null, compoundingPeriod?: { __typename?: 'CompoundingPeriodEnum', id: number, name?: string | null } | null, optionOfExtension?: { __typename?: 'RightOfExtensionEnum', id: number, name?: string | null } | null } | null, softLockups?: Array<{ __typename?: 'SoftLockup', id: number, liquidityId: number, cashAvailableDays?: number | null, lockupEndRedemptionOnId?: number | null, holdBackPercent?: number | null, noticeValue?: number | null, liquidityValue?: number | null, liquidityUnitId?: number | null, noticeBizDays?: boolean | null, redemptionFee: number, redemptionOnBizDays?: boolean | null, secondLockupEndRedemptionOnId?: number | null, termBeginMonth: number, termEndMonth: number, hasRedemptionFee?: boolean | null, lockupEndRedemptionOn?: { __typename?: 'FinancialPeriodEnum', id: number, name: string } | null, liquidityUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupEndRedemptionOn?: { __typename?: 'FinancialPeriodEnum', id: number, name: string } | null }> | null }> } };

export type GetOneShareClassQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneShareClassQuery = { __typename?: 'Query', shareClass?: { __typename?: 'ShareClass', id: number, investmentId: number, name: string, currencyDenominationEnumId?: number | null, otherFees?: string | null, restricted?: boolean | null, FAS157?: number | null, status?: string | null, isRcgNegotiated?: boolean | null, investment?: { __typename?: 'Investment', id: number, name: string, marketEnumId?: number | null } | null, investmentFees?: { __typename?: 'InvestmentFees', id: number, shareClassId: number, mgmtFee?: number | null, mgmtFeeCalcEnumId?: number | null, mgmtFeeFreqEnumId?: number | null, incentiveFee?: number | null, incentiveFeeCalcEnumId?: number | null, incentiveFeeFreqEnumId?: number | null, otherFee?: number | null, otherFeeCalcEnumId?: number | null, otherFeeFreqEnumId?: number | null, highWaterMark?: boolean | null, hurdle?: boolean | null, hurdleBenchmark?: string | null, annualReset?: boolean | null, peMgmtFeeCalcEnumId?: number | null, peIncentiveFeeCalcEnumId?: number | null, peMgmtFeeDuringCommitment?: number | null, peMgmtFeeDuringCommitmentCalcEnumId?: number | null, peMgmtFeeDuringHarvest?: number | null, peMgmtFeeDuringHarvestCalcEnumId?: number | null, pePlacementFeesPaid?: boolean | null, peGP?: number | null, peLP?: number | null, feeStructureChanged?: boolean | null, feeStructureChangedNotes?: string | null, standardShareClassRates?: boolean | null, abnormalFees?: boolean | null, abnormalFeesNotes?: string | null, hasMgmtFeeStepDown?: boolean | null, peMgmtFeeStepDownPercent?: number | null, peMgmtFeeStepDownCalcEnumId?: number | null, mgmtFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, mgmtFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, incentiveFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, incentiveFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, otherFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, otherFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, peMgmtFeeCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peIncentiveFeeCalc?: { __typename?: 'PeInctFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeDuringCommitmentCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeDuringHarvestCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeStepDownCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null } | null, liquidity?: { __typename?: 'Liquidity', id: number, shareClassId: number, hasGate?: boolean | null, gatePercentNav?: number | null, gatePercentCapital?: number | null, exceptions?: string | null, hasRollover?: boolean | null, rolloverValue?: number | null, rolloverUnitId?: number | null, hasLockup?: boolean | null, lockupValue?: number | null, lockupUnitId?: number | null, lockupEndValueId?: number | null, lockupEndUnitId?: number | null, lockupEndBasisDate?: string | null, lockupEndBizDays?: boolean | null, secondLockupValue?: number | null, secondLockupUnitId?: number | null, secondLockupEndValueId?: number | null, secondLockupEndUnitId?: number | null, secondLockupEndBasisDate?: string | null, secondLockupEndBizDays?: boolean | null, liquidityValue?: number | null, liquidityUnitId?: number | null, noticeValue?: number | null, noticeUnitId?: number | null, noticeBizDays?: boolean | null, subscriptionValue?: number | null, subscriptionUnitId?: number | null, cashAvailableDays?: number | null, hasHoldback?: boolean | null, holdbackPercent?: number | null, workoutId?: number | null, masterLevelFundGate?: boolean | null, lockupMonthlyValue: number, liquidityMonthlyValue: number, modelingNotes?: string | null, modifyDate?: string | null, rolloverUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, lockupUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, lockupEndValue?: { __typename?: 'LockupEndValueEnum', id: number, name?: string | null } | null, lockupEndUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupEndValue?: { __typename?: 'LockupEndValueEnum', id: number, name?: string | null } | null, secondLockupEndUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, liquidityUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, noticeUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, subscriptionUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, workout?: { __typename?: 'WorkoutEnum', id: number, name: string } | null } | null, peLiquidity?: { __typename?: 'PeLiquidity', id: number, shareClassId: number, preferredReturn?: number | null, isCompounded?: boolean | null, compoundingPeriodId?: number | null, hasCatchupProvision?: boolean | null, catchupPercent?: number | null, optionOfExtensionId?: number | null, compoundingPeriod?: { __typename?: 'CompoundingPeriodEnum', id: number, name?: string | null } | null, optionOfExtension?: { __typename?: 'RightOfExtensionEnum', id: number, name?: string | null } | null } | null, softLockups?: Array<{ __typename?: 'SoftLockup', id: number, liquidityId: number, cashAvailableDays?: number | null, lockupEndRedemptionOnId?: number | null, holdBackPercent?: number | null, noticeValue?: number | null, liquidityValue?: number | null, liquidityUnitId?: number | null, noticeBizDays?: boolean | null, redemptionFee: number, redemptionOnBizDays?: boolean | null, secondLockupEndRedemptionOnId?: number | null, termBeginMonth: number, termEndMonth: number, hasRedemptionFee?: boolean | null, lockupEndRedemptionOn?: { __typename?: 'FinancialPeriodEnum', id: number, name: string } | null, liquidityUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupEndRedemptionOn?: { __typename?: 'FinancialPeriodEnum', id: number, name: string } | null }> | null } | null };

export type GetManyShareClassQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyShareClassQuery = { __typename?: 'Query', shareClassMany: Array<{ __typename?: 'ShareClass', id: number, investmentId: number, name: string, currencyDenominationEnumId?: number | null, otherFees?: string | null, restricted?: boolean | null, FAS157?: number | null, status?: string | null, isRcgNegotiated?: boolean | null, investment?: { __typename?: 'Investment', id: number, name: string, marketEnumId?: number | null } | null, investmentFees?: { __typename?: 'InvestmentFees', id: number, shareClassId: number, mgmtFee?: number | null, mgmtFeeCalcEnumId?: number | null, mgmtFeeFreqEnumId?: number | null, incentiveFee?: number | null, incentiveFeeCalcEnumId?: number | null, incentiveFeeFreqEnumId?: number | null, otherFee?: number | null, otherFeeCalcEnumId?: number | null, otherFeeFreqEnumId?: number | null, highWaterMark?: boolean | null, hurdle?: boolean | null, hurdleBenchmark?: string | null, annualReset?: boolean | null, peMgmtFeeCalcEnumId?: number | null, peIncentiveFeeCalcEnumId?: number | null, peMgmtFeeDuringCommitment?: number | null, peMgmtFeeDuringCommitmentCalcEnumId?: number | null, peMgmtFeeDuringHarvest?: number | null, peMgmtFeeDuringHarvestCalcEnumId?: number | null, pePlacementFeesPaid?: boolean | null, peGP?: number | null, peLP?: number | null, feeStructureChanged?: boolean | null, feeStructureChangedNotes?: string | null, standardShareClassRates?: boolean | null, abnormalFees?: boolean | null, abnormalFeesNotes?: string | null, hasMgmtFeeStepDown?: boolean | null, peMgmtFeeStepDownPercent?: number | null, peMgmtFeeStepDownCalcEnumId?: number | null, mgmtFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, mgmtFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, incentiveFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, incentiveFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, otherFeeCalc?: { __typename?: 'FeeCalcEnum', id: number, name: string } | null, otherFeeFreq?: { __typename?: 'FeeFreqEnum', id: number, name: string } | null, peMgmtFeeCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peIncentiveFeeCalc?: { __typename?: 'PeInctFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeDuringCommitmentCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeDuringHarvestCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null, peMgmtFeeStepDownCalc?: { __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null } | null } | null, liquidity?: { __typename?: 'Liquidity', id: number, shareClassId: number, hasGate?: boolean | null, gatePercentNav?: number | null, gatePercentCapital?: number | null, exceptions?: string | null, hasRollover?: boolean | null, rolloverValue?: number | null, rolloverUnitId?: number | null, hasLockup?: boolean | null, lockupValue?: number | null, lockupUnitId?: number | null, lockupEndValueId?: number | null, lockupEndUnitId?: number | null, lockupEndBasisDate?: string | null, lockupEndBizDays?: boolean | null, secondLockupValue?: number | null, secondLockupUnitId?: number | null, secondLockupEndValueId?: number | null, secondLockupEndUnitId?: number | null, secondLockupEndBasisDate?: string | null, secondLockupEndBizDays?: boolean | null, liquidityValue?: number | null, liquidityUnitId?: number | null, noticeValue?: number | null, noticeUnitId?: number | null, noticeBizDays?: boolean | null, subscriptionValue?: number | null, subscriptionUnitId?: number | null, cashAvailableDays?: number | null, hasHoldback?: boolean | null, holdbackPercent?: number | null, workoutId?: number | null, masterLevelFundGate?: boolean | null, lockupMonthlyValue: number, liquidityMonthlyValue: number, modelingNotes?: string | null, modifyDate?: string | null, rolloverUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, lockupUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, lockupEndValue?: { __typename?: 'LockupEndValueEnum', id: number, name?: string | null } | null, lockupEndUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupEndValue?: { __typename?: 'LockupEndValueEnum', id: number, name?: string | null } | null, secondLockupEndUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, liquidityUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, noticeUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, subscriptionUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, workout?: { __typename?: 'WorkoutEnum', id: number, name: string } | null } | null, peLiquidity?: { __typename?: 'PeLiquidity', id: number, shareClassId: number, preferredReturn?: number | null, isCompounded?: boolean | null, compoundingPeriodId?: number | null, hasCatchupProvision?: boolean | null, catchupPercent?: number | null, optionOfExtensionId?: number | null, compoundingPeriod?: { __typename?: 'CompoundingPeriodEnum', id: number, name?: string | null } | null, optionOfExtension?: { __typename?: 'RightOfExtensionEnum', id: number, name?: string | null } | null } | null, softLockups?: Array<{ __typename?: 'SoftLockup', id: number, liquidityId: number, cashAvailableDays?: number | null, lockupEndRedemptionOnId?: number | null, holdBackPercent?: number | null, noticeValue?: number | null, liquidityValue?: number | null, liquidityUnitId?: number | null, noticeBizDays?: boolean | null, redemptionFee: number, redemptionOnBizDays?: boolean | null, secondLockupEndRedemptionOnId?: number | null, termBeginMonth: number, termEndMonth: number, hasRedemptionFee?: boolean | null, lockupEndRedemptionOn?: { __typename?: 'FinancialPeriodEnum', id: number, name: string } | null, liquidityUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupEndRedemptionOn?: { __typename?: 'FinancialPeriodEnum', id: number, name: string } | null }> | null } | null> };

export type CreateShareClassMutationVariables = Exact<{
  input: ShareClassInput;
}>;


export type CreateShareClassMutation = { __typename?: 'Mutation', addShareClass?: { __typename?: 'ShareClass', id: number } | null };

export type UpdateShareClassMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: ShareClassInput;
}>;


export type UpdateShareClassMutation = { __typename?: 'Mutation', updateShareClass: { __typename?: 'ShareClass', id: number } };

export type DeleteShareClassMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteShareClassMutation = { __typename?: 'Mutation', deleteShareClass: number };

export type SharedGroupEntityAttributesFragment = { __typename?: 'SharedGroupEntity', id: number, sourceGroupId: number, targetGroupId: number, entityId: number, groupShareDefinitionId: number, createDate: string, modifyDate: string, createUser?: string | null, modifyUser?: string | null, sourceGroup?: { __typename?: 'User', id: number, commonName: string, userName: string, organizationId?: number | null, organization?: { __typename?: 'Organization', id: number, name: string } | null } | null, targetGroup?: { __typename?: 'User', id: number, commonName: string, userName: string, organizationId?: number | null, organization?: { __typename?: 'Organization', id: number, name: string } | null } | null, groupShareDefinition?: { __typename?: 'GroupShareDefinition', id: number, sourceGroupId: number, targetGroupId: number, dynamicDefinition?: string | null, entityAccessId: number, isActive: boolean, lastExecuted?: string | null, createDate: string, modifyDate: string, createUser?: string | null, modifyUser?: string | null } | null };

export type GetListSharedGroupEntityQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<SharedGroupEntitySort> | SharedGroupEntitySort>;
  filter?: InputMaybe<SharedGroupEntityFilter>;
}>;


export type GetListSharedGroupEntityQuery = { __typename?: 'Query', sharedGroupEntityList: { __typename?: 'SharedGroupEntityList', total: number, items: Array<{ __typename?: 'SharedGroupEntity', id: number, sourceGroupId: number, targetGroupId: number, entityId: number, groupShareDefinitionId: number, createDate: string, modifyDate: string, createUser?: string | null, modifyUser?: string | null, sourceGroup?: { __typename?: 'User', id: number, commonName: string, userName: string, organizationId?: number | null, organization?: { __typename?: 'Organization', id: number, name: string } | null } | null, targetGroup?: { __typename?: 'User', id: number, commonName: string, userName: string, organizationId?: number | null, organization?: { __typename?: 'Organization', id: number, name: string } | null } | null, groupShareDefinition?: { __typename?: 'GroupShareDefinition', id: number, sourceGroupId: number, targetGroupId: number, dynamicDefinition?: string | null, entityAccessId: number, isActive: boolean, lastExecuted?: string | null, createDate: string, modifyDate: string, createUser?: string | null, modifyUser?: string | null } | null }> } };

export type GetOneSharedGroupEntityQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneSharedGroupEntityQuery = { __typename?: 'Query', sharedGroupEntity?: { __typename?: 'SharedGroupEntity', id: number, sourceGroupId: number, targetGroupId: number, entityId: number, groupShareDefinitionId: number, createDate: string, modifyDate: string, createUser?: string | null, modifyUser?: string | null, sourceGroup?: { __typename?: 'User', id: number, commonName: string, userName: string, organizationId?: number | null, organization?: { __typename?: 'Organization', id: number, name: string } | null } | null, targetGroup?: { __typename?: 'User', id: number, commonName: string, userName: string, organizationId?: number | null, organization?: { __typename?: 'Organization', id: number, name: string } | null } | null, groupShareDefinition?: { __typename?: 'GroupShareDefinition', id: number, sourceGroupId: number, targetGroupId: number, dynamicDefinition?: string | null, entityAccessId: number, isActive: boolean, lastExecuted?: string | null, createDate: string, modifyDate: string, createUser?: string | null, modifyUser?: string | null } | null } | null };

export type GetManySharedGroupEntityQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManySharedGroupEntityQuery = { __typename?: 'Query', sharedGroupEntityMany: Array<{ __typename?: 'SharedGroupEntity', id: number, sourceGroupId: number, targetGroupId: number, entityId: number, groupShareDefinitionId: number, createDate: string, modifyDate: string, createUser?: string | null, modifyUser?: string | null, sourceGroup?: { __typename?: 'User', id: number, commonName: string, userName: string, organizationId?: number | null, organization?: { __typename?: 'Organization', id: number, name: string } | null } | null, targetGroup?: { __typename?: 'User', id: number, commonName: string, userName: string, organizationId?: number | null, organization?: { __typename?: 'Organization', id: number, name: string } | null } | null, groupShareDefinition?: { __typename?: 'GroupShareDefinition', id: number, sourceGroupId: number, targetGroupId: number, dynamicDefinition?: string | null, entityAccessId: number, isActive: boolean, lastExecuted?: string | null, createDate: string, modifyDate: string, createUser?: string | null, modifyUser?: string | null } | null } | null> };

export type SoftLockupAttributesFragment = { __typename?: 'SoftLockup', id: number, liquidityId: number, cashAvailableDays?: number | null, lockupEndRedemptionOnId?: number | null, holdBackPercent?: number | null, noticeValue?: number | null, liquidityValue?: number | null, liquidityUnitId?: number | null, noticeBizDays?: boolean | null, redemptionFee: number, redemptionOnBizDays?: boolean | null, secondLockupEndRedemptionOnId?: number | null, termBeginMonth: number, termEndMonth: number, hasRedemptionFee?: boolean | null, lockupEndRedemptionOn?: { __typename?: 'FinancialPeriodEnum', id: number, name: string } | null, liquidityUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupEndRedemptionOn?: { __typename?: 'FinancialPeriodEnum', id: number, name: string } | null };

export type GetListSoftLockupQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<SoftLockupSort> | SoftLockupSort>;
  filter?: InputMaybe<SoftLockupFilter>;
}>;


export type GetListSoftLockupQuery = { __typename?: 'Query', softLockupList: { __typename?: 'SoftLockupList', total: number, items: Array<{ __typename?: 'SoftLockup', id: number, liquidityId: number, cashAvailableDays?: number | null, lockupEndRedemptionOnId?: number | null, holdBackPercent?: number | null, noticeValue?: number | null, liquidityValue?: number | null, liquidityUnitId?: number | null, noticeBizDays?: boolean | null, redemptionFee: number, redemptionOnBizDays?: boolean | null, secondLockupEndRedemptionOnId?: number | null, termBeginMonth: number, termEndMonth: number, hasRedemptionFee?: boolean | null, lockupEndRedemptionOn?: { __typename?: 'FinancialPeriodEnum', id: number, name: string } | null, liquidityUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupEndRedemptionOn?: { __typename?: 'FinancialPeriodEnum', id: number, name: string } | null }> } };

export type GetOneSoftLockupQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneSoftLockupQuery = { __typename?: 'Query', softLockup?: { __typename?: 'SoftLockup', id: number, liquidityId: number, cashAvailableDays?: number | null, lockupEndRedemptionOnId?: number | null, holdBackPercent?: number | null, noticeValue?: number | null, liquidityValue?: number | null, liquidityUnitId?: number | null, noticeBizDays?: boolean | null, redemptionFee: number, redemptionOnBizDays?: boolean | null, secondLockupEndRedemptionOnId?: number | null, termBeginMonth: number, termEndMonth: number, hasRedemptionFee?: boolean | null, lockupEndRedemptionOn?: { __typename?: 'FinancialPeriodEnum', id: number, name: string } | null, liquidityUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupEndRedemptionOn?: { __typename?: 'FinancialPeriodEnum', id: number, name: string } | null } | null };

export type GetManySoftLockupQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManySoftLockupQuery = { __typename?: 'Query', softLockupMany: Array<{ __typename?: 'SoftLockup', id: number, liquidityId: number, cashAvailableDays?: number | null, lockupEndRedemptionOnId?: number | null, holdBackPercent?: number | null, noticeValue?: number | null, liquidityValue?: number | null, liquidityUnitId?: number | null, noticeBizDays?: boolean | null, redemptionFee: number, redemptionOnBizDays?: boolean | null, secondLockupEndRedemptionOnId?: number | null, termBeginMonth: number, termEndMonth: number, hasRedemptionFee?: boolean | null, lockupEndRedemptionOn?: { __typename?: 'FinancialPeriodEnum', id: number, name: string } | null, liquidityUnit?: { __typename?: 'CalendarUnitEnum', id: number, name: string } | null, secondLockupEndRedemptionOn?: { __typename?: 'FinancialPeriodEnum', id: number, name: string } | null } | null> };

export type GetListStageEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<StageEnumSort> | StageEnumSort>;
}>;


export type GetListStageEnumQuery = { __typename?: 'Query', stageEnumList: { __typename?: 'StageEnumList', total: number, items: Array<{ __typename?: 'StageEnum', id: string, name: string }> } };

export type GetOneStageEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneStageEnumQuery = { __typename?: 'Query', stageEnum?: { __typename?: 'StageEnum', id: string, name: string } | null };

export type GetManyStageEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyStageEnumQuery = { __typename?: 'Query', stageEnumMany: Array<{ __typename?: 'StageEnum', id: string, name: string } | null> };

export type GetListStateEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<StateEnumSort> | StateEnumSort>;
}>;


export type GetListStateEnumQuery = { __typename?: 'Query', stateEnumList: { __typename?: 'StateEnumList', total: number, items: Array<{ __typename?: 'StateEnum', id: number, name: string }> } };

export type GetOneStateEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneStateEnumQuery = { __typename?: 'Query', stateEnum?: { __typename?: 'StateEnum', id: number, name: string } | null };

export type GetManyStateEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyStateEnumQuery = { __typename?: 'Query', stateEnumMany: Array<{ __typename?: 'StateEnum', id: number, name: string } | null> };

export type GetListStrategyEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<StrategyEnumSort> | StrategyEnumSort>;
}>;


export type GetListStrategyEnumQuery = { __typename?: 'Query', strategyEnumList: { __typename?: 'StrategyEnumList', total: number, items: Array<{ __typename?: 'StrategyEnum', id: number, name: string, subStrategies: Array<{ __typename?: 'SubStrategyEnum', id: number, name: string }> }> } };

export type GetListStrategyEnumOptionsQueryVariables = Exact<{
  filter?: InputMaybe<TypeAssetClassStrategyOptionsFilterInput>;
  sort?: InputMaybe<Array<TypeAssetClassStrategyOptionsSort> | TypeAssetClassStrategyOptionsSort>;
}>;


export type GetListStrategyEnumOptionsQuery = { __typename?: 'Query', strategyOptions: { __typename?: 'StrategyEnumList', total: number, items: Array<{ __typename?: 'StrategyEnum', id: number, name: string }> } };

export type GetOneStrategyEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneStrategyEnumQuery = { __typename?: 'Query', strategyEnum?: { __typename?: 'StrategyEnum', id: number, name: string } | null };

export type GetManyStrategyEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyStrategyEnumQuery = { __typename?: 'Query', strategyEnumMany: Array<{ __typename?: 'StrategyEnum', id: number, name: string } | null> };

export type GetListSubStrategyEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<SubStrategyEnumSort> | SubStrategyEnumSort>;
  filter?: InputMaybe<SubStrategyEnumFilterInput>;
}>;


export type GetListSubStrategyEnumQuery = { __typename?: 'Query', subStrategyEnumList: { __typename?: 'SubStrategyEnumList', total: number, items: Array<{ __typename?: 'SubStrategyEnum', id: number, name: string }> } };

export type GetOneSubStrategyEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneSubStrategyEnumQuery = { __typename?: 'Query', subStrategyEnum?: { __typename?: 'SubStrategyEnum', id: number, name: string } | null };

export type GetManySubStrategyEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManySubStrategyEnumQuery = { __typename?: 'Query', subStrategyEnumMany: Array<{ __typename?: 'SubStrategyEnum', id: number, name: string } | null> };

export type GetListTagClassesQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<TagClassSort> | TagClassSort>;
  filter?: InputMaybe<TagClassFilterInput>;
}>;


export type GetListTagClassesQuery = { __typename?: 'Query', tagClassList: { __typename?: 'TagClassList', total: number, items: Array<{ __typename?: 'TagClass', id: number, name: string, displayOrder?: number | null, tags: { __typename?: 'TagList', items: Array<{ __typename?: 'TagListItem', id: number, name: string }> } }> } };

export type GetManyTagClassesQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyTagClassesQuery = { __typename?: 'Query', tagClassMany: Array<{ __typename?: 'TagClass', id: number, name: string, displayOrder?: number | null } | null> };

export type GetOneTagClassesQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneTagClassesQuery = { __typename?: 'Query', tagClass?: { __typename?: 'TagClass', id: number, name: string, displayOrder?: number | null } | null };

export type GetListTagQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<TagSort> | TagSort>;
  filter?: InputMaybe<TagFilterInput>;
}>;


export type GetListTagQuery = { __typename?: 'Query', tagList: { __typename?: 'TagList', total: number, items: Array<{ __typename?: 'TagListItem', id: number, name: string, tagClassId: number, displayOrder?: number | null }> } };

export type GetManyTagQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyTagQuery = { __typename?: 'Query', tagMany: Array<{ __typename?: 'Tag', id: number, name: string, tagClassId: number, displayOrder?: number | null } | null> };

export type GetOneTagQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneTagQuery = { __typename?: 'Query', tag?: { __typename?: 'Tag', id: number, name: string, tagClassId: number, displayOrder?: number | null } | null };

export type GetManyReferenceTagQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<TagSort> | TagSort>;
  filter?: InputMaybe<TagFilterInput>;
}>;


export type GetManyReferenceTagQuery = { __typename?: 'Query', tagList: { __typename?: 'TagList', total: number, items: Array<{ __typename?: 'TagListItem', id: number, name: string, tagClassId: number, displayOrder?: number | null, tagClass: { __typename?: 'TagClass', id: number, name: string, displayOrder?: number | null } }> } };

export type GetListTitleEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<TitleEnumSort> | TitleEnumSort>;
}>;


export type GetListTitleEnumQuery = { __typename?: 'Query', titleEnumList: { __typename?: 'TitleEnumList', total: number, items: Array<{ __typename?: 'TitleEnum', id: number, name: string }> } };

export type GetOneTitleEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneTitleEnumQuery = { __typename?: 'Query', titleEnum?: { __typename?: 'TitleEnum', id: number, name: string } | null };

export type GetManyTitleEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyTitleEnumQuery = { __typename?: 'Query', titleEnumMany: Array<{ __typename?: 'TitleEnum', id: number, name: string } | null> };

export type UserListAttributesFragment = { __typename?: 'User', id: number, userName: string, commonName: string, imageType?: string | null, imageTypeSm?: string | null, isGroup: boolean, isUser: boolean, organizationId?: number | null, email?: string | null, groupEntityType?: GroupEntityType | null, isPrimaryOrganizationGroup?: boolean | null, groups?: Array<{ __typename?: 'User', id: number, commonName: string }> | null, roles: Array<{ __typename?: 'ApplicationFlags', id: number, name: string, description?: string | null }>, organization?: { __typename?: 'Organization', id: number, name: string } | null, sets?: Array<{ __typename?: 'Set', id: number, name: string }> | null };

export type FlagAttributesFragment = { __typename?: 'UserFlags', DCAdmin: boolean, isRockCreek: boolean, isSubscriptionUser: boolean, isRiskUser: boolean, isReportingUser: boolean, isServiceProviderManager: boolean, isDataManager: boolean, businessApplicant: boolean, isSuperUser: boolean, canAssumeUser: boolean, RECFReviewer: boolean, isClientUser: boolean, isPortalUser: boolean, investmentPageAccess: boolean, isClientServicesUser: boolean };

export type UserAttributesFragment = { __typename?: 'User', id: number, userName: string, commonName: string, imageType?: string | null, imageTypeSm?: string | null, isGroup: boolean, isUser: boolean, organizationId?: number | null, email?: string | null, groupEntityType?: GroupEntityType | null, isPrimaryOrganizationGroup?: boolean | null, userIds?: Array<number> | null, groupIds?: Array<number> | null, roleIds: Array<number>, users?: Array<{ __typename?: 'User', id: number, commonName: string }> | null, groups?: Array<{ __typename?: 'User', id: number, commonName: string }> | null, roles: Array<{ __typename?: 'ApplicationFlags', id: number, name: string, description?: string | null }>, organization?: { __typename?: 'Organization', id: number, name: string } | null, oktaUser?: { __typename?: 'OktaUser', id: string, created: string, activated?: string | null, lastLogin?: string | null, passwordChanged?: string | null, status: string } | null, flags: { __typename?: 'UserFlags', DCAdmin: boolean, isRockCreek: boolean, isSubscriptionUser: boolean, isRiskUser: boolean, isReportingUser: boolean, isServiceProviderManager: boolean, isDataManager: boolean, businessApplicant: boolean, isSuperUser: boolean, canAssumeUser: boolean, RECFReviewer: boolean, isClientUser: boolean, isPortalUser: boolean, investmentPageAccess: boolean, isClientServicesUser: boolean } };

export type GetListUserQueryVariables = Exact<{
  sort?: InputMaybe<Array<UserSort> | UserSort>;
  page?: InputMaybe<PageInput>;
  filter?: InputMaybe<UserFilterInput>;
}>;


export type GetListUserQuery = { __typename?: 'Query', userList: { __typename?: 'UserList', total: number, items: Array<{ __typename?: 'User', id: number, userName: string, commonName: string, imageType?: string | null, imageTypeSm?: string | null, isGroup: boolean, isUser: boolean, organizationId?: number | null, email?: string | null, groupEntityType?: GroupEntityType | null, isPrimaryOrganizationGroup?: boolean | null, groups?: Array<{ __typename?: 'User', id: number, commonName: string }> | null, roles: Array<{ __typename?: 'ApplicationFlags', id: number, name: string, description?: string | null }>, organization?: { __typename?: 'Organization', id: number, name: string } | null, sets?: Array<{ __typename?: 'Set', id: number, name: string }> | null }> } };

export type GetManyUserQueryVariables = Exact<{
  userNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetManyUserQuery = { __typename?: 'Query', userList: { __typename?: 'UserList', total: number, items: Array<{ __typename?: 'User', id: number, userName: string, commonName: string, imageType?: string | null, imageTypeSm?: string | null, isGroup: boolean, isUser: boolean, organizationId?: number | null, email?: string | null, groupEntityType?: GroupEntityType | null, isPrimaryOrganizationGroup?: boolean | null, groups?: Array<{ __typename?: 'User', id: number, commonName: string }> | null, roles: Array<{ __typename?: 'ApplicationFlags', id: number, name: string, description?: string | null }>, organization?: { __typename?: 'Organization', id: number, name: string } | null, sets?: Array<{ __typename?: 'Set', id: number, name: string }> | null }> } };

export type GetOneUserQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetOneUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: number, userName: string, commonName: string, imageType?: string | null, imageTypeSm?: string | null, isGroup: boolean, isUser: boolean, organizationId?: number | null, email?: string | null, groupEntityType?: GroupEntityType | null, isPrimaryOrganizationGroup?: boolean | null, userIds?: Array<number> | null, groupIds?: Array<number> | null, roleIds: Array<number>, users?: Array<{ __typename?: 'User', id: number, commonName: string }> | null, groups?: Array<{ __typename?: 'User', id: number, commonName: string }> | null, roles: Array<{ __typename?: 'ApplicationFlags', id: number, name: string, description?: string | null }>, organization?: { __typename?: 'Organization', id: number, name: string } | null, oktaUser?: { __typename?: 'OktaUser', id: string, created: string, activated?: string | null, lastLogin?: string | null, passwordChanged?: string | null, status: string } | null, flags: { __typename?: 'UserFlags', DCAdmin: boolean, isRockCreek: boolean, isSubscriptionUser: boolean, isRiskUser: boolean, isReportingUser: boolean, isServiceProviderManager: boolean, isDataManager: boolean, businessApplicant: boolean, isSuperUser: boolean, canAssumeUser: boolean, RECFReviewer: boolean, isClientUser: boolean, isPortalUser: boolean, investmentPageAccess: boolean, isClientServicesUser: boolean } } | null };

export type CreateUserMutationVariables = Exact<{
  input: UserCreateInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', id: number } };

export type CreateUserGroupMutationVariables = Exact<{
  input: UserGroupCreateInput;
}>;


export type CreateUserGroupMutation = { __typename?: 'Mutation', createUserGroup: { __typename?: 'User', id: number } };

export type UpdateUserGroupMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UserGroupUpdateInput;
}>;


export type UpdateUserGroupMutation = { __typename?: 'Mutation', updateUserGroup: { __typename?: 'User', id: number } };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UserUpdateInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: number } };

export type ActivateUserMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ActivateUserMutation = { __typename?: 'Mutation', activateUser: { __typename?: 'User', id: number } };

export type DeactivateUserMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeactivateUserMutation = { __typename?: 'Mutation', deactivateUser: { __typename?: 'User', id: number } };

export type GetListUserActivityQueryVariables = Exact<{
  sort?: InputMaybe<Array<UserActivitySort> | UserActivitySort>;
  page?: InputMaybe<PageInput>;
  filter?: InputMaybe<UserActivityFilter>;
}>;


export type GetListUserActivityQuery = { __typename?: 'Query', userActivityList: { __typename?: 'UserActivityList', total: number, items: Array<{ __typename?: 'UserActivity', id: string, createDate: string, email: string, adEntryId?: number | null, applicationId: number, rcgApplicationVersion: string, requestUri: string, requestUtc: string }> } };

export type GetManyUserActivityQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetManyUserActivityQuery = { __typename?: 'Query', userActivityList: { __typename?: 'UserActivityList', total: number, items: Array<{ __typename?: 'UserActivity', id: string, createDate: string, email: string, adEntryId?: number | null, applicationId: number, rcgApplicationVersion: string, requestUri: string, requestUtc: string }> } };

export type GetOneUserActivityQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOneUserActivityQuery = { __typename?: 'Query', userActivity?: { __typename?: 'UserActivity', id: string, createDate: string, email: string, adEntryId?: number | null, applicationId: number, rcgApplicationVersion: string, requestUri: string, requestUtc: string } | null };

export type UsersXGroupsAttributesFragment = { __typename?: 'UsersXGroups', id: string, userId: number, groupId: number, user: { __typename?: 'User', id: number, commonName: string, email?: string | null, roles: Array<{ __typename?: 'ApplicationFlags', id: number, name: string }>, sets?: Array<{ __typename?: 'Set', id: number, name: string }> | null, organization?: { __typename?: 'Organization', id: number, name: string } | null }, group: { __typename?: 'User', id: number, commonName: string, email?: string | null, roles: Array<{ __typename?: 'ApplicationFlags', id: number, name: string }>, sets?: Array<{ __typename?: 'Set', id: number, name: string }> | null, organization?: { __typename?: 'Organization', id: number, name: string } | null } };

export type GetListUsersXGroupsQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<UsersXGroupsSort> | UsersXGroupsSort>;
  filter?: InputMaybe<UsersXGroupsFilter>;
}>;


export type GetListUsersXGroupsQuery = { __typename?: 'Query', usersXGroupsList: { __typename?: 'UsersXGroupsList', total: number, items: Array<{ __typename?: 'UsersXGroups', id: string, userId: number, groupId: number, user: { __typename?: 'User', id: number, commonName: string, email?: string | null, roles: Array<{ __typename?: 'ApplicationFlags', id: number, name: string }>, sets?: Array<{ __typename?: 'Set', id: number, name: string }> | null, organization?: { __typename?: 'Organization', id: number, name: string } | null }, group: { __typename?: 'User', id: number, commonName: string, email?: string | null, roles: Array<{ __typename?: 'ApplicationFlags', id: number, name: string }>, sets?: Array<{ __typename?: 'Set', id: number, name: string }> | null, organization?: { __typename?: 'Organization', id: number, name: string } | null } }> } };

export type GetOneUsersXGroupsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOneUsersXGroupsQuery = { __typename?: 'Query', usersXGroups?: { __typename?: 'UsersXGroups', id: string, userId: number, groupId: number, user: { __typename?: 'User', id: number, commonName: string, email?: string | null, roles: Array<{ __typename?: 'ApplicationFlags', id: number, name: string }>, sets?: Array<{ __typename?: 'Set', id: number, name: string }> | null, organization?: { __typename?: 'Organization', id: number, name: string } | null }, group: { __typename?: 'User', id: number, commonName: string, email?: string | null, roles: Array<{ __typename?: 'ApplicationFlags', id: number, name: string }>, sets?: Array<{ __typename?: 'Set', id: number, name: string }> | null, organization?: { __typename?: 'Organization', id: number, name: string } | null } } | null };

export type GetManyUsersXGroupsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetManyUsersXGroupsQuery = { __typename?: 'Query', usersXGroupsMany: Array<{ __typename?: 'UsersXGroups', id: string, userId: number, groupId: number, user: { __typename?: 'User', id: number, commonName: string, email?: string | null, roles: Array<{ __typename?: 'ApplicationFlags', id: number, name: string }>, sets?: Array<{ __typename?: 'Set', id: number, name: string }> | null, organization?: { __typename?: 'Organization', id: number, name: string } | null }, group: { __typename?: 'User', id: number, commonName: string, email?: string | null, roles: Array<{ __typename?: 'ApplicationFlags', id: number, name: string }>, sets?: Array<{ __typename?: 'Set', id: number, name: string }> | null, organization?: { __typename?: 'Organization', id: number, name: string } | null } } | null> };

export type CreateUsersXGroupsMutationVariables = Exact<{
  input: UsersXGroupsInput;
}>;


export type CreateUsersXGroupsMutation = { __typename?: 'Mutation', addUsersXGroups: { __typename?: 'UsersXGroups', id: string } };

export type UpdateUsersXGroupsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UsersXGroupsInput;
}>;


export type UpdateUsersXGroupsMutation = { __typename?: 'Mutation', updateUsersXGroups: { __typename?: 'UsersXGroups', id: string } };

export type DeleteUsersXGroupsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteUsersXGroupsMutation = { __typename?: 'Mutation', deleteUsersXGroups: string };

export type GetListVehicleTypeEnumOptionsQueryVariables = Exact<{
  filter?: InputMaybe<TypeAssetClassStrategyOptionsFilterInput>;
  sort?: InputMaybe<Array<TypeAssetClassStrategyOptionsSort> | TypeAssetClassStrategyOptionsSort>;
}>;


export type GetListVehicleTypeEnumOptionsQuery = { __typename?: 'Query', vehicleTypeOptions: { __typename?: 'VehicleTypeEnumList', total: number, items: Array<{ __typename?: 'VehicleTypeEnum', id: number, name: string }> } };

export type GetOneVehicleTypeEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneVehicleTypeEnumQuery = { __typename?: 'Query', vehicleTypeEnum?: { __typename?: 'VehicleTypeEnum', id: number, name: string } | null };

export type GetManyVehicleTypeEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyVehicleTypeEnumQuery = { __typename?: 'Query', vehicleTypeEnumMany: Array<{ __typename?: 'VehicleTypeEnum', id: number, name: string } | null> };

export type GetListWorkoutEnumQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<WorkoutEnumSort> | WorkoutEnumSort>;
}>;


export type GetListWorkoutEnumQuery = { __typename?: 'Query', workoutEnumList: { __typename?: 'WorkoutEnumList', total: number, items: Array<{ __typename?: 'WorkoutEnum', id: number, name: string }> } };

export type GetOneWorkoutEnumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneWorkoutEnumQuery = { __typename?: 'Query', workoutEnum?: { __typename?: 'WorkoutEnum', id: number, name: string } | null };

export type GetManyWorkoutEnumQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetManyWorkoutEnumQuery = { __typename?: 'Query', workoutEnumMany: Array<{ __typename?: 'WorkoutEnum', id: number, name: string } | null> };

export type GetUserMutationAccessibleQueryVariables = Exact<{
  mutationName: Scalars['String']['input'];
  mutationArgs: Scalars['String']['input'];
}>;


export type GetUserMutationAccessibleQuery = { __typename?: 'Query', userMutationAccessible: { __typename?: 'MutationAccess', canAccess: boolean, fieldAccess?: Array<{ __typename?: 'FieldAccess', field: string, canInput: boolean, pointer?: string | null }> | null } };

export const AdEntriesXApplicationFlagsAttributesFragmentDoc = gql`
    fragment adEntriesXApplicationFlagsAttributes on AdEntriesXApplicationFlags {
  id
  userId
  applicationFlagId
  applicationFlag {
    id
    name
    description
  }
  user {
    id
    commonName
    email
  }
}
    `;
export const AdEntriesXApplicationsXSetsAttributesFragmentDoc = gql`
    fragment adEntriesXApplicationsXSetsAttributes on AdEntriesXApplicationsXSets {
  id
  entryId
  setId
  applicationId
  set {
    id
    name
  }
  entry {
    id
    commonName
    email
  }
  application {
    id
    name
  }
}
    `;
export const ApplicationAttributesFragmentDoc = gql`
    fragment applicationAttributes on Application {
  id
  name
}
    `;
export const ClientAttributesFragmentDoc = gql`
    fragment clientAttributes on Client {
  id
  clientName
  clientType
}
    `;
export const CompanyAttributesFragmentDoc = gql`
    fragment companyAttributes on Company {
  id
  firmId
  name
  summary
  isBusinessApplication
  ndaSigned
  operatingStatusEnumId
  operatingStatus {
    id
    name
  }
  lastFundingTypeEnumId
  lastFundingType {
    id
    name
  }
  companyTypeEnumId
  companyType {
    id
    name
  }
  primaryAssignment
  firmAttributes {
    id
    isCompany
    stockSymbol
    primaryAddressId
    isStaffMWDBE
    primaryAddress {
      id
      line1
      line2
      line3
      city
      stateEnumId
      otherState
      zipCode
      countryEnumId
      phone
      phone2
      fax
      fax2
      website
    }
    employeeTotal
    yearFounded
    email
    linkedIn
    website
    firmTags {
      firmId
      tagId
      tag {
        id
        name
        tagClassId
        tagClass {
          id
          name
        }
      }
    }
    firmXImpact {
      firmId
      impactEnumId
      impactEnum {
        id
        name
      }
    }
    impactTags {
      id
      name
    }
    firmEmployments {
      id
      firmId
      personId
      employeeRoleEnumId
      contactTypeEnumId
      leftInd
      leftDate
      leftReason
      authToTrade
      outsideAffil
      startDate
      jobDesc
      focusStrategyEnumId
      dataContact
      isFounder
      isKeyPersonnel
      auditContactTypeEnumId
      isDataEntryContact
      displayOrder
      comments
      person {
        id
        firstName
        lastName
        middleName
        email
        phone
      }
    }
  }
}
    `;
export const CompanyValuationAttributesFragmentDoc = gql`
    fragment companyValuationAttributes on CompanyValuation {
  id
  companyId
  valuation
  asOfDate
}
    `;
export const FlagAttributesFragmentDoc = gql`
    fragment flagAttributes on UserFlags {
  DCAdmin
  isRockCreek
  isSubscriptionUser
  isRiskUser
  isReportingUser
  isServiceProviderManager
  isDataManager
  businessApplicant
  isSuperUser
  canAssumeUser
  RECFReviewer
  isClientUser
  isPortalUser
  investmentPageAccess
  isClientServicesUser
}
    `;
export const CurrentUserAttributesFragmentDoc = gql`
    fragment currentUserAttributes on CurrentUser {
  id
  currentUserId
  isAssumed
  assumedUserId
  organizationId
  sub
  username
  userName
  commonName
  email
  imageType
  imageTypeSm
  entryTypeId
  organization {
    id
    name
  }
  flags {
    ...flagAttributes
  }
}
    ${FlagAttributesFragmentDoc}`;
export const CustomAnalyticsAttributesFragmentDoc = gql`
    fragment customAnalyticsAttributes on CustomAnalytics {
  id
  ownerId
  ownerType
  value
  investment {
    id
    name
  }
  asOfDate
  createDate
  createUser
  modifyDate
  modifyUser
}
    `;
export const CustomIndexTermAttributesFragmentDoc = gql`
    fragment customIndexTermAttributes on CustomIndexTerm {
  id
  inputInvestmentId
  multiplierFactor
  additionFactor
  additionFactorAfter
  laggedMonths
  groupId
}
    `;
export const CustomIndexGroupAttributesFragmentDoc = gql`
    fragment customIndexGroupAttributes on CustomIndexGroup {
  id
  geReturnDate
  leReturnDate
  terms {
    items {
      ...customIndexTermAttributes
    }
  }
}
    ${CustomIndexTermAttributesFragmentDoc}`;
export const CustomIndexInvestmentAttributesFragmentDoc = gql`
    fragment customIndexInvestmentAttributes on CustomIndexInvestment {
  id
  outputInvestment {
    name
  }
}
    `;
export const CustomIndexPreviewAttributesFragmentDoc = gql`
    fragment customIndexPreviewAttributes on PerformanceMTD {
  investmentId
  returnYear
  returnMonth
  return
}
    `;
export const CogencyLinkAttributesFragmentDoc = gql`
    fragment cogencyLinkAttributes on CogencyLink {
  id
  cogencyId
  cogStartDate
  solovisDataEnabled
  solovisTranStartDate
}
    `;
export const DealAttributesFragmentDoc = gql`
    fragment dealAttributes on Deal {
  id
  name
  companyId
  company {
    id
    name
    firmAttributes {
      id
      firmTags {
        firmId
        tagId
        tag {
          id
          name
          tagClassId
          tagClass {
            id
            name
          }
        }
      }
    }
  }
  dealTags {
    dealId
    tagId
    tag {
      id
      name
      tagClassId
      tagClass {
        id
        name
      }
    }
  }
  firmId
  firm {
    id
    name
  }
  fundingRoundEnumId
  fundingRound {
    id
    name
  }
  stageEnumId
  stage {
    id
    name
  }
  dealMarketingEnumId
  dealMarketing {
    id
    name
  }
  resultEnumId
  result {
    id
    name
  }
  dateReceived
  expectedCloseDate
  roundSize
  isLeadInvestor
  amount
  preMoneyValuation
  passedNote
  summary
  isImpact
  headquartersEnumId
  headquarters {
    id
    name
  }
  assetClassEnumId
  assetClass {
    id
    name
  }
  strategyEnumId
  strategy {
    id
    name
  }
  subStrategyEnumId
  subStrategy {
    id
    name
  }
  coInvestors
  dealStructureEnumId
  dealStructure {
    id
    name
  }
  rcSource
  rcSourceUser {
    id
    commonName
  }
  source
  dealGroupId
}
    `;
export const DocumentAttributesFragmentDoc = gql`
    fragment documentAttributes on Document {
  id
  name
  date
  digest
  signedUrl
  signedThumbnailUrl
  documentTypeEnumId
  accessLevel
  isGallery
  isApproved
  notifyUsers
  entityAssociations {
    id
    businessObjectTypeEnumId
    entityId
    entityName
  }
  documentTypeEnum {
    id
    name
    documentCategoryEnumId
  }
  documentAccessLevel {
    id
    name
  }
}
    `;
export const EmailDomainXOrganizationAttributesFragmentDoc = gql`
    fragment emailDomainXOrganizationAttributes on EmailDomainXOrganization {
  id
  emailDomain
  organizationId
  organization {
    id
    name
  }
}
    `;
export const FdpLoginAttributesFragmentDoc = gql`
    fragment fdpLoginAttributes on FDPLogin {
  id
  username
  password
  securityQuestion
  notes
  email
  mfaUser
  imageLink
  modifyUser
  modifyDate
  financialDataProviderId
  financialDataProvider {
    id
    name
    fdpWebsites {
      id
      website
    }
  }
  authenticatorEnumId
  authenticatorEnum {
    id
    name
  }
  firmFDPLogins {
    id
    firmId
    firm {
      id
      name
      isCompany
    }
    fdpLoginId
    fdpWebsiteId
    fdpWebsite {
      id
      website
      financialDataProviderId
    }
    investmentFDPLogins {
      id
      fdpLoginId
      investmentId
      investment {
        id
        name
      }
      fdpWebsiteId
      fdpWebsite {
        id
        website
        financialDataProviderId
      }
    }
  }
  portfolioFDPLogins {
    id
    portfolioId
    portfolio {
      id
      name
    }
    fdpLoginId
    fdpWebsiteId
    fdpWebsite {
      id
      website
      financialDataProviderId
    }
  }
  investmentFDPLogins {
    id
    fdpLoginId
    investmentId
    investment {
      id
      name
    }
    fdpWebsiteId
    fdpWebsite {
      id
      website
      financialDataProviderId
    }
  }
  firms {
    id
    name
    isCompany
  }
  investments {
    id
    name
  }
  portfolios {
    id
    name
  }
}
    `;
export const FdpWebsitesAttributesFragmentDoc = gql`
    fragment fdpWebsitesAttributes on FDPWebsites {
  id
  website
  financialDataProviderId
}
    `;
export const FinancialDataProviderAttributesFragmentDoc = gql`
    fragment financialDataProviderAttributes on FinancialDataProvider {
  id
  name
  fdpWebsites {
    id
    website
  }
}
    `;
export const FirmAttributesFragmentDoc = gql`
    fragment firmAttributes on Firm {
  id
  name
  isCompany
  companyId
  firmEmailDomains
  primaryAddress {
    id
    line1
    line2
    line3
    city
    stateEnumId
    otherState
    zipCode
    countryEnumId
    phone
    phone2
    fax
    fax2
    website
    webUserId
    webPassword
  }
  otherAddresses {
    id
    line1
    line2
    line3
    city
    stateEnumId
    otherState
    zipCode
    countryEnumId
    phone
    phone2
    fax
    fax2
  }
  families {
    id
    name
    firmId
  }
  yearFounded
  registeredWithIds
  registeredWithOther
  cik
  lei
  isStaffMWDBE
  crd
  ukHfsbSignatory
  ownershipDiversity {
    asOfDate
    africanAmericanPercent
    asianPercent
    hispanicPercent
    LGBTQPercent
    nativeAmericanPercent
    veteranPercent
    disabledPercent
    womenPercent
    otherPercent
    diversePercent
  }
  employeeTotal
  portfolioManagerCount
  investmentCount
  analystCount
  traderCount
  operationsCount
  administrativeCount
  investorRelationsCount
  legalCount
  firmIrEmail
  comments
  fdpLogins {
    username
    password
    securityQuestion
  }
  fdpLogins {
    id
    username
    password
    securityQuestion
  }
  portalFirm {
    migratedAt
  }
  dataOrganizationId
  firmEmployments {
    id
    person {
      id
      firstName
      middleName
      lastName
      email
    }
    employeeRole {
      id
      name
    }
  }
}
    `;
export const FirmDeiAttributesFragmentDoc = gql`
    fragment firmDEIAttributes on FirmDEI {
  id
  asOfDate
  firmId
  firm {
    id
    name
    isCompany
    companyId
  }
  isCompleted
  geographyEnumId
  geographyEnum {
    id
    description
  }
  diversityStatsEnumId
  comments
  firmDEIRecords {
    id
    firmDEIId
    deiCategory1EnumId
    deiCategory1Enum {
      id
      description
    }
    deiCategory2EnumId
    deiCategory2Enum {
      id
      description
    }
    measureEnumId
    measureEnum {
      id
      description
    }
    value
    percentValue
  }
}
    `;
export const FirmEmploymentAttributesFragmentDoc = gql`
    fragment firmEmploymentAttributes on FirmEmployment {
  id
  firmId
  personId
  employeeRoleEnumId
  contactTypeEnumId
  employeeRole {
    id
    name
  }
  contactType {
    id
    name
  }
  faceOfFirm
  leftInd
  leftDate
  leftReason
  authToTrade
  outsideAffil
  startDate
  jobDesc
  focusStrategyEnumId
  dataContact
  isFounder
  isKeyPersonnel
  isAdminContact
  auditContactTypeEnumId
  isDataEntryContact
  displayOrder
  comments
  firm {
    id
    name
    companyId
    isCompany
    fdpLogins {
      id
      username
      password
      securityQuestion
    }
    primaryAddress {
      id
      website
      webUserId
      webPassword
    }
  }
  person {
    id
    lastName
    firstName
    middleName
    email
    phone
  }
}
    `;
export const FirmFdpLoginsAttributesFragmentDoc = gql`
    fragment firmFDPLoginsAttributes on FirmFDPLogins {
  id
  firmId
  fdpLoginId
  firm {
    id
    name
    isCompany
    companyId
  }
  fdpWebsiteId
  fdpWebsite {
    id
    website
    financialDataProviderId
  }
  fdpLogin {
    id
    username
    financialDataProviderId
    financialDataProvider {
      id
      name
      fdpWebsites {
        id
        website
      }
    }
  }
}
    `;
export const FirmInstitutionsAttributesFragmentDoc = gql`
    fragment firmInstitutionsAttributes on FirmInstitutions {
  id
  firmId
  institutionId
  startDate
  endDate
  institutionInstitutionTypeEnumId
  firm {
    id
    name
  }
  institution {
    id
    name
  }
  officeLocationServiceType {
    id
    institutionTypeEnum {
      id
      name
    }
  }
}
    `;
export const GlobalProviderNoteTypeEnumAttributesFragmentDoc = gql`
    fragment globalProviderNoteTypeEnumAttributes on GlobalProviderNoteTypeEnum {
  id
  name
}
    `;
export const GroupShareDefinitionAttributesFragmentDoc = gql`
    fragment groupShareDefinitionAttributes on GroupShareDefinition {
  id
  dynamicDefinition
  dynamicDefinitionStructured {
    description
    displayName
    investmentsDynamicShare {
      investmentSet {
        setId
      }
    }
    firmsDynamicShare {
      investmentSet {
        setId
      }
    }
    personsDynamicShare {
      investmentSet {
        setId
      }
    }
    documentsDynamicShare {
      investmentSet {
        setId
      }
      documentTypes
    }
    everything
  }
  sourceGroupId
  sourceGroup {
    id
    commonName
    userName
    organizationId
    organization {
      id
      name
    }
  }
  targetGroupId
  targetGroup {
    id
    commonName
    userName
    organizationId
    organization {
      id
      name
    }
  }
  entityAccessId
  isActive
  lastExecuted
  createDate
  modifyDate
  createUser
  modifyUser
}
    `;
export const InstitutionEmploymentAttributesFragmentDoc = gql`
    fragment institutionEmploymentAttributes on InstitutionEmployment {
  id
  institutionId
  personId
  startDate
  leftDate
  isPrimaryContact
  person {
    id
    fullName
  }
  institution {
    id
    name
  }
}
    `;
export const InstitutionSelectionStatusEnumAttributesFragmentDoc = gql`
    fragment institutionSelectionStatusEnumAttributes on InstitutionSelectionStatusEnum {
  id
  name
}
    `;
export const InvestmentAttributesFragmentDoc = gql`
    fragment investmentAttributes on Investment {
  id
  assetClassEnumId
  atlasInvestmentId
  targetRaise
  hardCap
  committedCapital
  committedCapitalCurrencyId
  committedCapitalCurrency {
    id
    name
  }
  currencyDenominationEnumId
  fundLinkId
  domicileFundLinkId
  reportingLinkId
  isLiquidated
  isManagerUnwillingToProvidePerformance
  isManagerUnwillingToProvidePositions
  isManagerUnwillingToProvideRisk
  isManagerUnwillingToProvideAUM
  liquidationDate
  liquidationNote
  HFRIInvestmentId
  evestmentId
  burgissId
  bloombergCode
  bloombergField
  RICId
  ndaSigned
  portalSubmitted {
    migratedAt
  }
  currencyDenominationEnum {
    id
    name
  }
  assetClass {
    id
    name
  }
  vehicleTypeEnumId
  vehicleType {
    id
    name
  }
  market {
    id
    name
  }
  marketEnumId
  createDate
  createUser
  domicileCountry {
    id
    name
  }
  domicileCountryId
  domicileUSState {
    id
    name
  }
  domicileUSStateId
  familyId
  family {
    id
    name
  }
  firmId
  firm {
    id
    name
    isCompany
    companyId
  }
  gpCommitted
  gpCommittedCurrencyId
  gpCommittedCurrency {
    id
    name
  }
  inceptionDate
  isESG
  isImpact
  isOffshore
  isPartner
  isSubAdvised
  accountTypeEnumId
  advisorTypeEnumId
  advisorId
  advisor {
    id
    name
  }
  isWorkInProgress
  list {
    id
    name
  }
  shortName
  listEnumId
  maxExpectedVolatility
  maxGrossExposure
  maxNetExposure
  maxTargetNetIRR
  maxTargetNetMOIC
  minExpectedVolatility
  minGrossExposure
  fiscalYearEndMonth
  minNetExposure
  minTargetNetIRR
  minTargetNetMOIC
  modifyDate
  modifyUser
  name
  peLegalLifeYrs
  peFundNumberEnumId
  peFundNumber {
    id
    name
  }
  peStrategy {
    id
    name
  }
  peStrategyEnumId
  peSubStrategy {
    id
    name
  }
  peSubStrategyEnumId
  primaryAssignment
  primaryBenchmark {
    id
    name
  }
  primaryBenchmarkId
  secondaryAssignment
  secondaryBenchmark {
    id
    name
  }
  secondaryBenchmarkId
  strategy {
    id
    name
  }
  strategyEnumId
  subStrategy {
    id
    name
  }
  subStrategyEnumId
  summary
  uniqueSecurityCode
  vintageYear
  primaryGeographicFocus {
    id
    name
  }
  primaryGeographicFocusId
  otherGeographicFocuses {
    id
    name
  }
  otherGeographicFocusIds
  investmentStructureEnumId
  investmentStructure {
    id
    name
  }
  legalStructure {
    id
    name
  }
  legalStructureEnumId
  isRegisteredInvestmentCompany
  organizationStructureEnumId
  organizationStructure {
    id
    name
  }
  NAVClassificationEnumId
  NAVClassification {
    id
    name
  }
  pricingFrequency {
    id
    name
  }
  pricingFrequencyEnumId
  investmentTags {
    id
    tagId
    tagClassId
    tag {
      id
      name
      tagClassId
    }
  }
  closeDateFundSize {
    fundSize
    closeDate
  }
  investmentXImpact {
    impactEnumId
    impactEnum {
      id
      name
    }
  }
  performanceSource
  performanceSourceEnumId
  registeredAddressProvider {
    id
    name
    addressesId
    address {
      id
      line1
      line2
      line3
      city
      stateEnumId
      otherState
      zipCode
      countryEnumId
      phone
      phone2
      fax
      fax2
    }
  }
  reportingDate
  reportingDateReason
  indexCalcTypeEnumId
  indexCalcTypeEnum {
    id
    indexCalcType
  }
  access {
    read
    update
    delete
    preview
  }
  fundsXProxies {
    id
    investmentId
    proxyId
    proxyScalingFactor
    rank
    proxy {
      id
      name
    }
  }
}
    `;
export const InvestmentAxysCodeAttributesFragmentDoc = gql`
    fragment investmentAxysCodeAttributes on InvestmentAxysCode {
  id
  axysCodeId
  investmentId
  axysCode {
    id
    code
  }
}
    `;
export const InvestmentFdpLoginsAttributesFragmentDoc = gql`
    fragment investmentFDPLoginsAttributes on InvestmentFDPLogins {
  id
  investmentId
  fdpLoginId
  fdpWebsiteId
  fdpWebsite {
    id
    website
    financialDataProviderId
  }
  fdpLogin {
    id
    username
    financialDataProviderId
    financialDataProvider {
      id
      name
      fdpWebsites {
        id
        website
      }
    }
  }
  firmFDPLogin {
    id
    firmId
    firm {
      id
      name
    }
    fdpLoginId
  }
  investment {
    id
    name
  }
}
    `;
export const InvestmentInstitutionsAttributesFragmentDoc = gql`
    fragment investmentInstitutionsAttributes on InvestmentInstitutions {
  id
  investmentId
  institutionId
  startDate
  endDate
  institutionInstitutionTypeEnumId
  investment {
    id
    name
  }
  institution {
    id
    name
    globalProviderInstitution {
      id
      provider {
        id
        name
      }
    }
  }
  officeLocationServiceType {
    id
    institutionTypeEnum {
      id
      name
    }
  }
}
    `;
export const InvestmentAttributesForPrivateQuartilesFragmentDoc = gql`
    fragment investmentAttributesForPrivateQuartiles on Investment {
  id
  name
  firm {
    id
    name
  }
  derivedPrivateQuartileGroupCategory {
    id
    uniqueLabel
    displayLabel
  }
}
    `;
export const InvestmentPrivateQuartileGroupCategoryAttributesFragmentDoc = gql`
    fragment investmentPrivateQuartileGroupCategoryAttributes on InvestmentPrivateQuartileGroupCategory {
  id
  investmentId
  investment {
    id
    name
  }
  privateQuartileGroupCategoryId
  privateQuartileGroupCategory {
    id
    uniqueLabel
    displayLabel
  }
  isDefault
}
    `;
export const InvestmentFeesAttributesFragmentDoc = gql`
    fragment investmentFeesAttributes on InvestmentFees {
  id
  shareClassId
  mgmtFee
  mgmtFeeCalc {
    id
    name
  }
  mgmtFeeCalcEnumId
  mgmtFeeFreq {
    id
    name
  }
  mgmtFeeFreqEnumId
  incentiveFee
  incentiveFeeCalc {
    id
    name
  }
  incentiveFeeCalcEnumId
  incentiveFeeFreq {
    id
    name
  }
  incentiveFeeFreqEnumId
  otherFee
  otherFeeCalc {
    id
    name
  }
  otherFeeCalcEnumId
  otherFeeFreq {
    id
    name
  }
  otherFeeFreqEnumId
  highWaterMark
  hurdle
  hurdleBenchmark
  annualReset
  peMgmtFeeCalc {
    id
    name
  }
  peMgmtFeeCalcEnumId
  peIncentiveFeeCalc {
    id
    name
  }
  peIncentiveFeeCalcEnumId
  peMgmtFeeDuringCommitment
  peMgmtFeeDuringCommitmentCalc {
    id
    name
  }
  peMgmtFeeDuringCommitmentCalcEnumId
  peMgmtFeeDuringHarvest
  peMgmtFeeDuringHarvestCalc {
    id
    name
  }
  peMgmtFeeDuringHarvestCalcEnumId
  pePlacementFeesPaid
  peGP
  peLP
  feeStructureChanged
  feeStructureChangedNotes
  standardShareClassRates
  abnormalFees
  abnormalFeesNotes
  hasMgmtFeeStepDown
  peMgmtFeeStepDownPercent
  peMgmtFeeStepDownCalc {
    id
    name
  }
  peMgmtFeeStepDownCalcEnumId
}
    `;
export const LiquidityAttributesFragmentDoc = gql`
    fragment liquidityAttributes on Liquidity {
  id
  shareClassId
  hasGate
  gatePercentNav
  gatePercentCapital
  exceptions
  hasRollover
  rolloverValue
  rolloverUnit {
    id
    name
  }
  rolloverUnitId
  hasLockup
  lockupValue
  lockupUnit {
    id
    name
  }
  lockupUnitId
  lockupEndValueId
  lockupEndValue {
    id
    name
  }
  lockupEndUnit {
    id
    name
  }
  lockupEndUnitId
  lockupEndBasisDate
  lockupEndBizDays
  secondLockupValue
  secondLockupUnit {
    id
    name
  }
  secondLockupUnitId
  secondLockupEndValueId
  secondLockupEndValue {
    id
    name
  }
  secondLockupEndUnit {
    id
    name
  }
  secondLockupEndUnitId
  secondLockupEndBasisDate
  secondLockupEndBizDays
  liquidityValue
  liquidityUnit {
    id
    name
  }
  liquidityUnitId
  noticeValue
  noticeUnit {
    id
    name
  }
  noticeUnitId
  noticeBizDays
  subscriptionValue
  subscriptionUnit {
    id
    name
  }
  subscriptionUnitId
  cashAvailableDays
  hasHoldback
  holdbackPercent
  workout {
    id
    name
  }
  workoutId
  masterLevelFundGate
  lockupMonthlyValue
  liquidityMonthlyValue
  modelingNotes
  modifyDate
}
    `;
export const PeLiquidityAttributesFragmentDoc = gql`
    fragment peLiquidityAttributes on PeLiquidity {
  id
  shareClassId
  preferredReturn
  isCompounded
  compoundingPeriod {
    id
    name
  }
  compoundingPeriodId
  hasCatchupProvision
  catchupPercent
  optionOfExtension {
    id
    name
  }
  optionOfExtensionId
}
    `;
export const SoftLockupAttributesFragmentDoc = gql`
    fragment softLockupAttributes on SoftLockup {
  id
  liquidityId
  cashAvailableDays
  lockupEndRedemptionOn {
    id
    name
  }
  lockupEndRedemptionOnId
  holdBackPercent
  noticeValue
  liquidityValue
  liquidityUnit {
    id
    name
  }
  liquidityUnitId
  noticeBizDays
  redemptionFee
  redemptionOnBizDays
  secondLockupEndRedemptionOn {
    id
    name
  }
  secondLockupEndRedemptionOnId
  termBeginMonth
  termEndMonth
  hasRedemptionFee
}
    `;
export const ShareClassAttributesFragmentDoc = gql`
    fragment shareClassAttributes on ShareClass {
  id
  investmentId
  investment {
    id
    name
    marketEnumId
  }
  name
  currencyDenominationEnumId
  otherFees
  restricted
  FAS157
  status
  isRcgNegotiated
  investmentFees {
    ...investmentFeesAttributes
  }
  liquidity {
    ...liquidityAttributes
  }
  peLiquidity {
    ...peLiquidityAttributes
  }
  softLockups {
    ...softLockupAttributes
  }
}
    ${InvestmentFeesAttributesFragmentDoc}
${LiquidityAttributesFragmentDoc}
${PeLiquidityAttributesFragmentDoc}
${SoftLockupAttributesFragmentDoc}`;
export const InvestmentTermsAttributesFragmentDoc = gql`
    fragment investmentTermsAttributes on Investment {
  id
  name
  marketEnumId
  investmentPeriodYrs
  harvestPeriodYrs
  extensionPeriodYrs
  peLegalLifeYrs
  shareClassNote
  shareClasses {
    ...shareClassAttributes
  }
}
    ${ShareClassAttributesFragmentDoc}`;
export const LinksAttributesFragmentDoc = gql`
    fragment linksAttributes on Links {
  id
  name
  url
  iconEnum {
    name
    id
  }
  iconEnumId
  orgLinks {
    id
    linkId
    organizationId
    expirationDate
    organization {
      id
      name
    }
  }
}
    `;
export const NoteAttributesFragmentDoc = gql`
    fragment noteAttributes on Notes {
  id
  noteMetaId
  noteDate
  text
  createUser
  createDate
  modifyUser
  modifyDate
  accessLevelId
  entityAssignments {
    id
    businessObjectTypeEnumId
    entityId
    entityName
  }
  noteMeta {
    id
    label
  }
}
    `;
export const InstitutionAttributesFragmentDoc = gql`
    fragment institutionAttributes on Institution {
  id
  name
  institutionSelectionStatusEnum {
    name
  }
  institutionNameWithLocation
  address {
    id
    line1
    line2
    line3
    city
    stateEnumId
    otherState
    zipCode
    countryEnumId
    phone
    phone2
    fax
    fax2
    website
    webUserId
    webPassword
  }
  institutionSelectionStatusEnumId
  addressesId
  institutionInstitutionTypesList
  globalProviderInstitution {
    providerId
    id
    isCorporate
  }
}
    `;
export const OrgLinksAttributesFragmentDoc = gql`
    fragment orgLinksAttributes on OrgLinks {
  id
  linkId
  link {
    name
    url
    iconEnum {
      name
      id
    }
    iconEnumId
  }
  organizationId
  expirationDate
  organization {
    id
    name
  }
}
    `;
export const OrganizationAttributesFragmentDoc = gql`
    fragment organizationAttributes on Organization {
  id
  name
  clientId
  intakeOrganizationId
  smallIconUrl
  orgLinks {
    id
    organizationId
    linkId
    link {
      name
      url
      id
    }
    expirationDate
  }
}
    `;
export const PersonAttributesFragmentDoc = gql`
    fragment personAttributes on Person {
  id
  fullName
  firstName
  middleName
  lastName
  pronouns
  phone
  phone2
  fax
  fax2
  email
  email2
  isCFA
  linkedin
  twitter
  biography
  educationSummary
  workExperienceSummary
  newsMonitoringStartDate
  titleEnumId
  photoLink
  newsMonitoringStartDate
  diversity {
    africanAmerican
    asian
    hispanic
    lgbtq
    other
    nativeAmerican
    hawaiianOrPacificIslander
    veteran
    disabled
    nonBinary
    woman
  }
}
    `;
export const PersonEducationAttributesFragmentDoc = gql`
    fragment personEducationAttributes on PersonEducation {
  id
  person {
    id
    lastName
    firstName
    middleName
  }
  degreeEnumId
  degree {
    id
    name
  }
  school {
    id
    name
  }
  graduationYear
}
    `;
export const PersonWorkExperienceAttributesFragmentDoc = gql`
    fragment personWorkExperienceAttributes on PersonWorkExperience {
  id
  person {
    id
    lastName
    firstName
    middleName
  }
  personId
  companyEnumId
  company {
    id
    name
  }
  title
  fromYear
  toYear
}
    `;
export const PortalFirmAttributesFragmentDoc = gql`
    fragment portalFirmAttributes on PortalFirm {
  id
  name
  organizationId
  organization {
    id
    name
  }
  firmTypeEnumId
  rcgFirmId
  shouldUpdate
  rcgFirm {
    id
    name
  }
  firmType {
    id
    name
  }
  deleteDate
}
    `;
export const PortalOrganizationAttributesFragmentDoc = gql`
    fragment portalOrganizationAttributes on PortalOrganization {
  id
  name
  allowMultiFirm
  deleteDate
  deleteUser
  organization {
    id
    name
    intakeOrganizationId
    clientId
  }
  primaryFirm {
    id
    name
  }
  emailDomainMappings {
    emailDomain
    organizationId
  }
  portalServiceProviderFirms {
    id
    firmId
    organizationId
    firm {
      id
      name
      organizationId
      organization {
        id
        name
      }
    }
  }
  users {
    id
    firstName
    lastName
    email
  }
}
    `;
export const PortalSubmittedFieldsFragmentDoc = gql`
    fragment PortalSubmittedFields on PortalSubmitted {
  id
  name
  shouldUpdate
  rcgFundId
  rcgFund {
    id
    name
  }
  firm {
    id
    name
  }
  firmId
  deleteDate
}
    `;
export const PortfolioConfigAttributesFragmentDoc = gql`
    fragment portfolioConfigAttributes on PortfolioConfig {
  id
  showInvestments
  performanceLag {
    lag
    lagUnit {
      id
      name
    }
    lagUnitId
  }
  portfolioId
  portfolio {
    id
    name
  }
  lookthroughEnabled
  lookthroughInvestments {
    id
    name
  }
  tileImageId
  tileImage {
    id
    name
    signedUrl
  }
  clientVisibleTabs
}
    `;
export const PortfolioFdpLoginsAttributesFragmentDoc = gql`
    fragment portfolioFDPLoginsAttributes on PortfolioFDPLogins {
  id
  portfolioId
  fdpLoginId
  fdpWebsiteId
  fdpWebsite {
    id
    website
    financialDataProviderId
  }
  fdpLogin {
    id
    username
    financialDataProviderId
    financialDataProvider {
      id
      name
      fdpWebsites {
        id
        website
      }
    }
  }
  portfolio {
    id
    name
  }
}
    `;
export const ServiceProviderDocumentAttributesFragmentDoc = gql`
    fragment serviceProviderDocumentAttributes on ServiceProviderDocuments {
  id
  url
  name
  fileName
  fileType
  documentDate
  serviceProviderFirmId
  serviceProviderFirm {
    id
    name
  }
  documentTypeId
  documentType {
    id
    name
  }
  uploadedBy
  uploadedDate
}
    `;
export const ServiceProviderDocumentTypeAttributesFragmentDoc = gql`
    fragment serviceProviderDocumentTypeAttributes on ServiceProviderDocumentType {
  id
  name
}
    `;
export const ServiceProviderFirmAttributesFragmentDoc = gql`
    fragment serviceProviderFirmAttributes on ServiceProviderFirm {
  id
  name
  yearFounded
  tierLevel
  isEvaluating
  officeLocations {
    id
    isCorporate
    institution {
      id
      name
      address {
        id
        line1
        line2
        line3
        city
        stateEnumId
        otherState
        countryEnumId
        zipCode
        phone
        phone2
        fax
        fax2
        email
        state {
          name
        }
        country {
          name
        }
        city
      }
      institutionsInstitutionTypeEnumList {
        items {
          id
          institutionTypeEnum {
            id
            name
            displayOrder
          }
        }
      }
      institutionSelectionStatus {
        id
        name
        displayOrder
      }
    }
  }
}
    `;
export const ServiceProviderNotesAttributesFragmentDoc = gql`
    fragment serviceProviderNotesAttributes on ServiceProviderNotes {
  id
  isDeleted
  noteText
  eventDate
  providerNoteTypeEnumId
  createDate
  createUser
  providerId
  serviceProviderFirm {
    id
    name
  }
  providerNoteTypeEnum {
    id
    name
  }
}
    `;
export const SetAttributesFragmentDoc = gql`
    fragment setAttributes on Set {
  id
  setType
  name
  description
  expression
  expressionPg
  isBaseSet
  disabled
  subscriptionLevelEnumId
  givesAccess
}
    `;
export const SharedGroupEntityAttributesFragmentDoc = gql`
    fragment sharedGroupEntityAttributes on SharedGroupEntity {
  id
  sourceGroupId
  sourceGroup {
    id
    commonName
    userName
    organizationId
    organization {
      id
      name
    }
  }
  targetGroupId
  targetGroup {
    id
    commonName
    userName
    organizationId
    organization {
      id
      name
    }
  }
  entityId
  groupShareDefinitionId
  groupShareDefinition {
    id
    sourceGroupId
    targetGroupId
    dynamicDefinition
    entityAccessId
    isActive
    lastExecuted
    createDate
    modifyDate
    createUser
    modifyUser
  }
  createDate
  modifyDate
  createUser
  modifyUser
}
    `;
export const UserListAttributesFragmentDoc = gql`
    fragment userListAttributes on User {
  id
  userName
  commonName
  imageType
  imageTypeSm
  isGroup
  isUser
  organizationId
  email
  groupEntityType
  isPrimaryOrganizationGroup
  groups {
    id
    commonName
  }
  roles {
    id
    name
    description
  }
  organization {
    id
    name
  }
  sets {
    id
    name
  }
}
    `;
export const UserAttributesFragmentDoc = gql`
    fragment userAttributes on User {
  id
  userName
  commonName
  imageType
  imageTypeSm
  isGroup
  isUser
  organizationId
  email
  groupEntityType
  isPrimaryOrganizationGroup
  users {
    id
    commonName
  }
  userIds
  groups {
    id
    commonName
  }
  groupIds
  roles {
    id
    name
    description
  }
  roleIds
  organization {
    id
    name
  }
  oktaUser {
    id
    created
    activated
    lastLogin
    passwordChanged
    status
  }
  groupEntityType
  flags {
    ...flagAttributes
  }
}
    ${FlagAttributesFragmentDoc}`;
export const UsersXGroupsAttributesFragmentDoc = gql`
    fragment usersXGroupsAttributes on UsersXGroups {
  id
  userId
  groupId
  user {
    id
    commonName
    email
    roles {
      id
      name
    }
    sets {
      id
      name
    }
    organization {
      id
      name
    }
  }
  group {
    id
    commonName
    email
    roles {
      id
      name
    }
    sets {
      id
      name
    }
    organization {
      id
      name
    }
  }
}
    `;
export const ClientInvestmentFundsDocument = gql`
    query ClientInvestmentFunds {
  clientInvestmentFunds {
    rcgFundId
    name
    groupId
    groupName
    isCombined
  }
}
    `;
export const ClientInvestmentClientsDocument = gql`
    query ClientInvestmentClients($rcgFundId: Int) {
  clientInvestmentClients(rcgFundId: $rcgFundId) {
    clientId
    name
  }
}
    `;
export const ClientFeeOptionsDocument = gql`
    query ClientFeeOptions {
  clientFeeOptions {
    aum {
      id
      label
    }
    rate {
      id
      label
    }
    unit {
      id
      label
    }
  }
}
    `;
export const ClientShareClassesDocument = gql`
    query ClientShareClasses($rcgFundId: Int!, $clientId: Int) {
  clientShareClasses(rcgFundId: $rcgFundId, clientId: $clientId) {
    shareClassId
    name
    rcgFundId
    clientId
    unfunded
    feeAumOptionId
    feeRateOptionId
    feeUnitOptionId
    mgmtTiers {
      threshold
      rate
      isFlat
    }
    adminTiers {
      threshold
      rate
      isFlat
    }
    deletable
    derived
  }
}
    `;
export const ClientCapitalFlowsDocument = gql`
    query ClientCapitalFlows($rcgFundId: Int!, $clientId: Int!) {
  clientCapitalFlows(rcgFundId: $rcgFundId, clientId: $clientId) {
    shareClassId
    date
    addition
    redemption
    switchIn
    switchOut
  }
}
    `;
export const ClientSwitchesDocument = gql`
    query ClientSwitches($rcgFundId: Int!, $clientId: Int!) {
  clientSwitches(rcgFundId: $rcgFundId, clientId: $clientId) {
    fromShareClassId
    toShareClassId
    date
    amount
  }
}
    `;
export const ClientAllocationsDocument = gql`
    query ClientAllocations($rcgFundIds: [Int!], $shareClassId: Int, $month: Date, $withFlowsOnly: Boolean! = false) {
  clientAllocations(
    rcgFundIds: $rcgFundIds
    shareClassId: $shareClassId
    month: $month
    withFlowsOnly: $withFlowsOnly
  ) {
    shareClassId
    shareClassName
    rcgFundId
    rcgFundName
    clientId
    clientName
    derived
    date
    begBal
    addition
    redemption
    switchIn
    switchOut
    adjBegBal
    mgmtFeeRate
    mgmtFee
    adminFeeRate
    adminFee
    incentiveFee
    estGrossReturn
    estNetReturn
    estGrossEndBal
    estNetEndBal
    actGrossReturn
    actNetReturn
    actGrossEndBal
    actNetEndBal
    finalGrossReturn
    finalNetReturn
    effGrossReturn
    effNetReturn
    grossEndBal
    netEndBal
    pl
    enteredMgmtFee
    enteredAdminFee
    enteredIncentiveFee
  }
}
    `;
export const ClientInvestmentsAsyncTaskStatusDocument = gql`
    query ClientInvestmentsAsyncTaskStatus($id: ID!) {
  asyncTaskStatus(id: $id) {
    id
    endDate
    error
  }
}
    `;
export const SaveClientShareClassDocument = gql`
    mutation SaveClientShareClass($input: ClientShareClassInput!) {
  saveClientShareClass(input: $input)
}
    `;
export const DeleteClientShareClassDocument = gql`
    mutation DeleteClientShareClass($shareClassId: Int!) {
  deleteClientShareClass(shareClassId: $shareClassId)
}
    `;
export const SaveClientCashFlowDocument = gql`
    mutation SaveClientCashFlow($shareClassId: Int!, $month: Date!, $addition: Float, $redemption: Float) {
  saveClientCashFlow(
    shareClassId: $shareClassId
    month: $month
    addition: $addition
    redemption: $redemption
  )
}
    `;
export const SaveClientSwitchDocument = gql`
    mutation SaveClientSwitch($fromShareClassId: Int!, $toShareClassId: Int!, $month: Date!, $amount: Float!) {
  saveClientSwitch(
    fromShareClassId: $fromShareClassId
    toShareClassId: $toShareClassId
    month: $month
    amount: $amount
  )
}
    `;
export const SaveClientMonthEntriesDocument = gql`
    mutation SaveClientMonthEntries($month: Date!, $entries: [ClientMonthEntryInput!]!) {
  saveClientMonthEntries(month: $month, entries: $entries)
}
    `;
export const ImportClientPortfolioReturnsDocument = gql`
    mutation ImportClientPortfolioReturns($rcgFundIds: [Int!], $start: Date) {
  importClientPortfolioReturns(rcgFundIds: $rcgFundIds, start: $start) {
    id
    label
    startDate
  }
}
    `;
export const CompleteApplicationDocument = gql`
    mutation completeApplication($id: Int!, $input: CompanyInput!) {
  updateCompany(id: $id, input: $input) {
    id
    applicationCompletedAt
  }
}
    `;
export const GetApplicantCompanyDocument = gql`
    query getApplicantCompany {
  companyList {
    items {
      id
      name
      applicationCompletedAt
    }
  }
}
    `;
export const GetUploadUrlDocument = gql`
    query GetUploadUrl($id: ID!) {
  getDocumentQueueUploadUrl(id: $id)
}
    `;
export const RematchDocumentQueueEntitiesDocument = gql`
    mutation RematchDocumentQueueEntities($documentQueueIds: [ID!]!) {
  rematchDocumentQueueEntities(documentQueueIds: $documentQueueIds)
}
    `;
export const EarlyEstimatesDocument = gql`
    query EarlyEstimates($month: Date!) {
  earlyEstimates(month: $month) {
    rcgFundId
    name
    isEstimate
    systemGrossEndBal
    systemNetEndBal
    systemGrossReturn
    systemSpread
    netReturn
    grossEndBal
    netEndBal
    grossReturn
    spread
    version
  }
}
    `;
export const SaveEarlyEstimatesDocument = gql`
    mutation SaveEarlyEstimates($month: Date!, $estimates: [EarlyEstimateInput!]!) {
  saveEarlyEstimates(month: $month, estimates: $estimates)
}
    `;
export const GetOrganizationIconUploadUrlDocument = gql`
    query GetOrganizationIconUploadUrl($organizationId: Int!, $contentType: String!) {
  getOrganizationIconUploadUrl(
    organizationId: $organizationId
    contentType: $contentType
  )
}
    `;
export const ConfirmOrganizationIconUploadDocument = gql`
    mutation ConfirmOrganizationIconUpload($organizationId: Int!) {
  confirmOrganizationIconUpload(organizationId: $organizationId) {
    id
    smallIconUrl
  }
}
    `;
export const ReportRecipientsDocument = gql`
    query ReportRecipients {
  reportRecipients {
    reportId
    reportName
    recipients
  }
}
    `;
export const SaveReportRecipientDocument = gql`
    mutation SaveReportRecipient($input: ReportRecipientInput!) {
  saveReportRecipient(input: $input) {
    reportId
  }
}
    `;
export const DeleteReportRecipientDocument = gql`
    mutation DeleteReportRecipient($reportId: Int!) {
  deleteReportRecipient(reportId: $reportId)
}
    `;
export const GetListAccountTypeEnumDocument = gql`
    query getListAccountTypeEnum($page: PageInput, $sort: [AccountTypeEnumSort!]) {
  accountTypeEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneAccountTypeEnumDocument = gql`
    query getOneAccountTypeEnum($id: Int!) {
  accountTypeEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyAccountTypeEnumDocument = gql`
    query getManyAccountTypeEnum($ids: [Int!]!) {
  accountTypeEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListAdEntriesXApplicationFlagsDocument = gql`
    query getListAdEntriesXApplicationFlags($page: PageInput, $sort: [AdEntriesXApplicationFlagsSort!], $filter: AdEntriesXApplicationFlagsFilter) {
  adEntriesXApplicationFlagsList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...adEntriesXApplicationFlagsAttributes
    }
    total
  }
}
    ${AdEntriesXApplicationFlagsAttributesFragmentDoc}`;
export const GetOneAdEntriesXApplicationFlagsDocument = gql`
    query getOneAdEntriesXApplicationFlags($id: Int!) {
  adEntriesXApplicationFlags(id: $id) {
    ...adEntriesXApplicationFlagsAttributes
  }
}
    ${AdEntriesXApplicationFlagsAttributesFragmentDoc}`;
export const GetManyAdEntriesXApplicationFlagsDocument = gql`
    query getManyAdEntriesXApplicationFlags($ids: [Int!]!) {
  adEntriesXApplicationFlagsMany(ids: $ids) {
    ...adEntriesXApplicationFlagsAttributes
  }
}
    ${AdEntriesXApplicationFlagsAttributesFragmentDoc}`;
export const CreateAdEntriesXApplicationFlagsDocument = gql`
    mutation createAdEntriesXApplicationFlags($input: AdEntriesXApplicationFlagsInput!) {
  addAdEntriesXApplicationFlags(input: $input) {
    id
  }
}
    `;
export const UpdateAdEntriesXApplicationFlagsDocument = gql`
    mutation updateAdEntriesXApplicationFlags($id: Int!, $input: AdEntriesXApplicationFlagsInput!) {
  updateAdEntriesXApplicationFlags(id: $id, input: $input) {
    id
  }
}
    `;
export const DeleteAdEntriesXApplicationFlagsDocument = gql`
    mutation deleteAdEntriesXApplicationFlags($id: Int!) {
  deleteAdEntriesXApplicationFlags(id: $id)
}
    `;
export const GetListAdEntriesXApplicationsXSetsDocument = gql`
    query getListAdEntriesXApplicationsXSets($page: PageInput, $sort: [AdEntriesXApplicationsXSetsSort!], $filter: AdEntriesXApplicationsXSetsFilter) {
  adEntriesXApplicationsXSetsList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...adEntriesXApplicationsXSetsAttributes
    }
    total
  }
}
    ${AdEntriesXApplicationsXSetsAttributesFragmentDoc}`;
export const GetOneAdEntriesXApplicationsXSetsDocument = gql`
    query getOneAdEntriesXApplicationsXSets($id: Int!) {
  adEntriesXApplicationsXSets(id: $id) {
    ...adEntriesXApplicationsXSetsAttributes
  }
}
    ${AdEntriesXApplicationsXSetsAttributesFragmentDoc}`;
export const GetManyAdEntriesXApplicationsXSetsDocument = gql`
    query getManyAdEntriesXApplicationsXSets($ids: [Int!]!) {
  adEntriesXApplicationsXSetsMany(ids: $ids) {
    ...adEntriesXApplicationsXSetsAttributes
  }
}
    ${AdEntriesXApplicationsXSetsAttributesFragmentDoc}`;
export const CreateAdEntriesXApplicationsXSetsDocument = gql`
    mutation createAdEntriesXApplicationsXSets($input: AdEntriesXApplicationsXSetsInput!) {
  addAdEntriesXApplicationsXSets(input: $input) {
    id
  }
}
    `;
export const UpdateAdEntriesXApplicationsXSetsDocument = gql`
    mutation updateAdEntriesXApplicationsXSets($id: Int!, $input: AdEntriesXApplicationsXSetsInput!) {
  updateAdEntriesXApplicationsXSets(id: $id, input: $input) {
    id
  }
}
    `;
export const DeleteAdEntriesXApplicationsXSetsDocument = gql`
    mutation deleteAdEntriesXApplicationsXSets($id: Int!) {
  deleteAdEntriesXApplicationsXSets(id: $id)
}
    `;
export const GetListAdvisorTypeEnumDocument = gql`
    query getListAdvisorTypeEnum($page: PageInput, $sort: [AdvisorTypeEnumSort!]) {
  advisorTypeEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneAdvisorTypeEnumDocument = gql`
    query getOneAdvisorTypeEnum($id: Int!) {
  advisorTypeEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyAdvisorTypeEnumDocument = gql`
    query getManyAdvisorTypeEnum($ids: [Int!]!) {
  advisorTypeEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListAgencyDocument = gql`
    query getListAgency($page: PageInput, $sort: [AgencySort!]) {
  agencyList(page: $page, sort: $sort) {
    items {
      id
      name
      shortName
    }
    total
  }
}
    `;
export const GetOneAgencyDocument = gql`
    query getOneAgency($id: Int!) {
  agency(id: $id) {
    id
    name
    shortName
  }
}
    `;
export const GetManyAgencyDocument = gql`
    query getManyAgency($ids: [Int!]!) {
  agencyMany(ids: $ids) {
    id
    name
    shortName
  }
}
    `;
export const GetListApplicationDocument = gql`
    query getListApplication($page: PageInput, $sort: [ApplicationSort!], $filter: ApplicationFilter) {
  applicationList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...applicationAttributes
    }
    total
  }
}
    ${ApplicationAttributesFragmentDoc}`;
export const GetOneApplicationDocument = gql`
    query getOneApplication($id: Int!) {
  application(id: $id) {
    ...applicationAttributes
  }
}
    ${ApplicationAttributesFragmentDoc}`;
export const GetManyApplicationDocument = gql`
    query getManyApplication($ids: [Int!]!) {
  applicationMany(ids: $ids) {
    ...applicationAttributes
  }
}
    ${ApplicationAttributesFragmentDoc}`;
export const GetListApplicationFlagDocument = gql`
    query getListApplicationFlag($page: PageInput, $sort: [ApplicationFlagSort!], $filter: ApplicationFlagFilter) {
  applicationFlagList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      name
      description
      applicationId
    }
    total
  }
}
    `;
export const GetOneApplicationFlagDocument = gql`
    query getOneApplicationFlag($id: Int!) {
  applicationFlag(id: $id) {
    id
    name
    description
    applicationId
  }
}
    `;
export const GetManyApplicationFlagDocument = gql`
    query getManyApplicationFlag($ids: [Int!]!) {
  applicationFlagMany(ids: $ids) {
    id
    name
    description
    applicationId
  }
}
    `;
export const GetListAssetClass2EnumDocument = gql`
    query getListAssetClass2Enum($page: PageInput, $sort: [AssetClass2EnumSort!]) {
  assetClass2EnumList(page: $page, sort: $sort) {
    items {
      id
      name
      marketId
    }
    total
  }
}
    `;
export const GetListAssetClass2EnumOptionsDocument = gql`
    query getListAssetClass2EnumOptions($filter: TypeAssetClassStrategyOptionsFilterInput, $sort: [TypeAssetClassStrategyOptionsSort!]) {
  assetClassOptions(sort: $sort, filter: $filter) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneAssetClass2EnumDocument = gql`
    query getOneAssetClass2Enum($id: Int!) {
  assetClass2Enum(id: $id) {
    id
    name
    marketId
  }
}
    `;
export const GetManyAssetClass2EnumDocument = gql`
    query getManyAssetClass2Enum($ids: [Int!]!) {
  assetClass2EnumMany(ids: $ids) {
    id
    name
    marketId
  }
}
    `;
export const GetListMarketEnumDocument = gql`
    query getListMarketEnum($page: PageInput, $sort: [AssetClassEnumSort!]) {
  assetClassEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneMarketEnumDocument = gql`
    query getOneMarketEnum($id: Int!) {
  assetClassEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyMarketEnumDocument = gql`
    query getManyMarketEnum($ids: [Int!]!) {
  assetClassEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetOneAsyncTaskStatusDocument = gql`
    query getOneAsyncTaskStatus($id: ID!) {
  asyncTaskStatus(id: $id) {
    id
    startDate
    endDate
    error
  }
}
    `;
export const GetListAuditContactTypeEnumDocument = gql`
    query getListAuditContactTypeEnum($page: PageInput, $sort: [AuditContactTypeEnumSort!]) {
  auditContactTypeEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneAuditContactTypeEnumDocument = gql`
    query getOneAuditContactTypeEnum($id: Int!) {
  auditContactTypeEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyAuditContactTypeEnumDocument = gql`
    query getManyAuditContactTypeEnum($ids: [Int!]!) {
  auditContactTypeEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetOneInvestmentAumDocument = gql`
    query getOneInvestmentAum($investmentId: Int!) {
  investment(id: $investmentId) {
    id
    name
    inceptionDate
    firmId
    portalSubmitted {
      migratedAt
    }
    fdpLogins(filter: {includeFirmIfNoInvestment: true}) {
      id
      username
      password
      securityQuestion
      notes
      email
      mfaUser
      financialDataProvider {
        id
        name
        fdpWebsites {
          id
          website
        }
      }
    }
    firm {
      id
      name
      firmEmployments(
        filter: {contactTypeEnumIds: [2, 3]}
        page: {limit: 1, offset: 1}
        sort: [{field: personDefault, order: ASC}]
      ) {
        id
        person {
          id
          lastName
          firstName
          middleName
          email
          phone
        }
      }
      primaryAddress {
        id
        website
        webUserId
        webPassword
      }
    }
    assets(sort: [{field: asOfDate, order: DESC}]) {
      asOfDate
      firmAUM
      investmentAUM
      strategyAUM
      flow {
        strategy
        investment
      }
    }
  }
}
    `;
export const BulkUpdateAumDocument = gql`
    mutation bulkUpdateAUM($investmentId: Int!, $entries: [AumEntry!]!) {
  addOrUpdateAUM(investmentId: $investmentId, input: $entries) {
    items {
      asOfDate
      investmentAUM
      firmAUM
      strategyAUM
      flow {
        strategy
        investment
      }
    }
  }
}
    `;
export const GetListAxysCodeDocument = gql`
    query getListAxysCode($page: PageInput, $sort: [AxysCodeSort!], $filter: AxysCodeFilter) {
  axysCodeList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      code
    }
    total
  }
}
    `;
export const GetOneAxysCodeDocument = gql`
    query getOneAxysCode($id: Int!) {
  axysCode(id: $id) {
    id
    code
  }
}
    `;
export const GetManyAxysCodeDocument = gql`
    query getManyAxysCode($ids: [Int!]!) {
  axysCodeMany(ids: $ids) {
    id
    code
  }
}
    `;
export const GetListBusinessObjectEnumDocument = gql`
    query getListBusinessObjectEnum($page: PageInput, $sort: [BusinessObjectEnumSort!], $filter: BusinessObjectEnumFilter) {
  businessObjectEnumList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneBusinessObjectEnumDocument = gql`
    query getOneBusinessObjectEnum($id: Int!) {
  businessObjectEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyBusinessObjectEnumDocument = gql`
    query getManyBusinessObjectEnum($ids: [Int!]!) {
  businessObjectEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListCalendarUnitEnumDocument = gql`
    query getListCalendarUnitEnum($page: PageInput, $sort: [CalendarUnitEnumSort!]) {
  calendarUnitEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneCalendarUnitEnumDocument = gql`
    query getOneCalendarUnitEnum($id: Int!) {
  calendarUnitEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyCalendarUnitEnumDocument = gql`
    query getManyCalendarUnitEnum($ids: [Int!]!) {
  calendarUnitEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListClientDocument = gql`
    query getListClient($page: PageInput, $sort: [ClientSort!], $filter: ClientFilter) {
  clientList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...clientAttributes
    }
    total
  }
}
    ${ClientAttributesFragmentDoc}`;
export const GetOneClientDocument = gql`
    query getOneClient($id: ID!) {
  client(id: $id) {
    ...clientAttributes
  }
}
    ${ClientAttributesFragmentDoc}`;
export const GetManyClientDocument = gql`
    query getManyClient($ids: [ID!]!) {
  clientMany(ids: $ids) {
    ...clientAttributes
  }
}
    ${ClientAttributesFragmentDoc}`;
export const GetOneInvestmentCloseDatesDocument = gql`
    query getOneInvestmentCloseDates($investmentId: Int!) {
  investment(id: $investmentId) {
    id
    name
    closeDateFundSize {
      fundSize
      closeDate
    }
  }
}
    `;
export const UpdateInvestmentCloseDatesDocument = gql`
    mutation updateInvestmentCloseDates($investmentId: Int!, $closeDates: [CloseDateShort!]!) {
  addOrUpdateCloseDateSize(
    input: {investmentId: $investmentId, closeDates: $closeDates}
  ) {
    fundSize
    closeDate
  }
}
    `;
export const GetListCompanyDocument = gql`
    query getListCompany($page: PageInput, $sort: [CompanySort!], $filter: CompanyFilter) {
  companyList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...companyAttributes
    }
    total
  }
}
    ${CompanyAttributesFragmentDoc}`;
export const GetOneCompanyDocument = gql`
    query getOneCompany($id: Int!) {
  company(id: $id) {
    ...companyAttributes
  }
}
    ${CompanyAttributesFragmentDoc}`;
export const GetManyCompanyDocument = gql`
    query getManyCompany($ids: [Int!]!) {
  companyMany(ids: $ids) {
    ...companyAttributes
  }
}
    ${CompanyAttributesFragmentDoc}`;
export const CreateCompanyDocument = gql`
    mutation createCompany($input: CompanyInput!) {
  addCompany(input: $input) {
    id
  }
}
    `;
export const UpdateCompanyDocument = gql`
    mutation updateCompany($id: Int!, $input: CompanyInput!) {
  updateCompany(id: $id, input: $input) {
    id
  }
}
    `;
export const GetListCompanyEnumDocument = gql`
    query getListCompanyEnum($page: PageInput, $sort: [CompanyEnumSort!], $filter: CompanyEnumFilter) {
  companyEnumList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneCompanyEnumDocument = gql`
    query getOneCompanyEnum($id: Int!) {
  companyEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyCompanyEnumDocument = gql`
    query getManyCompanyEnum($ids: [Int!]!) {
  companyEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListCompanyTypeEnumDocument = gql`
    query getListCompanyTypeEnum($page: PageInput, $sort: [CompanyTypeEnumSort!]) {
  companyTypeEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneCompanyTypeEnumDocument = gql`
    query getOneCompanyTypeEnum($id: Int!) {
  companyTypeEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyCompanyTypeEnumDocument = gql`
    query getManyCompanyTypeEnum($ids: [Int!]!) {
  companyTypeEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListCompanyValuationDocument = gql`
    query getListCompanyValuation($page: PageInput, $sort: [CompanyValuationSort!], $filter: CompanyValuationFilter) {
  companyValuationList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...companyValuationAttributes
    }
    total
  }
}
    ${CompanyValuationAttributesFragmentDoc}`;
export const GetOneCompanyValuationDocument = gql`
    query getOneCompanyValuation($id: Int!) {
  companyValuation(id: $id) {
    ...companyValuationAttributes
  }
}
    ${CompanyValuationAttributesFragmentDoc}`;
export const GetManyCompanyValuationDocument = gql`
    query getManyCompanyValuation($ids: [Int!]!) {
  companyValuationMany(ids: $ids) {
    ...companyValuationAttributes
  }
}
    ${CompanyValuationAttributesFragmentDoc}`;
export const CreateCompanyValuationDocument = gql`
    mutation createCompanyValuation($input: CompanyValuationInput!) {
  addCompanyValuation(input: $input) {
    id
  }
}
    `;
export const UpdateCompanyValuationDocument = gql`
    mutation updateCompanyValuation($id: Int!, $input: CompanyValuationInput!) {
  updateCompanyValuation(id: $id, input: $input) {
    id
  }
}
    `;
export const DeleteCompanyValuationDocument = gql`
    mutation deleteCompanyValuation($id: Int!) {
  deleteCompanyValuation(id: $id)
}
    `;
export const GetListCompoundingPeriodEnumDocument = gql`
    query getListCompoundingPeriodEnum($page: PageInput, $sort: [CompoundingPeriodEnumSort!]) {
  compoundingPeriodEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneCompoundingPeriodEnumDocument = gql`
    query getOneCompoundingPeriodEnum($id: Int!) {
  compoundingPeriodEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyCompoundingPeriodEnumDocument = gql`
    query getManyCompoundingPeriodEnum($ids: [Int!]!) {
  compoundingPeriodEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListContactTypeEnumDocument = gql`
    query getListContactTypeEnum($page: PageInput, $sort: [ContactTypeEnumSort!]) {
  contactTypeEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneContactTypeEnumDocument = gql`
    query getOneContactTypeEnum($id: Int!) {
  contactTypeEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyContactTypeEnumDocument = gql`
    query getManyContactTypeEnum($ids: [Int!]!) {
  contactTypeEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListCountryEnumDocument = gql`
    query getListCountryEnum($page: PageInput, $sort: [CountryEnumSort!], $filter: CountryEnumFilter) {
  countryEnumList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneCountryEnumDocument = gql`
    query getOneCountryEnum($id: Int!) {
  countryEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyCountryEnumDocument = gql`
    query getManyCountryEnum($ids: [Int!]!) {
  countryEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListCurrencyDenominationEnumDocument = gql`
    query getListCurrencyDenominationEnum($page: PageInput, $sort: [CurrencyDenominationEnumSort!], $filter: CurrencyDenominationEnumFilter) {
  currencyDenominationEnumList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneCurrencyDenominationEnumDocument = gql`
    query getOneCurrencyDenominationEnum($id: Int!) {
  currencyDenominationEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyCurrencyDenominationEnumDocument = gql`
    query getManyCurrencyDenominationEnum($ids: [Int!]!) {
  currencyDenominationEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetOneCurrentUserDocument = gql`
    query getOneCurrentUser {
  currentUser {
    ...currentUserAttributes
  }
}
    ${CurrentUserAttributesFragmentDoc}`;
export const UpdateAssumeUserDocument = gql`
    mutation updateAssumeUser($input: AssumeUserInput!) {
  addOrUpdateAssumeUser(input: $input)
}
    `;
export const DeleteAssumeUserDocument = gql`
    mutation deleteAssumeUser {
  deleteAssumeUser
}
    `;
export const GetListCustomAnalyticsDocument = gql`
    query getListCustomAnalytics($page: PageInput, $sort: [CustomAnalyticsSort!], $filter: CustomAnalyticsFilter) {
  customAnalyticsList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...customAnalyticsAttributes
    }
    total
  }
}
    ${CustomAnalyticsAttributesFragmentDoc}`;
export const GetOneCustomAnalyticsDocument = gql`
    query getOneCustomAnalytics($id: String!) {
  customAnalytics(id: $id) {
    ...customAnalyticsAttributes
  }
}
    ${CustomAnalyticsAttributesFragmentDoc}`;
export const CreateCustomAnalyticsDocument = gql`
    mutation createCustomAnalytics($input: CustomAnalyticsInput!) {
  addCustomAnalytics(input: $input) {
    id
  }
}
    `;
export const UpdateCustomAnalyticsDocument = gql`
    mutation updateCustomAnalytics($id: String!, $input: CustomAnalyticsInput!) {
  updateCustomAnalytics(id: $id, input: $input) {
    id
  }
}
    `;
export const GetListCustomIndexInvestmentDocument = gql`
    query getListCustomIndexInvestment($page: PageInput, $sort: [CustomIndexInvestmentSort!], $filter: CustomIndexInvestmentFilter) {
  customIndexInvestmentList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...customIndexInvestmentAttributes
    }
    total
  }
}
    ${CustomIndexInvestmentAttributesFragmentDoc}`;
export const GetOneCustomIndexInvestmentDocument = gql`
    query getOneCustomIndexInvestment($id: Int!) {
  customIndexInvestment(id: $id) {
    ...customIndexInvestmentAttributes
    groups {
      items {
        ...customIndexGroupAttributes
      }
    }
  }
}
    ${CustomIndexInvestmentAttributesFragmentDoc}
${CustomIndexGroupAttributesFragmentDoc}`;
export const GetManyCustomIndexInvestmentDocument = gql`
    query getManyCustomIndexInvestment($ids: [Int!]!) {
  customIndexInvestmentMany(ids: $ids) {
    ...customIndexInvestmentAttributes
    groups {
      items {
        ...customIndexGroupAttributes
      }
    }
  }
}
    ${CustomIndexInvestmentAttributesFragmentDoc}
${CustomIndexGroupAttributesFragmentDoc}`;
export const CreateCustomIndexInvestmentDocument = gql`
    mutation createCustomIndexInvestment($input: CustomIndexInvestmentInput!) {
  addCustomIndexInvestment(input: $input) {
    id
  }
}
    `;
export const UpdateCustomIndexInvestmentDocument = gql`
    mutation updateCustomIndexInvestment($id: Int!, $input: CustomIndexInvestmentInput!) {
  updateCustomIndexInvestment(id: $id, input: $input) {
    id
  }
}
    `;
export const GetOneCustomIndexPreviewDocument = gql`
    query getOneCustomIndexPreview($input: CustomIndexInvestmentInput!) {
  customIndexPreview(input: $input) {
    ...customIndexPreviewAttributes
  }
}
    ${CustomIndexPreviewAttributesFragmentDoc}`;
export const GetOneDataLinksDocument = gql`
    query getOneDataLinks($id: Int!) {
  investment(id: $id) {
    id
    name
    inceptionDate
    vintageYear
    firmId
    portalSubmitted {
      migratedAt
    }
    firm {
      id
      name
    }
    cogencyLink {
      ...cogencyLinkAttributes
    }
  }
}
    ${CogencyLinkAttributesFragmentDoc}`;
export const AddOrUpdateCogencyLinkDocument = gql`
    mutation addOrUpdateCogencyLink($id: Int!, $input: CogencyLinkInput!) {
  addOrUpdateCogencyLink(id: $id, input: $input) {
    id
  }
}
    `;
export const GetListDealDocument = gql`
    query getListDeal($page: PageInput, $sort: [DealSort!], $filter: DealFilter) {
  dealList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...dealAttributes
    }
    total
  }
}
    ${DealAttributesFragmentDoc}`;
export const GetOneDealDocument = gql`
    query getOneDeal($id: Int!) {
  deal(id: $id) {
    ...dealAttributes
  }
}
    ${DealAttributesFragmentDoc}`;
export const GetManyDealDocument = gql`
    query getManyDeal($ids: [Int!]!) {
  dealMany(ids: $ids) {
    ...dealAttributes
  }
}
    ${DealAttributesFragmentDoc}`;
export const CreateDealDocument = gql`
    mutation createDeal($input: DealInput!) {
  addDeal(input: $input) {
    ...dealAttributes
  }
}
    ${DealAttributesFragmentDoc}`;
export const UpdateDealDocument = gql`
    mutation updateDeal($id: Int!, $input: DealInput!) {
  updateDeal(id: $id, input: $input) {
    ...dealAttributes
  }
}
    ${DealAttributesFragmentDoc}`;
export const GetListDealFilterOptionsDocument = gql`
    query getListDealFilterOptions($filter: DealFilter) {
  dealAvailableFilterOptions(filter: $filter) {
    headQuarterOptions {
      id
      name
    }
    rcSourceOptions
    fundingTypeOptions {
      id
      name
    }
    dealStructureOptions {
      id
      name
    }
    stageOptions {
      id
      name
      displayOrder
    }
    dealMarketingOptions {
      id
      name
      displayOrder
    }
    resultOptions {
      id
      name
    }
    assetClassOptions {
      id
      name
    }
  }
}
    `;
export const GetListDealMarketingEnumDocument = gql`
    query getListDealMarketingEnum($page: PageInput, $sort: [DealMarketingEnumSort!]) {
  dealMarketingEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneDealMarketingEnumDocument = gql`
    query getOneDealMarketingEnum($id: Int!) {
  dealMarketingEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyDealMarketingEnumDocument = gql`
    query getManyDealMarketingEnum($ids: [Int!]!) {
  dealMarketingEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListDealStructureEnumDocument = gql`
    query getListDealStructureEnum($page: PageInput, $sort: [DealStructureEnumSort!]) {
  dealStructureEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneDealStructureEnumDocument = gql`
    query getOneDealStructureEnum($id: Int!) {
  dealStructureEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyDealStructureEnumDocument = gql`
    query getManyDealStructureEnum($ids: [Int!]!) {
  dealStructureEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListDegreeEnumDocument = gql`
    query getListDegreeEnum($page: PageInput, $sort: [DegreeEnumSort!]) {
  degreeEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneDegreeEnumDocument = gql`
    query getOneDegreeEnum($id: Int!) {
  degreeEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyDegreeEnumDocument = gql`
    query getManyDegreeEnum($ids: [Int!]!) {
  degreeEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListDeiCategory1EnumDocument = gql`
    query getListDeiCategory1Enum($page: PageInput, $sort: [DeiCategory1EnumSort!]) {
  deiCategory1EnumList(page: $page, sort: $sort) {
    items {
      id
      description
    }
    total
  }
}
    `;
export const GetOneDeiCategory1EnumDocument = gql`
    query getOneDeiCategory1Enum($id: Int!) {
  deiCategory1Enum(id: $id) {
    id
    description
  }
}
    `;
export const GetManyDeiCategory1EnumDocument = gql`
    query getManyDeiCategory1Enum($ids: [Int!]!) {
  deiCategory1EnumMany(ids: $ids) {
    id
    description
  }
}
    `;
export const GetListDeiCategory2EnumDocument = gql`
    query getListDeiCategory2Enum($page: PageInput, $sort: [DeiCategory2EnumSort!]) {
  deiCategory2EnumList(page: $page, sort: $sort) {
    items {
      id
      description
    }
    total
  }
}
    `;
export const GetOneDeiCategory2EnumDocument = gql`
    query getOneDeiCategory2Enum($id: Int!) {
  deiCategory2Enum(id: $id) {
    id
    description
  }
}
    `;
export const GetManyDeiCategory2EnumDocument = gql`
    query getManyDeiCategory2Enum($ids: [Int!]!) {
  deiCategory2EnumMany(ids: $ids) {
    id
    description
  }
}
    `;
export const GetListDiversityStatsEnumDocument = gql`
    query getListDiversityStatsEnum($page: PageInput, $sort: [DiversityStatsEnumSort!]) {
  diversityStatsEnumList(page: $page, sort: $sort) {
    items {
      id
      value
    }
    total
  }
}
    `;
export const GetOneDiversityStatsEnumDocument = gql`
    query getOneDiversityStatsEnum($id: Int!) {
  diversityStatsEnum(id: $id) {
    id
    value
  }
}
    `;
export const GetManyDiversityStatsEnumDocument = gql`
    query getManyDiversityStatsEnum($ids: [Int!]!) {
  diversityStatsEnumMany(ids: $ids) {
    id
    value
  }
}
    `;
export const GetDocumentsListDocument = gql`
    query getDocumentsList($filter: DocumentFilter, $page: PageInput, $sort: [DocumentSort!]) {
  documents(filter: $filter, page: $page, sort: $sort) {
    items {
      ...documentAttributes
    }
    total
  }
}
    ${DocumentAttributesFragmentDoc}`;
export const GetOneDocumentDocument = gql`
    query getOneDocument($id: Int!) {
  document(id: $id) {
    ...documentAttributes
  }
}
    ${DocumentAttributesFragmentDoc}`;
export const UpdateDocumentDocument = gql`
    mutation updateDocument($id: Int!, $file: Upload, $documentTypeEnumId: Int, $date: Date, $accessLevel: Int, $isGallery: Boolean, $isApproved: Boolean, $notifyUsers: Boolean, $entities: [EntityAssociationInput!], $allowDuplicateFile: Boolean) {
  updateDocument(
    id: $id
    input: {file: $file, documentTypeEnumId: $documentTypeEnumId, date: $date, accessLevel: $accessLevel, isGallery: $isGallery, isApproved: $isApproved, notifyUsers: $notifyUsers, entities: $entities, allowDuplicateFile: $allowDuplicateFile}
  ) {
    id
  }
}
    `;
export const AddDocumentDocument = gql`
    mutation addDocument($file: Upload!, $documentTypeEnumId: Int!, $date: Date!, $accessLevel: Int, $isGallery: Boolean, $isApproved: Boolean, $notifyUsers: Boolean, $entities: [EntityAssociationInput!], $allowDuplicateFile: Boolean) {
  addDocument(
    input: {file: $file, documentTypeEnumId: $documentTypeEnumId, date: $date, accessLevel: $accessLevel, isGallery: $isGallery, isApproved: $isApproved, notifyUsers: $notifyUsers, entities: $entities, allowDuplicateFile: $allowDuplicateFile}
  ) {
    id
  }
}
    `;
export const DeleteDocumentDocument = gql`
    mutation deleteDocument($id: Int!) {
  deleteDocument(id: $id)
}
    `;
export const GetListDocumentAccessLevelDocument = gql`
    query getListDocumentAccessLevel($page: PageInput, $sort: [DocumentAccessLevelSort!]) {
  documentAccessLevelList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneDocumentAccessLevelDocument = gql`
    query getOneDocumentAccessLevel($id: Int!) {
  documentAccessLevel(id: $id) {
    id
    name
  }
}
    `;
export const GetManyDocumentAccessLevelDocument = gql`
    query getManyDocumentAccessLevel($ids: [Int!]!) {
  documentAccessLevelMany(ids: $ids) {
    id
    name
  }
}
    `;
export const AddDocumentQueueSignedUriDocument = gql`
    mutation addDocumentQueueSignedURI($names: [String!]!) {
  addDocumentQueueSignedURI(names: $names) {
    url
    documentQueueId: id
  }
}
    `;
export const ProcessDocumentQueueDocument = gql`
    mutation processDocumentQueue($queueId: ID!) {
  processDocumentQueue(documentQueueId: $queueId)
}
    `;
export const PublishDocumentQueuesDocument = gql`
    mutation publishDocumentQueues($input: [DocumentQueuePublishInput!]!) {
  publishDocumentQueues(input: $input) {
    documentQueueId
    success
    documentId
    documentName
    error
  }
}
    `;
export const GetDocumentQueueListDocument = gql`
    query GetDocumentQueueList($filter: DocumentQueueFilter, $sort: [DocumentQueueSort!], $page: PageInput) {
  documentQueueList(filter: $filter, sort: $sort, page: $page) {
    items {
      id
      name
      userId
      queueDate
      documentsId
      s3Bucket
      s3Key
      duplicateDocuments {
        id
      }
      hash
      llmEntityId
      llmEntityNotes
      llmEntityTypeId
      llmEntityTypeNotes
      llmAsOfDate
      llmAsOfDateNotes
      llmDocumentTypeEnumId
      llmDocumentTypeEnumNotes
      llmSuggestedName
      llmSuggestedNameNotes
      llmProcessedAt
      emailMaps {
        id
        emailMetadata {
          subject
          id
          fromAddress
          toAddress
          receivedDate
        }
      }
    }
    total
  }
}
    `;
export const GetOneDocumentQueueDocument = gql`
    query GetOneDocumentQueue($id: ID!) {
  documentQueue(id: $id) {
    id
    name
    userId
    queueDate
    documentsId
    hash
    llmEntityId
    llmEntityNotes
    llmEntityTypeId
    llmEntityTypeNotes
    llmAsOfDate
    llmAsOfDateNotes
    llmDocumentTypeEnumId
    llmDocumentTypeEnumNotes
    llmSuggestedName
    llmSuggestedNameNotes
    llmProcessedAt
    emailMaps {
      id
      emailMetadata {
        subject
        id
        fromAddress
        toAddress
      }
    }
  }
}
    `;
export const TransferToDocumentsDocument = gql`
    mutation TransferToDocuments($input: [DocumentQueuePublishInput!]!) {
  publishDocumentQueues(input: $input) {
    documentQueueId
    success
    documentId
    error
  }
}
    `;
export const DeleteDocumentQueueDocument = gql`
    mutation DeleteDocumentQueue($id: ID!) {
  deleteDocumentQueue(id: $id)
}
    `;
export const GetDocumentTypeEnumListDocument = gql`
    query getDocumentTypeEnumList($sort: [DocumentTypeEnumSort!], $filter: DocumentTypeEnumFilter) {
  documentTypeEnumList(sort: $sort, filter: $filter) {
    items {
      id
      name
      documentCategoryEnumId
    }
    total
  }
}
    `;
export const GetDocumentTypeEnumDocument = gql`
    query getDocumentTypeEnum($id: Int!) {
  documentTypeEnum(id: $id) {
    id
    name
    documentCategoryEnumId
  }
}
    `;
export const DocumentTypeSuggestionDocument = gql`
    query documentTypeSuggestion($text: String!) {
  documentTypeSuggestion(text: $text)
}
    `;
export const GetListEmailDomainXOrganizationDocument = gql`
    query getListEmailDomainXOrganization($page: PageInput, $sort: [EmailDomainXOrganizationSort!], $filter: EmailDomainXOrganizationFilter) {
  emailDomainXOrganizationList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...emailDomainXOrganizationAttributes
    }
    total
  }
}
    ${EmailDomainXOrganizationAttributesFragmentDoc}`;
export const GetOneEmailDomainXOrganizationDocument = gql`
    query getOneEmailDomainXOrganization($id: Int!) {
  emailDomainXOrganization(id: $id) {
    ...emailDomainXOrganizationAttributes
  }
}
    ${EmailDomainXOrganizationAttributesFragmentDoc}`;
export const GetManyEmailDomainXOrganizationDocument = gql`
    query getManyEmailDomainXOrganization($ids: [Int!]!) {
  emailDomainXOrganizationMany(ids: $ids) {
    ...emailDomainXOrganizationAttributes
  }
}
    ${EmailDomainXOrganizationAttributesFragmentDoc}`;
export const CreateEmailDomainXOrganizationDocument = gql`
    mutation createEmailDomainXOrganization($input: EmailDomainXOrganizationInput!) {
  addEmailDomainXOrganization(input: $input) {
    ...emailDomainXOrganizationAttributes
  }
}
    ${EmailDomainXOrganizationAttributesFragmentDoc}`;
export const UpdateEmailDomainXOrganizationDocument = gql`
    mutation updateEmailDomainXOrganization($id: Int!, $input: EmailDomainXOrganizationInput!) {
  updateEmailDomainXOrganization(id: $id, input: $input) {
    ...emailDomainXOrganizationAttributes
  }
}
    ${EmailDomainXOrganizationAttributesFragmentDoc}`;
export const DeleteEmailDomainXOrganizationDocument = gql`
    mutation deleteEmailDomainXOrganization($id: Int!) {
  deleteEmailDomainXOrganization(id: $id)
}
    `;
export const GetListEmployeeRoleEnumDocument = gql`
    query getListEmployeeRoleEnum($page: PageInput, $sort: [EmployeeRoleEnumSort!], $filter: EmployeeRoleEnumFilter) {
  employeeRoleEnumList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneEmployeeRoleEnumDocument = gql`
    query getOneEmployeeRoleEnum($id: Int!) {
  employeeRoleEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyEmployeeRoleEnumDocument = gql`
    query getManyEmployeeRoleEnum($ids: [Int!]!) {
  employeeRoleEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListFamilyDocument = gql`
    query getListFamily($page: PageInput, $sort: [FamilySort!], $filter: FamilyFilterInput) {
  familyList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      name
      firmId
      firm {
        id
        name
      }
      investmentsFamily {
        id
        familyId
        family {
          id
          name
          firmId
        }
        investmentId
        investment {
          id
          name
          firmId
        }
      }
    }
    total
  }
}
    `;
export const GetOneFamilyDocument = gql`
    query getOneFamily($id: Int!) {
  family(id: $id) {
    id
    name
    firmId
    firm {
      id
      name
    }
    investmentsFamily {
      id
      familyId
      family {
        id
        name
        firmId
      }
      investmentId
      investment {
        id
        name
        firmId
      }
    }
  }
}
    `;
export const GetManyFamilyDocument = gql`
    query getManyFamily($ids: [Int!]!) {
  familyMany(ids: $ids) {
    id
    name
    firmId
    firm {
      id
      name
    }
    investmentsFamily {
      id
      familyId
      family {
        id
        name
        firmId
      }
      investmentId
      investment {
        id
        name
        firmId
      }
    }
  }
}
    `;
export const GetManyReferenceFamilyDocument = gql`
    query getManyReferenceFamily($page: PageInput, $sort: [FamilySort!], $filter: FamilyFilterInput) {
  familyList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      name
      firmId
      firm {
        id
        name
      }
      investmentsFamily {
        id
        familyId
        family {
          id
          name
          firmId
        }
        investmentId
        investment {
          id
          name
          firmId
        }
      }
    }
    total
  }
}
    `;
export const CreateFamilyDocument = gql`
    mutation createFamily($input: FamilyInput!) {
  addFamily(input: $input) {
    id
  }
}
    `;
export const UpdateFamilyDocument = gql`
    mutation updateFamily($id: Int!, $input: FamilyInput!) {
  updateFamily(id: $id, input: $input) {
    id
  }
}
    `;
export const GetListFdpLoginDocument = gql`
    query getListFdpLogin($page: PageInput, $sort: [FDPLoginSort!], $filter: FDPLoginFilter) {
  fdpLoginList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...fdpLoginAttributes
    }
    total
  }
}
    ${FdpLoginAttributesFragmentDoc}`;
export const GetOneFdpLoginDocument = gql`
    query getOneFdpLogin($id: Int!) {
  fdpLogin(id: $id) {
    ...fdpLoginAttributes
  }
}
    ${FdpLoginAttributesFragmentDoc}`;
export const GetManyFdpLoginDocument = gql`
    query getManyFdpLogin($ids: [Int!]!) {
  fdpLoginMany(ids: $ids) {
    ...fdpLoginAttributes
  }
}
    ${FdpLoginAttributesFragmentDoc}`;
export const CreateFdpLoginDocument = gql`
    mutation createFdpLogin($input: FDPLoginInput!) {
  addFdpLogin(input: $input) {
    id
  }
}
    `;
export const UpdateFdpLoginDocument = gql`
    mutation updateFdpLogin($id: Int!, $input: FDPLoginInput!) {
  updateFdpLogin(id: $id, input: $input) {
    id
  }
}
    `;
export const DeleteFdpLoginDocument = gql`
    mutation deleteFdpLogin($id: Int!) {
  deleteFdpLogin(id: $id)
}
    `;
export const GetListFdpLoginAuthenticatorEnumDocument = gql`
    query getListFdpLoginAuthenticatorEnum($page: PageInput, $sort: [FDPLoginAuthenticatorEnumSort!]) {
  fdpLoginAuthenticatorEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneFdpLoginAuthenticatorEnumDocument = gql`
    query getOneFdpLoginAuthenticatorEnum($id: Int!) {
  fdpLoginAuthenticatorEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyFdpLoginAuthenticatorEnumDocument = gql`
    query getManyFdpLoginAuthenticatorEnum($ids: [Int!]!) {
  fdpLoginAuthenticatorEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListFdpWebsitesDocument = gql`
    query getListFdpWebsites($page: PageInput, $sort: [FDPWebsitesSort!], $filter: FDPWebsitesFilter) {
  fdpWebsitesList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...fdpWebsitesAttributes
    }
    total
  }
}
    ${FdpWebsitesAttributesFragmentDoc}`;
export const GetOneFdpWebsitesDocument = gql`
    query getOneFdpWebsites($id: Int!) {
  fdpWebsites(id: $id) {
    ...fdpWebsitesAttributes
  }
}
    ${FdpWebsitesAttributesFragmentDoc}`;
export const GetManyFdpWebsitesDocument = gql`
    query getManyFdpWebsites($ids: [Int!]!) {
  fdpWebsitesMany(ids: $ids) {
    ...fdpWebsitesAttributes
  }
}
    ${FdpWebsitesAttributesFragmentDoc}`;
export const CreateFdpWebsitesDocument = gql`
    mutation createFdpWebsites($input: FDPWebsitesInput!) {
  addFdpWebsites(input: $input) {
    id
  }
}
    `;
export const UpdateFdpWebsitesDocument = gql`
    mutation updateFdpWebsites($id: Int!, $input: FDPWebsitesInput!) {
  updateFdpWebsites(id: $id, input: $input) {
    id
  }
}
    `;
export const DeleteFdpWebsitesDocument = gql`
    mutation deleteFdpWebsites($id: Int!) {
  deleteFdpWebsites(id: $id)
}
    `;
export const GetListFeeCalcEnumDocument = gql`
    query getListFeeCalcEnum($page: PageInput, $sort: [FeeCalcEnumSort!]) {
  feeCalcEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneFeeCalcEnumDocument = gql`
    query getOneFeeCalcEnum($id: Int!) {
  feeCalcEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyFeeCalcEnumDocument = gql`
    query getManyFeeCalcEnum($ids: [Int!]!) {
  feeCalcEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListFeeFreqEnumDocument = gql`
    query getListFeeFreqEnum($page: PageInput, $sort: [FeeFreqEnumSort!]) {
  feeFreqEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneFeeFreqEnumDocument = gql`
    query getOneFeeFreqEnum($id: Int!) {
  feeFreqEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyFeeFreqEnumDocument = gql`
    query getManyFeeFreqEnum($ids: [Int!]!) {
  feeFreqEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListFinancialDataProviderDocument = gql`
    query getListFinancialDataProvider($page: PageInput, $sort: [FinancialDataProviderSort!], $filter: FinancialDataProviderFilter) {
  financialDataProviderList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...financialDataProviderAttributes
    }
    total
  }
}
    ${FinancialDataProviderAttributesFragmentDoc}`;
export const GetOneFinancialDataProviderDocument = gql`
    query getOneFinancialDataProvider($id: Int!) {
  financialDataProvider(id: $id) {
    ...financialDataProviderAttributes
  }
}
    ${FinancialDataProviderAttributesFragmentDoc}`;
export const GetManyFinancialDataProviderDocument = gql`
    query getManyFinancialDataProvider($ids: [Int!]!) {
  financialDataProviderMany(ids: $ids) {
    ...financialDataProviderAttributes
  }
}
    ${FinancialDataProviderAttributesFragmentDoc}`;
export const CreateFinancialDataProviderDocument = gql`
    mutation createFinancialDataProvider($input: FinancialDataProviderInput!) {
  addFinancialDataProvider(input: $input) {
    id
  }
}
    `;
export const UpdateFinancialDataProviderDocument = gql`
    mutation updateFinancialDataProvider($id: Int!, $input: FinancialDataProviderInput!) {
  updateFinancialDataProvider(id: $id, input: $input) {
    id
  }
}
    `;
export const GetListFinancialPeriodEnumDocument = gql`
    query getListFinancialPeriodEnum($page: PageInput, $sort: [FinancialPeriodEnumSort!]) {
  financialPeriodEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneFinancialPeriodEnumDocument = gql`
    query getOneFinancialPeriodEnum($id: Int!) {
  financialPeriodEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyFinancialPeriodEnumDocument = gql`
    query getManyFinancialPeriodEnum($ids: [Int!]!) {
  financialPeriodEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListFirmDocument = gql`
    query getListFirm($page: PageInput, $sort: [FirmSort!], $filter: FirmFilterInput, $searchFilters: [FirmSearchFilters!]) {
  firmList(
    page: $page
    sort: $sort
    filter: $filter
    firmSearchFilters: $searchFilters
  ) {
    items {
      ...firmAttributes
    }
    total
  }
}
    ${FirmAttributesFragmentDoc}`;
export const GetOneFirmDocument = gql`
    query getOneFirm($id: Int!) {
  firm(id: $id) {
    ...firmAttributes
  }
}
    ${FirmAttributesFragmentDoc}`;
export const GetManyFirmDocument = gql`
    query getManyFirm($ids: [Int!]!) {
  firmMany(ids: $ids) {
    ...firmAttributes
  }
}
    ${FirmAttributesFragmentDoc}`;
export const CreateFirmDocument = gql`
    mutation createFirm($input: FirmInput!) {
  addFirm(input: $input) {
    ...firmAttributes
  }
}
    ${FirmAttributesFragmentDoc}`;
export const UpdateFirmDocument = gql`
    mutation updateFirm($id: Int!, $input: FirmInput!) {
  updateFirm(id: $id, input: $input) {
    ...firmAttributes
  }
}
    ${FirmAttributesFragmentDoc}`;
export const DeleteFirmDocument = gql`
    mutation deleteFirm($id: ID!) {
  deleteFirm(id: $id)
}
    `;
export const GetListFirmDeiDocument = gql`
    query getListFirmDEI($page: PageInput, $sort: [FirmDEISort!], $filter: FirmDEIFilter) {
  firmDEIList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...firmDEIAttributes
    }
    total
  }
}
    ${FirmDeiAttributesFragmentDoc}`;
export const GetOneFirmDeiDocument = gql`
    query getOneFirmDEI($id: Int!) {
  firmDEI(id: $id) {
    ...firmDEIAttributes
  }
}
    ${FirmDeiAttributesFragmentDoc}`;
export const GetManyFirmDeiDocument = gql`
    query getManyFirmDEI($ids: [Int!]!) {
  firmDEIMany(ids: $ids) {
    ...firmDEIAttributes
  }
}
    ${FirmDeiAttributesFragmentDoc}`;
export const AddOrUpdateFirmDeiDocument = gql`
    mutation addOrUpdateFirmDEI($input: FirmDEICreateOrUpdate!) {
  createOrUpdateFirmDEI(input: $input) {
    ...firmDEIAttributes
  }
}
    ${FirmDeiAttributesFragmentDoc}`;
export const DeleteFirmDeiDocument = gql`
    mutation deleteFirmDei($id: ID!) {
  deleteFirmDei(id: $id)
}
    `;
export const GetListFirmEmploymentDocument = gql`
    query getListFirmEmployment($page: PageInput, $sort: [FirmEmploymentSort!], $filter: FirmEmploymentFilterInput) {
  firmEmploymentList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...firmEmploymentAttributes
    }
    total
  }
}
    ${FirmEmploymentAttributesFragmentDoc}`;
export const GetOneFirmEmploymentDocument = gql`
    query getOneFirmEmployment($id: Int!) {
  firmEmployment(id: $id) {
    ...firmEmploymentAttributes
  }
}
    ${FirmEmploymentAttributesFragmentDoc}`;
export const GetManyFirmEmploymentDocument = gql`
    query getManyFirmEmployment($ids: [Int!]!) {
  firmEmploymentMany(ids: $ids) {
    ...firmEmploymentAttributes
  }
}
    ${FirmEmploymentAttributesFragmentDoc}`;
export const GetManyReferenceFirmEmploymentDocument = gql`
    query getManyReferenceFirmEmployment($page: PageInput, $sort: [FirmEmploymentSort!], $filter: FirmEmploymentFilterInput) {
  firmEmploymentList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...firmEmploymentAttributes
    }
    total
  }
}
    ${FirmEmploymentAttributesFragmentDoc}`;
export const CreateFirmEmploymentDocument = gql`
    mutation createFirmEmployment($input: FirmEmploymentInput!) {
  addFirmEmployment(input: $input) {
    ...firmEmploymentAttributes
  }
}
    ${FirmEmploymentAttributesFragmentDoc}`;
export const UpdateFirmEmploymentDocument = gql`
    mutation updateFirmEmployment($id: Int!, $input: FirmEmploymentInput!) {
  updateFirmEmployment(id: $id, input: $input) {
    ...firmEmploymentAttributes
  }
}
    ${FirmEmploymentAttributesFragmentDoc}`;
export const DeleteFirmEmploymentDocument = gql`
    mutation deleteFirmEmployment($id: Int!) {
  deleteFirmEmployment(id: $id)
}
    `;
export const GetListFirmFdpLoginsDocument = gql`
    query getListFirmFDPLogins($page: PageInput, $sort: [FirmFDPLoginsSort!], $filter: FirmFDPLoginsFilter) {
  firmFDPLoginsList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...firmFDPLoginsAttributes
    }
    total
  }
}
    ${FirmFdpLoginsAttributesFragmentDoc}`;
export const GetOneFirmFdpLoginsDocument = gql`
    query getOneFirmFDPLogins($id: Int!) {
  firmFDPLogins(id: $id) {
    ...firmFDPLoginsAttributes
  }
}
    ${FirmFdpLoginsAttributesFragmentDoc}`;
export const GetManyFirmFdpLoginsDocument = gql`
    query getManyFirmFDPLogins($ids: [Int!]!) {
  firmFDPLoginsMany(ids: $ids) {
    ...firmFDPLoginsAttributes
  }
}
    ${FirmFdpLoginsAttributesFragmentDoc}`;
export const CreateFirmFdpLoginsDocument = gql`
    mutation createFirmFDPLogins($input: FirmFDPLoginsInput!) {
  addFirmFDPLogins(input: $input) {
    id
  }
}
    `;
export const UpdateFirmFdpLoginsDocument = gql`
    mutation updateFirmFDPLogins($id: Int!, $input: FirmFDPLoginsInput!) {
  updateFirmFDPLogins(id: $id, input: $input) {
    id
  }
}
    `;
export const GetListFirmInstitutionsDocument = gql`
    query getListFirmInstitutions($page: PageInput, $sort: [FirmInstitutionsSort!], $filter: FirmInstitutionsFilter) {
  firmInstitutionsList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...firmInstitutionsAttributes
    }
    total
  }
}
    ${FirmInstitutionsAttributesFragmentDoc}`;
export const GetOneFirmInstitutionsDocument = gql`
    query getOneFirmInstitutions($id: Int!) {
  firmInstitutions(id: $id) {
    ...firmInstitutionsAttributes
  }
}
    ${FirmInstitutionsAttributesFragmentDoc}`;
export const GetManyFirmInstitutionsDocument = gql`
    query getManyFirmInstitutions($ids: [Int!]!) {
  firmInstitutionsMany(ids: $ids) {
    ...firmInstitutionsAttributes
  }
}
    ${FirmInstitutionsAttributesFragmentDoc}`;
export const CreateFirmInstitutionsDocument = gql`
    mutation createFirmInstitutions($input: FirmInstitutionsInput!) {
  addFirmInstitutions(input: $input) {
    id
  }
}
    `;
export const UpdateFirmInstitutionsDocument = gql`
    mutation updateFirmInstitutions($id: Int!, $input: FirmInstitutionsInput!) {
  updateFirmInstitutions(id: $id, input: $input) {
    id
  }
}
    `;
export const DeleteFirmInstitutionsDocument = gql`
    mutation deleteFirmInstitutions($id: Int!) {
  deleteFirmInstitutions(id: $id)
}
    `;
export const GetListFundingTypeEnumDocument = gql`
    query getListFundingTypeEnum($page: PageInput, $sort: [FundingTypeEnumSort!]) {
  fundingTypeEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneFundingTypeEnumDocument = gql`
    query getOneFundingTypeEnum($id: Int!) {
  fundingTypeEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyFundingTypeEnumDocument = gql`
    query getManyFundingTypeEnum($ids: [Int!]!) {
  fundingTypeEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListFundsXProxiesDocument = gql`
    query getListFundsXProxies($page: PageInput, $sort: [FundsXProxiesSort!], $filter: FundsXProxiesFilter) {
  fundsXProxiesList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      investmentId
      proxyId
      proxyScalingFactor
      rank
      proxy {
        id
        name
      }
      createUser
      createDate
      modifyUser
      modifyDate
    }
    total
  }
}
    `;
export const GetOneFundsXProxiesDocument = gql`
    query getOneFundsXProxies($id: Int!) {
  fundsXProxies(id: $id) {
    id
    investmentId
    proxyId
    proxyScalingFactor
    rank
    proxy {
      id
      name
    }
    createUser
    createDate
    modifyUser
    modifyDate
  }
}
    `;
export const CreateFundsXProxiesDocument = gql`
    mutation createFundsXProxies($input: FundsXProxiesInput!) {
  addFundsXProxies(input: $input) {
    id
    investmentId
    proxyId
    proxyScalingFactor
    rank
    proxy {
      id
      name
    }
  }
}
    `;
export const UpdateFundsXProxiesDocument = gql`
    mutation updateFundsXProxies($id: Int!, $input: FundsXProxiesInput!) {
  updateFundsXProxies(id: $id, input: $input) {
    id
    investmentId
    proxyId
    proxyScalingFactor
    rank
    proxy {
      id
      name
    }
  }
}
    `;
export const DeleteFundsXProxiesDocument = gql`
    mutation deleteFundsXProxies($id: Int!) {
  deleteFundsXProxies(id: $id)
}
    `;
export const GetListGeographicFocusEnumDocument = gql`
    query getListGeographicFocusEnum($page: PageInput, $sort: [GeographicFocusEnumSort!]) {
  geographicFocusEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneGeographicFocusEnumDocument = gql`
    query getOneGeographicFocusEnum($id: Int!) {
  geographicFocusEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyGeographicFocusEnumDocument = gql`
    query getManyGeographicFocusEnum($ids: [Int!]!) {
  geographicFocusEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListGeographyEnumDocument = gql`
    query getListGeographyEnum($page: PageInput, $sort: [GeographyEnumSort!], $filter: GeographyEnumFilter) {
  geographyEnumList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      description
    }
    total
  }
}
    `;
export const GetOneGeographyEnumDocument = gql`
    query getOneGeographyEnum($id: Int!) {
  geographyEnum(id: $id) {
    id
    description
  }
}
    `;
export const GetManyGeographyEnumDocument = gql`
    query getManyGeographyEnum($ids: [Int!]!) {
  geographyEnumMany(ids: $ids) {
    id
    description
  }
}
    `;
export const GetListGlobalProviderNoteTypeEnumDocument = gql`
    query getListGlobalProviderNoteTypeEnum($page: PageInput, $sort: [GlobalProviderNoteTypeEnumSort!], $filter: GlobalProviderNoteTypeEnumFilter) {
  globalProviderNoteTypeEnumList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...globalProviderNoteTypeEnumAttributes
    }
    total
  }
}
    ${GlobalProviderNoteTypeEnumAttributesFragmentDoc}`;
export const GetOneGlobalProviderNoteTypeEnumDocument = gql`
    query getOneGlobalProviderNoteTypeEnum($id: Int!) {
  globalProviderNoteTypeEnum(id: $id) {
    ...globalProviderNoteTypeEnumAttributes
  }
}
    ${GlobalProviderNoteTypeEnumAttributesFragmentDoc}`;
export const GetManyGlobalProviderNoteTypeEnumDocument = gql`
    query getManyGlobalProviderNoteTypeEnum($ids: [Int!]!) {
  globalProviderNoteTypeEnumMany(ids: $ids) {
    ...globalProviderNoteTypeEnumAttributes
  }
}
    ${GlobalProviderNoteTypeEnumAttributesFragmentDoc}`;
export const GetListGroupShareDefinitionDocument = gql`
    query getListGroupShareDefinition($page: PageInput, $sort: [GroupShareDefinitionSort!], $filter: GroupShareDefinitionFilter) {
  groupShareDefinitionList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...groupShareDefinitionAttributes
    }
    total
  }
}
    ${GroupShareDefinitionAttributesFragmentDoc}`;
export const GetOneGroupShareDefinitionDocument = gql`
    query getOneGroupShareDefinition($id: Int!) {
  groupShareDefinition(id: $id) {
    ...groupShareDefinitionAttributes
  }
}
    ${GroupShareDefinitionAttributesFragmentDoc}`;
export const GetManyGroupShareDefinitionDocument = gql`
    query getManyGroupShareDefinition($ids: [Int!]!) {
  groupShareDefinitionMany(ids: $ids) {
    ...groupShareDefinitionAttributes
  }
}
    ${GroupShareDefinitionAttributesFragmentDoc}`;
export const CreateGroupShareDefinitionDocument = gql`
    mutation createGroupShareDefinition($input: GroupShareDefinitionInput!) {
  addGroupShareDefinition(input: $input) {
    ...groupShareDefinitionAttributes
  }
}
    ${GroupShareDefinitionAttributesFragmentDoc}`;
export const UpdateGroupShareDefinitionDocument = gql`
    mutation updateGroupShareDefinition($id: Int!, $input: GroupShareDefinitionInput!) {
  updateGroupShareDefinition(id: $id, input: $input) {
    ...groupShareDefinitionAttributes
  }
}
    ${GroupShareDefinitionAttributesFragmentDoc}`;
export const DeleteGroupShareDefinitionDocument = gql`
    mutation deleteGroupShareDefinition($id: Int!) {
  deleteGroupShareDefinition(id: $id)
}
    `;
export const GetListIconEnumDocument = gql`
    query getListIconEnum($page: PageInput, $sort: [IconEnumSort!]) {
  iconEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneIconEnumDocument = gql`
    query getOneIconEnum($id: Int!) {
  iconEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyIconEnumDocument = gql`
    query getManyIconEnum($ids: [Int!]!) {
  iconEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetImpactCategoryEnumListDocument = gql`
    query GetImpactCategoryEnumList {
  impactCategoryEnumList {
    items {
      id
      name
      impactEnums {
        id
        name
        displayOrder
      }
    }
    total
  }
}
    `;
export const GetListIndexCalcTypeEnumDocument = gql`
    query getListIndexCalcTypeEnum($page: PageInput, $sort: [IndexCalcTypeEnumSort!]) {
  indexCalcTypeEnumList(page: $page, sort: $sort) {
    items {
      id
      indexCalcType
    }
    total
  }
}
    `;
export const GetOneIndexCalcTypeEnumDocument = gql`
    query getOneIndexCalcTypeEnum($id: Int!) {
  indexCalcTypeEnum(id: $id) {
    id
    indexCalcType
  }
}
    `;
export const GetManyIndexCalcTypeEnumDocument = gql`
    query getManyIndexCalcTypeEnum($ids: [Int!]!) {
  indexCalcTypeEnumMany(ids: $ids) {
    id
    indexCalcType
  }
}
    `;
export const GetListInstitutionEmploymentDocument = gql`
    query getListInstitutionEmployment($page: PageInput, $sort: [InstitutionEmploymentSort!], $filter: InstitutionEmploymentFilter) {
  institutionEmploymentList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...institutionEmploymentAttributes
    }
    total
  }
}
    ${InstitutionEmploymentAttributesFragmentDoc}`;
export const GetOneInstitutionEmploymentDocument = gql`
    query getOneInstitutionEmployment($id: Int!) {
  institutionEmployment(id: $id) {
    ...institutionEmploymentAttributes
  }
}
    ${InstitutionEmploymentAttributesFragmentDoc}`;
export const GetManyInstitutionEmploymentDocument = gql`
    query getManyInstitutionEmployment($ids: [Int!]!) {
  institutionEmploymentMany(ids: $ids) {
    ...institutionEmploymentAttributes
  }
}
    ${InstitutionEmploymentAttributesFragmentDoc}`;
export const CreateInstitutionEmploymentDocument = gql`
    mutation createInstitutionEmployment($input: InstitutionEmploymentInput!) {
  addInstitutionEmployment(input: $input) {
    id
  }
}
    `;
export const UpdateInstitutionEmploymentDocument = gql`
    mutation updateInstitutionEmployment($id: Int!, $input: InstitutionEmploymentInput!) {
  updateInstitutionEmployment(id: $id, input: $input) {
    id
  }
}
    `;
export const GetListinstitutionInstitutionTypeEnumDocument = gql`
    query getListinstitutionInstitutionTypeEnum($page: PageInput, $sort: [InstitutionsInstitutionTypeEnumSort!], $filter: InstitutionsInstitutionTypeEnumFilterInput) {
  institutionsInstitutionTypeEnumList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      institutionId
      institutionTypeEnumId
      institutionTypeEnum {
        id
        name
      }
    }
    total
  }
}
    `;
export const GetOneinstitutionInstitutionTypeEnumDocument = gql`
    query getOneinstitutionInstitutionTypeEnum($id: Int!) {
  institutionsInstitutionTypeEnum(id: $id) {
    id
    institutionId
    institutionTypeEnumId
    institutionTypeEnum {
      id
      name
    }
  }
}
    `;
export const GetManyinstitutionInstitutionTypeEnumDocument = gql`
    query getManyinstitutionInstitutionTypeEnum($ids: [Int!]!) {
  institutionsInstitutionTypeEnumMany(ids: $ids) {
    id
    institutionId
    institutionTypeEnumId
    institutionTypeEnum {
      id
      name
    }
  }
}
    `;
export const GetListInstitutionSelectionStatusEnumDocument = gql`
    query getListInstitutionSelectionStatusEnum($page: PageInput, $sort: [InstitutionSelectionStatusEnumSort!], $filter: InstitutionSelectionStatusEnumFilter) {
  institutionSelectionStatusEnumList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...institutionSelectionStatusEnumAttributes
    }
    total
  }
}
    ${InstitutionSelectionStatusEnumAttributesFragmentDoc}`;
export const GetOneInstitutionSelectionStatusEnumDocument = gql`
    query getOneInstitutionSelectionStatusEnum($id: Int!) {
  institutionSelectionStatusEnum(id: $id) {
    ...institutionSelectionStatusEnumAttributes
  }
}
    ${InstitutionSelectionStatusEnumAttributesFragmentDoc}`;
export const GetManyInstitutionSelectionStatusEnumDocument = gql`
    query getManyInstitutionSelectionStatusEnum($ids: [Int!]!) {
  institutionSelectionStatusEnumMany(ids: $ids) {
    ...institutionSelectionStatusEnumAttributes
  }
}
    ${InstitutionSelectionStatusEnumAttributesFragmentDoc}`;
export const GetListInstitutionTypeEnumDocument = gql`
    query getListInstitutionTypeEnum($page: PageInput, $sort: [InstitutionTypeEnumSort!], $filter: InstitutionTypeEnumFilterInput) {
  institutionTypeEnumList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneInstitutionTypeEnumDocument = gql`
    query getOneInstitutionTypeEnum($id: Int!) {
  institutionTypeEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyInstitutionTypeEnumDocument = gql`
    query getManyInstitutionTypeEnum($ids: [Int!]!) {
  institutionTypeEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListInvestmentDocument = gql`
    query getListInvestment($page: PageInput, $sort: [InvestmentSort!], $searchFilters: [InvestmentSearchFilters!], $filter: InvestmentFilterInput) {
  investmentList(
    page: $page
    sort: $sort
    searchFilters: $searchFilters
    filter: $filter
  ) {
    items {
      ...investmentAttributes
    }
    total
  }
}
    ${InvestmentAttributesFragmentDoc}`;
export const GetOneInvestmentDocument = gql`
    query getOneInvestment($id: Int!) {
  investment(id: $id) {
    ...investmentAttributes
  }
}
    ${InvestmentAttributesFragmentDoc}`;
export const GetManyInvestmentDocument = gql`
    query getManyInvestment($ids: [Int!]!) {
  investmentMany(ids: $ids) {
    ...investmentAttributes
  }
}
    ${InvestmentAttributesFragmentDoc}`;
export const GetManyReferenceInvestmentDocument = gql`
    query getManyReferenceInvestment($page: PageInput, $sort: [InvestmentSort!], $filter: InvestmentFilterInput) {
  investmentList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...investmentAttributes
    }
    total
  }
}
    ${InvestmentAttributesFragmentDoc}`;
export const CreateInvestmentDocument = gql`
    mutation createInvestment($input: InvestmentInput!) {
  addInvestment(input: $input) {
    id
  }
}
    `;
export const UpdateInvestmentDocument = gql`
    mutation updateInvestment($id: Int!, $input: InvestmentInput!) {
  updateInvestment(id: $id, input: $input) {
    id
  }
}
    `;
export const DeleteInvestmentDocument = gql`
    mutation deleteInvestment($id: Int!) {
  deleteInvestment(id: $id)
}
    `;
export const GetListInvestmentAssignmentOptionDocument = gql`
    query getListInvestmentAssignmentOption($page: PageInput, $sort: [InvestmentAssignmentOptionSort!], $filter: InvestmentAssignmentOptionFilter) {
  investmentAssignmentOptionList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      commonName
      isPrimary
      isSecondary
    }
    total
  }
}
    `;
export const GetManyInvestmentAssignmentOptionDocument = gql`
    query getManyInvestmentAssignmentOption($ids: [String!]!) {
  investmentAssignmentOptionMany(ids: $ids) {
    id
    commonName
    isPrimary
    isSecondary
  }
}
    `;
export const GetListInvestmentAxysCodeDocument = gql`
    query getListInvestmentAxysCode($page: PageInput, $sort: [InvestmentAxysCodeSort!], $filter: InvestmentAxysCodeFilter) {
  investmentAxysCodeList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...investmentAxysCodeAttributes
    }
    total
  }
}
    ${InvestmentAxysCodeAttributesFragmentDoc}`;
export const GetOneInvestmentAxysCodeDocument = gql`
    query getOneInvestmentAxysCode($id: Int!) {
  investmentAxysCode(id: $id) {
    ...investmentAxysCodeAttributes
  }
}
    ${InvestmentAxysCodeAttributesFragmentDoc}`;
export const GetManyInvestmentAxysCodeDocument = gql`
    query getManyInvestmentAxysCode($ids: [Int!]!) {
  investmentAxysCodeMany(ids: $ids) {
    ...investmentAxysCodeAttributes
  }
}
    ${InvestmentAxysCodeAttributesFragmentDoc}`;
export const CreateInvestmentAxysCodeDocument = gql`
    mutation createInvestmentAxysCode($input: InvestmentAxysCodeInput!) {
  addInvestmentAxysCode(input: $input) {
    id
  }
}
    `;
export const DeleteInvestmentAxysCodeDocument = gql`
    mutation deleteInvestmentAxysCode($id: Int!) {
  deleteInvestmentAxysCode(id: $id)
}
    `;
export const GetBulkInvestmentDocument = gql`
    query getBulkInvestment($sort: [InvestmentSort!], $filter: InvestmentFilterInput) {
  investmentBulk(sort: $sort, filter: $filter) {
    id
    name
  }
}
    `;
export const GetListInvestmentFdpLoginsDocument = gql`
    query getListInvestmentFDPLogins($page: PageInput, $sort: [InvestmentFDPLoginsSort!], $filter: InvestmentFDPLoginsFilter) {
  investmentFDPLoginsList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...investmentFDPLoginsAttributes
    }
    total
  }
}
    ${InvestmentFdpLoginsAttributesFragmentDoc}`;
export const GetOneInvestmentFdpLoginsDocument = gql`
    query getOneInvestmentFDPLogins($id: Int!) {
  investmentFDPLogins(id: $id) {
    ...investmentFDPLoginsAttributes
  }
}
    ${InvestmentFdpLoginsAttributesFragmentDoc}`;
export const GetManyInvestmentFdpLoginsDocument = gql`
    query getManyInvestmentFDPLogins($ids: [Int!]!) {
  investmentFDPLoginsMany(ids: $ids) {
    ...investmentFDPLoginsAttributes
  }
}
    ${InvestmentFdpLoginsAttributesFragmentDoc}`;
export const CreateInvestmentFdpLoginsDocument = gql`
    mutation createInvestmentFDPLogins($input: InvestmentFDPLoginsInput!) {
  addInvestmentFDPLogins(input: $input) {
    id
  }
}
    `;
export const UpdateInvestmentFdpLoginsDocument = gql`
    mutation updateInvestmentFDPLogins($id: Int!, $input: InvestmentFDPLoginsInput!) {
  updateInvestmentFDPLogins(id: $id, input: $input) {
    id
  }
}
    `;
export const GetListInvestmentFeesDocument = gql`
    query getListInvestmentFees($page: PageInput, $sort: [InvestmentFeesSort!], $filter: InvestmentFeesFilter) {
  investmentFeesList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...investmentFeesAttributes
    }
    total
  }
}
    ${InvestmentFeesAttributesFragmentDoc}`;
export const GetOneInvestmentFeesDocument = gql`
    query getOneInvestmentFees($id: Int!) {
  investmentFees(id: $id) {
    ...investmentFeesAttributes
  }
}
    ${InvestmentFeesAttributesFragmentDoc}`;
export const GetManyInvestmentFeesDocument = gql`
    query getManyInvestmentFees($ids: [Int!]!) {
  investmentFeesMany(ids: $ids) {
    ...investmentFeesAttributes
  }
}
    ${InvestmentFeesAttributesFragmentDoc}`;
export const GetListInvestmentFirmEmploymentDocument = gql`
    query getListInvestmentFirmEmployment($page: PageInput, $sort: [InvestmentFirmEmploymentSort!], $filter: InvestmentFirmEmploymentFilterInput) {
  investmentFirmEmploymentList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      firmEmploymentId
      investmentId
      employeeRoleEnumId
      startDate
      leftDate
      faceOfInvestment
      firmEmployment {
        id
        firm {
          id
          name
        }
        person {
          id
          lastName
          firstName
          middleName
        }
      }
      investment {
        id
        name
      }
      employeeRole {
        id
        name
      }
    }
    total
  }
}
    `;
export const GetOneInvestmentFirmEmploymentDocument = gql`
    query getOneInvestmentFirmEmployment($id: Int!) {
  investmentFirmEmployment(id: $id) {
    id
    employeeRoleEnumId
    startDate
    leftDate
    faceOfInvestment
    firmEmployment {
      id
      firm {
        id
        name
      }
      person {
        id
        lastName
        firstName
        middleName
      }
    }
    investment {
      id
      name
    }
  }
}
    `;
export const GetManyInvestmentFirmEmploymentDocument = gql`
    query getManyInvestmentFirmEmployment($ids: [Int!]!) {
  investmentFirmEmploymentMany(ids: $ids) {
    id
    firmEmploymentId
    investmentId
  }
}
    `;
export const GetManyReferenceInvestmentFirmEmploymentDocument = gql`
    query getManyReferenceInvestmentFirmEmployment($page: PageInput, $sort: [InvestmentFirmEmploymentSort!], $filter: InvestmentFirmEmploymentFilterInput) {
  investmentFirmEmploymentList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      startDate
      leftDate
      faceOfInvestment
      firmEmployment {
        id
        firm {
          id
          name
        }
        person {
          id
          lastName
          firstName
          middleName
        }
        leftInd
        leftDate
        employeeRole {
          id
          name
        }
        isKeyPersonnel
        isFounder
        contactType {
          id
          name
        }
      }
      investment {
        id
        name
      }
      employeeRole {
        id
        name
      }
    }
    total
  }
}
    `;
export const CreateInvestmentFirmEmploymentDocument = gql`
    mutation createInvestmentFirmEmployment($input: InvestmentFirmEmploymentInput!) {
  addInvestmentFirmEmployment(input: $input) {
    id
  }
}
    `;
export const UpdateInvestmentFirmEmploymentDocument = gql`
    mutation updateInvestmentFirmEmployment($id: Int!, $input: InvestmentFirmEmploymentInput!) {
  updateInvestmentFirmEmployment(id: $id, input: $input) {
    id
  }
}
    `;
export const DeleteInvestmentFirmEmploymentDocument = gql`
    mutation deleteInvestmentFirmEmployment($id: Int!) {
  deleteInvestmentFirmEmployment(id: $id)
}
    `;
export const CreateInvestmentFirmEmploymentBulkDocument = gql`
    mutation createInvestmentFirmEmploymentBulk($input: [InvestmentFirmEmploymentInput!]!) {
  addInvestmentFirmEmploymentRecords(input: $input) {
    id
  }
}
    `;
export const GetListInvestmentFirmEmploymentRoleEnumDocument = gql`
    query getListInvestmentFirmEmploymentRoleEnum($page: PageInput, $sort: [InvestmentFirmEmploymentRoleEnumSort!], $filter: InvestmentFirmEmploymentRoleEnumFilter) {
  investmentFirmEmploymentRoleEnumList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneInvestmentFirmEmploymentRoleEnumDocument = gql`
    query getOneInvestmentFirmEmploymentRoleEnum($id: Int!) {
  investmentFirmEmploymentRoleEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyInvestmentFirmEmploymentRoleEnumDocument = gql`
    query getManyInvestmentFirmEmploymentRoleEnum($ids: [Int!]!) {
  investmentFirmEmploymentRoleEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListInvestmentInstitutionsDocument = gql`
    query getListInvestmentInstitutions($page: PageInput, $sort: [InvestmentInstitutionsSort!], $filter: InvestmentInstitutionsFilter) {
  investmentInstitutionsList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...investmentInstitutionsAttributes
    }
    total
  }
}
    ${InvestmentInstitutionsAttributesFragmentDoc}`;
export const GetOneInvestmentInstitutionsDocument = gql`
    query getOneInvestmentInstitutions($id: Int!) {
  investmentInstitutions(id: $id) {
    ...investmentInstitutionsAttributes
  }
}
    ${InvestmentInstitutionsAttributesFragmentDoc}`;
export const GetManyInvestmentInstitutionsDocument = gql`
    query getManyInvestmentInstitutions($ids: [Int!]!) {
  investmentInstitutionsMany(ids: $ids) {
    ...investmentInstitutionsAttributes
  }
}
    ${InvestmentInstitutionsAttributesFragmentDoc}`;
export const CreateInvestmentInstitutionsDocument = gql`
    mutation createInvestmentInstitutions($input: InvestmentInstitutionsInput!) {
  addInvestmentInstitutions(input: $input) {
    id
  }
}
    `;
export const UpdateInvestmentInstitutionsDocument = gql`
    mutation updateInvestmentInstitutions($id: Int!, $input: InvestmentInstitutionsInput!) {
  updateInvestmentInstitutions(id: $id, input: $input) {
    id
  }
}
    `;
export const DeleteInvestmentInstitutionsDocument = gql`
    mutation deleteInvestmentInstitutions($id: Int!) {
  deleteInvestmentInstitutions(id: $id)
}
    `;
export const GetOneInvestmentForPrivateQuartilesDocument = gql`
    query getOneInvestmentForPrivateQuartiles($id: Int!) {
  investment(id: $id) {
    ...investmentAttributesForPrivateQuartiles
  }
}
    ${InvestmentAttributesForPrivateQuartilesFragmentDoc}`;
export const GetListInvestmentListEnumDocument = gql`
    query getListInvestmentListEnum($page: PageInput, $sort: [InvestmentListEnumSort!], $filter: InvestmentListEnumFilter) {
  investmentListEnumList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneInvestmentListEnumDocument = gql`
    query getOneInvestmentListEnum($id: Int!) {
  investmentListEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyInvestmentListEnumDocument = gql`
    query getManyInvestmentListEnum($ids: [Int!]!) {
  investmentListEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetOneInvestmentPeersDocument = gql`
    query getOneInvestmentPeers($id: Int!, $sort: [InvestmentSort!], $filter: InvestmentPeersFilterInput) {
  investment(id: $id) {
    id
    name
    market {
      id
      name
    }
    marketEnumId
    firm {
      id
      name
    }
    vintageYear
    portalSubmitted {
      migratedAt
    }
    peersList(sort: $sort, filter: $filter) {
      items {
        id
        name
      }
    }
  }
}
    `;
export const UpdateInvestmentPeersDocument = gql`
    mutation updateInvestmentPeers($id: Int!, $peerIds: [Int!]!) {
  updateInvestment(id: $id, input: {peerIds: $peerIds}) {
    id
  }
}
    `;
export const GetOneInvestmentPeersAutoDocument = gql`
    query getOneInvestmentPeersAuto($id: Int!) {
  investment(id: $id) {
    id
    peersAutoList {
      items {
        id
        name
      }
    }
  }
}
    `;
export const GetListInvestmentPrivateQuartileGroupCategoryDocument = gql`
    query getListInvestmentPrivateQuartileGroupCategory($page: PageInput, $sort: [InvestmentPrivateQuartileGroupCategorySort!], $filter: InvestmentPrivateQuartileGroupCategoryFilter) {
  investmentPrivateQuartileGroupCategoryList(
    page: $page
    sort: $sort
    filter: $filter
  ) {
    items {
      ...investmentPrivateQuartileGroupCategoryAttributes
    }
    total
  }
}
    ${InvestmentPrivateQuartileGroupCategoryAttributesFragmentDoc}`;
export const GetOneInvestmentPrivateQuartileGroupCategoryDocument = gql`
    query getOneInvestmentPrivateQuartileGroupCategory($id: Int!) {
  investmentPrivateQuartileGroupCategory(id: $id) {
    ...investmentPrivateQuartileGroupCategoryAttributes
  }
}
    ${InvestmentPrivateQuartileGroupCategoryAttributesFragmentDoc}`;
export const GetManyInvestmentPrivateQuartileGroupCategoryDocument = gql`
    query getManyInvestmentPrivateQuartileGroupCategory($ids: [Int!]!) {
  investmentPrivateQuartileGroupCategoryMany(ids: $ids) {
    ...investmentPrivateQuartileGroupCategoryAttributes
  }
}
    ${InvestmentPrivateQuartileGroupCategoryAttributesFragmentDoc}`;
export const CreateInvestmentPrivateQuartileGroupCategoryDocument = gql`
    mutation createInvestmentPrivateQuartileGroupCategory($input: InvestmentPrivateQuartileGroupCategoryInput!) {
  addInvestmentPrivateQuartileGroupCategory(input: $input) {
    ...investmentPrivateQuartileGroupCategoryAttributes
  }
}
    ${InvestmentPrivateQuartileGroupCategoryAttributesFragmentDoc}`;
export const UpdateInvestmentPrivateQuartileGroupCategoryDocument = gql`
    mutation updateInvestmentPrivateQuartileGroupCategory($id: Int!, $input: InvestmentPrivateQuartileGroupCategoryInput!) {
  updateInvestmentPrivateQuartileGroupCategory(id: $id, input: $input) {
    ...investmentPrivateQuartileGroupCategoryAttributes
  }
}
    ${InvestmentPrivateQuartileGroupCategoryAttributesFragmentDoc}`;
export const DeleteInvestmentPrivateQuartileGroupCategoryDocument = gql`
    mutation deleteInvestmentPrivateQuartileGroupCategory($id: Int!) {
  deleteInvestmentPrivateQuartileGroupCategory(id: $id)
}
    `;
export const GetInvestmentRiskCategoryListDocument = gql`
    query getInvestmentRiskCategoryList($page: PageInput, $sort: [InvestmentRiskCategorySort!], $filter: InvestmentRiskCategoryFilter) {
  investmentRiskCategoryList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const RefreshInvestmentRiskDocument = gql`
    mutation refreshInvestmentRisk($listType: RefreshInvestmentRiskListType!, $investmentIds: [Int!]) {
  refreshInvestmentRisk(listType: $listType, investmentIds: $investmentIds) {
    id
    startDate
  }
}
    `;
export const CopyRiskMeasuresDocument = gql`
    mutation copyRiskMeasures($sourceInvestmentId: Int!, $targetInvestmentId: Int!) {
  copyRiskMeasures(
    sourceInvestmentId: $sourceInvestmentId
    targetInvestmentId: $targetInvestmentId
  )
}
    `;
export const DeleteRiskMeasuresDocument = gql`
    mutation deleteRiskMeasures($listType: DeleteInvestmentRiskListType!, $investmentIds: [Int!], $categoryIds: [String!], $minDate: DateTime, $maxDate: DateTime) {
  deleteRiskMeasures(
    listType: $listType
    investmentIds: $investmentIds
    categoryIds: $categoryIds
    minDate: $minDate
    maxDate: $maxDate
  )
}
    `;
export const ImportRiskMeasuresStatusDocument = gql`
    query importRiskMeasuresStatus($id: ID!) {
  importRiskMeasuresStatus(id: $id) {
    id
    status {
      id
      endDate
      error
    }
    returnValue {
      errorCount
      totalCount
      errorRows {
        line
        error
        raw {
          investmentId
          reportDate
          measure
          tier1
          tier2
          category1
          category2
          category3
          category4
          category5
        }
        parsed {
          investmentId
          reportDate
          measure
          tierId
          categoryId
        }
      }
      validInvestments {
        id
        name
      }
    }
  }
}
    `;
export const ImportRiskMeasuresDocument = gql`
    mutation importRiskMeasures($validateOnly: Boolean!, $isEstimated: Boolean!, $file: Upload!, $notify: Boolean!) {
  importRiskMeasures(
    validateOnly: $validateOnly
    isEstimated: $isEstimated
    file: $file
    notify: $notify
  ) {
    id
    startDate
  }
}
    `;
export const GetInvestmentRiskInvestmentListDocument = gql`
    query getInvestmentRiskInvestmentList($page: PageInput, $sort: [InvestmentRiskInvestmentSort!], $filter: InvestmentRiskInvestmentFilter) {
  investmentRiskInvestmentList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      name
      firm {
        id
        name
      }
    }
    total
  }
}
    `;
export const GetListInvestmentSetDocument = gql`
    query getListInvestmentSet($page: PageInput, $sort: [InvestmentSetSort!], $filter: InvestmentSetFilter) {
  investmentSetList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneInvestmentSetDocument = gql`
    query getOneInvestmentSet($id: Int!) {
  investmentSet(id: $id) {
    id
    name
    investments {
      items {
        id
        name
      }
    }
  }
}
    `;
export const GetListInvestmentStructureEnumDocument = gql`
    query getListInvestmentStructureEnum($page: PageInput, $sort: [InvestmentStructureEnumSort!]) {
  investmentStructureEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneInvestmentStructureEnumDocument = gql`
    query getOneInvestmentStructureEnum($id: Int!) {
  investmentStructureEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyInvestmentStructureEnumDocument = gql`
    query getManyInvestmentStructureEnum($ids: [Int!]!) {
  investmentStructureEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListInvestmentTagsDocument = gql`
    query getListInvestmentTags($page: PageInput, $sort: [InvestmentTagsSort!], $filter: InvestmentTagsFilterInput) {
  investmentTagsList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      tagId
      tagClassId
      investmentId
    }
    total
  }
}
    `;
export const GetManyInvestmentTagsDocument = gql`
    query getManyInvestmentTags($ids: [Int!]!) {
  investmentTagsMany(ids: $ids) {
    id
    tagId
    tagClassId
    investmentId
  }
}
    `;
export const GetOneInvestmentTagsDocument = gql`
    query getOneInvestmentTags($id: Int!) {
  investmentTags(id: $id) {
    id
    tagId
    tagClassId
    investmentId
  }
}
    `;
export const GetOneInvestmentTermsDocument = gql`
    query getOneInvestmentTerms($id: Int!) {
  investment(id: $id) {
    ...investmentTermsAttributes
  }
}
    ${InvestmentTermsAttributesFragmentDoc}`;
export const UpdateInvestmentTermsDocument = gql`
    mutation updateInvestmentTerms($id: Int!, $input: InvestmentInput!) {
  updateInvestment(id: $id, input: $input) {
    ...investmentTermsAttributes
  }
}
    ${InvestmentTermsAttributesFragmentDoc}`;
export const CreateInvestmentsFamilyDocument = gql`
    mutation createInvestmentsFamily($input: InvestmentsFamilyInput!) {
  addInvestmentsFamily(input: $input) {
    id
  }
}
    `;
export const DeleteInvestmentsFamilyDocument = gql`
    mutation deleteInvestmentsFamily($id: Int!) {
  deleteInvestmentsFamily(id: $id)
}
    `;
export const GetListLegalStructureEnumDocument = gql`
    query getListLegalStructureEnum($page: PageInput, $sort: [LegalStructureEnumSort!]) {
  legalStructureEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneLegalStructureEnumDocument = gql`
    query getOneLegalStructureEnum($id: Int!) {
  legalStructureEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyLegalStructureEnumDocument = gql`
    query getManyLegalStructureEnum($ids: [Int!]!) {
  legalStructureEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListLinksDocument = gql`
    query getListLinks($page: PageInput, $sort: [LinksSort!], $filter: LinksFilter) {
  linksList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...linksAttributes
    }
    total
  }
}
    ${LinksAttributesFragmentDoc}`;
export const GetOneLinkDocument = gql`
    query getOneLink($id: Int!) {
  links(id: $id) {
    ...linksAttributes
  }
}
    ${LinksAttributesFragmentDoc}`;
export const GetManyLinksDocument = gql`
    query getManyLinks($ids: [Int!]!) {
  linksMany(ids: $ids) {
    ...linksAttributes
  }
}
    ${LinksAttributesFragmentDoc}`;
export const CreateLinksDocument = gql`
    mutation createLinks($input: LinksInput!) {
  addLinks(input: $input) {
    ...linksAttributes
  }
}
    ${LinksAttributesFragmentDoc}`;
export const UpdateLinksDocument = gql`
    mutation updateLinks($id: Int!, $input: LinksInput!) {
  updateLinks(id: $id, input: $input) {
    ...linksAttributes
  }
}
    ${LinksAttributesFragmentDoc}`;
export const DeleteLinksDocument = gql`
    mutation deleteLinks($id: Int!) {
  deleteLinks(id: $id)
}
    `;
export const GetListLiquidityDocument = gql`
    query getListLiquidity($page: PageInput, $sort: [LiquiditySort!], $filter: LiquidityFilter) {
  liquidityList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...liquidityAttributes
    }
    total
  }
}
    ${LiquidityAttributesFragmentDoc}`;
export const GetOneLiquidityDocument = gql`
    query getOneLiquidity($id: Int!) {
  liquidity(id: $id) {
    ...liquidityAttributes
  }
}
    ${LiquidityAttributesFragmentDoc}`;
export const GetManyLiquidityDocument = gql`
    query getManyLiquidity($ids: [Int!]!) {
  liquidityMany(ids: $ids) {
    ...liquidityAttributes
  }
}
    ${LiquidityAttributesFragmentDoc}`;
export const GetListLockupEndValueEnumDocument = gql`
    query getListLockupEndValueEnum($page: PageInput, $sort: [LockupEndValueEnumSort!]) {
  lockupEndValueEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneLockupEndValueEnumDocument = gql`
    query getOneLockupEndValueEnum($id: Int!) {
  lockupEndValueEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyLockupEndValueEnumDocument = gql`
    query getManyLockupEndValueEnum($ids: [Int!]!) {
  lockupEndValueEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListMeasureEnumDocument = gql`
    query getListMeasureEnum($page: PageInput, $sort: [MeasureEnumSort!]) {
  measureEnumList(page: $page, sort: $sort) {
    items {
      id
      description
      displayOrder
      questionText
      measureTypeEnumId
      measureTypeEnum {
        id
        name
      }
    }
    total
  }
}
    `;
export const GetOneMeasureEnumDocument = gql`
    query getOneMeasureEnum($id: Int!) {
  measureEnum(id: $id) {
    id
    description
    displayOrder
    questionText
    measureTypeEnumId
    measureTypeEnum {
      id
      name
    }
  }
}
    `;
export const GetManyMeasureEnumDocument = gql`
    query getManyMeasureEnum($ids: [Int!]!) {
  measureEnumMany(ids: $ids) {
    id
    description
    displayOrder
    questionText
    measureTypeEnumId
    measureTypeEnum {
      id
      name
    }
  }
}
    `;
export const GetListMeasureTypeEnumDocument = gql`
    query getListMeasureTypeEnum($page: PageInput, $sort: [MeasureTypeEnumSort!]) {
  measureTypeEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneMeasureTypeEnumDocument = gql`
    query getOneMeasureTypeEnum($id: Int!) {
  measureTypeEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyMeasureTypeEnumDocument = gql`
    query getManyMeasureTypeEnum($ids: [Int!]!) {
  measureTypeEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListNavClassificationEnumDocument = gql`
    query getListNavClassificationEnum($page: PageInput, $sort: [NAVClassificationEnumSort!]) {
  navClassificationEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneNavClassificationEnumDocument = gql`
    query getOneNavClassificationEnum($id: Int!) {
  navClassificationEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyNavClassificationEnumDocument = gql`
    query getManyNavClassificationEnum($ids: [Int!]!) {
  navClassificationEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListNotesMetaEnumDocument = gql`
    query getListNotesMetaEnum($page: PageInput, $sort: [NoteMetaEnumSort!], $filter: NoteMetaEnumFilter) {
  noteMetaEnumList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      label
    }
    total
  }
}
    `;
export const GetManyNotesMetaEnumDocument = gql`
    query getManyNotesMetaEnum($ids: [Int!]!) {
  noteMetaEnumMany(ids: $ids) {
    id
    label
  }
}
    `;
export const GetListNotesDocument = gql`
    query getListNotes($page: PageInput, $sort: [NotesSort!], $filter: NotesFilter) {
  notesList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...noteAttributes
    }
    total
  }
}
    ${NoteAttributesFragmentDoc}`;
export const GetOneNotesDocument = gql`
    query getOneNotes($id: Int!) {
  notes(id: $id) {
    ...noteAttributes
  }
}
    ${NoteAttributesFragmentDoc}`;
export const GetManyNotesDocument = gql`
    query getManyNotes($ids: [Int!]!) {
  notesMany(ids: $ids) {
    ...noteAttributes
  }
}
    ${NoteAttributesFragmentDoc}`;
export const AddNoteDocument = gql`
    mutation addNote($input: NotesInput!) {
  addNote(input: $input) {
    id
  }
}
    `;
export const UpdateNoteDocument = gql`
    mutation updateNote($id: Int!, $input: NotesInput!) {
  updateNote(id: $id, input: $input) {
    id
  }
}
    `;
export const GetListInstitutionDocument = gql`
    query getListInstitution($page: PageInput, $sort: [InstitutionSort!], $filter: InstitutionFilterInput) {
  institutionList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...institutionAttributes
    }
    total
  }
}
    ${InstitutionAttributesFragmentDoc}`;
export const GetOneInstitutionDocument = gql`
    query getOneInstitution($id: Int!) {
  institution(id: $id) {
    ...institutionAttributes
  }
}
    ${InstitutionAttributesFragmentDoc}`;
export const GetManyInstitutionDocument = gql`
    query getManyInstitution($ids: [Int!]!) {
  institutionMany(ids: $ids) {
    ...institutionAttributes
  }
}
    ${InstitutionAttributesFragmentDoc}`;
export const CreateInstitutionDocument = gql`
    mutation createInstitution($input: InstitutionInput!) {
  addInstitution(input: $input) {
    ...institutionAttributes
  }
}
    ${InstitutionAttributesFragmentDoc}`;
export const UpdateInstitutionDocument = gql`
    mutation updateInstitution($id: Int!, $input: InstitutionInput!) {
  updateInstitution(id: $id, input: $input) {
    ...institutionAttributes
  }
}
    ${InstitutionAttributesFragmentDoc}`;
export const GetListOperatingStatusEnumDocument = gql`
    query getListOperatingStatusEnum($page: PageInput, $sort: [OperatingStatusEnumSort!]) {
  operatingStatusEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneOperatingStatusEnumDocument = gql`
    query getOneOperatingStatusEnum($id: Int!) {
  operatingStatusEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyOperatingStatusEnumDocument = gql`
    query getManyOperatingStatusEnum($ids: [Int!]!) {
  operatingStatusEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListOrgLinksDocument = gql`
    query getListOrgLinks($page: PageInput, $sort: [OrgLinksSort!], $filter: OrgLinksFilter) {
  orgLinksList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...orgLinksAttributes
    }
    total
  }
}
    ${OrgLinksAttributesFragmentDoc}`;
export const GetOneOrgLinksDocument = gql`
    query getOneOrgLinks($id: Int!) {
  orgLinks(id: $id) {
    ...orgLinksAttributes
  }
}
    ${OrgLinksAttributesFragmentDoc}`;
export const GetManyOrgLinksDocument = gql`
    query getManyOrgLinks($ids: [Int!]!) {
  orgLinksMany(ids: $ids) {
    ...orgLinksAttributes
  }
}
    ${OrgLinksAttributesFragmentDoc}`;
export const GetListOrganizationDocument = gql`
    query getListOrganization($page: PageInput, $sort: [OrganizationSort!], $filter: OrganizationFilter) {
  organizationList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...organizationAttributes
    }
    total
  }
}
    ${OrganizationAttributesFragmentDoc}`;
export const GetOneOrganizationDocument = gql`
    query getOneOrganization($id: Int!) {
  organization(id: $id) {
    ...organizationAttributes
  }
}
    ${OrganizationAttributesFragmentDoc}`;
export const UpdateOrganizationDocument = gql`
    mutation updateOrganization($id: Int!, $input: OrganizationInput!) {
  updateOrganization(id: $id, input: $input) {
    id
  }
}
    `;
export const CreateOrganizationDocument = gql`
    mutation createOrganization($input: OrganizationCreateInput!) {
  createOrganization(input: $input) {
    ...organizationAttributes
  }
}
    ${OrganizationAttributesFragmentDoc}`;
export const GetListOrganizationStructureEnumDocument = gql`
    query getListOrganizationStructureEnum($page: PageInput, $sort: [OrganizationStructureEnumSort!]) {
  organizationStructureEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneOrganizationStructureEnumDocument = gql`
    query getOneOrganizationStructureEnum($id: Int!) {
  organizationStructureEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyOrganizationStructureEnumDocument = gql`
    query getManyOrganizationStructureEnum($ids: [Int!]!) {
  organizationStructureEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListPeFundNumberEnumDocument = gql`
    query getListPeFundNumberEnum($page: PageInput, $sort: [PEFundNumberEnumSort!], $filter: PEFundNumberEnumFilter) {
  peFundNumberEnumList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOnePeFundNumberEnumDocument = gql`
    query getOnePeFundNumberEnum($id: Int!) {
  peFundNumberEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyPeFundNumberEnumDocument = gql`
    query getManyPeFundNumberEnum($ids: [Int!]!) {
  peFundNumberEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListPeInctFeeCalcEnumDocument = gql`
    query getListPeInctFeeCalcEnum($page: PageInput, $sort: [PeInctFeeCalcEnumSort!]) {
  peInctFeeCalcEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOnePeInctFeeCalcEnumDocument = gql`
    query getOnePeInctFeeCalcEnum($id: Int!) {
  peInctFeeCalcEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyPeInctFeeCalcEnumDocument = gql`
    query getManyPeInctFeeCalcEnum($ids: [Int!]!) {
  peInctFeeCalcEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListPeLiquidityDocument = gql`
    query getListPeLiquidity($page: PageInput, $sort: [PeLiquiditySort!], $filter: PeLiquidityFilter) {
  peLiquidityList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...peLiquidityAttributes
    }
    total
  }
}
    ${PeLiquidityAttributesFragmentDoc}`;
export const GetOnePeLiquidityDocument = gql`
    query getOnePeLiquidity($id: Int!) {
  peLiquidity(id: $id) {
    ...peLiquidityAttributes
  }
}
    ${PeLiquidityAttributesFragmentDoc}`;
export const GetManyPeLiquidityDocument = gql`
    query getManyPeLiquidity($ids: [Int!]!) {
  peLiquidityMany(ids: $ids) {
    ...peLiquidityAttributes
  }
}
    ${PeLiquidityAttributesFragmentDoc}`;
export const GetListPeMgmtFeeCalcEnumDocument = gql`
    query getListPeMgmtFeeCalcEnum($page: PageInput, $sort: [PeMgmtFeeCalcEnumSort!]) {
  peMgmtFeeCalcEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOnePeMgmtFeeCalcEnumDocument = gql`
    query getOnePeMgmtFeeCalcEnum($id: Int!) {
  peMgmtFeeCalcEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyPeMgmtFeeCalcEnumDocument = gql`
    query getManyPeMgmtFeeCalcEnum($ids: [Int!]!) {
  peMgmtFeeCalcEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListPeStrategyEnumDocument = gql`
    query getListPEStrategyEnum($page: PageInput, $sort: [PEStrategyEnumSort!]) {
  peStrategyEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOnePeStrategyEnumDocument = gql`
    query getOnePEStrategyEnum($id: Int!) {
  peStrategyEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyPeStrategyEnumDocument = gql`
    query getManyPEStrategyEnum($ids: [Int!]!) {
  peStrategyEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const PerformanceBackgroundDocument = gql`
    query performanceBackground($investmentId: Int!) {
  investment(id: $investmentId) {
    id
    name
    firmId
    fdpLogins(filter: {includeFirmIfNoInvestment: true}) {
      id
      username
      password
      securityQuestion
      notes
      email
      mfaUser
      financialDataProvider {
        id
        name
        fdpWebsites {
          id
          website
        }
      }
    }
    firm {
      id
      name
      firmEmployments(
        filter: {contactTypeEnumIds: [2, 3], isCurrent: true}
        page: {limit: 1, offset: 1}
        sort: [{field: personDefault, order: ASC}]
      ) {
        id
        person {
          id
          lastName
          firstName
          middleName
          email
          phone
        }
      }
      primaryAddress {
        id
        website
        webUserId
        webPassword
      }
    }
    portalSubmitted {
      migratedAt
    }
    latestNote(noteMetaId: 9) {
      id
      createDate
      createUser
      text
    }
  }
}
    `;
export const GetOneInvestmentPerformanceMtdDocument = gql`
    query getOneInvestmentPerformanceMTD($investmentId: Int!, $priorTrackRecord: Boolean, $returnType: ReturnTypes, $includeLlm: Boolean! = false) {
  investment(id: $investmentId) {
    name
    id
    firmId
    fdpLogins(filter: {includeFirmIfNoInvestment: true}) {
      id
      username
      password
      securityQuestion
      notes
      email
      mfaUser
      financialDataProvider {
        id
        name
        fdpWebsites {
          id
          website
        }
      }
    }
    firm {
      id
      name
      firmEmployments(
        filter: {contactTypeEnumIds: [2, 3], isCurrent: true}
        page: {limit: 1, offset: 1}
        sort: [{field: personDefault, order: ASC}]
      ) {
        id
        person {
          id
          lastName
          firstName
          middleName
          email
          phone
        }
      }
      primaryAddress {
        id
        website
        webUserId
        webPassword
      }
    }
    inceptionDate
    currencyDenominationEnumId
    performanceSource
    latestNote(noteMetaId: 9) {
      id
      createDate
      createUser
      text
    }
    performanceMTD(
      sort: {field: asOfDate, order: DESC}
      filter: {priorTrackRecord: $priorTrackRecord, returnType: $returnType}
    ) {
      returnYear
      returnMonth
      return
      currencyId
      asOfDate
      createUser
      createDate
      modifyUser
      modifyDate
      performanceCommentary
    }
    llmPerformanceMTD(filter: {returnType: $returnType}) @include(if: $includeLlm) {
      returnYear
      returnMonth
      return
      currencyId
      asOfDate
      returnType
      performanceCommentary
      documentId
      createUser
      createDate
    }
    portalSubmitted {
      migratedAt
    }
  }
}
    `;
export const GetOneInvestmentPerformanceQuarterlyDocument = gql`
    query getOneInvestmentPerformanceQuarterly($investmentId: Int!, $priorTrackRecord: Boolean, $returnType: ReturnTypes) {
  investment(id: $investmentId) {
    name
    id
    firmId
    inceptionDate
    performanceSource
    latestNote(noteMetaId: 9) {
      id
      createDate
      createUser
      text
    }
    performanceQuarterly(
      sort: {field: asOfDate, order: DESC}
      filter: {returnType: $returnType, priorTrackRecord: $priorTrackRecord}
    ) {
      returnYear
      returnQuarter
      returnType
      return
    }
    portalSubmitted {
      migratedAt
    }
  }
}
    `;
export const BulkUpdatePerformanceQuarterlyDocument = gql`
    mutation bulkUpdatePerformanceQuarterly($investmentId: Int!, $returnType: ReturnTypes!, $quarters: [PerformanceQuarterlyShort!]!) {
  addOrUpdatePerformanceQuarterly(
    input: {investmentId: $investmentId, returnType: $returnType, quarters: $quarters}
  ) {
    items {
      return
      returnYear
      returnQuarter
      returnType
    }
  }
}
    `;
export const BulkUpdatePerformanceMtdDocument = gql`
    mutation bulkUpdatePerformanceMTD($investmentId: Int!, $returnType: ReturnTypes!, $currencyId: Int!, $months: [PerformanceMTDShort!]!) {
  addOrUpdatePerformanceMTD(
    input: {investmentId: $investmentId, returnType: $returnType, currencyId: $currencyId, months: $months}
  ) {
    items {
      returnYear
      returnMonth
      returnType
      return
      currencyId
      asOfDate
    }
  }
}
    `;
export const BloombergDiligenceExtractDocument = gql`
    mutation bloombergDiligenceExtract($investmentIds: [Int!]!, $startDate: String!, $endDate: String!) {
  bloombergDiligenceExtract(
    investmentIds: $investmentIds
    startDate: $startDate
    endDate: $endDate
  ) {
    currency
    tickers
    monthlyId
    dailyId
  }
}
    `;
export const BloombergDiligenceExtractStatusDocument = gql`
    query bloombergDiligenceExtractStatus($datasetIds: [String!]!) {
  bloombergDiligenceExtractStatus(datasetIds: $datasetIds) {
    statusCode
    identifier
  }
}
    `;
export const BloombergDiligenceLoadDocument = gql`
    mutation bloombergDiligenceLoad($inputs: [BloombergPullLoadInput!]!) {
  bloombergDiligenceLoad(inputs: $inputs)
}
    `;
export const GetPerformanceBackfillInvestmentListDocument = gql`
    query getPerformanceBackfillInvestmentList($page: PageInput, $sort: [InvestmentRiskInvestmentSort!]!, $filter: InvestmentRiskInvestmentFilter) {
  investmentList: investmentRiskInvestmentList(
    page: $page
    sort: $sort
    filter: $filter
  ) {
    items {
      id
      name
      performanceSourceEnumId
      bloombergCode
    }
    total
  }
}
    `;
export const GetManyPerformanceTwrrMtdDocument = gql`
    query getManyPerformanceTwrrMtd($investmentIds: [Int!]!, $returnType: ReturnTypes!, $minAsOfDate: DateTime, $maxAsOfDate: DateTime, $offset: Int, $limit: Int) {
  investmentMany(ids: $investmentIds) {
    id
    performanceMTD(
      page: {offset: $offset, limit: $limit}
      sort: {field: asOfDate, order: DESC}
      filter: {returnType: $returnType, asOfDateRange: {start: $minAsOfDate, end: $maxAsOfDate}}
    ) {
      returnYear
      returnMonth
      return
      asOfDate
      currency {
        id
        name
      }
    }
  }
}
    `;
export const GetManyPerformanceTwrrQtdDocument = gql`
    query getManyPerformanceTwrrQtd($investmentIds: [Int!]!, $returnType: ReturnTypes!, $minAsOfDate: DateTime, $maxAsOfDate: DateTime, $offset: Int, $limit: Int) {
  investmentMany(ids: $investmentIds) {
    id
    performanceQuarterly(
      page: {offset: $offset, limit: $limit}
      sort: {field: asOfDate, order: DESC}
      filter: {returnType: $returnType, asOfDateRange: {start: $minAsOfDate, end: $maxAsOfDate}}
    ) {
      returnYear
      returnQuarter
      return
    }
  }
}
    `;
export const GetManyPerformanceIrrDocument = gql`
    query getManyPerformanceIrr($investmentIds: [Int!]!, $minAsOfDate: DateTime, $maxAsOfDate: DateTime, $offset: Int, $limit: Int) {
  investmentMany(ids: $investmentIds) {
    id
    performancePrivate(
      page: {offset: $offset, limit: $limit}
      sort: {field: asOfDate, order: DESC}
      filter: {asOfDateRange: {start: $minAsOfDate, end: $maxAsOfDate}}
    ) {
      returnYear
      returnQuarter
      netIRR
    }
  }
}
    `;
export const BulkUpsertPerformancePrivateDocument = gql`
    mutation bulkUpsertPerformancePrivate($input: [ManyPerformancePrivate!]!) {
  bulkUpsertPerformancePrivate(input: $input) {
    total
  }
}
    `;
export const BulkUpsertPerformanceQuarterlyDocument = gql`
    mutation bulkUpsertPerformanceQuarterly($input: [ManyPerformanceQuarterly!]!) {
  bulkUpsertPerformanceQuarterly(input: $input) {
    total
  }
}
    `;
export const BulkUpsertPerformanceMtdDocument = gql`
    mutation bulkUpsertPerformanceMTD($input: [ManyPerformanceMTD!]!) {
  bulkUpsertPerformanceMTD(input: $input) {
    total
  }
}
    `;
export const GetOneInvestmentPerformancePrivateDocument = gql`
    query getOneInvestmentPerformancePrivate($investmentId: Int) {
  investment(id: $investmentId) {
    id
    name
    vintageYear
    firm {
      id
      name
    }
    portalSubmitted {
      migratedAt
    }
    performancePrivate(sort: {field: asOfDate, order: DESC}) {
      investmentId
      investment {
        id
        name
        vintageYear
      }
      returnYear
      returnQuarter
      netIRR
      tvpi
      dpi
    }
    portalSubmitted {
      migratedAt
    }
  }
}
    `;
export const GetListInvestmentPerformancePrivateDocument = gql`
    query getListInvestmentPerformancePrivate($investmentFilter: InvestmentFilterInput, $performancePrivateFilter: PerformancePrivateFilter) {
  investmentList(filter: $investmentFilter) {
    items {
      id
      name
      vintageYear
      firm {
        id
        name
      }
      portalSubmitted {
        migratedAt
      }
      performancePrivate(
        sort: {field: asOfDate, order: DESC}
        filter: $performancePrivateFilter
      ) {
        investmentId
        investment {
          id
          name
          vintageYear
        }
        returnYear
        returnQuarter
        netIRR
        tvpi
        dpi
      }
      portalSubmitted {
        migratedAt
      }
    }
    total
  }
}
    `;
export const GetManyInvestmentPerformancePrivateDocument = gql`
    query getManyInvestmentPerformancePrivate($ids: [Int!]!, $filter: PerformancePrivateFilter) {
  investmentMany(ids: $ids) {
    id
    name
    vintageYear
    firm {
      id
      name
    }
    portalSubmitted {
      migratedAt
    }
    performancePrivate(sort: {field: asOfDate, order: DESC}, filter: $filter) {
      investmentId
      investment {
        id
        name
        vintageYear
      }
      returnYear
      returnQuarter
      netIRR
      tvpi
      dpi
    }
    portalSubmitted {
      migratedAt
    }
  }
}
    `;
export const AddOrUpdatePerformancePrivateDocument = gql`
    mutation addOrUpdatePerformancePrivate($input: ManyPerformancePrivate!) {
  addOrUpdatePerformancePrivate(input: $input) {
    items {
      investmentId
      investment {
        id
        name
        vintageYear
      }
      returnYear
      returnQuarter
      netIRR
      tvpi
      dpi
    }
  }
}
    `;
export const GetListPerformanceSourceEnumDocument = gql`
    query getListPerformanceSourceEnum($page: PageInput, $sort: [PerformanceSourceEnumSort!]) {
  performanceSourceEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOnePerformanceSourceEnumDocument = gql`
    query getOnePerformanceSourceEnum($id: Int!) {
  performanceSourceEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyPerformanceSourceEnumDocument = gql`
    query getManyPerformanceSourceEnum($ids: [Int!]!) {
  performanceSourceEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetOnePerformanceStatisticsDocument = gql`
    query getOnePerformanceStatistics($id: Int!, $dependentIds: [Int!]!, $asOfDate: Date!) {
  investment(id: $id) {
    id
    inceptionDate
    groupStats(dependentIds: $dependentIds, asOfDate: $asOfDate) {
      items {
        id
      }
      stats {
        compoundReturn1m: compoundReturn(annualized: false)
        compoundReturn3m: compoundReturn(rangeOffset: 2, annualized: false)
        compoundReturn1y: compoundReturn(rangeOffset: 11, annualized: false)
        compoundReturn3y: compoundReturn(rangeOffset: 35, annualized: false)
        compoundReturn5y: compoundReturn(rangeOffset: 59, annualized: false)
        compoundReturnYtd: compoundReturn(rangeUnit: Y, annualized: false)
        compoundReturnItdAnnualized: compoundReturn(rangeUnit: I, annualized: true)
        standardDeviation3y: stdDev(rangeOffset: 35, annualized: true)
        sharpeRatio3y: sharpeRatio(rangeOffset: 35, annualized: true)
        maxDrawDown3y: maxDrawDown(rangeOffset: 35)
        percentProfitablePeriods3y: percentProfitablePeriods(rangeOffset: 35)
        startDate: inceptionDate
      }
    }
  }
}
    `;
export const GetManyPerformanceStatisticsDocument = gql`
    query getManyPerformanceStatistics($ids: [Int!]!, $endDate: Date) {
  investmentMany(ids: $ids) {
    performanceStats(endDate: $endDate) {
      id
      compoundReturn1m
      compoundReturn3m
      compoundReturn1y
      compoundReturn3y
      compoundReturn5y
      compoundReturnYtd
      compoundReturnItdAnnualized
      standardDeviation3y
      sharpeRatio3y
      maxDrawDown3y
      percentProfitablePeriods3y
      startDate
    }
  }
}
    `;
export const GetListPersonDocument = gql`
    query getListPerson($page: PageInput, $sort: [PersonSort!], $filter: PersonFilterInput, $searchFilters: [PersonSearchFilters!]) {
  personList(
    page: $page
    sort: $sort
    filter: $filter
    personSearchFilters: $searchFilters
  ) {
    items {
      ...personAttributes
      firmEmployment(filter: {isCurrent: true}) {
        firm {
          id
          name
        }
      }
    }
    total
  }
}
    ${PersonAttributesFragmentDoc}`;
export const GetOnePersonDocument = gql`
    query getOnePerson($id: Int!) {
  person(id: $id) {
    ...personAttributes
  }
}
    ${PersonAttributesFragmentDoc}`;
export const GetManyPersonDocument = gql`
    query getManyPerson($ids: [Int!]!) {
  personMany(ids: $ids) {
    ...personAttributes
  }
}
    ${PersonAttributesFragmentDoc}`;
export const CreatePersonDocument = gql`
    mutation createPerson($input: PersonInput!, $firmId: Int) {
  addPerson(input: $input, firmId: $firmId) {
    ...personAttributes
  }
}
    ${PersonAttributesFragmentDoc}`;
export const UpdatePersonDocument = gql`
    mutation updatePerson($id: Int!, $input: PersonInput!) {
  updatePerson(id: $id, input: $input) {
    ...personAttributes
  }
}
    ${PersonAttributesFragmentDoc}`;
export const GetListPersonEducationDocument = gql`
    query getListPersonEducation($page: PageInput, $sort: [PersonEducationSort!], $filter: PersonEducationFilterInput) {
  personEducationList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...personEducationAttributes
    }
    total
  }
}
    ${PersonEducationAttributesFragmentDoc}`;
export const GetOnePersonEducationDocument = gql`
    query getOnePersonEducation($id: Int!) {
  personEducation(id: $id) {
    ...personEducationAttributes
  }
}
    ${PersonEducationAttributesFragmentDoc}`;
export const GetManyPersonEducationDocument = gql`
    query getManyPersonEducation($ids: [Int!]!) {
  personEducationMany(ids: $ids) {
    ...personEducationAttributes
  }
}
    ${PersonEducationAttributesFragmentDoc}`;
export const GetManyReferencePersonEducationDocument = gql`
    query getManyReferencePersonEducation($page: PageInput, $sort: [PersonEducationSort!], $filter: PersonEducationFilterInput) {
  personEducationList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...personEducationAttributes
    }
    total
  }
}
    ${PersonEducationAttributesFragmentDoc}`;
export const CreatePersonEducationDocument = gql`
    mutation createPersonEducation($input: PersonEducationInput!) {
  addPersonEducation(input: $input) {
    ...personEducationAttributes
  }
}
    ${PersonEducationAttributesFragmentDoc}`;
export const UpdatePersonEducationDocument = gql`
    mutation updatePersonEducation($id: Int!, $input: PersonEducationInput!) {
  updatePersonEducation(id: $id, input: $input) {
    ...personEducationAttributes
  }
}
    ${PersonEducationAttributesFragmentDoc}`;
export const DeletePersonEducationDocument = gql`
    mutation deletePersonEducation($id: Int!) {
  deletePersonEducation(id: $id)
}
    `;
export const GetListPersonWorkExperienceDocument = gql`
    query getListPersonWorkExperience($page: PageInput, $sort: [PersonWorkExperienceSort!], $filter: PersonWorkExperienceFilterInput) {
  personWorkExperienceList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...personWorkExperienceAttributes
    }
    total
  }
}
    ${PersonWorkExperienceAttributesFragmentDoc}`;
export const GetOnePersonWorkExperienceDocument = gql`
    query getOnePersonWorkExperience($id: Int!) {
  personWorkExperience(id: $id) {
    ...personWorkExperienceAttributes
  }
}
    ${PersonWorkExperienceAttributesFragmentDoc}`;
export const GetManyPersonWorkExperienceDocument = gql`
    query getManyPersonWorkExperience($ids: [Int!]!) {
  personWorkExperienceMany(ids: $ids) {
    ...personWorkExperienceAttributes
  }
}
    ${PersonWorkExperienceAttributesFragmentDoc}`;
export const GetManyReferencePersonWorkExperienceDocument = gql`
    query getManyReferencePersonWorkExperience($page: PageInput, $sort: [PersonWorkExperienceSort!], $filter: PersonWorkExperienceFilterInput) {
  personWorkExperienceList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...personWorkExperienceAttributes
    }
    total
  }
}
    ${PersonWorkExperienceAttributesFragmentDoc}`;
export const CreatePersonWorkExperienceDocument = gql`
    mutation createPersonWorkExperience($input: PersonWorkExperienceInput!) {
  addPersonWorkExperience(input: $input) {
    ...personWorkExperienceAttributes
  }
}
    ${PersonWorkExperienceAttributesFragmentDoc}`;
export const UpdatePersonWorkExperienceDocument = gql`
    mutation updatePersonWorkExperience($id: Int!, $input: PersonWorkExperienceInput!) {
  updatePersonWorkExperience(id: $id, input: $input) {
    ...personWorkExperienceAttributes
  }
}
    ${PersonWorkExperienceAttributesFragmentDoc}`;
export const DeletePersonWorkExperienceDocument = gql`
    mutation deletePersonWorkExperience($id: Int!) {
  deletePersonWorkExperience(id: $id)
}
    `;
export const GetListEmailDomainOrganizationDocument = gql`
    query getListEmailDomainOrganization($page: PageInput, $sort: [EmailDomainOrganizationSort!], $filter: EmailDomainOrganizationFilter) {
  portalEmailDomainOrganizationList(page: $page, sort: $sort, filter: $filter) {
    items {
      organizationId
      emailDomain
    }
    total
  }
}
    `;
export const GetManyReferenceEmailDomainOrganizationDocument = gql`
    query getManyReferenceEmailDomainOrganization($page: PageInput, $sort: [EmailDomainOrganizationSort!], $filter: EmailDomainOrganizationFilter) {
  portalEmailDomainOrganizationList(page: $page, sort: $sort, filter: $filter) {
    items {
      organizationId
      emailDomain
    }
    total
  }
}
    `;
export const GetListPortalFirmDocument = gql`
    query getListPortalFirm($page: PageInput, $sort: [PortalFirmSort!], $filter: PortalFirmFilter) {
  portalFirmList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...portalFirmAttributes
    }
    total
  }
}
    ${PortalFirmAttributesFragmentDoc}`;
export const GetManyReferencePortalFirmDocument = gql`
    query getManyReferencePortalFirm($page: PageInput, $sort: [PortalFirmSort!], $filter: PortalFirmFilter) {
  portalFirmList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...portalFirmAttributes
    }
    total
  }
}
    ${PortalFirmAttributesFragmentDoc}`;
export const GetOnePortalFirmDocument = gql`
    query getOnePortalFirm($id: String!) {
  portalFirm(id: $id) {
    ...portalFirmAttributes
  }
}
    ${PortalFirmAttributesFragmentDoc}`;
export const GetManyPortalFirmDocument = gql`
    query getManyPortalFirm($ids: [String!]!) {
  portalFirmMany(ids: $ids) {
    ...portalFirmAttributes
  }
}
    ${PortalFirmAttributesFragmentDoc}`;
export const UpdatePortalFirmDocument = gql`
    mutation updatePortalFirm($id: String!, $input: PortalFirmInput!) {
  updatePortalFirm(id: $id, input: $input) {
    ...portalFirmAttributes
  }
}
    ${PortalFirmAttributesFragmentDoc}`;
export const DeletePortalFirmDocument = gql`
    mutation deletePortalFirm($id: ID!) {
  deletePortalFirm(id: $id)
}
    `;
export const GetListPortalFirmTypeEnumDocument = gql`
    query getListPortalFirmTypeEnum($page: PageInput, $sort: [PortalFirmTypeEnumSort!]) {
  portalFirmTypeEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOnePortalFirmTypeEnumDocument = gql`
    query getOnePortalFirmTypeEnum($id: Int!) {
  portalFirmTypeEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyPortalFirmTypeEnumDocument = gql`
    query getManyPortalFirmTypeEnum($ids: [Int!]!) {
  portalFirmTypeEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListPortalOrganizationDocument = gql`
    query getListPortalOrganization($page: PageInput, $sort: [PortalOrganizationSort!], $filter: PortalOrganizationFilter) {
  portalOrganizationList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...portalOrganizationAttributes
    }
    total
  }
}
    ${PortalOrganizationAttributesFragmentDoc}`;
export const GetOnePortalOrganizationDocument = gql`
    query getOnePortalOrganization($id: ID!) {
  portalOrganization(id: $id) {
    ...portalOrganizationAttributes
  }
}
    ${PortalOrganizationAttributesFragmentDoc}`;
export const GetManyReferencePortalOrganizationDocument = gql`
    query getManyReferencePortalOrganization($page: PageInput, $sort: [PortalOrganizationSort!], $filter: PortalOrganizationFilter) {
  portalOrganizationList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...portalOrganizationAttributes
    }
    total
  }
}
    ${PortalOrganizationAttributesFragmentDoc}`;
export const GetManyPortalOrganizationDocument = gql`
    query getManyPortalOrganization($ids: [ID!]!) {
  portalOrganizationMany(ids: $ids) {
    ...portalOrganizationAttributes
  }
}
    ${PortalOrganizationAttributesFragmentDoc}`;
export const UpdatePortalOrganizationDocument = gql`
    mutation updatePortalOrganization($id: ID!, $input: PortalOrganizationInput!) {
  updatePortalOrganization(id: $id, input: $input) {
    ...portalOrganizationAttributes
  }
}
    ${PortalOrganizationAttributesFragmentDoc}`;
export const AddPortalOrganizationDocument = gql`
    mutation addPortalOrganization($input: PortalOrganizationCreateInput!) {
  addPortalOrganization(input: $input) {
    ...portalOrganizationAttributes
  }
}
    ${PortalOrganizationAttributesFragmentDoc}`;
export const DeletePortalOrganizationDocument = gql`
    mutation deletePortalOrganization($id: ID!) {
  deletePortalOrganization(id: $id)
}
    `;
export const AddPortalServiceProviderFirmDocument = gql`
    mutation addPortalServiceProviderFirm($input: PortalServiceProviderFirmInput!) {
  addPortalServiceProviderFirm(input: $input) {
    id
    organizationId
    organization {
      id
      name
    }
    firmId
    firm {
      id
      name
      organization {
        id
        name
      }
      organizationId
    }
  }
}
    `;
export const GetOnePortalServiceProviderFirmDocument = gql`
    query getOnePortalServiceProviderFirm($id: Int!) {
  portalServiceProviderFirm(id: $id) {
    id
    organizationId
    organization {
      id
      name
    }
    firmId
    firm {
      id
      name
      organization {
        id
        name
      }
      organizationId
    }
  }
}
    `;
export const GetListPortalServiceProviderFirmDocument = gql`
    query getListPortalServiceProviderFirm($page: PageInput, $sort: [PortalServiceProviderFirmSort!], $filter: PortalServiceProviderFirmFilter) {
  portalServiceProviderFirmsList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      organizationId
      organization {
        id
        name
      }
      firmId
      firm {
        id
        name
        organization {
          id
          name
        }
        organizationId
      }
    }
    total
  }
}
    `;
export const DeletePortalServiceProviderFirmDocument = gql`
    mutation deletePortalServiceProviderFirm($id: Int!) {
  deletePortalServiceProviderFirm(id: $id)
}
    `;
export const GetListPortalSubmittedDocument = gql`
    query getListPortalSubmitted($filter: PortalSubmittedFilter, $sort: [PortalSubmittedSort!], $page: PageInput) {
  portalSubmittedList(filter: $filter, sort: $sort, page: $page) {
    items {
      ...PortalSubmittedFields
    }
    total
  }
}
    ${PortalSubmittedFieldsFragmentDoc}`;
export const GetOnePortalSubmittedDocument = gql`
    query getOnePortalSubmitted($id: String!) {
  portalSubmitted(id: $id) {
    ...PortalSubmittedFields
  }
}
    ${PortalSubmittedFieldsFragmentDoc}`;
export const UpdatePortalSubmittedDocument = gql`
    mutation updatePortalSubmitted($id: String!, $input: PortalSubmittedInput!) {
  updatePortalSubmitted(id: $id, input: $input) {
    ...PortalSubmittedFields
  }
}
    ${PortalSubmittedFieldsFragmentDoc}`;
export const DeletePortalSubmittedDocument = gql`
    mutation deletePortalSubmitted($id: ID!) {
  deletePortalSubmitted(id: $id)
}
    `;
export const GetListPortalUserDocument = gql`
    query getListPortalUser($page: PageInput, $sort: [PortalUserSort!], $filter: PortalUserFilter) {
  portalUserList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      organizationId
      organization {
        id
        name
      }
      firstName
      lastName
      email
      deleteDate
    }
    total
  }
}
    `;
export const GetManyReferencePortalUserDocument = gql`
    query getManyReferencePortalUser($page: PageInput, $sort: [PortalUserSort!], $filter: PortalUserFilter) {
  portalUserList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      organizationId
      organization {
        id
        name
      }
      firstName
      lastName
      email
      deleteDate
    }
    total
  }
}
    `;
export const GetOnePortalUserDocument = gql`
    query getOnePortalUser($id: ID!) {
  portalUser(id: $id) {
    id
    organizationId
    organization {
      id
      name
    }
    firstName
    lastName
    email
    deleteDate
  }
}
    `;
export const GetManyPortalUserDocument = gql`
    query getManyPortalUser($ids: [ID!]!) {
  portalUserMany(ids: $ids) {
    id
    organizationId
    organization {
      id
      name
    }
    firstName
    lastName
    email
    deleteDate
  }
}
    `;
export const UpdatePortalUserDocument = gql`
    mutation updatePortalUser($id: ID!, $input: PortalUserInput!) {
  updatePortalUser(id: $id, input: $input) {
    id
  }
}
    `;
export const DeletePortalUserDocument = gql`
    mutation deletePortalUser($id: ID!) {
  deletePortalUser(id: $id)
}
    `;
export const GetListPortfolioConfigDocument = gql`
    query getListPortfolioConfig($page: PageInput, $sort: [PortfolioConfigSort!], $filter: PortfolioConfigFilter) {
  portfolioConfigList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...portfolioConfigAttributes
    }
    total
  }
}
    ${PortfolioConfigAttributesFragmentDoc}`;
export const GetOnePortfolioConfigDocument = gql`
    query getOnePortfolioConfig($id: Int!) {
  portfolioConfig(id: $id) {
    ...portfolioConfigAttributes
  }
}
    ${PortfolioConfigAttributesFragmentDoc}`;
export const GetManyPortfolioConfigDocument = gql`
    query getManyPortfolioConfig($ids: [Int!]!) {
  portfolioConfigMany(ids: $ids) {
    ...portfolioConfigAttributes
  }
}
    ${PortfolioConfigAttributesFragmentDoc}`;
export const CreatePortfolioConfigDocument = gql`
    mutation createPortfolioConfig($input: PortfolioConfigInput!) {
  addPortfolioConfig(input: $input) {
    id
  }
}
    `;
export const UpdatePortfolioConfigDocument = gql`
    mutation updatePortfolioConfig($id: Int!, $input: PortfolioConfigInput!) {
  updatePortfolioConfig(id: $id, input: $input) {
    id
  }
}
    `;
export const GetListPortfolioFdpLoginsDocument = gql`
    query getListPortfolioFDPLogins($page: PageInput, $sort: [PortfolioFDPLoginsSort!], $filter: PortfolioFDPLoginsFilter) {
  portfolioFDPLoginsList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...portfolioFDPLoginsAttributes
    }
    total
  }
}
    ${PortfolioFdpLoginsAttributesFragmentDoc}`;
export const GetOnePortfolioFdpLoginsDocument = gql`
    query getOnePortfolioFDPLogins($id: Int!) {
  portfolioFDPLogins(id: $id) {
    ...portfolioFDPLoginsAttributes
  }
}
    ${PortfolioFdpLoginsAttributesFragmentDoc}`;
export const GetManyPortfolioFdpLoginsDocument = gql`
    query getManyPortfolioFDPLogins($ids: [Int!]!) {
  portfolioFDPLoginsMany(ids: $ids) {
    ...portfolioFDPLoginsAttributes
  }
}
    ${PortfolioFdpLoginsAttributesFragmentDoc}`;
export const CreatePortfolioFdpLoginsDocument = gql`
    mutation createPortfolioFDPLogins($input: PortfolioFDPLoginsInput!) {
  addPortfolioFDPLogins(input: $input) {
    id
  }
}
    `;
export const UpdatePortfolioFdpLoginsDocument = gql`
    mutation updatePortfolioFDPLogins($id: Int!, $input: PortfolioFDPLoginsInput!) {
  updatePortfolioFDPLogins(id: $id, input: $input) {
    id
  }
}
    `;
export const GetListPricingFrequencyEnumDocument = gql`
    query getListPricingFrequencyEnum($page: PageInput, $sort: [PricingFrequencyEnumSort!]) {
  pricingFrequencyEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOnePricingFrequencyEnumDocument = gql`
    query getOnePricingFrequencyEnum($id: Int!) {
  pricingFrequencyEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyPricingFrequencyEnumDocument = gql`
    query getManyPricingFrequencyEnum($ids: [Int!]!) {
  pricingFrequencyEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListPrivateQuartileGroupCategoryDocument = gql`
    query getListPrivateQuartileGroupCategory($filter: PrivateQuartileGroupCategoryFilter, $page: PageInput, $sort: [PrivateQuartileGroupCategorySort!]) {
  privateQuartileGroupCategoryList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      uniqueLabel
      displayLabel
    }
    total
  }
}
    `;
export const GetOnePrivateQuartileGroupCategoryDocument = gql`
    query getOnePrivateQuartileGroupCategory($id: Int!) {
  privateQuartileGroupCategory(id: $id) {
    id
    uniqueLabel
    displayLabel
  }
}
    `;
export const GetManyPrivateQuartileGroupCategoryDocument = gql`
    query getManyPrivateQuartileGroupCategory($ids: [Int!]!) {
  privateQuartileGroupCategoryMany(ids: $ids) {
    id
    uniqueLabel
    displayLabel
  }
}
    `;
export const GetInvestmentCompletenessHeadDocument = gql`
    query getInvestmentCompletenessHead {
  investmentCompletenessHead {
    category
    subcategory
    level
    percentComplete
  }
}
    `;
export const GetListProspectiveInvestmentDocument = gql`
    query getListProspectiveInvestment($searchFilters: [InvestmentSearchFilters!], $filter: InvestmentFilterInput, $sort: [InvestmentSort!], $page: PageInput) {
  investmentList(
    searchFilters: $searchFilters
    filter: $filter
    sort: $sort
    page: $page
  ) {
    total
    items {
      id
      name
      primaryAssignment
      completeness(memoized: true) {
        category
        subcategory
        level
        percentComplete
      }
    }
  }
}
    `;
export const GetListResultEnumDocument = gql`
    query getListResultEnum($page: PageInput, $sort: [ResultEnumSort!]) {
  resultEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneResultEnumDocument = gql`
    query getOneResultEnum($id: Int!) {
  resultEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyResultEnumDocument = gql`
    query getManyResultEnum($ids: [Int!]!) {
  resultEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListRightOfExtensionEnumDocument = gql`
    query getListRightOfExtensionEnum($page: PageInput, $sort: [RightOfExtensionEnumSort!]) {
  rightOfExtensionEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneRightOfExtensionEnumDocument = gql`
    query getOneRightOfExtensionEnum($id: Int!) {
  rightOfExtensionEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyRightOfExtensionEnumDocument = gql`
    query getManyRightOfExtensionEnum($ids: [Int!]!) {
  rightOfExtensionEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const RiskRefreshListDocument = gql`
    query riskRefreshList {
  riskRefreshList {
    items {
      id
      investment {
        id
        name
        firm {
          id
          name
        }
      }
    }
    total
  }
}
    `;
export const UpdateRiskRefreshListDocument = gql`
    mutation updateRiskRefreshList($add: [Int!], $remove: [Int!]) {
  updateRiskRefreshList(input: {add: $add, remove: $remove}) {
    items {
      id
    }
  }
}
    `;
export const GetListSchoolEnumDocument = gql`
    query getListSchoolEnum($page: PageInput, $sort: [SchoolEnumSort!], $filter: SchoolEnumFilter) {
  schoolEnumList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneSchoolEnumDocument = gql`
    query getOneSchoolEnum($id: Int!) {
  schoolEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManySchoolEnumDocument = gql`
    query getManySchoolEnum($ids: [Int!]!) {
  schoolEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListServiceProviderDocumentsDocument = gql`
    query getListServiceProviderDocuments($page: PageInput, $sort: [ServiceProviderDocumentsSort!], $filter: ServiceProviderDocumentsFilter) {
  serviceProviderDocumentsList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...serviceProviderDocumentAttributes
    }
    total
  }
}
    ${ServiceProviderDocumentAttributesFragmentDoc}`;
export const GetOneServiceProviderDocumentsDocument = gql`
    query getOneServiceProviderDocuments($id: Int!) {
  serviceProviderDocuments(id: $id) {
    ...serviceProviderDocumentAttributes
  }
}
    ${ServiceProviderDocumentAttributesFragmentDoc}`;
export const GetManyServiceProviderDocumentsDocument = gql`
    query getManyServiceProviderDocuments($ids: [Int!]!) {
  serviceProviderDocumentsMany(ids: $ids) {
    ...serviceProviderDocumentAttributes
  }
}
    ${ServiceProviderDocumentAttributesFragmentDoc}`;
export const CreateServiceProviderDocumentDocument = gql`
    mutation createServiceProviderDocument($input: ServiceProviderDocumentsInput!) {
  addServiceProviderDocuments(input: $input) {
    id
  }
}
    `;
export const UpdateServiceProviderDocumentDocument = gql`
    mutation updateServiceProviderDocument($id: Int!, $input: ServiceProviderDocumentsInput!) {
  updateServiceProviderDocuments(id: $id, input: $input) {
    id
  }
}
    `;
export const GetListServiceProviderDocumentTypeDocument = gql`
    query getListServiceProviderDocumentType($page: PageInput, $sort: [ServiceProviderDocumentTypeSort!], $filter: ServiceProviderDocumentTypeFilter) {
  serviceProviderDocumentTypeList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...serviceProviderDocumentTypeAttributes
    }
    total
  }
}
    ${ServiceProviderDocumentTypeAttributesFragmentDoc}`;
export const GetOneServiceProviderDocumentTypeDocument = gql`
    query getOneServiceProviderDocumentType($id: Int!) {
  serviceProviderDocumentType(id: $id) {
    ...serviceProviderDocumentTypeAttributes
  }
}
    ${ServiceProviderDocumentTypeAttributesFragmentDoc}`;
export const GetManyServiceProviderDocumentTypeDocument = gql`
    query getManyServiceProviderDocumentType($ids: [Int!]!) {
  serviceProviderDocumentTypeMany(ids: $ids) {
    ...serviceProviderDocumentTypeAttributes
  }
}
    ${ServiceProviderDocumentTypeAttributesFragmentDoc}`;
export const GetListServiceProviderFirmDocument = gql`
    query getListServiceProviderFirm($page: PageInput, $sort: [ServiceProviderFirmSort!], $filter: ServiceProviderFirmFilter) {
  serviceProviderFirmList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...serviceProviderFirmAttributes
    }
    total
  }
}
    ${ServiceProviderFirmAttributesFragmentDoc}`;
export const GetOneServiceProviderFirmDocument = gql`
    query getOneServiceProviderFirm($id: Int!) {
  serviceProviderFirm(id: $id) {
    ...serviceProviderFirmAttributes
  }
}
    ${ServiceProviderFirmAttributesFragmentDoc}`;
export const GetManyServiceProviderFirmDocument = gql`
    query getManyServiceProviderFirm($ids: [Int!]!) {
  serviceProviderFirmMany(ids: $ids) {
    ...serviceProviderFirmAttributes
  }
}
    ${ServiceProviderFirmAttributesFragmentDoc}`;
export const CreateServiceProviderFirmDocument = gql`
    mutation createServiceProviderFirm($input: ServiceProviderFirmInput!) {
  addServiceProviderFirm(input: $input) {
    ...serviceProviderFirmAttributes
  }
}
    ${ServiceProviderFirmAttributesFragmentDoc}`;
export const UpdateServiceProviderFirmDocument = gql`
    mutation updateServiceProviderFirm($id: Int!, $input: ServiceProviderFirmInput!) {
  updateServiceProviderFirm(id: $id, input: $input) {
    ...serviceProviderFirmAttributes
  }
}
    ${ServiceProviderFirmAttributesFragmentDoc}`;
export const GetListServiceProviderNotesDocument = gql`
    query getListServiceProviderNotes($page: PageInput, $sort: [ServiceProviderNotesSort!], $filter: ServiceProviderNotesFilter) {
  serviceProviderNotesList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...serviceProviderNotesAttributes
    }
    total
  }
}
    ${ServiceProviderNotesAttributesFragmentDoc}`;
export const GetOneServiceProviderNotesDocument = gql`
    query getOneServiceProviderNotes($id: Int!) {
  serviceProviderNotes(id: $id) {
    ...serviceProviderNotesAttributes
  }
}
    ${ServiceProviderNotesAttributesFragmentDoc}`;
export const GetManyServiceProviderNotesDocument = gql`
    query getManyServiceProviderNotes($ids: [Int!]!) {
  serviceProviderNotesMany(ids: $ids) {
    ...serviceProviderNotesAttributes
  }
}
    ${ServiceProviderNotesAttributesFragmentDoc}`;
export const CreateServiceProviderNotesDocument = gql`
    mutation createServiceProviderNotes($input: ServiceProviderNotesInput!) {
  addServiceProviderNotes(input: $input) {
    id
  }
}
    `;
export const UpdateServiceProviderNotesDocument = gql`
    mutation updateServiceProviderNotes($id: Int!, $input: ServiceProviderNotesInput!) {
  updateServiceProviderNotes(id: $id, input: $input) {
    id
  }
}
    `;
export const GetListSetDocument = gql`
    query getListSet($page: PageInput, $sort: [SetSort!], $filter: SetFilter) {
  setList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...setAttributes
    }
    total
  }
}
    ${SetAttributesFragmentDoc}`;
export const GetOneSetDocument = gql`
    query getOneSet($id: Int!) {
  set(id: $id) {
    ...setAttributes
  }
}
    ${SetAttributesFragmentDoc}`;
export const GetManySetDocument = gql`
    query getManySet($ids: [Int!]!) {
  setMany(ids: $ids) {
    ...setAttributes
  }
}
    ${SetAttributesFragmentDoc}`;
export const CreateSetDocument = gql`
    mutation createSet($input: SetInput!) {
  addSet(input: $input) {
    id
  }
}
    `;
export const UpdateSetDocument = gql`
    mutation updateSet($id: Int!, $input: SetInput!) {
  updateSet(id: $id, input: $input) {
    id
  }
}
    `;
export const GetListShareClassDocument = gql`
    query getListShareClass($page: PageInput, $sort: [ShareClassSort!], $filter: ShareClassFilter) {
  shareClassList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...shareClassAttributes
    }
    total
  }
}
    ${ShareClassAttributesFragmentDoc}`;
export const GetOneShareClassDocument = gql`
    query getOneShareClass($id: Int!) {
  shareClass(id: $id) {
    ...shareClassAttributes
  }
}
    ${ShareClassAttributesFragmentDoc}`;
export const GetManyShareClassDocument = gql`
    query getManyShareClass($ids: [Int!]!) {
  shareClassMany(ids: $ids) {
    ...shareClassAttributes
  }
}
    ${ShareClassAttributesFragmentDoc}`;
export const CreateShareClassDocument = gql`
    mutation createShareClass($input: ShareClassInput!) {
  addShareClass(input: $input) {
    id
  }
}
    `;
export const UpdateShareClassDocument = gql`
    mutation updateShareClass($id: Int!, $input: ShareClassInput!) {
  updateShareClass(id: $id, input: $input) {
    id
  }
}
    `;
export const DeleteShareClassDocument = gql`
    mutation deleteShareClass($id: Int!) {
  deleteShareClass(id: $id)
}
    `;
export const GetListSharedGroupEntityDocument = gql`
    query getListSharedGroupEntity($page: PageInput, $sort: [SharedGroupEntitySort!], $filter: SharedGroupEntityFilter) {
  sharedGroupEntityList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...sharedGroupEntityAttributes
    }
    total
  }
}
    ${SharedGroupEntityAttributesFragmentDoc}`;
export const GetOneSharedGroupEntityDocument = gql`
    query getOneSharedGroupEntity($id: Int!) {
  sharedGroupEntity(id: $id) {
    ...sharedGroupEntityAttributes
  }
}
    ${SharedGroupEntityAttributesFragmentDoc}`;
export const GetManySharedGroupEntityDocument = gql`
    query getManySharedGroupEntity($ids: [Int!]!) {
  sharedGroupEntityMany(ids: $ids) {
    ...sharedGroupEntityAttributes
  }
}
    ${SharedGroupEntityAttributesFragmentDoc}`;
export const GetListSoftLockupDocument = gql`
    query getListSoftLockup($page: PageInput, $sort: [SoftLockupSort!], $filter: SoftLockupFilter) {
  softLockupList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...softLockupAttributes
    }
    total
  }
}
    ${SoftLockupAttributesFragmentDoc}`;
export const GetOneSoftLockupDocument = gql`
    query getOneSoftLockup($id: Int!) {
  softLockup(id: $id) {
    ...softLockupAttributes
  }
}
    ${SoftLockupAttributesFragmentDoc}`;
export const GetManySoftLockupDocument = gql`
    query getManySoftLockup($ids: [Int!]!) {
  softLockupMany(ids: $ids) {
    ...softLockupAttributes
  }
}
    ${SoftLockupAttributesFragmentDoc}`;
export const GetListStageEnumDocument = gql`
    query getListStageEnum($page: PageInput, $sort: [StageEnumSort!]) {
  stageEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneStageEnumDocument = gql`
    query getOneStageEnum($id: Int!) {
  stageEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyStageEnumDocument = gql`
    query getManyStageEnum($ids: [Int!]!) {
  stageEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListStateEnumDocument = gql`
    query getListStateEnum($page: PageInput, $sort: [StateEnumSort!]) {
  stateEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneStateEnumDocument = gql`
    query getOneStateEnum($id: Int!) {
  stateEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyStateEnumDocument = gql`
    query getManyStateEnum($ids: [Int!]!) {
  stateEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListStrategyEnumDocument = gql`
    query getListStrategyEnum($page: PageInput, $sort: [StrategyEnumSort!]) {
  strategyEnumList(page: $page, sort: $sort) {
    items {
      id
      name
      subStrategies {
        id
        name
      }
    }
    total
  }
}
    `;
export const GetListStrategyEnumOptionsDocument = gql`
    query getListStrategyEnumOptions($filter: TypeAssetClassStrategyOptionsFilterInput, $sort: [TypeAssetClassStrategyOptionsSort!]) {
  strategyOptions(sort: $sort, filter: $filter) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneStrategyEnumDocument = gql`
    query getOneStrategyEnum($id: Int!) {
  strategyEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyStrategyEnumDocument = gql`
    query getManyStrategyEnum($ids: [Int!]!) {
  strategyEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListSubStrategyEnumDocument = gql`
    query getListSubStrategyEnum($page: PageInput, $sort: [SubStrategyEnumSort!], $filter: SubStrategyEnumFilterInput) {
  subStrategyEnumList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneSubStrategyEnumDocument = gql`
    query getOneSubStrategyEnum($id: Int!) {
  subStrategyEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManySubStrategyEnumDocument = gql`
    query getManySubStrategyEnum($ids: [Int!]!) {
  subStrategyEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListTagClassesDocument = gql`
    query getListTagClasses($page: PageInput, $sort: [TagClassSort!], $filter: TagClassFilterInput) {
  tagClassList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      name
      displayOrder
      tags {
        items {
          id
          name
        }
      }
    }
    total
  }
}
    `;
export const GetManyTagClassesDocument = gql`
    query getManyTagClasses($ids: [Int!]!) {
  tagClassMany(ids: $ids) {
    id
    name
    displayOrder
  }
}
    `;
export const GetOneTagClassesDocument = gql`
    query getOneTagClasses($id: Int!) {
  tagClass(id: $id) {
    id
    name
    displayOrder
  }
}
    `;
export const GetListTagDocument = gql`
    query getListTag($page: PageInput, $sort: [TagSort!], $filter: TagFilterInput) {
  tagList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      name
      tagClassId
      displayOrder
    }
    total
  }
}
    `;
export const GetManyTagDocument = gql`
    query getManyTag($ids: [Int!]!) {
  tagMany(ids: $ids) {
    id
    name
    tagClassId
    displayOrder
  }
}
    `;
export const GetOneTagDocument = gql`
    query getOneTag($id: Int!) {
  tag(id: $id) {
    id
    name
    tagClassId
    displayOrder
  }
}
    `;
export const GetManyReferenceTagDocument = gql`
    query getManyReferenceTag($page: PageInput, $sort: [TagSort!], $filter: TagFilterInput) {
  tagList(page: $page, sort: $sort, filter: $filter) {
    items {
      id
      name
      tagClassId
      displayOrder
      tagClass {
        id
        name
        displayOrder
      }
    }
    total
  }
}
    `;
export const GetListTitleEnumDocument = gql`
    query getListTitleEnum($page: PageInput, $sort: [TitleEnumSort!]) {
  titleEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneTitleEnumDocument = gql`
    query getOneTitleEnum($id: Int!) {
  titleEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyTitleEnumDocument = gql`
    query getManyTitleEnum($ids: [Int!]!) {
  titleEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListUserDocument = gql`
    query getListUser($sort: [UserSort!], $page: PageInput, $filter: UserFilterInput) {
  userList(sort: $sort, page: $page, filter: $filter) {
    items {
      ...userListAttributes
    }
    total
  }
}
    ${UserListAttributesFragmentDoc}`;
export const GetManyUserDocument = gql`
    query getManyUser($userNames: [String!]) {
  userList(filter: {userNames: $userNames}) {
    items {
      ...userListAttributes
    }
    total
  }
}
    ${UserListAttributesFragmentDoc}`;
export const GetOneUserDocument = gql`
    query getOneUser($id: Int) {
  user(id: $id) {
    ...userAttributes
  }
}
    ${UserAttributesFragmentDoc}`;
export const CreateUserDocument = gql`
    mutation createUser($input: UserCreateInput!) {
  createUser(input: $input) {
    id
  }
}
    `;
export const CreateUserGroupDocument = gql`
    mutation createUserGroup($input: UserGroupCreateInput!) {
  createUserGroup(input: $input) {
    id
  }
}
    `;
export const UpdateUserGroupDocument = gql`
    mutation updateUserGroup($id: Int!, $input: UserGroupUpdateInput!) {
  updateUserGroup(id: $id, input: $input) {
    id
  }
}
    `;
export const UpdateUserDocument = gql`
    mutation updateUser($id: Int!, $input: UserUpdateInput!) {
  updateUser(id: $id, input: $input) {
    id
  }
}
    `;
export const ActivateUserDocument = gql`
    mutation activateUser($id: Int!) {
  activateUser(id: $id) {
    id
  }
}
    `;
export const DeactivateUserDocument = gql`
    mutation deactivateUser($id: Int!) {
  deactivateUser(id: $id) {
    id
  }
}
    `;
export const GetListUserActivityDocument = gql`
    query getListUserActivity($sort: [UserActivitySort!], $page: PageInput, $filter: UserActivityFilter) {
  userActivityList(sort: $sort, page: $page, filter: $filter) {
    items {
      id
      createDate
      email
      adEntryId
      applicationId
      rcgApplicationVersion
      requestUri
      requestUtc
    }
    total
  }
}
    `;
export const GetManyUserActivityDocument = gql`
    query getManyUserActivity($ids: [ID!]) {
  userActivityList(filter: {ids: $ids}) {
    items {
      id
      createDate
      email
      adEntryId
      applicationId
      rcgApplicationVersion
      requestUri
      requestUtc
    }
    total
  }
}
    `;
export const GetOneUserActivityDocument = gql`
    query getOneUserActivity($id: ID!) {
  userActivity(id: $id) {
    id
    createDate
    email
    adEntryId
    applicationId
    rcgApplicationVersion
    requestUri
    requestUtc
  }
}
    `;
export const GetListUsersXGroupsDocument = gql`
    query getListUsersXGroups($page: PageInput, $sort: [UsersXGroupsSort!], $filter: UsersXGroupsFilter) {
  usersXGroupsList(page: $page, sort: $sort, filter: $filter) {
    items {
      ...usersXGroupsAttributes
    }
    total
  }
}
    ${UsersXGroupsAttributesFragmentDoc}`;
export const GetOneUsersXGroupsDocument = gql`
    query getOneUsersXGroups($id: ID!) {
  usersXGroups(id: $id) {
    ...usersXGroupsAttributes
  }
}
    ${UsersXGroupsAttributesFragmentDoc}`;
export const GetManyUsersXGroupsDocument = gql`
    query getManyUsersXGroups($ids: [ID!]!) {
  usersXGroupsMany(ids: $ids) {
    ...usersXGroupsAttributes
  }
}
    ${UsersXGroupsAttributesFragmentDoc}`;
export const CreateUsersXGroupsDocument = gql`
    mutation createUsersXGroups($input: UsersXGroupsInput!) {
  addUsersXGroups(input: $input) {
    id
  }
}
    `;
export const UpdateUsersXGroupsDocument = gql`
    mutation updateUsersXGroups($id: ID!, $input: UsersXGroupsInput!) {
  updateUsersXGroups(id: $id, input: $input) {
    id
  }
}
    `;
export const DeleteUsersXGroupsDocument = gql`
    mutation deleteUsersXGroups($id: ID!) {
  deleteUsersXGroups(id: $id)
}
    `;
export const GetListVehicleTypeEnumOptionsDocument = gql`
    query getListVehicleTypeEnumOptions($filter: TypeAssetClassStrategyOptionsFilterInput, $sort: [TypeAssetClassStrategyOptionsSort!]) {
  vehicleTypeOptions(sort: $sort, filter: $filter) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneVehicleTypeEnumDocument = gql`
    query getOneVehicleTypeEnum($id: Int!) {
  vehicleTypeEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyVehicleTypeEnumDocument = gql`
    query getManyVehicleTypeEnum($ids: [Int!]!) {
  vehicleTypeEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetListWorkoutEnumDocument = gql`
    query getListWorkoutEnum($page: PageInput, $sort: [WorkoutEnumSort!]) {
  workoutEnumList(page: $page, sort: $sort) {
    items {
      id
      name
    }
    total
  }
}
    `;
export const GetOneWorkoutEnumDocument = gql`
    query getOneWorkoutEnum($id: Int!) {
  workoutEnum(id: $id) {
    id
    name
  }
}
    `;
export const GetManyWorkoutEnumDocument = gql`
    query getManyWorkoutEnum($ids: [Int!]!) {
  workoutEnumMany(ids: $ids) {
    id
    name
  }
}
    `;
export const GetUserMutationAccessibleDocument = gql`
    query getUserMutationAccessible($mutationName: String!, $mutationArgs: String!) {
  userMutationAccessible(mutationName: $mutationName, mutationArgs: $mutationArgs) {
    canAccess
    fieldAccess {
      field
      canInput
      pointer
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    ClientInvestmentFunds(variables?: ClientInvestmentFundsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ClientInvestmentFundsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ClientInvestmentFundsQuery>(ClientInvestmentFundsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ClientInvestmentFunds', 'query');
    },
    ClientInvestmentClients(variables?: ClientInvestmentClientsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ClientInvestmentClientsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ClientInvestmentClientsQuery>(ClientInvestmentClientsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ClientInvestmentClients', 'query');
    },
    ClientFeeOptions(variables?: ClientFeeOptionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ClientFeeOptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ClientFeeOptionsQuery>(ClientFeeOptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ClientFeeOptions', 'query');
    },
    ClientShareClasses(variables: ClientShareClassesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ClientShareClassesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ClientShareClassesQuery>(ClientShareClassesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ClientShareClasses', 'query');
    },
    ClientCapitalFlows(variables: ClientCapitalFlowsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ClientCapitalFlowsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ClientCapitalFlowsQuery>(ClientCapitalFlowsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ClientCapitalFlows', 'query');
    },
    ClientSwitches(variables: ClientSwitchesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ClientSwitchesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ClientSwitchesQuery>(ClientSwitchesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ClientSwitches', 'query');
    },
    ClientAllocations(variables?: ClientAllocationsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ClientAllocationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ClientAllocationsQuery>(ClientAllocationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ClientAllocations', 'query');
    },
    ClientInvestmentsAsyncTaskStatus(variables: ClientInvestmentsAsyncTaskStatusQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ClientInvestmentsAsyncTaskStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ClientInvestmentsAsyncTaskStatusQuery>(ClientInvestmentsAsyncTaskStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ClientInvestmentsAsyncTaskStatus', 'query');
    },
    SaveClientShareClass(variables: SaveClientShareClassMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SaveClientShareClassMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveClientShareClassMutation>(SaveClientShareClassDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SaveClientShareClass', 'mutation');
    },
    DeleteClientShareClass(variables: DeleteClientShareClassMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteClientShareClassMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteClientShareClassMutation>(DeleteClientShareClassDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteClientShareClass', 'mutation');
    },
    SaveClientCashFlow(variables: SaveClientCashFlowMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SaveClientCashFlowMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveClientCashFlowMutation>(SaveClientCashFlowDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SaveClientCashFlow', 'mutation');
    },
    SaveClientSwitch(variables: SaveClientSwitchMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SaveClientSwitchMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveClientSwitchMutation>(SaveClientSwitchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SaveClientSwitch', 'mutation');
    },
    SaveClientMonthEntries(variables: SaveClientMonthEntriesMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SaveClientMonthEntriesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveClientMonthEntriesMutation>(SaveClientMonthEntriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SaveClientMonthEntries', 'mutation');
    },
    ImportClientPortfolioReturns(variables?: ImportClientPortfolioReturnsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ImportClientPortfolioReturnsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ImportClientPortfolioReturnsMutation>(ImportClientPortfolioReturnsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ImportClientPortfolioReturns', 'mutation');
    },
    completeApplication(variables: CompleteApplicationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CompleteApplicationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompleteApplicationMutation>(CompleteApplicationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'completeApplication', 'mutation');
    },
    getApplicantCompany(variables?: GetApplicantCompanyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetApplicantCompanyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetApplicantCompanyQuery>(GetApplicantCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getApplicantCompany', 'query');
    },
    GetUploadUrl(variables: GetUploadUrlQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetUploadUrlQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUploadUrlQuery>(GetUploadUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetUploadUrl', 'query');
    },
    RematchDocumentQueueEntities(variables: RematchDocumentQueueEntitiesMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RematchDocumentQueueEntitiesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RematchDocumentQueueEntitiesMutation>(RematchDocumentQueueEntitiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RematchDocumentQueueEntities', 'mutation');
    },
    EarlyEstimates(variables: EarlyEstimatesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<EarlyEstimatesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EarlyEstimatesQuery>(EarlyEstimatesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'EarlyEstimates', 'query');
    },
    SaveEarlyEstimates(variables: SaveEarlyEstimatesMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SaveEarlyEstimatesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveEarlyEstimatesMutation>(SaveEarlyEstimatesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SaveEarlyEstimates', 'mutation');
    },
    GetOrganizationIconUploadUrl(variables: GetOrganizationIconUploadUrlQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOrganizationIconUploadUrlQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrganizationIconUploadUrlQuery>(GetOrganizationIconUploadUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetOrganizationIconUploadUrl', 'query');
    },
    ConfirmOrganizationIconUpload(variables: ConfirmOrganizationIconUploadMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ConfirmOrganizationIconUploadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConfirmOrganizationIconUploadMutation>(ConfirmOrganizationIconUploadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ConfirmOrganizationIconUpload', 'mutation');
    },
    ReportRecipients(variables?: ReportRecipientsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ReportRecipientsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReportRecipientsQuery>(ReportRecipientsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ReportRecipients', 'query');
    },
    SaveReportRecipient(variables: SaveReportRecipientMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SaveReportRecipientMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveReportRecipientMutation>(SaveReportRecipientDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SaveReportRecipient', 'mutation');
    },
    DeleteReportRecipient(variables: DeleteReportRecipientMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteReportRecipientMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteReportRecipientMutation>(DeleteReportRecipientDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteReportRecipient', 'mutation');
    },
    getListAccountTypeEnum(variables?: GetListAccountTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListAccountTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListAccountTypeEnumQuery>(GetListAccountTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListAccountTypeEnum', 'query');
    },
    getOneAccountTypeEnum(variables: GetOneAccountTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneAccountTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneAccountTypeEnumQuery>(GetOneAccountTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneAccountTypeEnum', 'query');
    },
    getManyAccountTypeEnum(variables: GetManyAccountTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyAccountTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyAccountTypeEnumQuery>(GetManyAccountTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyAccountTypeEnum', 'query');
    },
    getListAdEntriesXApplicationFlags(variables?: GetListAdEntriesXApplicationFlagsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListAdEntriesXApplicationFlagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListAdEntriesXApplicationFlagsQuery>(GetListAdEntriesXApplicationFlagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListAdEntriesXApplicationFlags', 'query');
    },
    getOneAdEntriesXApplicationFlags(variables: GetOneAdEntriesXApplicationFlagsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneAdEntriesXApplicationFlagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneAdEntriesXApplicationFlagsQuery>(GetOneAdEntriesXApplicationFlagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneAdEntriesXApplicationFlags', 'query');
    },
    getManyAdEntriesXApplicationFlags(variables: GetManyAdEntriesXApplicationFlagsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyAdEntriesXApplicationFlagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyAdEntriesXApplicationFlagsQuery>(GetManyAdEntriesXApplicationFlagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyAdEntriesXApplicationFlags', 'query');
    },
    createAdEntriesXApplicationFlags(variables: CreateAdEntriesXApplicationFlagsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateAdEntriesXApplicationFlagsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAdEntriesXApplicationFlagsMutation>(CreateAdEntriesXApplicationFlagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createAdEntriesXApplicationFlags', 'mutation');
    },
    updateAdEntriesXApplicationFlags(variables: UpdateAdEntriesXApplicationFlagsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateAdEntriesXApplicationFlagsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAdEntriesXApplicationFlagsMutation>(UpdateAdEntriesXApplicationFlagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateAdEntriesXApplicationFlags', 'mutation');
    },
    deleteAdEntriesXApplicationFlags(variables: DeleteAdEntriesXApplicationFlagsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteAdEntriesXApplicationFlagsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteAdEntriesXApplicationFlagsMutation>(DeleteAdEntriesXApplicationFlagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteAdEntriesXApplicationFlags', 'mutation');
    },
    getListAdEntriesXApplicationsXSets(variables?: GetListAdEntriesXApplicationsXSetsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListAdEntriesXApplicationsXSetsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListAdEntriesXApplicationsXSetsQuery>(GetListAdEntriesXApplicationsXSetsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListAdEntriesXApplicationsXSets', 'query');
    },
    getOneAdEntriesXApplicationsXSets(variables: GetOneAdEntriesXApplicationsXSetsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneAdEntriesXApplicationsXSetsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneAdEntriesXApplicationsXSetsQuery>(GetOneAdEntriesXApplicationsXSetsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneAdEntriesXApplicationsXSets', 'query');
    },
    getManyAdEntriesXApplicationsXSets(variables: GetManyAdEntriesXApplicationsXSetsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyAdEntriesXApplicationsXSetsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyAdEntriesXApplicationsXSetsQuery>(GetManyAdEntriesXApplicationsXSetsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyAdEntriesXApplicationsXSets', 'query');
    },
    createAdEntriesXApplicationsXSets(variables: CreateAdEntriesXApplicationsXSetsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateAdEntriesXApplicationsXSetsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAdEntriesXApplicationsXSetsMutation>(CreateAdEntriesXApplicationsXSetsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createAdEntriesXApplicationsXSets', 'mutation');
    },
    updateAdEntriesXApplicationsXSets(variables: UpdateAdEntriesXApplicationsXSetsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateAdEntriesXApplicationsXSetsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAdEntriesXApplicationsXSetsMutation>(UpdateAdEntriesXApplicationsXSetsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateAdEntriesXApplicationsXSets', 'mutation');
    },
    deleteAdEntriesXApplicationsXSets(variables: DeleteAdEntriesXApplicationsXSetsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteAdEntriesXApplicationsXSetsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteAdEntriesXApplicationsXSetsMutation>(DeleteAdEntriesXApplicationsXSetsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteAdEntriesXApplicationsXSets', 'mutation');
    },
    getListAdvisorTypeEnum(variables?: GetListAdvisorTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListAdvisorTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListAdvisorTypeEnumQuery>(GetListAdvisorTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListAdvisorTypeEnum', 'query');
    },
    getOneAdvisorTypeEnum(variables: GetOneAdvisorTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneAdvisorTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneAdvisorTypeEnumQuery>(GetOneAdvisorTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneAdvisorTypeEnum', 'query');
    },
    getManyAdvisorTypeEnum(variables: GetManyAdvisorTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyAdvisorTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyAdvisorTypeEnumQuery>(GetManyAdvisorTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyAdvisorTypeEnum', 'query');
    },
    getListAgency(variables?: GetListAgencyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListAgencyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListAgencyQuery>(GetListAgencyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListAgency', 'query');
    },
    getOneAgency(variables: GetOneAgencyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneAgencyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneAgencyQuery>(GetOneAgencyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneAgency', 'query');
    },
    getManyAgency(variables: GetManyAgencyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyAgencyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyAgencyQuery>(GetManyAgencyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyAgency', 'query');
    },
    getListApplication(variables?: GetListApplicationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListApplicationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListApplicationQuery>(GetListApplicationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListApplication', 'query');
    },
    getOneApplication(variables: GetOneApplicationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneApplicationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneApplicationQuery>(GetOneApplicationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneApplication', 'query');
    },
    getManyApplication(variables: GetManyApplicationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyApplicationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyApplicationQuery>(GetManyApplicationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyApplication', 'query');
    },
    getListApplicationFlag(variables?: GetListApplicationFlagQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListApplicationFlagQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListApplicationFlagQuery>(GetListApplicationFlagDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListApplicationFlag', 'query');
    },
    getOneApplicationFlag(variables: GetOneApplicationFlagQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneApplicationFlagQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneApplicationFlagQuery>(GetOneApplicationFlagDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneApplicationFlag', 'query');
    },
    getManyApplicationFlag(variables: GetManyApplicationFlagQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyApplicationFlagQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyApplicationFlagQuery>(GetManyApplicationFlagDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyApplicationFlag', 'query');
    },
    getListAssetClass2Enum(variables?: GetListAssetClass2EnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListAssetClass2EnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListAssetClass2EnumQuery>(GetListAssetClass2EnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListAssetClass2Enum', 'query');
    },
    getListAssetClass2EnumOptions(variables?: GetListAssetClass2EnumOptionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListAssetClass2EnumOptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListAssetClass2EnumOptionsQuery>(GetListAssetClass2EnumOptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListAssetClass2EnumOptions', 'query');
    },
    getOneAssetClass2Enum(variables: GetOneAssetClass2EnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneAssetClass2EnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneAssetClass2EnumQuery>(GetOneAssetClass2EnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneAssetClass2Enum', 'query');
    },
    getManyAssetClass2Enum(variables: GetManyAssetClass2EnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyAssetClass2EnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyAssetClass2EnumQuery>(GetManyAssetClass2EnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyAssetClass2Enum', 'query');
    },
    getListMarketEnum(variables?: GetListMarketEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListMarketEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListMarketEnumQuery>(GetListMarketEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListMarketEnum', 'query');
    },
    getOneMarketEnum(variables: GetOneMarketEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneMarketEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneMarketEnumQuery>(GetOneMarketEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneMarketEnum', 'query');
    },
    getManyMarketEnum(variables: GetManyMarketEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyMarketEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyMarketEnumQuery>(GetManyMarketEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyMarketEnum', 'query');
    },
    getOneAsyncTaskStatus(variables: GetOneAsyncTaskStatusQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneAsyncTaskStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneAsyncTaskStatusQuery>(GetOneAsyncTaskStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneAsyncTaskStatus', 'query');
    },
    getListAuditContactTypeEnum(variables?: GetListAuditContactTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListAuditContactTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListAuditContactTypeEnumQuery>(GetListAuditContactTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListAuditContactTypeEnum', 'query');
    },
    getOneAuditContactTypeEnum(variables: GetOneAuditContactTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneAuditContactTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneAuditContactTypeEnumQuery>(GetOneAuditContactTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneAuditContactTypeEnum', 'query');
    },
    getManyAuditContactTypeEnum(variables: GetManyAuditContactTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyAuditContactTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyAuditContactTypeEnumQuery>(GetManyAuditContactTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyAuditContactTypeEnum', 'query');
    },
    getOneInvestmentAum(variables: GetOneInvestmentAumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneInvestmentAumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneInvestmentAumQuery>(GetOneInvestmentAumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneInvestmentAum', 'query');
    },
    bulkUpdateAUM(variables: BulkUpdateAumMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BulkUpdateAumMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BulkUpdateAumMutation>(BulkUpdateAumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bulkUpdateAUM', 'mutation');
    },
    getListAxysCode(variables?: GetListAxysCodeQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListAxysCodeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListAxysCodeQuery>(GetListAxysCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListAxysCode', 'query');
    },
    getOneAxysCode(variables: GetOneAxysCodeQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneAxysCodeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneAxysCodeQuery>(GetOneAxysCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneAxysCode', 'query');
    },
    getManyAxysCode(variables: GetManyAxysCodeQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyAxysCodeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyAxysCodeQuery>(GetManyAxysCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyAxysCode', 'query');
    },
    getListBusinessObjectEnum(variables?: GetListBusinessObjectEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListBusinessObjectEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListBusinessObjectEnumQuery>(GetListBusinessObjectEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListBusinessObjectEnum', 'query');
    },
    getOneBusinessObjectEnum(variables: GetOneBusinessObjectEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneBusinessObjectEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneBusinessObjectEnumQuery>(GetOneBusinessObjectEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneBusinessObjectEnum', 'query');
    },
    getManyBusinessObjectEnum(variables: GetManyBusinessObjectEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyBusinessObjectEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyBusinessObjectEnumQuery>(GetManyBusinessObjectEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyBusinessObjectEnum', 'query');
    },
    getListCalendarUnitEnum(variables?: GetListCalendarUnitEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListCalendarUnitEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListCalendarUnitEnumQuery>(GetListCalendarUnitEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListCalendarUnitEnum', 'query');
    },
    getOneCalendarUnitEnum(variables: GetOneCalendarUnitEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneCalendarUnitEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneCalendarUnitEnumQuery>(GetOneCalendarUnitEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneCalendarUnitEnum', 'query');
    },
    getManyCalendarUnitEnum(variables: GetManyCalendarUnitEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyCalendarUnitEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyCalendarUnitEnumQuery>(GetManyCalendarUnitEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyCalendarUnitEnum', 'query');
    },
    getListClient(variables?: GetListClientQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListClientQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListClientQuery>(GetListClientDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListClient', 'query');
    },
    getOneClient(variables: GetOneClientQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneClientQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneClientQuery>(GetOneClientDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneClient', 'query');
    },
    getManyClient(variables: GetManyClientQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyClientQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyClientQuery>(GetManyClientDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyClient', 'query');
    },
    getOneInvestmentCloseDates(variables: GetOneInvestmentCloseDatesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneInvestmentCloseDatesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneInvestmentCloseDatesQuery>(GetOneInvestmentCloseDatesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneInvestmentCloseDates', 'query');
    },
    updateInvestmentCloseDates(variables: UpdateInvestmentCloseDatesMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateInvestmentCloseDatesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateInvestmentCloseDatesMutation>(UpdateInvestmentCloseDatesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateInvestmentCloseDates', 'mutation');
    },
    getListCompany(variables?: GetListCompanyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListCompanyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListCompanyQuery>(GetListCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListCompany', 'query');
    },
    getOneCompany(variables: GetOneCompanyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneCompanyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneCompanyQuery>(GetOneCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneCompany', 'query');
    },
    getManyCompany(variables: GetManyCompanyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyCompanyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyCompanyQuery>(GetManyCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyCompany', 'query');
    },
    createCompany(variables: CreateCompanyMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateCompanyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCompanyMutation>(CreateCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createCompany', 'mutation');
    },
    updateCompany(variables: UpdateCompanyMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateCompanyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCompanyMutation>(UpdateCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCompany', 'mutation');
    },
    getListCompanyEnum(variables?: GetListCompanyEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListCompanyEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListCompanyEnumQuery>(GetListCompanyEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListCompanyEnum', 'query');
    },
    getOneCompanyEnum(variables: GetOneCompanyEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneCompanyEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneCompanyEnumQuery>(GetOneCompanyEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneCompanyEnum', 'query');
    },
    getManyCompanyEnum(variables: GetManyCompanyEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyCompanyEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyCompanyEnumQuery>(GetManyCompanyEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyCompanyEnum', 'query');
    },
    getListCompanyTypeEnum(variables?: GetListCompanyTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListCompanyTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListCompanyTypeEnumQuery>(GetListCompanyTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListCompanyTypeEnum', 'query');
    },
    getOneCompanyTypeEnum(variables: GetOneCompanyTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneCompanyTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneCompanyTypeEnumQuery>(GetOneCompanyTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneCompanyTypeEnum', 'query');
    },
    getManyCompanyTypeEnum(variables: GetManyCompanyTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyCompanyTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyCompanyTypeEnumQuery>(GetManyCompanyTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyCompanyTypeEnum', 'query');
    },
    getListCompanyValuation(variables?: GetListCompanyValuationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListCompanyValuationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListCompanyValuationQuery>(GetListCompanyValuationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListCompanyValuation', 'query');
    },
    getOneCompanyValuation(variables: GetOneCompanyValuationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneCompanyValuationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneCompanyValuationQuery>(GetOneCompanyValuationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneCompanyValuation', 'query');
    },
    getManyCompanyValuation(variables: GetManyCompanyValuationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyCompanyValuationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyCompanyValuationQuery>(GetManyCompanyValuationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyCompanyValuation', 'query');
    },
    createCompanyValuation(variables: CreateCompanyValuationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateCompanyValuationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCompanyValuationMutation>(CreateCompanyValuationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createCompanyValuation', 'mutation');
    },
    updateCompanyValuation(variables: UpdateCompanyValuationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateCompanyValuationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCompanyValuationMutation>(UpdateCompanyValuationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCompanyValuation', 'mutation');
    },
    deleteCompanyValuation(variables: DeleteCompanyValuationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteCompanyValuationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteCompanyValuationMutation>(DeleteCompanyValuationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteCompanyValuation', 'mutation');
    },
    getListCompoundingPeriodEnum(variables?: GetListCompoundingPeriodEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListCompoundingPeriodEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListCompoundingPeriodEnumQuery>(GetListCompoundingPeriodEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListCompoundingPeriodEnum', 'query');
    },
    getOneCompoundingPeriodEnum(variables: GetOneCompoundingPeriodEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneCompoundingPeriodEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneCompoundingPeriodEnumQuery>(GetOneCompoundingPeriodEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneCompoundingPeriodEnum', 'query');
    },
    getManyCompoundingPeriodEnum(variables: GetManyCompoundingPeriodEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyCompoundingPeriodEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyCompoundingPeriodEnumQuery>(GetManyCompoundingPeriodEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyCompoundingPeriodEnum', 'query');
    },
    getListContactTypeEnum(variables?: GetListContactTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListContactTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListContactTypeEnumQuery>(GetListContactTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListContactTypeEnum', 'query');
    },
    getOneContactTypeEnum(variables: GetOneContactTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneContactTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneContactTypeEnumQuery>(GetOneContactTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneContactTypeEnum', 'query');
    },
    getManyContactTypeEnum(variables: GetManyContactTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyContactTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyContactTypeEnumQuery>(GetManyContactTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyContactTypeEnum', 'query');
    },
    getListCountryEnum(variables?: GetListCountryEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListCountryEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListCountryEnumQuery>(GetListCountryEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListCountryEnum', 'query');
    },
    getOneCountryEnum(variables: GetOneCountryEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneCountryEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneCountryEnumQuery>(GetOneCountryEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneCountryEnum', 'query');
    },
    getManyCountryEnum(variables: GetManyCountryEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyCountryEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyCountryEnumQuery>(GetManyCountryEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyCountryEnum', 'query');
    },
    getListCurrencyDenominationEnum(variables?: GetListCurrencyDenominationEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListCurrencyDenominationEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListCurrencyDenominationEnumQuery>(GetListCurrencyDenominationEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListCurrencyDenominationEnum', 'query');
    },
    getOneCurrencyDenominationEnum(variables: GetOneCurrencyDenominationEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneCurrencyDenominationEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneCurrencyDenominationEnumQuery>(GetOneCurrencyDenominationEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneCurrencyDenominationEnum', 'query');
    },
    getManyCurrencyDenominationEnum(variables: GetManyCurrencyDenominationEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyCurrencyDenominationEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyCurrencyDenominationEnumQuery>(GetManyCurrencyDenominationEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyCurrencyDenominationEnum', 'query');
    },
    getOneCurrentUser(variables?: GetOneCurrentUserQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneCurrentUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneCurrentUserQuery>(GetOneCurrentUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneCurrentUser', 'query');
    },
    updateAssumeUser(variables: UpdateAssumeUserMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateAssumeUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAssumeUserMutation>(UpdateAssumeUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateAssumeUser', 'mutation');
    },
    deleteAssumeUser(variables?: DeleteAssumeUserMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteAssumeUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteAssumeUserMutation>(DeleteAssumeUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteAssumeUser', 'mutation');
    },
    getListCustomAnalytics(variables?: GetListCustomAnalyticsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListCustomAnalyticsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListCustomAnalyticsQuery>(GetListCustomAnalyticsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListCustomAnalytics', 'query');
    },
    getOneCustomAnalytics(variables: GetOneCustomAnalyticsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneCustomAnalyticsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneCustomAnalyticsQuery>(GetOneCustomAnalyticsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneCustomAnalytics', 'query');
    },
    createCustomAnalytics(variables: CreateCustomAnalyticsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateCustomAnalyticsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCustomAnalyticsMutation>(CreateCustomAnalyticsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createCustomAnalytics', 'mutation');
    },
    updateCustomAnalytics(variables: UpdateCustomAnalyticsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateCustomAnalyticsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCustomAnalyticsMutation>(UpdateCustomAnalyticsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCustomAnalytics', 'mutation');
    },
    getListCustomIndexInvestment(variables?: GetListCustomIndexInvestmentQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListCustomIndexInvestmentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListCustomIndexInvestmentQuery>(GetListCustomIndexInvestmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListCustomIndexInvestment', 'query');
    },
    getOneCustomIndexInvestment(variables: GetOneCustomIndexInvestmentQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneCustomIndexInvestmentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneCustomIndexInvestmentQuery>(GetOneCustomIndexInvestmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneCustomIndexInvestment', 'query');
    },
    getManyCustomIndexInvestment(variables: GetManyCustomIndexInvestmentQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyCustomIndexInvestmentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyCustomIndexInvestmentQuery>(GetManyCustomIndexInvestmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyCustomIndexInvestment', 'query');
    },
    createCustomIndexInvestment(variables: CreateCustomIndexInvestmentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateCustomIndexInvestmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCustomIndexInvestmentMutation>(CreateCustomIndexInvestmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createCustomIndexInvestment', 'mutation');
    },
    updateCustomIndexInvestment(variables: UpdateCustomIndexInvestmentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateCustomIndexInvestmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCustomIndexInvestmentMutation>(UpdateCustomIndexInvestmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCustomIndexInvestment', 'mutation');
    },
    getOneCustomIndexPreview(variables: GetOneCustomIndexPreviewQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneCustomIndexPreviewQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneCustomIndexPreviewQuery>(GetOneCustomIndexPreviewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneCustomIndexPreview', 'query');
    },
    getOneDataLinks(variables: GetOneDataLinksQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneDataLinksQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneDataLinksQuery>(GetOneDataLinksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneDataLinks', 'query');
    },
    addOrUpdateCogencyLink(variables: AddOrUpdateCogencyLinkMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddOrUpdateCogencyLinkMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddOrUpdateCogencyLinkMutation>(AddOrUpdateCogencyLinkDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addOrUpdateCogencyLink', 'mutation');
    },
    getListDeal(variables?: GetListDealQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListDealQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListDealQuery>(GetListDealDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListDeal', 'query');
    },
    getOneDeal(variables: GetOneDealQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneDealQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneDealQuery>(GetOneDealDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneDeal', 'query');
    },
    getManyDeal(variables: GetManyDealQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyDealQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyDealQuery>(GetManyDealDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyDeal', 'query');
    },
    createDeal(variables: CreateDealMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateDealMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateDealMutation>(CreateDealDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createDeal', 'mutation');
    },
    updateDeal(variables: UpdateDealMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateDealMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateDealMutation>(UpdateDealDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateDeal', 'mutation');
    },
    getListDealFilterOptions(variables?: GetListDealFilterOptionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListDealFilterOptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListDealFilterOptionsQuery>(GetListDealFilterOptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListDealFilterOptions', 'query');
    },
    getListDealMarketingEnum(variables?: GetListDealMarketingEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListDealMarketingEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListDealMarketingEnumQuery>(GetListDealMarketingEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListDealMarketingEnum', 'query');
    },
    getOneDealMarketingEnum(variables: GetOneDealMarketingEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneDealMarketingEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneDealMarketingEnumQuery>(GetOneDealMarketingEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneDealMarketingEnum', 'query');
    },
    getManyDealMarketingEnum(variables: GetManyDealMarketingEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyDealMarketingEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyDealMarketingEnumQuery>(GetManyDealMarketingEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyDealMarketingEnum', 'query');
    },
    getListDealStructureEnum(variables?: GetListDealStructureEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListDealStructureEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListDealStructureEnumQuery>(GetListDealStructureEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListDealStructureEnum', 'query');
    },
    getOneDealStructureEnum(variables: GetOneDealStructureEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneDealStructureEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneDealStructureEnumQuery>(GetOneDealStructureEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneDealStructureEnum', 'query');
    },
    getManyDealStructureEnum(variables: GetManyDealStructureEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyDealStructureEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyDealStructureEnumQuery>(GetManyDealStructureEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyDealStructureEnum', 'query');
    },
    getListDegreeEnum(variables?: GetListDegreeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListDegreeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListDegreeEnumQuery>(GetListDegreeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListDegreeEnum', 'query');
    },
    getOneDegreeEnum(variables: GetOneDegreeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneDegreeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneDegreeEnumQuery>(GetOneDegreeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneDegreeEnum', 'query');
    },
    getManyDegreeEnum(variables: GetManyDegreeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyDegreeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyDegreeEnumQuery>(GetManyDegreeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyDegreeEnum', 'query');
    },
    getListDeiCategory1Enum(variables?: GetListDeiCategory1EnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListDeiCategory1EnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListDeiCategory1EnumQuery>(GetListDeiCategory1EnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListDeiCategory1Enum', 'query');
    },
    getOneDeiCategory1Enum(variables: GetOneDeiCategory1EnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneDeiCategory1EnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneDeiCategory1EnumQuery>(GetOneDeiCategory1EnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneDeiCategory1Enum', 'query');
    },
    getManyDeiCategory1Enum(variables: GetManyDeiCategory1EnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyDeiCategory1EnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyDeiCategory1EnumQuery>(GetManyDeiCategory1EnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyDeiCategory1Enum', 'query');
    },
    getListDeiCategory2Enum(variables?: GetListDeiCategory2EnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListDeiCategory2EnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListDeiCategory2EnumQuery>(GetListDeiCategory2EnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListDeiCategory2Enum', 'query');
    },
    getOneDeiCategory2Enum(variables: GetOneDeiCategory2EnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneDeiCategory2EnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneDeiCategory2EnumQuery>(GetOneDeiCategory2EnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneDeiCategory2Enum', 'query');
    },
    getManyDeiCategory2Enum(variables: GetManyDeiCategory2EnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyDeiCategory2EnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyDeiCategory2EnumQuery>(GetManyDeiCategory2EnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyDeiCategory2Enum', 'query');
    },
    getListDiversityStatsEnum(variables?: GetListDiversityStatsEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListDiversityStatsEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListDiversityStatsEnumQuery>(GetListDiversityStatsEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListDiversityStatsEnum', 'query');
    },
    getOneDiversityStatsEnum(variables: GetOneDiversityStatsEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneDiversityStatsEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneDiversityStatsEnumQuery>(GetOneDiversityStatsEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneDiversityStatsEnum', 'query');
    },
    getManyDiversityStatsEnum(variables: GetManyDiversityStatsEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyDiversityStatsEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyDiversityStatsEnumQuery>(GetManyDiversityStatsEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyDiversityStatsEnum', 'query');
    },
    getDocumentsList(variables?: GetDocumentsListQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetDocumentsListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDocumentsListQuery>(GetDocumentsListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getDocumentsList', 'query');
    },
    getOneDocument(variables: GetOneDocumentQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneDocumentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneDocumentQuery>(GetOneDocumentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneDocument', 'query');
    },
    updateDocument(variables: UpdateDocumentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateDocumentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateDocumentMutation>(UpdateDocumentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateDocument', 'mutation');
    },
    addDocument(variables: AddDocumentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddDocumentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddDocumentMutation>(AddDocumentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addDocument', 'mutation');
    },
    deleteDocument(variables: DeleteDocumentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteDocumentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteDocumentMutation>(DeleteDocumentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteDocument', 'mutation');
    },
    getListDocumentAccessLevel(variables?: GetListDocumentAccessLevelQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListDocumentAccessLevelQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListDocumentAccessLevelQuery>(GetListDocumentAccessLevelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListDocumentAccessLevel', 'query');
    },
    getOneDocumentAccessLevel(variables: GetOneDocumentAccessLevelQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneDocumentAccessLevelQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneDocumentAccessLevelQuery>(GetOneDocumentAccessLevelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneDocumentAccessLevel', 'query');
    },
    getManyDocumentAccessLevel(variables: GetManyDocumentAccessLevelQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyDocumentAccessLevelQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyDocumentAccessLevelQuery>(GetManyDocumentAccessLevelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyDocumentAccessLevel', 'query');
    },
    addDocumentQueueSignedURI(variables: AddDocumentQueueSignedUriMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddDocumentQueueSignedUriMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddDocumentQueueSignedUriMutation>(AddDocumentQueueSignedUriDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addDocumentQueueSignedURI', 'mutation');
    },
    processDocumentQueue(variables: ProcessDocumentQueueMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ProcessDocumentQueueMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProcessDocumentQueueMutation>(ProcessDocumentQueueDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'processDocumentQueue', 'mutation');
    },
    publishDocumentQueues(variables: PublishDocumentQueuesMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<PublishDocumentQueuesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PublishDocumentQueuesMutation>(PublishDocumentQueuesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'publishDocumentQueues', 'mutation');
    },
    GetDocumentQueueList(variables?: GetDocumentQueueListQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetDocumentQueueListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDocumentQueueListQuery>(GetDocumentQueueListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetDocumentQueueList', 'query');
    },
    GetOneDocumentQueue(variables: GetOneDocumentQueueQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneDocumentQueueQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneDocumentQueueQuery>(GetOneDocumentQueueDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetOneDocumentQueue', 'query');
    },
    TransferToDocuments(variables: TransferToDocumentsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<TransferToDocumentsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TransferToDocumentsMutation>(TransferToDocumentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'TransferToDocuments', 'mutation');
    },
    DeleteDocumentQueue(variables: DeleteDocumentQueueMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteDocumentQueueMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteDocumentQueueMutation>(DeleteDocumentQueueDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteDocumentQueue', 'mutation');
    },
    getDocumentTypeEnumList(variables?: GetDocumentTypeEnumListQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetDocumentTypeEnumListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDocumentTypeEnumListQuery>(GetDocumentTypeEnumListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getDocumentTypeEnumList', 'query');
    },
    getDocumentTypeEnum(variables: GetDocumentTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetDocumentTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDocumentTypeEnumQuery>(GetDocumentTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getDocumentTypeEnum', 'query');
    },
    documentTypeSuggestion(variables: DocumentTypeSuggestionQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DocumentTypeSuggestionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DocumentTypeSuggestionQuery>(DocumentTypeSuggestionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'documentTypeSuggestion', 'query');
    },
    getListEmailDomainXOrganization(variables?: GetListEmailDomainXOrganizationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListEmailDomainXOrganizationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListEmailDomainXOrganizationQuery>(GetListEmailDomainXOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListEmailDomainXOrganization', 'query');
    },
    getOneEmailDomainXOrganization(variables: GetOneEmailDomainXOrganizationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneEmailDomainXOrganizationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneEmailDomainXOrganizationQuery>(GetOneEmailDomainXOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneEmailDomainXOrganization', 'query');
    },
    getManyEmailDomainXOrganization(variables: GetManyEmailDomainXOrganizationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyEmailDomainXOrganizationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyEmailDomainXOrganizationQuery>(GetManyEmailDomainXOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyEmailDomainXOrganization', 'query');
    },
    createEmailDomainXOrganization(variables: CreateEmailDomainXOrganizationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateEmailDomainXOrganizationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateEmailDomainXOrganizationMutation>(CreateEmailDomainXOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createEmailDomainXOrganization', 'mutation');
    },
    updateEmailDomainXOrganization(variables: UpdateEmailDomainXOrganizationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateEmailDomainXOrganizationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateEmailDomainXOrganizationMutation>(UpdateEmailDomainXOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateEmailDomainXOrganization', 'mutation');
    },
    deleteEmailDomainXOrganization(variables: DeleteEmailDomainXOrganizationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteEmailDomainXOrganizationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteEmailDomainXOrganizationMutation>(DeleteEmailDomainXOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteEmailDomainXOrganization', 'mutation');
    },
    getListEmployeeRoleEnum(variables?: GetListEmployeeRoleEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListEmployeeRoleEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListEmployeeRoleEnumQuery>(GetListEmployeeRoleEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListEmployeeRoleEnum', 'query');
    },
    getOneEmployeeRoleEnum(variables: GetOneEmployeeRoleEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneEmployeeRoleEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneEmployeeRoleEnumQuery>(GetOneEmployeeRoleEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneEmployeeRoleEnum', 'query');
    },
    getManyEmployeeRoleEnum(variables: GetManyEmployeeRoleEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyEmployeeRoleEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyEmployeeRoleEnumQuery>(GetManyEmployeeRoleEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyEmployeeRoleEnum', 'query');
    },
    getListFamily(variables?: GetListFamilyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListFamilyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListFamilyQuery>(GetListFamilyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListFamily', 'query');
    },
    getOneFamily(variables: GetOneFamilyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneFamilyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneFamilyQuery>(GetOneFamilyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneFamily', 'query');
    },
    getManyFamily(variables: GetManyFamilyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyFamilyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyFamilyQuery>(GetManyFamilyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyFamily', 'query');
    },
    getManyReferenceFamily(variables?: GetManyReferenceFamilyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyReferenceFamilyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyReferenceFamilyQuery>(GetManyReferenceFamilyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyReferenceFamily', 'query');
    },
    createFamily(variables: CreateFamilyMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateFamilyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateFamilyMutation>(CreateFamilyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createFamily', 'mutation');
    },
    updateFamily(variables: UpdateFamilyMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateFamilyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateFamilyMutation>(UpdateFamilyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateFamily', 'mutation');
    },
    getListFdpLogin(variables?: GetListFdpLoginQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListFdpLoginQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListFdpLoginQuery>(GetListFdpLoginDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListFdpLogin', 'query');
    },
    getOneFdpLogin(variables: GetOneFdpLoginQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneFdpLoginQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneFdpLoginQuery>(GetOneFdpLoginDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneFdpLogin', 'query');
    },
    getManyFdpLogin(variables: GetManyFdpLoginQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyFdpLoginQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyFdpLoginQuery>(GetManyFdpLoginDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyFdpLogin', 'query');
    },
    createFdpLogin(variables: CreateFdpLoginMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateFdpLoginMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateFdpLoginMutation>(CreateFdpLoginDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createFdpLogin', 'mutation');
    },
    updateFdpLogin(variables: UpdateFdpLoginMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateFdpLoginMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateFdpLoginMutation>(UpdateFdpLoginDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateFdpLogin', 'mutation');
    },
    deleteFdpLogin(variables: DeleteFdpLoginMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteFdpLoginMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteFdpLoginMutation>(DeleteFdpLoginDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteFdpLogin', 'mutation');
    },
    getListFdpLoginAuthenticatorEnum(variables?: GetListFdpLoginAuthenticatorEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListFdpLoginAuthenticatorEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListFdpLoginAuthenticatorEnumQuery>(GetListFdpLoginAuthenticatorEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListFdpLoginAuthenticatorEnum', 'query');
    },
    getOneFdpLoginAuthenticatorEnum(variables: GetOneFdpLoginAuthenticatorEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneFdpLoginAuthenticatorEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneFdpLoginAuthenticatorEnumQuery>(GetOneFdpLoginAuthenticatorEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneFdpLoginAuthenticatorEnum', 'query');
    },
    getManyFdpLoginAuthenticatorEnum(variables: GetManyFdpLoginAuthenticatorEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyFdpLoginAuthenticatorEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyFdpLoginAuthenticatorEnumQuery>(GetManyFdpLoginAuthenticatorEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyFdpLoginAuthenticatorEnum', 'query');
    },
    getListFdpWebsites(variables?: GetListFdpWebsitesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListFdpWebsitesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListFdpWebsitesQuery>(GetListFdpWebsitesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListFdpWebsites', 'query');
    },
    getOneFdpWebsites(variables: GetOneFdpWebsitesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneFdpWebsitesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneFdpWebsitesQuery>(GetOneFdpWebsitesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneFdpWebsites', 'query');
    },
    getManyFdpWebsites(variables: GetManyFdpWebsitesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyFdpWebsitesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyFdpWebsitesQuery>(GetManyFdpWebsitesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyFdpWebsites', 'query');
    },
    createFdpWebsites(variables: CreateFdpWebsitesMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateFdpWebsitesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateFdpWebsitesMutation>(CreateFdpWebsitesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createFdpWebsites', 'mutation');
    },
    updateFdpWebsites(variables: UpdateFdpWebsitesMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateFdpWebsitesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateFdpWebsitesMutation>(UpdateFdpWebsitesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateFdpWebsites', 'mutation');
    },
    deleteFdpWebsites(variables: DeleteFdpWebsitesMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteFdpWebsitesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteFdpWebsitesMutation>(DeleteFdpWebsitesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteFdpWebsites', 'mutation');
    },
    getListFeeCalcEnum(variables?: GetListFeeCalcEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListFeeCalcEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListFeeCalcEnumQuery>(GetListFeeCalcEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListFeeCalcEnum', 'query');
    },
    getOneFeeCalcEnum(variables: GetOneFeeCalcEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneFeeCalcEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneFeeCalcEnumQuery>(GetOneFeeCalcEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneFeeCalcEnum', 'query');
    },
    getManyFeeCalcEnum(variables: GetManyFeeCalcEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyFeeCalcEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyFeeCalcEnumQuery>(GetManyFeeCalcEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyFeeCalcEnum', 'query');
    },
    getListFeeFreqEnum(variables?: GetListFeeFreqEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListFeeFreqEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListFeeFreqEnumQuery>(GetListFeeFreqEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListFeeFreqEnum', 'query');
    },
    getOneFeeFreqEnum(variables: GetOneFeeFreqEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneFeeFreqEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneFeeFreqEnumQuery>(GetOneFeeFreqEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneFeeFreqEnum', 'query');
    },
    getManyFeeFreqEnum(variables: GetManyFeeFreqEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyFeeFreqEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyFeeFreqEnumQuery>(GetManyFeeFreqEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyFeeFreqEnum', 'query');
    },
    getListFinancialDataProvider(variables?: GetListFinancialDataProviderQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListFinancialDataProviderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListFinancialDataProviderQuery>(GetListFinancialDataProviderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListFinancialDataProvider', 'query');
    },
    getOneFinancialDataProvider(variables: GetOneFinancialDataProviderQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneFinancialDataProviderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneFinancialDataProviderQuery>(GetOneFinancialDataProviderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneFinancialDataProvider', 'query');
    },
    getManyFinancialDataProvider(variables: GetManyFinancialDataProviderQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyFinancialDataProviderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyFinancialDataProviderQuery>(GetManyFinancialDataProviderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyFinancialDataProvider', 'query');
    },
    createFinancialDataProvider(variables: CreateFinancialDataProviderMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateFinancialDataProviderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateFinancialDataProviderMutation>(CreateFinancialDataProviderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createFinancialDataProvider', 'mutation');
    },
    updateFinancialDataProvider(variables: UpdateFinancialDataProviderMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateFinancialDataProviderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateFinancialDataProviderMutation>(UpdateFinancialDataProviderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateFinancialDataProvider', 'mutation');
    },
    getListFinancialPeriodEnum(variables?: GetListFinancialPeriodEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListFinancialPeriodEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListFinancialPeriodEnumQuery>(GetListFinancialPeriodEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListFinancialPeriodEnum', 'query');
    },
    getOneFinancialPeriodEnum(variables: GetOneFinancialPeriodEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneFinancialPeriodEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneFinancialPeriodEnumQuery>(GetOneFinancialPeriodEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneFinancialPeriodEnum', 'query');
    },
    getManyFinancialPeriodEnum(variables: GetManyFinancialPeriodEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyFinancialPeriodEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyFinancialPeriodEnumQuery>(GetManyFinancialPeriodEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyFinancialPeriodEnum', 'query');
    },
    getListFirm(variables?: GetListFirmQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListFirmQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListFirmQuery>(GetListFirmDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListFirm', 'query');
    },
    getOneFirm(variables: GetOneFirmQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneFirmQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneFirmQuery>(GetOneFirmDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneFirm', 'query');
    },
    getManyFirm(variables: GetManyFirmQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyFirmQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyFirmQuery>(GetManyFirmDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyFirm', 'query');
    },
    createFirm(variables: CreateFirmMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateFirmMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateFirmMutation>(CreateFirmDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createFirm', 'mutation');
    },
    updateFirm(variables: UpdateFirmMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateFirmMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateFirmMutation>(UpdateFirmDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateFirm', 'mutation');
    },
    deleteFirm(variables: DeleteFirmMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteFirmMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteFirmMutation>(DeleteFirmDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteFirm', 'mutation');
    },
    getListFirmDEI(variables?: GetListFirmDeiQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListFirmDeiQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListFirmDeiQuery>(GetListFirmDeiDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListFirmDEI', 'query');
    },
    getOneFirmDEI(variables: GetOneFirmDeiQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneFirmDeiQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneFirmDeiQuery>(GetOneFirmDeiDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneFirmDEI', 'query');
    },
    getManyFirmDEI(variables: GetManyFirmDeiQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyFirmDeiQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyFirmDeiQuery>(GetManyFirmDeiDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyFirmDEI', 'query');
    },
    addOrUpdateFirmDEI(variables: AddOrUpdateFirmDeiMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddOrUpdateFirmDeiMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddOrUpdateFirmDeiMutation>(AddOrUpdateFirmDeiDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addOrUpdateFirmDEI', 'mutation');
    },
    deleteFirmDei(variables: DeleteFirmDeiMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteFirmDeiMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteFirmDeiMutation>(DeleteFirmDeiDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteFirmDei', 'mutation');
    },
    getListFirmEmployment(variables?: GetListFirmEmploymentQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListFirmEmploymentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListFirmEmploymentQuery>(GetListFirmEmploymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListFirmEmployment', 'query');
    },
    getOneFirmEmployment(variables: GetOneFirmEmploymentQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneFirmEmploymentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneFirmEmploymentQuery>(GetOneFirmEmploymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneFirmEmployment', 'query');
    },
    getManyFirmEmployment(variables: GetManyFirmEmploymentQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyFirmEmploymentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyFirmEmploymentQuery>(GetManyFirmEmploymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyFirmEmployment', 'query');
    },
    getManyReferenceFirmEmployment(variables?: GetManyReferenceFirmEmploymentQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyReferenceFirmEmploymentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyReferenceFirmEmploymentQuery>(GetManyReferenceFirmEmploymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyReferenceFirmEmployment', 'query');
    },
    createFirmEmployment(variables: CreateFirmEmploymentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateFirmEmploymentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateFirmEmploymentMutation>(CreateFirmEmploymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createFirmEmployment', 'mutation');
    },
    updateFirmEmployment(variables: UpdateFirmEmploymentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateFirmEmploymentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateFirmEmploymentMutation>(UpdateFirmEmploymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateFirmEmployment', 'mutation');
    },
    deleteFirmEmployment(variables: DeleteFirmEmploymentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteFirmEmploymentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteFirmEmploymentMutation>(DeleteFirmEmploymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteFirmEmployment', 'mutation');
    },
    getListFirmFDPLogins(variables?: GetListFirmFdpLoginsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListFirmFdpLoginsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListFirmFdpLoginsQuery>(GetListFirmFdpLoginsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListFirmFDPLogins', 'query');
    },
    getOneFirmFDPLogins(variables: GetOneFirmFdpLoginsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneFirmFdpLoginsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneFirmFdpLoginsQuery>(GetOneFirmFdpLoginsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneFirmFDPLogins', 'query');
    },
    getManyFirmFDPLogins(variables: GetManyFirmFdpLoginsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyFirmFdpLoginsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyFirmFdpLoginsQuery>(GetManyFirmFdpLoginsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyFirmFDPLogins', 'query');
    },
    createFirmFDPLogins(variables: CreateFirmFdpLoginsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateFirmFdpLoginsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateFirmFdpLoginsMutation>(CreateFirmFdpLoginsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createFirmFDPLogins', 'mutation');
    },
    updateFirmFDPLogins(variables: UpdateFirmFdpLoginsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateFirmFdpLoginsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateFirmFdpLoginsMutation>(UpdateFirmFdpLoginsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateFirmFDPLogins', 'mutation');
    },
    getListFirmInstitutions(variables?: GetListFirmInstitutionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListFirmInstitutionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListFirmInstitutionsQuery>(GetListFirmInstitutionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListFirmInstitutions', 'query');
    },
    getOneFirmInstitutions(variables: GetOneFirmInstitutionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneFirmInstitutionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneFirmInstitutionsQuery>(GetOneFirmInstitutionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneFirmInstitutions', 'query');
    },
    getManyFirmInstitutions(variables: GetManyFirmInstitutionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyFirmInstitutionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyFirmInstitutionsQuery>(GetManyFirmInstitutionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyFirmInstitutions', 'query');
    },
    createFirmInstitutions(variables: CreateFirmInstitutionsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateFirmInstitutionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateFirmInstitutionsMutation>(CreateFirmInstitutionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createFirmInstitutions', 'mutation');
    },
    updateFirmInstitutions(variables: UpdateFirmInstitutionsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateFirmInstitutionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateFirmInstitutionsMutation>(UpdateFirmInstitutionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateFirmInstitutions', 'mutation');
    },
    deleteFirmInstitutions(variables: DeleteFirmInstitutionsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteFirmInstitutionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteFirmInstitutionsMutation>(DeleteFirmInstitutionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteFirmInstitutions', 'mutation');
    },
    getListFundingTypeEnum(variables?: GetListFundingTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListFundingTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListFundingTypeEnumQuery>(GetListFundingTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListFundingTypeEnum', 'query');
    },
    getOneFundingTypeEnum(variables: GetOneFundingTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneFundingTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneFundingTypeEnumQuery>(GetOneFundingTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneFundingTypeEnum', 'query');
    },
    getManyFundingTypeEnum(variables: GetManyFundingTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyFundingTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyFundingTypeEnumQuery>(GetManyFundingTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyFundingTypeEnum', 'query');
    },
    getListFundsXProxies(variables?: GetListFundsXProxiesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListFundsXProxiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListFundsXProxiesQuery>(GetListFundsXProxiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListFundsXProxies', 'query');
    },
    getOneFundsXProxies(variables: GetOneFundsXProxiesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneFundsXProxiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneFundsXProxiesQuery>(GetOneFundsXProxiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneFundsXProxies', 'query');
    },
    createFundsXProxies(variables: CreateFundsXProxiesMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateFundsXProxiesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateFundsXProxiesMutation>(CreateFundsXProxiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createFundsXProxies', 'mutation');
    },
    updateFundsXProxies(variables: UpdateFundsXProxiesMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateFundsXProxiesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateFundsXProxiesMutation>(UpdateFundsXProxiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateFundsXProxies', 'mutation');
    },
    deleteFundsXProxies(variables: DeleteFundsXProxiesMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteFundsXProxiesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteFundsXProxiesMutation>(DeleteFundsXProxiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteFundsXProxies', 'mutation');
    },
    getListGeographicFocusEnum(variables?: GetListGeographicFocusEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListGeographicFocusEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListGeographicFocusEnumQuery>(GetListGeographicFocusEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListGeographicFocusEnum', 'query');
    },
    getOneGeographicFocusEnum(variables: GetOneGeographicFocusEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneGeographicFocusEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneGeographicFocusEnumQuery>(GetOneGeographicFocusEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneGeographicFocusEnum', 'query');
    },
    getManyGeographicFocusEnum(variables: GetManyGeographicFocusEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyGeographicFocusEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyGeographicFocusEnumQuery>(GetManyGeographicFocusEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyGeographicFocusEnum', 'query');
    },
    getListGeographyEnum(variables?: GetListGeographyEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListGeographyEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListGeographyEnumQuery>(GetListGeographyEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListGeographyEnum', 'query');
    },
    getOneGeographyEnum(variables: GetOneGeographyEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneGeographyEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneGeographyEnumQuery>(GetOneGeographyEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneGeographyEnum', 'query');
    },
    getManyGeographyEnum(variables: GetManyGeographyEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyGeographyEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyGeographyEnumQuery>(GetManyGeographyEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyGeographyEnum', 'query');
    },
    getListGlobalProviderNoteTypeEnum(variables?: GetListGlobalProviderNoteTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListGlobalProviderNoteTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListGlobalProviderNoteTypeEnumQuery>(GetListGlobalProviderNoteTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListGlobalProviderNoteTypeEnum', 'query');
    },
    getOneGlobalProviderNoteTypeEnum(variables: GetOneGlobalProviderNoteTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneGlobalProviderNoteTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneGlobalProviderNoteTypeEnumQuery>(GetOneGlobalProviderNoteTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneGlobalProviderNoteTypeEnum', 'query');
    },
    getManyGlobalProviderNoteTypeEnum(variables: GetManyGlobalProviderNoteTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyGlobalProviderNoteTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyGlobalProviderNoteTypeEnumQuery>(GetManyGlobalProviderNoteTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyGlobalProviderNoteTypeEnum', 'query');
    },
    getListGroupShareDefinition(variables?: GetListGroupShareDefinitionQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListGroupShareDefinitionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListGroupShareDefinitionQuery>(GetListGroupShareDefinitionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListGroupShareDefinition', 'query');
    },
    getOneGroupShareDefinition(variables: GetOneGroupShareDefinitionQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneGroupShareDefinitionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneGroupShareDefinitionQuery>(GetOneGroupShareDefinitionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneGroupShareDefinition', 'query');
    },
    getManyGroupShareDefinition(variables: GetManyGroupShareDefinitionQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyGroupShareDefinitionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyGroupShareDefinitionQuery>(GetManyGroupShareDefinitionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyGroupShareDefinition', 'query');
    },
    createGroupShareDefinition(variables: CreateGroupShareDefinitionMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateGroupShareDefinitionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateGroupShareDefinitionMutation>(CreateGroupShareDefinitionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createGroupShareDefinition', 'mutation');
    },
    updateGroupShareDefinition(variables: UpdateGroupShareDefinitionMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateGroupShareDefinitionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateGroupShareDefinitionMutation>(UpdateGroupShareDefinitionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateGroupShareDefinition', 'mutation');
    },
    deleteGroupShareDefinition(variables: DeleteGroupShareDefinitionMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteGroupShareDefinitionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteGroupShareDefinitionMutation>(DeleteGroupShareDefinitionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteGroupShareDefinition', 'mutation');
    },
    getListIconEnum(variables?: GetListIconEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListIconEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListIconEnumQuery>(GetListIconEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListIconEnum', 'query');
    },
    getOneIconEnum(variables: GetOneIconEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneIconEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneIconEnumQuery>(GetOneIconEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneIconEnum', 'query');
    },
    getManyIconEnum(variables: GetManyIconEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyIconEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyIconEnumQuery>(GetManyIconEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyIconEnum', 'query');
    },
    GetImpactCategoryEnumList(variables?: GetImpactCategoryEnumListQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetImpactCategoryEnumListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetImpactCategoryEnumListQuery>(GetImpactCategoryEnumListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetImpactCategoryEnumList', 'query');
    },
    getListIndexCalcTypeEnum(variables?: GetListIndexCalcTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListIndexCalcTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListIndexCalcTypeEnumQuery>(GetListIndexCalcTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListIndexCalcTypeEnum', 'query');
    },
    getOneIndexCalcTypeEnum(variables: GetOneIndexCalcTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneIndexCalcTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneIndexCalcTypeEnumQuery>(GetOneIndexCalcTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneIndexCalcTypeEnum', 'query');
    },
    getManyIndexCalcTypeEnum(variables: GetManyIndexCalcTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyIndexCalcTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyIndexCalcTypeEnumQuery>(GetManyIndexCalcTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyIndexCalcTypeEnum', 'query');
    },
    getListInstitutionEmployment(variables?: GetListInstitutionEmploymentQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListInstitutionEmploymentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListInstitutionEmploymentQuery>(GetListInstitutionEmploymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListInstitutionEmployment', 'query');
    },
    getOneInstitutionEmployment(variables: GetOneInstitutionEmploymentQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneInstitutionEmploymentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneInstitutionEmploymentQuery>(GetOneInstitutionEmploymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneInstitutionEmployment', 'query');
    },
    getManyInstitutionEmployment(variables: GetManyInstitutionEmploymentQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyInstitutionEmploymentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyInstitutionEmploymentQuery>(GetManyInstitutionEmploymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyInstitutionEmployment', 'query');
    },
    createInstitutionEmployment(variables: CreateInstitutionEmploymentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateInstitutionEmploymentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateInstitutionEmploymentMutation>(CreateInstitutionEmploymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createInstitutionEmployment', 'mutation');
    },
    updateInstitutionEmployment(variables: UpdateInstitutionEmploymentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateInstitutionEmploymentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateInstitutionEmploymentMutation>(UpdateInstitutionEmploymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateInstitutionEmployment', 'mutation');
    },
    getListinstitutionInstitutionTypeEnum(variables?: GetListinstitutionInstitutionTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListinstitutionInstitutionTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListinstitutionInstitutionTypeEnumQuery>(GetListinstitutionInstitutionTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListinstitutionInstitutionTypeEnum', 'query');
    },
    getOneinstitutionInstitutionTypeEnum(variables: GetOneinstitutionInstitutionTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneinstitutionInstitutionTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneinstitutionInstitutionTypeEnumQuery>(GetOneinstitutionInstitutionTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneinstitutionInstitutionTypeEnum', 'query');
    },
    getManyinstitutionInstitutionTypeEnum(variables: GetManyinstitutionInstitutionTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyinstitutionInstitutionTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyinstitutionInstitutionTypeEnumQuery>(GetManyinstitutionInstitutionTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyinstitutionInstitutionTypeEnum', 'query');
    },
    getListInstitutionSelectionStatusEnum(variables?: GetListInstitutionSelectionStatusEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListInstitutionSelectionStatusEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListInstitutionSelectionStatusEnumQuery>(GetListInstitutionSelectionStatusEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListInstitutionSelectionStatusEnum', 'query');
    },
    getOneInstitutionSelectionStatusEnum(variables: GetOneInstitutionSelectionStatusEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneInstitutionSelectionStatusEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneInstitutionSelectionStatusEnumQuery>(GetOneInstitutionSelectionStatusEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneInstitutionSelectionStatusEnum', 'query');
    },
    getManyInstitutionSelectionStatusEnum(variables: GetManyInstitutionSelectionStatusEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyInstitutionSelectionStatusEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyInstitutionSelectionStatusEnumQuery>(GetManyInstitutionSelectionStatusEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyInstitutionSelectionStatusEnum', 'query');
    },
    getListInstitutionTypeEnum(variables?: GetListInstitutionTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListInstitutionTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListInstitutionTypeEnumQuery>(GetListInstitutionTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListInstitutionTypeEnum', 'query');
    },
    getOneInstitutionTypeEnum(variables: GetOneInstitutionTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneInstitutionTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneInstitutionTypeEnumQuery>(GetOneInstitutionTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneInstitutionTypeEnum', 'query');
    },
    getManyInstitutionTypeEnum(variables: GetManyInstitutionTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyInstitutionTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyInstitutionTypeEnumQuery>(GetManyInstitutionTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyInstitutionTypeEnum', 'query');
    },
    getListInvestment(variables?: GetListInvestmentQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListInvestmentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListInvestmentQuery>(GetListInvestmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListInvestment', 'query');
    },
    getOneInvestment(variables: GetOneInvestmentQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneInvestmentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneInvestmentQuery>(GetOneInvestmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneInvestment', 'query');
    },
    getManyInvestment(variables: GetManyInvestmentQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyInvestmentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyInvestmentQuery>(GetManyInvestmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyInvestment', 'query');
    },
    getManyReferenceInvestment(variables?: GetManyReferenceInvestmentQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyReferenceInvestmentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyReferenceInvestmentQuery>(GetManyReferenceInvestmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyReferenceInvestment', 'query');
    },
    createInvestment(variables: CreateInvestmentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateInvestmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateInvestmentMutation>(CreateInvestmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createInvestment', 'mutation');
    },
    updateInvestment(variables: UpdateInvestmentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateInvestmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateInvestmentMutation>(UpdateInvestmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateInvestment', 'mutation');
    },
    deleteInvestment(variables: DeleteInvestmentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteInvestmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteInvestmentMutation>(DeleteInvestmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteInvestment', 'mutation');
    },
    getListInvestmentAssignmentOption(variables?: GetListInvestmentAssignmentOptionQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListInvestmentAssignmentOptionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListInvestmentAssignmentOptionQuery>(GetListInvestmentAssignmentOptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListInvestmentAssignmentOption', 'query');
    },
    getManyInvestmentAssignmentOption(variables: GetManyInvestmentAssignmentOptionQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyInvestmentAssignmentOptionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyInvestmentAssignmentOptionQuery>(GetManyInvestmentAssignmentOptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyInvestmentAssignmentOption', 'query');
    },
    getListInvestmentAxysCode(variables?: GetListInvestmentAxysCodeQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListInvestmentAxysCodeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListInvestmentAxysCodeQuery>(GetListInvestmentAxysCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListInvestmentAxysCode', 'query');
    },
    getOneInvestmentAxysCode(variables: GetOneInvestmentAxysCodeQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneInvestmentAxysCodeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneInvestmentAxysCodeQuery>(GetOneInvestmentAxysCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneInvestmentAxysCode', 'query');
    },
    getManyInvestmentAxysCode(variables: GetManyInvestmentAxysCodeQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyInvestmentAxysCodeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyInvestmentAxysCodeQuery>(GetManyInvestmentAxysCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyInvestmentAxysCode', 'query');
    },
    createInvestmentAxysCode(variables: CreateInvestmentAxysCodeMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateInvestmentAxysCodeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateInvestmentAxysCodeMutation>(CreateInvestmentAxysCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createInvestmentAxysCode', 'mutation');
    },
    deleteInvestmentAxysCode(variables: DeleteInvestmentAxysCodeMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteInvestmentAxysCodeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteInvestmentAxysCodeMutation>(DeleteInvestmentAxysCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteInvestmentAxysCode', 'mutation');
    },
    getBulkInvestment(variables?: GetBulkInvestmentQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetBulkInvestmentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBulkInvestmentQuery>(GetBulkInvestmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBulkInvestment', 'query');
    },
    getListInvestmentFDPLogins(variables?: GetListInvestmentFdpLoginsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListInvestmentFdpLoginsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListInvestmentFdpLoginsQuery>(GetListInvestmentFdpLoginsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListInvestmentFDPLogins', 'query');
    },
    getOneInvestmentFDPLogins(variables: GetOneInvestmentFdpLoginsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneInvestmentFdpLoginsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneInvestmentFdpLoginsQuery>(GetOneInvestmentFdpLoginsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneInvestmentFDPLogins', 'query');
    },
    getManyInvestmentFDPLogins(variables: GetManyInvestmentFdpLoginsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyInvestmentFdpLoginsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyInvestmentFdpLoginsQuery>(GetManyInvestmentFdpLoginsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyInvestmentFDPLogins', 'query');
    },
    createInvestmentFDPLogins(variables: CreateInvestmentFdpLoginsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateInvestmentFdpLoginsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateInvestmentFdpLoginsMutation>(CreateInvestmentFdpLoginsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createInvestmentFDPLogins', 'mutation');
    },
    updateInvestmentFDPLogins(variables: UpdateInvestmentFdpLoginsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateInvestmentFdpLoginsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateInvestmentFdpLoginsMutation>(UpdateInvestmentFdpLoginsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateInvestmentFDPLogins', 'mutation');
    },
    getListInvestmentFees(variables?: GetListInvestmentFeesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListInvestmentFeesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListInvestmentFeesQuery>(GetListInvestmentFeesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListInvestmentFees', 'query');
    },
    getOneInvestmentFees(variables: GetOneInvestmentFeesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneInvestmentFeesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneInvestmentFeesQuery>(GetOneInvestmentFeesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneInvestmentFees', 'query');
    },
    getManyInvestmentFees(variables: GetManyInvestmentFeesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyInvestmentFeesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyInvestmentFeesQuery>(GetManyInvestmentFeesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyInvestmentFees', 'query');
    },
    getListInvestmentFirmEmployment(variables?: GetListInvestmentFirmEmploymentQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListInvestmentFirmEmploymentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListInvestmentFirmEmploymentQuery>(GetListInvestmentFirmEmploymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListInvestmentFirmEmployment', 'query');
    },
    getOneInvestmentFirmEmployment(variables: GetOneInvestmentFirmEmploymentQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneInvestmentFirmEmploymentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneInvestmentFirmEmploymentQuery>(GetOneInvestmentFirmEmploymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneInvestmentFirmEmployment', 'query');
    },
    getManyInvestmentFirmEmployment(variables: GetManyInvestmentFirmEmploymentQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyInvestmentFirmEmploymentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyInvestmentFirmEmploymentQuery>(GetManyInvestmentFirmEmploymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyInvestmentFirmEmployment', 'query');
    },
    getManyReferenceInvestmentFirmEmployment(variables?: GetManyReferenceInvestmentFirmEmploymentQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyReferenceInvestmentFirmEmploymentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyReferenceInvestmentFirmEmploymentQuery>(GetManyReferenceInvestmentFirmEmploymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyReferenceInvestmentFirmEmployment', 'query');
    },
    createInvestmentFirmEmployment(variables: CreateInvestmentFirmEmploymentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateInvestmentFirmEmploymentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateInvestmentFirmEmploymentMutation>(CreateInvestmentFirmEmploymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createInvestmentFirmEmployment', 'mutation');
    },
    updateInvestmentFirmEmployment(variables: UpdateInvestmentFirmEmploymentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateInvestmentFirmEmploymentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateInvestmentFirmEmploymentMutation>(UpdateInvestmentFirmEmploymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateInvestmentFirmEmployment', 'mutation');
    },
    deleteInvestmentFirmEmployment(variables: DeleteInvestmentFirmEmploymentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteInvestmentFirmEmploymentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteInvestmentFirmEmploymentMutation>(DeleteInvestmentFirmEmploymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteInvestmentFirmEmployment', 'mutation');
    },
    createInvestmentFirmEmploymentBulk(variables: CreateInvestmentFirmEmploymentBulkMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateInvestmentFirmEmploymentBulkMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateInvestmentFirmEmploymentBulkMutation>(CreateInvestmentFirmEmploymentBulkDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createInvestmentFirmEmploymentBulk', 'mutation');
    },
    getListInvestmentFirmEmploymentRoleEnum(variables?: GetListInvestmentFirmEmploymentRoleEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListInvestmentFirmEmploymentRoleEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListInvestmentFirmEmploymentRoleEnumQuery>(GetListInvestmentFirmEmploymentRoleEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListInvestmentFirmEmploymentRoleEnum', 'query');
    },
    getOneInvestmentFirmEmploymentRoleEnum(variables: GetOneInvestmentFirmEmploymentRoleEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneInvestmentFirmEmploymentRoleEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneInvestmentFirmEmploymentRoleEnumQuery>(GetOneInvestmentFirmEmploymentRoleEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneInvestmentFirmEmploymentRoleEnum', 'query');
    },
    getManyInvestmentFirmEmploymentRoleEnum(variables: GetManyInvestmentFirmEmploymentRoleEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyInvestmentFirmEmploymentRoleEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyInvestmentFirmEmploymentRoleEnumQuery>(GetManyInvestmentFirmEmploymentRoleEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyInvestmentFirmEmploymentRoleEnum', 'query');
    },
    getListInvestmentInstitutions(variables?: GetListInvestmentInstitutionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListInvestmentInstitutionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListInvestmentInstitutionsQuery>(GetListInvestmentInstitutionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListInvestmentInstitutions', 'query');
    },
    getOneInvestmentInstitutions(variables: GetOneInvestmentInstitutionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneInvestmentInstitutionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneInvestmentInstitutionsQuery>(GetOneInvestmentInstitutionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneInvestmentInstitutions', 'query');
    },
    getManyInvestmentInstitutions(variables: GetManyInvestmentInstitutionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyInvestmentInstitutionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyInvestmentInstitutionsQuery>(GetManyInvestmentInstitutionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyInvestmentInstitutions', 'query');
    },
    createInvestmentInstitutions(variables: CreateInvestmentInstitutionsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateInvestmentInstitutionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateInvestmentInstitutionsMutation>(CreateInvestmentInstitutionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createInvestmentInstitutions', 'mutation');
    },
    updateInvestmentInstitutions(variables: UpdateInvestmentInstitutionsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateInvestmentInstitutionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateInvestmentInstitutionsMutation>(UpdateInvestmentInstitutionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateInvestmentInstitutions', 'mutation');
    },
    deleteInvestmentInstitutions(variables: DeleteInvestmentInstitutionsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteInvestmentInstitutionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteInvestmentInstitutionsMutation>(DeleteInvestmentInstitutionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteInvestmentInstitutions', 'mutation');
    },
    getOneInvestmentForPrivateQuartiles(variables: GetOneInvestmentForPrivateQuartilesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneInvestmentForPrivateQuartilesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneInvestmentForPrivateQuartilesQuery>(GetOneInvestmentForPrivateQuartilesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneInvestmentForPrivateQuartiles', 'query');
    },
    getListInvestmentListEnum(variables?: GetListInvestmentListEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListInvestmentListEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListInvestmentListEnumQuery>(GetListInvestmentListEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListInvestmentListEnum', 'query');
    },
    getOneInvestmentListEnum(variables: GetOneInvestmentListEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneInvestmentListEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneInvestmentListEnumQuery>(GetOneInvestmentListEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneInvestmentListEnum', 'query');
    },
    getManyInvestmentListEnum(variables: GetManyInvestmentListEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyInvestmentListEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyInvestmentListEnumQuery>(GetManyInvestmentListEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyInvestmentListEnum', 'query');
    },
    getOneInvestmentPeers(variables: GetOneInvestmentPeersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneInvestmentPeersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneInvestmentPeersQuery>(GetOneInvestmentPeersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneInvestmentPeers', 'query');
    },
    updateInvestmentPeers(variables: UpdateInvestmentPeersMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateInvestmentPeersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateInvestmentPeersMutation>(UpdateInvestmentPeersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateInvestmentPeers', 'mutation');
    },
    getOneInvestmentPeersAuto(variables: GetOneInvestmentPeersAutoQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneInvestmentPeersAutoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneInvestmentPeersAutoQuery>(GetOneInvestmentPeersAutoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneInvestmentPeersAuto', 'query');
    },
    getListInvestmentPrivateQuartileGroupCategory(variables?: GetListInvestmentPrivateQuartileGroupCategoryQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListInvestmentPrivateQuartileGroupCategoryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListInvestmentPrivateQuartileGroupCategoryQuery>(GetListInvestmentPrivateQuartileGroupCategoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListInvestmentPrivateQuartileGroupCategory', 'query');
    },
    getOneInvestmentPrivateQuartileGroupCategory(variables: GetOneInvestmentPrivateQuartileGroupCategoryQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneInvestmentPrivateQuartileGroupCategoryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneInvestmentPrivateQuartileGroupCategoryQuery>(GetOneInvestmentPrivateQuartileGroupCategoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneInvestmentPrivateQuartileGroupCategory', 'query');
    },
    getManyInvestmentPrivateQuartileGroupCategory(variables: GetManyInvestmentPrivateQuartileGroupCategoryQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyInvestmentPrivateQuartileGroupCategoryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyInvestmentPrivateQuartileGroupCategoryQuery>(GetManyInvestmentPrivateQuartileGroupCategoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyInvestmentPrivateQuartileGroupCategory', 'query');
    },
    createInvestmentPrivateQuartileGroupCategory(variables: CreateInvestmentPrivateQuartileGroupCategoryMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateInvestmentPrivateQuartileGroupCategoryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateInvestmentPrivateQuartileGroupCategoryMutation>(CreateInvestmentPrivateQuartileGroupCategoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createInvestmentPrivateQuartileGroupCategory', 'mutation');
    },
    updateInvestmentPrivateQuartileGroupCategory(variables: UpdateInvestmentPrivateQuartileGroupCategoryMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateInvestmentPrivateQuartileGroupCategoryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateInvestmentPrivateQuartileGroupCategoryMutation>(UpdateInvestmentPrivateQuartileGroupCategoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateInvestmentPrivateQuartileGroupCategory', 'mutation');
    },
    deleteInvestmentPrivateQuartileGroupCategory(variables: DeleteInvestmentPrivateQuartileGroupCategoryMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteInvestmentPrivateQuartileGroupCategoryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteInvestmentPrivateQuartileGroupCategoryMutation>(DeleteInvestmentPrivateQuartileGroupCategoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteInvestmentPrivateQuartileGroupCategory', 'mutation');
    },
    getInvestmentRiskCategoryList(variables?: GetInvestmentRiskCategoryListQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetInvestmentRiskCategoryListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetInvestmentRiskCategoryListQuery>(GetInvestmentRiskCategoryListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getInvestmentRiskCategoryList', 'query');
    },
    refreshInvestmentRisk(variables: RefreshInvestmentRiskMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RefreshInvestmentRiskMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RefreshInvestmentRiskMutation>(RefreshInvestmentRiskDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'refreshInvestmentRisk', 'mutation');
    },
    copyRiskMeasures(variables: CopyRiskMeasuresMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CopyRiskMeasuresMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CopyRiskMeasuresMutation>(CopyRiskMeasuresDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'copyRiskMeasures', 'mutation');
    },
    deleteRiskMeasures(variables: DeleteRiskMeasuresMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteRiskMeasuresMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteRiskMeasuresMutation>(DeleteRiskMeasuresDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteRiskMeasures', 'mutation');
    },
    importRiskMeasuresStatus(variables: ImportRiskMeasuresStatusQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ImportRiskMeasuresStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ImportRiskMeasuresStatusQuery>(ImportRiskMeasuresStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'importRiskMeasuresStatus', 'query');
    },
    importRiskMeasures(variables: ImportRiskMeasuresMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ImportRiskMeasuresMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ImportRiskMeasuresMutation>(ImportRiskMeasuresDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'importRiskMeasures', 'mutation');
    },
    getInvestmentRiskInvestmentList(variables?: GetInvestmentRiskInvestmentListQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetInvestmentRiskInvestmentListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetInvestmentRiskInvestmentListQuery>(GetInvestmentRiskInvestmentListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getInvestmentRiskInvestmentList', 'query');
    },
    getListInvestmentSet(variables?: GetListInvestmentSetQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListInvestmentSetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListInvestmentSetQuery>(GetListInvestmentSetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListInvestmentSet', 'query');
    },
    getOneInvestmentSet(variables: GetOneInvestmentSetQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneInvestmentSetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneInvestmentSetQuery>(GetOneInvestmentSetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneInvestmentSet', 'query');
    },
    getListInvestmentStructureEnum(variables?: GetListInvestmentStructureEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListInvestmentStructureEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListInvestmentStructureEnumQuery>(GetListInvestmentStructureEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListInvestmentStructureEnum', 'query');
    },
    getOneInvestmentStructureEnum(variables: GetOneInvestmentStructureEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneInvestmentStructureEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneInvestmentStructureEnumQuery>(GetOneInvestmentStructureEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneInvestmentStructureEnum', 'query');
    },
    getManyInvestmentStructureEnum(variables: GetManyInvestmentStructureEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyInvestmentStructureEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyInvestmentStructureEnumQuery>(GetManyInvestmentStructureEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyInvestmentStructureEnum', 'query');
    },
    getListInvestmentTags(variables?: GetListInvestmentTagsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListInvestmentTagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListInvestmentTagsQuery>(GetListInvestmentTagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListInvestmentTags', 'query');
    },
    getManyInvestmentTags(variables: GetManyInvestmentTagsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyInvestmentTagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyInvestmentTagsQuery>(GetManyInvestmentTagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyInvestmentTags', 'query');
    },
    getOneInvestmentTags(variables: GetOneInvestmentTagsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneInvestmentTagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneInvestmentTagsQuery>(GetOneInvestmentTagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneInvestmentTags', 'query');
    },
    getOneInvestmentTerms(variables: GetOneInvestmentTermsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneInvestmentTermsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneInvestmentTermsQuery>(GetOneInvestmentTermsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneInvestmentTerms', 'query');
    },
    updateInvestmentTerms(variables: UpdateInvestmentTermsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateInvestmentTermsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateInvestmentTermsMutation>(UpdateInvestmentTermsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateInvestmentTerms', 'mutation');
    },
    createInvestmentsFamily(variables: CreateInvestmentsFamilyMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateInvestmentsFamilyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateInvestmentsFamilyMutation>(CreateInvestmentsFamilyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createInvestmentsFamily', 'mutation');
    },
    deleteInvestmentsFamily(variables: DeleteInvestmentsFamilyMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteInvestmentsFamilyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteInvestmentsFamilyMutation>(DeleteInvestmentsFamilyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteInvestmentsFamily', 'mutation');
    },
    getListLegalStructureEnum(variables?: GetListLegalStructureEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListLegalStructureEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListLegalStructureEnumQuery>(GetListLegalStructureEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListLegalStructureEnum', 'query');
    },
    getOneLegalStructureEnum(variables: GetOneLegalStructureEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneLegalStructureEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneLegalStructureEnumQuery>(GetOneLegalStructureEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneLegalStructureEnum', 'query');
    },
    getManyLegalStructureEnum(variables: GetManyLegalStructureEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyLegalStructureEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyLegalStructureEnumQuery>(GetManyLegalStructureEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyLegalStructureEnum', 'query');
    },
    getListLinks(variables?: GetListLinksQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListLinksQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListLinksQuery>(GetListLinksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListLinks', 'query');
    },
    getOneLink(variables: GetOneLinkQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneLinkQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneLinkQuery>(GetOneLinkDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneLink', 'query');
    },
    getManyLinks(variables: GetManyLinksQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyLinksQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyLinksQuery>(GetManyLinksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyLinks', 'query');
    },
    createLinks(variables: CreateLinksMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateLinksMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateLinksMutation>(CreateLinksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createLinks', 'mutation');
    },
    updateLinks(variables: UpdateLinksMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateLinksMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateLinksMutation>(UpdateLinksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateLinks', 'mutation');
    },
    deleteLinks(variables: DeleteLinksMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteLinksMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteLinksMutation>(DeleteLinksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteLinks', 'mutation');
    },
    getListLiquidity(variables?: GetListLiquidityQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListLiquidityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListLiquidityQuery>(GetListLiquidityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListLiquidity', 'query');
    },
    getOneLiquidity(variables: GetOneLiquidityQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneLiquidityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneLiquidityQuery>(GetOneLiquidityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneLiquidity', 'query');
    },
    getManyLiquidity(variables: GetManyLiquidityQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyLiquidityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyLiquidityQuery>(GetManyLiquidityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyLiquidity', 'query');
    },
    getListLockupEndValueEnum(variables?: GetListLockupEndValueEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListLockupEndValueEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListLockupEndValueEnumQuery>(GetListLockupEndValueEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListLockupEndValueEnum', 'query');
    },
    getOneLockupEndValueEnum(variables: GetOneLockupEndValueEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneLockupEndValueEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneLockupEndValueEnumQuery>(GetOneLockupEndValueEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneLockupEndValueEnum', 'query');
    },
    getManyLockupEndValueEnum(variables: GetManyLockupEndValueEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyLockupEndValueEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyLockupEndValueEnumQuery>(GetManyLockupEndValueEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyLockupEndValueEnum', 'query');
    },
    getListMeasureEnum(variables?: GetListMeasureEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListMeasureEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListMeasureEnumQuery>(GetListMeasureEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListMeasureEnum', 'query');
    },
    getOneMeasureEnum(variables: GetOneMeasureEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneMeasureEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneMeasureEnumQuery>(GetOneMeasureEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneMeasureEnum', 'query');
    },
    getManyMeasureEnum(variables: GetManyMeasureEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyMeasureEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyMeasureEnumQuery>(GetManyMeasureEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyMeasureEnum', 'query');
    },
    getListMeasureTypeEnum(variables?: GetListMeasureTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListMeasureTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListMeasureTypeEnumQuery>(GetListMeasureTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListMeasureTypeEnum', 'query');
    },
    getOneMeasureTypeEnum(variables: GetOneMeasureTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneMeasureTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneMeasureTypeEnumQuery>(GetOneMeasureTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneMeasureTypeEnum', 'query');
    },
    getManyMeasureTypeEnum(variables: GetManyMeasureTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyMeasureTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyMeasureTypeEnumQuery>(GetManyMeasureTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyMeasureTypeEnum', 'query');
    },
    getListNavClassificationEnum(variables?: GetListNavClassificationEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListNavClassificationEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListNavClassificationEnumQuery>(GetListNavClassificationEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListNavClassificationEnum', 'query');
    },
    getOneNavClassificationEnum(variables: GetOneNavClassificationEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneNavClassificationEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneNavClassificationEnumQuery>(GetOneNavClassificationEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneNavClassificationEnum', 'query');
    },
    getManyNavClassificationEnum(variables: GetManyNavClassificationEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyNavClassificationEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyNavClassificationEnumQuery>(GetManyNavClassificationEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyNavClassificationEnum', 'query');
    },
    getListNotesMetaEnum(variables?: GetListNotesMetaEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListNotesMetaEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListNotesMetaEnumQuery>(GetListNotesMetaEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListNotesMetaEnum', 'query');
    },
    getManyNotesMetaEnum(variables: GetManyNotesMetaEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyNotesMetaEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyNotesMetaEnumQuery>(GetManyNotesMetaEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyNotesMetaEnum', 'query');
    },
    getListNotes(variables?: GetListNotesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListNotesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListNotesQuery>(GetListNotesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListNotes', 'query');
    },
    getOneNotes(variables: GetOneNotesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneNotesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneNotesQuery>(GetOneNotesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneNotes', 'query');
    },
    getManyNotes(variables: GetManyNotesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyNotesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyNotesQuery>(GetManyNotesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyNotes', 'query');
    },
    addNote(variables: AddNoteMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddNoteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddNoteMutation>(AddNoteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addNote', 'mutation');
    },
    updateNote(variables: UpdateNoteMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateNoteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateNoteMutation>(UpdateNoteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateNote', 'mutation');
    },
    getListInstitution(variables?: GetListInstitutionQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListInstitutionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListInstitutionQuery>(GetListInstitutionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListInstitution', 'query');
    },
    getOneInstitution(variables: GetOneInstitutionQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneInstitutionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneInstitutionQuery>(GetOneInstitutionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneInstitution', 'query');
    },
    getManyInstitution(variables: GetManyInstitutionQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyInstitutionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyInstitutionQuery>(GetManyInstitutionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyInstitution', 'query');
    },
    createInstitution(variables: CreateInstitutionMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateInstitutionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateInstitutionMutation>(CreateInstitutionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createInstitution', 'mutation');
    },
    updateInstitution(variables: UpdateInstitutionMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateInstitutionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateInstitutionMutation>(UpdateInstitutionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateInstitution', 'mutation');
    },
    getListOperatingStatusEnum(variables?: GetListOperatingStatusEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListOperatingStatusEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListOperatingStatusEnumQuery>(GetListOperatingStatusEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListOperatingStatusEnum', 'query');
    },
    getOneOperatingStatusEnum(variables: GetOneOperatingStatusEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneOperatingStatusEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneOperatingStatusEnumQuery>(GetOneOperatingStatusEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneOperatingStatusEnum', 'query');
    },
    getManyOperatingStatusEnum(variables: GetManyOperatingStatusEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyOperatingStatusEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyOperatingStatusEnumQuery>(GetManyOperatingStatusEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyOperatingStatusEnum', 'query');
    },
    getListOrgLinks(variables?: GetListOrgLinksQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListOrgLinksQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListOrgLinksQuery>(GetListOrgLinksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListOrgLinks', 'query');
    },
    getOneOrgLinks(variables: GetOneOrgLinksQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneOrgLinksQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneOrgLinksQuery>(GetOneOrgLinksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneOrgLinks', 'query');
    },
    getManyOrgLinks(variables: GetManyOrgLinksQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyOrgLinksQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyOrgLinksQuery>(GetManyOrgLinksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyOrgLinks', 'query');
    },
    getListOrganization(variables?: GetListOrganizationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListOrganizationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListOrganizationQuery>(GetListOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListOrganization', 'query');
    },
    getOneOrganization(variables: GetOneOrganizationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneOrganizationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneOrganizationQuery>(GetOneOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneOrganization', 'query');
    },
    updateOrganization(variables: UpdateOrganizationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateOrganizationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOrganizationMutation>(UpdateOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateOrganization', 'mutation');
    },
    createOrganization(variables: CreateOrganizationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateOrganizationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOrganizationMutation>(CreateOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOrganization', 'mutation');
    },
    getListOrganizationStructureEnum(variables?: GetListOrganizationStructureEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListOrganizationStructureEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListOrganizationStructureEnumQuery>(GetListOrganizationStructureEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListOrganizationStructureEnum', 'query');
    },
    getOneOrganizationStructureEnum(variables: GetOneOrganizationStructureEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneOrganizationStructureEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneOrganizationStructureEnumQuery>(GetOneOrganizationStructureEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneOrganizationStructureEnum', 'query');
    },
    getManyOrganizationStructureEnum(variables: GetManyOrganizationStructureEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyOrganizationStructureEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyOrganizationStructureEnumQuery>(GetManyOrganizationStructureEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyOrganizationStructureEnum', 'query');
    },
    getListPeFundNumberEnum(variables?: GetListPeFundNumberEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListPeFundNumberEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListPeFundNumberEnumQuery>(GetListPeFundNumberEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListPeFundNumberEnum', 'query');
    },
    getOnePeFundNumberEnum(variables: GetOnePeFundNumberEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOnePeFundNumberEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOnePeFundNumberEnumQuery>(GetOnePeFundNumberEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOnePeFundNumberEnum', 'query');
    },
    getManyPeFundNumberEnum(variables: GetManyPeFundNumberEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyPeFundNumberEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyPeFundNumberEnumQuery>(GetManyPeFundNumberEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyPeFundNumberEnum', 'query');
    },
    getListPeInctFeeCalcEnum(variables?: GetListPeInctFeeCalcEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListPeInctFeeCalcEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListPeInctFeeCalcEnumQuery>(GetListPeInctFeeCalcEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListPeInctFeeCalcEnum', 'query');
    },
    getOnePeInctFeeCalcEnum(variables: GetOnePeInctFeeCalcEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOnePeInctFeeCalcEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOnePeInctFeeCalcEnumQuery>(GetOnePeInctFeeCalcEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOnePeInctFeeCalcEnum', 'query');
    },
    getManyPeInctFeeCalcEnum(variables: GetManyPeInctFeeCalcEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyPeInctFeeCalcEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyPeInctFeeCalcEnumQuery>(GetManyPeInctFeeCalcEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyPeInctFeeCalcEnum', 'query');
    },
    getListPeLiquidity(variables?: GetListPeLiquidityQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListPeLiquidityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListPeLiquidityQuery>(GetListPeLiquidityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListPeLiquidity', 'query');
    },
    getOnePeLiquidity(variables: GetOnePeLiquidityQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOnePeLiquidityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOnePeLiquidityQuery>(GetOnePeLiquidityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOnePeLiquidity', 'query');
    },
    getManyPeLiquidity(variables: GetManyPeLiquidityQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyPeLiquidityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyPeLiquidityQuery>(GetManyPeLiquidityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyPeLiquidity', 'query');
    },
    getListPeMgmtFeeCalcEnum(variables?: GetListPeMgmtFeeCalcEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListPeMgmtFeeCalcEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListPeMgmtFeeCalcEnumQuery>(GetListPeMgmtFeeCalcEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListPeMgmtFeeCalcEnum', 'query');
    },
    getOnePeMgmtFeeCalcEnum(variables: GetOnePeMgmtFeeCalcEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOnePeMgmtFeeCalcEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOnePeMgmtFeeCalcEnumQuery>(GetOnePeMgmtFeeCalcEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOnePeMgmtFeeCalcEnum', 'query');
    },
    getManyPeMgmtFeeCalcEnum(variables: GetManyPeMgmtFeeCalcEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyPeMgmtFeeCalcEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyPeMgmtFeeCalcEnumQuery>(GetManyPeMgmtFeeCalcEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyPeMgmtFeeCalcEnum', 'query');
    },
    getListPEStrategyEnum(variables?: GetListPeStrategyEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListPeStrategyEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListPeStrategyEnumQuery>(GetListPeStrategyEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListPEStrategyEnum', 'query');
    },
    getOnePEStrategyEnum(variables: GetOnePeStrategyEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOnePeStrategyEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOnePeStrategyEnumQuery>(GetOnePeStrategyEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOnePEStrategyEnum', 'query');
    },
    getManyPEStrategyEnum(variables: GetManyPeStrategyEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyPeStrategyEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyPeStrategyEnumQuery>(GetManyPeStrategyEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyPEStrategyEnum', 'query');
    },
    performanceBackground(variables: PerformanceBackgroundQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<PerformanceBackgroundQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PerformanceBackgroundQuery>(PerformanceBackgroundDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'performanceBackground', 'query');
    },
    getOneInvestmentPerformanceMTD(variables: GetOneInvestmentPerformanceMtdQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneInvestmentPerformanceMtdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneInvestmentPerformanceMtdQuery>(GetOneInvestmentPerformanceMtdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneInvestmentPerformanceMTD', 'query');
    },
    getOneInvestmentPerformanceQuarterly(variables: GetOneInvestmentPerformanceQuarterlyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneInvestmentPerformanceQuarterlyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneInvestmentPerformanceQuarterlyQuery>(GetOneInvestmentPerformanceQuarterlyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneInvestmentPerformanceQuarterly', 'query');
    },
    bulkUpdatePerformanceQuarterly(variables: BulkUpdatePerformanceQuarterlyMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BulkUpdatePerformanceQuarterlyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BulkUpdatePerformanceQuarterlyMutation>(BulkUpdatePerformanceQuarterlyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bulkUpdatePerformanceQuarterly', 'mutation');
    },
    bulkUpdatePerformanceMTD(variables: BulkUpdatePerformanceMtdMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BulkUpdatePerformanceMtdMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BulkUpdatePerformanceMtdMutation>(BulkUpdatePerformanceMtdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bulkUpdatePerformanceMTD', 'mutation');
    },
    bloombergDiligenceExtract(variables: BloombergDiligenceExtractMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BloombergDiligenceExtractMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BloombergDiligenceExtractMutation>(BloombergDiligenceExtractDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bloombergDiligenceExtract', 'mutation');
    },
    bloombergDiligenceExtractStatus(variables: BloombergDiligenceExtractStatusQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BloombergDiligenceExtractStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BloombergDiligenceExtractStatusQuery>(BloombergDiligenceExtractStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bloombergDiligenceExtractStatus', 'query');
    },
    bloombergDiligenceLoad(variables: BloombergDiligenceLoadMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BloombergDiligenceLoadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BloombergDiligenceLoadMutation>(BloombergDiligenceLoadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bloombergDiligenceLoad', 'mutation');
    },
    getPerformanceBackfillInvestmentList(variables: GetPerformanceBackfillInvestmentListQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPerformanceBackfillInvestmentListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPerformanceBackfillInvestmentListQuery>(GetPerformanceBackfillInvestmentListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPerformanceBackfillInvestmentList', 'query');
    },
    getManyPerformanceTwrrMtd(variables: GetManyPerformanceTwrrMtdQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyPerformanceTwrrMtdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyPerformanceTwrrMtdQuery>(GetManyPerformanceTwrrMtdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyPerformanceTwrrMtd', 'query');
    },
    getManyPerformanceTwrrQtd(variables: GetManyPerformanceTwrrQtdQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyPerformanceTwrrQtdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyPerformanceTwrrQtdQuery>(GetManyPerformanceTwrrQtdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyPerformanceTwrrQtd', 'query');
    },
    getManyPerformanceIrr(variables: GetManyPerformanceIrrQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyPerformanceIrrQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyPerformanceIrrQuery>(GetManyPerformanceIrrDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyPerformanceIrr', 'query');
    },
    bulkUpsertPerformancePrivate(variables: BulkUpsertPerformancePrivateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BulkUpsertPerformancePrivateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BulkUpsertPerformancePrivateMutation>(BulkUpsertPerformancePrivateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bulkUpsertPerformancePrivate', 'mutation');
    },
    bulkUpsertPerformanceQuarterly(variables: BulkUpsertPerformanceQuarterlyMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BulkUpsertPerformanceQuarterlyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BulkUpsertPerformanceQuarterlyMutation>(BulkUpsertPerformanceQuarterlyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bulkUpsertPerformanceQuarterly', 'mutation');
    },
    bulkUpsertPerformanceMTD(variables: BulkUpsertPerformanceMtdMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BulkUpsertPerformanceMtdMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BulkUpsertPerformanceMtdMutation>(BulkUpsertPerformanceMtdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bulkUpsertPerformanceMTD', 'mutation');
    },
    getOneInvestmentPerformancePrivate(variables?: GetOneInvestmentPerformancePrivateQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneInvestmentPerformancePrivateQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneInvestmentPerformancePrivateQuery>(GetOneInvestmentPerformancePrivateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneInvestmentPerformancePrivate', 'query');
    },
    getListInvestmentPerformancePrivate(variables?: GetListInvestmentPerformancePrivateQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListInvestmentPerformancePrivateQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListInvestmentPerformancePrivateQuery>(GetListInvestmentPerformancePrivateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListInvestmentPerformancePrivate', 'query');
    },
    getManyInvestmentPerformancePrivate(variables: GetManyInvestmentPerformancePrivateQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyInvestmentPerformancePrivateQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyInvestmentPerformancePrivateQuery>(GetManyInvestmentPerformancePrivateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyInvestmentPerformancePrivate', 'query');
    },
    addOrUpdatePerformancePrivate(variables: AddOrUpdatePerformancePrivateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddOrUpdatePerformancePrivateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddOrUpdatePerformancePrivateMutation>(AddOrUpdatePerformancePrivateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addOrUpdatePerformancePrivate', 'mutation');
    },
    getListPerformanceSourceEnum(variables?: GetListPerformanceSourceEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListPerformanceSourceEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListPerformanceSourceEnumQuery>(GetListPerformanceSourceEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListPerformanceSourceEnum', 'query');
    },
    getOnePerformanceSourceEnum(variables: GetOnePerformanceSourceEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOnePerformanceSourceEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOnePerformanceSourceEnumQuery>(GetOnePerformanceSourceEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOnePerformanceSourceEnum', 'query');
    },
    getManyPerformanceSourceEnum(variables: GetManyPerformanceSourceEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyPerformanceSourceEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyPerformanceSourceEnumQuery>(GetManyPerformanceSourceEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyPerformanceSourceEnum', 'query');
    },
    getOnePerformanceStatistics(variables: GetOnePerformanceStatisticsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOnePerformanceStatisticsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOnePerformanceStatisticsQuery>(GetOnePerformanceStatisticsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOnePerformanceStatistics', 'query');
    },
    getManyPerformanceStatistics(variables: GetManyPerformanceStatisticsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyPerformanceStatisticsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyPerformanceStatisticsQuery>(GetManyPerformanceStatisticsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyPerformanceStatistics', 'query');
    },
    getListPerson(variables?: GetListPersonQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListPersonQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListPersonQuery>(GetListPersonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListPerson', 'query');
    },
    getOnePerson(variables: GetOnePersonQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOnePersonQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOnePersonQuery>(GetOnePersonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOnePerson', 'query');
    },
    getManyPerson(variables: GetManyPersonQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyPersonQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyPersonQuery>(GetManyPersonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyPerson', 'query');
    },
    createPerson(variables: CreatePersonMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreatePersonMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePersonMutation>(CreatePersonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createPerson', 'mutation');
    },
    updatePerson(variables: UpdatePersonMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdatePersonMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePersonMutation>(UpdatePersonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePerson', 'mutation');
    },
    getListPersonEducation(variables?: GetListPersonEducationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListPersonEducationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListPersonEducationQuery>(GetListPersonEducationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListPersonEducation', 'query');
    },
    getOnePersonEducation(variables: GetOnePersonEducationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOnePersonEducationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOnePersonEducationQuery>(GetOnePersonEducationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOnePersonEducation', 'query');
    },
    getManyPersonEducation(variables: GetManyPersonEducationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyPersonEducationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyPersonEducationQuery>(GetManyPersonEducationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyPersonEducation', 'query');
    },
    getManyReferencePersonEducation(variables?: GetManyReferencePersonEducationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyReferencePersonEducationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyReferencePersonEducationQuery>(GetManyReferencePersonEducationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyReferencePersonEducation', 'query');
    },
    createPersonEducation(variables: CreatePersonEducationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreatePersonEducationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePersonEducationMutation>(CreatePersonEducationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createPersonEducation', 'mutation');
    },
    updatePersonEducation(variables: UpdatePersonEducationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdatePersonEducationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePersonEducationMutation>(UpdatePersonEducationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePersonEducation', 'mutation');
    },
    deletePersonEducation(variables: DeletePersonEducationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeletePersonEducationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeletePersonEducationMutation>(DeletePersonEducationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deletePersonEducation', 'mutation');
    },
    getListPersonWorkExperience(variables?: GetListPersonWorkExperienceQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListPersonWorkExperienceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListPersonWorkExperienceQuery>(GetListPersonWorkExperienceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListPersonWorkExperience', 'query');
    },
    getOnePersonWorkExperience(variables: GetOnePersonWorkExperienceQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOnePersonWorkExperienceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOnePersonWorkExperienceQuery>(GetOnePersonWorkExperienceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOnePersonWorkExperience', 'query');
    },
    getManyPersonWorkExperience(variables: GetManyPersonWorkExperienceQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyPersonWorkExperienceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyPersonWorkExperienceQuery>(GetManyPersonWorkExperienceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyPersonWorkExperience', 'query');
    },
    getManyReferencePersonWorkExperience(variables?: GetManyReferencePersonWorkExperienceQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyReferencePersonWorkExperienceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyReferencePersonWorkExperienceQuery>(GetManyReferencePersonWorkExperienceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyReferencePersonWorkExperience', 'query');
    },
    createPersonWorkExperience(variables: CreatePersonWorkExperienceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreatePersonWorkExperienceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePersonWorkExperienceMutation>(CreatePersonWorkExperienceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createPersonWorkExperience', 'mutation');
    },
    updatePersonWorkExperience(variables: UpdatePersonWorkExperienceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdatePersonWorkExperienceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePersonWorkExperienceMutation>(UpdatePersonWorkExperienceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePersonWorkExperience', 'mutation');
    },
    deletePersonWorkExperience(variables: DeletePersonWorkExperienceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeletePersonWorkExperienceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeletePersonWorkExperienceMutation>(DeletePersonWorkExperienceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deletePersonWorkExperience', 'mutation');
    },
    getListEmailDomainOrganization(variables?: GetListEmailDomainOrganizationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListEmailDomainOrganizationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListEmailDomainOrganizationQuery>(GetListEmailDomainOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListEmailDomainOrganization', 'query');
    },
    getManyReferenceEmailDomainOrganization(variables?: GetManyReferenceEmailDomainOrganizationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyReferenceEmailDomainOrganizationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyReferenceEmailDomainOrganizationQuery>(GetManyReferenceEmailDomainOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyReferenceEmailDomainOrganization', 'query');
    },
    getListPortalFirm(variables?: GetListPortalFirmQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListPortalFirmQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListPortalFirmQuery>(GetListPortalFirmDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListPortalFirm', 'query');
    },
    getManyReferencePortalFirm(variables?: GetManyReferencePortalFirmQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyReferencePortalFirmQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyReferencePortalFirmQuery>(GetManyReferencePortalFirmDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyReferencePortalFirm', 'query');
    },
    getOnePortalFirm(variables: GetOnePortalFirmQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOnePortalFirmQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOnePortalFirmQuery>(GetOnePortalFirmDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOnePortalFirm', 'query');
    },
    getManyPortalFirm(variables: GetManyPortalFirmQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyPortalFirmQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyPortalFirmQuery>(GetManyPortalFirmDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyPortalFirm', 'query');
    },
    updatePortalFirm(variables: UpdatePortalFirmMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdatePortalFirmMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePortalFirmMutation>(UpdatePortalFirmDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePortalFirm', 'mutation');
    },
    deletePortalFirm(variables: DeletePortalFirmMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeletePortalFirmMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeletePortalFirmMutation>(DeletePortalFirmDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deletePortalFirm', 'mutation');
    },
    getListPortalFirmTypeEnum(variables?: GetListPortalFirmTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListPortalFirmTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListPortalFirmTypeEnumQuery>(GetListPortalFirmTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListPortalFirmTypeEnum', 'query');
    },
    getOnePortalFirmTypeEnum(variables: GetOnePortalFirmTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOnePortalFirmTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOnePortalFirmTypeEnumQuery>(GetOnePortalFirmTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOnePortalFirmTypeEnum', 'query');
    },
    getManyPortalFirmTypeEnum(variables: GetManyPortalFirmTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyPortalFirmTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyPortalFirmTypeEnumQuery>(GetManyPortalFirmTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyPortalFirmTypeEnum', 'query');
    },
    getListPortalOrganization(variables?: GetListPortalOrganizationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListPortalOrganizationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListPortalOrganizationQuery>(GetListPortalOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListPortalOrganization', 'query');
    },
    getOnePortalOrganization(variables: GetOnePortalOrganizationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOnePortalOrganizationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOnePortalOrganizationQuery>(GetOnePortalOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOnePortalOrganization', 'query');
    },
    getManyReferencePortalOrganization(variables?: GetManyReferencePortalOrganizationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyReferencePortalOrganizationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyReferencePortalOrganizationQuery>(GetManyReferencePortalOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyReferencePortalOrganization', 'query');
    },
    getManyPortalOrganization(variables: GetManyPortalOrganizationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyPortalOrganizationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyPortalOrganizationQuery>(GetManyPortalOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyPortalOrganization', 'query');
    },
    updatePortalOrganization(variables: UpdatePortalOrganizationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdatePortalOrganizationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePortalOrganizationMutation>(UpdatePortalOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePortalOrganization', 'mutation');
    },
    addPortalOrganization(variables: AddPortalOrganizationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddPortalOrganizationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddPortalOrganizationMutation>(AddPortalOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addPortalOrganization', 'mutation');
    },
    deletePortalOrganization(variables: DeletePortalOrganizationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeletePortalOrganizationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeletePortalOrganizationMutation>(DeletePortalOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deletePortalOrganization', 'mutation');
    },
    addPortalServiceProviderFirm(variables: AddPortalServiceProviderFirmMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddPortalServiceProviderFirmMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddPortalServiceProviderFirmMutation>(AddPortalServiceProviderFirmDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addPortalServiceProviderFirm', 'mutation');
    },
    getOnePortalServiceProviderFirm(variables: GetOnePortalServiceProviderFirmQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOnePortalServiceProviderFirmQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOnePortalServiceProviderFirmQuery>(GetOnePortalServiceProviderFirmDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOnePortalServiceProviderFirm', 'query');
    },
    getListPortalServiceProviderFirm(variables?: GetListPortalServiceProviderFirmQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListPortalServiceProviderFirmQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListPortalServiceProviderFirmQuery>(GetListPortalServiceProviderFirmDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListPortalServiceProviderFirm', 'query');
    },
    deletePortalServiceProviderFirm(variables: DeletePortalServiceProviderFirmMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeletePortalServiceProviderFirmMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeletePortalServiceProviderFirmMutation>(DeletePortalServiceProviderFirmDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deletePortalServiceProviderFirm', 'mutation');
    },
    getListPortalSubmitted(variables?: GetListPortalSubmittedQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListPortalSubmittedQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListPortalSubmittedQuery>(GetListPortalSubmittedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListPortalSubmitted', 'query');
    },
    getOnePortalSubmitted(variables: GetOnePortalSubmittedQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOnePortalSubmittedQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOnePortalSubmittedQuery>(GetOnePortalSubmittedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOnePortalSubmitted', 'query');
    },
    updatePortalSubmitted(variables: UpdatePortalSubmittedMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdatePortalSubmittedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePortalSubmittedMutation>(UpdatePortalSubmittedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePortalSubmitted', 'mutation');
    },
    deletePortalSubmitted(variables: DeletePortalSubmittedMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeletePortalSubmittedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeletePortalSubmittedMutation>(DeletePortalSubmittedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deletePortalSubmitted', 'mutation');
    },
    getListPortalUser(variables?: GetListPortalUserQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListPortalUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListPortalUserQuery>(GetListPortalUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListPortalUser', 'query');
    },
    getManyReferencePortalUser(variables?: GetManyReferencePortalUserQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyReferencePortalUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyReferencePortalUserQuery>(GetManyReferencePortalUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyReferencePortalUser', 'query');
    },
    getOnePortalUser(variables: GetOnePortalUserQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOnePortalUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOnePortalUserQuery>(GetOnePortalUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOnePortalUser', 'query');
    },
    getManyPortalUser(variables: GetManyPortalUserQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyPortalUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyPortalUserQuery>(GetManyPortalUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyPortalUser', 'query');
    },
    updatePortalUser(variables: UpdatePortalUserMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdatePortalUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePortalUserMutation>(UpdatePortalUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePortalUser', 'mutation');
    },
    deletePortalUser(variables: DeletePortalUserMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeletePortalUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeletePortalUserMutation>(DeletePortalUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deletePortalUser', 'mutation');
    },
    getListPortfolioConfig(variables?: GetListPortfolioConfigQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListPortfolioConfigQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListPortfolioConfigQuery>(GetListPortfolioConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListPortfolioConfig', 'query');
    },
    getOnePortfolioConfig(variables: GetOnePortfolioConfigQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOnePortfolioConfigQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOnePortfolioConfigQuery>(GetOnePortfolioConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOnePortfolioConfig', 'query');
    },
    getManyPortfolioConfig(variables: GetManyPortfolioConfigQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyPortfolioConfigQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyPortfolioConfigQuery>(GetManyPortfolioConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyPortfolioConfig', 'query');
    },
    createPortfolioConfig(variables: CreatePortfolioConfigMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreatePortfolioConfigMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePortfolioConfigMutation>(CreatePortfolioConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createPortfolioConfig', 'mutation');
    },
    updatePortfolioConfig(variables: UpdatePortfolioConfigMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdatePortfolioConfigMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePortfolioConfigMutation>(UpdatePortfolioConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePortfolioConfig', 'mutation');
    },
    getListPortfolioFDPLogins(variables?: GetListPortfolioFdpLoginsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListPortfolioFdpLoginsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListPortfolioFdpLoginsQuery>(GetListPortfolioFdpLoginsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListPortfolioFDPLogins', 'query');
    },
    getOnePortfolioFDPLogins(variables: GetOnePortfolioFdpLoginsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOnePortfolioFdpLoginsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOnePortfolioFdpLoginsQuery>(GetOnePortfolioFdpLoginsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOnePortfolioFDPLogins', 'query');
    },
    getManyPortfolioFDPLogins(variables: GetManyPortfolioFdpLoginsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyPortfolioFdpLoginsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyPortfolioFdpLoginsQuery>(GetManyPortfolioFdpLoginsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyPortfolioFDPLogins', 'query');
    },
    createPortfolioFDPLogins(variables: CreatePortfolioFdpLoginsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreatePortfolioFdpLoginsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePortfolioFdpLoginsMutation>(CreatePortfolioFdpLoginsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createPortfolioFDPLogins', 'mutation');
    },
    updatePortfolioFDPLogins(variables: UpdatePortfolioFdpLoginsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdatePortfolioFdpLoginsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePortfolioFdpLoginsMutation>(UpdatePortfolioFdpLoginsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePortfolioFDPLogins', 'mutation');
    },
    getListPricingFrequencyEnum(variables?: GetListPricingFrequencyEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListPricingFrequencyEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListPricingFrequencyEnumQuery>(GetListPricingFrequencyEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListPricingFrequencyEnum', 'query');
    },
    getOnePricingFrequencyEnum(variables: GetOnePricingFrequencyEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOnePricingFrequencyEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOnePricingFrequencyEnumQuery>(GetOnePricingFrequencyEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOnePricingFrequencyEnum', 'query');
    },
    getManyPricingFrequencyEnum(variables: GetManyPricingFrequencyEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyPricingFrequencyEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyPricingFrequencyEnumQuery>(GetManyPricingFrequencyEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyPricingFrequencyEnum', 'query');
    },
    getListPrivateQuartileGroupCategory(variables?: GetListPrivateQuartileGroupCategoryQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListPrivateQuartileGroupCategoryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListPrivateQuartileGroupCategoryQuery>(GetListPrivateQuartileGroupCategoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListPrivateQuartileGroupCategory', 'query');
    },
    getOnePrivateQuartileGroupCategory(variables: GetOnePrivateQuartileGroupCategoryQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOnePrivateQuartileGroupCategoryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOnePrivateQuartileGroupCategoryQuery>(GetOnePrivateQuartileGroupCategoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOnePrivateQuartileGroupCategory', 'query');
    },
    getManyPrivateQuartileGroupCategory(variables: GetManyPrivateQuartileGroupCategoryQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyPrivateQuartileGroupCategoryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyPrivateQuartileGroupCategoryQuery>(GetManyPrivateQuartileGroupCategoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyPrivateQuartileGroupCategory', 'query');
    },
    getInvestmentCompletenessHead(variables?: GetInvestmentCompletenessHeadQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetInvestmentCompletenessHeadQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetInvestmentCompletenessHeadQuery>(GetInvestmentCompletenessHeadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getInvestmentCompletenessHead', 'query');
    },
    getListProspectiveInvestment(variables?: GetListProspectiveInvestmentQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListProspectiveInvestmentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListProspectiveInvestmentQuery>(GetListProspectiveInvestmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListProspectiveInvestment', 'query');
    },
    getListResultEnum(variables?: GetListResultEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListResultEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListResultEnumQuery>(GetListResultEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListResultEnum', 'query');
    },
    getOneResultEnum(variables: GetOneResultEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneResultEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneResultEnumQuery>(GetOneResultEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneResultEnum', 'query');
    },
    getManyResultEnum(variables: GetManyResultEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyResultEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyResultEnumQuery>(GetManyResultEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyResultEnum', 'query');
    },
    getListRightOfExtensionEnum(variables?: GetListRightOfExtensionEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListRightOfExtensionEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListRightOfExtensionEnumQuery>(GetListRightOfExtensionEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListRightOfExtensionEnum', 'query');
    },
    getOneRightOfExtensionEnum(variables: GetOneRightOfExtensionEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneRightOfExtensionEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneRightOfExtensionEnumQuery>(GetOneRightOfExtensionEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneRightOfExtensionEnum', 'query');
    },
    getManyRightOfExtensionEnum(variables: GetManyRightOfExtensionEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyRightOfExtensionEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyRightOfExtensionEnumQuery>(GetManyRightOfExtensionEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyRightOfExtensionEnum', 'query');
    },
    riskRefreshList(variables?: RiskRefreshListQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RiskRefreshListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RiskRefreshListQuery>(RiskRefreshListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'riskRefreshList', 'query');
    },
    updateRiskRefreshList(variables?: UpdateRiskRefreshListMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateRiskRefreshListMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateRiskRefreshListMutation>(UpdateRiskRefreshListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateRiskRefreshList', 'mutation');
    },
    getListSchoolEnum(variables?: GetListSchoolEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListSchoolEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListSchoolEnumQuery>(GetListSchoolEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListSchoolEnum', 'query');
    },
    getOneSchoolEnum(variables: GetOneSchoolEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneSchoolEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneSchoolEnumQuery>(GetOneSchoolEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneSchoolEnum', 'query');
    },
    getManySchoolEnum(variables: GetManySchoolEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManySchoolEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManySchoolEnumQuery>(GetManySchoolEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManySchoolEnum', 'query');
    },
    getListServiceProviderDocuments(variables?: GetListServiceProviderDocumentsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListServiceProviderDocumentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListServiceProviderDocumentsQuery>(GetListServiceProviderDocumentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListServiceProviderDocuments', 'query');
    },
    getOneServiceProviderDocuments(variables: GetOneServiceProviderDocumentsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneServiceProviderDocumentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneServiceProviderDocumentsQuery>(GetOneServiceProviderDocumentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneServiceProviderDocuments', 'query');
    },
    getManyServiceProviderDocuments(variables: GetManyServiceProviderDocumentsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyServiceProviderDocumentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyServiceProviderDocumentsQuery>(GetManyServiceProviderDocumentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyServiceProviderDocuments', 'query');
    },
    createServiceProviderDocument(variables: CreateServiceProviderDocumentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateServiceProviderDocumentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateServiceProviderDocumentMutation>(CreateServiceProviderDocumentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createServiceProviderDocument', 'mutation');
    },
    updateServiceProviderDocument(variables: UpdateServiceProviderDocumentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateServiceProviderDocumentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateServiceProviderDocumentMutation>(UpdateServiceProviderDocumentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateServiceProviderDocument', 'mutation');
    },
    getListServiceProviderDocumentType(variables?: GetListServiceProviderDocumentTypeQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListServiceProviderDocumentTypeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListServiceProviderDocumentTypeQuery>(GetListServiceProviderDocumentTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListServiceProviderDocumentType', 'query');
    },
    getOneServiceProviderDocumentType(variables: GetOneServiceProviderDocumentTypeQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneServiceProviderDocumentTypeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneServiceProviderDocumentTypeQuery>(GetOneServiceProviderDocumentTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneServiceProviderDocumentType', 'query');
    },
    getManyServiceProviderDocumentType(variables: GetManyServiceProviderDocumentTypeQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyServiceProviderDocumentTypeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyServiceProviderDocumentTypeQuery>(GetManyServiceProviderDocumentTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyServiceProviderDocumentType', 'query');
    },
    getListServiceProviderFirm(variables?: GetListServiceProviderFirmQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListServiceProviderFirmQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListServiceProviderFirmQuery>(GetListServiceProviderFirmDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListServiceProviderFirm', 'query');
    },
    getOneServiceProviderFirm(variables: GetOneServiceProviderFirmQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneServiceProviderFirmQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneServiceProviderFirmQuery>(GetOneServiceProviderFirmDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneServiceProviderFirm', 'query');
    },
    getManyServiceProviderFirm(variables: GetManyServiceProviderFirmQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyServiceProviderFirmQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyServiceProviderFirmQuery>(GetManyServiceProviderFirmDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyServiceProviderFirm', 'query');
    },
    createServiceProviderFirm(variables: CreateServiceProviderFirmMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateServiceProviderFirmMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateServiceProviderFirmMutation>(CreateServiceProviderFirmDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createServiceProviderFirm', 'mutation');
    },
    updateServiceProviderFirm(variables: UpdateServiceProviderFirmMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateServiceProviderFirmMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateServiceProviderFirmMutation>(UpdateServiceProviderFirmDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateServiceProviderFirm', 'mutation');
    },
    getListServiceProviderNotes(variables?: GetListServiceProviderNotesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListServiceProviderNotesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListServiceProviderNotesQuery>(GetListServiceProviderNotesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListServiceProviderNotes', 'query');
    },
    getOneServiceProviderNotes(variables: GetOneServiceProviderNotesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneServiceProviderNotesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneServiceProviderNotesQuery>(GetOneServiceProviderNotesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneServiceProviderNotes', 'query');
    },
    getManyServiceProviderNotes(variables: GetManyServiceProviderNotesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyServiceProviderNotesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyServiceProviderNotesQuery>(GetManyServiceProviderNotesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyServiceProviderNotes', 'query');
    },
    createServiceProviderNotes(variables: CreateServiceProviderNotesMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateServiceProviderNotesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateServiceProviderNotesMutation>(CreateServiceProviderNotesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createServiceProviderNotes', 'mutation');
    },
    updateServiceProviderNotes(variables: UpdateServiceProviderNotesMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateServiceProviderNotesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateServiceProviderNotesMutation>(UpdateServiceProviderNotesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateServiceProviderNotes', 'mutation');
    },
    getListSet(variables?: GetListSetQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListSetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListSetQuery>(GetListSetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListSet', 'query');
    },
    getOneSet(variables: GetOneSetQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneSetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneSetQuery>(GetOneSetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneSet', 'query');
    },
    getManySet(variables: GetManySetQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManySetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManySetQuery>(GetManySetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManySet', 'query');
    },
    createSet(variables: CreateSetMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateSetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSetMutation>(CreateSetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createSet', 'mutation');
    },
    updateSet(variables: UpdateSetMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateSetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSetMutation>(UpdateSetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateSet', 'mutation');
    },
    getListShareClass(variables?: GetListShareClassQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListShareClassQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListShareClassQuery>(GetListShareClassDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListShareClass', 'query');
    },
    getOneShareClass(variables: GetOneShareClassQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneShareClassQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneShareClassQuery>(GetOneShareClassDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneShareClass', 'query');
    },
    getManyShareClass(variables: GetManyShareClassQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyShareClassQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyShareClassQuery>(GetManyShareClassDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyShareClass', 'query');
    },
    createShareClass(variables: CreateShareClassMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateShareClassMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateShareClassMutation>(CreateShareClassDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createShareClass', 'mutation');
    },
    updateShareClass(variables: UpdateShareClassMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateShareClassMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateShareClassMutation>(UpdateShareClassDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateShareClass', 'mutation');
    },
    deleteShareClass(variables: DeleteShareClassMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteShareClassMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteShareClassMutation>(DeleteShareClassDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteShareClass', 'mutation');
    },
    getListSharedGroupEntity(variables?: GetListSharedGroupEntityQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListSharedGroupEntityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListSharedGroupEntityQuery>(GetListSharedGroupEntityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListSharedGroupEntity', 'query');
    },
    getOneSharedGroupEntity(variables: GetOneSharedGroupEntityQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneSharedGroupEntityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneSharedGroupEntityQuery>(GetOneSharedGroupEntityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneSharedGroupEntity', 'query');
    },
    getManySharedGroupEntity(variables: GetManySharedGroupEntityQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManySharedGroupEntityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManySharedGroupEntityQuery>(GetManySharedGroupEntityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManySharedGroupEntity', 'query');
    },
    getListSoftLockup(variables?: GetListSoftLockupQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListSoftLockupQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListSoftLockupQuery>(GetListSoftLockupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListSoftLockup', 'query');
    },
    getOneSoftLockup(variables: GetOneSoftLockupQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneSoftLockupQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneSoftLockupQuery>(GetOneSoftLockupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneSoftLockup', 'query');
    },
    getManySoftLockup(variables: GetManySoftLockupQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManySoftLockupQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManySoftLockupQuery>(GetManySoftLockupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManySoftLockup', 'query');
    },
    getListStageEnum(variables?: GetListStageEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListStageEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListStageEnumQuery>(GetListStageEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListStageEnum', 'query');
    },
    getOneStageEnum(variables: GetOneStageEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneStageEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneStageEnumQuery>(GetOneStageEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneStageEnum', 'query');
    },
    getManyStageEnum(variables: GetManyStageEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyStageEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyStageEnumQuery>(GetManyStageEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyStageEnum', 'query');
    },
    getListStateEnum(variables?: GetListStateEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListStateEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListStateEnumQuery>(GetListStateEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListStateEnum', 'query');
    },
    getOneStateEnum(variables: GetOneStateEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneStateEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneStateEnumQuery>(GetOneStateEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneStateEnum', 'query');
    },
    getManyStateEnum(variables: GetManyStateEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyStateEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyStateEnumQuery>(GetManyStateEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyStateEnum', 'query');
    },
    getListStrategyEnum(variables?: GetListStrategyEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListStrategyEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListStrategyEnumQuery>(GetListStrategyEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListStrategyEnum', 'query');
    },
    getListStrategyEnumOptions(variables?: GetListStrategyEnumOptionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListStrategyEnumOptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListStrategyEnumOptionsQuery>(GetListStrategyEnumOptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListStrategyEnumOptions', 'query');
    },
    getOneStrategyEnum(variables: GetOneStrategyEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneStrategyEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneStrategyEnumQuery>(GetOneStrategyEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneStrategyEnum', 'query');
    },
    getManyStrategyEnum(variables: GetManyStrategyEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyStrategyEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyStrategyEnumQuery>(GetManyStrategyEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyStrategyEnum', 'query');
    },
    getListSubStrategyEnum(variables?: GetListSubStrategyEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListSubStrategyEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListSubStrategyEnumQuery>(GetListSubStrategyEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListSubStrategyEnum', 'query');
    },
    getOneSubStrategyEnum(variables: GetOneSubStrategyEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneSubStrategyEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneSubStrategyEnumQuery>(GetOneSubStrategyEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneSubStrategyEnum', 'query');
    },
    getManySubStrategyEnum(variables: GetManySubStrategyEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManySubStrategyEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManySubStrategyEnumQuery>(GetManySubStrategyEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManySubStrategyEnum', 'query');
    },
    getListTagClasses(variables?: GetListTagClassesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListTagClassesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListTagClassesQuery>(GetListTagClassesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListTagClasses', 'query');
    },
    getManyTagClasses(variables: GetManyTagClassesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyTagClassesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyTagClassesQuery>(GetManyTagClassesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyTagClasses', 'query');
    },
    getOneTagClasses(variables: GetOneTagClassesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneTagClassesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneTagClassesQuery>(GetOneTagClassesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneTagClasses', 'query');
    },
    getListTag(variables?: GetListTagQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListTagQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListTagQuery>(GetListTagDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListTag', 'query');
    },
    getManyTag(variables: GetManyTagQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyTagQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyTagQuery>(GetManyTagDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyTag', 'query');
    },
    getOneTag(variables: GetOneTagQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneTagQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneTagQuery>(GetOneTagDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneTag', 'query');
    },
    getManyReferenceTag(variables?: GetManyReferenceTagQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyReferenceTagQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyReferenceTagQuery>(GetManyReferenceTagDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyReferenceTag', 'query');
    },
    getListTitleEnum(variables?: GetListTitleEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListTitleEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListTitleEnumQuery>(GetListTitleEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListTitleEnum', 'query');
    },
    getOneTitleEnum(variables: GetOneTitleEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneTitleEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneTitleEnumQuery>(GetOneTitleEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneTitleEnum', 'query');
    },
    getManyTitleEnum(variables: GetManyTitleEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyTitleEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyTitleEnumQuery>(GetManyTitleEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyTitleEnum', 'query');
    },
    getListUser(variables?: GetListUserQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListUserQuery>(GetListUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListUser', 'query');
    },
    getManyUser(variables?: GetManyUserQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyUserQuery>(GetManyUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyUser', 'query');
    },
    getOneUser(variables?: GetOneUserQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneUserQuery>(GetOneUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneUser', 'query');
    },
    createUser(variables: CreateUserMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateUserMutation>(CreateUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createUser', 'mutation');
    },
    createUserGroup(variables: CreateUserGroupMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateUserGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateUserGroupMutation>(CreateUserGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createUserGroup', 'mutation');
    },
    updateUserGroup(variables: UpdateUserGroupMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateUserGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserGroupMutation>(UpdateUserGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateUserGroup', 'mutation');
    },
    updateUser(variables: UpdateUserMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserMutation>(UpdateUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateUser', 'mutation');
    },
    activateUser(variables: ActivateUserMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ActivateUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ActivateUserMutation>(ActivateUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'activateUser', 'mutation');
    },
    deactivateUser(variables: DeactivateUserMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeactivateUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeactivateUserMutation>(DeactivateUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deactivateUser', 'mutation');
    },
    getListUserActivity(variables?: GetListUserActivityQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListUserActivityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListUserActivityQuery>(GetListUserActivityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListUserActivity', 'query');
    },
    getManyUserActivity(variables?: GetManyUserActivityQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyUserActivityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyUserActivityQuery>(GetManyUserActivityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyUserActivity', 'query');
    },
    getOneUserActivity(variables: GetOneUserActivityQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneUserActivityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneUserActivityQuery>(GetOneUserActivityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneUserActivity', 'query');
    },
    getListUsersXGroups(variables?: GetListUsersXGroupsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListUsersXGroupsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListUsersXGroupsQuery>(GetListUsersXGroupsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListUsersXGroups', 'query');
    },
    getOneUsersXGroups(variables: GetOneUsersXGroupsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneUsersXGroupsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneUsersXGroupsQuery>(GetOneUsersXGroupsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneUsersXGroups', 'query');
    },
    getManyUsersXGroups(variables: GetManyUsersXGroupsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyUsersXGroupsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyUsersXGroupsQuery>(GetManyUsersXGroupsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyUsersXGroups', 'query');
    },
    createUsersXGroups(variables: CreateUsersXGroupsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateUsersXGroupsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateUsersXGroupsMutation>(CreateUsersXGroupsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createUsersXGroups', 'mutation');
    },
    updateUsersXGroups(variables: UpdateUsersXGroupsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateUsersXGroupsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUsersXGroupsMutation>(UpdateUsersXGroupsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateUsersXGroups', 'mutation');
    },
    deleteUsersXGroups(variables: DeleteUsersXGroupsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteUsersXGroupsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteUsersXGroupsMutation>(DeleteUsersXGroupsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteUsersXGroups', 'mutation');
    },
    getListVehicleTypeEnumOptions(variables?: GetListVehicleTypeEnumOptionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListVehicleTypeEnumOptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListVehicleTypeEnumOptionsQuery>(GetListVehicleTypeEnumOptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListVehicleTypeEnumOptions', 'query');
    },
    getOneVehicleTypeEnum(variables: GetOneVehicleTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneVehicleTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneVehicleTypeEnumQuery>(GetOneVehicleTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneVehicleTypeEnum', 'query');
    },
    getManyVehicleTypeEnum(variables: GetManyVehicleTypeEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyVehicleTypeEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyVehicleTypeEnumQuery>(GetManyVehicleTypeEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyVehicleTypeEnum', 'query');
    },
    getListWorkoutEnum(variables?: GetListWorkoutEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetListWorkoutEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListWorkoutEnumQuery>(GetListWorkoutEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getListWorkoutEnum', 'query');
    },
    getOneWorkoutEnum(variables: GetOneWorkoutEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOneWorkoutEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOneWorkoutEnumQuery>(GetOneWorkoutEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOneWorkoutEnum', 'query');
    },
    getManyWorkoutEnum(variables: GetManyWorkoutEnumQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetManyWorkoutEnumQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetManyWorkoutEnumQuery>(GetManyWorkoutEnumDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getManyWorkoutEnum', 'query');
    },
    getUserMutationAccessible(variables: GetUserMutationAccessibleQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetUserMutationAccessibleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserMutationAccessibleQuery>(GetUserMutationAccessibleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUserMutationAccessible', 'query');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;